import { defineComponent as Tt, computed as zt, onMounted as le, openBlock as wt, createElementBlock as Rt, normalizeStyle as yn, ref as Ft, createBlock as Et, unref as St, resolveComponent as bn, createVNode as Qt, withCtx as Xt, createCommentVNode as Wt, toDisplayString as qt, renderSlot as Ht, Fragment as vn, normalizeClass as Xr, onBeforeMount as Hr, normalizeProps as Cn, mergeProps as An, createApp as Mn } from "vue";
import { BaseSearchBox as Yr, TeaserBoxesSlider as wn, AnnouncementItem as Sn, CtaElementType as kn, BaseIconType as Pn, useTranslation as Tn, EntryGateModal as En, HTMLContentBlock as Ln, BaseImage as On, ColumnLayoutType as re, StretchedColumn as jn, PageSection as Wr, TwoColumnLayout as Dn, ThreeColumnLayout as In, useCallLeavingDisclaimer as js, LeavingDisclaimer as Bn, RiskDisclaimer as Rn, ContentBoxWithImage as Nn, ContentBox as zn, ArticlePageOverview as Fn, ContentSlider as Un, QuizAndPoll as Vr, FormBuilder as Gn, useArchivePageStore as Xn, ArchivePageSearchEventType as Hn, ArchivePage as Yn, Calendar as Wn, FaqPage as Vn, useSearchResultPageStore as qn, SearchResultsEventType as _n, SearchResultPage as Kn, PersonDetailPage as $n, usePropertyGalleryStore as Zn, PropertyGalleryPageContainer as Jn, PropertyDetailPage as Qn, Glossary as ta, useMediaReleasesStore as ea, MediaReleasesSearchEventType as Ds, MediaReleasesContainer as ia, ProductBuyingProcess as sa, Footer as oa, PageFrame as ra, Header as na, TeaserWww as aa, TeaserHero as la, TeaserEvents as ha, TeaserBoxes as da, KeyFacts as ca, ProductTeaserTopProducts as pa, TeaserMostClickedFunds as ua, ProductTeaserFundsInFocus as ga, PersonSectionBlock as fa, TabContainer as ma, TabContent as xa, VideoModule as ya, DownloadList as ba, TopicTileContentBlock as va, Quote as Ca, AccordionContainer as Aa, AccordionItem as Ma, ExpandableTeasers as wa, NewsletterTeaser as Sa, PageFootnoteList as ka, PageFootnoteReference as Pa, TextBlock as Ta, TimelineBlock as Ea, ProductChartTeaser as La, ProductChartTeasers as Oa, DataTable as ja, SingleVideoModule as Da, ErrorPage as Ia, FeaturedPropertyTeaser as Ba, FactsLists as Ra, MarketDataBlock as Na, ImageGallery as za, JumpmarkAnchor as Fa, ArticleHeader as Ua, ResponsivePicture as Ga, ImageGalleryTeaser as Xa, ProductTeaserWithImage as Ha, BaseDisclaimer as Ya, BaseContactBox as Wa, MediaReleasesDetailsPage as Va, GlossaryItem as qa, EntryDisclaimer as _a, AudioModule as Ka, ArticlePageLayout as $a, InvestmentCalculator as Za, InflationCalculator as Ja, Breadcrumb as Qa, DxPlugin as tl } from "dws-dx";
var ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function It(rt) {
  return rt && rt.__esModule && Object.prototype.hasOwnProperty.call(rt, "default") ? rt.default : rt;
}
var ae = { exports: {} }, el = ae.exports, Is;
function il() {
  return Is || (Is = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * (c) 2009-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt, r) {
      rt.exports ? (r.default = r, rt.exports = tt && tt.document ? r(tt) : r) : (tt.Highcharts && tt.Highcharts.error(16, !0), tt.Highcharts = r(tt));
    })(typeof window < "u" ? window : el, function(tt) {
      var r = {};
      function Z(T, B, I, R) {
        !T.hasOwnProperty(B) && (T[B] = R.apply(null, I), tt && typeof CustomEvent == "function" && tt.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      return Z(r, "Core/Globals.js", [], function() {
        var T, B;
        return (B = T || (T = {})).SVG_NS = "http://www.w3.org/2000/svg", B.product = "Highcharts", B.version = "11.4.8", B.win = tt !== void 0 ? tt : {}, B.doc = B.win.document, B.svg = B.doc && B.doc.createElementNS && !!B.doc.createElementNS(B.SVG_NS, "svg").createSVGRect, B.userAgent = B.win.navigator && B.win.navigator.userAgent || "", B.isChrome = B.win.chrome, B.isFirefox = B.userAgent.indexOf("Firefox") !== -1, B.isMS = /(edge|msie|trident)/i.test(B.userAgent) && !B.win.opera, B.isSafari = !B.isChrome && B.userAgent.indexOf("Safari") !== -1, B.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(B.userAgent), B.isWebKit = B.userAgent.indexOf("AppleWebKit") !== -1, B.deg2rad = 2 * Math.PI / 360, B.hasBidiBug = B.isFirefox && 4 > parseInt(B.userAgent.split("Firefox/")[1], 10), B.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], B.noop = function() {
        }, B.supportsPassiveEvents = function() {
          let I = !1;
          if (!B.isMS) {
            let R = Object.defineProperty({}, "passive", { get: function() {
              I = !0;
            } });
            B.win.addEventListener && B.win.removeEventListener && (B.win.addEventListener("testPassive", B.noop, R), B.win.removeEventListener("testPassive", B.noop, R));
          }
          return I;
        }(), B.charts = [], B.composed = [], B.dateFormats = {}, B.seriesTypes = {}, B.symbolSizes = {}, B.chartCount = 0, T;
      }), Z(r, "Core/Utilities.js", [r["Core/Globals.js"]], function(T) {
        let B, { charts: I, doc: R, win: z } = T;
        function O(t, e, n, d) {
          let i = e ? "Highcharts error" : "Highcharts warning";
          t === 32 && (t = `${i}: Deprecated member`);
          let g = c(t), m = g ? `${i} #${t}: www.highcharts.com/errors/${t}/` : t.toString();
          if (d !== void 0) {
            let k = "";
            g && (m += "?"), b(d, function(j, P) {
              k += `
 - ${P}: ${j}`, g && (m += encodeURI(P) + "=" + encodeURI(j));
            }), m += k;
          }
          C(T, "displayError", { chart: n, code: t, message: m, params: d }, function() {
            if (e) throw Error(m);
            z.console && O.messages.indexOf(m) === -1 && console.warn(m);
          }), O.messages.push(m);
        }
        function L(t, e) {
          return parseInt(t, e || 10);
        }
        function M(t) {
          return typeof t == "string";
        }
        function w(t) {
          let e = Object.prototype.toString.call(t);
          return e === "[object Array]" || e === "[object Array Iterator]";
        }
        function A(t, e) {
          return !!t && typeof t == "object" && (!e || !w(t));
        }
        function l(t) {
          return A(t) && typeof t.nodeType == "number";
        }
        function u(t) {
          let e = t && t.constructor;
          return !!(A(t, !0) && !l(t) && e && e.name && e.name !== "Object");
        }
        function c(t) {
          return typeof t == "number" && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
        }
        function v(t) {
          return t != null;
        }
        function s(t, e, n) {
          let d, i = M(e) && !v(n), g = (m, k) => {
            v(m) ? t.setAttribute(k, m) : i ? (d = t.getAttribute(k)) || k !== "class" || (d = t.getAttribute(k + "Name")) : t.removeAttribute(k);
          };
          return M(e) ? g(n, e) : b(e, g), d;
        }
        function f(t) {
          return w(t) ? t : [t];
        }
        function y(t, e) {
          let n;
          for (n in t || (t = {}), e) t[n] = e[n];
          return t;
        }
        function h() {
          let t = arguments, e = t.length;
          for (let n = 0; n < e; n++) {
            let d = t[n];
            if (d != null) return d;
          }
        }
        function a(t, e) {
          y(t.style, e);
        }
        function x(t) {
          return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
        }
        function S(t, e) {
          return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
        }
        O.messages = [], Math.easeInOutSine = function(t) {
          return -0.5 * (Math.cos(Math.PI * t) - 1);
        };
        let E = Array.prototype.find ? function(t, e) {
          return t.find(e);
        } : function(t, e) {
          let n, d = t.length;
          for (n = 0; n < d; n++) if (e(t[n], n)) return t[n];
        };
        function b(t, e, n) {
          for (let d in t) Object.hasOwnProperty.call(t, d) && e.call(n || t[d], t[d], d, t);
        }
        function p(t, e, n) {
          function d(m, k) {
            let j = t.removeEventListener;
            j && j.call(t, m, k, !1);
          }
          function i(m) {
            let k, j;
            t.nodeName && (e ? (k = {})[e] = !0 : k = m, b(k, function(P, D) {
              if (m[D]) for (j = m[D].length; j--; ) d(D, m[D][j].fn);
            }));
          }
          let g = typeof t == "function" && t.prototype || t;
          if (Object.hasOwnProperty.call(g, "hcEvents")) {
            let m = g.hcEvents;
            if (e) {
              let k = m[e] || [];
              n ? (m[e] = k.filter(function(j) {
                return n !== j.fn;
              }), d(e, n)) : (i(m), m[e] = []);
            } else i(m), delete g.hcEvents;
          }
        }
        function C(t, e, n, d) {
          if (n = n || {}, R.createEvent && (t.dispatchEvent || t.fireEvent && t !== T)) {
            let i = R.createEvent("Events");
            i.initEvent(e, !0, !0), n = y(i, n), t.dispatchEvent ? t.dispatchEvent(n) : t.fireEvent(e, n);
          } else if (t.hcEvents) {
            n.target || y(n, { preventDefault: function() {
              n.defaultPrevented = !0;
            }, target: t, type: e });
            let i = [], g = t, m = !1;
            for (; g.hcEvents; ) Object.hasOwnProperty.call(g, "hcEvents") && g.hcEvents[e] && (i.length && (m = !0), i.unshift.apply(i, g.hcEvents[e])), g = Object.getPrototypeOf(g);
            m && i.sort((k, j) => k.order - j.order), i.forEach((k) => {
              k.fn.call(t, n) === !1 && n.preventDefault();
            });
          }
          d && !n.defaultPrevented && d.call(t, n);
        }
        b({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(t, e) {
          T[e] = function(n) {
            return O(32, !1, void 0, { [`Highcharts.${e}`]: `use Array.${t}` }), Array.prototype[t].apply(n, [].slice.call(arguments, 1));
          };
        });
        let o = function() {
          let t = Math.random().toString(36).substring(2, 9) + "-", e = 0;
          return function() {
            return "highcharts-" + (B ? "" : t) + e++;
          };
        }();
        return z.jQuery && (z.jQuery.fn.highcharts = function() {
          let t = [].slice.call(arguments);
          if (this[0]) return t[0] ? (new T[M(t[0]) ? t.shift() : "Chart"](this[0], t[0], t[1]), this) : I[s(this[0], "data-highcharts-chart")];
        }), { addEvent: function(t, e, n, d = {}) {
          let i = typeof t == "function" && t.prototype || t;
          Object.hasOwnProperty.call(i, "hcEvents") || (i.hcEvents = {});
          let g = i.hcEvents;
          T.Point && t instanceof T.Point && t.series && t.series.chart && (t.series.chart.runTrackerClick = !0);
          let m = t.addEventListener;
          m && m.call(t, e, n, !!T.supportsPassiveEvents && { passive: d.passive === void 0 ? e.indexOf("touch") !== -1 : d.passive, capture: !1 }), g[e] || (g[e] = []);
          let k = { fn: n, order: typeof d.order == "number" ? d.order : 1 / 0 };
          return g[e].push(k), g[e].sort((j, P) => j.order - P.order), function() {
            p(t, e, n);
          };
        }, arrayMax: function(t) {
          let e = t.length, n = t[0];
          for (; e--; ) t[e] > n && (n = t[e]);
          return n;
        }, arrayMin: function(t) {
          let e = t.length, n = t[0];
          for (; e--; ) t[e] < n && (n = t[e]);
          return n;
        }, attr: s, clamp: function(t, e, n) {
          return t > e ? t < n ? t : n : e;
        }, clearTimeout: function(t) {
          v(t) && clearTimeout(t);
        }, correctFloat: S, createElement: function(t, e, n, d, i) {
          let g = R.createElement(t);
          return e && y(g, e), i && a(g, { padding: "0", border: "none", margin: "0" }), n && a(g, n), d && d.appendChild(g), g;
        }, crisp: (t, e = 0, n) => {
          let d = e % 2 / 2, i = n ? -1 : 1;
          return (Math.round(t * i - d) + d) * i;
        }, css: a, defined: v, destroyObjectProperties: function(t, e, n) {
          b(t, function(d, i) {
            d !== e && (d != null && d.destroy) && d.destroy(), (d != null && d.destroy || !n) && delete t[i];
          });
        }, diffObjects: function(t, e, n, d) {
          let i = {};
          return function g(m, k, j, P) {
            let D = n ? k : m;
            b(m, function(H, G) {
              if (!P && d && d.indexOf(G) > -1 && k[G]) {
                H = f(H), j[G] = [];
                for (let V = 0; V < Math.max(H.length, k[G].length); V++) k[G][V] && (H[V] === void 0 ? j[G][V] = k[G][V] : (j[G][V] = {}, g(H[V], k[G][V], j[G][V], P + 1)));
              } else A(H, !0) && !H.nodeType ? (j[G] = w(H) ? [] : {}, g(H, k[G] || {}, j[G], P + 1), Object.keys(j[G]).length !== 0 || G === "colorAxis" && P === 0 || delete j[G]) : (m[G] !== k[G] || G in m && !(G in k)) && G !== "__proto__" && G !== "constructor" && (j[G] = D[G]);
            });
          }(t, e, i, 0), i;
        }, discardElement: function(t) {
          t && t.parentElement && t.parentElement.removeChild(t);
        }, erase: function(t, e) {
          let n = t.length;
          for (; n--; ) if (t[n] === e) {
            t.splice(n, 1);
            break;
          }
        }, error: O, extend: y, extendClass: function(t, e) {
          let n = function() {
          };
          return n.prototype = new t(), y(n.prototype, e), n;
        }, find: E, fireEvent: C, getClosestDistance: function(t, e) {
          let n, d, i, g = !e;
          return t.forEach((m) => {
            if (m.length > 1) for (i = m.length - 1; i > 0; i--) (d = m[i] - m[i - 1]) < 0 && !g ? (e == null || e(), e = void 0) : d && (n === void 0 || d < n) && (n = d);
          }), n;
        }, getMagnitude: x, getNestedProperty: function(t, e) {
          let n = t.split(".");
          for (; n.length && v(e); ) {
            let d = n.shift();
            if (d === void 0 || d === "__proto__") return;
            if (d === "this") {
              let g;
              return A(e) && (g = e["@this"]), g ?? e;
            }
            let i = e[d];
            if (!v(i) || typeof i == "function" || typeof i.nodeType == "number" || i === z) return;
            e = i;
          }
          return e;
        }, getStyle: function t(e, n, d) {
          let i;
          if (n === "width") {
            let m = Math.min(e.offsetWidth, e.scrollWidth), k = e.getBoundingClientRect && e.getBoundingClientRect().width;
            return k < m && k >= m - 1 && (m = Math.floor(k)), Math.max(0, m - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
          }
          if (n === "height") return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
          let g = z.getComputedStyle(e, void 0);
          return g && (i = g.getPropertyValue(n), h(d, n !== "opacity") && (i = L(i))), i;
        }, inArray: function(t, e, n) {
          return O(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), e.indexOf(t, n);
        }, insertItem: function(t, e) {
          let n, d = t.options.index, i = e.length;
          for (n = t.options.isInternal ? i : 0; n < i + 1; n++) if (!e[n] || c(d) && d < h(e[n].options.index, e[n]._i) || e[n].options.isInternal) {
            e.splice(n, 0, t);
            break;
          }
          return n;
        }, isArray: w, isClass: u, isDOMElement: l, isFunction: function(t) {
          return typeof t == "function";
        }, isNumber: c, isObject: A, isString: M, keys: function(t) {
          return O(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(t);
        }, merge: function() {
          let t, e = arguments, n = {}, d = function(g, m) {
            return typeof g != "object" && (g = {}), b(m, function(k, j) {
              j !== "__proto__" && j !== "constructor" && (!A(k, !0) || u(k) || l(k) ? g[j] = m[j] : g[j] = d(g[j] || {}, k));
            }), g;
          };
          e[0] === !0 && (n = e[1], e = Array.prototype.slice.call(e, 2));
          let i = e.length;
          for (t = 0; t < i; t++) n = d(n, e[t]);
          return n;
        }, normalizeTickInterval: function(t, e, n, d, i) {
          let g, m = t;
          n = h(n, x(t));
          let k = t / n;
          for (!e && (e = i ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], d === !1 && (n === 1 ? e = e.filter(function(j) {
            return j % 1 == 0;
          }) : n <= 0.1 && (e = [1 / n]))), g = 0; g < e.length && (m = e[g], (!i || !(m * n >= t)) && (i || !(k <= (e[g] + (e[g + 1] || e[g])) / 2))); g++) ;
          return S(m * n, -Math.round(Math.log(1e-3) / Math.LN10));
        }, objectEach: b, offset: function(t) {
          let e = R.documentElement, n = t.parentElement || t.parentNode ? t.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
          return { top: n.top + (z.pageYOffset || e.scrollTop) - (e.clientTop || 0), left: n.left + (z.pageXOffset || e.scrollLeft) - (e.clientLeft || 0), width: n.width, height: n.height };
        }, pad: function(t, e, n) {
          return Array((e || 2) + 1 - String(t).replace("-", "").length).join(n || "0") + t;
        }, pick: h, pInt: L, pushUnique: function(t, e) {
          return 0 > t.indexOf(e) && !!t.push(e);
        }, relativeLength: function(t, e, n) {
          return /%$/.test(t) ? e * parseFloat(t) / 100 + (n || 0) : parseFloat(t);
        }, removeEvent: p, replaceNested: function(t, ...e) {
          let n, d;
          do
            for (d of (n = t, e)) t = t.replace(d[0], d[1]);
          while (t !== n);
          return t;
        }, splat: f, stableSort: function(t, e) {
          let n, d, i = t.length;
          for (d = 0; d < i; d++) t[d].safeI = d;
          for (t.sort(function(g, m) {
            return (n = e(g, m)) === 0 ? g.safeI - m.safeI : n;
          }), d = 0; d < i; d++) delete t[d].safeI;
        }, syncTimeout: function(t, e, n) {
          return e > 0 ? setTimeout(t, e, n) : (t.call(0, n), -1);
        }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: o, useSerialIds: function(t) {
          return B = h(t, B);
        }, wrap: function(t, e, n) {
          let d = t[e];
          t[e] = function() {
            let i = arguments, g = this;
            return n.apply(this, [function() {
              return d.apply(g, arguments.length ? arguments : i);
            }].concat([].slice.call(arguments)));
          };
        } };
      }), Z(r, "Core/Chart/ChartDefaults.js", [], function() {
        return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
      }), Z(r, "Core/Color/Palettes.js", [], function() {
        return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
      }), Z(r, "Core/Time.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { win: I } = T, { defined: R, error: z, extend: O, isNumber: L, isObject: M, merge: w, objectEach: A, pad: l, pick: u, splat: c, timeUnits: v } = B, s = T.isSafari && I.Intl && I.Intl.DateTimeFormat.prototype.formatRange, f = T.isSafari && I.Intl && !I.Intl.DateTimeFormat.prototype.formatRange;
        class y {
          constructor(a) {
            this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = I.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(a);
          }
          get(a, x) {
            if (this.variableTimezone || this.timezoneOffset) {
              let S = x.getTime(), E = S - this.getTimezoneOffset(x);
              x.setTime(E);
              let b = x["getUTC" + a]();
              return x.setTime(S), b;
            }
            return this.useUTC ? x["getUTC" + a]() : x["get" + a]();
          }
          set(a, x, S) {
            if (this.variableTimezone || this.timezoneOffset) {
              if (a === "Milliseconds" || a === "Seconds" || a === "Minutes" && this.getTimezoneOffset(x) % 36e5 == 0) return x["setUTC" + a](S);
              let E = this.getTimezoneOffset(x), b = x.getTime() - E;
              x.setTime(b), x["setUTC" + a](S);
              let p = this.getTimezoneOffset(x);
              return b = x.getTime() + p, x.setTime(b);
            }
            return this.useUTC || s && a === "FullYear" ? x["setUTC" + a](S) : x["set" + a](S);
          }
          update(a = {}) {
            let x = u(a.useUTC, !0);
            this.options = a = w(!0, this.options, a), this.Date = a.Date || I.Date || Date, this.useUTC = x, this.timezoneOffset = x && a.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = x && !!(a.getTimezoneOffset || a.timezone);
          }
          makeTime(a, x, S, E, b, p) {
            let C, o, t;
            return this.useUTC ? (C = this.Date.UTC.apply(0, arguments), o = this.getTimezoneOffset(C), C += o, o !== (t = this.getTimezoneOffset(C)) ? C += t - o : o - 36e5 !== this.getTimezoneOffset(C - 36e5) || f || (C -= 36e5)) : C = new this.Date(a, x, u(S, 1), u(E, 0), u(b, 0), u(p, 0)).getTime(), C;
          }
          timezoneOffsetFunction() {
            let a = this, x = this.options, S = x.getTimezoneOffset;
            return this.useUTC ? x.timezone ? (E) => {
              try {
                let b = `shortOffset,${x.timezone || ""}`, [p, C, o, t, e = 0] = (y.formatCache[b] = y.formatCache[b] || Intl.DateTimeFormat("en", { timeZone: x.timezone, timeZoneName: "shortOffset" })).format(E).split(/(GMT|:)/).map(Number), n = -(36e5 * (o + e / 60));
                if (L(n)) return n;
              } catch {
                z(34);
              }
              return 0;
            } : this.useUTC && S ? (E) => 6e4 * S(E.valueOf()) : () => 6e4 * (a.timezoneOffset || 0) : (E) => 6e4 * new Date(E.toString()).getTimezoneOffset();
          }
          dateFormat(a, x, S) {
            if (!R(x) || isNaN(x)) return T.defaultOptions.lang && T.defaultOptions.lang.invalidDate || "";
            a = u(a, "%Y-%m-%d %H:%M:%S");
            let E = this, b = new this.Date(x), p = this.get("Hours", b), C = this.get("Day", b), o = this.get("Date", b), t = this.get("Month", b), e = this.get("FullYear", b), n = T.defaultOptions.lang, d = n && n.weekdays, i = n && n.shortWeekdays;
            return A(O({ a: i ? i[C] : d[C].substr(0, 3), A: d[C], d: l(o), e: l(o, 2, " "), w: C, b: n.shortMonths[t], B: n.months[t], m: l(t + 1), o: t + 1, y: e.toString().substr(2, 2), Y: e, H: l(p), k: p, I: l(p % 12 || 12), l: p % 12 || 12, M: l(this.get("Minutes", b)), p: p < 12 ? "AM" : "PM", P: p < 12 ? "am" : "pm", S: l(this.get("Seconds", b)), L: l(Math.floor(x % 1e3), 3) }, T.dateFormats), function(g, m) {
              for (; a.indexOf("%" + m) !== -1; ) a = a.replace("%" + m, typeof g == "function" ? g.call(E, x) : g);
            }), S ? a.substr(0, 1).toUpperCase() + a.substr(1) : a;
          }
          resolveDTLFormat(a) {
            return M(a, !0) ? a : { main: (a = c(a))[0], from: a[1], to: a[2] };
          }
          getTimeTicks(a, x, S, E) {
            let b, p, C, o, t = this, e = t.Date, n = [], d = {}, i = new e(x), g = a.unitRange, m = a.count || 1;
            if (E = u(E, 1), R(x)) {
              t.set("Milliseconds", i, g >= v.second ? 0 : m * Math.floor(t.get("Milliseconds", i) / m)), g >= v.second && t.set("Seconds", i, g >= v.minute ? 0 : m * Math.floor(t.get("Seconds", i) / m)), g >= v.minute && t.set("Minutes", i, g >= v.hour ? 0 : m * Math.floor(t.get("Minutes", i) / m)), g >= v.hour && t.set("Hours", i, g >= v.day ? 0 : m * Math.floor(t.get("Hours", i) / m)), g >= v.day && t.set("Date", i, g >= v.month ? 1 : Math.max(1, m * Math.floor(t.get("Date", i) / m))), g >= v.month && (t.set("Month", i, g >= v.year ? 0 : m * Math.floor(t.get("Month", i) / m)), p = t.get("FullYear", i)), g >= v.year && (p -= p % m, t.set("FullYear", i, p)), g === v.week && (o = t.get("Day", i), t.set("Date", i, t.get("Date", i) - o + E + (o < E ? -7 : 0))), p = t.get("FullYear", i);
              let k = t.get("Month", i), j = t.get("Date", i), P = t.get("Hours", i);
              x = i.getTime(), (t.variableTimezone || !t.useUTC) && R(S) && (C = S - x > 4 * v.month || t.getTimezoneOffset(x) !== t.getTimezoneOffset(S));
              let D = i.getTime();
              for (b = 1; D < S; ) n.push(D), g === v.year ? D = t.makeTime(p + b * m, 0) : g === v.month ? D = t.makeTime(p, k + b * m) : C && (g === v.day || g === v.week) ? D = t.makeTime(p, k, j + b * m * (g === v.day ? 1 : 7)) : C && g === v.hour && m > 1 ? D = t.makeTime(p, k, j, P + b * m) : D += g * m, b++;
              n.push(D), g <= v.hour && n.length < 1e4 && n.forEach(function(H) {
                H % 18e5 == 0 && t.dateFormat("%H%M%S%L", H) === "000000000" && (d[H] = "day");
              });
            }
            return n.info = O(a, { higherRanks: d, totalRange: g * m }), n;
          }
          getDateFormat(a, x, S, E) {
            let b = this.dateFormat("%m-%d %H:%M:%S.%L", x), p = "01-01 00:00:00.000", C = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, o = "millisecond", t = o;
            for (o in v) {
              if (a === v.week && +this.dateFormat("%w", x) === S && b.substr(6) === p.substr(6)) {
                o = "week";
                break;
              }
              if (v[o] > a) {
                o = t;
                break;
              }
              if (C[o] && b.substr(C[o]) !== p.substr(C[o])) break;
              o !== "week" && (t = o);
            }
            return this.resolveDTLFormat(E[o]).main;
          }
        }
        return y.formatCache = {}, y;
      }), Z(r, "Core/Defaults.js", [r["Core/Chart/ChartDefaults.js"], r["Core/Globals.js"], r["Core/Color/Palettes.js"], r["Core/Time.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { isTouchDevice: O } = B, { fireEvent: L, merge: M } = z, w = { colors: I.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: T, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
          return this.name;
        }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (l) => Math.sqrt(1 - Math.pow(l - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: O ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
        w.chart.styledMode = !1;
        let A = new R(w.time);
        return { defaultOptions: w, defaultTime: A, getOptions: function() {
          return w;
        }, setOptions: function(l) {
          return L(B, "setOptions", { options: l }), M(!0, w, l), (l.time || l.global) && (B.time ? B.time.update(M(w.global, w.time, l.global, l.time)) : B.time = A), w;
        } };
      }), Z(r, "Core/Color/Color.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { isNumber: I, merge: R, pInt: z } = B;
        class O {
          static parse(M) {
            return M ? new O(M) : O.None;
          }
          constructor(M) {
            let w, A, l, u;
            this.rgba = [NaN, NaN, NaN, NaN], this.input = M;
            let c = T.Color;
            if (c && c !== O) return new c(M);
            if (typeof M == "object" && M.stops !== void 0) this.stops = M.stops.map((v) => new O(v[1]));
            else if (typeof M == "string") {
              if (this.input = M = O.names[M.toLowerCase()] || M, M.charAt(0) === "#") {
                let v = M.length, s = parseInt(M.substr(1), 16);
                v === 7 ? A = [(16711680 & s) >> 16, (65280 & s) >> 8, 255 & s, 1] : v === 4 && (A = [(3840 & s) >> 4 | (3840 & s) >> 8, (240 & s) >> 4 | 240 & s, (15 & s) << 4 | 15 & s, 1]);
              }
              if (!A) for (l = O.parsers.length; l-- && !A; ) (w = (u = O.parsers[l]).regex.exec(M)) && (A = u.parse(w));
            }
            A && (this.rgba = A);
          }
          get(M) {
            let w = this.input, A = this.rgba;
            if (typeof w == "object" && this.stops !== void 0) {
              let l = R(w);
              return l.stops = [].slice.call(l.stops), this.stops.forEach((u, c) => {
                l.stops[c] = [l.stops[c][0], u.get(M)];
              }), l;
            }
            return A && I(A[0]) ? M !== "rgb" && (M || A[3] !== 1) ? M === "a" ? `${A[3]}` : "rgba(" + A.join(",") + ")" : "rgb(" + A[0] + "," + A[1] + "," + A[2] + ")" : w;
          }
          brighten(M) {
            let w = this.rgba;
            if (this.stops) this.stops.forEach(function(A) {
              A.brighten(M);
            });
            else if (I(M) && M !== 0) for (let A = 0; A < 3; A++) w[A] += z(255 * M), w[A] < 0 && (w[A] = 0), w[A] > 255 && (w[A] = 255);
            return this;
          }
          setOpacity(M) {
            return this.rgba[3] = M, this;
          }
          tweenTo(M, w) {
            let A = this.rgba, l = M.rgba;
            if (!I(A[0]) || !I(l[0])) return M.input || "none";
            let u = l[3] !== 1 || A[3] !== 1;
            return (u ? "rgba(" : "rgb(") + Math.round(l[0] + (A[0] - l[0]) * (1 - w)) + "," + Math.round(l[1] + (A[1] - l[1]) * (1 - w)) + "," + Math.round(l[2] + (A[2] - l[2]) * (1 - w)) + (u ? "," + (l[3] + (A[3] - l[3]) * (1 - w)) : "") + ")";
          }
        }
        return O.names = { white: "#ffffff", black: "#000000" }, O.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(L) {
          return [z(L[1]), z(L[2]), z(L[3]), parseFloat(L[4], 10)];
        } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(L) {
          return [z(L[1]), z(L[2]), z(L[3]), 1];
        } }], O.None = new O(""), O;
      }), Z(r, "Core/Animation/Fx.js", [r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { parse: R } = T, { win: z } = B, { isNumber: O, objectEach: L } = I;
        class M {
          constructor(A, l, u) {
            this.pos = NaN, this.options = l, this.elem = A, this.prop = u;
          }
          dSetter() {
            let A = this.paths, l = A && A[0], u = A && A[1], c = this.now || 0, v = [];
            if (c !== 1 && l && u)
              if (l.length === u.length && c < 1) for (let s = 0; s < u.length; s++) {
                let f = l[s], y = u[s], h = [];
                for (let a = 0; a < y.length; a++) {
                  let x = f[a], S = y[a];
                  O(x) && O(S) && !(y[0] === "A" && (a === 4 || a === 5)) ? h[a] = x + c * (S - x) : h[a] = S;
                }
                v.push(h);
              }
              else v = u;
            else v = this.toD || [];
            this.elem.attr("d", v, void 0, !0);
          }
          update() {
            let A = this.elem, l = this.prop, u = this.now, c = this.options.step;
            this[l + "Setter"] ? this[l + "Setter"]() : A.attr ? A.element && A.attr(l, u, null, !0) : A.style[l] = u + this.unit, c && c.call(A, u, this);
          }
          run(A, l, u) {
            let c = this, v = c.options, s = function(h) {
              return !s.stopped && c.step(h);
            }, f = z.requestAnimationFrame || function(h) {
              setTimeout(h, 13);
            }, y = function() {
              for (let h = 0; h < M.timers.length; h++) M.timers[h]() || M.timers.splice(h--, 1);
              M.timers.length && f(y);
            };
            A !== l || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = A, this.end = l, this.unit = u, this.now = this.start, this.pos = 0, s.elem = this.elem, s.prop = this.prop, s() && M.timers.push(s) === 1 && f(y)) : (delete v.curAnim[this.prop], v.complete && Object.keys(v.curAnim).length === 0 && v.complete.call(this.elem));
          }
          step(A) {
            let l, u, c = +/* @__PURE__ */ new Date(), v = this.options, s = this.elem, f = v.complete, y = v.duration, h = v.curAnim;
            return s.attr && !s.element ? l = !1 : A || c >= y + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), h[this.prop] = !0, u = !0, L(h, function(a) {
              a !== !0 && (u = !1);
            }), u && f && f.call(s), l = !1) : (this.pos = v.easing((c - this.startTime) / y), this.now = this.start + (this.end - this.start) * this.pos, this.update(), l = !0), l;
          }
          initPath(A, l, u) {
            let c = A.startX, v = A.endX, s = u.slice(), f = A.isArea, y = f ? 2 : 1, h = l && u.length > l.length && u.hasStackedCliffs, a, x, S, E, b = l && l.slice();
            if (!b || h) return [s, s];
            function p(o, t) {
              for (; o.length < x; ) {
                let e = o[0], n = t[x - o.length];
                if (n && e[0] === "M" && (n[0] === "C" ? o[0] = ["C", e[1], e[2], e[1], e[2], e[1], e[2]] : o[0] = ["L", e[1], e[2]]), o.unshift(e), f) {
                  let d = o.pop();
                  o.push(o[o.length - 1], d);
                }
              }
            }
            function C(o) {
              for (; o.length < x; ) {
                let t = o[Math.floor(o.length / y) - 1].slice();
                if (t[0] === "C" && (t[1] = t[5], t[2] = t[6]), f) {
                  let e = o[Math.floor(o.length / y)].slice();
                  o.splice(o.length / 2, 0, t, e);
                } else o.push(t);
              }
            }
            if (c && v && v.length) {
              for (S = 0; S < c.length; S++) {
                if (c[S] === v[0]) {
                  a = S;
                  break;
                }
                if (c[0] === v[v.length - c.length + S]) {
                  a = S, E = !0;
                  break;
                }
                if (c[c.length - 1] === v[v.length - c.length + S]) {
                  a = c.length - S;
                  break;
                }
              }
              a === void 0 && (b = []);
            }
            return b.length && O(a) && (x = s.length + a * y, E ? (p(b, s), C(s)) : (p(s, b), C(b))), [b, s];
          }
          fillSetter() {
            M.prototype.strokeSetter.apply(this, arguments);
          }
          strokeSetter() {
            this.elem.attr(this.prop, R(this.start).tweenTo(R(this.end), this.pos), void 0, !0);
          }
        }
        return M.timers = [], M;
      }), Z(r, "Core/Animation/AnimationUtilities.js", [r["Core/Animation/Fx.js"], r["Core/Utilities.js"]], function(T, B) {
        let { defined: I, getStyle: R, isArray: z, isNumber: O, isObject: L, merge: M, objectEach: w, pick: A } = B;
        function l(c) {
          return L(c) ? M({ duration: 500, defer: 0 }, c) : { duration: c ? 500 : 0, defer: 0 };
        }
        function u(c, v) {
          let s = T.timers.length;
          for (; s--; ) T.timers[s].elem !== c || v && v !== T.timers[s].prop || (T.timers[s].stopped = !0);
        }
        return { animate: function(c, v, s) {
          let f, y = "", h, a, x;
          L(s) || (x = arguments, s = { duration: x[2], easing: x[3], complete: x[4] }), O(s.duration) || (s.duration = 400), s.easing = typeof s.easing == "function" ? s.easing : Math[s.easing] || Math.easeInOutSine, s.curAnim = M(v), w(v, function(S, E) {
            u(c, E), a = new T(c, s, E), h = void 0, E === "d" && z(v.d) ? (a.paths = a.initPath(c, c.pathArray, v.d), a.toD = v.d, f = 0, h = 1) : c.attr ? f = c.attr(E) : (f = parseFloat(R(c, E)) || 0, E !== "opacity" && (y = "px")), h || (h = S), typeof h == "string" && h.match("px") && (h = h.replace(/px/g, "")), a.run(f, h, y);
          });
        }, animObject: l, getDeferredAnimation: function(c, v, s) {
          let f = l(v), y = s ? [s] : c.series, h = 0, a = 0;
          return y.forEach((x) => {
            let S = l(x.options.animation);
            h = L(v) && I(v.defer) ? f.defer : Math.max(h, S.duration + S.defer), a = Math.min(f.duration, S.duration);
          }), c.renderer.forExport && (h = 0), { defer: Math.max(0, h - a), duration: Math.min(h, a) };
        }, setAnimation: function(c, v) {
          v.renderer.globalAnimation = A(c, v.options.chart.animation, !0);
        }, stop: u };
      }), Z(r, "Core/Renderer/HTML/AST.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { SVG_NS: I, win: R } = T, { attr: z, createElement: O, css: L, error: M, isFunction: w, isString: A, objectEach: l, splat: u } = B, { trustedTypes: c } = R, v = c && w(c.createPolicy) && c.createPolicy("highcharts", { createHTML: (h) => h }), s = v ? v.createHTML("") : "", f = function() {
          try {
            return !!new DOMParser().parseFromString(s, "text/html");
          } catch {
            return !1;
          }
        }();
        class y {
          static filterUserAttributes(a) {
            return l(a, (x, S) => {
              let E = !0;
              y.allowedAttributes.indexOf(S) === -1 && (E = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(S) !== -1 && (E = A(x) && y.allowedReferences.some((b) => x.indexOf(b) === 0)), E || (M(33, !1, void 0, { "Invalid attribute in config": `${S}` }), delete a[S]), A(x) && a[S] && (a[S] = x.replace(/</g, "&lt;"));
            }), a;
          }
          static parseStyle(a) {
            return a.split(";").reduce((x, S) => {
              let E = S.split(":").map((p) => p.trim()), b = E.shift();
              return b && E.length && (x[b.replace(/-([a-z])/g, (p) => p[1].toUpperCase())] = E.join(":")), x;
            }, {});
          }
          static setElementHTML(a, x) {
            a.innerHTML = y.emptyHTML, x && new y(x).addToDOM(a);
          }
          constructor(a) {
            this.nodes = typeof a == "string" ? this.parseMarkup(a) : a;
          }
          addToDOM(a) {
            return function x(S, E) {
              let b;
              return u(S).forEach(function(p) {
                let C, o = p.tagName, t = p.textContent ? T.doc.createTextNode(p.textContent) : void 0, e = y.bypassHTMLFiltering;
                if (o)
                  if (o === "#text") C = t;
                  else if (y.allowedTags.indexOf(o) !== -1 || e) {
                    let n = o === "svg" ? I : E.namespaceURI || I, d = T.doc.createElementNS(n, o), i = p.attributes || {};
                    l(p, function(g, m) {
                      m !== "tagName" && m !== "attributes" && m !== "children" && m !== "style" && m !== "textContent" && (i[m] = g);
                    }), z(d, e ? i : y.filterUserAttributes(i)), p.style && L(d, p.style), t && d.appendChild(t), x(p.children || [], d), C = d;
                  } else M(33, !1, void 0, { "Invalid tagName in config": o });
                C && E.appendChild(C), b = C;
              }), b;
            }(this.nodes, a);
          }
          parseMarkup(a) {
            let x, S = [];
            if (a = a.trim().replace(/ style=(["'])/g, " data-style=$1"), f) x = new DOMParser().parseFromString(v ? v.createHTML(a) : a, "text/html");
            else {
              let b = O("div");
              b.innerHTML = a, x = { body: b };
            }
            let E = (b, p) => {
              let C = b.nodeName.toLowerCase(), o = { tagName: C };
              C === "#text" && (o.textContent = b.textContent || "");
              let t = b.attributes;
              if (t) {
                let e = {};
                [].forEach.call(t, (n) => {
                  n.name === "data-style" ? o.style = y.parseStyle(n.value) : e[n.name] = n.value;
                }), o.attributes = e;
              }
              if (b.childNodes.length) {
                let e = [];
                [].forEach.call(b.childNodes, (n) => {
                  E(n, e);
                }), e.length && (o.children = e);
              }
              p.push(o);
            };
            return [].forEach.call(x.body.childNodes, (b) => E(b, S)), S;
          }
        }
        return y.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], y.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], y.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], y.emptyHTML = s, y.bypassHTMLFiltering = !1, y;
      }), Z(r, "Core/Templating.js", [r["Core/Defaults.js"], r["Core/Utilities.js"]], function(T, B) {
        let { defaultOptions: I, defaultTime: R } = T, { extend: z, getNestedProperty: O, isArray: L, isNumber: M, isObject: w, pick: A, pInt: l } = B, u = { add: (s, f) => s + f, divide: (s, f) => f !== 0 ? s / f : "", eq: (s, f) => s == f, each: function(s) {
          let f = arguments[arguments.length - 1];
          return !!L(s) && s.map((y, h) => c(f.body, z(w(y) ? y : { "@this": y }, { "@index": h, "@first": h === 0, "@last": h === s.length - 1 }))).join("");
        }, ge: (s, f) => s >= f, gt: (s, f) => s > f, if: (s) => !!s, le: (s, f) => s <= f, lt: (s, f) => s < f, multiply: (s, f) => s * f, ne: (s, f) => s != f, subtract: (s, f) => s - f, unless: (s) => !s };
        function c(s = "", f, y) {
          let h = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, a = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, x = [], S = /f$/, E = /\.(\d)/, b = I.lang, p = y && y.time || R, C = y && y.numberFormatter || v, o = (i = "") => {
            let g;
            return i === "true" || i !== "false" && ((g = Number(i)).toString() === i ? g : O(i, f));
          }, t, e, n = 0, d;
          for (; (t = h.exec(s)) !== null; ) {
            let i = a.exec(t[1]);
            i && (t = i, d = !0), e && e.isBlock || (e = { ctx: f, expression: t[1], find: t[0], isBlock: t[1].charAt(0) === "#", start: t.index, startInner: t.index + t[0].length, length: t[0].length });
            let g = t[1].split(" ")[0].replace("#", "");
            u[g] && (e.isBlock && g === e.fn && n++, e.fn || (e.fn = g));
            let m = t[1] === "else";
            if (e.isBlock && e.fn && (t[1] === `/${e.fn}` || m))
              if (n) !m && n--;
              else {
                let k = e.startInner, j = s.substr(k, t.index - k);
                e.body === void 0 ? (e.body = j, e.startInner = t.index + t[0].length) : e.elseBody = j, e.find += j + t[0], m || (x.push(e), e = void 0);
              }
            else e.isBlock || x.push(e);
            if (i && !(e != null && e.isBlock)) break;
          }
          return x.forEach((i) => {
            let g, m, { body: k, elseBody: j, expression: P, fn: D } = i;
            if (D) {
              let H = [i], G = P.split(" ");
              for (m = u[D].length; m--; ) H.unshift(o(G[m + 1]));
              g = u[D].apply(f, H), i.isBlock && typeof g == "boolean" && (g = c(g ? k : j, f, y));
            } else {
              let H = P.split(":");
              if (g = o(H.shift() || ""), H.length && typeof g == "number") {
                let G = H.join(":");
                if (S.test(G)) {
                  let V = parseInt((G.match(E) || ["", "-1"])[1], 10);
                  g !== null && (g = C(g, V, b.decimalPoint, G.indexOf(",") > -1 ? b.thousandsSep : ""));
                } else g = p.dateFormat(G, g);
              }
            }
            s = s.replace(i.find, A(g, ""));
          }), d ? c(s, f, y) : s;
        }
        function v(s, f, y, h) {
          let a, x;
          s = +s || 0, f = +f;
          let S = I.lang, E = (s.toString().split(".")[1] || "").split("e")[0].length, b = s.toString().split("e"), p = f;
          f === -1 ? f = Math.min(E, 20) : M(f) ? f && b[1] && b[1] < 0 && ((x = f + +b[1]) >= 0 ? (b[0] = (+b[0]).toExponential(x).split("e")[0], f = x) : (b[0] = b[0].split(".")[0] || 0, s = f < 20 ? (b[0] * Math.pow(10, b[1])).toFixed(f) : 0, b[1] = 0)) : f = 2;
          let C = (Math.abs(b[1] ? b[0] : s) + Math.pow(10, -Math.max(f, E) - 1)).toFixed(f), o = String(l(C)), t = o.length > 3 ? o.length % 3 : 0;
          return y = A(y, S.decimalPoint), h = A(h, S.thousandsSep), a = (s < 0 ? "-" : "") + (t ? o.substr(0, t) + h : ""), 0 > +b[1] && !p ? a = "0" : a += o.substr(t).replace(/(\d{3})(?=\d)/g, "$1" + h), f ? a += y + C.slice(-f) : +a == 0 && (a = "0"), b[1] && +a != 0 && (a += "e" + b[1]), a;
        }
        return { dateFormat: function(s, f, y) {
          return R.dateFormat(s, f, y);
        }, format: c, helpers: u, numberFormat: v };
      }), Z(r, "Core/Renderer/RendererRegistry.js", [r["Core/Globals.js"]], function(T) {
        var B, I;
        let R;
        return (I = B || (B = {})).rendererTypes = {}, I.getRendererType = function(z = R) {
          return I.rendererTypes[z] || I.rendererTypes[R];
        }, I.registerRendererType = function(z, O, L) {
          I.rendererTypes[z] = O, (!R || L) && (R = z, T.Renderer = O);
        }, B;
      }), Z(r, "Core/Renderer/RendererUtilities.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { clamp: I, pick: R, pushUnique: z, stableSort: O } = T;
        return (B || (B = {})).distribute = function L(M, w, A) {
          let l = M, u = l.reducedLen || w, c = (o, t) => o.target - t.target, v = [], s = M.length, f = [], y = v.push, h, a, x, S = !0, E, b, p = 0, C;
          for (h = s; h--; ) p += M[h].size;
          if (p > u) {
            for (O(M, (o, t) => (t.rank || 0) - (o.rank || 0)), x = (C = M[0].rank === M[M.length - 1].rank) ? s / 2 : -1, a = C ? x : s - 1; x && p > u; ) E = M[h = Math.floor(a)], z(f, h) && (p -= E.size), a += x, C && a >= M.length && (x /= 2, a = x);
            f.sort((o, t) => t - o).forEach((o) => y.apply(v, M.splice(o, 1)));
          }
          for (O(M, c), M = M.map((o) => ({ size: o.size, targets: [o.target], align: R(o.align, 0.5) })); S; ) {
            for (h = M.length; h--; ) E = M[h], b = (Math.min.apply(0, E.targets) + Math.max.apply(0, E.targets)) / 2, E.pos = I(b - E.size * E.align, 0, w - E.size);
            for (h = M.length, S = !1; h--; ) h > 0 && M[h - 1].pos + M[h - 1].size > M[h].pos && (M[h - 1].size += M[h].size, M[h - 1].targets = M[h - 1].targets.concat(M[h].targets), M[h - 1].align = 0.5, M[h - 1].pos + M[h - 1].size > w && (M[h - 1].pos = w - M[h - 1].size), M.splice(h, 1), S = !0);
          }
          return y.apply(l, v), h = 0, M.some((o) => {
            let t = 0;
            return (o.targets || []).some(() => (l[h].pos = o.pos + t, A !== void 0 && Math.abs(l[h].pos - l[h].target) > A ? (l.slice(0, h + 1).forEach((e) => delete e.pos), l.reducedLen = (l.reducedLen || w) - 0.1 * w, l.reducedLen > 0.1 * w && L(l, w, A), !0) : (t += l[h].size, h++, !1)));
          }), O(l, c), l;
        }, B;
      }), Z(r, "Core/Renderer/SVG/SVGElement.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { animate: z, animObject: O, stop: L } = T, { deg2rad: M, doc: w, svg: A, SVG_NS: l, win: u } = I, { addEvent: c, attr: v, createElement: s, crisp: f, css: y, defined: h, erase: a, extend: x, fireEvent: S, isArray: E, isFunction: b, isObject: p, isString: C, merge: o, objectEach: t, pick: e, pInt: n, pushUnique: d, replaceNested: i, syncTimeout: g, uniqueKey: m } = R;
        class k {
          _defaultGetter(P) {
            let D = e(this[P + "Value"], this[P], this.element ? this.element.getAttribute(P) : null, 0);
            return /^-?[\d\.]+$/.test(D) && (D = parseFloat(D)), D;
          }
          _defaultSetter(P, D, H) {
            H.setAttribute(D, P);
          }
          add(P) {
            let D, H = this.renderer, G = this.element;
            return P && (this.parentGroup = P), this.textStr !== void 0 && this.element.nodeName === "text" && H.buildText(this), this.added = !0, (!P || P.handleZ || this.zIndex) && (D = this.zIndexSetter()), D || (P ? P.element : H.box).appendChild(G), this.onAdd && this.onAdd(), this;
          }
          addClass(P, D) {
            let H = D ? "" : this.attr("class") || "";
            return (P = (P || "").split(/ /g).reduce(function(G, V) {
              return H.indexOf(V) === -1 && G.push(V), G;
            }, H ? [H] : []).join(" ")) !== H && this.attr("class", P), this;
          }
          afterSetters() {
            this.doTransform && (this.updateTransform(), this.doTransform = !1);
          }
          align(P, D, H, G = !0) {
            let V, F, U, Y, q = {}, N = this.renderer, X = N.alignedObjects, W = !!P;
            P ? (this.alignOptions = P, this.alignByTranslate = D, this.alignTo = H) : (P = this.alignOptions || {}, D = this.alignByTranslate, H = this.alignTo);
            let _ = !H || C(H) ? H || "renderer" : void 0;
            _ && (W && d(X, this), H = void 0);
            let K = e(H, N[_], N), J = P.align, $ = P.verticalAlign;
            return V = (K.x || 0) + (P.x || 0), F = (K.y || 0) + (P.y || 0), J === "right" ? U = 1 : J === "center" && (U = 2), U && (V += ((K.width || 0) - (P.width || 0)) / U), q[D ? "translateX" : "x"] = Math.round(V), $ === "bottom" ? Y = 1 : $ === "middle" && (Y = 2), Y && (F += ((K.height || 0) - (P.height || 0)) / Y), q[D ? "translateY" : "y"] = Math.round(F), G && (this[this.placed ? "animate" : "attr"](q), this.placed = !0), this.alignAttr = q, this;
          }
          alignSetter(P) {
            let D = { left: "start", center: "middle", right: "end" };
            D[P] && (this.alignValue = P, this.element.setAttribute("text-anchor", D[P]));
          }
          animate(P, D, H) {
            let G = O(e(D, this.renderer.globalAnimation, !0)), V = G.defer;
            return w.hidden && (G.duration = 0), G.duration !== 0 ? (H && (G.complete = H), g(() => {
              this.element && z(this, P, G);
            }, V)) : (this.attr(P, void 0, H || G.complete), t(P, function(F, U) {
              G.step && G.step.call(this, F, { prop: U, pos: 1, elem: this });
            }, this)), this;
          }
          applyTextOutline(P) {
            let D = this.element;
            P.indexOf("contrast") !== -1 && (P = P.replace(/contrast/g, this.renderer.getContrast(D.style.fill)));
            let H = P.split(" "), G = H[H.length - 1], V = H[0];
            if (V && V !== "none" && I.svg) {
              this.fakeTS = !0, V = V.replace(/(^[\d\.]+)(.*?)$/g, function(N, X, W) {
                return 2 * Number(X) + W;
              }), this.removeTextOutline();
              let F = w.createElementNS(l, "tspan");
              v(F, { class: "highcharts-text-outline", fill: G, stroke: G, "stroke-width": V, "stroke-linejoin": "round" });
              let U = D.querySelector("textPath") || D;
              [].forEach.call(U.childNodes, (N) => {
                let X = N.cloneNode(!0);
                X.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((W) => X.removeAttribute(W)), F.appendChild(X);
              });
              let Y = 0;
              [].forEach.call(U.querySelectorAll("text tspan"), (N) => {
                Y += Number(N.getAttribute("dy"));
              });
              let q = w.createElementNS(l, "tspan");
              q.textContent = "​", v(q, { x: Number(D.getAttribute("x")), dy: -Y }), F.appendChild(q), U.insertBefore(F, U.firstChild);
            }
          }
          attr(P, D, H, G) {
            let { element: V } = this, F = k.symbolCustomAttribs, U, Y, q = this, N;
            return typeof P == "string" && D !== void 0 && (U = P, (P = {})[U] = D), typeof P == "string" ? q = (this[P + "Getter"] || this._defaultGetter).call(this, P, V) : (t(P, function(X, W) {
              N = !1, G || L(this, W), this.symbolName && F.indexOf(W) !== -1 && (Y || (this.symbolAttr(P), Y = !0), N = !0), this.rotation && (W === "x" || W === "y") && (this.doTransform = !0), N || (this[W + "Setter"] || this._defaultSetter).call(this, X, W, V);
            }, this), this.afterSetters()), H && H.call(this), q;
          }
          clip(P) {
            if (P && !P.clipPath) {
              let D = m() + "-", H = this.renderer.createElement("clipPath").attr({ id: D }).add(this.renderer.defs);
              x(P, { clipPath: H, id: D, count: 0 }), P.add(H);
            }
            return this.attr("clip-path", P ? `url(${this.renderer.url}#${P.id})` : "none");
          }
          crisp(P, D) {
            D = Math.round(D || P.strokeWidth || 0);
            let H = P.x || this.x || 0, G = P.y || this.y || 0, V = (P.width || this.width || 0) + H, F = (P.height || this.height || 0) + G, U = f(H, D), Y = f(G, D);
            return x(P, { x: U, y: Y, width: f(V, D) - U, height: f(F, D) - Y }), h(P.strokeWidth) && (P.strokeWidth = D), P;
          }
          complexColor(P, D, H) {
            let G = this.renderer, V, F, U, Y, q, N, X, W, _, K, J = [], $;
            S(this.renderer, "complexColor", { args: arguments }, function() {
              if (P.radialGradient ? F = "radialGradient" : P.linearGradient && (F = "linearGradient"), F) {
                if (U = P[F], q = G.gradients, N = P.stops, _ = H.radialReference, E(U) && (P[F] = U = { x1: U[0], y1: U[1], x2: U[2], y2: U[3], gradientUnits: "userSpaceOnUse" }), F === "radialGradient" && _ && !h(U.gradientUnits) && (Y = U, U = o(U, G.getRadialAttr(_, Y), { gradientUnits: "userSpaceOnUse" })), t(U, function(et, st) {
                  st !== "id" && J.push(st, et);
                }), t(N, function(et) {
                  J.push(et);
                }), q[J = J.join(",")]) K = q[J].attr("id");
                else {
                  U.id = K = m();
                  let et = q[J] = G.createElement(F).attr(U).add(G.defs);
                  et.radAttr = Y, et.stops = [], N.forEach(function(st) {
                    st[1].indexOf("rgba") === 0 ? (X = (V = B.parse(st[1])).get("rgb"), W = V.get("a")) : (X = st[1], W = 1);
                    let at = G.createElement("stop").attr({ offset: st[0], "stop-color": X, "stop-opacity": W }).add(et);
                    et.stops.push(at);
                  });
                }
                $ = "url(" + G.url + "#" + K + ")", H.setAttribute(D, $), H.gradient = J, P.toString = function() {
                  return $;
                };
              }
            });
          }
          css(P) {
            let D = this.styles, H = {}, G = this.element, V, F = !D;
            if (D && t(P, function(U, Y) {
              D && D[Y] !== U && (H[Y] = U, F = !0);
            }), F) {
              D && (P = x(D, H)), P.width === null || P.width === "auto" ? delete this.textWidth : G.nodeName.toLowerCase() === "text" && P.width && (V = this.textWidth = n(P.width)), x(this.styles, P), V && !A && this.renderer.forExport && delete P.width;
              let U = o(P);
              G.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((Y) => U && delete U[Y]), U.color && (U.fill = U.color)), y(G, U);
            }
            return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), P.textOutline && this.applyTextOutline(P.textOutline)), this;
          }
          dashstyleSetter(P) {
            let D, H = this["stroke-width"];
            if (H === "inherit" && (H = 1), P = P && P.toLowerCase()) {
              let G = P.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
              for (D = G.length; D--; ) G[D] = "" + n(G[D]) * e(H, NaN);
              P = G.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", P);
            }
          }
          destroy() {
            var Y;
            let P = this, D = P.element || {}, H = P.renderer, G = D.ownerSVGElement, V = D.nodeName === "SPAN" && P.parentGroup || void 0, F, U;
            if (D.onclick = D.onmouseout = D.onmouseover = D.onmousemove = D.point = null, L(P), P.clipPath && G) {
              let q = P.clipPath;
              [].forEach.call(G.querySelectorAll("[clip-path],[CLIP-PATH]"), function(N) {
                N.getAttribute("clip-path").indexOf(q.element.id) > -1 && N.removeAttribute("clip-path");
              }), P.clipPath = q.destroy();
            }
            if (P.connector = (Y = P.connector) == null ? void 0 : Y.destroy(), P.stops) {
              for (U = 0; U < P.stops.length; U++) P.stops[U].destroy();
              P.stops.length = 0, P.stops = void 0;
            }
            for (P.safeRemoveChild(D); V && V.div && V.div.childNodes.length === 0; ) F = V.parentGroup, P.safeRemoveChild(V.div), delete V.div, V = F;
            P.alignOptions && a(H.alignedObjects, P), t(P, function(q, N) {
              P[N] && P[N].parentGroup === P && P[N].destroy && P[N].destroy(), delete P[N];
            });
          }
          dSetter(P, D, H) {
            E(P) && (typeof P[0] == "string" && (P = this.renderer.pathToSegments(P)), this.pathArray = P, P = P.reduce((G, V, F) => V && V.join ? (F ? G + " " : "") + V.join(" ") : (V || "").toString(), "")), /(NaN| {2}|^$)/.test(P) && (P = "M 0 0"), this[D] !== P && (H.setAttribute(D, P), this[D] = P);
          }
          fillSetter(P, D, H) {
            typeof P == "string" ? H.setAttribute(D, P) : P && this.complexColor(P, D, H);
          }
          hrefSetter(P, D, H) {
            H.setAttributeNS("http://www.w3.org/1999/xlink", D, P);
          }
          getBBox(P, D) {
            let H, G, V, F, { alignValue: U, element: Y, renderer: q, styles: N, textStr: X } = this, { cache: W, cacheKeys: _ } = q, K = Y.namespaceURI === this.SVG_NS, J = e(D, this.rotation, 0), $ = q.styledMode ? Y && k.prototype.getStyle.call(Y, "font-size") : N.fontSize;
            if (h(X) && ((F = X.toString()).indexOf("<") === -1 && (F = F.replace(/\d/g, "0")), F += ["", q.rootFontSize, $, J, this.textWidth, U, N.textOverflow, N.fontWeight].join(",")), F && !P && (H = W[F]), !H || H.polygon) {
              if (K || q.forExport) {
                try {
                  V = this.fakeTS && function(st) {
                    let at = Y.querySelector(".highcharts-text-outline");
                    at && y(at, { display: st });
                  }, b(V) && V("none"), H = Y.getBBox ? x({}, Y.getBBox()) : { width: Y.offsetWidth, height: Y.offsetHeight, x: 0, y: 0 }, b(V) && V("");
                } catch {
                }
                (!H || H.width < 0) && (H = { x: 0, y: 0, width: 0, height: 0 });
              } else H = this.htmlGetBBox();
              G = H.height, K && (H.height = G = { "11px,17": 14, "13px,20": 16 }[`${$ || ""},${Math.round(G)}`] || G), J && (H = this.getRotatedBox(H, J));
              let et = { bBox: H };
              S(this, "afterGetBBox", et), H = et.bBox;
            }
            if (F && (X === "" || H.height > 0)) {
              for (; _.length > 250; ) delete W[_.shift()];
              W[F] || _.push(F), W[F] = H;
            }
            return H;
          }
          getRotatedBox(P, D) {
            let { x: H, y: G, width: V, height: F } = P, { alignValue: U, translateY: Y, rotationOriginX: q = 0, rotationOriginY: N = 0 } = this, X = { right: 1, center: 0.5 }[U || 0] || 0, W = Number(this.element.getAttribute("y") || 0) - (Y ? 0 : G), _ = D * M, K = (D - 90) * M, J = Math.cos(_), $ = Math.sin(_), et = V * J, st = V * $, at = Math.cos(K), lt = Math.sin(K), [[it, Q], [ot, nt]] = [q, N].map((Ct) => [Ct - Ct * J, Ct * $]), ht = H + X * (V - et) + it + nt + W * at, ct = ht + et, dt = ct - F * at, ut = dt - et, pt = G + W - X * st - Q + ot + W * lt, gt = pt + st, ft = gt - F * lt, mt = ft - st, yt = Math.min(ht, ct, dt, ut), xt = Math.min(pt, gt, ft, mt), bt = Math.max(ht, ct, dt, ut) - yt, vt = Math.max(pt, gt, ft, mt) - xt;
            return { x: yt, y: xt, width: bt, height: vt, polygon: [[ht, pt], [ct, gt], [dt, ft], [ut, mt]] };
          }
          getStyle(P) {
            return u.getComputedStyle(this.element || this, "").getPropertyValue(P);
          }
          hasClass(P) {
            return ("" + this.attr("class")).split(" ").indexOf(P) !== -1;
          }
          hide() {
            return this.attr({ visibility: "hidden" });
          }
          htmlGetBBox() {
            return { height: 0, width: 0, x: 0, y: 0 };
          }
          constructor(P, D) {
            this.onEvents = {}, this.opacity = 1, this.SVG_NS = l, this.element = D === "span" || D === "body" ? s(D) : w.createElementNS(this.SVG_NS, D), this.renderer = P, this.styles = {}, S(this, "afterInit");
          }
          on(P, D) {
            let { onEvents: H } = this;
            return H[P] && H[P](), H[P] = c(this.element, P, D), this;
          }
          opacitySetter(P, D, H) {
            let G = Number(Number(P).toFixed(3));
            this.opacity = G, H.setAttribute(D, G);
          }
          reAlign() {
            var P;
            (P = this.alignOptions) != null && P.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
          }
          removeClass(P) {
            return this.attr("class", ("" + this.attr("class")).replace(C(P) ? RegExp(`(^| )${P}( |$)`) : P, " ").replace(/ +/g, " ").trim());
          }
          removeTextOutline() {
            let P = this.element.querySelector("tspan.highcharts-text-outline");
            P && this.safeRemoveChild(P);
          }
          safeRemoveChild(P) {
            let D = P.parentNode;
            D && D.removeChild(P);
          }
          setRadialReference(P) {
            let D = this.element.gradient && this.renderer.gradients[this.element.gradient];
            return this.element.radialReference = P, D && D.radAttr && D.animate(this.renderer.getRadialAttr(P, D.radAttr)), this;
          }
          shadow(P) {
            var V;
            let { renderer: D } = this, H = o(((V = this.parentGroup) == null ? void 0 : V.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, p(P) ? P : {}), G = D.shadowDefinition(H);
            return this.attr({ filter: P ? `url(${D.url}#${G})` : "none" });
          }
          show(P = !0) {
            return this.attr({ visibility: P ? "inherit" : "visible" });
          }
          "stroke-widthSetter"(P, D, H) {
            this[D] = P, H.setAttribute(D, P);
          }
          strokeWidth() {
            if (!this.renderer.styledMode) return this["stroke-width"] || 0;
            let P = this.getStyle("stroke-width"), D = 0, H;
            return /px$/.test(P) ? D = n(P) : P !== "" && (v(H = w.createElementNS(l, "rect"), { width: P, "stroke-width": 0 }), this.element.parentNode.appendChild(H), D = H.getBBox().width, H.parentNode.removeChild(H)), D;
          }
          symbolAttr(P) {
            let D = this;
            k.symbolCustomAttribs.forEach(function(H) {
              D[H] = e(P[H], D[H]);
            }), D.attr({ d: D.renderer.symbols[D.symbolName](D.x, D.y, D.width, D.height, D) });
          }
          textSetter(P) {
            P !== this.textStr && (delete this.textPxLength, this.textStr = P, this.added && this.renderer.buildText(this), this.reAlign());
          }
          titleSetter(P) {
            let D = this.element, H = D.getElementsByTagName("title")[0] || w.createElementNS(this.SVG_NS, "title");
            D.insertBefore ? D.insertBefore(H, D.firstChild) : D.appendChild(H), H.textContent = i(e(P, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
          }
          toFront() {
            let P = this.element;
            return P.parentNode.appendChild(P), this;
          }
          translate(P, D) {
            return this.attr({ translateX: P, translateY: D });
          }
          updateTransform(P = "transform") {
            var W;
            let { element: D, matrix: H, rotation: G = 0, rotationOriginX: V, rotationOriginY: F, scaleX: U, scaleY: Y, translateX: q = 0, translateY: N = 0 } = this, X = ["translate(" + q + "," + N + ")"];
            h(H) && X.push("matrix(" + H.join(",") + ")"), G && (X.push("rotate(" + G + " " + e(V, D.getAttribute("x"), 0) + " " + e(F, D.getAttribute("y") || 0) + ")"), ((W = this.text) == null ? void 0 : W.element.tagName) === "SPAN" && this.text.attr({ rotation: G, rotationOriginX: (V || 0) - this.padding, rotationOriginY: (F || 0) - this.padding })), (h(U) || h(Y)) && X.push("scale(" + e(U, 1) + " " + e(Y, 1) + ")"), X.length && !(this.text || this).textPath && D.setAttribute(P, X.join(" "));
          }
          visibilitySetter(P, D, H) {
            P === "inherit" ? H.removeAttribute(D) : this[D] !== P && H.setAttribute(D, P), this[D] = P;
          }
          xGetter(P) {
            return this.element.nodeName === "circle" && (P === "x" ? P = "cx" : P === "y" && (P = "cy")), this._defaultGetter(P);
          }
          zIndexSetter(P, D) {
            let H = this.renderer, G = this.parentGroup, V = (G || H).element || H.box, F = this.element, U = V === H.box, Y, q, N, X = !1, W, _ = this.added, K;
            if (h(P) ? (F.setAttribute("data-z-index", P), P = +P, this[D] === P && (_ = !1)) : h(this[D]) && F.removeAttribute("data-z-index"), this[D] = P, _) {
              for ((P = this.zIndex) && G && (G.handleZ = !0), K = (Y = V.childNodes).length - 1; K >= 0 && !X; K--) W = !h(N = (q = Y[K]).getAttribute("data-z-index")), q !== F && (P < 0 && W && !U && !K ? (V.insertBefore(F, Y[K]), X = !0) : (n(N) <= P || W && (!h(P) || P >= 0)) && (V.insertBefore(F, Y[K + 1]), X = !0));
              X || (V.insertBefore(F, Y[U ? 3 : 0]), X = !0);
            }
            return X;
          }
        }
        return k.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], k.prototype.strokeSetter = k.prototype.fillSetter, k.prototype.yGetter = k.prototype.xGetter, k.prototype.matrixSetter = k.prototype.rotationOriginXSetter = k.prototype.rotationOriginYSetter = k.prototype.rotationSetter = k.prototype.scaleXSetter = k.prototype.scaleYSetter = k.prototype.translateXSetter = k.prototype.translateYSetter = k.prototype.verticalAlignSetter = function(j, P) {
          this[P] = j, this.doTransform = !0;
        }, k;
      }), Z(r, "Core/Renderer/SVG/SVGLabel.js", [r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B) {
        let { defined: I, extend: R, isNumber: z, merge: O, pick: L, removeEvent: M } = B;
        class w extends T {
          constructor(l, u, c, v, s, f, y, h, a, x) {
            let S;
            super(l, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = u, this.x = c, this.y = v, this.anchorX = f, this.anchorY = y, this.baseline = a, this.className = x, this.addClass(x === "button" ? "highcharts-no-tooltip" : "highcharts-label"), x && this.addClass("highcharts-" + x), this.text = l.text(void 0, 0, 0, h).attr({ zIndex: 1 }), typeof s == "string" && ((S = /^url\((.*?)\)$/.test(s)) || this.renderer.symbols[s]) && (this.symbolKey = s), this.bBox = w.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = l.styledMode || S, this.deferredAttr = {}, this.alignFactor = 0;
          }
          alignSetter(l) {
            let u = { left: 0, center: 0.5, right: 1 }[l];
            u !== this.alignFactor && (this.alignFactor = u, this.bBox && z(this.xSetting) && this.attr({ x: this.xSetting }));
          }
          anchorXSetter(l, u) {
            this.anchorX = l, this.boxAttr(u, Math.round(l) - this.getCrispAdjust() - this.xSetting);
          }
          anchorYSetter(l, u) {
            this.anchorY = l, this.boxAttr(u, l - this.ySetting);
          }
          boxAttr(l, u) {
            this.box ? this.box.attr(l, u) : this.deferredAttr[l] = u;
          }
          css(l) {
            if (l) {
              let u = {};
              l = O(l), w.textProps.forEach((c) => {
                l[c] !== void 0 && (u[c] = l[c], delete l[c]);
              }), this.text.css(u), "fontSize" in u || "fontWeight" in u ? this.updateTextPadding() : ("width" in u || "textOverflow" in u) && this.updateBoxSize();
            }
            return T.prototype.css.call(this, l);
          }
          destroy() {
            M(this.element, "mouseenter"), M(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), T.prototype.destroy.call(this);
          }
          fillSetter(l, u) {
            l && (this.needsBox = !0), this.fill = l, this.boxAttr(u, l);
          }
          getBBox(l, u) {
            this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
            let { padding: c, height: v = 0, translateX: s = 0, translateY: f = 0, width: y = 0 } = this, h = L(this.paddingLeft, c), a = u ?? (this.rotation || 0), x = { width: y, height: v, x: s + this.bBox.x - h, y: f + this.bBox.y - c + this.baselineOffset };
            return a && (x = this.getRotatedBox(x, a)), x;
          }
          getCrispAdjust() {
            return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
          }
          heightSetter(l) {
            this.heightSetting = l, this.doUpdate = !0;
          }
          afterSetters() {
            super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
          }
          onAdd() {
            this.text.add(this), this.attr({ text: L(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && I(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
          }
          paddingSetter(l, u) {
            z(l) ? l !== this[u] && (this[u] = l, this.updateTextPadding()) : this[u] = void 0;
          }
          rSetter(l, u) {
            this.boxAttr(u, l);
          }
          strokeSetter(l, u) {
            this.stroke = l, this.boxAttr(u, l);
          }
          "stroke-widthSetter"(l, u) {
            l && (this.needsBox = !0), this["stroke-width"] = l, this.boxAttr(u, l);
          }
          "text-alignSetter"(l) {
            this.textAlign = l;
          }
          textSetter(l) {
            l !== void 0 && this.text.attr({ text: l }), this.updateTextPadding(), this.reAlign();
          }
          updateBoxSize() {
            let l, u = this.text, c = {}, v = this.padding, s = this.bBox = (!z(this.widthSetting) || !z(this.heightSetting) || this.textAlign) && I(u.textStr) ? u.getBBox(void 0, 0) : w.emptyBBox;
            this.width = this.getPaddedWidth(), this.height = (this.heightSetting || s.height || 0) + 2 * v;
            let f = this.renderer.fontMetrics(u);
            if (this.baselineOffset = v + Math.min((this.text.firstLineMetrics || f).b, s.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - f.h) / 2), this.needsBox && !u.textPath) {
              if (!this.box) {
                let y = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                y.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), y.add(this);
              }
              l = this.getCrispAdjust(), c.x = l, c.y = (this.baseline ? -this.baselineOffset : 0) + l, c.width = Math.round(this.width), c.height = Math.round(this.height), this.box.attr(R(c, this.deferredAttr)), this.deferredAttr = {};
            }
          }
          updateTextPadding() {
            let l = this.text;
            if (!l.textPath) {
              this.updateBoxSize();
              let u = this.baseline ? 0 : this.baselineOffset, c = L(this.paddingLeft, this.padding);
              I(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (c += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (c !== l.x || u !== l.y) && (l.attr("x", c), l.hasBoxWidthChanged && (this.bBox = l.getBBox(!0)), u !== void 0 && l.attr("y", u)), l.x = c, l.y = u;
            }
          }
          widthSetter(l) {
            this.widthSetting = z(l) ? l : void 0, this.doUpdate = !0;
          }
          getPaddedWidth() {
            let l = this.padding, u = L(this.paddingLeft, l), c = L(this.paddingRight, l);
            return (this.widthSetting || this.bBox.width || 0) + u + c;
          }
          xSetter(l) {
            this.x = l, this.alignFactor && (l -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(l), this.attr("translateX", this.xSetting);
          }
          ySetter(l) {
            this.ySetting = this.y = Math.round(l), this.attr("translateY", this.ySetting);
          }
        }
        return w.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, w.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], w;
      }), Z(r, "Core/Renderer/SVG/Symbols.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B, isNumber: I, pick: R } = T;
        function z(M, w, A, l, u) {
          let c = [];
          if (u) {
            let v = u.start || 0, s = R(u.r, A), f = R(u.r, l || A), y = 2e-4 / (u.borderRadius ? 1 : Math.max(s, 1)), h = Math.abs((u.end || 0) - v - 2 * Math.PI) < y, a = (u.end || 0) - (h ? y : 0), x = u.innerR, S = R(u.open, h), E = Math.cos(v), b = Math.sin(v), p = Math.cos(a), C = Math.sin(a), o = R(u.longArc, a - v - Math.PI < y ? 0 : 1), t = ["A", s, f, 0, o, R(u.clockwise, 1), M + s * p, w + f * C];
            t.params = { start: v, end: a, cx: M, cy: w }, c.push(["M", M + s * E, w + f * b], t), B(x) && ((t = ["A", x, x, 0, o, B(u.clockwise) ? 1 - u.clockwise : 0, M + x * E, w + x * b]).params = { start: a, end: v, cx: M, cy: w }, c.push(S ? ["M", M + x * p, w + x * C] : ["L", M + x * p, w + x * C], t)), S || c.push(["Z"]);
          }
          return c;
        }
        function O(M, w, A, l, u) {
          return u && u.r ? L(M, w, A, l, u) : [["M", M, w], ["L", M + A, w], ["L", M + A, w + l], ["L", M, w + l], ["Z"]];
        }
        function L(M, w, A, l, u) {
          let c = (u == null ? void 0 : u.r) || 0;
          return [["M", M + c, w], ["L", M + A - c, w], ["A", c, c, 0, 0, 1, M + A, w + c], ["L", M + A, w + l - c], ["A", c, c, 0, 0, 1, M + A - c, w + l], ["L", M + c, w + l], ["A", c, c, 0, 0, 1, M, w + l - c], ["L", M, w + c], ["A", c, c, 0, 0, 1, M + c, w], ["Z"]];
        }
        return { arc: z, callout: function(M, w, A, l, u) {
          let c = Math.min(u && u.r || 0, A, l), v = c + 6, s = u && u.anchorX, f = u && u.anchorY || 0, y = L(M, w, A, l, { r: c });
          if (!I(s) || s < A && s > 0 && f < l && f > 0) return y;
          if (M + s > A - v)
            if (f > w + v && f < w + l - v) y.splice(3, 1, ["L", M + A, f - 6], ["L", M + A + 6, f], ["L", M + A, f + 6], ["L", M + A, w + l - c]);
            else if (s < A) {
              let h = f < w + v, a = h ? w : w + l;
              y.splice(h ? 2 : 5, 0, ["L", s, f], ["L", M + A - c, a]);
            } else y.splice(3, 1, ["L", M + A, l / 2], ["L", s, f], ["L", M + A, l / 2], ["L", M + A, w + l - c]);
          else if (M + s < v)
            if (f > w + v && f < w + l - v) y.splice(7, 1, ["L", M, f + 6], ["L", M - 6, f], ["L", M, f - 6], ["L", M, w + c]);
            else if (s > 0) {
              let h = f < w + v, a = h ? w : w + l;
              y.splice(h ? 1 : 6, 0, ["L", s, f], ["L", M + c, a]);
            } else y.splice(7, 1, ["L", M, l / 2], ["L", s, f], ["L", M, l / 2], ["L", M, w + c]);
          else f > l && s < A - v ? y.splice(5, 1, ["L", s + 6, w + l], ["L", s, w + l + 6], ["L", s - 6, w + l], ["L", M + c, w + l]) : f < 0 && s > v && y.splice(1, 1, ["L", s - 6, w], ["L", s, w - 6], ["L", s + 6, w], ["L", A - c, w]);
          return y;
        }, circle: function(M, w, A, l) {
          return z(M + A / 2, w + l / 2, A / 2, l / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
        }, diamond: function(M, w, A, l) {
          return [["M", M + A / 2, w], ["L", M + A, w + l / 2], ["L", M + A / 2, w + l], ["L", M, w + l / 2], ["Z"]];
        }, rect: O, roundedRect: L, square: O, triangle: function(M, w, A, l) {
          return [["M", M + A / 2, w], ["L", M + A, w + l], ["L", M, w + l], ["Z"]];
        }, "triangle-down": function(M, w, A, l) {
          return [["M", M, w], ["L", M + A, w], ["L", M + A / 2, w + l], ["Z"]];
        } };
      }), Z(r, "Core/Renderer/SVG/TextBuilder.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { doc: R, SVG_NS: z, win: O } = B, { attr: L, extend: M, fireEvent: w, isString: A, objectEach: l, pick: u } = I;
        return class {
          constructor(c) {
            let v = c.styles;
            this.renderer = c.renderer, this.svgElement = c, this.width = c.textWidth, this.textLineHeight = v && v.lineHeight, this.textOutline = v && v.textOutline, this.ellipsis = !!(v && v.textOverflow === "ellipsis"), this.noWrap = !!(v && v.whiteSpace === "nowrap");
          }
          buildSVG() {
            let c = this.svgElement, v = c.element, s = c.renderer, f = u(c.textStr, "").toString(), y = f.indexOf("<") !== -1, h = v.childNodes, a = !c.added && s.box, x = [f, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, c.getStyle("font-size"), this.width].join(",");
            if (x !== c.textCache) {
              c.textCache = x, delete c.actualWidth;
              for (let S = h.length; S--; ) v.removeChild(h[S]);
              if (y || this.ellipsis || this.width || c.textPath || f.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(f))) {
                if (f !== "") {
                  a && a.appendChild(v);
                  let S = new T(f);
                  this.modifyTree(S.nodes), S.addToDOM(v), this.modifyDOM(), this.ellipsis && (v.textContent || "").indexOf("…") !== -1 && c.attr("title", this.unescapeEntities(c.textStr || "", ["&lt;", "&gt;"])), a && a.removeChild(v);
                }
              } else v.appendChild(R.createTextNode(this.unescapeEntities(f)));
              A(this.textOutline) && c.applyTextOutline && c.applyTextOutline(this.textOutline);
            }
          }
          modifyDOM() {
            let c, v = this.svgElement, s = L(v.element, "x");
            for (v.firstLineMetrics = void 0; (c = v.element.firstChild) && /^[\s\u200B]*$/.test(c.textContent || " "); ) v.element.removeChild(c);
            [].forEach.call(v.element.querySelectorAll("tspan.highcharts-br"), (a, x) => {
              a.nextSibling && a.previousSibling && (x === 0 && a.previousSibling.nodeType === 1 && (v.firstLineMetrics = v.renderer.fontMetrics(a.previousSibling)), L(a, { dy: this.getLineHeight(a.nextSibling), x: s }));
            });
            let f = this.width || 0;
            if (!f) return;
            let y = (a, x) => {
              let S = a.textContent || "", E = S.replace(/([^\^])-/g, "$1- ").split(" "), b = !this.noWrap && (E.length > 1 || v.element.childNodes.length > 1), p = this.getLineHeight(x), C = 0, o = v.actualWidth;
              if (this.ellipsis) S && this.truncate(a, S, void 0, 0, Math.max(0, f - 0.8 * p), (t, e) => t.substring(0, e) + "…");
              else if (b) {
                let t = [], e = [];
                for (; x.firstChild && x.firstChild !== a; ) e.push(x.firstChild), x.removeChild(x.firstChild);
                for (; E.length; ) E.length && !this.noWrap && C > 0 && (t.push(a.textContent || ""), a.textContent = E.join(" ").replace(/- /g, "-")), this.truncate(a, void 0, E, C === 0 && o || 0, f, (n, d) => E.slice(0, d).join(" ").replace(/- /g, "-")), o = v.actualWidth, C++;
                e.forEach((n) => {
                  x.insertBefore(n, a);
                }), t.forEach((n) => {
                  x.insertBefore(R.createTextNode(n), a);
                  let d = R.createElementNS(z, "tspan");
                  d.textContent = "​", L(d, { dy: p, x: s }), x.insertBefore(d, a);
                });
              }
            }, h = (a) => {
              [].slice.call(a.childNodes).forEach((x) => {
                x.nodeType === O.Node.TEXT_NODE ? y(x, a) : (x.className.baseVal.indexOf("highcharts-br") !== -1 && (v.actualWidth = 0), h(x));
              });
            };
            h(v.element);
          }
          getLineHeight(c) {
            let v = c.nodeType === O.Node.TEXT_NODE ? c.parentElement : c;
            return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(v || this.svgElement.element).h;
          }
          modifyTree(c) {
            let v = (s, f) => {
              let { attributes: y = {}, children: h, style: a = {}, tagName: x } = s, S = this.renderer.styledMode;
              if (x === "b" || x === "strong" ? S ? y.class = "highcharts-strong" : a.fontWeight = "bold" : (x === "i" || x === "em") && (S ? y.class = "highcharts-emphasized" : a.fontStyle = "italic"), a && a.color && (a.fill = a.color), x === "br") {
                y.class = "highcharts-br", s.textContent = "​";
                let E = c[f + 1];
                E && E.textContent && (E.textContent = E.textContent.replace(/^ +/gm, ""));
              } else x === "a" && h && h.some((E) => E.tagName === "#text") && (s.children = [{ children: h, tagName: "tspan" }]);
              x !== "#text" && x !== "a" && (s.tagName = "tspan"), M(s, { attributes: y, style: a }), h && h.filter((E) => E.tagName !== "#text").forEach(v);
            };
            c.forEach(v), w(this.svgElement, "afterModifyTree", { nodes: c });
          }
          truncate(c, v, s, f, y, h) {
            let a, x, S = this.svgElement, { rotation: E } = S, b = [], p = s ? 1 : 0, C = (v || s || "").length, o = C, t = function(e, n) {
              let d = n || e, i = c.parentNode;
              if (i && b[d] === void 0 && i.getSubStringLength) try {
                b[d] = f + i.getSubStringLength(0, s ? d + 1 : d);
              } catch {
              }
              return b[d];
            };
            if (S.rotation = 0, f + (x = t(c.textContent.length)) > y) {
              for (; p <= C; ) o = Math.ceil((p + C) / 2), s && (a = h(s, o)), x = t(o, a && a.length - 1), p === C ? p = C + 1 : x > y ? C = o - 1 : p = o;
              C === 0 ? c.textContent = "" : v && C === v.length - 1 || (c.textContent = a || h(v || s, o));
            }
            s && s.splice(0, o), S.actualWidth = x, S.rotation = E;
          }
          unescapeEntities(c, v) {
            return l(this.renderer.escapes, function(s, f) {
              v && v.indexOf(s) !== -1 || (c = c.toString().replace(RegExp(s, "g"), f));
            }), c;
          }
        };
      }), Z(r, "Core/Renderer/SVG/SVGRenderer.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Defaults.js"], r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Renderer/RendererRegistry.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Renderer/SVG/SVGLabel.js"], r["Core/Renderer/SVG/Symbols.js"], r["Core/Renderer/SVG/TextBuilder.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A) {
        let l, { defaultOptions: u } = B, { charts: c, deg2rad: v, doc: s, isFirefox: f, isMS: y, isWebKit: h, noop: a, SVG_NS: x, symbolSizes: S, win: E } = R, { addEvent: b, attr: p, createElement: C, crisp: o, css: t, defined: e, destroyObjectProperties: n, extend: d, isArray: i, isNumber: g, isObject: m, isString: k, merge: j, pick: P, pInt: D, replaceNested: H, uniqueKey: G } = A;
        class V {
          constructor(U, Y, q, N, X, W, _) {
            let K, J, $ = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), et = $.element;
            _ || $.css(this.getStyle(N || {})), U.appendChild(et), p(U, "dir", "ltr"), U.innerHTML.indexOf("xmlns") === -1 && p(et, "xmlns", this.SVG_NS), this.box = et, this.boxWrapper = $, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(s.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = W, this.forExport = X, this.styledMode = _, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = $.getStyle("font-size"), this.setSize(Y, q, !1), f && U.getBoundingClientRect && ((K = function() {
              t(U, { left: 0, top: 0 }), J = U.getBoundingClientRect(), t(U, { left: Math.ceil(J.left) - J.left + "px", top: Math.ceil(J.top) - J.top + "px" });
            })(), this.unSubPixelFix = b(E, "resize", K));
          }
          definition(U) {
            return new T([U]).addToDOM(this.defs.element);
          }
          getReferenceURL() {
            if ((f || h) && s.getElementsByTagName("base").length) {
              if (!e(l)) {
                let U = G(), Y = new T([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: U }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${U})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(s.body);
                t(Y, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
                let q = s.elementFromPoint(6, 6);
                l = (q && q.id) === "hitme", s.body.removeChild(Y);
              }
              if (l) return H(E.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
            }
            return "";
          }
          getStyle(U) {
            return this.style = d({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, U), this.style;
          }
          setStyle(U) {
            this.boxWrapper.css(this.getStyle(U));
          }
          isHidden() {
            return !this.boxWrapper.getBBox().width;
          }
          destroy() {
            let U = this.defs;
            return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), n(this.gradients || {}), this.gradients = null, this.defs = U.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
          }
          createElement(U) {
            return new this.Element(this, U);
          }
          getRadialAttr(U, Y) {
            return { cx: U[0] - U[2] / 2 + (Y.cx || 0) * U[2], cy: U[1] - U[2] / 2 + (Y.cy || 0) * U[2], r: (Y.r || 0) * U[2] };
          }
          shadowDefinition(U) {
            let Y = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(U).map((N) => `${N}-${U[N]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), q = j({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, U);
            return this.defs.element.querySelector(`#${Y}`) || this.definition({ tagName: "filter", attributes: { id: Y, filterUnits: q.filterUnits }, children: this.getShadowFilterContent(q) }), Y;
          }
          getShadowFilterContent(U) {
            return [{ tagName: "feDropShadow", attributes: { dx: U.offsetX, dy: U.offsetY, "flood-color": U.color, "flood-opacity": Math.min(5 * U.opacity, 1), stdDeviation: U.width / 2 } }];
          }
          buildText(U) {
            new w(U).buildSVG();
          }
          getContrast(U) {
            let Y = I.parse(U).rgba.map((N) => {
              let X = N / 255;
              return X <= 0.03928 ? X / 12.92 : Math.pow((X + 0.055) / 1.055, 2.4);
            }), q = 0.2126 * Y[0] + 0.7152 * Y[1] + 0.0722 * Y[2];
            return 1.05 / (q + 0.05) > (q + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
          }
          button(U, Y, q, N, X = {}, W, _, K, J, $) {
            let et = this.label(U, Y, q, J, void 0, void 0, $, void 0, "button"), st = this.styledMode, at = arguments, lt = 0;
            X = j(u.global.buttonTheme, X), st && (delete X.fill, delete X.stroke, delete X["stroke-width"]);
            let it = X.states || {}, Q = X.style || {};
            delete X.states, delete X.style;
            let ot = [T.filterUserAttributes(X)], nt = [Q];
            return st || ["hover", "select", "disabled"].forEach((ht, ct) => {
              ot.push(j(ot[0], T.filterUserAttributes(at[ct + 5] || it[ht] || {}))), nt.push(ot[ct + 1].style), delete ot[ct + 1].style;
            }), b(et.element, y ? "mouseover" : "mouseenter", function() {
              lt !== 3 && et.setState(1);
            }), b(et.element, y ? "mouseout" : "mouseleave", function() {
              lt !== 3 && et.setState(lt);
            }), et.setState = (ht = 0) => {
              if (ht !== 1 && (et.state = lt = ht), et.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ht]), !st) {
                et.attr(ot[ht]);
                let ct = nt[ht];
                m(ct) && et.css(ct);
              }
            }, et.attr(ot[0]), !st && (et.css(d({ cursor: "default" }, Q)), $ && et.text.css({ pointerEvents: "none" })), et.on("touchstart", (ht) => ht.stopPropagation()).on("click", function(ht) {
              lt !== 3 && N.call(et, ht);
            });
          }
          crispLine(U, Y) {
            let [q, N] = U;
            return e(q[1]) && q[1] === N[1] && (q[1] = N[1] = o(q[1], Y)), e(q[2]) && q[2] === N[2] && (q[2] = N[2] = o(q[2], Y)), U;
          }
          path(U) {
            let Y = this.styledMode ? {} : { fill: "none" };
            return i(U) ? Y.d = U : m(U) && d(Y, U), this.createElement("path").attr(Y);
          }
          circle(U, Y, q) {
            let N = m(U) ? U : U === void 0 ? {} : { x: U, y: Y, r: q }, X = this.createElement("circle");
            return X.xSetter = X.ySetter = function(W, _, K) {
              K.setAttribute("c" + _, W);
            }, X.attr(N);
          }
          arc(U, Y, q, N, X, W) {
            let _;
            m(U) ? (Y = (_ = U).y, q = _.r, N = _.innerR, X = _.start, W = _.end, U = _.x) : _ = { innerR: N, start: X, end: W };
            let K = this.symbol("arc", U, Y, q, q, _);
            return K.r = q, K;
          }
          rect(U, Y, q, N, X, W) {
            let _ = m(U) ? U : U === void 0 ? {} : { x: U, y: Y, r: X, width: Math.max(q || 0, 0), height: Math.max(N || 0, 0) }, K = this.createElement("rect");
            return this.styledMode || (W !== void 0 && (_["stroke-width"] = W, d(_, K.crisp(_))), _.fill = "none"), K.rSetter = function(J, $, et) {
              K.r = J, p(et, { rx: J, ry: J });
            }, K.rGetter = function() {
              return K.r || 0;
            }, K.attr(_);
          }
          roundedRect(U) {
            return this.symbol("roundedRect").attr(U);
          }
          setSize(U, Y, q) {
            this.width = U, this.height = Y, this.boxWrapper.animate({ width: U, height: Y }, { step: function() {
              this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
            }, duration: P(q, !0) ? void 0 : 0 }), this.alignElements();
          }
          g(U) {
            let Y = this.createElement("g");
            return U ? Y.attr({ class: "highcharts-" + U }) : Y;
          }
          image(U, Y, q, N, X, W) {
            let _ = { preserveAspectRatio: "none" };
            g(Y) && (_.x = Y), g(q) && (_.y = q), g(N) && (_.width = N), g(X) && (_.height = X);
            let K = this.createElement("image").attr(_), J = function($) {
              K.attr({ href: U }), W.call(K, $);
            };
            if (W) {
              K.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
              let $ = new E.Image();
              b($, "load", J), $.src = U, $.complete && J({});
            } else K.attr({ href: U });
            return K;
          }
          symbol(U, Y, q, N, X, W) {
            let _, K, J, $, et = this, st = /^url\((.*?)\)$/, at = st.test(U), lt = !at && (this.symbols[U] ? U : "circle"), it = lt && this.symbols[lt];
            if (it) typeof Y == "number" && (K = it.call(this.symbols, Y || 0, q || 0, N || 0, X || 0, W)), _ = this.path(K), et.styledMode || _.attr("fill", "none"), d(_, { symbolName: lt || void 0, x: Y, y: q, width: N, height: X }), W && d(_, W);
            else if (at) {
              J = U.match(st)[1];
              let Q = _ = this.image(J);
              Q.imgwidth = P(W && W.width, S[J] && S[J].width), Q.imgheight = P(W && W.height, S[J] && S[J].height), $ = (ot) => ot.attr({ width: ot.width, height: ot.height }), ["width", "height"].forEach((ot) => {
                Q[`${ot}Setter`] = function(nt, ht) {
                  this[ht] = nt;
                  let { alignByTranslate: ct, element: dt, width: ut, height: pt, imgwidth: gt, imgheight: ft } = this, mt = ht === "width" ? gt : ft, yt = 1;
                  W && W.backgroundSize === "within" && ut && pt && gt && ft ? (yt = Math.min(ut / gt, pt / ft), p(dt, { width: Math.round(gt * yt), height: Math.round(ft * yt) })) : dt && mt && dt.setAttribute(ht, mt), !ct && gt && ft && this.translate(((ut || 0) - gt * yt) / 2, ((pt || 0) - ft * yt) / 2);
                };
              }), e(Y) && Q.attr({ x: Y, y: q }), Q.isImg = !0, Q.symbolUrl = U, e(Q.imgwidth) && e(Q.imgheight) ? $(Q) : (Q.attr({ width: 0, height: 0 }), C("img", { onload: function() {
                let ot = c[et.chartIndex];
                this.width === 0 && (t(this, { position: "absolute", top: "-999em" }), s.body.appendChild(this)), S[J] = { width: this.width, height: this.height }, Q.imgwidth = this.width, Q.imgheight = this.height, Q.element && $(Q), this.parentNode && this.parentNode.removeChild(this), et.imgCount--, et.imgCount || !ot || ot.hasLoaded || ot.onload();
              }, src: J }), this.imgCount++);
            }
            return _;
          }
          clipRect(U, Y, q, N) {
            return this.rect(U, Y, q, N, 0);
          }
          text(U, Y, q, N) {
            let X = {};
            if (N && (this.allowHTML || !this.forExport)) return this.html(U, Y, q);
            X.x = Math.round(Y || 0), q && (X.y = Math.round(q)), e(U) && (X.text = U);
            let W = this.createElement("text").attr(X);
            return N && (!this.forExport || this.allowHTML) || (W.xSetter = function(_, K, J) {
              let $ = J.getElementsByTagName("tspan"), et = J.getAttribute(K);
              for (let st = 0, at; st < $.length; st++) (at = $[st]).getAttribute(K) === et && at.setAttribute(K, _);
              J.setAttribute(K, _);
            }), W;
          }
          fontMetrics(U) {
            let Y = D(O.prototype.getStyle.call(U, "font-size") || 0), q = Y < 24 ? Y + 3 : Math.round(1.2 * Y), N = Math.round(0.8 * q);
            return { h: q, b: N, f: Y };
          }
          rotCorr(U, Y, q) {
            let N = U;
            return Y && q && (N = Math.max(N * Math.cos(Y * v), 4)), { x: -U / 3 * Math.sin(Y * v), y: N };
          }
          pathToSegments(U) {
            let Y = [], q = [], N = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
            for (let X = 0; X < U.length; X++) k(q[0]) && g(U[X]) && q.length === N[q[0].toUpperCase()] && U.splice(X, 0, q[0].replace("M", "L").replace("m", "l")), typeof U[X] == "string" && (q.length && Y.push(q.slice(0)), q.length = 0), q.push(U[X]);
            return Y.push(q.slice(0)), Y;
          }
          label(U, Y, q, N, X, W, _, K, J) {
            return new L(this, U, Y, q, N, X, W, _, K, J);
          }
          alignElements() {
            this.alignedObjects.forEach((U) => U.align());
          }
        }
        return d(V.prototype, { Element: O, SVG_NS: x, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: M, draw: a }), z.registerRendererType("svg", V, !0), V;
      }), Z(r, "Core/Renderer/HTML/HTMLElement.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Globals.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { composed: z } = B, { attr: O, css: L, createElement: M, defined: w, extend: A, pInt: l, pushUnique: u } = R;
        function c(y, h, a) {
          var S;
          let x = ((S = this.div) == null ? void 0 : S.style) || a.style;
          I.prototype[`${h}Setter`].call(this, y, h, a), x && (x[h] = y);
        }
        let v = (y, h) => {
          var a;
          if (!y.div) {
            let x = O(y.element, "class"), S = y.css, E = M("div", x ? { className: x } : void 0, { position: "absolute", left: `${y.translateX || 0}px`, top: `${y.translateY || 0}px`, ...y.styles, display: y.display, opacity: y.opacity, visibility: y.visibility }, ((a = y.parentGroup) == null ? void 0 : a.div) || h);
            y.classSetter = (b, p, C) => {
              C.setAttribute("class", b), E.className = b;
            }, y.translateXSetter = y.translateYSetter = (b, p) => {
              y[p] = b, E.style[p === "translateX" ? "left" : "top"] = `${b}px`, y.doTransform = !0;
            }, y.opacitySetter = y.visibilitySetter = c, y.css = (b) => (S.call(y, b), b.cursor && (E.style.cursor = b.cursor), b.pointerEvents && (E.style.pointerEvents = b.pointerEvents), y), y.on = function() {
              return I.prototype.on.apply({ element: E, onEvents: y.onEvents }, arguments), y;
            }, y.div = E;
          }
          return y.div;
        };
        class s extends I {
          static compose(h) {
            u(z, this.compose) && (h.prototype.html = function(a, x, S) {
              return new s(this, "span").attr({ text: a, x: Math.round(x), y: Math.round(S) });
            });
          }
          constructor(h, a) {
            super(h, a), this.css({ position: "absolute", ...h.styledMode ? {} : { fontFamily: h.style.fontFamily, fontSize: h.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
          }
          getSpanCorrection(h, a, x) {
            this.xCorr = -h * x, this.yCorr = -a;
          }
          css(h) {
            let a, { element: x } = this, S = x.tagName === "SPAN" && h && "width" in h, E = S && h.width;
            return S && (delete h.width, this.textWidth = l(E) || void 0, a = !0), (h == null ? void 0 : h.textOverflow) === "ellipsis" && (h.whiteSpace = "nowrap", h.overflow = "hidden"), A(this.styles, h), L(x, h), a && this.updateTransform(), this;
          }
          htmlGetBBox() {
            let { element: h } = this;
            return { x: h.offsetLeft, y: h.offsetTop, width: h.offsetWidth, height: h.offsetHeight };
          }
          updateTransform() {
            var g;
            if (!this.added) {
              this.alignOnAdd = !0;
              return;
            }
            let { element: h, renderer: a, rotation: x, rotationOriginX: S, rotationOriginY: E, styles: b, textAlign: p = "left", textWidth: C, translateX: o = 0, translateY: t = 0, x: e = 0, y: n = 0 } = this, d = { left: 0, center: 0.5, right: 1 }[p], i = b.whiteSpace;
            if (L(h, { marginLeft: `${o}px`, marginTop: `${t}px` }), h.tagName === "SPAN") {
              let m = [x, p, h.innerHTML, C, this.textAlign].join(","), k = -(((g = this.parentGroup) == null ? void 0 : g.padding) * 1) || 0, j, P = !1;
              if (C !== this.oldTextWidth) {
                let F = this.textPxLength ? this.textPxLength : (L(h, { width: "", whiteSpace: i || "nowrap" }), h.offsetWidth), U = C || 0;
                (U > this.oldTextWidth || F > U) && (/[ \-]/.test(h.textContent || h.innerText) || h.style.textOverflow === "ellipsis") && (L(h, { width: F > U || x ? C + "px" : "auto", display: "block", whiteSpace: i || "normal" }), this.oldTextWidth = C, P = !0);
              }
              this.hasBoxWidthChanged = P, m !== this.cTT && (j = a.fontMetrics(h).b, w(x) && (x !== (this.oldRotation || 0) || p !== this.oldAlign) && this.setSpanRotation(x, k, k), this.getSpanCorrection(!w(x) && this.textPxLength || h.offsetWidth, j, d));
              let { xCorr: D = 0, yCorr: H = 0 } = this, G = (S ?? e) - D - e - k, V = (E ?? n) - H - n - k;
              L(h, { left: `${e + D}px`, top: `${n + H}px`, transformOrigin: `${G}px ${V}px` }), this.cTT = m, this.oldRotation = x, this.oldAlign = p;
            }
          }
          setSpanRotation(h, a, x) {
            L(this.element, { transform: `rotate(${h}deg)`, transformOrigin: `${a}% ${x}px` });
          }
          add(h) {
            let a, x = this.renderer.box.parentNode, S = [];
            if (this.parentGroup = h, h && !(a = h.div)) {
              let E = h;
              for (; E; ) S.push(E), E = E.parentGroup;
              for (let b of S.reverse()) a = v(b, x);
            }
            return (a || x).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
          }
          textSetter(h) {
            h !== this.textStr && (delete this.bBox, delete this.oldTextWidth, T.setElementHTML(this.element, h ?? ""), this.textStr = h, this.doTransform = !0);
          }
          alignSetter(h) {
            this.alignValue = this.textAlign = h, this.doTransform = !0;
          }
          xSetter(h, a) {
            this[a] = h, this.doTransform = !0;
          }
        }
        let f = s.prototype;
        return f.visibilitySetter = f.opacitySetter = c, f.ySetter = f.rotationSetter = f.rotationOriginXSetter = f.rotationOriginYSetter = f.xSetter, s;
      }), Z(r, "Core/Axis/AxisDefaults.js", [], function() {
        var T, B;
        return (B = T || (T = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, B.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
          let { numberFormatter: I } = this.axis.chart;
          return I(this.total || 0, -1);
        }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, T;
      }), Z(r, "Core/Foundation.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, isFunction: R, objectEach: z, removeEvent: O } = T;
        return (B || (B = {})).registerEventOptions = function(L, M) {
          L.eventOptions = L.eventOptions || {}, z(M.events, function(w, A) {
            L.eventOptions[A] !== w && (L.eventOptions[A] && (O(L, A, L.eventOptions[A]), delete L.eventOptions[A]), R(w) && (L.eventOptions[A] = w, I(L, A, w, { order: 0 })));
          });
        }, B;
      }), Z(r, "Core/Axis/Tick.js", [r["Core/Templating.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { deg2rad: R } = B, { clamp: z, correctFloat: O, defined: L, destroyObjectProperties: M, extend: w, fireEvent: A, isNumber: l, merge: u, objectEach: c, pick: v } = I;
        return class {
          constructor(s, f, y, h, a) {
            this.isNew = !0, this.isNewLabel = !0, this.axis = s, this.pos = f, this.type = y || "", this.parameters = a || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, A(this, "init"), y || h || this.addLabel();
          }
          addLabel() {
            let s = this, f = s.axis, y = f.options, h = f.chart, a = f.categories, x = f.logarithmic, S = f.names, E = s.pos, b = v(s.options && s.options.labels, y.labels), p = f.tickPositions, C = E === p[0], o = E === p[p.length - 1], t = (!b.step || b.step === 1) && f.tickInterval === 1, e = p.info, n = s.label, d, i, g, m = this.parameters.category || (a ? v(a[E], S[E], E) : E);
            x && l(m) && (m = O(x.lin2log(m))), f.dateTime && (e ? d = (i = h.time.resolveDTLFormat(y.dateTimeLabelFormats[!y.grid && e.higherRanks[E] || e.unitName])).main : l(m) && (d = f.dateTime.getXDateFormat(m, y.dateTimeLabelFormats || {}))), s.isFirst = C, s.isLast = o;
            let k = { axis: f, chart: h, dateTimeLabelFormat: d, isFirst: C, isLast: o, pos: E, tick: s, tickPositionInfo: e, value: m };
            A(this, "labelFormat", k);
            let j = (H) => b.formatter ? b.formatter.call(H, H) : b.format ? (H.text = f.defaultLabelFormatter.call(H), T.format(b.format, H, h)) : f.defaultLabelFormatter.call(H), P = j.call(k, k), D = i && i.list;
            D ? s.shortenLabel = function() {
              for (g = 0; g < D.length; g++) if (w(k, { dateTimeLabelFormat: D[g] }), n.attr({ text: j.call(k, k) }), n.getBBox().width < f.getSlotWidth(s) - 2 * (b.padding || 0)) return;
              n.attr({ text: "" });
            } : s.shortenLabel = void 0, t && f._addedPlotLB && s.moveLabel(P, b), L(n) || s.movedLabel ? n && n.textStr !== P && !t && (!n.textWidth || b.style.width || n.styles.width || n.css({ width: null }), n.attr({ text: P }), n.textPxLength = n.getBBox().width) : (s.label = n = s.createLabel(P, b), s.rotation = 0);
          }
          createLabel(s, f, y) {
            let h = this.axis, a = h.chart, x = L(s) && f.enabled ? a.renderer.text(s, y == null ? void 0 : y.x, y == null ? void 0 : y.y, f.useHTML).add(h.labelGroup) : void 0;
            return x && (a.styledMode || x.css(u(f.style)), x.textPxLength = x.getBBox().width), x;
          }
          destroy() {
            M(this, this.axis);
          }
          getPosition(s, f, y, h) {
            let a = this.axis, x = a.chart, S = h && x.oldChartHeight || x.chartHeight, E = { x: s ? O(a.translate(f + y, void 0, void 0, h) + a.transB) : a.left + a.offset + (a.opposite ? (h && x.oldChartWidth || x.chartWidth) - a.right - a.left : 0), y: s ? S - a.bottom + a.offset - (a.opposite ? a.height : 0) : O(S - a.translate(f + y, void 0, void 0, h) - a.transB) };
            return E.y = z(E.y, -1e9, 1e9), A(this, "afterGetPosition", { pos: E }), E;
          }
          getLabelPosition(s, f, y, h, a, x, S, E) {
            let b, p, C = this.axis, o = C.transA, t = C.isLinked && C.linkedParent ? C.linkedParent.reversed : C.reversed, e = C.staggerLines, n = C.tickRotCorr || { x: 0, y: 0 }, d = h || C.reserveSpaceDefault ? 0 : -C.labelOffset * (C.labelAlign === "center" ? 0.5 : 1), i = a.distance, g = {};
            return b = C.side === 0 ? y.rotation ? -i : -y.getBBox().height : C.side === 2 ? n.y + i : Math.cos(y.rotation * R) * (n.y - y.getBBox(!1, 0).height / 2), L(a.y) && (b = C.side === 0 && C.horiz ? a.y + b : a.y), s = s + v(a.x, [0, 1, 0, -1][C.side] * i) + d + n.x - (x && h ? x * o * (t ? -1 : 1) : 0), f = f + b - (x && !h ? x * o * (t ? 1 : -1) : 0), e && (p = S / (E || 1) % e, C.opposite && (p = e - p - 1), f += p * (C.labelOffset / e)), g.x = s, g.y = Math.round(f), A(this, "afterGetLabelPosition", { pos: g, tickmarkOffset: x, index: S }), g;
          }
          getLabelSize() {
            return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
          }
          getMarkPath(s, f, y, h, a = !1, x) {
            return x.crispLine([["M", s, f], ["L", s + (a ? 0 : -y), f + (a ? y : 0)]], h);
          }
          handleOverflow(s) {
            let f = this.axis, y = f.options.labels, h = s.x, a = f.chart.chartWidth, x = f.chart.spacing, S = v(f.labelLeft, Math.min(f.pos, x[3])), E = v(f.labelRight, Math.max(f.isRadial ? 0 : f.pos + f.len, a - x[1])), b = this.label, p = this.rotation, C = { left: 0, center: 0.5, right: 1 }[f.labelAlign || b.attr("align")], o = b.getBBox().width, t = f.getSlotWidth(this), e = {}, n = t, d = 1, i, g, m;
            p || y.overflow !== "justify" ? p < 0 && h - C * o < S ? m = Math.round(h / Math.cos(p * R) - S) : p > 0 && h + C * o > E && (m = Math.round((a - h) / Math.cos(p * R))) : (i = h - C * o, g = h + (1 - C) * o, i < S ? n = s.x + n * (1 - C) - S : g > E && (n = E - s.x + n * C, d = -1), (n = Math.min(t, n)) < t && f.labelAlign === "center" && (s.x += d * (t - n - C * (t - Math.min(o, n)))), (o > n || f.autoRotation && (b.styles || {}).width) && (m = n)), m && (this.shortenLabel ? this.shortenLabel() : (e.width = Math.floor(m) + "px", (y.style || {}).textOverflow || (e.textOverflow = "ellipsis"), b.css(e)));
          }
          moveLabel(s, f) {
            let y = this, h = y.label, a = y.axis, x = !1, S;
            h && h.textStr === s ? (y.movedLabel = h, x = !0, delete y.label) : c(a.ticks, function(E) {
              x || E.isNew || E === y || !E.label || E.label.textStr !== s || (y.movedLabel = E.label, x = !0, E.labelPos = y.movedLabel.xy, delete E.label);
            }), !x && (y.labelPos || h) && (S = y.labelPos || h.xy, y.movedLabel = y.createLabel(s, f, S), y.movedLabel && y.movedLabel.attr({ opacity: 0 }));
          }
          render(s, f, y) {
            let h = this.axis, a = h.horiz, x = this.pos, S = v(this.tickmarkOffset, h.tickmarkOffset), E = this.getPosition(a, x, S, f), b = E.x, p = E.y, C = h.pos, o = C + h.len, t = a ? b : p;
            !h.chart.polar && this.isNew && (O(t) < C || t > o) && (y = 0);
            let e = v(y, this.label && this.label.newOpacity, 1);
            y = v(y, 1), this.isActive = !0, this.renderGridLine(f, y), this.renderMark(E, y), this.renderLabel(E, f, e, s), this.isNew = !1, A(this, "afterRender");
          }
          renderGridLine(s, f) {
            let y = this.axis, h = y.options, a = {}, x = this.pos, S = this.type, E = v(this.tickmarkOffset, y.tickmarkOffset), b = y.chart.renderer, p = this.gridLine, C, o = h.gridLineWidth, t = h.gridLineColor, e = h.gridLineDashStyle;
            this.type === "minor" && (o = h.minorGridLineWidth, t = h.minorGridLineColor, e = h.minorGridLineDashStyle), p || (y.chart.styledMode || (a.stroke = t, a["stroke-width"] = o || 0, a.dashstyle = e), S || (a.zIndex = 1), s && (f = 0), this.gridLine = p = b.path().attr(a).addClass("highcharts-" + (S ? S + "-" : "") + "grid-line").add(y.gridGroup)), p && (C = y.getPlotLinePath({ value: x + E, lineWidth: p.strokeWidth(), force: "pass", old: s, acrossPanes: !1 })) && p[s || this.isNew ? "attr" : "animate"]({ d: C, opacity: f });
          }
          renderMark(s, f) {
            let y = this.axis, h = y.options, a = y.chart.renderer, x = this.type, S = y.tickSize(x ? x + "Tick" : "tick"), E = s.x, b = s.y, p = v(h[x !== "minor" ? "tickWidth" : "minorTickWidth"], !x && y.isXAxis ? 1 : 0), C = h[x !== "minor" ? "tickColor" : "minorTickColor"], o = this.mark, t = !o;
            S && (y.opposite && (S[0] = -S[0]), o || (this.mark = o = a.path().addClass("highcharts-" + (x ? x + "-" : "") + "tick").add(y.axisGroup), y.chart.styledMode || o.attr({ stroke: C, "stroke-width": p })), o[t ? "attr" : "animate"]({ d: this.getMarkPath(E, b, S[0], o.strokeWidth(), y.horiz, a), opacity: f }));
          }
          renderLabel(s, f, y, h) {
            let a = this.axis, x = a.horiz, S = a.options, E = this.label, b = S.labels, p = b.step, C = v(this.tickmarkOffset, a.tickmarkOffset), o = s.x, t = s.y, e = !0;
            E && l(o) && (E.xy = s = this.getLabelPosition(o, t, E, x, b, C, h, p), (!this.isFirst || this.isLast || S.showFirstLabel) && (!this.isLast || this.isFirst || S.showLastLabel) ? !x || b.step || b.rotation || f || y === 0 || this.handleOverflow(s) : e = !1, p && h % p && (e = !1), e && l(s.y) ? (s.opacity = y, E[this.isNewLabel ? "attr" : "animate"](s).show(!0), this.isNewLabel = !1) : (E.hide(), this.isNewLabel = !0));
          }
          replaceMovedLabel() {
            let s = this.label, f = this.axis;
            s && !this.isNew && (s.animate({ opacity: 0 }, void 0, s.destroy), delete this.label), f.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
          }
        };
      }), Z(r, "Core/Axis/Axis.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Axis/AxisDefaults.js"], r["Core/Color/Color.js"], r["Core/Defaults.js"], r["Core/Foundation.js"], r["Core/Globals.js"], r["Core/Axis/Tick.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { animObject: w } = T, { xAxis: A, yAxis: l } = B, { defaultOptions: u } = R, { registerEventOptions: c } = z, { deg2rad: v } = O, { arrayMax: s, arrayMin: f, clamp: y, correctFloat: h, defined: a, destroyObjectProperties: x, erase: S, error: E, extend: b, fireEvent: p, getClosestDistance: C, insertItem: o, isArray: t, isNumber: e, isString: n, merge: d, normalizeTickInterval: i, objectEach: g, pick: m, relativeLength: k, removeEvent: j, splat: P, syncTimeout: D } = M, H = (V, F) => i(F, void 0, void 0, m(V.options.allowDecimals, F < 0.5 || V.tickAmount !== void 0), !!V.tickAmount);
        b(u, { xAxis: A, yAxis: d(A, l) });
        class G {
          constructor(F, U, Y) {
            this.init(F, U, Y);
          }
          init(F, U, Y = this.coll) {
            let q = Y === "xAxis", N = this.isZAxis || (F.inverted ? !q : q);
            this.chart = F, this.horiz = N, this.isXAxis = q, this.coll = Y, p(this, "init", { userOptions: U }), this.opposite = m(U.opposite, this.opposite), this.side = m(U.side, this.side, N ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(U);
            let X = this.options, W = X.labels;
            this.type ?? (this.type = X.type || "linear"), this.uniqueNames ?? (this.uniqueNames = X.uniqueNames ?? !0), p(this, "afterSetType"), this.userOptions = U, this.minPixelPadding = 0, this.reversed = m(X.reversed, this.reversed), this.visible = X.visible, this.zoomEnabled = X.zoomEnabled, this.hasNames = this.type === "category" || X.categories === !0, this.categories = t(X.categories) && X.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = a(X.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = X.minRange || X.maxZoom, this.range = X.range, this.offset = X.offset || 0, this.max = void 0, this.min = void 0;
            let _ = m(X.crosshair, P(F.options.tooltip.crosshairs)[q ? 0 : 1]);
            this.crosshair = _ === !0 ? {} : _, F.axes.indexOf(this) === -1 && (q ? F.axes.splice(F.xAxis.length, 0, this) : F.axes.push(this), o(this, F[this.coll])), F.orderItems(this.coll), this.series = this.series || [], F.inverted && !this.isZAxis && q && !a(this.reversed) && (this.reversed = !0), this.labelRotation = e(W.rotation) ? W.rotation : void 0, c(this, X), p(this, "afterInit");
          }
          setOptions(F) {
            let U = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
            this.options = d(U, u[this.coll], F), p(this, "afterSetOptions", { userOptions: F });
          }
          defaultLabelFormatter() {
            let F = this.axis, { numberFormatter: U } = this.chart, Y = e(this.value) ? this.value : NaN, q = F.chart.time, N = F.categories, X = this.dateTimeLabelFormat, W = u.lang, _ = W.numericSymbols, K = W.numericSymbolMagnitude || 1e3, J = F.logarithmic ? Math.abs(Y) : F.tickInterval, $ = _ && _.length, et, st;
            if (N) st = `${this.value}`;
            else if (X) st = q.dateFormat(X, Y);
            else if ($ && _ && J >= 1e3) for (; $-- && st === void 0; ) J >= (et = Math.pow(K, $ + 1)) && 10 * Y % et == 0 && _[$] !== null && Y !== 0 && (st = U(Y / et, -1) + _[$]);
            return st === void 0 && (st = Math.abs(Y) >= 1e4 ? U(Y, -1) : U(Y, -1, void 0, "")), st;
          }
          getSeriesExtremes() {
            let F, U = this;
            p(this, "getSeriesExtremes", null, function() {
              U.hasVisibleSeries = !1, U.dataMin = U.dataMax = U.threshold = void 0, U.softThreshold = !U.isXAxis, U.series.forEach((Y) => {
                if (Y.reserveSpace()) {
                  let q = Y.options, N, X = q.threshold, W, _;
                  if (U.hasVisibleSeries = !0, U.positiveValuesOnly && 0 >= (X || 0) && (X = void 0), U.isXAxis) (N = Y.xData) && N.length && (N = U.logarithmic ? N.filter((K) => K > 0) : N, W = (F = Y.getXExtremes(N)).min, _ = F.max, e(W) || W instanceof Date || (N = N.filter(e), W = (F = Y.getXExtremes(N)).min, _ = F.max), N.length && (U.dataMin = Math.min(m(U.dataMin, W), W), U.dataMax = Math.max(m(U.dataMax, _), _)));
                  else {
                    let K = Y.applyExtremes();
                    e(K.dataMin) && (W = K.dataMin, U.dataMin = Math.min(m(U.dataMin, W), W)), e(K.dataMax) && (_ = K.dataMax, U.dataMax = Math.max(m(U.dataMax, _), _)), a(X) && (U.threshold = X), (!q.softThreshold || U.positiveValuesOnly) && (U.softThreshold = !1);
                  }
                }
              });
            }), p(this, "afterGetSeriesExtremes");
          }
          translate(F, U, Y, q, N, X) {
            var lt;
            let W = this.linkedParent || this, _ = q && W.old ? W.old.min : W.min;
            if (!e(_)) return NaN;
            let K = W.minPixelPadding, J = (W.isOrdinal || ((lt = W.brokenAxis) == null ? void 0 : lt.hasBreaks) || W.logarithmic && N) && W.lin2val, $ = 1, et = 0, st = q && W.old ? W.old.transA : W.transA, at = 0;
            return st || (st = W.transA), Y && ($ *= -1, et = W.len), W.reversed && ($ *= -1, et -= $ * (W.sector || W.len)), U ? (at = (F = F * $ + et - K) / st + _, J && (at = W.lin2val(at))) : (J && (F = W.val2lin(F)), at = $ * (F - _) * st + et + $ * K + (e(X) ? st * X : 0), W.isRadial || (at = h(at))), at;
          }
          toPixels(F, U) {
            return this.translate(F, !1, !this.horiz, void 0, !0) + (U ? 0 : this.pos);
          }
          toValue(F, U) {
            return this.translate(F - (U ? 0 : this.pos), !0, !this.horiz, void 0, !0);
          }
          getPlotLinePath(F) {
            let U = this, Y = U.chart, q = U.left, N = U.top, X = F.old, W = F.value, _ = F.lineWidth, K = X && Y.oldChartHeight || Y.chartHeight, J = X && Y.oldChartWidth || Y.chartWidth, $ = U.transB, et = F.translatedValue, st = F.force, at, lt, it, Q, ot;
            function nt(ct, dt, ut) {
              return st !== "pass" && (ct < dt || ct > ut) && (st ? ct = y(ct, dt, ut) : ot = !0), ct;
            }
            let ht = { value: W, lineWidth: _, old: X, force: st, acrossPanes: F.acrossPanes, translatedValue: et };
            return p(this, "getPlotLinePath", ht, function(ct) {
              at = it = (et = y(et = m(et, U.translate(W, void 0, void 0, X)), -1e9, 1e9)) + $, lt = Q = K - et - $, e(et) ? U.horiz ? (lt = N, Q = K - U.bottom + (U.options.isInternal ? 0 : Y.scrollablePixelsY || 0), at = it = nt(at, q, q + U.width)) : (at = q, it = J - U.right + (Y.scrollablePixelsX || 0), lt = Q = nt(lt, N, N + U.height)) : (ot = !0, st = !1), ct.path = ot && !st ? void 0 : Y.renderer.crispLine([["M", at, lt], ["L", it, Q]], _ || 1);
            }), ht.path;
          }
          getLinearTickPositions(F, U, Y) {
            let q, N, X, W = h(Math.floor(U / F) * F), _ = h(Math.ceil(Y / F) * F), K = [];
            if (h(W + F) === W && (X = 20), this.single) return [U];
            for (q = W; q <= _ && (K.push(q), (q = h(q + F, X)) !== N); ) N = q;
            return K;
          }
          getMinorTickInterval() {
            let { minorTicks: F, minorTickInterval: U } = this.options;
            return F === !0 ? m(U, "auto") : F !== !1 ? U : void 0;
          }
          getMinorTickPositions() {
            let F = this.options, U = this.tickPositions, Y = this.minorTickInterval, q = this.pointRangePadding || 0, N = (this.min || 0) - q, X = (this.max || 0) + q, W = X - N, _ = [], K;
            if (W && W / Y < this.len / 3) {
              let J = this.logarithmic;
              if (J) this.paddedTicks.forEach(function($, et, st) {
                et && _.push.apply(_, J.getLogTickPositions(Y, st[et - 1], st[et], !0));
              });
              else if (this.dateTime && this.getMinorTickInterval() === "auto") _ = _.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(Y), N, X, F.startOfWeek));
              else for (K = N + (U[0] - N) % Y; K <= X && K !== _[0]; K += Y) _.push(K);
            }
            return _.length !== 0 && this.trimTicks(_), _;
          }
          adjustForMinRange() {
            let F = this.options, U = this.logarithmic, { max: Y, min: q, minRange: N } = this, X, W, _, K;
            this.isXAxis && N === void 0 && !U && (N = a(F.min) || a(F.max) || a(F.floor) || a(F.ceiling) ? null : Math.min(5 * (C(this.series.map((J) => {
              var $;
              return (J.xIncrement ? ($ = J.xData) == null ? void 0 : $.slice(0, 2) : J.xData) || [];
            })) || 0), this.dataMax - this.dataMin)), e(Y) && e(q) && e(N) && Y - q < N && (W = this.dataMax - this.dataMin >= N, X = (N - Y + q) / 2, _ = [q - X, m(F.min, q - X)], W && (_[2] = U ? U.log2lin(this.dataMin) : this.dataMin), K = [(q = s(_)) + N, m(F.max, q + N)], W && (K[2] = U ? U.log2lin(this.dataMax) : this.dataMax), (Y = f(K)) - q < N && (_[0] = Y - N, _[1] = m(F.min, Y - N), q = s(_))), this.minRange = N, this.min = q, this.max = Y;
          }
          getClosest() {
            let F, U;
            if (this.categories) U = 1;
            else {
              let Y = [];
              this.series.forEach(function(q) {
                var X;
                let N = q.closestPointRange;
                ((X = q.xData) == null ? void 0 : X.length) === 1 ? Y.push(q.xData[0]) : !q.noSharedTooltip && a(N) && q.reserveSpace() && (U = a(U) ? Math.min(U, N) : N);
              }), Y.length && (Y.sort((q, N) => q - N), F = C([Y]));
            }
            return F && U ? Math.min(F, U) : F || U;
          }
          nameToX(F) {
            let U = t(this.options.categories), Y = U ? this.categories : this.names, q = F.options.x, N;
            return F.series.requireSorting = !1, a(q) || (q = this.uniqueNames && Y ? U ? Y.indexOf(F.name) : m(Y.keys[F.name], -1) : F.series.autoIncrement()), q === -1 ? !U && Y && (N = Y.length) : N = q, N !== void 0 ? (this.names[N] = F.name, this.names.keys[F.name] = N) : F.x && (N = F.x), N;
          }
          updateNames() {
            let F = this, U = this.names;
            U.length > 0 && (Object.keys(U.keys).forEach(function(Y) {
              delete U.keys[Y];
            }), U.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((Y) => {
              Y.xIncrement = null, (!Y.points || Y.isDirtyData) && (F.max = Math.max(F.max, Y.xData.length - 1), Y.processData(), Y.generatePoints()), Y.data.forEach(function(q, N) {
                let X;
                q != null && q.options && q.name !== void 0 && (X = F.nameToX(q)) !== void 0 && X !== q.x && (q.x = X, Y.xData[N] = X);
              });
            }));
          }
          setAxisTranslation() {
            let F = this, U = F.max - F.min, Y = F.linkedParent, q = !!F.categories, N = F.isXAxis, X = F.axisPointRange || 0, W, _ = 0, K = 0, J, $ = F.transA;
            (N || q || X) && (W = F.getClosest(), Y ? (_ = Y.minPointOffset, K = Y.pointRangePadding) : F.series.forEach(function(et) {
              let st = q ? 1 : N ? m(et.options.pointRange, W, 0) : F.axisPointRange || 0, at = et.options.pointPlacement;
              if (X = Math.max(X, st), !F.single || q) {
                let lt = et.is("xrange") ? !N : N;
                _ = Math.max(_, lt && n(at) ? 0 : st / 2), K = Math.max(K, lt && at === "on" ? 0 : st);
              }
            }), J = F.ordinal && F.ordinal.slope && W ? F.ordinal.slope / W : 1, F.minPointOffset = _ *= J, F.pointRangePadding = K *= J, F.pointRange = Math.min(X, F.single && q ? 1 : U), N && W && (F.closestPointRange = W)), F.translationSlope = F.transA = $ = F.staticScale || F.len / (U + K || 1), F.transB = F.horiz ? F.left : F.bottom, F.minPixelPadding = $ * _, p(this, "afterSetAxisTranslation");
          }
          minFromRange() {
            let { max: F, min: U } = this;
            return e(F) && e(U) && F - U || void 0;
          }
          setTickInterval(F) {
            var bt, vt, Ct, At;
            let { categories: U, chart: Y, dataMax: q, dataMin: N, dateTime: X, isXAxis: W, logarithmic: _, options: K, softThreshold: J } = this, $ = e(this.threshold) ? this.threshold : void 0, et = this.minRange || 0, { ceiling: st, floor: at, linkedTo: lt, softMax: it, softMin: Q } = K, ot = e(lt) && ((bt = Y[this.coll]) == null ? void 0 : bt[lt]), nt = K.tickPixelInterval, ht = K.maxPadding, ct = K.minPadding, dt = 0, ut, pt = e(K.tickInterval) && K.tickInterval >= 0 ? K.tickInterval : void 0, gt, ft, mt, yt;
            if (X || U || ot || this.getTickAmount(), mt = m(this.userMin, K.min), yt = m(this.userMax, K.max), ot ? (this.linkedParent = ot, ut = ot.getExtremes(), this.min = m(ut.min, ut.dataMin), this.max = m(ut.max, ut.dataMax), this.type !== ot.type && E(11, !0, Y)) : (J && a($) && e(q) && e(N) && (N >= $ ? (gt = $, ct = 0) : q <= $ && (ft = $, ht = 0)), this.min = m(mt, gt, N), this.max = m(yt, ft, q)), e(this.max) && e(this.min) && (_ && (this.positiveValuesOnly && !F && 0 >= Math.min(this.min, m(N, this.min)) && E(10, !0, Y), this.min = h(_.log2lin(this.min), 16), this.max = h(_.log2lin(this.max), 16)), this.range && e(N) && (this.userMin = this.min = mt = Math.max(N, this.minFromRange() || 0), this.userMax = yt = this.max, this.range = void 0)), p(this, "foundExtremes"), this.adjustForMinRange(), e(this.min) && e(this.max)) {
              if (!e(this.userMin) && e(Q) && Q < this.min && (this.min = mt = Q), !e(this.userMax) && e(it) && it > this.max && (this.max = yt = it), U || this.axisPointRange || (vt = this.stacking) != null && vt.usePercentage || ot || !(dt = this.max - this.min) || (!a(mt) && ct && (this.min -= dt * ct), a(yt) || !ht || (this.max += dt * ht)), !e(this.userMin) && e(at) && (this.min = Math.max(this.min, at)), !e(this.userMax) && e(st) && (this.max = Math.min(this.max, st)), J && e(N) && e(q)) {
                let Mt = $ || 0;
                !a(mt) && this.min < Mt && N >= Mt ? this.min = K.minRange ? Math.min(Mt, this.max - et) : Mt : !a(yt) && this.max > Mt && q <= Mt && (this.max = K.minRange ? Math.max(Mt, this.min + et) : Mt);
              }
              !Y.polar && this.min > this.max && (a(K.min) ? this.max = this.min : a(K.max) && (this.min = this.max)), dt = this.max - this.min;
            }
            if (this.min !== this.max && e(this.min) && e(this.max) ? ot && !pt && nt === ot.options.tickPixelInterval ? this.tickInterval = pt = ot.tickInterval : this.tickInterval = m(pt, this.tickAmount ? dt / Math.max(this.tickAmount - 1, 1) : void 0, U ? 1 : dt * nt / Math.max(this.len, nt)) : this.tickInterval = 1, W && !F) {
              let Mt = this.min !== ((Ct = this.old) == null ? void 0 : Ct.min) || this.max !== ((At = this.old) == null ? void 0 : At.max);
              this.series.forEach(function(kt) {
                var Pt;
                kt.forceCrop = (Pt = kt.forceCropping) == null ? void 0 : Pt.call(kt), kt.processData(Mt);
              }), p(this, "postProcessData", { hasExtremesChanged: Mt });
            }
            this.setAxisTranslation(), p(this, "initialAxisTranslation"), this.pointRange && !pt && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
            let xt = m(K.minTickInterval, X && !this.series.some((Mt) => Mt.noSharedTooltip) ? this.closestPointRange : 0);
            !pt && this.tickInterval < xt && (this.tickInterval = xt), X || _ || pt || (this.tickInterval = H(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
          }
          setTickPositions() {
            var J, $;
            let F = this.options, U = F.tickPositions, Y = F.tickPositioner, q = this.getMinorTickInterval(), N = !this.isPanning, X = N && F.startOnTick, W = N && F.endOnTick, _ = [], K;
            if (this.tickmarkOffset = this.categories && F.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && a(this.min) && !this.tickAmount && (this.min % 1 == 0 || F.allowDecimals !== !1), U) _ = U.slice();
            else if (e(this.min) && e(this.max)) {
              if (!((J = this.ordinal) != null && J.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) _ = [this.min, this.max], E(19, !1, this.chart);
              else if (this.dateTime) _ = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, F.units), this.min, this.max, F.startOfWeek, ($ = this.ordinal) == null ? void 0 : $.positions, this.closestPointRange, !0);
              else if (this.logarithmic) _ = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
              else {
                let et = this.tickInterval, st = et;
                for (; st <= 2 * et && (_ = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && _.length > this.tickAmount); ) this.tickInterval = H(this, st *= 1.1);
              }
              _.length > this.len && (_ = [_[0], _[_.length - 1]])[0] === _[1] && (_.length = 1), Y && (this.tickPositions = _, (K = Y.apply(this, [this.min, this.max])) && (_ = K));
            }
            this.tickPositions = _, this.minorTickInterval = q === "auto" && this.tickInterval ? this.tickInterval / F.minorTicksPerMajor : q, this.paddedTicks = _.slice(0), this.trimTicks(_, X, W), !this.isLinked && e(this.min) && e(this.max) && (this.single && _.length < 2 && !this.categories && !this.series.some((et) => et.is("heatmap") && et.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), U || K || this.adjustTickAmount()), p(this, "afterSetTickPositions");
          }
          trimTicks(F, U, Y) {
            let q = F[0], N = F[F.length - 1], X = !this.isOrdinal && this.minPointOffset || 0;
            if (p(this, "trimTicks"), !this.isLinked) {
              if (U && q !== -1 / 0) this.min = q;
              else for (; this.min - X > F[0]; ) F.shift();
              if (Y) this.max = N;
              else for (; this.max + X < F[F.length - 1]; ) F.pop();
              F.length === 0 && a(q) && !this.options.tickPositions && F.push((N + q) / 2);
            }
          }
          alignToOthers() {
            let F, U = this, Y = U.chart, q = [this], N = U.options, X = Y.options.chart, W = this.coll === "yAxis" && X.alignThresholds, _ = [];
            if (U.thresholdAlignment = void 0, (X.alignTicks !== !1 && N.alignTicks || W) && N.startOnTick !== !1 && N.endOnTick !== !1 && !U.logarithmic) {
              let K = ($) => {
                let { horiz: et, options: st } = $;
                return [et ? st.left : st.top, st.width, st.height, st.pane].join(",");
              }, J = K(this);
              Y[this.coll].forEach(function($) {
                let { series: et } = $;
                et.length && et.some((st) => st.visible) && $ !== U && K($) === J && (F = !0, q.push($));
              });
            }
            if (F && W) {
              q.forEach((J) => {
                let $ = J.getThresholdAlignment(U);
                e($) && _.push($);
              });
              let K = _.length > 1 ? _.reduce((J, $) => J += $, 0) / _.length : void 0;
              q.forEach((J) => {
                J.thresholdAlignment = K;
              });
            }
            return F;
          }
          getThresholdAlignment(F) {
            if ((!e(this.dataMin) || this !== F && this.series.some((U) => U.isDirty || U.isDirtyData)) && this.getSeriesExtremes(), e(this.threshold)) {
              let U = y((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
              return this.options.reversed && (U = 1 - U), U;
            }
          }
          getTickAmount() {
            let F = this.options, U = F.tickPixelInterval, Y = F.tickAmount;
            a(F.tickInterval) || Y || !(this.len < U) || this.isRadial || this.logarithmic || !F.startOnTick || !F.endOnTick || (Y = 2), !Y && this.alignToOthers() && (Y = Math.ceil(this.len / U) + 1), Y < 4 && (this.finalTickAmt = Y, Y = 5), this.tickAmount = Y;
          }
          adjustTickAmount() {
            let F = this, { finalTickAmt: U, max: Y, min: q, options: N, tickPositions: X, tickAmount: W, thresholdAlignment: _ } = F, K = X == null ? void 0 : X.length, J = m(F.threshold, F.softThreshold ? 0 : null), $, et, st = F.tickInterval, at, lt = () => X.push(h(X[X.length - 1] + st)), it = () => X.unshift(h(X[0] - st));
            if (e(_) && (at = _ < 0.5 ? Math.ceil(_ * (W - 1)) : Math.floor(_ * (W - 1)), N.reversed && (at = W - 1 - at)), F.hasData() && e(q) && e(Y)) {
              let Q = () => {
                F.transA *= (K - 1) / (W - 1), F.min = N.startOnTick ? X[0] : Math.min(q, X[0]), F.max = N.endOnTick ? X[X.length - 1] : Math.max(Y, X[X.length - 1]);
              };
              if (e(at) && e(F.threshold)) {
                for (; X[at] !== J || X.length !== W || X[0] > q || X[X.length - 1] < Y; ) {
                  for (X.length = 0, X.push(F.threshold); X.length < W; ) X[at] === void 0 || X[at] > F.threshold ? it() : lt();
                  if (st > 8 * F.tickInterval) break;
                  st *= 2;
                }
                Q();
              } else if (K < W) {
                for (; X.length < W; ) X.length % 2 || q === J ? lt() : it();
                Q();
              }
              if (a(U)) {
                for (et = $ = X.length; et--; ) (U === 3 && et % 2 == 1 || U <= 2 && et > 0 && et < $ - 1) && X.splice(et, 1);
                F.finalTickAmt = void 0;
              }
            }
          }
          setScale() {
            var X, W;
            let { coll: F, stacking: U } = this, Y = !1, q = !1;
            this.series.forEach((_) => {
              Y = Y || _.isDirtyData || _.isDirty, q = q || _.xAxis && _.xAxis.isDirty || !1;
            }), this.setAxisSize();
            let N = this.len !== (this.old && this.old.len);
            N || Y || q || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (U && F === "yAxis" && U.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), U && F === "xAxis" && U.buildStacks(), this.isDirty || (this.isDirty = N || this.min !== ((X = this.old) == null ? void 0 : X.min) || this.max !== ((W = this.old) == null ? void 0 : W.max))) : U && U.cleanStacks(), Y && delete this.allExtremes, p(this, "afterSetScale");
          }
          setExtremes(F, U, Y = !0, q, N) {
            this.series.forEach((X) => {
              delete X.kdTree;
            }), p(this, "setExtremes", N = b(N, { min: F, max: U }), (X) => {
              this.userMin = X.min, this.userMax = X.max, this.eventArgs = X, Y && this.chart.redraw(q);
            });
          }
          setAxisSize() {
            let F = this.chart, U = this.options, Y = U.offsets || [0, 0, 0, 0], q = this.horiz, N = this.width = Math.round(k(m(U.width, F.plotWidth - Y[3] + Y[1]), F.plotWidth)), X = this.height = Math.round(k(m(U.height, F.plotHeight - Y[0] + Y[2]), F.plotHeight)), W = this.top = Math.round(k(m(U.top, F.plotTop + Y[0]), F.plotHeight, F.plotTop)), _ = this.left = Math.round(k(m(U.left, F.plotLeft + Y[3]), F.plotWidth, F.plotLeft));
            this.bottom = F.chartHeight - X - W, this.right = F.chartWidth - N - _, this.len = Math.max(q ? N : X, 0), this.pos = q ? _ : W;
          }
          getExtremes() {
            let F = this.logarithmic;
            return { min: F ? h(F.lin2log(this.min)) : this.min, max: F ? h(F.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
          }
          getThreshold(F) {
            let U = this.logarithmic, Y = U ? U.lin2log(this.min) : this.min, q = U ? U.lin2log(this.max) : this.max;
            return F === null || F === -1 / 0 ? F = Y : F === 1 / 0 ? F = q : Y > F ? F = Y : q < F && (F = q), this.translate(F, 0, 1, 0, 1);
          }
          autoLabelAlign(F) {
            let U = (m(F, 0) - 90 * this.side + 720) % 360, Y = { align: "center" };
            return p(this, "autoLabelAlign", Y, function(q) {
              U > 15 && U < 165 ? q.align = "right" : U > 195 && U < 345 && (q.align = "left");
            }), Y.align;
          }
          tickSize(F) {
            let U = this.options, Y = m(U[F === "tick" ? "tickWidth" : "minorTickWidth"], F === "tick" && this.isXAxis && !this.categories ? 1 : 0), q = U[F === "tick" ? "tickLength" : "minorTickLength"], N;
            Y && q && (U[F + "Position"] === "inside" && (q = -q), N = [q, Y]);
            let X = { tickSize: N };
            return p(this, "afterTickSize", X), X.tickSize;
          }
          labelMetrics() {
            let F = this.chart.renderer, U = this.ticks, Y = U[Object.keys(U)[0]] || {};
            return this.chart.renderer.fontMetrics(Y.label || Y.movedLabel || F.box);
          }
          unsquish() {
            let F = this.options.labels, U = F.padding || 0, Y = this.horiz, q = this.tickInterval, N = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / q), X = F.rotation, W = h(0.8 * this.labelMetrics().h), _ = Math.max(this.max - this.min, 0), K = function(at) {
              let lt = (at + 2 * U) / (N || 1);
              return (lt = lt > 1 ? Math.ceil(lt) : 1) * q > _ && at !== 1 / 0 && N !== 1 / 0 && _ && (lt = Math.ceil(_ / q)), h(lt * q);
            }, J = q, $, et = Number.MAX_VALUE, st;
            if (Y) {
              if (!F.staggerLines && (e(X) ? st = [X] : N < F.autoRotationLimit && (st = F.autoRotation)), st) {
                let at, lt;
                for (let it of st) (it === X || it && it >= -90 && it <= 90) && (lt = (at = K(Math.abs(W / Math.sin(v * it)))) + Math.abs(it / 360)) < et && (et = lt, $ = it, J = at);
              }
            } else J = K(0.75 * W);
            return this.autoRotation = st, this.labelRotation = m($, e(X) ? X : 0), F.step ? q : J;
          }
          getSlotWidth(F) {
            let U = this.chart, Y = this.horiz, q = this.options.labels, N = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), X = U.margin[3];
            if (F && e(F.slotWidth)) return F.slotWidth;
            if (Y && q.step < 2) return q.rotation ? 0 : (this.staggerLines || 1) * this.len / N;
            if (!Y) {
              let W = q.style.width;
              if (W !== void 0) return parseInt(String(W), 10);
              if (X) return X - U.spacing[3];
            }
            return 0.33 * U.chartWidth;
          }
          renderUnsquish() {
            let F = this.chart, U = F.renderer, Y = this.tickPositions, q = this.ticks, N = this.options.labels, X = N.style, W = this.horiz, _ = this.getSlotWidth(), K = Math.max(1, Math.round(_ - (W ? 2 * (N.padding || 0) : N.distance || 0))), J = {}, $ = this.labelMetrics(), et = X.textOverflow, st, at, lt = 0, it, Q;
            if (n(N.rotation) || (J.rotation = N.rotation || 0), Y.forEach(function(ot) {
              let nt = q[ot];
              nt.movedLabel && nt.replaceMovedLabel(), nt && nt.label && nt.label.textPxLength > lt && (lt = nt.label.textPxLength);
            }), this.maxLabelLength = lt, this.autoRotation) lt > K && lt > $.h ? J.rotation = this.labelRotation : this.labelRotation = 0;
            else if (_ && (st = K, !et)) for (at = "clip", Q = Y.length; !W && Q--; ) (it = q[Y[Q]].label) && (it.styles.textOverflow === "ellipsis" ? it.css({ textOverflow: "clip" }) : it.textPxLength > _ && it.css({ width: _ + "px" }), it.getBBox().height > this.len / Y.length - ($.h - $.f) && (it.specificTextOverflow = "ellipsis"));
            J.rotation && (st = lt > 0.5 * F.chartHeight ? 0.33 * F.chartHeight : lt, et || (at = "ellipsis")), this.labelAlign = N.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (J.align = this.labelAlign), Y.forEach(function(ot) {
              let nt = q[ot], ht = nt && nt.label, ct = X.width, dt = {};
              ht && (ht.attr(J), nt.shortenLabel ? nt.shortenLabel() : st && !ct && X.whiteSpace !== "nowrap" && (st < ht.textPxLength || ht.element.tagName === "SPAN") ? (dt.width = st + "px", et || (dt.textOverflow = ht.specificTextOverflow || at), ht.css(dt)) : !ht.styles.width || dt.width || ct || ht.css({ width: null }), delete ht.specificTextOverflow, nt.rotation = J.rotation);
            }, this), this.tickRotCorr = U.rotCorr($.b, this.labelRotation || 0, this.side !== 0);
          }
          hasData() {
            return this.series.some(function(F) {
              return F.hasData();
            }) || this.options.showEmpty && a(this.min) && a(this.max);
          }
          addTitle(F) {
            let U, Y = this.chart.renderer, q = this.horiz, N = this.opposite, X = this.options.title, W = this.chart.styledMode;
            this.axisTitle || ((U = X.textAlign) || (U = (q ? { low: "left", middle: "center", high: "right" } : { low: N ? "right" : "left", middle: "center", high: N ? "left" : "right" })[X.align]), this.axisTitle = Y.text(X.text || "", 0, 0, X.useHTML).attr({ zIndex: 7, rotation: X.rotation || 0, align: U }).addClass("highcharts-axis-title"), W || this.axisTitle.css(d(X.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), W || X.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[F ? "show" : "hide"](F);
          }
          generateTick(F) {
            let U = this.ticks;
            U[F] ? U[F].addLabel() : U[F] = new L(this, F);
          }
          createGroups() {
            let { axisParent: F, chart: U, coll: Y, options: q } = this, N = U.renderer, X = (W, _, K) => N.g(W).attr({ zIndex: K }).addClass(`highcharts-${Y.toLowerCase()}${_} ` + (this.isRadial ? `highcharts-radial-axis${_} ` : "") + (q.className || "")).add(F);
            this.axisGroup || (this.gridGroup = X("grid", "-grid", q.gridZIndex), this.axisGroup = X("axis", "", q.zIndex), this.labelGroup = X("axis-labels", "-labels", q.labels.zIndex));
          }
          getOffset() {
            let F = this, { chart: U, horiz: Y, options: q, side: N, ticks: X, tickPositions: W, coll: _ } = F, K = U.inverted && !F.isZAxis ? [1, 0, 3, 2][N] : N, J = F.hasData(), $ = q.title, et = q.labels, st = e(q.crossing), at = U.axisOffset, lt = U.clipOffset, it = [-1, 1, 1, -1][N], Q, ot = 0, nt, ht = 0, ct = 0, dt, ut;
            if (F.showAxis = Q = J || q.showEmpty, F.staggerLines = F.horiz && et.staggerLines || void 0, F.createGroups(), J || F.isLinked ? (W.forEach(function(pt) {
              F.generateTick(pt);
            }), F.renderUnsquish(), F.reserveSpaceDefault = N === 0 || N === 2 || { 1: "left", 3: "right" }[N] === F.labelAlign, m(et.reserveSpace, !st && null, F.labelAlign === "center" || null, F.reserveSpaceDefault) && W.forEach(function(pt) {
              ct = Math.max(X[pt].getLabelSize(), ct);
            }), F.staggerLines && (ct *= F.staggerLines), F.labelOffset = ct * (F.opposite ? -1 : 1)) : g(X, function(pt, gt) {
              pt.destroy(), delete X[gt];
            }), $ != null && $.text && $.enabled !== !1 && (F.addTitle(Q), Q && !st && $.reserveSpace !== !1 && (F.titleOffset = ot = F.axisTitle.getBBox()[Y ? "height" : "width"], ht = a(nt = $.offset) ? 0 : m($.margin, Y ? 5 : 10))), F.renderLine(), F.offset = it * m(q.offset, at[N] ? at[N] + (q.margin || 0) : 0), F.tickRotCorr = F.tickRotCorr || { x: 0, y: 0 }, ut = N === 0 ? -F.labelMetrics().h : N === 2 ? F.tickRotCorr.y : 0, dt = Math.abs(ct) + ht, ct && (dt -= ut, dt += it * (Y ? m(et.y, F.tickRotCorr.y + it * et.distance) : m(et.x, it * et.distance))), F.axisTitleMargin = m(nt, dt), F.getMaxLabelDimensions && (F.maxLabelDimensions = F.getMaxLabelDimensions(X, W)), _ !== "colorAxis" && lt) {
              let pt = this.tickSize("tick");
              at[N] = Math.max(at[N], (F.axisTitleMargin || 0) + ot + it * F.offset, dt, W && W.length && pt ? pt[0] + it * F.offset : 0);
              let gt = !F.axisLine || q.offset ? 0 : F.axisLine.strokeWidth() / 2;
              lt[K] = Math.max(lt[K], gt);
            }
            p(this, "afterGetOffset");
          }
          getLinePath(F) {
            let U = this.chart, Y = this.opposite, q = this.offset, N = this.horiz, X = this.left + (Y ? this.width : 0) + q, W = U.chartHeight - this.bottom - (Y ? this.height : 0) + q;
            return Y && (F *= -1), U.renderer.crispLine([["M", N ? this.left : X, N ? W : this.top], ["L", N ? U.chartWidth - this.right : X, N ? W : U.chartHeight - this.bottom]], F);
          }
          renderLine() {
            this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
          }
          getTitlePosition(F) {
            let U = this.horiz, Y = this.left, q = this.top, N = this.len, X = this.options.title, W = U ? Y : q, _ = this.opposite, K = this.offset, J = X.x, $ = X.y, et = this.chart.renderer.fontMetrics(F), st = F ? Math.max(F.getBBox(!1, 0).height - et.h - 1, 0) : 0, at = { low: W + (U ? 0 : N), middle: W + N / 2, high: W + (U ? N : 0) }[X.align], lt = (U ? q + this.height : Y) + (U ? 1 : -1) * (_ ? -1 : 1) * (this.axisTitleMargin || 0) + [-st, st, et.f, -st][this.side], it = { x: U ? at + J : lt + (_ ? this.width : 0) + K + J, y: U ? lt + $ - (_ ? this.height : 0) + K : at + $ };
            return p(this, "afterGetTitlePosition", { titlePosition: it }), it;
          }
          renderMinorTick(F, U) {
            let Y = this.minorTicks;
            Y[F] || (Y[F] = new L(this, F, "minor")), U && Y[F].isNew && Y[F].render(null, !0), Y[F].render(null, !1, 1);
          }
          renderTick(F, U, Y) {
            let q = this.isLinked, N = this.ticks;
            (!q || F >= this.min && F <= this.max || this.grid && this.grid.isColumn) && (N[F] || (N[F] = new L(this, F)), Y && N[F].isNew && N[F].render(U, !0, -1), N[F].render(U));
          }
          render() {
            let F, U, Y = this, q = Y.chart, N = Y.logarithmic, X = q.renderer, W = Y.options, _ = Y.isLinked, K = Y.tickPositions, J = Y.axisTitle, $ = Y.ticks, et = Y.minorTicks, st = Y.alternateBands, at = W.stackLabels, lt = W.alternateGridColor, it = W.crossing, Q = Y.tickmarkOffset, ot = Y.axisLine, nt = Y.showAxis, ht = w(X.globalAnimation);
            if (Y.labelEdge.length = 0, Y.overlap = !1, [$, et, st].forEach(function(ct) {
              g(ct, function(dt) {
                dt.isActive = !1;
              });
            }), e(it)) {
              let ct = this.isXAxis ? q.yAxis[0] : q.xAxis[0], dt = [1, -1, -1, 1][this.side];
              if (ct) {
                let ut = ct.toPixels(it, !0);
                Y.horiz && (ut = ct.len - ut), Y.offset = dt * ut;
              }
            }
            if (Y.hasData() || _) {
              let ct = Y.chart.hasRendered && Y.old && e(Y.old.min);
              Y.minorTickInterval && !Y.categories && Y.getMinorTickPositions().forEach(function(dt) {
                Y.renderMinorTick(dt, ct);
              }), K.length && (K.forEach(function(dt, ut) {
                Y.renderTick(dt, ut, ct);
              }), Q && (Y.min === 0 || Y.single) && ($[-1] || ($[-1] = new L(Y, -1, null, !0)), $[-1].render(-1))), lt && K.forEach(function(dt, ut) {
                U = K[ut + 1] !== void 0 ? K[ut + 1] + Q : Y.max - Q, ut % 2 == 0 && dt < Y.max && U <= Y.max + (q.polar ? -Q : Q) && (st[dt] || (st[dt] = new O.PlotLineOrBand(Y, {})), F = dt + Q, st[dt].options = { from: N ? N.lin2log(F) : F, to: N ? N.lin2log(U) : U, color: lt, className: "highcharts-alternate-grid" }, st[dt].render(), st[dt].isActive = !0);
              }), Y._addedPlotLB || (Y._addedPlotLB = !0, (W.plotLines || []).concat(W.plotBands || []).forEach(function(dt) {
                Y.addPlotBandOrLine(dt);
              }));
            }
            [$, et, st].forEach(function(ct) {
              let dt = [], ut = ht.duration;
              g(ct, function(pt, gt) {
                pt.isActive || (pt.render(gt, !1, 0), pt.isActive = !1, dt.push(gt));
              }), D(function() {
                let pt = dt.length;
                for (; pt--; ) ct[dt[pt]] && !ct[dt[pt]].isActive && (ct[dt[pt]].destroy(), delete ct[dt[pt]]);
              }, ct !== st && q.hasRendered && ut ? ut : 0);
            }), ot && (ot[ot.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(ot.strokeWidth()) }), ot.isPlaced = !0, ot[nt ? "show" : "hide"](nt)), J && nt && (J[J.isNew ? "attr" : "animate"](Y.getTitlePosition(J)), J.isNew = !1), at && at.enabled && Y.stacking && Y.stacking.renderStackTotals(), Y.old = { len: Y.len, max: Y.max, min: Y.min, transA: Y.transA, userMax: Y.userMax, userMin: Y.userMin }, Y.isDirty = !1, p(this, "afterRender");
          }
          redraw() {
            this.visible && (this.render(), this.plotLinesAndBands.forEach(function(F) {
              F.render();
            })), this.series.forEach(function(F) {
              F.isDirty = !0;
            });
          }
          getKeepProps() {
            return this.keepProps || G.keepProps;
          }
          destroy(F) {
            let U = this, Y = U.plotLinesAndBands, q = this.eventOptions;
            if (p(this, "destroy", { keepEvents: F }), F || j(U), [U.ticks, U.minorTicks, U.alternateBands].forEach(function(N) {
              x(N);
            }), Y) {
              let N = Y.length;
              for (; N--; ) Y[N].destroy();
            }
            for (let N in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(X) {
              U[X] && (U[X] = U[X].destroy());
            }), U.plotLinesAndBandsGroups) U.plotLinesAndBandsGroups[N] = U.plotLinesAndBandsGroups[N].destroy();
            g(U, function(N, X) {
              U.getKeepProps().indexOf(X) === -1 && delete U[X];
            }), this.eventOptions = q;
          }
          drawCrosshair(F, U) {
            let Y = this.crosshair, q = m(Y && Y.snap, !0), N = this.chart, X, W, _, K = this.cross, J;
            if (p(this, "drawCrosshair", { e: F, point: U }), F || (F = this.cross && this.cross.e), Y && (a(U) || !q) !== !1) {
              if (q ? a(U) && (W = m(this.coll !== "colorAxis" ? U.crosshairPos : null, this.isXAxis ? U.plotX : this.len - U.plotY)) : W = F && (this.horiz ? F.chartX - this.pos : this.len - F.chartY + this.pos), a(W) && (J = { value: U && (this.isXAxis ? U.x : m(U.stackY, U.y)), translatedValue: W }, N.polar && b(J, { isCrosshair: !0, chartX: F && F.chartX, chartY: F && F.chartY, point: U }), X = this.getPlotLinePath(J) || null), !a(X)) {
                this.hideCrosshair();
                return;
              }
              _ = this.categories && !this.isRadial, K || (this.cross = K = N.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (_ ? "category " : "thin ") + (Y.className || "")).attr({ zIndex: m(Y.zIndex, 2) }).add(), !N.styledMode && (K.attr({ stroke: Y.color || (_ ? I.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": m(Y.width, 1) }).css({ "pointer-events": "none" }), Y.dashStyle && K.attr({ dashstyle: Y.dashStyle }))), K.show().attr({ d: X }), _ && !Y.width && K.attr({ "stroke-width": this.transA }), this.cross.e = F;
            } else this.hideCrosshair();
            p(this, "afterDrawCrosshair", { e: F, point: U });
          }
          hideCrosshair() {
            this.cross && this.cross.hide(), p(this, "afterHideCrosshair");
          }
          update(F, U) {
            let Y = this.chart;
            F = d(this.userOptions, F), this.destroy(!0), this.init(Y, F), Y.isDirtyBox = !0, m(U, !0) && Y.redraw();
          }
          remove(F) {
            let U = this.chart, Y = this.coll, q = this.series, N = q.length;
            for (; N--; ) q[N] && q[N].remove(!1);
            S(U.axes, this), S(U[Y] || [], this), U.orderItems(Y), this.destroy(), U.isDirtyBox = !0, m(F, !0) && U.redraw();
          }
          setTitle(F, U) {
            this.update({ title: F }, U);
          }
          setCategories(F, U) {
            this.update({ categories: F }, U);
          }
        }
        return G.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], G;
      }), Z(r, "Core/Axis/DateTimeAxis.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, getMagnitude: R, normalizeTickInterval: z, timeUnits: O } = T;
        return function(L) {
          function M() {
            return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
          }
          function w() {
            if (this.type !== "datetime") {
              this.dateTime = void 0;
              return;
            }
            this.dateTime || (this.dateTime = new A(this));
          }
          L.compose = function(l) {
            return l.keepProps.includes("dateTime") || (l.keepProps.push("dateTime"), l.prototype.getTimeTicks = M, I(l, "afterSetType", w)), l;
          };
          class A {
            constructor(u) {
              this.axis = u;
            }
            normalizeTimeTickInterval(u, c) {
              let v = c || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], s = v[v.length - 1], f = O[s[0]], y = s[1], h;
              for (h = 0; h < v.length && (f = O[(s = v[h])[0]], y = s[1], !v[h + 1] || !(u <= (f * y[y.length - 1] + O[v[h + 1][0]]) / 2)); h++) ;
              f === O.year && u < 5 * f && (y = [1, 2, 5]);
              let a = z(u / f, y, s[0] === "year" ? Math.max(R(u / f), 1) : 1);
              return { unitRange: f, count: a, unitName: s[0] };
            }
            getXDateFormat(u, c) {
              let { axis: v } = this, s = v.chart.time;
              return v.closestPointRange ? s.getDateFormat(v.closestPointRange, u, v.options.startOfWeek, c) || s.resolveDTLFormat(c.year).main : s.resolveDTLFormat(c.day).main;
            }
          }
          L.Additions = A;
        }(B || (B = {})), B;
      }), Z(r, "Core/Axis/LogarithmicAxis.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, normalizeTickInterval: R, pick: z } = T;
        return function(O) {
          function L() {
            this.type !== "logarithmic" ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new w(this));
          }
          function M() {
            let A = this.logarithmic;
            A && (this.lin2val = function(l) {
              return A.lin2log(l);
            }, this.val2lin = function(l) {
              return A.log2lin(l);
            });
          }
          O.compose = function(A) {
            return A.keepProps.includes("logarithmic") || (A.keepProps.push("logarithmic"), I(A, "afterSetType", L), I(A, "afterInit", M)), A;
          };
          class w {
            constructor(l) {
              this.axis = l;
            }
            getLogTickPositions(l, u, c, v) {
              let s = this.axis, f = s.len, y = s.options, h = [];
              if (v || (this.minorAutoInterval = void 0), l >= 0.5) l = Math.round(l), h = s.getLinearTickPositions(l, u, c);
              else if (l >= 0.08) {
                let a, x, S, E, b, p, C, o = Math.floor(u);
                for (a = l > 0.3 ? [1, 2, 4] : l > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], x = o; x < c + 1 && !C; x++) for (S = 0, E = a.length; S < E && !C; S++) (b = this.log2lin(this.lin2log(x) * a[S])) > u && (!v || p <= c) && p !== void 0 && h.push(p), p > c && (C = !0), p = b;
              } else {
                let a = this.lin2log(u), x = this.lin2log(c), S = v ? s.getMinorTickInterval() : y.tickInterval, E = y.tickPixelInterval / (v ? 5 : 1), b = v ? f / s.tickPositions.length : f;
                l = R(l = z(S === "auto" ? null : S, this.minorAutoInterval, (x - a) * E / (b || 1))), h = s.getLinearTickPositions(l, a, x).map(this.log2lin), v || (this.minorAutoInterval = l / 5);
              }
              return v || (s.tickInterval = l), h;
            }
            lin2log(l) {
              return Math.pow(10, l);
            }
            log2lin(l) {
              return Math.log(l) / Math.LN10;
            }
          }
          O.Additions = w;
        }(B || (B = {})), B;
      }), Z(r, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { erase: I, extend: R, isNumber: z } = T;
        return function(O) {
          let L;
          function M(s) {
            return this.addPlotBandOrLine(s, "plotBands");
          }
          function w(s, f) {
            let y = this.userOptions, h = new L(this, s);
            if (this.visible && (h = h.render()), h) {
              if (this._addedPlotLB || (this._addedPlotLB = !0, (y.plotLines || []).concat(y.plotBands || []).forEach((a) => {
                this.addPlotBandOrLine(a);
              })), f) {
                let a = y[f] || [];
                a.push(s), y[f] = a;
              }
              this.plotLinesAndBands.push(h);
            }
            return h;
          }
          function A(s) {
            return this.addPlotBandOrLine(s, "plotLines");
          }
          function l(s, f, y) {
            y = y || this.options;
            let h = this.getPlotLinePath({ value: f, force: !0, acrossPanes: y.acrossPanes }), a = [], x = this.horiz, S = !z(this.min) || !z(this.max) || s < this.min && f < this.min || s > this.max && f > this.max, E = this.getPlotLinePath({ value: s, force: !0, acrossPanes: y.acrossPanes }), b, p = 1, C;
            if (E && h) for (S && (C = E.toString() === h.toString(), p = 0), b = 0; b < E.length; b += 2) {
              let o = E[b], t = E[b + 1], e = h[b], n = h[b + 1];
              (o[0] === "M" || o[0] === "L") && (t[0] === "M" || t[0] === "L") && (e[0] === "M" || e[0] === "L") && (n[0] === "M" || n[0] === "L") && (x && e[1] === o[1] ? (e[1] += p, n[1] += p) : x || e[2] !== o[2] || (e[2] += p, n[2] += p), a.push(["M", o[1], o[2]], ["L", t[1], t[2]], ["L", n[1], n[2]], ["L", e[1], e[2]], ["Z"])), a.isFlat = C;
            }
            return a;
          }
          function u(s) {
            this.removePlotBandOrLine(s);
          }
          function c(s) {
            let f = this.plotLinesAndBands, y = this.options, h = this.userOptions;
            if (f) {
              let a = f.length;
              for (; a--; ) f[a].id === s && f[a].destroy();
              [y.plotLines || [], h.plotLines || [], y.plotBands || [], h.plotBands || []].forEach(function(x) {
                for (a = x.length; a--; ) (x[a] || {}).id === s && I(x, x[a]);
              });
            }
          }
          function v(s) {
            this.removePlotBandOrLine(s);
          }
          O.compose = function(s, f) {
            let y = f.prototype;
            return y.addPlotBand || (L = s, R(y, { addPlotBand: M, addPlotLine: A, addPlotBandOrLine: w, getPlotBandPath: l, removePlotBand: u, removePlotLine: v, removePlotBandOrLine: c })), f;
          };
        }(B || (B = {})), B;
      }), Z(r, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [r["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], r["Core/Utilities.js"]], function(T, B) {
        let { addEvent: I, arrayMax: R, arrayMin: z, defined: O, destroyObjectProperties: L, erase: M, fireEvent: w, merge: A, objectEach: l, pick: u } = B;
        class c {
          static compose(s, f) {
            return I(s, "afterInit", function() {
              this.labelCollectors.push(() => {
                var h;
                let y = [];
                for (let a of this.axes) for (let { label: x, options: S } of a.plotLinesAndBands) x && !((h = S == null ? void 0 : S.label) != null && h.allowOverlap) && y.push(x);
                return y;
              });
            }), T.compose(c, f);
          }
          constructor(s, f) {
            this.axis = s, this.options = f, this.id = f.id;
          }
          render() {
            w(this, "render");
            let { axis: s, options: f } = this, { horiz: y, logarithmic: h } = s, { color: a, events: x, zIndex: S = 0 } = f, E = {}, b = s.chart.renderer, p = f.to, C = f.from, o = f.value, t = f.borderWidth, e = f.label, { label: n, svgElem: d } = this, i = [], g, m = O(C) && O(p), k = O(o), j = !d, P = { class: "highcharts-plot-" + (m ? "band " : "line ") + (f.className || "") }, D = m ? "bands" : "lines";
            if (!s.chart.styledMode && (k ? (P.stroke = a || "#999999", P["stroke-width"] = u(f.width, 1), f.dashStyle && (P.dashstyle = f.dashStyle)) : m && (P.fill = a || "#e6e9ff", t && (P.stroke = f.borderColor, P["stroke-width"] = t))), E.zIndex = S, D += "-" + S, (g = s.plotLinesAndBandsGroups[D]) || (s.plotLinesAndBandsGroups[D] = g = b.g("plot-" + D).attr(E).add()), d || (this.svgElem = d = b.path().attr(P).add(g)), O(o)) i = s.getPlotLinePath({ value: (h == null ? void 0 : h.log2lin(o)) ?? o, lineWidth: d.strokeWidth(), acrossPanes: f.acrossPanes });
            else {
              if (!(O(C) && O(p))) return;
              i = s.getPlotBandPath((h == null ? void 0 : h.log2lin(C)) ?? C, (h == null ? void 0 : h.log2lin(p)) ?? p, f);
            }
            return !this.eventsAdded && x && (l(x, (H, G) => {
              d == null || d.on(G, (V) => {
                x[G].apply(this, [V]);
              });
            }), this.eventsAdded = !0), (j || !d.d) && (i != null && i.length) ? d.attr({ d: i }) : d && (i ? (d.show(), d.animate({ d: i })) : d.d && (d.hide(), n && (this.label = n = n.destroy()))), e && (O(e.text) || O(e.formatter)) && (i != null && i.length) && s.width > 0 && s.height > 0 && !i.isFlat ? (e = A({ align: y && m ? "center" : void 0, x: y ? !m && 4 : 10, verticalAlign: !y && m ? "middle" : void 0, y: y ? m ? 16 : 10 : m ? 6 : -4, rotation: y && !m ? 90 : 0, ...m ? { inside: !0 } : {} }, e), this.renderLabel(e, i, m, S)) : n && n.hide(), this;
          }
          renderLabel(s, f, y, h) {
            var e;
            let a = this.axis, x = a.chart.renderer, S = s.inside, E = this.label;
            E || (this.label = E = x.text(this.getLabelText(s), 0, 0, s.useHTML).attr({ align: s.textAlign || s.align, rotation: s.rotation, class: "highcharts-plot-" + (y ? "band" : "line") + "-label " + (s.className || ""), zIndex: h }), a.chart.styledMode || E.css(A({ fontSize: "0.8em", textOverflow: y && !S ? "" : "ellipsis" }, s.style)), E.add());
            let b = f.xBounds || [f[0][1], f[1][1], y ? f[2][1] : f[0][1]], p = f.yBounds || [f[0][2], f[1][2], y ? f[2][2] : f[0][2]], C = z(b), o = z(p), t = R(b) - C;
            E.align(s, !1, { x: C, y: o, width: t, height: R(p) - o }), (!E.alignValue || E.alignValue === "left" || O(S)) && E.css({ width: (((e = s.style) == null ? void 0 : e.width) || (y && S ? t : E.rotation === 90 ? a.height - (E.alignAttr.y - a.top) : (s.clip ? a.width : a.chart.chartWidth) - (E.alignAttr.x - a.left))) + "px" }), E.show(!0);
          }
          getLabelText(s) {
            return O(s.formatter) ? s.formatter.call(this) : s.text;
          }
          destroy() {
            M(this.axis.plotLinesAndBands, this), delete this.axis, L(this);
          }
        }
        return c;
      }), Z(r, "Core/Tooltip.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Core/Renderer/RendererUtilities.js"], r["Core/Renderer/RendererRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        var L;
        let { animObject: M } = T, { format: w } = B, { composed: A, doc: l, isSafari: u } = I, { distribute: c } = R, { addEvent: v, clamp: s, css: f, discardElement: y, extend: h, fireEvent: a, isArray: x, isNumber: S, isString: E, merge: b, pick: p, pushUnique: C, splat: o, syncTimeout: t } = O;
        class e {
          constructor(d, i, g) {
            this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = d, this.init(d, i), this.pointer = g;
          }
          bodyFormatter(d) {
            return d.map(function(i) {
              let g = i.series.tooltipOptions;
              return (g[(i.point.formatPrefix || "point") + "Formatter"] || i.point.tooltipFormatter).call(i.point, g[(i.point.formatPrefix || "point") + "Format"] || "");
            });
          }
          cleanSplit(d) {
            this.chart.series.forEach(function(i) {
              let g = i && i.tt;
              g && (!g.isActive || d ? i.tt = g.destroy() : g.isActive = !1);
            });
          }
          defaultFormatter(d) {
            let i, g = this.points || o(this);
            return (i = (i = [d.tooltipFooterHeaderFormatter(g[0])]).concat(d.bodyFormatter(g))).push(d.tooltipFooterHeaderFormatter(g[0], !0)), i;
          }
          destroy() {
            this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), y(this.container)), O.clearTimeout(this.hideTimer);
          }
          getAnchor(d, i) {
            let g, { chart: m, pointer: k } = this, j = m.inverted, P = m.plotTop, D = m.plotLeft;
            if ((d = o(d))[0].series && d[0].series.yAxis && !d[0].series.yAxis.options.reversedStacks && (d = d.slice().reverse()), this.followPointer && i) i.chartX === void 0 && (i = k.normalize(i)), g = [i.chartX - D, i.chartY - P];
            else if (d[0].tooltipPos) g = d[0].tooltipPos;
            else {
              let H = 0, G = 0;
              d.forEach(function(V) {
                let F = V.pos(!0);
                F && (H += F[0], G += F[1]);
              }), H /= d.length, G /= d.length, this.shared && d.length > 1 && i && (j ? H = i.chartX : G = i.chartY), g = [H - D, G - P];
            }
            return g.map(Math.round);
          }
          getClassName(d, i, g) {
            let m = this.options, k = d.series, j = k.options;
            return [m.className, "highcharts-label", g && "highcharts-tooltip-header", i ? "highcharts-tooltip-box" : "highcharts-tooltip", !g && "highcharts-color-" + p(d.colorIndex, k.colorIndex), j && j.className].filter(E).join(" ");
          }
          getLabel({ anchorX: d, anchorY: i } = { anchorX: 0, anchorY: 0 }) {
            let g = this, m = this.chart.styledMode, k = this.options, j = this.split && this.allowShared, P = this.container, D = this.chart.renderer;
            if (this.label) {
              let H = !this.label.hasClass("highcharts-label");
              (!j && H || j && !H) && this.destroy();
            }
            if (!this.label) {
              if (this.outside) {
                let H = this.chart.options.chart.style, G = z.getRendererType();
                this.container = P = I.doc.createElement("div"), P.className = "highcharts-tooltip-container", f(P, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (H && H.zIndex || 0) + 3) }), this.renderer = D = new G(P, 0, 0, H, void 0, void 0, D.styledMode);
              }
              if (j ? this.label = D.g("tooltip") : (this.label = D.label("", d, i, k.shape, void 0, void 0, k.useHTML, void 0, "tooltip").attr({ padding: k.padding, r: k.borderRadius }), m || this.label.attr({ fill: k.backgroundColor, "stroke-width": k.borderWidth || 0 }).css(k.style).css({ pointerEvents: k.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), g.outside) {
                let H = this.label;
                [H.xSetter, H.ySetter].forEach((G, V) => {
                  H[V ? "ySetter" : "xSetter"] = (F) => {
                    G.call(H, g.distance), H[V ? "y" : "x"] = F, P && (P.style[V ? "top" : "left"] = `${F}px`);
                  };
                });
              }
              this.label.attr({ zIndex: 8 }).shadow(k.shadow).add();
            }
            return P && !P.parentElement && I.doc.body.appendChild(P), this.label;
          }
          getPlayingField() {
            let { body: d, documentElement: i } = l, { chart: g, distance: m, outside: k } = this;
            return { width: k ? Math.max(d.scrollWidth, i.scrollWidth, d.offsetWidth, i.offsetWidth, i.clientWidth) - 2 * m : g.chartWidth, height: k ? Math.max(d.scrollHeight, i.scrollHeight, d.offsetHeight, i.offsetHeight, i.clientHeight) : g.chartHeight };
          }
          getPosition(d, i, g) {
            var ht, ct;
            let { distance: m, chart: k, outside: j, pointer: P } = this, { inverted: D, plotLeft: H, plotTop: G, polar: V } = k, { plotX: F = 0, plotY: U = 0 } = g, Y = {}, q = D && g.h || 0, { height: N, width: X } = this.getPlayingField(), W = P.getChartPosition(), _ = (dt) => dt * W.scaleX, K = (dt) => dt * W.scaleY, J = (dt) => {
              let ut = dt === "x";
              return [dt, ut ? X : N, ut ? d : i].concat(j ? [ut ? _(d) : K(i), ut ? W.left - m + _(F + H) : W.top - m + K(U + G), 0, ut ? X : N] : [ut ? d : i, ut ? F + H : U + G, ut ? H : G, ut ? H + k.plotWidth : G + k.plotHeight]);
            }, $ = J("y"), et = J("x"), st, at = !!g.negative;
            !V && ((ct = (ht = k.hoverSeries) == null ? void 0 : ht.yAxis) != null && ct.reversed) && (at = !at);
            let lt = !this.followPointer && p(g.ttBelow, !V && !D === at), it = function(dt, ut, pt, gt, ft, mt, yt) {
              let xt = j ? dt === "y" ? K(m) : _(m) : m, bt = (pt - gt) / 2, vt = gt < ft - m, Ct = ft + m + gt < ut, At = ft - xt - pt + bt, Mt = ft + xt - bt;
              if (lt && Ct) Y[dt] = Mt;
              else if (!lt && vt) Y[dt] = At;
              else if (vt) Y[dt] = Math.min(yt - gt, At - q < 0 ? At : At - q);
              else {
                if (!Ct) return !1;
                Y[dt] = Math.max(mt, Mt + q + pt > ut ? Mt : Mt + q);
              }
            }, Q = function(dt, ut, pt, gt, ft) {
              if (ft < m || ft > ut - m) return !1;
              ft < pt / 2 ? Y[dt] = 1 : ft > ut - gt / 2 ? Y[dt] = ut - gt - 2 : Y[dt] = ft - pt / 2;
            }, ot = function(dt) {
              [$, et] = [et, $], st = dt;
            }, nt = () => {
              it.apply(0, $) !== !1 ? Q.apply(0, et) !== !1 || st || (ot(!0), nt()) : st ? Y.x = Y.y = 0 : (ot(!0), nt());
            };
            return (D && !V || this.len > 1) && ot(), nt(), Y;
          }
          hide(d) {
            let i = this;
            O.clearTimeout(this.hideTimer), d = p(d, this.options.hideDelay), this.isHidden || (this.hideTimer = t(function() {
              let g = i.getLabel();
              i.getLabel().animate({ opacity: 0 }, { duration: d && 150, complete: () => {
                g.hide(), i.container && i.container.remove();
              } }), i.isHidden = !0;
            }, d));
          }
          init(d, i) {
            this.chart = d, this.options = i, this.crosshairs = [], this.isHidden = !0, this.split = i.split && !d.inverted && !d.polar, this.shared = i.shared || this.split, this.outside = p(i.outside, !!(d.scrollablePixelsX || d.scrollablePixelsY));
          }
          shouldStickOnContact(d) {
            return !!(!this.followPointer && this.options.stickOnContact && (!d || this.pointer.inClass(d.target, "highcharts-tooltip")));
          }
          move(d, i, g, m) {
            let k = this, j = M(!k.isHidden && k.options.animation), P = k.followPointer || (k.len || 0) > 1, D = { x: d, y: i };
            P || (D.anchorX = g, D.anchorY = m), j.step = () => k.drawTracker(), k.getLabel().animate(D, j);
          }
          refresh(d, i) {
            let { chart: g, options: m, pointer: k, shared: j } = this, P = o(d), D = P[0], H = [], G = m.format, V = m.formatter || this.defaultFormatter, F = g.styledMode, U = {}, Y = this.allowShared;
            if (!m.enabled || !D.series) return;
            O.clearTimeout(this.hideTimer), this.allowShared = !(!x(d) && d.series && d.series.noSharedTooltip), Y = Y && !this.allowShared, this.followPointer = !this.split && D.series.tooltipOptions.followPointer;
            let q = this.getAnchor(d, i), N = q[0], X = q[1];
            j && this.allowShared ? (k.applyInactiveState(P), P.forEach(function(K) {
              K.setState("hover"), H.push(K.getLabelConfig());
            }), (U = D.getLabelConfig()).points = H) : U = D.getLabelConfig(), this.len = H.length;
            let W = E(G) ? w(G, U, g) : V.call(U, this), _ = D.series;
            if (this.distance = p(_.tooltipOptions.distance, 16), W === !1) this.hide();
            else {
              if (this.split && this.allowShared) this.renderSplit(W, P);
              else {
                let K = N, J = X;
                if (i && k.isDirectTouch && (K = i.chartX - g.plotLeft, J = i.chartY - g.plotTop), g.polar || _.options.clip === !1 || P.some(($) => k.isDirectTouch || $.series.shouldShowTooltip(K, J))) {
                  let $ = this.getLabel(Y && this.tt || {});
                  (!m.style.width || F) && $.css({ width: (this.outside ? this.getPlayingField() : g.spacingBox).width + "px" }), $.attr({ class: this.getClassName(D), text: W && W.join ? W.join("") : W }), this.outside && $.attr({ x: s($.x || 0, 0, this.getPlayingField().width - ($.width || 0)) }), F || $.attr({ stroke: m.borderColor || D.color || _.color || "#666666" }), this.updatePosition({ plotX: N, plotY: X, negative: D.negative, ttBelow: D.ttBelow, h: q[2] || 0 });
                } else {
                  this.hide();
                  return;
                }
              }
              this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
            }
            a(this, "refresh");
          }
          renderSplit(d, i) {
            var ut;
            let g = this, { chart: m, chart: { chartWidth: k, chartHeight: j, plotHeight: P, plotLeft: D, plotTop: H, scrollablePixelsY: G = 0, scrollablePixelsX: V, styledMode: F }, distance: U, options: Y, options: { positioner: q }, pointer: N } = g, { scrollLeft: X = 0, scrollTop: W = 0 } = ((ut = m.scrollablePlotArea) == null ? void 0 : ut.scrollingContainer) || {}, _ = g.outside && typeof V != "number" ? l.documentElement.getBoundingClientRect() : { left: X, right: X + k, top: W, bottom: W + j }, K = g.getLabel(), J = this.renderer || m.renderer, $ = !!(m.xAxis[0] && m.xAxis[0].opposite), { left: et, top: st } = N.getChartPosition(), at = H + W, lt = 0, it = P - G;
            function Q(pt, gt, ft, mt, yt = !0) {
              let xt, bt;
              return ft ? (xt = $ ? 0 : it, bt = s(pt - mt / 2, _.left, _.right - mt - (g.outside ? et : 0))) : (xt = gt - at, bt = s(bt = yt ? pt - mt - U : pt + U, yt ? bt : _.left, _.right)), { x: bt, y: xt };
            }
            E(d) && (d = [!1, d]);
            let ot = d.slice(0, i.length + 1).reduce(function(pt, gt, ft) {
              if (gt !== !1 && gt !== "") {
                let mt = i[ft - 1] || { isHeader: !0, plotX: i[0].plotX, plotY: P, series: {} }, yt = mt.isHeader, xt = yt ? g : mt.series, bt = xt.tt = function(kt, Pt, jt) {
                  let Lt = kt, { isHeader: Bt, series: Yt } = Pt;
                  if (!Lt) {
                    let Ut = { padding: Y.padding, r: Y.borderRadius };
                    F || (Ut.fill = Y.backgroundColor, Ut["stroke-width"] = Y.borderWidth ?? 1), Lt = J.label("", 0, 0, Y[Bt ? "headerShape" : "shape"], void 0, void 0, Y.useHTML).addClass(g.getClassName(Pt, !0, Bt)).attr(Ut).add(K);
                  }
                  return Lt.isActive = !0, Lt.attr({ text: jt }), F || Lt.css(Y.style).attr({ stroke: Y.borderColor || Pt.color || Yt.color || "#333333" }), Lt;
                }(xt.tt, mt, gt.toString()), vt = bt.getBBox(), Ct = vt.width + bt.strokeWidth();
                yt && (lt = vt.height, it += lt, $ && (at -= lt));
                let { anchorX: At, anchorY: Mt } = function(kt) {
                  let Pt, jt, { isHeader: Lt, plotX: Bt = 0, plotY: Yt = 0, series: Ut } = kt;
                  if (Lt) Pt = Math.max(D + Bt, D), jt = H + P / 2;
                  else {
                    let { xAxis: Kt, yAxis: Dt } = Ut;
                    Pt = Kt.pos + s(Bt, -U, Kt.len + U), Ut.shouldShowTooltip(0, Dt.pos - H + Yt, { ignoreX: !0 }) && (jt = Dt.pos + Yt);
                  }
                  return { anchorX: Pt = s(Pt, _.left - U, _.right + U), anchorY: jt };
                }(mt);
                if (typeof Mt == "number") {
                  let kt = vt.height + 1, Pt = q ? q.call(g, Ct, kt, mt) : Q(At, Mt, yt, Ct);
                  pt.push({ align: q ? 0 : void 0, anchorX: At, anchorY: Mt, boxWidth: Ct, point: mt, rank: p(Pt.rank, yt ? 1 : 0), size: kt, target: Pt.y, tt: bt, x: Pt.x });
                } else bt.isActive = !1;
              }
              return pt;
            }, []);
            !q && ot.some((pt) => {
              let { outside: gt } = g, ft = (gt ? et : 0) + pt.anchorX;
              return ft < _.left && ft + pt.boxWidth < _.right || ft < et - _.left + pt.boxWidth && _.right - ft > ft;
            }) && (ot = ot.map((pt) => {
              let { x: gt, y: ft } = Q(pt.anchorX, pt.anchorY, pt.point.isHeader, pt.boxWidth, !1);
              return h(pt, { target: ft, x: gt });
            })), g.cleanSplit(), c(ot, it);
            let nt = { left: et, right: et };
            ot.forEach(function(pt) {
              let { x: gt, boxWidth: ft, isHeader: mt } = pt;
              !mt && (g.outside && et + gt < nt.left && (nt.left = et + gt), !mt && g.outside && nt.left + ft > nt.right && (nt.right = et + gt));
            }), ot.forEach(function(pt) {
              let { x: gt, anchorX: ft, anchorY: mt, pos: yt, point: { isHeader: xt } } = pt, bt = { visibility: yt === void 0 ? "hidden" : "inherit", x: gt, y: (yt || 0) + at, anchorX: ft, anchorY: mt };
              if (g.outside && gt < ft) {
                let vt = et - nt.left;
                vt > 0 && (xt || (bt.x = gt + vt, bt.anchorX = ft + vt), xt && (bt.x = (nt.right - nt.left) / 2, bt.anchorX = ft + vt));
              }
              pt.tt.attr(bt);
            });
            let { container: ht, outside: ct, renderer: dt } = g;
            if (ct && ht && dt) {
              let { width: pt, height: gt, x: ft, y: mt } = K.getBBox();
              dt.setSize(pt + ft, gt + mt, !1), ht.style.left = nt.left + "px", ht.style.top = st + "px";
            }
            u && K.attr({ opacity: K.opacity === 1 ? 0.999 : 1 });
          }
          drawTracker() {
            if (!this.shouldStickOnContact()) {
              this.tracker && (this.tracker = this.tracker.destroy());
              return;
            }
            let d = this.chart, i = this.label, g = this.shared ? d.hoverPoints : d.hoverPoint;
            if (!i || !g) return;
            let m = { x: 0, y: 0, width: 0, height: 0 }, k = this.getAnchor(g), j = i.getBBox();
            k[0] += d.plotLeft - (i.translateX || 0), k[1] += d.plotTop - (i.translateY || 0), m.x = Math.min(0, k[0]), m.y = Math.min(0, k[1]), m.width = k[0] < 0 ? Math.max(Math.abs(k[0]), j.width - k[0]) : Math.max(Math.abs(k[0]), j.width), m.height = k[1] < 0 ? Math.max(Math.abs(k[1]), j.height - Math.abs(k[1])) : Math.max(Math.abs(k[1]), j.height), this.tracker ? this.tracker.attr(m) : (this.tracker = i.renderer.rect(m).addClass("highcharts-tracker").add(i), d.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
          }
          styledModeFormat(d) {
            return d.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
          }
          tooltipFooterHeaderFormatter(d, i) {
            let g = d.series, m = g.tooltipOptions, k = g.xAxis, j = k && k.dateTime, P = { isFooter: i, labelConfig: d }, D = m.xDateFormat, H = m[i ? "footerFormat" : "headerFormat"];
            return a(this, "headerFormatter", P, function(G) {
              j && !D && S(d.key) && (D = j.getXDateFormat(d.key, m.dateTimeLabelFormats)), j && D && (d.point && d.point.tooltipDateKeys || ["key"]).forEach(function(V) {
                H = H.replace("{point." + V + "}", "{point." + V + ":" + D + "}");
              }), g.chart.styledMode && (H = this.styledModeFormat(H)), G.text = w(H, { point: d, series: g }, this.chart);
            }), P.text;
          }
          update(d) {
            this.destroy(), this.init(this.chart, b(!0, this.options, d));
          }
          updatePosition(d) {
            let { chart: i, container: g, distance: m, options: k, pointer: j, renderer: P } = this, { height: D = 0, width: H = 0 } = this.getLabel(), { left: G, top: V, scaleX: F, scaleY: U } = j.getChartPosition(), Y = (k.positioner || this.getPosition).call(this, H, D, d), q = (d.plotX || 0) + i.plotLeft, N = (d.plotY || 0) + i.plotTop, X;
            P && g && (k.positioner && (Y.x += G - m, Y.y += V - m), X = (k.borderWidth || 0) + 2 * m + 2, P.setSize(H + X, D + X, !1), (F !== 1 || U !== 1) && (f(g, { transform: `scale(${F}, ${U})` }), q *= F, N *= U), q += G - Y.x, N += V - Y.y), this.move(Math.round(Y.x), Math.round(Y.y || 0), q, N);
          }
        }
        return (L = e).compose = function(n) {
          C(A, "Core.Tooltip") && v(n, "afterInit", function() {
            let d = this.chart;
            d.options.tooltip && (d.tooltip = new L(d, d.options.tooltip, this));
          });
        }, e;
      }), Z(r, "Core/Series/Point.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Animation/AnimationUtilities.js"], r["Core/Defaults.js"], r["Core/Templating.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { animObject: O } = B, { defaultOptions: L } = I, { format: M } = R, { addEvent: w, crisp: A, erase: l, extend: u, fireEvent: c, getNestedProperty: v, isArray: s, isFunction: f, isNumber: y, isObject: h, merge: a, pick: x, syncTimeout: S, removeEvent: E, uniqueKey: b } = z;
        class p {
          animateBeforeDestroy() {
            let o = this, t = { x: o.startXPos, opacity: 0 }, e = o.getGraphicalProps();
            e.singular.forEach(function(n) {
              o[n] = o[n].animate(n === "dataLabel" ? { x: o[n].startXPos, y: o[n].startYPos, opacity: 0 } : t);
            }), e.plural.forEach(function(n) {
              o[n].forEach(function(d) {
                d.element && d.animate(u({ x: o.startXPos }, d.startYPos ? { x: d.startXPos, y: d.startYPos } : {}));
              });
            });
          }
          applyOptions(o, t) {
            let e = this.series, n = e.options.pointValKey || e.pointValKey;
            return u(this, o = p.prototype.optionsToObject.call(this, o)), this.options = this.options ? u(this.options, o) : o, o.group && delete this.group, o.dataLabels && delete this.dataLabels, n && (this.y = p.prototype.getNestedProperty.call(this, n)), this.selected && (this.state = "select"), "name" in this && t === void 0 && e.xAxis && e.xAxis.hasNames && (this.x = e.xAxis.nameToX(this)), this.x === void 0 && e ? this.x = t ?? e.autoIncrement() : y(o.x) && e.options.relativeXValue && (this.x = e.autoIncrement(o.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
          }
          destroy() {
            if (!this.destroyed) {
              let o = this, t = o.series, e = t.chart, n = t.options.dataSorting, d = e.hoverPoints, i = O(o.series.chart.renderer.globalAnimation), g = () => {
                for (let m in (o.graphic || o.graphics || o.dataLabel || o.dataLabels) && (E(o), o.destroyElements()), o) delete o[m];
              };
              o.legendItem && e.legend.destroyItem(o), d && (o.setState(), l(d, o), d.length || (e.hoverPoints = null)), o === e.hoverPoint && o.onMouseOut(), n && n.enabled ? (this.animateBeforeDestroy(), S(g, i.duration)) : g(), e.pointCount--;
            }
            this.destroyed = !0;
          }
          destroyElements(o) {
            let t = this, e = t.getGraphicalProps(o);
            e.singular.forEach(function(n) {
              t[n] = t[n].destroy();
            }), e.plural.forEach(function(n) {
              t[n].forEach(function(d) {
                d && d.element && d.destroy();
              }), delete t[n];
            });
          }
          firePointEvent(o, t, e) {
            let n = this, d = this.series.options;
            n.manageEvent(o), o === "click" && d.allowPointSelect && (e = function(i) {
              !n.destroyed && n.select && n.select(null, i.ctrlKey || i.metaKey || i.shiftKey);
            }), c(n, o, t, e);
          }
          getClassName() {
            return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
          }
          getGraphicalProps(o) {
            let t, e, n = this, d = [], i = { singular: [], plural: [] };
            for ((o = o || { graphic: 1, dataLabel: 1 }).graphic && d.push("graphic", "connector"), o.dataLabel && d.push("dataLabel", "dataLabelPath", "dataLabelUpper"), e = d.length; e--; ) n[t = d[e]] && i.singular.push(t);
            return ["graphic", "dataLabel"].forEach(function(g) {
              let m = g + "s";
              o[g] && n[m] && i.plural.push(m);
            }), i;
          }
          getLabelConfig() {
            return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
          }
          getNestedProperty(o) {
            return o ? o.indexOf("custom.") === 0 ? v(o, this.options) : this[o] : void 0;
          }
          getZone() {
            let o = this.series, t = o.zones, e = o.zoneAxis || "y", n, d = 0;
            for (n = t[0]; this[e] >= n.value; ) n = t[++d];
            return this.nonZonedColor || (this.nonZonedColor = this.color), n && n.color && !this.options.color ? this.color = n.color : this.color = this.nonZonedColor, n;
          }
          hasNewShapeType() {
            return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
          }
          constructor(o, t, e) {
            this.formatPrefix = "point", this.visible = !0, this.series = o, this.applyOptions(t, e), this.id ?? (this.id = b()), this.resolveColor(), o.chart.pointCount++, c(this, "afterInit");
          }
          isValid() {
            return (y(this.x) || this.x instanceof Date) && y(this.y);
          }
          optionsToObject(o) {
            let t = this.series, e = t.options.keys, n = e || t.pointArrayMap || ["y"], d = n.length, i = {}, g, m = 0, k = 0;
            if (y(o) || o === null) i[n[0]] = o;
            else if (s(o)) for (!e && o.length > d && ((g = typeof o[0]) == "string" ? i.name = o[0] : g === "number" && (i.x = o[0]), m++); k < d; ) e && o[m] === void 0 || (n[k].indexOf(".") > 0 ? p.prototype.setNestedProperty(i, o[m], n[k]) : i[n[k]] = o[m]), m++, k++;
            else typeof o == "object" && (i = o, o.dataLabels && (t.hasDataLabels = () => !0), o.marker && (t._hasPointMarkers = !0));
            return i;
          }
          pos(o, t = this.plotY) {
            if (!this.destroyed) {
              let { plotX: e, series: n } = this, { chart: d, xAxis: i, yAxis: g } = n, m = 0, k = 0;
              if (y(e) && y(t)) return o && (m = i ? i.pos : d.plotLeft, k = g ? g.pos : d.plotTop), d.inverted && i && g ? [g.len - t + k, i.len - e + m] : [e + m, t + k];
            }
          }
          resolveColor() {
            let o = this.series, t = o.chart.options.chart, e = o.chart.styledMode, n, d, i = t.colorCount, g;
            delete this.nonZonedColor, o.options.colorByPoint ? (e || (n = (d = o.options.colors || o.chart.options.colors)[o.colorCounter], i = d.length), g = o.colorCounter, o.colorCounter++, o.colorCounter === i && (o.colorCounter = 0)) : (e || (n = o.color), g = o.colorIndex), this.colorIndex = x(this.options.colorIndex, g), this.color = x(this.options.color, n);
          }
          setNestedProperty(o, t, e) {
            return e.split(".").reduce(function(n, d, i, g) {
              let m = g.length - 1 === i;
              return n[d] = m ? t : h(n[d], !0) ? n[d] : {}, n[d];
            }, o), o;
          }
          shouldDraw() {
            return !this.isNull;
          }
          tooltipFormatter(o) {
            let t = this.series, e = t.tooltipOptions, n = x(e.valueDecimals, ""), d = e.valuePrefix || "", i = e.valueSuffix || "";
            return t.chart.styledMode && (o = t.chart.tooltip.styledModeFormat(o)), (t.pointArrayMap || ["y"]).forEach(function(g) {
              g = "{point." + g, (d || i) && (o = o.replace(RegExp(g + "}", "g"), d + g + "}" + i)), o = o.replace(RegExp(g + "}", "g"), g + ":,." + n + "f}");
            }), M(o, { point: this, series: this.series }, t.chart);
          }
          update(o, t, e, n) {
            let d, i = this, g = i.series, m = i.graphic, k = g.chart, j = g.options;
            function P() {
              i.applyOptions(o);
              let D = m && i.hasMockGraphic, H = i.y === null ? !D : D;
              m && H && (i.graphic = m.destroy(), delete i.hasMockGraphic), h(o, !0) && (m && m.element && o && o.marker && o.marker.symbol !== void 0 && (i.graphic = m.destroy()), o != null && o.dataLabels && i.dataLabel && (i.dataLabel = i.dataLabel.destroy())), d = i.index, g.updateParallelArrays(i, d), j.data[d] = h(j.data[d], !0) || h(o, !0) ? i.options : x(o, j.data[d]), g.isDirty = g.isDirtyData = !0, !g.fixedBox && g.hasCartesianSeries && (k.isDirtyBox = !0), j.legendType === "point" && (k.isDirtyLegend = !0), t && k.redraw(e);
            }
            t = x(t, !0), n === !1 ? P() : i.firePointEvent("update", { options: o }, P);
          }
          remove(o, t) {
            this.series.removePoint(this.series.data.indexOf(this), o, t);
          }
          select(o, t) {
            let e = this, n = e.series, d = n.chart;
            o = x(o, !e.selected), this.selectedStaging = o, e.firePointEvent(o ? "select" : "unselect", { accumulate: t }, function() {
              e.selected = e.options.selected = o, n.options.data[n.data.indexOf(e)] = e.options, e.setState(o && "select"), t || d.getSelectedPoints().forEach(function(i) {
                let g = i.series;
                i.selected && i !== e && (i.selected = i.options.selected = !1, g.options.data[g.data.indexOf(i)] = i.options, i.setState(d.hoverPoints && g.options.inactiveOtherPoints ? "inactive" : ""), i.firePointEvent("unselect"));
              });
            }), delete this.selectedStaging;
          }
          onMouseOver(o) {
            let { inverted: t, pointer: e } = this.series.chart;
            e && (o = o ? e.normalize(o) : e.getChartCoordinatesFromPoint(this, t), e.runPointActions(o, this));
          }
          onMouseOut() {
            let o = this.series.chart;
            this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (o.hoverPoints || []).forEach(function(t) {
              t.setState();
            }), o.hoverPoints = o.hoverPoint = null;
          }
          manageEvent(o) {
            var n, d, i, g, m, k;
            let t = a(this.series.options.point, this.options), e = (n = t.events) == null ? void 0 : n[o];
            f(e) && (!((d = this.hcEvents) != null && d[o]) || ((g = (i = this.hcEvents) == null ? void 0 : i[o]) == null ? void 0 : g.map((j) => j.fn).indexOf(e)) === -1) ? ((m = this.importedUserEvent) == null || m.call(this), this.importedUserEvent = w(this, o, e)) : this.importedUserEvent && !e && ((k = this.hcEvents) != null && k[o]) && (E(this, o), delete this.hcEvents[o], Object.keys(this.hcEvents) || delete this.importedUserEvent);
          }
          setState(o, t) {
            var W;
            let e = this.series, n = this.state, d = e.options.states[o || "normal"] || {}, i = L.plotOptions[e.type].marker && e.options.marker, g = i && i.enabled === !1, m = i && i.states && i.states[o || "normal"] || {}, k = m.enabled === !1, j = this.marker || {}, P = e.chart, D = i && e.markerAttribs, H = e.halo, G, V, F, U = e.stateMarkerGraphic, Y;
            if ((o = o || "") === this.state && !t || this.selected && o !== "select" || d.enabled === !1 || o && (k || g && m.enabled === !1) || o && j.states && j.states[o] && j.states[o].enabled === !1) return;
            if (this.state = o, D && (G = e.markerAttribs(this, o)), this.graphic && !this.hasMockGraphic) {
              if (n && this.graphic.removeClass("highcharts-point-" + n), o && this.graphic.addClass("highcharts-point-" + o), !P.styledMode) {
                V = e.pointAttribs(this, o), F = x(P.options.chart.animation, d.animation);
                let _ = V.opacity;
                e.options.inactiveOtherPoints && y(_) && (this.dataLabels || []).forEach(function(K) {
                  K && !K.hasClass("highcharts-data-label-hidden") && (K.animate({ opacity: _ }, F), K.connector && K.connector.animate({ opacity: _ }, F));
                }), this.graphic.animate(V, F);
              }
              G && this.graphic.animate(G, x(P.options.chart.animation, m.animation, i.animation)), U && U.hide();
            } else o && m && (Y = j.symbol || e.symbol, U && U.currentSymbol !== Y && (U = U.destroy()), G && (U ? U[t ? "animate" : "attr"]({ x: G.x, y: G.y }) : Y && (e.stateMarkerGraphic = U = P.renderer.symbol(Y, G.x, G.y, G.width, G.height).add(e.markerGroup), U.currentSymbol = Y)), !P.styledMode && U && this.state !== "inactive" && U.attr(e.pointAttribs(this, o))), U && (U[o && this.isInside ? "show" : "hide"](), U.element.point = this, U.addClass(this.getClassName(), !0));
            let q = d.halo, N = this.graphic || U, X = N && N.visibility || "inherit";
            q && q.size && N && X !== "hidden" && !this.isCluster ? (H || (e.halo = H = P.renderer.path().add(N.parentGroup)), H.show()[t ? "animate" : "attr"]({ d: this.haloPath(q.size) }), H.attr({ class: "highcharts-halo highcharts-color-" + x(this.colorIndex, e.colorIndex) + (this.className ? " " + this.className : ""), visibility: X, zIndex: -1 }), H.point = this, P.styledMode || H.attr(u({ fill: this.color || e.color, "fill-opacity": q.opacity }, T.filterUserAttributes(q.attributes || {})))) : (W = H == null ? void 0 : H.point) != null && W.haloPath && !H.point.destroyed && H.animate({ d: H.point.haloPath(0) }, null, H.hide), c(this, "afterSetState", { state: o });
          }
          haloPath(o) {
            let t = this.pos();
            return t ? this.series.chart.renderer.symbols.circle(A(t[0], 1) - o, t[1] - o, 2 * o, 2 * o) : [];
          }
        }
        return p;
      }), Z(r, "Core/Pointer.js", [r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { parse: z } = T, { charts: O, composed: L, isTouchDevice: M } = B, { addEvent: w, attr: A, css: l, extend: u, find: c, fireEvent: v, isNumber: s, isObject: f, objectEach: y, offset: h, pick: a, pushUnique: x, splat: S } = I;
        class E {
          applyInactiveState(p) {
            let C = [], o;
            (p || []).forEach(function(t) {
              o = t.series, C.push(o), o.linkedParent && C.push(o.linkedParent), o.linkedSeries && (C = C.concat(o.linkedSeries)), o.navigatorSeries && C.push(o.navigatorSeries);
            }), this.chart.series.forEach(function(t) {
              C.indexOf(t) === -1 ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
            });
          }
          destroy() {
            let p = this;
            this.eventsToUnbind.forEach((C) => C()), this.eventsToUnbind = [], !B.chartCount && (E.unbindDocumentMouseUp && E.unbindDocumentMouseUp.forEach((C) => C()), E.unbindDocumentTouchEnd && (E.unbindDocumentTouchEnd = E.unbindDocumentTouchEnd())), clearInterval(p.tooltipTimeout), y(p, function(C, o) {
              p[o] = void 0;
            });
          }
          getSelectionMarkerAttrs(p, C) {
            let o = { args: { chartX: p, chartY: C }, attrs: {}, shapeType: "rect" };
            return v(this, "getSelectionMarkerAttrs", o, (t) => {
              let e, { chart: n, zoomHor: d, zoomVert: i } = this, { mouseDownX: g = 0, mouseDownY: m = 0 } = n, k = t.attrs;
              k.x = n.plotLeft, k.y = n.plotTop, k.width = d ? 1 : n.plotWidth, k.height = i ? 1 : n.plotHeight, d && (e = p - g, k.width = Math.max(1, Math.abs(e)), k.x = (e > 0 ? 0 : e) + g), i && (e = C - m, k.height = Math.max(1, Math.abs(e)), k.y = (e > 0 ? 0 : e) + m);
            }), o;
          }
          drag(p) {
            let { chart: C } = this, { mouseDownX: o = 0, mouseDownY: t = 0 } = C, { panning: e, panKey: n, selectionMarkerFill: d } = C.options.chart, i = C.plotLeft, g = C.plotTop, m = C.plotWidth, k = C.plotHeight, j = f(e) ? e.enabled : e, P = n && p[`${n}Key`], D = p.chartX, H = p.chartY, G, V = this.selectionMarker;
            if ((!V || !V.touch) && (D < i ? D = i : D > i + m && (D = i + m), H < g ? H = g : H > g + k && (H = g + k), this.hasDragged = Math.sqrt(Math.pow(o - D, 2) + Math.pow(t - H, 2)), this.hasDragged > 10)) {
              G = C.isInsidePlot(o - i, t - g, { visiblePlotOnly: !0 });
              let { shapeType: F, attrs: U } = this.getSelectionMarkerAttrs(D, H);
              (C.hasCartesianSeries || C.mapView) && this.hasZoom && G && !P && !V && (this.selectionMarker = V = C.renderer[F](), V.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), C.styledMode || V.attr({ fill: d || z("#334eff").setOpacity(0.25).get() })), V && V.attr(U), G && !V && j && C.pan(p, e);
            }
          }
          dragStart(p) {
            let C = this.chart;
            C.mouseIsDown = p.type, C.cancelClick = !1, C.mouseDownX = p.chartX, C.mouseDownY = p.chartY;
          }
          getSelectionBox(p) {
            let C = { args: { marker: p }, result: p.getBBox() };
            return v(this, "getSelectionBox", C), C.result;
          }
          drop(p) {
            let C, { chart: o, selectionMarker: t } = this;
            for (let e of o.axes) e.isPanning && (e.isPanning = !1, (e.options.startOnTick || e.options.endOnTick || e.series.some((n) => n.boosted)) && (e.forceRedraw = !0, e.setExtremes(e.userMin, e.userMax, !1), C = !0));
            if (C && o.redraw(), t && p) {
              if (this.hasDragged) {
                let e = this.getSelectionBox(t);
                o.transform({ axes: o.axes.filter((n) => n.zoomEnabled && (n.coll === "xAxis" && this.zoomX || n.coll === "yAxis" && this.zoomY)), selection: { originalEvent: p, xAxis: [], yAxis: [], ...e }, from: e });
              }
              s(o.index) && (this.selectionMarker = t.destroy());
            }
            o && s(o.index) && (l(o.container, { cursor: o._cursor }), o.cancelClick = this.hasDragged > 10, o.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
          }
          findNearestKDPoint(p, C, o) {
            let t;
            return p.forEach(function(e) {
              let n = !(e.noSharedTooltip && C) && 0 > e.options.findNearestPointBy.indexOf("y"), d = e.searchPoint(o, n);
              f(d, !0) && d.series && (!f(t, !0) || function(i, g) {
                var P, D;
                let m = i.distX - g.distX, k = i.dist - g.dist, j = ((P = g.series.group) == null ? void 0 : P.zIndex) - ((D = i.series.group) == null ? void 0 : D.zIndex);
                return m !== 0 && C ? m : k !== 0 ? k : j !== 0 ? j : i.series.index > g.series.index ? -1 : 1;
              }(t, d) > 0) && (t = d);
            }), t;
          }
          getChartCoordinatesFromPoint(p, C) {
            let { xAxis: o, yAxis: t } = p.series, e = p.shapeArgs;
            if (o && t) {
              let n = p.clientX ?? p.plotX ?? 0, d = p.plotY || 0;
              return p.isNode && e && s(e.x) && s(e.y) && (n = e.x, d = e.y), C ? { chartX: t.len + t.pos - d, chartY: o.len + o.pos - n } : { chartX: n + o.pos, chartY: d + t.pos };
            }
            if (e && e.x && e.y) return { chartX: e.x, chartY: e.y };
          }
          getChartPosition() {
            if (this.chartPosition) return this.chartPosition;
            let { container: p } = this.chart, C = h(p);
            this.chartPosition = { left: C.left, top: C.top, scaleX: 1, scaleY: 1 };
            let { offsetHeight: o, offsetWidth: t } = p;
            return t > 2 && o > 2 && (this.chartPosition.scaleX = C.width / t, this.chartPosition.scaleY = C.height / o), this.chartPosition;
          }
          getCoordinates(p) {
            let C = { xAxis: [], yAxis: [] };
            for (let o of this.chart.axes) C[o.isXAxis ? "xAxis" : "yAxis"].push({ axis: o, value: o.toValue(p[o.horiz ? "chartX" : "chartY"]) });
            return C;
          }
          getHoverData(p, C, o, t, e, n) {
            let d = [], i = function(P) {
              return P.visible && !(!e && P.directTouch) && a(P.options.enableMouseTracking, !0);
            }, g = C, m, k = { chartX: n ? n.chartX : void 0, chartY: n ? n.chartY : void 0, shared: e };
            v(this, "beforeGetHoverData", k), m = g && !g.stickyTracking ? [g] : o.filter((P) => P.stickyTracking && (k.filter || i)(P));
            let j = t && p || !n ? p : this.findNearestKDPoint(m, e, n);
            return g = j && j.series, j && (e && !g.noSharedTooltip ? (m = o.filter(function(P) {
              return k.filter ? k.filter(P) : i(P) && !P.noSharedTooltip;
            })).forEach(function(P) {
              let D = c(P.points, function(H) {
                return H.x === j.x && !H.isNull;
              });
              f(D) && (P.boosted && P.boost && (D = P.boost.getPoint(D)), d.push(D));
            }) : d.push(j)), v(this, "afterGetHoverData", k = { hoverPoint: j }), { hoverPoint: k.hoverPoint, hoverSeries: g, hoverPoints: d };
          }
          getPointFromEvent(p) {
            let C = p.target, o;
            for (; C && !o; ) o = C.point, C = C.parentNode;
            return o;
          }
          onTrackerMouseOut(p) {
            let C = this.chart, o = p.relatedTarget, t = C.hoverSeries;
            this.isDirectTouch = !1, !t || !o || t.stickyTracking || this.inClass(o, "highcharts-tooltip") || this.inClass(o, "highcharts-series-" + t.index) && this.inClass(o, "highcharts-tracker") || t.onMouseOut();
          }
          inClass(p, C) {
            let o = p, t;
            for (; o; ) {
              if (t = A(o, "class")) {
                if (t.indexOf(C) !== -1) return !0;
                if (t.indexOf("highcharts-container") !== -1) return !1;
              }
              o = o.parentElement;
            }
          }
          constructor(p, C) {
            var o;
            this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = C, this.chart = p, this.runChartClick = !!((o = C.chart.events) != null && o.click), this.pinchDown = [], this.setDOMEvents(), v(this, "afterInit");
          }
          normalize(p, C) {
            let o = p.touches, t = o ? o.length ? o.item(0) : a(o.changedTouches, p.changedTouches)[0] : p;
            C || (C = this.getChartPosition());
            let e = t.pageX - C.left, n = t.pageY - C.top;
            return u(p, { chartX: Math.round(e /= C.scaleX), chartY: Math.round(n /= C.scaleY) });
          }
          onContainerClick(p) {
            let C = this.chart, o = C.hoverPoint, t = this.normalize(p), e = C.plotLeft, n = C.plotTop;
            !C.cancelClick && (o && this.inClass(t.target, "highcharts-tracker") ? (v(o.series, "click", u(t, { point: o })), C.hoverPoint && o.firePointEvent("click", t)) : (u(t, this.getCoordinates(t)), C.isInsidePlot(t.chartX - e, t.chartY - n, { visiblePlotOnly: !0 }) && v(C, "click", t)));
          }
          onContainerMouseDown(p) {
            var o;
            let C = (1 & (p.buttons || p.button)) == 1;
            p = this.normalize(p), B.isFirefox && p.button !== 0 && this.onContainerMouseMove(p), (p.button === void 0 || C) && (this.zoomOption(p), C && ((o = p.preventDefault) == null || o.call(p)), this.dragStart(p));
          }
          onContainerMouseLeave(p) {
            let { pointer: C } = O[a(E.hoverChartIndex, -1)] || {};
            p = this.normalize(p), this.onContainerMouseMove(p), C && !this.inClass(p.relatedTarget, "highcharts-tooltip") && (C.reset(), C.chartPosition = void 0);
          }
          onContainerMouseEnter() {
            delete this.chartPosition;
          }
          onContainerMouseMove(p) {
            let C = this.chart, o = C.tooltip, t = this.normalize(p);
            this.setHoverChartIndex(p), (C.mouseIsDown === "mousedown" || this.touchSelect(t)) && this.drag(t), !C.openMenu && (this.inClass(t.target, "highcharts-tracker") || C.isInsidePlot(t.chartX - C.plotLeft, t.chartY - C.plotTop, { visiblePlotOnly: !0 })) && !(o && o.shouldStickOnContact(t)) && (this.inClass(t.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(t));
          }
          onDocumentTouchEnd(p) {
            this.onDocumentMouseUp(p);
          }
          onContainerTouchMove(p) {
            this.touchSelect(p) ? this.onContainerMouseMove(p) : this.touch(p);
          }
          onContainerTouchStart(p) {
            this.touchSelect(p) ? this.onContainerMouseDown(p) : (this.zoomOption(p), this.touch(p, !0));
          }
          onDocumentMouseMove(p) {
            let C = this.chart, o = C.tooltip, t = this.chartPosition, e = this.normalize(p, t);
            !t || C.isInsidePlot(e.chartX - C.plotLeft, e.chartY - C.plotTop, { visiblePlotOnly: !0 }) || o && o.shouldStickOnContact(e) || e.target !== C.container.ownerDocument && this.inClass(e.target, "highcharts-tracker") || this.reset();
          }
          onDocumentMouseUp(p) {
            var C, o;
            (o = (C = O[a(E.hoverChartIndex, -1)]) == null ? void 0 : C.pointer) == null || o.drop(p);
          }
          pinch(p) {
            let C = this, { chart: o, hasZoom: t, lastTouches: e } = C, n = [].map.call(p.touches || [], (k) => C.normalize(k)), d = n.length, i = d === 1 && (C.inClass(p.target, "highcharts-tracker") && o.runTrackerClick || C.runChartClick), g = o.tooltip, m = d === 1 && a(g == null ? void 0 : g.options.followTouchMove, !0);
            d > 1 ? C.initiated = !0 : m && (C.initiated = !1), t && C.initiated && !i && p.cancelable !== !1 && p.preventDefault(), p.type === "touchstart" ? (C.pinchDown = n, C.res = !0, o.mouseDownX = p.chartX) : m ? this.runPointActions(C.normalize(p)) : e && (v(o, "touchpan", { originalEvent: p, touches: n }, () => {
              let k = (j) => {
                let P = j[0], D = j[1] || P;
                return { x: P.chartX, y: P.chartY, width: D.chartX - P.chartX, height: D.chartY - P.chartY };
              };
              o.transform({ axes: o.axes.filter((j) => j.zoomEnabled && (this.zoomHor && j.horiz || this.zoomVert && !j.horiz)), to: k(n), from: k(e), trigger: p.type });
            }), C.res && (C.res = !1, this.reset(!1, 0))), C.lastTouches = n;
          }
          reset(p, C) {
            let o = this.chart, t = o.hoverSeries, e = o.hoverPoint, n = o.hoverPoints, d = o.tooltip, i = d && d.shared ? n : e;
            p && i && S(i).forEach(function(g) {
              g.series.isCartesian && g.plotX === void 0 && (p = !1);
            }), p ? d && i && S(i).length && (d.refresh(i), d.shared && n ? n.forEach(function(g) {
              g.setState(g.state, !0), g.series.isCartesian && (g.series.xAxis.crosshair && g.series.xAxis.drawCrosshair(null, g), g.series.yAxis.crosshair && g.series.yAxis.drawCrosshair(null, g));
            }) : e && (e.setState(e.state, !0), o.axes.forEach(function(g) {
              g.crosshair && e.series[g.coll] === g && g.drawCrosshair(null, e);
            }))) : (e && e.onMouseOut(), n && n.forEach(function(g) {
              g.setState();
            }), t && t.onMouseOut(), d && d.hide(C), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), o.axes.forEach(function(g) {
              g.hideCrosshair();
            }), o.hoverPoints = o.hoverPoint = void 0);
          }
          runPointActions(p, C, o) {
            let t = this.chart, e = t.series, n = t.tooltip && t.tooltip.options.enabled ? t.tooltip : void 0, d = !!n && n.shared, i = C || t.hoverPoint, g = i && i.series || t.hoverSeries, m = (!p || p.type !== "touchmove") && (!!C || g && g.directTouch && this.isDirectTouch), k = this.getHoverData(i, g, e, m, d, p);
            i = k.hoverPoint, g = k.hoverSeries;
            let j = k.hoverPoints, P = g && g.tooltipOptions.followPointer && !g.tooltipOptions.split, D = d && g && !g.noSharedTooltip;
            if (i && (o || i !== t.hoverPoint || n && n.isHidden)) {
              if ((t.hoverPoints || []).forEach(function(H) {
                j.indexOf(H) === -1 && H.setState();
              }), t.hoverSeries !== g && g.onMouseOver(), this.applyInactiveState(j), (j || []).forEach(function(H) {
                H.setState("hover");
              }), t.hoverPoint && t.hoverPoint.firePointEvent("mouseOut"), !i.series) return;
              t.hoverPoints = j, t.hoverPoint = i, i.firePointEvent("mouseOver", void 0, () => {
                n && i && n.refresh(D ? j : i, p);
              });
            } else if (P && n && !n.isHidden) {
              let H = n.getAnchor([{}], p);
              t.isInsidePlot(H[0], H[1], { visiblePlotOnly: !0 }) && n.updatePosition({ plotX: H[0], plotY: H[1] });
            }
            this.unDocMouseMove || (this.unDocMouseMove = w(t.container.ownerDocument, "mousemove", (H) => {
              var G, V;
              return (V = (G = O[E.hoverChartIndex ?? -1]) == null ? void 0 : G.pointer) == null ? void 0 : V.onDocumentMouseMove(H);
            }), this.eventsToUnbind.push(this.unDocMouseMove)), t.axes.forEach(function(H) {
              let G, V = a((H.crosshair || {}).snap, !0);
              !V || (G = t.hoverPoint) && G.series[H.coll] === H || (G = c(j, (F) => F.series && F.series[H.coll] === H)), G || !V ? H.drawCrosshair(p, G) : H.hideCrosshair();
            });
          }
          setDOMEvents() {
            let p = this.chart.container, C = p.ownerDocument;
            p.onmousedown = this.onContainerMouseDown.bind(this), p.onmousemove = this.onContainerMouseMove.bind(this), p.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(w(p, "mouseenter", this.onContainerMouseEnter.bind(this)), w(p, "mouseleave", this.onContainerMouseLeave.bind(this))), E.unbindDocumentMouseUp || (E.unbindDocumentMouseUp = []), E.unbindDocumentMouseUp.push(w(C, "mouseup", this.onDocumentMouseUp.bind(this)));
            let o = this.chart.renderTo.parentElement;
            for (; o && o.tagName !== "BODY"; ) this.eventsToUnbind.push(w(o, "scroll", () => {
              delete this.chartPosition;
            })), o = o.parentElement;
            this.eventsToUnbind.push(w(p, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), w(p, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), E.unbindDocumentTouchEnd || (E.unbindDocumentTouchEnd = w(C, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), w(this.chart, "redraw", this.setPointerCapture.bind(this));
          }
          setPointerCapture() {
            var e, n;
            if (!M) return;
            let p = this.pointerCaptureEventsToUnbind, C = this.chart, o = C.container, t = a((e = C.options.tooltip) == null ? void 0 : e.followTouchMove, !0) && C.series.some((d) => d.options.findNearestPointBy.indexOf("y") > -1);
            !this.hasPointerCapture && t ? (p.push(w(o, "pointerdown", (d) => {
              var i, g;
              (i = d.target) != null && i.hasPointerCapture(d.pointerId) && ((g = d.target) == null || g.releasePointerCapture(d.pointerId));
            }), w(o, "pointermove", (d) => {
              var i, g;
              (g = (i = C.pointer) == null ? void 0 : i.getPointFromEvent(d)) == null || g.onMouseOver(d);
            })), C.styledMode || l(o, { "touch-action": "none" }), o.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !t && (p.forEach((d) => d()), p.length = 0, C.styledMode || l(o, { "touch-action": a((n = C.options.chart.style) == null ? void 0 : n["touch-action"], "manipulation") }), o.className = o.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
          }
          setHoverChartIndex(p) {
            var t;
            let C = this.chart, o = B.charts[a(E.hoverChartIndex, -1)];
            if (o && o !== C) {
              let e = { relatedTarget: C.container };
              p && !(p != null && p.relatedTarget) && (p = { ...e, ...p }), (t = o.pointer) == null || t.onContainerMouseLeave(p || e);
            }
            o && o.mouseIsDown || (E.hoverChartIndex = C.index);
          }
          touch(p, C) {
            let o, { chart: t, pinchDown: e = [] } = this;
            this.setHoverChartIndex(), (p = this.normalize(p)).touches.length === 1 ? t.isInsidePlot(p.chartX - t.plotLeft, p.chartY - t.plotTop, { visiblePlotOnly: !0 }) && !t.openMenu ? (C && this.runPointActions(p), p.type === "touchmove" && (o = !!e[0] && Math.pow(e[0].chartX - p.chartX, 2) + Math.pow(e[0].chartY - p.chartY, 2) >= 16), a(o, !0) && this.pinch(p)) : C && this.reset() : p.touches.length === 2 && this.pinch(p);
          }
          touchSelect(p) {
            return !!(this.chart.zooming.singleTouch && p.touches && p.touches.length === 1);
          }
          zoomOption(p) {
            let C = this.chart, o = C.inverted, t = C.zooming.type || "", e, n;
            /touch/.test(p.type) && (t = a(C.zooming.pinchType, t)), this.zoomX = e = /x/.test(t), this.zoomY = n = /y/.test(t), this.zoomHor = e && !o || n && o, this.zoomVert = n && !o || e && o, this.hasZoom = e || n;
          }
        }
        return (R = E).compose = function(b) {
          x(L, "Core.Pointer") && w(b, "beforeRender", function() {
            this.pointer = new R(this, this.options);
          });
        }, E;
      }), Z(r, "Core/Legend/LegendSymbol.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { extend: I, merge: R, pick: z } = T;
        return function(O) {
          function L(M, w, A) {
            var o, t;
            let l = this.legendItem = this.legendItem || {}, { chart: u, options: c } = this, { baseline: v = 0, symbolWidth: s, symbolHeight: f } = M, y = this.symbol || "circle", h = f / 2, a = u.renderer, x = l.group, S = v - Math.round((((o = M.fontMetrics) == null ? void 0 : o.b) || f) * (A ? 0.4 : 0.3)), E = {}, b, p = c.marker, C = 0;
            if (u.styledMode || (E["stroke-width"] = Math.min(c.lineWidth || 0, 24), c.dashStyle ? E.dashstyle = c.dashStyle : c.linecap === "square" || (E["stroke-linecap"] = "round")), l.line = a.path().addClass("highcharts-graph").attr(E).add(x), A && (l.area = a.path().addClass("highcharts-area").add(x)), E["stroke-linecap"] && (C = Math.min(l.line.strokeWidth(), s) / 2), s) {
              let e = [["M", C, S], ["L", s - C, S]];
              l.line.attr({ d: e }), (t = l.area) == null || t.attr({ d: [...e, ["L", s - C, v], ["L", C, v]] });
            }
            if (p && p.enabled !== !1 && s) {
              let e = Math.min(z(p.radius, h), h);
              y.indexOf("url") === 0 && (p = R(p, { width: f, height: f }), e = 0), l.symbol = b = a.symbol(y, s / 2 - e, S - e, 2 * e, 2 * e, I({ context: "legend" }, p)).addClass("highcharts-point").add(x), b.isMarker = !0;
            }
          }
          O.areaMarker = function(M, w) {
            L.call(this, M, w, !0);
          }, O.lineMarker = L, O.rectangle = function(M, w) {
            let A = w.legendItem || {}, l = M.options, u = M.symbolHeight, c = l.squareSymbol, v = c ? u : M.symbolWidth;
            A.symbol = this.chart.renderer.rect(c ? (M.symbolWidth - u) / 2 : 0, M.baseline - u + 1, v, u, z(M.options.symbolRadius, u / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(A.group);
          };
        }(B || (B = {})), B;
      }), Z(r, "Core/Series/SeriesDefaults.js", [], function() {
        return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
          let { numberFormatter: T } = this.series.chart;
          return typeof this.y != "number" ? "" : T(this.y, -1);
        }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
      }), Z(r, "Core/Series/SeriesRegistry.js", [r["Core/Globals.js"], r["Core/Defaults.js"], r["Core/Series/Point.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { defaultOptions: O } = B, { extend: L, extendClass: M, merge: w } = R;
        return function(A) {
          function l(u, c) {
            let v = O.plotOptions || {}, s = c.defaultOptions, f = c.prototype;
            return f.type = u, f.pointClass || (f.pointClass = I), !A.seriesTypes[u] && (s && (v[u] = s), A.seriesTypes[u] = c, !0);
          }
          A.seriesTypes = T.seriesTypes, A.registerSeriesType = l, A.seriesType = function(u, c, v, s, f) {
            let y = O.plotOptions || {};
            if (c = c || "", y[u] = w(y[c], v), delete A.seriesTypes[u], l(u, M(A.seriesTypes[c] || function() {
            }, s)), A.seriesTypes[u].prototype.type = u, f) {
              class h extends I {
              }
              L(h.prototype, f), A.seriesTypes[u].prototype.pointClass = h;
            }
            return A.seriesTypes[u];
          };
        }(z || (z = {})), z;
      }), Z(r, "Core/Series/Series.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Defaults.js"], r["Core/Foundation.js"], r["Core/Globals.js"], r["Core/Legend/LegendSymbol.js"], r["Core/Series/Point.js"], r["Core/Series/SeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A) {
        let { animObject: l, setAnimation: u } = T, { defaultOptions: c } = B, { registerEventOptions: v } = I, { svg: s, win: f } = R, { seriesTypes: y } = M, { arrayMax: h, arrayMin: a, clamp: x, correctFloat: S, crisp: E, defined: b, destroyObjectProperties: p, diffObjects: C, erase: o, error: t, extend: e, find: n, fireEvent: d, getClosestDistance: i, getNestedProperty: g, insertItem: m, isArray: k, isNumber: j, isString: P, merge: D, objectEach: H, pick: G, removeEvent: V, splat: F, syncTimeout: U } = A;
        class Y {
          constructor() {
            this.zoneAxis = "y";
          }
          init(N, X) {
            let W;
            d(this, "init", { options: X });
            let _ = this, K = N.series;
            this.eventsToUnbind = [], _.chart = N, _.options = _.setOptions(X);
            let J = _.options, $ = J.visible !== !1;
            _.linkedSeries = [], _.bindAxes(), e(_, { name: J.name, state: "", visible: $, selected: J.selected === !0 }), v(this, J);
            let et = J.events;
            (et && et.click || J.point && J.point.events && J.point.events.click || J.allowPointSelect) && (N.runTrackerClick = !0), _.getColor(), _.getSymbol(), _.parallelArrays.forEach(function(st) {
              _[st + "Data"] || (_[st + "Data"] = []);
            }), _.isCartesian && (N.hasCartesianSeries = !0), K.length && (W = K[K.length - 1]), _._i = G(W && W._i, -1) + 1, _.opacity = _.options.opacity, N.orderItems("series", m(this, K)), J.dataSorting && J.dataSorting.enabled ? _.setDataSortingOptions() : _.points || _.data || _.setData(J.data, !1), d(this, "afterInit");
          }
          is(N) {
            return y[N] && this instanceof y[N];
          }
          bindAxes() {
            let N, X = this, W = X.options, _ = X.chart;
            d(this, "bindAxes", null, function() {
              (X.axisTypes || []).forEach(function(K) {
                (_[K] || []).forEach(function(J) {
                  N = J.options, (G(W[K], 0) === J.index || W[K] !== void 0 && W[K] === N.id) && (m(X, J.series), X[K] = J, J.isDirty = !0);
                }), X[K] || X.optionalAxis === K || t(18, !0, _);
              });
            }), d(this, "afterBindAxes");
          }
          updateParallelArrays(N, X, W) {
            let _ = N.series, K = j(X) ? function(J) {
              let $ = J === "y" && _.toYData ? _.toYData(N) : N[J];
              _[J + "Data"][X] = $;
            } : function(J) {
              Array.prototype[X].apply(_[J + "Data"], W);
            };
            _.parallelArrays.forEach(K);
          }
          hasData() {
            return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
          }
          hasMarkerChanged(N, X) {
            let W = N.marker, _ = X.marker || {};
            return W && (_.enabled && !W.enabled || _.symbol !== W.symbol || _.height !== W.height || _.width !== W.width);
          }
          autoIncrement(N) {
            let X = this.options, W = X.pointIntervalUnit, _ = X.relativeXValue, K = this.chart.time, J = this.xIncrement, $, et;
            return J = G(J, X.pointStart, 0), this.pointInterval = et = G(this.pointInterval, X.pointInterval, 1), _ && j(N) && (et *= N), W && ($ = new K.Date(J), W === "day" ? K.set("Date", $, K.get("Date", $) + et) : W === "month" ? K.set("Month", $, K.get("Month", $) + et) : W === "year" && K.set("FullYear", $, K.get("FullYear", $) + et), et = $.getTime() - J), _ && j(N) ? J + et : (this.xIncrement = J + et, J);
          }
          setDataSortingOptions() {
            let N = this.options;
            e(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), b(N.pointRange) || (N.pointRange = 1);
          }
          setOptions(N) {
            var ht, ct;
            let X, W = this.chart, _ = W.options.plotOptions, K = W.userOptions || {}, J = D(N), $ = W.styledMode, et = { plotOptions: _, userOptions: J };
            d(this, "setOptions", et);
            let st = et.plotOptions[this.type], at = K.plotOptions || {}, lt = at.series || {}, it = c.plotOptions[this.type] || {}, Q = at[this.type] || {};
            this.userOptions = et.userOptions;
            let ot = D(st, _.series, Q, J);
            this.tooltipOptions = D(c.tooltip, (ht = c.plotOptions.series) == null ? void 0 : ht.tooltip, it == null ? void 0 : it.tooltip, W.userOptions.tooltip, (ct = at.series) == null ? void 0 : ct.tooltip, Q.tooltip, J.tooltip), this.stickyTracking = G(J.stickyTracking, Q.stickyTracking, lt.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || ot.stickyTracking), st.marker === null && delete ot.marker, this.zoneAxis = ot.zoneAxis || "y";
            let nt = this.zones = (ot.zones || []).map((dt) => ({ ...dt }));
            return (ot.negativeColor || ot.negativeFillColor) && !ot.zones && (X = { value: ot[this.zoneAxis + "Threshold"] || ot.threshold || 0, className: "highcharts-negative" }, $ || (X.color = ot.negativeColor, X.fillColor = ot.negativeFillColor), nt.push(X)), nt.length && b(nt[nt.length - 1].value) && nt.push($ ? {} : { color: this.color, fillColor: this.fillColor }), d(this, "afterSetOptions", { options: ot }), ot;
          }
          getName() {
            return G(this.options.name, "Series " + (this.index + 1));
          }
          getCyclic(N, X, W) {
            let _, K, J = this.chart, $ = `${N}Index`, et = `${N}Counter`, st = (W == null ? void 0 : W.length) || J.options.chart.colorCount;
            !X && (b(K = G(N === "color" ? this.options.colorIndex : void 0, this[$])) ? _ = K : (J.series.length || (J[et] = 0), _ = J[et] % st, J[et] += 1), W && (X = W[_])), _ !== void 0 && (this[$] = _), this[N] = X;
          }
          getColor() {
            this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || c.plotOptions[this.type].color, this.chart.options.colors);
          }
          getPointsCollection() {
            return (this.hasGroupedData ? this.points : this.data) || [];
          }
          getSymbol() {
            let N = this.options.marker;
            this.getCyclic("symbol", N.symbol, this.chart.options.symbols);
          }
          findPointIndex(N, X) {
            let W, _, K, J = N.id, $ = N.x, et = this.points, st = this.options.dataSorting;
            if (J) {
              let at = this.chart.get(J);
              at instanceof O && (W = at);
            } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
              let at = (lt) => !lt.touched && lt.index === N.index;
              if (st && st.matchByName ? at = (lt) => !lt.touched && lt.name === N.name : this.options.relativeXValue && (at = (lt) => !lt.touched && lt.options.x === N.x), !(W = n(et, at))) return;
            }
            return W && (K = W && W.index) !== void 0 && (_ = !0), K === void 0 && j($) && (K = this.xData.indexOf($, X)), K !== -1 && K !== void 0 && this.cropped && (K = K >= this.cropStart ? K - this.cropStart : K), !_ && j(K) && et[K] && et[K].touched && (K = void 0), K;
          }
          updateData(N, X) {
            let W = this.options, _ = W.dataSorting, K = this.points, J = [], $ = this.requireSorting, et = N.length === K.length, st, at, lt, it, Q = !0;
            if (this.xIncrement = null, N.forEach(function(ot, nt) {
              let ht, ct = b(ot) && this.pointClass.prototype.optionsToObject.call({ series: this }, ot) || {}, dt = ct.x;
              ct.id || j(dt) ? ((ht = this.findPointIndex(ct, it)) === -1 || ht === void 0 ? J.push(ot) : K[ht] && ot !== W.data[ht] ? (K[ht].update(ot, !1, null, !1), K[ht].touched = !0, $ && (it = ht + 1)) : K[ht] && (K[ht].touched = !0), (!et || nt !== ht || _ && _.enabled || this.hasDerivedData) && (st = !0)) : J.push(ot);
            }, this), st) for (at = K.length; at--; ) (lt = K[at]) && !lt.touched && lt.remove && lt.remove(!1, X);
            else !et || _ && _.enabled ? Q = !1 : (N.forEach(function(ot, nt) {
              ot === K[nt].y || K[nt].destroyed || K[nt].update(ot, !1, null, !1);
            }), J.length = 0);
            return K.forEach(function(ot) {
              ot && (ot.touched = !1);
            }), !!Q && (J.forEach(function(ot) {
              this.addPoint(ot, !1, null, null, !1);
            }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = h(this.xData), this.autoIncrement()), !0);
          }
          setData(N, X = !0, W, _) {
            var xt;
            let K = this, J = K.points, $ = J && J.length || 0, et = K.options, st = K.chart, at = et.dataSorting, lt = K.xAxis, it = et.turboThreshold, Q = this.xData, ot = this.yData, nt = K.pointArrayMap, ht = nt && nt.length, ct = et.keys, dt, ut, pt, gt = 0, ft = 1, mt;
            st.options.chart.allowMutatingData || (et.data && delete K.options.data, K.userOptions.data && delete K.userOptions.data, mt = D(!0, N));
            let yt = (N = mt || N || []).length;
            if (at && at.enabled && (N = this.sortData(N)), st.options.chart.allowMutatingData && _ !== !1 && yt && $ && !K.cropped && !K.hasGroupedData && K.visible && !K.boosted && (pt = this.updateData(N, W)), !pt) {
              K.xIncrement = null, K.colorCounter = 0, this.parallelArrays.forEach(function(vt) {
                K[vt + "Data"].length = 0;
              });
              let bt = it && yt > it;
              if (bt) {
                let vt = K.getFirstValidPoint(N), Ct = K.getFirstValidPoint(N, yt - 1, -1), At = (Mt) => !!(k(Mt) && (ct || j(Mt[0])));
                if (j(vt) && j(Ct)) for (dt = 0; dt < yt; dt++) Q[dt] = this.autoIncrement(), ot[dt] = N[dt];
                else if (At(vt) && At(Ct))
                  if (ht)
                    if (vt.length === ht) for (dt = 0; dt < yt; dt++) Q[dt] = this.autoIncrement(), ot[dt] = N[dt];
                    else for (dt = 0; dt < yt; dt++) ut = N[dt], Q[dt] = ut[0], ot[dt] = ut.slice(1, ht + 1);
                  else if (ct && (gt = ct.indexOf("x"), ft = ct.indexOf("y"), gt = gt >= 0 ? gt : 0, ft = ft >= 0 ? ft : 1), vt.length === 1 && (ft = 0), gt === ft) for (dt = 0; dt < yt; dt++) Q[dt] = this.autoIncrement(), ot[dt] = N[dt][ft];
                  else for (dt = 0; dt < yt; dt++) ut = N[dt], Q[dt] = ut[gt], ot[dt] = ut[ft];
                else bt = !1;
              }
              if (!bt) for (dt = 0; dt < yt; dt++) ut = { series: K }, K.pointClass.prototype.applyOptions.apply(ut, [N[dt]]), K.updateParallelArrays(ut, dt);
              for (ot && P(ot[0]) && t(14, !0, st), K.data = [], K.options.data = K.userOptions.data = N, dt = $; dt--; ) (xt = J[dt]) == null || xt.destroy();
              lt && (lt.minRange = lt.userMinRange), K.isDirty = st.isDirtyBox = !0, K.isDirtyData = !!J, W = !1;
            }
            et.legendType === "point" && (this.processData(), this.generatePoints()), X && st.redraw(W);
          }
          sortData(N) {
            let X = this, W = X.options.dataSorting.sortKey || "y", _ = function(K, J) {
              return b(J) && K.pointClass.prototype.optionsToObject.call({ series: K }, J) || {};
            };
            return N.forEach(function(K, J) {
              N[J] = _(X, K), N[J].index = J;
            }, this), N.concat().sort((K, J) => {
              let $ = g(W, K), et = g(W, J);
              return et < $ ? -1 : et > $ ? 1 : 0;
            }).forEach(function(K, J) {
              K.x = J;
            }, this), X.linkedSeries && X.linkedSeries.forEach(function(K) {
              let J = K.options, $ = J.data;
              J.dataSorting && J.dataSorting.enabled || !$ || ($.forEach(function(et, st) {
                $[st] = _(K, et), N[st] && ($[st].x = N[st].x, $[st].index = st);
              }), K.setData($, !1));
            }), N;
          }
          getProcessedData(N) {
            let X = this, W = X.xAxis, _ = X.options.cropThreshold, K = W == null ? void 0 : W.logarithmic, J = X.isCartesian, $, et, st = 0, at, lt, it, Q = X.xData, ot = X.yData, nt = !1, ht = Q.length;
            W && (lt = (at = W.getExtremes()).min, it = at.max, nt = !!(W.categories && !W.names.length)), J && X.sorted && !N && (!_ || ht > _ || X.forceCrop) && (Q[ht - 1] < lt || Q[0] > it ? (Q = [], ot = []) : X.yData && (Q[0] < lt || Q[ht - 1] > it) && (Q = ($ = this.cropData(X.xData, X.yData, lt, it)).xData, ot = $.yData, st = $.start, et = !0));
            let ct = i([K ? Q.map(K.log2lin) : Q], () => X.requireSorting && !nt && t(15, !1, X.chart));
            return { xData: Q, yData: ot, cropped: et, cropStart: st, closestPointRange: ct };
          }
          processData(N) {
            let X = this.xAxis;
            if (this.isCartesian && !this.isDirty && !X.isDirty && !this.yAxis.isDirty && !N) return !1;
            let W = this.getProcessedData();
            this.cropped = W.cropped, this.cropStart = W.cropStart, this.processedXData = W.xData, this.processedYData = W.yData, this.closestPointRange = this.basePointRange = W.closestPointRange, d(this, "afterProcessData");
          }
          cropData(N, X, W, _) {
            let K = N.length, J, $, et = 0, st = K;
            for (J = 0; J < K; J++) if (N[J] >= W) {
              et = Math.max(0, J - 1);
              break;
            }
            for ($ = J; $ < K; $++) if (N[$] > _) {
              st = $ + 1;
              break;
            }
            return { xData: N.slice(et, st), yData: X.slice(et, st), start: et, end: st };
          }
          generatePoints() {
            let N = this.options, X = this.processedData || N.data, W = this.processedXData, _ = this.processedYData, K = this.pointClass, J = W.length, $ = this.cropStart || 0, et = this.hasGroupedData, st = N.keys, at = [], lt = N.dataGrouping && N.dataGrouping.groupAll ? $ : 0, it, Q, ot, nt, ht = this.data;
            if (!ht && !et) {
              let ct = [];
              ct.length = X.length, ht = this.data = ct;
            }
            for (st && et && (this.options.keys = !1), nt = 0; nt < J; nt++) Q = $ + nt, et ? ((ot = new K(this, [W[nt]].concat(F(_[nt])))).dataGroup = this.groupMap[lt + nt], ot.dataGroup.options && (ot.options = ot.dataGroup.options, e(ot, ot.dataGroup.options), delete ot.dataLabels)) : (ot = ht[Q]) || X[Q] === void 0 || (ht[Q] = ot = new K(this, X[Q], W[nt])), ot && (ot.index = et ? lt + nt : Q, at[nt] = ot);
            if (this.options.keys = st, ht && (J !== (it = ht.length) || et)) for (nt = 0; nt < it; nt++) nt !== $ || et || (nt += J), ht[nt] && (ht[nt].destroyElements(), ht[nt].plotX = void 0);
            this.data = ht, this.points = at, d(this, "afterGeneratePoints");
          }
          getXExtremes(N) {
            return { min: a(N), max: h(N) };
          }
          getExtremes(N, X) {
            let W = this.xAxis, _ = this.yAxis, K = [], J = this.requireSorting && !this.is("column") ? 1 : 0, $ = !!_ && _.positiveValuesOnly, et = X || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: st, processedYData: at } = this, lt, it, Q, ot, nt, ht, ct, dt = 0, ut = 0, pt = 0;
            if (this.cropped && et) {
              let yt = this.getProcessedData(!0);
              st = yt.xData, at = yt.yData;
            }
            let gt = (N = N || this.stackedYData || at || []).length, ft = st || this.xData;
            for (W && (dt = (lt = W.getExtremes()).min, ut = lt.max), ht = 0; ht < gt; ht++) if (ot = ft[ht], it = (j(nt = N[ht]) || k(nt)) && ((j(nt) ? nt > 0 : nt.length) || !$), Q = X || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !W || (ft[ht + J] || ot) >= dt && (ft[ht - J] || ot) <= ut, it && Q)
              if (ct = nt.length) for (; ct--; ) j(nt[ct]) && (K[pt++] = nt[ct]);
              else K[pt++] = nt;
            let mt = { activeYData: K, dataMin: a(K), dataMax: h(K) };
            return d(this, "afterGetExtremes", { dataExtremes: mt }), mt;
          }
          applyExtremes() {
            let N = this.getExtremes();
            return this.dataMin = N.dataMin, this.dataMax = N.dataMax, N;
          }
          getFirstValidPoint(N, X = 0, W = 1) {
            let _ = N.length, K = X;
            for (; K >= 0 && K < _; ) {
              if (b(N[K])) return N[K];
              K += W;
            }
          }
          translate() {
            var ut;
            this.processedXData || this.processData(), this.generatePoints();
            let N = this.options, X = N.stacking, W = this.xAxis, _ = W.categories, K = this.enabledDataSorting, J = this.yAxis, $ = this.points, et = $.length, st = this.pointPlacementToXValue(), at = !!st, lt = N.threshold, it = N.startFromThreshold ? lt : 0, Q, ot, nt, ht, ct = Number.MAX_VALUE;
            function dt(pt) {
              return x(pt, -1e9, 1e9);
            }
            for (Q = 0; Q < et; Q++) {
              let pt, gt = $[Q], ft = gt.x, mt, yt, xt = gt.y, bt = gt.low, vt = X && ((ut = J.stacking) == null ? void 0 : ut.stacks[(this.negStacks && xt < (it ? 0 : lt) ? "-" : "") + this.stackKey]);
              ot = W.translate(ft, !1, !1, !1, !0, st), gt.plotX = j(ot) ? S(dt(ot)) : void 0, X && this.visible && vt && vt[ft] && (ht = this.getStackIndicator(ht, ft, this.index), !gt.isNull && ht.key && (yt = (mt = vt[ft]).points[ht.key]), mt && k(yt) && (bt = yt[0], xt = yt[1], bt === it && ht.key === vt[ft].base && (bt = G(j(lt) ? lt : J.min)), J.positiveValuesOnly && b(bt) && bt <= 0 && (bt = void 0), gt.total = gt.stackTotal = G(mt.total), gt.percentage = b(gt.y) && mt.total ? gt.y / mt.total * 100 : void 0, gt.stackY = xt, this.irregularWidths || mt.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), gt.yBottom = b(bt) ? dt(J.translate(bt, !1, !0, !1, !0)) : void 0, this.dataModify && (xt = this.dataModify.modifyValue(xt, Q)), j(xt) && gt.plotX !== void 0 && (pt = j(pt = J.translate(xt, !1, !0, !1, !0)) ? dt(pt) : void 0), gt.plotY = pt, gt.isInside = this.isPointInside(gt), gt.clientX = at ? S(W.translate(ft, !1, !1, !1, !0, st)) : ot, gt.negative = (gt.y || 0) < (lt || 0), gt.category = G(_ && _[gt.x], gt.x), gt.isNull || gt.visible === !1 || (nt !== void 0 && (ct = Math.min(ct, Math.abs(ot - nt))), nt = ot), gt.zone = this.zones.length ? gt.getZone() : void 0, !gt.graphic && this.group && K && (gt.isNew = !0);
            }
            this.closestPointRangePx = ct, d(this, "afterTranslate");
          }
          getValidPoints(N, X, W) {
            let _ = this.chart;
            return (N || this.points || []).filter(function(K) {
              let { plotX: J, plotY: $ } = K;
              return !!((W || !K.isNull && j($)) && (!X || _.isInsidePlot(J, $, { inverted: _.inverted }))) && K.visible !== !1;
            });
          }
          getClipBox() {
            let { chart: N, xAxis: X, yAxis: W } = this, { x: _, y: K, width: J, height: $ } = D(N.clipBox);
            return X && X.len !== N.plotSizeX && (J = X.len), W && W.len !== N.plotSizeY && ($ = W.len), N.inverted && !this.invertible && ([J, $] = [$, J]), { x: _, y: K, width: J, height: $ };
          }
          getSharedClipKey() {
            return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
          }
          setClip() {
            let { chart: N, group: X, markerGroup: W } = this, _ = N.sharedClips, K = N.renderer, J = this.getClipBox(), $ = this.getSharedClipKey(), et = _[$];
            et ? et.animate(J) : _[$] = et = K.clipRect(J), X && X.clip(this.options.clip === !1 ? void 0 : et), W && W.clip();
          }
          animate(N) {
            let { chart: X, group: W, markerGroup: _ } = this, K = X.inverted, J = l(this.options.animation), $ = [this.getSharedClipKey(), J.duration, J.easing, J.defer].join(","), et = X.sharedClips[$], st = X.sharedClips[$ + "m"];
            if (N && W) {
              let at = this.getClipBox();
              if (et) et.attr("height", at.height);
              else {
                at.width = 0, K && (at.x = X.plotHeight), et = X.renderer.clipRect(at), X.sharedClips[$] = et;
                let lt = { x: -99, y: -99, width: K ? X.plotWidth + 199 : 99, height: K ? 99 : X.plotHeight + 199 };
                st = X.renderer.clipRect(lt), X.sharedClips[$ + "m"] = st;
              }
              W.clip(et), _ == null || _.clip(st);
            } else if (et && !et.hasClass("highcharts-animating")) {
              let at = this.getClipBox(), lt = J.step;
              (_ != null && _.element.childNodes.length || X.series.length > 1) && (J.step = function(it, Q) {
                lt && lt.apply(Q, arguments), Q.prop === "width" && (st != null && st.element) && st.attr(K ? "height" : "width", it + 99);
              }), et.addClass("highcharts-animating").animate(at, J);
            }
          }
          afterAnimate() {
            this.setClip(), H(this.chart.sharedClips, (N, X, W) => {
              N && !this.chart.container.querySelector(`[clip-path="url(#${N.id})"]`) && (N.destroy(), delete W[X]);
            }), this.finishedAnimating = !0, d(this, "afterAnimate");
          }
          drawPoints(N = this.points) {
            let X, W, _, K, J, $, et, st = this.chart, at = st.styledMode, { colorAxis: lt, options: it } = this, Q = it.marker, ot = this[this.specialGroup || "markerGroup"], nt = this.xAxis, ht = G(Q.enabled, !nt || !!nt.isRadial || null, this.closestPointRangePx >= Q.enabledThreshold * Q.radius);
            if (Q.enabled !== !1 || this._hasPointMarkers) for (X = 0; X < N.length; X++) if (K = (_ = (W = N[X]).graphic) ? "animate" : "attr", J = W.marker || {}, $ = !!W.marker, (ht && J.enabled === void 0 || J.enabled) && !W.isNull && W.visible !== !1) {
              let ct = G(J.symbol, this.symbol, "rect");
              et = this.markerAttribs(W, W.selected && "select"), this.enabledDataSorting && (W.startXPos = nt.reversed ? -(et.width || 0) : nt.width);
              let dt = W.isInside !== !1;
              if (!_ && dt && ((et.width || 0) > 0 || W.hasImage) && (W.graphic = _ = st.renderer.symbol(ct, et.x, et.y, et.width, et.height, $ ? J : Q).add(ot), this.enabledDataSorting && st.hasRendered && (_.attr({ x: W.startXPos }), K = "animate")), _ && K === "animate" && _[dt ? "show" : "hide"](dt).animate(et), _) {
                let ut = this.pointAttribs(W, at || !W.selected ? void 0 : "select");
                at ? lt && _.css({ fill: ut.fill }) : _[K](ut);
              }
              _ && _.addClass(W.getClassName(), !0);
            } else _ && (W.graphic = _.destroy());
          }
          markerAttribs(N, X) {
            let W = this.options, _ = W.marker, K = N.marker || {}, J = K.symbol || _.symbol, $ = {}, et, st, at = G(K.radius, _ && _.radius);
            X && (et = _.states[X], at = G((st = K.states && K.states[X]) && st.radius, et && et.radius, at && at + (et && et.radiusPlus || 0))), N.hasImage = J && J.indexOf("url") === 0, N.hasImage && (at = 0);
            let lt = N.pos();
            return j(at) && lt && (W.crisp && (lt[0] = E(lt[0], N.hasImage ? 0 : J === "rect" ? (_ == null ? void 0 : _.lineWidth) || 0 : 1)), $.x = lt[0] - at, $.y = lt[1] - at), at && ($.width = $.height = 2 * at), $;
          }
          pointAttribs(N, X) {
            let W = this.options.marker, _ = N && N.options, K = _ && _.marker || {}, J = _ && _.color, $ = N && N.color, et = N && N.zone && N.zone.color, st, at, lt = this.color, it, Q, ot = G(K.lineWidth, W.lineWidth), nt = 1;
            return lt = J || et || $ || lt, it = K.fillColor || W.fillColor || lt, Q = K.lineColor || W.lineColor || lt, X = X || "normal", st = W.states[X] || {}, ot = G((at = K.states && K.states[X] || {}).lineWidth, st.lineWidth, ot + G(at.lineWidthPlus, st.lineWidthPlus, 0)), it = at.fillColor || st.fillColor || it, { stroke: Q = at.lineColor || st.lineColor || Q, "stroke-width": ot, fill: it, opacity: nt = G(at.opacity, st.opacity, nt) };
          }
          destroy(N) {
            let X, W, _, K = this, J = K.chart, $ = /AppleWebKit\/533/.test(f.navigator.userAgent), et = K.data || [];
            for (d(K, "destroy", { keepEventsForUpdate: N }), this.removeEvents(N), (K.axisTypes || []).forEach(function(st) {
              (_ = K[st]) && _.series && (o(_.series, K), _.isDirty = _.forceRedraw = !0);
            }), K.legendItem && K.chart.legend.destroyItem(K), X = et.length; X--; ) (W = et[X]) && W.destroy && W.destroy();
            for (let st of K.zones) p(st, void 0, !0);
            A.clearTimeout(K.animationTimeout), H(K, function(st, at) {
              st instanceof w && !st.survive && st[$ && at === "group" ? "hide" : "destroy"]();
            }), J.hoverSeries === K && (J.hoverSeries = void 0), o(J.series, K), J.orderItems("series"), H(K, function(st, at) {
              N && at === "hcEvents" || delete K[at];
            });
          }
          applyZones() {
            let { area: N, chart: X, graph: W, zones: _, points: K, xAxis: J, yAxis: $, zoneAxis: et } = this, { inverted: st, renderer: at } = X, lt = this[`${et}Axis`], { isXAxis: it, len: Q = 0 } = lt || {}, ot = ((W == null ? void 0 : W.strokeWidth()) || 0) / 2 + 1, nt = (ht, ct = 0, dt = 0) => {
              st && (dt = Q - dt);
              let { translated: ut = 0, lineClip: pt } = ht, gt = dt - ut;
              pt == null || pt.push(["L", ct, Math.abs(gt) < ot ? dt - ot * (gt <= 0 ? -1 : 1) : ut]);
            };
            if (_.length && (W || N) && lt && j(lt.min)) {
              let ht = lt.getExtremes().max, ct = (pt) => {
                pt.forEach((gt, ft) => {
                  (gt[0] === "M" || gt[0] === "L") && (pt[ft] = [gt[0], it ? Q - gt[1] : gt[1], it ? gt[2] : Q - gt[2]]);
                });
              };
              if (_.forEach((pt) => {
                pt.lineClip = [], pt.translated = x(lt.toPixels(G(pt.value, ht), !0) || 0, 0, Q);
              }), W && !this.showLine && W.hide(), N && N.hide(), et === "y" && K.length < J.len) for (let pt of K) {
                let { plotX: gt, plotY: ft, zone: mt } = pt, yt = mt && _[_.indexOf(mt) - 1];
                mt && nt(mt, gt, ft), yt && nt(yt, gt, ft);
              }
              let dt = [], ut = lt.toPixels(lt.getExtremes().min, !0);
              _.forEach((pt) => {
                var kt, Pt;
                let gt = pt.lineClip || [], ft = Math.round(pt.translated || 0);
                J.reversed && gt.reverse();
                let { clip: mt, simpleClip: yt } = pt, xt = 0, bt = 0, vt = J.len, Ct = $.len;
                it ? (xt = ft, vt = ut) : (bt = ft, Ct = ut);
                let At = [["M", xt, bt], ["L", vt, bt], ["L", vt, Ct], ["L", xt, Ct], ["Z"]], Mt = [At[0], ...gt, At[1], At[2], ...dt, At[3], At[4]];
                dt = gt.reverse(), ut = ft, st && (ct(Mt), N && ct(At)), mt ? (mt.animate({ d: Mt }), yt == null || yt.animate({ d: At })) : (mt = pt.clip = at.path(Mt), N && (yt = pt.simpleClip = at.path(At))), W && ((kt = pt.graph) == null || kt.clip(mt)), N && ((Pt = pt.area) == null || Pt.clip(yt));
              });
            } else this.visible && (W && W.show(), N && N.show());
          }
          plotGroup(N, X, W, _, K) {
            let J = this[N], $ = !J, et = { visibility: W, zIndex: _ || 0.1 };
            return b(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (et.opacity = this.opacity), J || (this[N] = J = this.chart.renderer.g().add(K)), J.addClass("highcharts-" + X + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (b(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (J.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), J.attr(et)[$ ? "attr" : "animate"](this.getPlotBox(X)), J;
          }
          getPlotBox(N) {
            let X = this.xAxis, W = this.yAxis, _ = this.chart, K = _.inverted && !_.polar && X && this.invertible && N === "series";
            return _.inverted && (X = W, W = this.xAxis), { translateX: X ? X.left : _.plotLeft, translateY: W ? W.top : _.plotTop, rotation: K ? 90 : 0, rotationOriginX: K ? (X.len - W.len) / 2 : 0, rotationOriginY: K ? (X.len + W.len) / 2 : 0, scaleX: K ? -1 : 1, scaleY: 1 };
          }
          removeEvents(N) {
            let { eventsToUnbind: X } = this;
            N || V(this), X.length && (X.forEach((W) => {
              W();
            }), X.length = 0);
          }
          render() {
            var at, lt, it, Q, ot;
            let N = this, { chart: X, options: W, hasRendered: _ } = N, K = l(W.animation), J = N.visible ? "inherit" : "hidden", $ = W.zIndex, et = X.seriesGroup, st = N.finishedAnimating ? 0 : K.duration;
            d(this, "render"), N.plotGroup("group", "series", J, $, et), N.markerGroup = N.plotGroup("markerGroup", "markers", J, $, et), W.clip !== !1 && N.setClip(), st && ((at = N.animate) == null || at.call(N, !0)), N.drawGraph && (N.drawGraph(), N.applyZones()), N.visible && N.drawPoints(), (lt = N.drawDataLabels) == null || lt.call(N), (it = N.redrawPoints) == null || it.call(N), W.enableMouseTracking && ((Q = N.drawTracker) == null || Q.call(N)), st && ((ot = N.animate) == null || ot.call(N)), _ || (st && K.defer && (st += K.defer), N.animationTimeout = U(() => {
              N.afterAnimate();
            }, st || 0)), N.isDirty = !1, N.hasRendered = !0, d(N, "afterRender");
          }
          redraw() {
            let N = this.isDirty || this.isDirtyData;
            this.translate(), this.render(), N && delete this.kdTree;
          }
          reserveSpace() {
            return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
          }
          searchPoint(N, X) {
            let { xAxis: W, yAxis: _ } = this, K = this.chart.inverted;
            return this.searchKDTree({ clientX: K ? W.len - N.chartY + W.pos : N.chartX - W.pos, plotY: K ? _.len - N.chartX + _.pos : N.chartY - _.pos }, X, N);
          }
          buildKDTree(N) {
            this.buildingKdTree = !0;
            let X = this, W = X.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
            delete X.kdTree, U(function() {
              X.kdTree = function _(K, J, $) {
                let et, st, at = K == null ? void 0 : K.length;
                if (at) return et = X.kdAxisArray[J % $], K.sort((lt, it) => (lt[et] || 0) - (it[et] || 0)), { point: K[st = Math.floor(at / 2)], left: _(K.slice(0, st), J + 1, $), right: _(K.slice(st + 1), J + 1, $) };
              }(X.getValidPoints(void 0, !X.directTouch), W, W), X.buildingKdTree = !1;
            }, X.options.kdNow || (N == null ? void 0 : N.type) === "touchstart" ? 0 : 1);
          }
          searchKDTree(N, X, W) {
            let _ = this, [K, J] = this.kdAxisArray, $ = X ? "distX" : "dist", et = (_.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, st = !!_.isBubble;
            if (this.kdTree || this.buildingKdTree || this.buildKDTree(W), this.kdTree) return function at(lt, it, Q, ot) {
              var mt;
              let nt = it.point, ht = _.kdAxisArray[Q % ot], ct, dt, ut = nt;
              (function(yt, xt) {
                var jt;
                let bt = yt[K], vt = xt[K], Ct = b(bt) && b(vt) ? bt - vt : null, At = yt[J], Mt = xt[J], kt = b(At) && b(Mt) ? At - Mt : 0, Pt = st && ((jt = xt.marker) == null ? void 0 : jt.radius) || 0;
                xt.dist = Math.sqrt((Ct && Ct * Ct || 0) + kt * kt) - Pt, xt.distX = b(Ct) ? Math.abs(Ct) - Pt : Number.MAX_VALUE;
              })(lt, nt);
              let pt = (lt[ht] || 0) - (nt[ht] || 0) + (st && ((mt = nt.marker) == null ? void 0 : mt.radius) || 0), gt = pt < 0 ? "left" : "right", ft = pt < 0 ? "right" : "left";
              return it[gt] && (ut = (ct = at(lt, it[gt], Q + 1, ot))[$] < ut[$] ? ct : nt), it[ft] && Math.sqrt(pt * pt) < ut[$] && (ut = (dt = at(lt, it[ft], Q + 1, ot))[$] < ut[$] ? dt : ut), ut;
            }(N, this.kdTree, et, et);
          }
          pointPlacementToXValue() {
            let { options: N, xAxis: X } = this, W = N.pointPlacement;
            return W === "between" && (W = X.reversed ? -0.5 : 0.5), j(W) ? W * (N.pointRange || X.pointRange) : 0;
          }
          isPointInside(N) {
            let { chart: X, xAxis: W, yAxis: _ } = this, { plotX: K = -1, plotY: J = -1 } = N;
            return J >= 0 && J <= (_ ? _.len : X.plotHeight) && K >= 0 && K <= (W ? W.len : X.plotWidth);
          }
          drawTracker() {
            var it;
            let N = this, X = N.options, W = X.trackByArea, _ = [].concat((W ? N.areaPath : N.graphPath) || []), K = N.chart, J = K.pointer, $ = K.renderer, et = ((it = K.options.tooltip) == null ? void 0 : it.snap) || 0, st = () => {
              X.enableMouseTracking && K.hoverSeries !== N && N.onMouseOver();
            }, at = "rgba(192,192,192," + (s ? 1e-4 : 2e-3) + ")", lt = N.tracker;
            lt ? lt.attr({ d: _ }) : N.graph && (N.tracker = lt = $.path(_).attr({ visibility: N.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(W ? "highcharts-tracker-area" : "highcharts-tracker-line").add(N.group), K.styledMode || lt.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: at, fill: W ? at : "none", "stroke-width": N.graph.strokeWidth() + (W ? 0 : 2 * et) }), [N.tracker, N.markerGroup, N.dataLabelsGroup].forEach((Q) => {
              Q && (Q.addClass("highcharts-tracker").on("mouseover", st).on("mouseout", (ot) => {
                J == null || J.onTrackerMouseOut(ot);
              }), X.cursor && !K.styledMode && Q.css({ cursor: X.cursor }), Q.on("touchstart", st));
            })), d(this, "afterDrawTracker");
          }
          addPoint(N, X, W, _, K) {
            let J, $, et = this.options, st = this.data, at = this.chart, lt = this.xAxis, it = lt && lt.hasNames && lt.names, Q = et.data, ot = this.xData;
            X = G(X, !0);
            let nt = { series: this };
            this.pointClass.prototype.applyOptions.apply(nt, [N]);
            let ht = nt.x;
            if ($ = ot.length, this.requireSorting && ht < ot[$ - 1]) for (J = !0; $ && ot[$ - 1] > ht; ) $--;
            this.updateParallelArrays(nt, "splice", [$, 0, 0]), this.updateParallelArrays(nt, $), it && nt.name && (it[ht] = nt.name), Q.splice($, 0, N), (J || this.processedData) && (this.data.splice($, 0, null), this.processData()), et.legendType === "point" && this.generatePoints(), W && (st[0] && st[0].remove ? st[0].remove(!1) : (st.shift(), this.updateParallelArrays(nt, "shift"), Q.shift())), K !== !1 && d(this, "addPoint", { point: nt }), this.isDirty = !0, this.isDirtyData = !0, X && at.redraw(_);
          }
          removePoint(N, X, W) {
            let _ = this, K = _.data, J = K[N], $ = _.points, et = _.chart, st = function() {
              $ && $.length === K.length && $.splice(N, 1), K.splice(N, 1), _.options.data.splice(N, 1), _.updateParallelArrays(J || { series: _ }, "splice", [N, 1]), J && J.destroy(), _.isDirty = !0, _.isDirtyData = !0, X && et.redraw();
            };
            u(W, et), X = G(X, !0), J ? J.firePointEvent("remove", null, st) : st();
          }
          remove(N, X, W, _) {
            let K = this, J = K.chart;
            function $() {
              K.destroy(_), J.isDirtyLegend = J.isDirtyBox = !0, J.linkSeries(_), G(N, !0) && J.redraw(X);
            }
            W !== !1 ? d(K, "remove", null, $) : $();
          }
          update(N, X) {
            var ct, dt, ut;
            d(this, "update", { options: N = C(N, this.userOptions) });
            let W = this, _ = W.chart, K = W.userOptions, J = W.initialType || W.type, $ = _.options.plotOptions, et = y[J].prototype, st = W.finishedAnimating && { animation: !1 }, at = {}, lt, it, Q = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], ot = N.type || K.type || _.options.chart.type, nt = !(this.hasDerivedData || ot && ot !== this.type || N.pointStart !== void 0 || N.pointInterval !== void 0 || N.relativeXValue !== void 0 || N.joinBy || N.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((pt) => W.hasOptionChanged(pt)));
            ot = ot || J, nt && (Q.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), N.visible !== !1 && Q.push("area", "graph"), W.parallelArrays.forEach(function(pt) {
              Q.push(pt + "Data");
            }), N.data && (N.dataSorting && e(W.options.dataSorting, N.dataSorting), this.setData(N.data, !1))), N = D(K, { index: K.index === void 0 ? W.index : K.index, pointStart: ((ct = $ == null ? void 0 : $.series) == null ? void 0 : ct.pointStart) ?? K.pointStart ?? ((dt = W.xData) == null ? void 0 : dt[0]) }, !nt && { data: W.options.data }, N, st), nt && N.data && (N.data = W.options.data), (Q = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(Q)).forEach(function(pt) {
              Q[pt] = W[pt], delete W[pt];
            });
            let ht = !1;
            if (y[ot]) {
              if (ht = ot !== W.type, W.remove(!1, !1, !1, !0), ht)
                if (_.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(W, y[ot].prototype);
                else {
                  let pt = Object.hasOwnProperty.call(W, "hcEvents") && W.hcEvents;
                  for (it in et) W[it] = void 0;
                  e(W, y[ot].prototype), pt ? W.hcEvents = pt : delete W.hcEvents;
                }
            } else t(17, !0, _, { missingModuleFor: ot });
            if (Q.forEach(function(pt) {
              W[pt] = Q[pt];
            }), W.init(_, N), nt && this.points) for (let pt of ((lt = W.options).visible === !1 ? (at.graphic = 1, at.dataLabel = 1) : (this.hasMarkerChanged(lt, K) && (at.graphic = 1), (ut = W.hasDataLabels) != null && ut.call(W) || (at.dataLabel = 1)), this.points)) pt && pt.series && (pt.resolveColor(), Object.keys(at).length && pt.destroyElements(at), lt.showInLegend === !1 && pt.legendItem && _.legend.destroyItem(pt));
            W.initialType = J, _.linkSeries(), _.setSortedData(), ht && W.linkedSeries.length && (W.isDirtyData = !0), d(this, "afterUpdate"), G(X, !0) && _.redraw(!!nt && void 0);
          }
          setName(N) {
            this.name = this.options.name = this.userOptions.name = N, this.chart.isDirtyLegend = !0;
          }
          hasOptionChanged(N) {
            var $, et;
            let X = this.chart, W = this.options[N], _ = X.options.plotOptions, K = this.userOptions[N], J = G(($ = _ == null ? void 0 : _[this.type]) == null ? void 0 : $[N], (et = _ == null ? void 0 : _.series) == null ? void 0 : et[N]);
            return K && !b(J) ? W !== K : W !== G(J, W);
          }
          onMouseOver() {
            let N = this.chart, X = N.hoverSeries, W = N.pointer;
            W == null || W.setHoverChartIndex(), X && X !== this && X.onMouseOut(), this.options.events.mouseOver && d(this, "mouseOver"), this.setState("hover"), N.hoverSeries = this;
          }
          onMouseOut() {
            let N = this.options, X = this.chart, W = X.tooltip, _ = X.hoverPoint;
            X.hoverSeries = null, _ && _.onMouseOut(), this && N.events.mouseOut && d(this, "mouseOut"), W && !this.stickyTracking && (!W.shared || this.noSharedTooltip) && W.hide(), X.series.forEach(function(K) {
              K.setState("", !0);
            });
          }
          setState(N, X) {
            let W = this, _ = W.options, K = W.graph, J = _.inactiveOtherPoints, $ = _.states, et = G($[N || "normal"] && $[N || "normal"].animation, W.chart.options.chart.animation), st = _.lineWidth, at = _.opacity;
            if (N = N || "", W.state !== N && ([W.group, W.markerGroup, W.dataLabelsGroup].forEach(function(lt) {
              lt && (W.state && lt.removeClass("highcharts-series-" + W.state), N && lt.addClass("highcharts-series-" + N));
            }), W.state = N, !W.chart.styledMode)) {
              if ($[N] && $[N].enabled === !1) return;
              if (N && (st = $[N].lineWidth || st + ($[N].lineWidthPlus || 0), at = G($[N].opacity, at)), K && !K.dashstyle && j(st)) for (let lt of [K, ...this.zones.map((it) => it.graph)]) lt == null || lt.animate({ "stroke-width": st }, et);
              J || [W.group, W.markerGroup, W.dataLabelsGroup, W.labelBySeries].forEach(function(lt) {
                lt && lt.animate({ opacity: at }, et);
              });
            }
            X && J && W.points && W.setAllPointsToState(N || void 0);
          }
          setAllPointsToState(N) {
            this.points.forEach(function(X) {
              X.setState && X.setState(N);
            });
          }
          setVisible(N, X) {
            var et;
            let W = this, _ = W.chart, K = _.options.chart.ignoreHiddenSeries, J = W.visible;
            W.visible = N = W.options.visible = W.userOptions.visible = N === void 0 ? !J : N;
            let $ = N ? "show" : "hide";
            ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((st) => {
              var at;
              (at = W[st]) == null || at[$]();
            }), (_.hoverSeries === W || ((et = _.hoverPoint) == null ? void 0 : et.series) === W) && W.onMouseOut(), W.legendItem && _.legend.colorizeItem(W, N), W.isDirty = !0, W.options.stacking && _.series.forEach((st) => {
              st.options.stacking && st.visible && (st.isDirty = !0);
            }), W.linkedSeries.forEach((st) => {
              st.setVisible(N, !1);
            }), K && (_.isDirtyBox = !0), d(W, $), X !== !1 && _.redraw();
          }
          show() {
            this.setVisible(!0);
          }
          hide() {
            this.setVisible(!1);
          }
          select(N) {
            this.selected = N = this.options.selected = N === void 0 ? !this.selected : N, this.checkbox && (this.checkbox.checked = N), d(this, N ? "select" : "unselect");
          }
          shouldShowTooltip(N, X, W = {}) {
            return W.series = this, W.visiblePlotOnly = !0, this.chart.isInsidePlot(N, X, W);
          }
          drawLegendSymbol(N, X) {
            var W;
            (W = z[this.options.legendSymbol || "rectangle"]) == null || W.call(this, N, X);
          }
        }
        return Y.defaultOptions = L, Y.types = M.seriesTypes, Y.registerType = M.registerSeriesType, e(Y.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: O, requireSorting: !0, sorted: !0 }), M.series = Y, Y;
      }), Z(r, "Core/Legend/Legend.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Foundation.js"], r["Core/Globals.js"], r["Core/Series/Series.js"], r["Core/Series/Point.js"], r["Core/Renderer/RendererUtilities.js"], r["Core/Templating.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        var w;
        let { animObject: A, setAnimation: l } = T, { registerEventOptions: u } = B, { composed: c, marginNames: v } = I, { distribute: s } = O, { format: f } = L, { addEvent: y, createElement: h, css: a, defined: x, discardElement: S, find: E, fireEvent: b, isNumber: p, merge: C, pick: o, pushUnique: t, relativeLength: e, stableSort: n, syncTimeout: d } = M;
        class i {
          constructor(m, k) {
            this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = m, this.setOptions(k), k.enabled && (this.render(), u(this, k), y(this.chart, "endResize", function() {
              this.legend.positionCheckboxes();
            })), y(this.chart, "render", () => {
              this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
            });
          }
          setOptions(m) {
            let k = o(m.padding, 8);
            this.options = m, this.chart.styledMode || (this.itemStyle = m.itemStyle, this.itemHiddenStyle = C(this.itemStyle, m.itemHiddenStyle)), this.itemMarginTop = m.itemMarginTop, this.itemMarginBottom = m.itemMarginBottom, this.padding = k, this.initialItemY = k - 5, this.symbolWidth = o(m.symbolWidth, 16), this.pages = [], this.proximate = m.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
          }
          update(m, k) {
            let j = this.chart;
            this.setOptions(C(!0, this.options, m)), "events" in this.options && u(this, this.options), this.destroy(), j.isDirtyLegend = j.isDirtyBox = !0, o(k, !0) && j.redraw(), b(this, "afterUpdate", { redraw: k });
          }
          colorizeItem(m, k) {
            let { area: j, group: P, label: D, line: H, symbol: G } = m.legendItem || {};
            if (P == null || P[k ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
              let { itemHiddenStyle: V = {} } = this, F = V.color, { fillColor: U, fillOpacity: Y, lineColor: q, marker: N } = m.options, X = (W) => (!k && (W.fill && (W.fill = F), W.stroke && (W.stroke = F)), W);
              D == null || D.css(C(k ? this.itemStyle : V)), H == null || H.attr(X({ stroke: q || m.color })), G && G.attr(X(N && G.isMarker ? m.pointAttribs() : { fill: m.color })), j == null || j.attr(X({ fill: U || m.color, "fill-opacity": U ? 1 : Y ?? 0.75 }));
            }
            b(this, "afterColorizeItem", { item: m, visible: k });
          }
          positionItems() {
            this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
          }
          positionItem(m) {
            let { group: k, x: j = 0, y: P = 0 } = m.legendItem || {}, D = this.options, H = D.symbolPadding, G = !D.rtl, V = m.checkbox;
            if (k && k.element) {
              let F = { translateX: G ? j : this.legendWidth - j - 2 * H - 4, translateY: P };
              k[x(k.translateY) ? "animate" : "attr"](F, void 0, () => {
                b(this, "afterPositionItem", { item: m });
              });
            }
            V && (V.x = j, V.y = P);
          }
          destroyItem(m) {
            let k = m.checkbox, j = m.legendItem || {};
            for (let P of ["group", "label", "line", "symbol"]) j[P] && (j[P] = j[P].destroy());
            k && S(k), m.legendItem = void 0;
          }
          destroy() {
            for (let m of this.getAllItems()) this.destroyItem(m);
            for (let m of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[m] && (this[m] = this[m].destroy());
            this.display = null;
          }
          positionCheckboxes() {
            let m, k = this.group && this.group.alignAttr, j = this.clipHeight || this.legendHeight, P = this.titleHeight;
            k && (m = k.translateY, this.allItems.forEach(function(D) {
              let H, G = D.checkbox;
              G && (H = m + P + G.y + (this.scrollOffset || 0) + 3, a(G, { left: k.translateX + D.checkboxOffset + G.x - 20 + "px", top: H + "px", display: this.proximate || H > m - 6 && H < m + j - 6 ? "" : "none" }));
            }, this));
          }
          renderTitle() {
            let m = this.options, k = this.padding, j = m.title, P, D = 0;
            j.text && (this.title || (this.title = this.chart.renderer.label(j.text, k - 3, k - 4, void 0, void 0, void 0, m.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(j.style), this.title.add(this.group)), j.width || this.title.css({ width: this.maxLegendWidth + "px" }), D = (P = this.title.getBBox()).height, this.offsetWidth = P.width, this.contentGroup.attr({ translateY: D })), this.titleHeight = D;
          }
          setText(m) {
            let k = this.options;
            m.legendItem.label.attr({ text: k.labelFormat ? f(k.labelFormat, m, this.chart) : k.labelFormatter.call(m) });
          }
          renderItem(m) {
            let k = m.legendItem = m.legendItem || {}, j = this.chart, P = j.renderer, D = this.options, H = D.layout === "horizontal", G = this.symbolWidth, V = D.symbolPadding || 0, F = this.itemStyle, U = this.itemHiddenStyle, Y = H ? o(D.itemDistance, 20) : 0, q = !D.rtl, N = !m.series, X = !N && m.series.drawLegendSymbol ? m.series : m, W = X.options, _ = !!this.createCheckboxForItem && W && W.showCheckbox, K = D.useHTML, J = m.options.className, $ = k.label, et = G + V + Y + (_ ? 20 : 0);
            !$ && (k.group = P.g("legend-item").addClass("highcharts-" + X.type + "-series highcharts-color-" + m.colorIndex + (J ? " " + J : "") + (N ? " highcharts-series-" + m.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), k.label = $ = P.text("", q ? G + V : -V, this.baseline || 0, K), j.styledMode || $.css(C(m.visible ? F : U)), $.attr({ align: q ? "left" : "right", zIndex: 2 }).add(k.group), !this.baseline && (this.fontMetrics = P.fontMetrics($), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, $.attr("y", this.baseline), this.symbolHeight = o(D.symbolHeight, this.fontMetrics.f), D.squareSymbol && (this.symbolWidth = o(D.symbolWidth, Math.max(this.symbolHeight, 16)), et = this.symbolWidth + V + Y + (_ ? 20 : 0), q && $.attr("x", this.symbolWidth + V))), X.drawLegendSymbol(this, m), this.setItemEvents && this.setItemEvents(m, $, K)), _ && !m.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(m), this.colorizeItem(m, m.visible), (j.styledMode || !F.width) && $.css({ width: (D.itemWidth || this.widthOption || j.spacingBox.width) - et + "px" }), this.setText(m);
            let st = $.getBBox(), at = this.fontMetrics && this.fontMetrics.h || 0;
            m.itemWidth = m.checkboxOffset = D.itemWidth || k.labelWidth || st.width + et, this.maxItemWidth = Math.max(this.maxItemWidth, m.itemWidth), this.totalItemWidth += m.itemWidth, this.itemHeight = m.itemHeight = Math.round(k.labelHeight || (st.height > 1.5 * at ? st.height : at));
          }
          layoutItem(m) {
            let k = this.options, j = this.padding, P = k.layout === "horizontal", D = m.itemHeight, H = this.itemMarginBottom, G = this.itemMarginTop, V = P ? o(k.itemDistance, 20) : 0, F = this.maxLegendWidth, U = k.alignColumns && this.totalItemWidth > F ? this.maxItemWidth : m.itemWidth, Y = m.legendItem || {};
            P && this.itemX - j + U > F && (this.itemX = j, this.lastLineHeight && (this.itemY += G + this.lastLineHeight + H), this.lastLineHeight = 0), this.lastItemY = G + this.itemY + H, this.lastLineHeight = Math.max(D, this.lastLineHeight), Y.x = this.itemX, Y.y = this.itemY, P ? this.itemX += U : (this.itemY += G + D + H, this.lastLineHeight = D), this.offsetWidth = this.widthOption || Math.max((P ? this.itemX - j - (m.checkbox ? 0 : V) : U) + j, this.offsetWidth);
          }
          getAllItems() {
            let m = [];
            return this.chart.series.forEach(function(k) {
              let j = k && k.options;
              k && o(j.showInLegend, !x(j.linkedTo) && void 0, !0) && (m = m.concat((k.legendItem || {}).labels || (j.legendType === "point" ? k.data : k)));
            }), b(this, "afterGetAllItems", { allItems: m }), m;
          }
          getAlignment() {
            let m = this.options;
            return this.proximate ? m.align.charAt(0) + "tv" : m.floating ? "" : m.align.charAt(0) + m.verticalAlign.charAt(0) + m.layout.charAt(0);
          }
          adjustMargins(m, k) {
            let j = this.chart, P = this.options, D = this.getAlignment();
            D && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(H, G) {
              H.test(D) && !x(m[G]) && (j[v[G]] = Math.max(j[v[G]], j.legend[(G + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][G] * P[G % 2 ? "x" : "y"] + o(P.margin, 12) + k[G] + (j.titleOffset[G] || 0)));
            });
          }
          proximatePositions() {
            let m, k = this.chart, j = [], P = this.options.align === "left";
            for (let D of (this.allItems.forEach(function(H) {
              let G, V, F = P, U, Y;
              H.yAxis && (H.xAxis.options.reversed && (F = !F), H.points && (G = E(F ? H.points : H.points.slice(0).reverse(), function(q) {
                return p(q.plotY);
              })), V = this.itemMarginTop + H.legendItem.label.getBBox().height + this.itemMarginBottom, Y = H.yAxis.top - k.plotTop, U = H.visible ? (G ? G.plotY : H.yAxis.height) + (Y - 0.3 * V) : Y + H.yAxis.height, j.push({ target: U, size: V, item: H }));
            }, this), s(j, k.plotHeight))) m = D.item.legendItem || {}, p(D.pos) && (m.y = k.plotTop - k.spacing[0] + D.pos);
          }
          render() {
            let m = this.chart, k = m.renderer, j = this.options, P = this.padding, D = this.getAllItems(), H, G, V, F = this.group, U, Y = this.box;
            this.itemX = P, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = e(j.width, m.spacingBox.width - P), U = m.spacingBox.width - 2 * P - j.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (U /= 2), this.maxLegendWidth = this.widthOption || U, F || (this.group = F = k.g("legend").addClass(j.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = k.g().attr({ zIndex: 1 }).add(F), this.scrollGroup = k.g().add(this.contentGroup)), this.renderTitle(), n(D, (q, N) => (q.options && q.options.legendIndex || 0) - (N.options && N.options.legendIndex || 0)), j.reversed && D.reverse(), this.allItems = D, this.display = H = !!D.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, D.forEach(this.renderItem, this), D.forEach(this.layoutItem, this), G = (this.widthOption || this.offsetWidth) + P, V = this.lastItemY + this.lastLineHeight + this.titleHeight, V = this.handleOverflow(V) + P, Y || (this.box = Y = k.rect().addClass("highcharts-legend-box").attr({ r: j.borderRadius }).add(F)), m.styledMode || Y.attr({ stroke: j.borderColor, "stroke-width": j.borderWidth || 0, fill: j.backgroundColor || "none" }).shadow(j.shadow), G > 0 && V > 0 && Y[Y.placed ? "animate" : "attr"](Y.crisp.call({}, { x: 0, y: 0, width: G, height: V }, Y.strokeWidth())), F[H ? "show" : "hide"](), m.styledMode && F.getStyle("display") === "none" && (G = V = 0), this.legendWidth = G, this.legendHeight = V, H && this.align(), this.proximate || this.positionItems(), b(this, "afterRender");
          }
          align(m = this.chart.spacingBox) {
            let k = this.chart, j = this.options, P = m.y;
            /(lth|ct|rth)/.test(this.getAlignment()) && k.titleOffset[0] > 0 ? P += k.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && k.titleOffset[2] > 0 && (P -= k.titleOffset[2]), P !== m.y && (m = C(m, { y: P })), k.hasRendered || (this.group.placed = !1), this.group.align(C(j, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : j.verticalAlign }), !0, m);
          }
          handleOverflow(m) {
            let k = this, j = this.chart, P = j.renderer, D = this.options, H = D.y, G = D.verticalAlign === "top", V = this.padding, F = D.maxHeight, U = D.navigation, Y = o(U.animation, !0), q = U.arrowSize || 12, N = this.pages, X = this.allItems, W = function(lt) {
              typeof lt == "number" ? at.attr({ height: lt }) : at && (k.clipRect = at.destroy(), k.contentGroup.clip()), k.contentGroup.div && (k.contentGroup.div.style.clip = lt ? "rect(" + V + "px,9999px," + (V + lt) + "px,0)" : "auto");
            }, _ = function(lt) {
              return k[lt] = P.circle(0, 0, 1.3 * q).translate(q / 2, q / 2).add(st), j.styledMode || k[lt].attr("fill", "rgba(0,0,0,0.0001)"), k[lt];
            }, K, J, $, et = j.spacingBox.height + (G ? -H : H) - V, st = this.nav, at = this.clipRect;
            return D.layout !== "horizontal" || D.verticalAlign === "middle" || D.floating || (et /= 2), F && (et = Math.min(et, F)), N.length = 0, m && et > 0 && m > et && U.enabled !== !1 ? (this.clipHeight = K = Math.max(et - 20 - this.titleHeight - V, 0), this.currentPage = o(this.currentPage, 1), this.fullHeight = m, X.forEach((lt, it) => {
              let Q = ($ = lt.legendItem || {}).y || 0, ot = Math.round($.label.getBBox().height), nt = N.length;
              (!nt || Q - N[nt - 1] > K && (J || Q) !== N[nt - 1]) && (N.push(J || Q), nt++), $.pageIx = nt - 1, J && ((X[it - 1].legendItem || {}).pageIx = nt - 1), it === X.length - 1 && Q + ot - N[nt - 1] > K && Q > N[nt - 1] && (N.push(Q), $.pageIx = nt), Q !== J && (J = Q);
            }), at || (at = k.clipRect = P.clipRect(0, V - 2, 9999, 0), k.contentGroup.clip(at)), W(K), st || (this.nav = st = P.g().attr({ zIndex: 1 }).add(this.group), this.up = P.symbol("triangle", 0, 0, q, q).add(st), _("upTracker").on("click", function() {
              k.scroll(-1, Y);
            }), this.pager = P.text("", 15, 10).addClass("highcharts-legend-navigation"), !j.styledMode && U.style && this.pager.css(U.style), this.pager.add(st), this.down = P.symbol("triangle-down", 0, 0, q, q).add(st), _("downTracker").on("click", function() {
              k.scroll(1, Y);
            })), k.scroll(0), m = et) : st && (W(), this.nav = st.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), m;
          }
          scroll(m, k) {
            let j = this.chart, P = this.pages, D = P.length, H = this.clipHeight, G = this.options.navigation, V = this.pager, F = this.padding, U = this.currentPage + m;
            U > D && (U = D), U > 0 && (k !== void 0 && l(k, j), this.nav.attr({ translateX: F, translateY: H + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(Y) {
              Y.attr({ class: U === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
            }), V.attr({ text: U + "/" + D }), [this.down, this.downTracker].forEach(function(Y) {
              Y.attr({ x: 18 + this.pager.getBBox().width, class: U === D ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
            }, this), j.styledMode || (this.up.attr({ fill: U === 1 ? G.inactiveColor : G.activeColor }), this.upTracker.css({ cursor: U === 1 ? "default" : "pointer" }), this.down.attr({ fill: U === D ? G.inactiveColor : G.activeColor }), this.downTracker.css({ cursor: U === D ? "default" : "pointer" })), this.scrollOffset = -P[U - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = U, this.positionCheckboxes(), d(() => {
              b(this, "afterScroll", { currentPage: U });
            }, A(o(k, j.renderer.globalAnimation, !0)).duration));
          }
          setItemEvents(m, k, j) {
            let P = this, D = m.legendItem || {}, H = P.chart.renderer.boxWrapper, G = m instanceof z, V = m instanceof R, F = "highcharts-legend-" + (G ? "point" : "series") + "-active", U = P.chart.styledMode, Y = j ? [k, D.symbol] : [D.group], q = (N) => {
              P.allItems.forEach((X) => {
                m !== X && [X].concat(X.linkedSeries || []).forEach((W) => {
                  W.setState(N, !G);
                });
              });
            };
            for (let N of Y) N && N.on("mouseover", function() {
              m.visible && q("inactive"), m.setState("hover"), m.visible && H.addClass(F), U || k.css(P.options.itemHoverStyle);
            }).on("mouseout", function() {
              P.chart.styledMode || k.css(C(m.visible ? P.itemStyle : P.itemHiddenStyle)), q(""), H.removeClass(F), m.setState();
            }).on("click", function(X) {
              let W = function() {
                m.setVisible && m.setVisible(), q(m.visible ? "inactive" : "");
              };
              H.removeClass(F), b(P, "itemClick", { browserEvent: X, legendItem: m }, W), G ? m.firePointEvent("legendItemClick", { browserEvent: X }) : V && b(m, "legendItemClick", { browserEvent: X });
            });
          }
          createCheckboxForItem(m) {
            m.checkbox = h("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: m.selected, defaultChecked: m.selected }, this.options.itemCheckboxStyle, this.chart.container), y(m.checkbox, "click", function(k) {
              let j = k.target;
              b(m.series || m, "checkboxClick", { checked: j.checked, item: m }, function() {
                m.select();
              });
            });
          }
        }
        return (w = i).compose = function(g) {
          t(c, "Core.Legend") && y(g, "beforeMargins", function() {
            this.legend = new w(this, this.options.legend);
          });
        }, i;
      }), Z(r, "Core/Chart/Chart.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Axis/Axis.js"], r["Core/Defaults.js"], r["Core/Templating.js"], r["Core/Foundation.js"], r["Core/Globals.js"], r["Core/Renderer/RendererRegistry.js"], r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Time.js"], r["Core/Utilities.js"], r["Core/Renderer/HTML/AST.js"], r["Core/Axis/Tick.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u, c, v) {
        let { animate: s, animObject: f, setAnimation: y } = T, { defaultOptions: h, defaultTime: a } = I, { numberFormat: x } = R, { registerEventOptions: S } = z, { charts: E, doc: b, marginNames: p, svg: C, win: o } = O, { seriesTypes: t } = w, { addEvent: e, attr: n, createElement: d, css: i, defined: g, diffObjects: m, discardElement: k, erase: j, error: P, extend: D, find: H, fireEvent: G, getStyle: V, isArray: F, isNumber: U, isObject: Y, isString: q, merge: N, objectEach: X, pick: W, pInt: _, relativeLength: K, removeEvent: J, splat: $, syncTimeout: et, uniqueKey: st } = u;
        class at {
          static chart(it, Q, ot) {
            return new at(it, Q, ot);
          }
          constructor(it, Q, ot) {
            this.sharedClips = {};
            let nt = [...arguments];
            (q(it) || it.nodeName) && (this.renderTo = nt.shift()), this.init(nt[0], nt[1]);
          }
          setZoomOptions() {
            let it = this.options.chart, Q = it.zooming;
            this.zooming = { ...Q, type: W(it.zoomType, Q.type), key: W(it.zoomKey, Q.key), pinchType: W(it.pinchType, Q.pinchType), singleTouch: W(it.zoomBySingleTouch, Q.singleTouch, !1), resetButton: N(Q.resetButton, it.resetZoomButton) };
          }
          init(it, Q) {
            G(this, "init", { args: arguments }, function() {
              let ot = N(h, it), nt = ot.chart;
              this.userOptions = D({}, it), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = Q, this.isResizing = 0, this.options = ot, this.axes = [], this.series = [], this.time = it.time && Object.keys(it.time).length ? new l(it.time) : O.time, this.numberFormatter = nt.numberFormatter || x, this.styledMode = nt.styledMode, this.hasCartesianSeries = nt.showAxes, this.index = E.length, E.push(this), O.chartCount++, S(this, nt), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), G(this, "afterInit"), this.firstRender();
            });
          }
          initSeries(it) {
            let Q = this.options.chart, ot = it.type || Q.type, nt = t[ot];
            nt || P(17, !0, this, { missingModuleFor: ot });
            let ht = new nt();
            return typeof ht.init == "function" && ht.init(this, it), ht;
          }
          setSortedData() {
            this.getSeriesOrderByLinks().forEach(function(it) {
              it.points || it.data || !it.enabledDataSorting || it.setData(it.options.data, !1);
            });
          }
          getSeriesOrderByLinks() {
            return this.series.concat().sort(function(it, Q) {
              return it.linkedSeries.length || Q.linkedSeries.length ? Q.linkedSeries.length - it.linkedSeries.length : 0;
            });
          }
          orderItems(it, Q = 0) {
            let ot = this[it], nt = this.options[it] = $(this.options[it]).slice(), ht = this.userOptions[it] = this.userOptions[it] ? $(this.userOptions[it]).slice() : [];
            if (this.hasRendered && (nt.splice(Q), ht.splice(Q)), ot) for (let ct = Q, dt = ot.length; ct < dt; ++ct) {
              let ut = ot[ct];
              ut && (ut.index = ct, ut instanceof M && (ut.name = ut.getName()), ut.options.isInternal || (nt[ct] = ut.options, ht[ct] = ut.userOptions));
            }
          }
          isInsidePlot(it, Q, ot = {}) {
            var vt;
            let { inverted: nt, plotBox: ht, plotLeft: ct, plotTop: dt, scrollablePlotBox: ut } = this, { scrollLeft: pt = 0, scrollTop: gt = 0 } = ot.visiblePlotOnly && ((vt = this.scrollablePlotArea) == null ? void 0 : vt.scrollingContainer) || {}, ft = ot.series, mt = ot.visiblePlotOnly && ut || ht, yt = ot.inverted ? Q : it, xt = ot.inverted ? it : Q, bt = { x: yt, y: xt, isInsidePlot: !0, options: ot };
            if (!ot.ignoreX) {
              let Ct = ft && (nt && !this.polar ? ft.yAxis : ft.xAxis) || { pos: ct, len: 1 / 0 }, At = ot.paneCoordinates ? Ct.pos + yt : ct + yt;
              At >= Math.max(pt + ct, Ct.pos) && At <= Math.min(pt + ct + mt.width, Ct.pos + Ct.len) || (bt.isInsidePlot = !1);
            }
            if (!ot.ignoreY && bt.isInsidePlot) {
              let Ct = !nt && ot.axis && !ot.axis.isXAxis && ot.axis || ft && (nt ? ft.xAxis : ft.yAxis) || { pos: dt, len: 1 / 0 }, At = ot.paneCoordinates ? Ct.pos + xt : dt + xt;
              At >= Math.max(gt + dt, Ct.pos) && At <= Math.min(gt + dt + mt.height, Ct.pos + Ct.len) || (bt.isInsidePlot = !1);
            }
            return G(this, "afterIsInsidePlot", bt), bt.isInsidePlot;
          }
          redraw(it) {
            G(this, "beforeRedraw");
            let Q = this.hasCartesianSeries ? this.axes : this.colorAxis || [], ot = this.series, nt = this.pointer, ht = this.legend, ct = this.userOptions.legend, dt = this.renderer, ut = dt.isHidden(), pt = [], gt, ft, mt, yt = this.isDirtyBox, xt = this.isDirtyLegend, bt;
            for (dt.rootFontSize = dt.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), y(!!this.hasRendered && it, this), ut && this.temporaryDisplay(), this.layOutTitles(!1), mt = ot.length; mt--; ) if (((bt = ot[mt]).options.stacking || bt.options.centerInCategory) && (ft = !0, bt.isDirty)) {
              gt = !0;
              break;
            }
            if (gt) for (mt = ot.length; mt--; ) (bt = ot[mt]).options.stacking && (bt.isDirty = !0);
            ot.forEach(function(vt) {
              vt.isDirty && (vt.options.legendType === "point" ? (typeof vt.updateTotals == "function" && vt.updateTotals(), xt = !0) : ct && (ct.labelFormatter || ct.labelFormat) && (xt = !0)), vt.isDirtyData && G(vt, "updatedData");
            }), xt && ht && ht.options.enabled && (ht.render(), this.isDirtyLegend = !1), ft && this.getStacks(), Q.forEach(function(vt) {
              vt.updateNames(), vt.setScale();
            }), this.getMargins(), Q.forEach(function(vt) {
              vt.isDirty && (yt = !0);
            }), Q.forEach(function(vt) {
              let Ct = vt.min + "," + vt.max;
              vt.extKey !== Ct && (vt.extKey = Ct, pt.push(function() {
                G(vt, "afterSetExtremes", D(vt.eventArgs, vt.getExtremes())), delete vt.eventArgs;
              })), (yt || ft) && vt.redraw();
            }), yt && this.drawChartBox(), G(this, "predraw"), ot.forEach(function(vt) {
              (yt || vt.isDirty) && vt.visible && vt.redraw(), vt.isDirtyData = !1;
            }), nt && nt.reset(!0), dt.draw(), G(this, "redraw"), G(this, "render"), ut && this.temporaryDisplay(!0), pt.forEach(function(vt) {
              vt.call();
            });
          }
          get(it) {
            let Q = this.series;
            function ot(ht) {
              return ht.id === it || ht.options && ht.options.id === it;
            }
            let nt = H(this.axes, ot) || H(this.series, ot);
            for (let ht = 0; !nt && ht < Q.length; ht++) nt = H(Q[ht].points || [], ot);
            return nt;
          }
          getAxes() {
            let it = this.userOptions;
            for (let Q of (G(this, "getAxes"), ["xAxis", "yAxis"])) for (let ot of it[Q] = $(it[Q] || {})) new B(this, ot, Q);
            G(this, "afterGetAxes");
          }
          getSelectedPoints() {
            return this.series.reduce((it, Q) => (Q.getPointsCollection().forEach((ot) => {
              W(ot.selectedStaging, ot.selected) && it.push(ot);
            }), it), []);
          }
          getSelectedSeries() {
            return this.series.filter(function(it) {
              return it.selected;
            });
          }
          setTitle(it, Q, ot) {
            this.applyDescription("title", it), this.applyDescription("subtitle", Q), this.applyDescription("caption", void 0), this.layOutTitles(ot);
          }
          applyDescription(it, Q) {
            let ot = this, nt = this.options[it] = N(this.options[it], Q), ht = this[it];
            ht && Q && (this[it] = ht = ht.destroy()), nt && !ht && ((ht = this.renderer.text(nt.text, 0, 0, nt.useHTML).attr({ align: nt.align, class: "highcharts-" + it, zIndex: nt.zIndex || 4 }).add()).update = function(ct, dt) {
              ot.applyDescription(it, ct), ot.layOutTitles(dt);
            }, this.styledMode || ht.css(D(it === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, nt.style)), this[it] = ht);
          }
          layOutTitles(it = !0) {
            let Q = [0, 0, 0], ot = this.renderer, nt = this.spacingBox;
            ["title", "subtitle", "caption"].forEach(function(ct) {
              let dt = this[ct], ut = this.options[ct], pt = ut.verticalAlign || "top", gt = ct === "title" ? pt === "top" ? -3 : 0 : pt === "top" ? Q[0] + 2 : 0;
              if (dt) {
                dt.css({ width: (ut.width || nt.width + (ut.widthAdjust || 0)) + "px" });
                let ft = ot.fontMetrics(dt).b, mt = Math.round(dt.getBBox(ut.useHTML).height);
                dt.align(D({ y: pt === "bottom" ? ft : gt + ft, height: mt }, ut), !1, "spacingBox"), ut.floating || (pt === "top" ? Q[0] = Math.ceil(Q[0] + mt) : pt === "bottom" && (Q[2] = Math.ceil(Q[2] + mt)));
              }
            }, this), Q[0] && (this.options.title.verticalAlign || "top") === "top" && (Q[0] += this.options.title.margin), Q[2] && this.options.caption.verticalAlign === "bottom" && (Q[2] += this.options.caption.margin);
            let ht = !this.titleOffset || this.titleOffset.join(",") !== Q.join(",");
            this.titleOffset = Q, G(this, "afterLayOutTitles"), !this.isDirtyBox && ht && (this.isDirtyBox = this.isDirtyLegend = ht, this.hasRendered && it && this.isDirtyBox && this.redraw());
          }
          getContainerBox() {
            let it = [].map.call(this.renderTo.children, (ot) => {
              if (ot !== this.container) {
                let nt = ot.style.display;
                return ot.style.display = "none", [ot, nt];
              }
            }), Q = { width: V(this.renderTo, "width", !0) || 0, height: V(this.renderTo, "height", !0) || 0 };
            return it.filter(Boolean).forEach(([ot, nt]) => {
              ot.style.display = nt;
            }), Q;
          }
          getChartSize() {
            var ct;
            let it = this.options.chart, Q = it.width, ot = it.height, nt = this.getContainerBox(), ht = nt.height > 1 && !(!((ct = this.renderTo.parentElement) != null && ct.style.height) && this.renderTo.style.height === "100%");
            this.chartWidth = Math.max(0, Q || nt.width || 600), this.chartHeight = Math.max(0, K(ot, this.chartWidth) || (ht ? nt.height : 400)), this.containerBox = nt;
          }
          temporaryDisplay(it) {
            let Q = this.renderTo, ot;
            if (it) for (; Q && Q.style; ) Q.hcOrigStyle && (i(Q, Q.hcOrigStyle), delete Q.hcOrigStyle), Q.hcOrigDetached && (b.body.removeChild(Q), Q.hcOrigDetached = !1), Q = Q.parentNode;
            else for (; Q && Q.style && (b.body.contains(Q) || Q.parentNode || (Q.hcOrigDetached = !0, b.body.appendChild(Q)), (V(Q, "display", !1) === "none" || Q.hcOricDetached) && (Q.hcOrigStyle = { display: Q.style.display, height: Q.style.height, overflow: Q.style.overflow }, ot = { display: "block", overflow: "hidden" }, Q !== this.renderTo && (ot.height = 0), i(Q, ot), Q.offsetWidth || Q.style.setProperty("display", "block", "important")), (Q = Q.parentNode) !== b.body); ) ;
          }
          setClassName(it) {
            this.container.className = "highcharts-container " + (it || "");
          }
          getContainer() {
            var mt;
            let it = this.options, Q = it.chart, ot = "data-highcharts-chart", nt = st(), ht, ct = this.renderTo;
            ct || (this.renderTo = ct = Q.renderTo), q(ct) && (this.renderTo = ct = b.getElementById(ct)), ct || P(13, !0, this);
            let dt = _(n(ct, ot));
            U(dt) && E[dt] && E[dt].hasRendered && E[dt].destroy(), n(ct, ot, this.index), ct.innerHTML = c.emptyHTML, Q.skipClone || ct.offsetWidth || this.temporaryDisplay(), this.getChartSize();
            let ut = this.chartHeight, pt = this.chartWidth;
            i(ct, { overflow: "hidden" }), this.styledMode || (ht = D({ position: "relative", overflow: "hidden", width: pt + "px", height: ut + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, Q.style || {}));
            let gt = d("div", { id: nt }, ht, ct);
            this.container = gt, this.getChartSize(), pt === this.chartWidth || (pt = this.chartWidth, this.styledMode || i(gt, { width: W((mt = Q.style) == null ? void 0 : mt.width, pt + "px") })), this.containerBox = this.getContainerBox(), this._cursor = gt.style.cursor;
            let ft = Q.renderer || !C ? L.getRendererType(Q.renderer) : A;
            if (this.renderer = new ft(gt, pt, ut, void 0, Q.forExport, it.exporting && it.exporting.allowHTML, this.styledMode), y(void 0, this), this.setClassName(Q.className), this.styledMode) for (let yt in it.defs) this.renderer.definition(it.defs[yt]);
            else this.renderer.setStyle(Q.style);
            this.renderer.chartIndex = this.index, G(this, "afterGetContainer");
          }
          getMargins(it) {
            let { spacing: Q, margin: ot, titleOffset: nt } = this;
            this.resetMargins(), nt[0] && !g(ot[0]) && (this.plotTop = Math.max(this.plotTop, nt[0] + Q[0])), nt[2] && !g(ot[2]) && (this.marginBottom = Math.max(this.marginBottom, nt[2] + Q[2])), this.legend && this.legend.display && this.legend.adjustMargins(ot, Q), G(this, "getMargins"), it || this.getAxisMargins();
          }
          getAxisMargins() {
            let it = this, Q = it.axisOffset = [0, 0, 0, 0], ot = it.colorAxis, nt = it.margin, ht = function(ct) {
              ct.forEach(function(dt) {
                dt.visible && dt.getOffset();
              });
            };
            it.hasCartesianSeries ? ht(it.axes) : ot && ot.length && ht(ot), p.forEach(function(ct, dt) {
              g(nt[dt]) || (it[ct] += Q[dt]);
            }), it.setChartSize();
          }
          getOptions() {
            return m(this.userOptions, h);
          }
          reflow(it) {
            var ht;
            let Q = this, ot = Q.containerBox, nt = Q.getContainerBox();
            (ht = Q.pointer) == null || delete ht.chartPosition, !Q.isPrinting && !Q.isResizing && ot && nt.width && ((nt.width !== ot.width || nt.height !== ot.height) && (u.clearTimeout(Q.reflowTimeout), Q.reflowTimeout = et(function() {
              Q.container && Q.setSize(void 0, void 0, !1);
            }, it ? 100 : 0)), Q.containerBox = nt);
          }
          setReflow() {
            let it = this, Q = (ot) => {
              var nt;
              (nt = it.options) != null && nt.chart.reflow && it.hasLoaded && it.reflow(ot);
            };
            if (typeof ResizeObserver == "function") new ResizeObserver(Q).observe(it.renderTo);
            else {
              let ot = e(o, "resize", Q);
              e(this, "destroy", ot);
            }
          }
          setSize(it, Q, ot) {
            let nt = this, ht = nt.renderer;
            nt.isResizing += 1, y(ot, nt);
            let ct = ht.globalAnimation;
            nt.oldChartHeight = nt.chartHeight, nt.oldChartWidth = nt.chartWidth, it !== void 0 && (nt.options.chart.width = it), Q !== void 0 && (nt.options.chart.height = Q), nt.getChartSize();
            let { chartWidth: dt, chartHeight: ut, scrollablePixelsX: pt = 0, scrollablePixelsY: gt = 0 } = nt;
            (nt.isDirtyBox || dt !== nt.oldChartWidth || ut !== nt.oldChartHeight) && (nt.styledMode || (ct ? s : i)(nt.container, { width: `${dt + pt}px`, height: `${ut + gt}px` }, ct), nt.setChartSize(!0), ht.setSize(dt, ut, ct), nt.axes.forEach(function(ft) {
              ft.isDirty = !0, ft.setScale();
            }), nt.isDirtyLegend = !0, nt.isDirtyBox = !0, nt.layOutTitles(), nt.getMargins(), nt.redraw(ct), nt.oldChartHeight = void 0, G(nt, "resize"), setTimeout(() => {
              nt && G(nt, "endResize");
            }, f(ct).duration)), nt.isResizing -= 1;
          }
          setChartSize(it) {
            let Q, ot, nt, ht, { chartHeight: ct, chartWidth: dt, inverted: ut, spacing: pt, renderer: gt } = this, ft = this.clipOffset, mt = Math[ut ? "floor" : "round"];
            this.plotLeft = Q = Math.round(this.plotLeft), this.plotTop = ot = Math.round(this.plotTop), this.plotWidth = nt = Math.max(0, Math.round(dt - Q - this.marginRight)), this.plotHeight = ht = Math.max(0, Math.round(ct - ot - this.marginBottom)), this.plotSizeX = ut ? ht : nt, this.plotSizeY = ut ? nt : ht, this.spacingBox = gt.spacingBox = { x: pt[3], y: pt[0], width: dt - pt[3] - pt[1], height: ct - pt[0] - pt[2] }, this.plotBox = gt.plotBox = { x: Q, y: ot, width: nt, height: ht }, ft && (this.clipBox = { x: mt(ft[3]), y: mt(ft[0]), width: mt(this.plotSizeX - ft[1] - ft[3]), height: mt(this.plotSizeY - ft[0] - ft[2]) }), it || (this.axes.forEach(function(yt) {
              yt.setAxisSize(), yt.setAxisTranslation();
            }), gt.alignElements()), G(this, "afterSetChartSize", { skipAxes: it });
          }
          resetMargins() {
            G(this, "resetMargins");
            let it = this, Q = it.options.chart, ot = Q.plotBorderWidth || 0, nt = ot / 2;
            ["margin", "spacing"].forEach(function(ht) {
              let ct = Q[ht], dt = Y(ct) ? ct : [ct, ct, ct, ct];
              ["Top", "Right", "Bottom", "Left"].forEach(function(ut, pt) {
                it[ht][pt] = W(Q[ht + ut], dt[pt]);
              });
            }), p.forEach(function(ht, ct) {
              it[ht] = W(it.margin[ct], it.spacing[ct]);
            }), it.axisOffset = [0, 0, 0, 0], it.clipOffset = [nt, nt, nt, nt], it.plotBorderWidth = ot;
          }
          drawChartBox() {
            let it = this.options.chart, Q = this.renderer, ot = this.chartWidth, nt = this.chartHeight, ht = this.styledMode, ct = this.plotBGImage, dt = it.backgroundColor, ut = it.plotBackgroundColor, pt = it.plotBackgroundImage, gt = this.plotLeft, ft = this.plotTop, mt = this.plotWidth, yt = this.plotHeight, xt = this.plotBox, bt = this.clipRect, vt = this.clipBox, Ct = this.chartBackground, At = this.plotBackground, Mt = this.plotBorder, kt, Pt, jt, Lt = "animate";
            Ct || (this.chartBackground = Ct = Q.rect().addClass("highcharts-background").add(), Lt = "attr"), ht ? kt = Pt = Ct.strokeWidth() : (Pt = (kt = it.borderWidth || 0) + (it.shadow ? 8 : 0), jt = { fill: dt || "none" }, (kt || Ct["stroke-width"]) && (jt.stroke = it.borderColor, jt["stroke-width"] = kt), Ct.attr(jt).shadow(it.shadow)), Ct[Lt]({ x: Pt / 2, y: Pt / 2, width: ot - Pt - kt % 2, height: nt - Pt - kt % 2, r: it.borderRadius }), Lt = "animate", At || (Lt = "attr", this.plotBackground = At = Q.rect().addClass("highcharts-plot-background").add()), At[Lt](xt), !ht && (At.attr({ fill: ut || "none" }).shadow(it.plotShadow), pt && (ct ? (pt !== ct.attr("href") && ct.attr("href", pt), ct.animate(xt)) : this.plotBGImage = Q.image(pt, gt, ft, mt, yt).add())), bt ? bt.animate({ width: vt.width, height: vt.height }) : this.clipRect = Q.clipRect(vt), Lt = "animate", Mt || (Lt = "attr", this.plotBorder = Mt = Q.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ht || Mt.attr({ stroke: it.plotBorderColor, "stroke-width": it.plotBorderWidth || 0, fill: "none" }), Mt[Lt](Mt.crisp({ x: gt, y: ft, width: mt, height: yt }, -Mt.strokeWidth())), this.isDirtyBox = !1, G(this, "afterDrawChartBox");
          }
          propFromSeries() {
            let it, Q, ot, nt = this, ht = nt.options.chart, ct = nt.options.series;
            ["inverted", "angular", "polar"].forEach(function(dt) {
              for (Q = t[ht.type], ot = ht[dt] || Q && Q.prototype[dt], it = ct && ct.length; !ot && it--; ) (Q = t[ct[it].type]) && Q.prototype[dt] && (ot = !0);
              nt[dt] = ot;
            });
          }
          linkSeries(it) {
            let Q = this, ot = Q.series;
            ot.forEach(function(nt) {
              nt.linkedSeries.length = 0;
            }), ot.forEach(function(nt) {
              let { linkedTo: ht } = nt.options;
              if (q(ht)) {
                let ct;
                (ct = ht === ":previous" ? Q.series[nt.index - 1] : Q.get(ht)) && ct.linkedParent !== nt && (ct.linkedSeries.push(nt), nt.linkedParent = ct, ct.enabledDataSorting && nt.setDataSortingOptions(), nt.visible = W(nt.options.visible, ct.options.visible, nt.visible));
              }
            }), G(this, "afterLinkSeries", { isUpdating: it });
          }
          renderSeries() {
            this.series.forEach(function(it) {
              it.translate(), it.render();
            });
          }
          render() {
            var gt;
            let it = this.axes, Q = this.colorAxis, ot = this.renderer, nt = this.options.chart.axisLayoutRuns || 2, ht = (ft) => {
              ft.forEach((mt) => {
                mt.visible && mt.render();
              });
            }, ct = 0, dt = !0, ut, pt = 0;
            for (let ft of (this.setTitle(), G(this, "beforeMargins"), (gt = this.getStacks) == null || gt.call(this), this.getMargins(!0), this.setChartSize(), it)) {
              let { options: mt } = ft, { labels: yt } = mt;
              if (this.hasCartesianSeries && ft.horiz && ft.visible && yt.enabled && ft.series.length && ft.coll !== "colorAxis" && !this.polar) {
                ct = mt.tickLength, ft.createGroups();
                let xt = new v(ft, 0, "", !0), bt = xt.createLabel("x", yt);
                if (xt.destroy(), bt && W(yt.reserveSpace, !U(mt.crossing)) && (ct = bt.getBBox().height + yt.distance + Math.max(mt.offset || 0, 0)), ct) {
                  bt == null || bt.destroy();
                  break;
                }
              }
            }
            for (this.plotHeight = Math.max(this.plotHeight - ct, 0); (dt || ut || nt > 1) && pt < nt; ) {
              let ft = this.plotWidth, mt = this.plotHeight;
              for (let yt of it) pt === 0 ? yt.setScale() : (yt.horiz && dt || !yt.horiz && ut) && yt.setTickInterval(!0);
              pt === 0 ? this.getAxisMargins() : this.getMargins(), dt = ft / this.plotWidth > (pt ? 1 : 1.1), ut = mt / this.plotHeight > (pt ? 1 : 1.05), pt++;
            }
            this.drawChartBox(), this.hasCartesianSeries ? ht(it) : Q && Q.length && ht(Q), this.seriesGroup || (this.seriesGroup = ot.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
          }
          addCredits(it) {
            let Q = this, ot = N(!0, this.options.credits, it);
            ot.enabled && !this.credits && (this.credits = this.renderer.text(ot.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
              ot.href && (o.location.href = ot.href);
            }).attr({ align: ot.position.align, zIndex: 8 }), Q.styledMode || this.credits.css(ot.style), this.credits.add().align(ot.position), this.credits.update = function(nt) {
              Q.credits = Q.credits.destroy(), Q.addCredits(nt);
            });
          }
          destroy() {
            let it, Q = this, ot = Q.axes, nt = Q.series, ht = Q.container, ct = ht && ht.parentNode;
            for (G(Q, "destroy"), Q.renderer.forExport ? j(E, Q) : E[Q.index] = void 0, O.chartCount--, Q.renderTo.removeAttribute("data-highcharts-chart"), J(Q), it = ot.length; it--; ) ot[it] = ot[it].destroy();
            for (this.scroller && this.scroller.destroy && this.scroller.destroy(), it = nt.length; it--; ) nt[it] = nt[it].destroy();
            ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(dt) {
              let ut = Q[dt];
              ut && ut.destroy && (Q[dt] = ut.destroy());
            }), ht && (ht.innerHTML = c.emptyHTML, J(ht), ct && k(ht)), X(Q, function(dt, ut) {
              delete Q[ut];
            });
          }
          firstRender() {
            var nt;
            let it = this, Q = it.options;
            it.getContainer(), it.resetMargins(), it.setChartSize(), it.propFromSeries(), it.getAxes();
            let ot = F(Q.series) ? Q.series : [];
            Q.series = [], ot.forEach(function(ht) {
              it.initSeries(ht);
            }), it.linkSeries(), it.setSortedData(), G(it, "beforeRender"), it.render(), (nt = it.pointer) == null || nt.getChartPosition(), it.renderer.imgCount || it.hasLoaded || it.onload(), it.temporaryDisplay(!0);
          }
          onload() {
            this.callbacks.concat([this.callback]).forEach(function(it) {
              it && this.index !== void 0 && it.apply(this, [this]);
            }, this), G(this, "load"), G(this, "render"), g(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
          }
          warnIfA11yModuleNotLoaded() {
            let { options: it, title: Q } = this;
            !it || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (Q && Q.element.textContent || "").replace(/</g, "&lt;") }), it.accessibility && it.accessibility.enabled === !1 || P('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
          }
          addSeries(it, Q, ot) {
            let nt, ht = this;
            return it && (Q = W(Q, !0), G(ht, "addSeries", { options: it }, function() {
              nt = ht.initSeries(it), ht.isDirtyLegend = !0, ht.linkSeries(), nt.enabledDataSorting && nt.setData(it.data, !1), G(ht, "afterAddSeries", { series: nt }), Q && ht.redraw(ot);
            })), nt;
          }
          addAxis(it, Q, ot, nt) {
            return this.createAxis(Q ? "xAxis" : "yAxis", { axis: it, redraw: ot, animation: nt });
          }
          addColorAxis(it, Q, ot) {
            return this.createAxis("colorAxis", { axis: it, redraw: Q, animation: ot });
          }
          createAxis(it, Q) {
            let ot = new B(this, Q.axis, it);
            return W(Q.redraw, !0) && this.redraw(Q.animation), ot;
          }
          showLoading(it) {
            let Q = this, ot = Q.options, nt = ot.loading, ht = function() {
              ct && i(ct, { left: Q.plotLeft + "px", top: Q.plotTop + "px", width: Q.plotWidth + "px", height: Q.plotHeight + "px" });
            }, ct = Q.loadingDiv, dt = Q.loadingSpan;
            ct || (Q.loadingDiv = ct = d("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, Q.container)), dt || (Q.loadingSpan = dt = d("span", { className: "highcharts-loading-inner" }, null, ct), e(Q, "redraw", ht)), ct.className = "highcharts-loading", c.setElementHTML(dt, W(it, ot.lang.loading, "")), Q.styledMode || (i(ct, D(nt.style, { zIndex: 10 })), i(dt, nt.labelStyle), Q.loadingShown || (i(ct, { opacity: 0, display: "" }), s(ct, { opacity: nt.style.opacity || 0.5 }, { duration: nt.showDuration || 0 }))), Q.loadingShown = !0, ht();
          }
          hideLoading() {
            let it = this.options, Q = this.loadingDiv;
            Q && (Q.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || s(Q, { opacity: 0 }, { duration: it.loading.hideDuration || 100, complete: function() {
              i(Q, { display: "none" });
            } })), this.loadingShown = !1;
          }
          update(it, Q, ot, nt) {
            let ht, ct, dt, ut = this, pt = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, gt = it.isResponsiveOptions, ft = [];
            G(ut, "update", { options: it }), gt || ut.setResponsive(!1, !0), it = m(it, ut.options), ut.userOptions = N(ut.userOptions, it);
            let mt = it.chart;
            mt && (N(!0, ut.options.chart, mt), this.setZoomOptions(), "className" in mt && ut.setClassName(mt.className), ("inverted" in mt || "polar" in mt || "type" in mt) && (ut.propFromSeries(), ht = !0), "alignTicks" in mt && (ht = !0), "events" in mt && S(this, mt), X(mt, function(bt, vt) {
              ut.propsRequireUpdateSeries.indexOf("chart." + vt) !== -1 && (ct = !0), ut.propsRequireDirtyBox.indexOf(vt) !== -1 && (ut.isDirtyBox = !0), ut.propsRequireReflow.indexOf(vt) === -1 || (ut.isDirtyBox = !0, gt || (dt = !0));
            }), !ut.styledMode && mt.style && ut.renderer.setStyle(ut.options.chart.style || {})), !ut.styledMode && it.colors && (this.options.colors = it.colors), it.time && (this.time === a && (this.time = new l(it.time)), N(!0, ut.options.time, it.time)), X(it, function(bt, vt) {
              ut[vt] && typeof ut[vt].update == "function" ? ut[vt].update(bt, !1) : typeof ut[pt[vt]] == "function" ? ut[pt[vt]](bt) : vt !== "colors" && ut.collectionsWithUpdate.indexOf(vt) === -1 && N(!0, ut.options[vt], it[vt]), vt !== "chart" && ut.propsRequireUpdateSeries.indexOf(vt) !== -1 && (ct = !0);
            }), this.collectionsWithUpdate.forEach(function(bt) {
              it[bt] && ($(it[bt]).forEach(function(vt, Ct) {
                let At, Mt = g(vt.id);
                Mt && (At = ut.get(vt.id)), !At && ut[bt] && (At = ut[bt][W(vt.index, Ct)]) && (Mt && g(At.options.id) || At.options.isInternal) && (At = void 0), At && At.coll === bt && (At.update(vt, !1), ot && (At.touched = !0)), !At && ot && ut.collectionsWithInit[bt] && (ut.collectionsWithInit[bt][0].apply(ut, [vt].concat(ut.collectionsWithInit[bt][1] || []).concat([!1])).touched = !0);
              }), ot && ut[bt].forEach(function(vt) {
                vt.touched || vt.options.isInternal ? delete vt.touched : ft.push(vt);
              }));
            }), ft.forEach(function(bt) {
              bt.chart && bt.remove && bt.remove(!1);
            }), ht && ut.axes.forEach(function(bt) {
              bt.update({}, !1);
            }), ct && ut.getSeriesOrderByLinks().forEach(function(bt) {
              bt.chart && bt.update({}, !1);
            }, this);
            let yt = mt && mt.width, xt = mt && (q(mt.height) ? K(mt.height, yt || ut.chartWidth) : mt.height);
            dt || U(yt) && yt !== ut.chartWidth || U(xt) && xt !== ut.chartHeight ? ut.setSize(yt, xt, nt) : W(Q, !0) && ut.redraw(nt), G(ut, "afterUpdate", { options: it, redraw: Q, animation: nt });
          }
          setSubtitle(it, Q) {
            this.applyDescription("subtitle", it), this.layOutTitles(Q);
          }
          setCaption(it, Q) {
            this.applyDescription("caption", it), this.layOutTitles(Q);
          }
          showResetZoom() {
            let it = this, Q = h.lang, ot = it.zooming.resetButton, nt = ot.theme, ht = ot.relativeTo === "chart" || ot.relativeTo === "spacingBox" ? null : "plotBox";
            function ct() {
              it.zoomOut();
            }
            G(this, "beforeShowResetZoom", null, function() {
              it.resetZoomButton = it.renderer.button(Q.resetZoom, null, null, ct, nt).attr({ align: ot.position.align, title: Q.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(ot.position, !1, ht);
            }), G(this, "afterShowResetZoom");
          }
          zoomOut() {
            G(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
          }
          pan(it, Q) {
            let ot = this, nt = typeof Q == "object" ? Q : { enabled: Q, type: "x" }, ht = nt.type, ct = ht && ot[{ x: "xAxis", xy: "axes", y: "yAxis" }[ht]].filter((ut) => ut.options.panningEnabled && !ut.options.isInternal), dt = ot.options.chart;
            dt != null && dt.panning && (dt.panning = nt), G(this, "pan", { originalEvent: it }, () => {
              ot.transform({ axes: ct, event: it, to: { x: it.chartX - (ot.mouseDownX || 0), y: it.chartY - (ot.mouseDownY || 0) }, trigger: "pan" }), i(ot.container, { cursor: "move" });
            });
          }
          transform(it) {
            var yt;
            let { axes: Q = this.axes, event: ot, from: nt = {}, reset: ht, selection: ct, to: dt = {}, trigger: ut } = it, { inverted: pt } = this, gt = !1, ft, mt;
            for (let xt of ((yt = this.hoverPoints) == null || yt.forEach((bt) => bt.setState()), Q)) {
              let { horiz: bt, len: vt, minPointOffset: Ct = 0, options: At, reversed: Mt } = xt, kt = bt ? "width" : "height", Pt = bt ? "x" : "y", jt = W(dt[kt], xt.len), Lt = W(nt[kt], xt.len), Bt = 10 > Math.abs(jt) ? 1 : jt / Lt, Yt = (nt[Pt] || 0) + Lt / 2 - xt.pos, Ut = Yt - ((dt[Pt] ?? xt.pos) + jt / 2 - xt.pos) / Bt, Kt = Mt && !pt || !Mt && pt ? -1 : 1;
              if (!ht && (Yt < 0 || Yt > xt.len)) continue;
              let Dt = xt.toValue(Ut, !0) + (ct || xt.isOrdinal ? 0 : Ct * Kt), Nt = xt.toValue(Ut + vt / Bt, !0) - (ct || xt.isOrdinal ? 0 : Ct * Kt || 0), Gt = xt.allExtremes;
              if (Dt > Nt && ([Dt, Nt] = [Nt, Dt]), Bt === 1 && !ht && xt.coll === "yAxis" && !Gt) {
                for (let Os of xt.series) {
                  let oe = Os.getExtremes(Os.getProcessedData(!0).yData, !0);
                  Gt ?? (Gt = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), U(oe.dataMin) && U(oe.dataMax) && (Gt.dataMin = Math.min(oe.dataMin, Gt.dataMin), Gt.dataMax = Math.max(oe.dataMax, Gt.dataMax));
                }
                xt.allExtremes = Gt;
              }
              let { dataMin: mn, dataMax: xn, min: Ss, max: ks } = D(xt.getExtremes(), Gt || {}), Ps = mn ?? At.min, Ts = xn ?? At.max, xe = Nt - Dt, Es = xt.categories ? 0 : Math.min(xe, Ts - Ps), ye = Ps - Es * (g(At.min) ? 0 : At.minPadding), be = Ts + Es * (g(At.max) ? 0 : At.maxPadding), Ls = xt.allowZoomOutside || Bt === 1 || ut !== "zoom" && Bt > 1, ie = Math.min(At.min ?? ye, ye, Ls ? Ss : ye), se = Math.max(At.max ?? be, be, Ls ? ks : be);
              (!xt.isOrdinal || xt.options.overscroll || Bt !== 1 || ht) && (Dt < ie && (Dt = ie, Bt >= 1 && (Nt = Dt + xe)), Nt > se && (Nt = se, Bt >= 1 && (Dt = Nt - xe)), (ht || xt.series.length && (Dt !== Ss || Nt !== ks) && Dt >= ie && Nt <= se) && (ct ? ct[xt.coll].push({ axis: xt, min: Dt, max: Nt }) : (xt.isPanning = ut !== "zoom", xt.isPanning && (mt = !0), xt.setExtremes(ht ? void 0 : Dt, ht ? void 0 : Nt, !1, !1, { move: Ut, trigger: ut, scale: Bt }), !ht && (Dt > ie || Nt < se) && ut !== "mousewheel" && (ft = !0)), gt = !0), ot && (this[bt ? "mouseDownX" : "mouseDownY"] = ot[bt ? "chartX" : "chartY"]));
            }
            return gt && (ct ? G(this, "selection", ct, () => {
              delete it.selection, it.trigger = "zoom", this.transform(it);
            }) : (!ft || mt || this.resetZoomButton ? !ft && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(ut === "zoom" && (this.options.chart.animation ?? this.pointCount < 100)))), gt;
          }
        }
        return D(at.prototype, { callbacks: [], collectionsWithInit: { xAxis: [at.prototype.addAxis, [!0]], yAxis: [at.prototype.addAxis, [!1]], series: [at.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), at;
      }), Z(r, "Extensions/ScrollablePlotArea.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Globals.js"], r["Core/Renderer/RendererRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { stop: z } = T, { composed: O } = B, { addEvent: L, createElement: M, css: w, defined: A, merge: l, pushUnique: u } = R;
        function c() {
          let f = this.scrollablePlotArea;
          (this.scrollablePixelsX || this.scrollablePixelsY) && !f && (this.scrollablePlotArea = f = new s(this)), f == null || f.applyFixed();
        }
        function v() {
          this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
        }
        class s {
          static compose(y, h, a) {
            u(O, this.compose) && (L(y, "afterInit", v), L(h, "afterSetChartSize", (x) => this.afterSetSize(x.target, x)), L(h, "render", c), L(a, "show", v));
          }
          static afterSetSize(y, h) {
            let a, x, S, { minWidth: E, minHeight: b } = y.options.chart.scrollablePlotArea || {}, { clipBox: p, plotBox: C, inverted: o, renderer: t } = y;
            if (!t.forExport && (E ? (y.scrollablePixelsX = a = Math.max(0, E - y.chartWidth), a && (y.scrollablePlotBox = l(y.plotBox), C.width = y.plotWidth += a, p[o ? "height" : "width"] += a, S = !0)) : b && (y.scrollablePixelsY = x = Math.max(0, b - y.chartHeight), A(x) && (y.scrollablePlotBox = l(y.plotBox), C.height = y.plotHeight += x, p[o ? "width" : "height"] += x, S = !1)), A(S) && !h.skipAxes)) for (let e of y.axes) e.horiz === S && (e.setAxisSize(), e.setAxisTranslation());
          }
          constructor(y) {
            var n;
            let h, a = y.options.chart, x = I.getRendererType(), S = a.scrollablePlotArea || {}, E = this.moveFixedElements.bind(this), b = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
            y.scrollablePixelsX && (b.overflowX = "auto"), y.scrollablePixelsY && (b.overflowY = "auto"), this.chart = y;
            let p = this.parentDiv = M("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, y.renderTo), C = this.scrollingContainer = M("div", { className: "highcharts-scrolling" }, b, p), o = this.innerContainer = M("div", { className: "highcharts-inner-container" }, void 0, C), t = this.fixedDiv = M("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((n = a.style) == null ? void 0 : n.zIndex) || 0) + 2, top: 0 }, void 0, !0), e = this.fixedRenderer = new x(t, y.chartWidth, y.chartHeight, a.style);
            this.mask = e.path().attr({ fill: a.backgroundColor || "#fff", "fill-opacity": S.opacity ?? 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), C.parentNode.insertBefore(t, C), w(y.renderTo, { overflow: "visible" }), L(y, "afterShowResetZoom", E), L(y, "afterApplyDrilldown", E), L(y, "afterLayOutTitles", E), L(C, "scroll", () => {
              let { pointer: d, hoverPoint: i } = y;
              d && (delete d.chartPosition, i && (h = i), d.runPointActions(void 0, h, !0));
            }), o.appendChild(y.container);
          }
          applyFixed() {
            var U;
            let { chart: y, fixedRenderer: h, isDirty: a, scrollingContainer: x } = this, { axisOffset: S, chartWidth: E, chartHeight: b, container: p, plotHeight: C, plotLeft: o, plotTop: t, plotWidth: e, scrollablePixelsX: n = 0, scrollablePixelsY: d = 0 } = y, { scrollPositionX: i = 0, scrollPositionY: g = 0 } = y.options.chart.scrollablePlotArea || {}, m = E + n, k = b + d;
            h.setSize(E, b), (a ?? !0) && (this.isDirty = !1, this.moveFixedElements()), z(y.container), w(p, { width: `${m}px`, height: `${k}px` }), y.renderer.boxWrapper.attr({ width: m, height: k, viewBox: [0, 0, m, k].join(" ") }), (U = y.chartBackground) == null || U.attr({ width: m, height: k }), w(x, { width: `${E}px`, height: `${b}px` }), A(a) || (x.scrollLeft = n * i, x.scrollTop = d * g);
            let j = t - S[0] - 1, P = o - S[3] - 1, D = t + C + S[2] + 1, H = o + e + S[1] + 1, G = o + e - n, V = t + C - d, F = [["M", 0, 0]];
            n ? F = [["M", 0, j], ["L", o - 1, j], ["L", o - 1, D], ["L", 0, D], ["Z"], ["M", G, j], ["L", E, j], ["L", E, D], ["L", G, D], ["Z"]] : d && (F = [["M", P, 0], ["L", P, t - 1], ["L", H, t - 1], ["L", H, 0], ["Z"], ["M", P, V], ["L", P, b], ["L", H, b], ["L", H, V], ["Z"]]), y.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: F });
          }
          moveFixedElements() {
            let y, { container: h, inverted: a, scrollablePixelsX: x, scrollablePixelsY: S } = this.chart, E = this.fixedRenderer, b = s.fixedSelectors;
            for (let p of (x && !a ? y = ".highcharts-yaxis" : x && a || S && !a ? y = ".highcharts-xaxis" : S && a && (y = ".highcharts-yaxis"), y && b.push(`${y}:not(.highcharts-radial-axis)`, `${y}-labels:not(.highcharts-radial-axis-labels)`), b)) [].forEach.call(h.querySelectorAll(p), (C) => {
              (C.namespaceURI === E.SVG_NS ? E.box : E.box.parentNode).appendChild(C), C.style.pointerEvents = "auto";
            });
          }
        }
        return s.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], s;
      }), Z(r, "Core/Axis/Stacking/StackItem.js", [r["Core/Templating.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { format: R } = T, { series: z } = B, { destroyObjectProperties: O, fireEvent: L, isNumber: M, pick: w } = I;
        return class {
          constructor(A, l, u, c, v) {
            let s = A.chart.inverted, f = A.reversed;
            this.axis = A;
            let y = this.isNegative = !!u != !!f;
            this.options = l = l || {}, this.x = c, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = v, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: l.align || (s ? y ? "left" : "right" : "center"), verticalAlign: l.verticalAlign || (s ? "middle" : y ? "bottom" : "top"), y: l.y, x: l.x }, this.textAlign = l.textAlign || (s ? y ? "right" : "left" : "center");
          }
          destroy() {
            O(this, this.axis);
          }
          render(A) {
            let l = this.axis.chart, u = this.options, c = u.format, v = c ? R(c, this, l) : u.formatter.call(this);
            if (this.label) this.label.attr({ text: v, visibility: "hidden" });
            else {
              this.label = l.renderer.label(v, null, void 0, u.shape, void 0, void 0, u.useHTML, !1, "stack-labels");
              let s = { r: u.borderRadius || 0, text: v, padding: w(u.padding, 5), visibility: "hidden" };
              l.styledMode || (s.fill = u.backgroundColor, s.stroke = u.borderColor, s["stroke-width"] = u.borderWidth, this.label.css(u.style || {})), this.label.attr(s), this.label.added || this.label.add(A);
            }
            this.label.labelrank = l.plotSizeY, L(this, "afterRender");
          }
          setOffset(A, l, u, c, v, s) {
            let { alignOptions: f, axis: y, label: h, options: a, textAlign: x } = this, S = y.chart, E = this.getStackBox({ xOffset: A, width: l, boxBottom: u, boxTop: c, defaultX: v, xAxis: s }), { verticalAlign: b } = f;
            if (h && E) {
              let p = h.getBBox(void 0, 0), C = h.padding, o = w(a.overflow, "justify") === "justify", t;
              f.x = a.x || 0, f.y = a.y || 0;
              let { x: e, y: n } = this.adjustStackPosition({ labelBox: p, verticalAlign: b, textAlign: x });
              E.x -= e, E.y -= n, h.align(f, !1, E), (t = S.isInsidePlot(h.alignAttr.x + f.x + e, h.alignAttr.y + f.y + n)) || (o = !1), o && z.prototype.justifyDataLabel.call(y, h, f, h.alignAttr, p, E), h.attr({ x: h.alignAttr.x, y: h.alignAttr.y, rotation: a.rotation, rotationOriginX: p.width * { left: 0, center: 0.5, right: 1 }[a.textAlign || "center"], rotationOriginY: p.height / 2 }), w(!o && a.crop, !0) && (t = M(h.x) && M(h.y) && S.isInsidePlot(h.x - C + (h.width || 0), h.y) && S.isInsidePlot(h.x + C, h.y)), h[t ? "show" : "hide"]();
            }
            L(this, "afterSetOffset", { xOffset: A, width: l });
          }
          adjustStackPosition({ labelBox: A, verticalAlign: l, textAlign: u }) {
            let c = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, v = c[l], s = c[u];
            return { x: A.width / 2 + A.width / 2 * s, y: A.height / 2 * v };
          }
          getStackBox(A) {
            let l = this.axis, u = l.chart, { boxTop: c, defaultX: v, xOffset: s, width: f, boxBottom: y } = A, h = l.stacking.usePercentage ? 100 : w(c, this.total, 0), a = l.toPixels(h), x = A.xAxis || u.xAxis[0], S = w(v, x.translate(this.x)) + s, E = Math.abs(a - l.toPixels(y || M(l.min) && l.logarithmic && l.logarithmic.lin2log(l.min) || 0)), b = u.inverted, p = this.isNegative;
            return b ? { x: (p ? a : a - E) - u.plotLeft, y: x.height - S - f + x.top - u.plotTop, width: E, height: f } : { x: S + x.transB - u.plotLeft, y: (p ? a - E : a) - u.plotTop, width: f, height: E };
          }
        };
      }), Z(r, "Core/Axis/Stacking/StackingAxis.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Axis/Axis.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Axis/Stacking/StackItem.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        var O;
        let { getDeferredAnimation: L } = T, { series: { prototype: M } } = I, { addEvent: w, correctFloat: A, defined: l, destroyObjectProperties: u, fireEvent: c, isArray: v, isNumber: s, objectEach: f, pick: y } = z;
        function h() {
          let t = this.inverted;
          this.axes.forEach((e) => {
            e.stacking && e.stacking.stacks && e.hasVisibleSeries && (e.stacking.oldStacks = e.stacking.stacks);
          }), this.series.forEach((e) => {
            let n = e.xAxis && e.xAxis.options || {};
            e.options.stacking && e.reserveSpace() && (e.stackKey = [e.type, y(e.options.stack, ""), t ? n.top : n.left, t ? n.height : n.width].join(","));
          });
        }
        function a() {
          var e;
          let t = this.stacking;
          if (t) {
            let n = t.stacks;
            f(n, (d, i) => {
              u(d), delete n[i];
            }), (e = t.stackTotalGroup) == null || e.destroy();
          }
        }
        function x() {
          this.stacking || (this.stacking = new o(this));
        }
        function S(t, e, n, d) {
          return !l(t) || t.x !== e || d && t.stackKey !== d ? t = { x: e, index: 0, key: d, stackKey: d } : t.index++, t.key = [n, e, t.index].join(","), t;
        }
        function E() {
          let t, e = this, n = e.yAxis, d = e.stackKey || "", i = n.stacking.stacks, g = e.processedXData, m = e.options.stacking, k = e[m + "Stacker"];
          k && [d, "-" + d].forEach((j) => {
            var V;
            let P = g.length, D, H, G;
            for (; P--; ) D = g[P], t = e.getStackIndicator(t, D, e.index, j), H = (V = i[j]) == null ? void 0 : V[D], (G = H == null ? void 0 : H.points[t.key || ""]) && k.call(e, G, H, P);
          });
        }
        function b(t, e, n) {
          let d = e.total ? 100 / e.total : 0;
          t[0] = A(t[0] * d), t[1] = A(t[1] * d), this.stackedYData[n] = t[1];
        }
        function p(t) {
          (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? M.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
        }
        function C(t, e) {
          var st, at;
          let n, d, i, g, m, k, j, P, D, H = e || this.options.stacking;
          if (!H || !this.reserveSpace() || ({ group: "xAxis" }[H] || "yAxis") !== t.coll) return;
          let G = this.processedXData, V = this.processedYData, F = [], U = V.length, Y = this.options, q = Y.threshold || 0, N = Y.startFromThreshold ? q : 0, X = Y.stack, W = e ? `${this.type},${H}` : this.stackKey || "", _ = "-" + W, K = this.negStacks, J = t.stacking, $ = J.stacks, et = J.oldStacks;
          for (J.stacksTouched += 1, j = 0; j < U; j++) {
            P = G[j], D = V[j], k = (n = this.getStackIndicator(n, P, this.index)).key || "", $[m = (d = K && D < (N ? 0 : q)) ? _ : W] || ($[m] = {}), $[m][P] || ((st = et[m]) != null && st[P] ? ($[m][P] = et[m][P], $[m][P].total = null) : $[m][P] = new R(t, t.options.stackLabels, !!d, P, X)), i = $[m][P], D !== null ? (i.points[k] = i.points[this.index] = [y(i.cumulative, N)], l(i.cumulative) || (i.base = k), i.touched = J.stacksTouched, n.index > 0 && this.singleStacks === !1 && (i.points[k][0] = i.points[this.index + "," + P + ",0"][0])) : (delete i.points[k], delete i.points[this.index]);
            let lt = i.total || 0;
            H === "percent" ? (g = d ? W : _, lt = K && ((at = $[g]) != null && at[P]) ? (g = $[g][P]).total = Math.max(g.total || 0, lt) + Math.abs(D) || 0 : A(lt + (Math.abs(D) || 0))) : H === "group" ? (v(D) && (D = D[0]), D !== null && lt++) : lt = A(lt + (D || 0)), H === "group" ? i.cumulative = (lt || 1) - 1 : i.cumulative = A(y(i.cumulative, N) + (D || 0)), i.total = lt, D !== null && (i.points[k].push(i.cumulative), F[j] = i.cumulative, i.hasValidPoints = !0);
          }
          H === "percent" && (J.usePercentage = !0), H !== "group" && (this.stackedYData = F), J.oldStacks = {};
        }
        class o {
          constructor(e) {
            this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = e;
          }
          buildStacks() {
            let e, n, d = this.axis, i = d.series, g = d.coll === "xAxis", m = d.options.reversedStacks, k = i.length;
            for (this.resetStacks(), this.usePercentage = !1, n = k; n--; ) e = i[m ? n : k - n - 1], g && e.setGroupedPoints(d), e.setStackedPoints(d);
            if (!g) for (n = 0; n < k; n++) i[n].modifyStacks();
            c(d, "afterBuildStacks");
          }
          cleanStacks() {
            this.oldStacks && (this.stacks = this.oldStacks, f(this.stacks, (e) => {
              f(e, (n) => {
                n.cumulative = n.total;
              });
            }));
          }
          resetStacks() {
            f(this.stacks, (e) => {
              f(e, (n, d) => {
                s(n.touched) && n.touched < this.stacksTouched ? (n.destroy(), delete e[d]) : (n.total = null, n.cumulative = null);
              });
            });
          }
          renderStackTotals() {
            var k;
            let e = this.axis, n = e.chart, d = n.renderer, i = this.stacks, g = L(n, ((k = e.options.stackLabels) == null ? void 0 : k.animation) || !1), m = this.stackTotalGroup = this.stackTotalGroup || d.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
            m.translate(n.plotLeft, n.plotTop), f(i, (j) => {
              f(j, (P) => {
                P.render(m);
              });
            }), m.animate({ opacity: 1 }, g);
          }
        }
        return (O || (O = {})).compose = function(t, e, n) {
          let d = e.prototype, i = n.prototype;
          d.getStacks || (w(t, "init", x), w(t, "destroy", a), d.getStacks = h, i.getStackIndicator = S, i.modifyStacks = E, i.percentStacker = b, i.setGroupedPoints = p, i.setStackedPoints = C);
        }, O;
      }), Z(r, "Series/Line/LineSeries.js", [r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { defined: R, merge: z, isObject: O } = I;
        class L extends T {
          drawGraph() {
            let w = this.options, A = (this.gappedPath || this.getGraphPath).call(this), l = this.chart.styledMode;
            [this, ...this.zones].forEach((u, c) => {
              let v, s = u.graph, f = s ? "animate" : "attr", y = u.dashStyle || w.dashStyle;
              s ? (s.endX = this.preventGraphAnimation ? null : A.xMap, s.animate({ d: A })) : A.length && (u.graph = s = this.chart.renderer.path(A).addClass("highcharts-graph" + (c ? ` highcharts-zone-graph-${c - 1} ` : " ") + (c && u.className || "")).attr({ zIndex: 1 }).add(this.group)), s && !l && (v = { stroke: !c && w.lineColor || u.color || this.color || "#cccccc", "stroke-width": w.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, y ? v.dashstyle = y : w.linecap !== "square" && (v["stroke-linecap"] = v["stroke-linejoin"] = "round"), s[f](v).shadow(c < 2 && w.shadow && z({ filterUnits: "userSpaceOnUse" }, O(w.shadow) ? w.shadow : {}))), s && (s.startX = A.xMap, s.isArea = A.isArea);
            });
          }
          getGraphPath(w, A, l) {
            let u = this, c = u.options, v = [], s = [], f, y = c.step, h = (w = w || u.points).reversed;
            return h && w.reverse(), (y = { right: 1, center: 2 }[y] || y && 3) && h && (y = 4 - y), (w = this.getValidPoints(w, !1, !(c.connectNulls && !A && !l))).forEach(function(a, x) {
              let S, E = a.plotX, b = a.plotY, p = w[x - 1], C = a.isNull || typeof b != "number";
              (a.leftCliff || p && p.rightCliff) && !l && (f = !0), C && !R(A) && x > 0 ? f = !c.connectNulls : C && !A ? f = !0 : (x === 0 || f ? S = [["M", a.plotX, a.plotY]] : u.getPointSpline ? S = [u.getPointSpline(w, a, x)] : y ? (S = y === 1 ? [["L", p.plotX, b]] : y === 2 ? [["L", (p.plotX + E) / 2, p.plotY], ["L", (p.plotX + E) / 2, b]] : [["L", E, p.plotY]]).push(["L", E, b]) : S = [["L", E, b]], s.push(a.x), y && (s.push(a.x), y === 2 && s.push(a.x)), v.push.apply(v, S), f = !1);
            }), v.xMap = s, u.graphPath = v, v;
          }
        }
        return L.defaultOptions = z(T.defaultOptions, { legendSymbol: "lineMarker" }), B.registerSeriesType("line", L), L;
      }), Z(r, "Series/Area/AreaSeriesDefaults.js", [], function() {
        return { threshold: 0, legendSymbol: "areaMarker" };
      }), Z(r, "Series/Area/AreaSeries.js", [r["Series/Area/AreaSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { seriesTypes: { line: R } } = B, { extend: z, merge: O, objectEach: L, pick: M } = I;
        class w extends R {
          drawGraph() {
            this.areaPath = [], super.drawGraph.apply(this);
            let { areaPath: l, options: u } = this;
            [this, ...this.zones].forEach((c, v) => {
              let s = {}, f = c.fillColor || u.fillColor, y = c.area, h = y ? "animate" : "attr";
              y ? (y.endX = this.preventGraphAnimation ? null : l.xMap, y.animate({ d: l })) : (s.zIndex = 0, (y = c.area = this.chart.renderer.path(l).addClass("highcharts-area" + (v ? ` highcharts-zone-area-${v - 1} ` : " ") + (v && c.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (s.fill = f || c.color || this.color, s["fill-opacity"] = f ? 1 : u.fillOpacity ?? 0.75, y.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), y[h](s), y.startX = l.xMap, y.shiftUnit = u.step ? 2 : 1;
            });
          }
          getGraphPath(l) {
            let u, c, v, s = R.prototype.getGraphPath, f = this.options, y = f.stacking, h = this.yAxis, a = [], x = [], S = this.index, E = h.stacking.stacks[this.stackKey], b = f.threshold, p = Math.round(h.getThreshold(f.threshold)), C = M(f.connectNulls, y === "percent"), o = function(g, m, k) {
              let j = l[g], P = y && E[j.x].points[S], D = j[k + "Null"] || 0, H = j[k + "Cliff"] || 0, G, V, F = !0;
              H || D ? (G = (D ? P[0] : P[1]) + H, V = P[0] + H, F = !!D) : !y && l[m] && l[m].isNull && (G = V = b), G !== void 0 && (x.push({ plotX: u, plotY: G === null ? p : h.getThreshold(G), isNull: F, isCliff: !0 }), a.push({ plotX: u, plotY: V === null ? p : h.getThreshold(V), doCurve: !1 }));
            };
            l = l || this.points, y && (l = this.getStackPoints(l));
            for (let g = 0, m = l.length; g < m; ++g) y || (l[g].leftCliff = l[g].rightCliff = l[g].leftNull = l[g].rightNull = void 0), c = l[g].isNull, u = M(l[g].rectPlotX, l[g].plotX), v = y ? M(l[g].yBottom, p) : p, c && !C || (C || o(g, g - 1, "left"), c && !y && C || (x.push(l[g]), a.push({ x: g, plotX: u, plotY: v })), C || o(g, g + 1, "right"));
            let t = s.call(this, x, !0, !0);
            a.reversed = !0;
            let e = s.call(this, a, !0, !0), n = e[0];
            n && n[0] === "M" && (e[0] = ["L", n[1], n[2]]);
            let d = t.concat(e);
            d.length && d.push(["Z"]);
            let i = s.call(this, x, !1, C);
            return this.chart.series.length > 1 && y && x.some((g) => g.isCliff) && (d.hasStackedCliffs = i.hasStackedCliffs = !0), d.xMap = t.xMap, this.areaPath = d, i;
          }
          getStackPoints(l) {
            let u = this, c = [], v = [], s = this.xAxis, f = this.yAxis, y = f.stacking.stacks[this.stackKey], h = {}, a = f.series, x = a.length, S = f.options.reversedStacks ? 1 : -1, E = a.indexOf(u);
            if (l = l || this.points, this.options.stacking) {
              for (let p = 0; p < l.length; p++) l[p].leftNull = l[p].rightNull = void 0, h[l[p].x] = l[p];
              L(y, function(p, C) {
                p.total !== null && v.push(C);
              }), v.sort(function(p, C) {
                return p - C;
              });
              let b = a.map((p) => p.visible);
              v.forEach(function(p, C) {
                let o = 0, t, e;
                if (h[p] && !h[p].isNull) c.push(h[p]), [-1, 1].forEach(function(n) {
                  let d = n === 1 ? "rightNull" : "leftNull", i = y[v[C + n]], g = 0;
                  if (i) {
                    let m = E;
                    for (; m >= 0 && m < x; ) {
                      let k = a[m].index;
                      !(t = i.points[k]) && (k === u.index ? h[p][d] = !0 : b[m] && (e = y[p].points[k]) && (g -= e[1] - e[0])), m += S;
                    }
                  }
                  h[p][n === 1 ? "rightCliff" : "leftCliff"] = g;
                });
                else {
                  let n = E;
                  for (; n >= 0 && n < x; ) {
                    let d = a[n].index;
                    if (t = y[p].points[d]) {
                      o = t[1];
                      break;
                    }
                    n += S;
                  }
                  o = M(o, 0), o = f.translate(o, 0, 1, 0, 1), c.push({ isNull: !0, plotX: s.translate(p, 0, 0, 0, 1), x: p, plotY: o, yBottom: o });
                }
              });
            }
            return c;
          }
        }
        return w.defaultOptions = O(R.defaultOptions, T), z(w.prototype, { singleStacks: !1 }), B.registerSeriesType("area", w), w;
      }), Z(r, "Series/Spline/SplineSeries.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { line: I } = T.seriesTypes, { merge: R, pick: z } = B;
        class O extends I {
          getPointSpline(M, w, A) {
            let l, u, c, v, s = w.plotX || 0, f = w.plotY || 0, y = M[A - 1], h = M[A + 1];
            function a(S) {
              return S && !S.isNull && S.doCurve !== !1 && !w.isCliff;
            }
            if (a(y) && a(h)) {
              let S = y.plotX || 0, E = y.plotY || 0, b = h.plotX || 0, p = h.plotY || 0, C = 0;
              l = (1.5 * s + S) / 2.5, u = (1.5 * f + E) / 2.5, c = (1.5 * s + b) / 2.5, v = (1.5 * f + p) / 2.5, c !== l && (C = (v - u) * (c - s) / (c - l) + f - v), u += C, v += C, u > E && u > f ? (u = Math.max(E, f), v = 2 * f - u) : u < E && u < f && (u = Math.min(E, f), v = 2 * f - u), v > p && v > f ? (v = Math.max(p, f), u = 2 * f - v) : v < p && v < f && (v = Math.min(p, f), u = 2 * f - v), w.rightContX = c, w.rightContY = v, w.controlPoints = { low: [l, u], high: [c, v] };
            }
            let x = ["C", z(y.rightContX, y.plotX, 0), z(y.rightContY, y.plotY, 0), z(l, s, 0), z(u, f, 0), s, f];
            return y.rightContX = y.rightContY = void 0, x;
          }
        }
        return O.defaultOptions = R(I.defaultOptions), T.registerSeriesType("spline", O), O;
      }), Z(r, "Series/AreaSpline/AreaSplineSeries.js", [r["Series/Spline/SplineSeries.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { area: R, area: { prototype: z } } = B.seriesTypes, { extend: O, merge: L } = I;
        class M extends T {
        }
        return M.defaultOptions = L(T.defaultOptions, R.defaultOptions), O(M.prototype, { getGraphPath: z.getGraphPath, getStackPoints: z.getStackPoints, drawGraph: z.drawGraph }), B.registerSeriesType("areaspline", M), M;
      }), Z(r, "Series/Column/ColumnSeriesDefaults.js", [], function() {
        return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
      }), Z(r, "Series/Column/ColumnSeries.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Color/Color.js"], r["Series/Column/ColumnSeriesDefaults.js"], r["Core/Globals.js"], r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { animObject: M } = T, { parse: w } = B, { noop: A } = R, { clamp: l, crisp: u, defined: c, extend: v, fireEvent: s, isArray: f, isNumber: y, merge: h, pick: a, objectEach: x } = L;
        class S extends z {
          animate(b) {
            let p, C, o = this, t = this.yAxis, e = t.pos, n = t.reversed, d = o.options, { clipOffset: i, inverted: g } = this.chart, m = {}, k = g ? "translateX" : "translateY";
            b && i ? (m.scaleY = 1e-3, C = l(t.toPixels(d.threshold), e, e + t.len), g ? (C += n ? -Math.floor(i[0]) : Math.ceil(i[2]), m.translateX = C - t.len) : (C += n ? Math.ceil(i[0]) : -Math.floor(i[2]), m.translateY = C), o.clipBox && o.setClip(), o.group.attr(m)) : (p = Number(o.group.attr(k)), o.group.animate({ scaleY: 1 }, v(M(o.options.animation), { step: function(j, P) {
              o.group && (m[k] = p + P.pos * (e - p), o.group.attr(m));
            } })));
          }
          init(b, p) {
            super.init.apply(this, arguments);
            let C = this;
            (b = C.chart).hasRendered && b.series.forEach(function(o) {
              o.type === C.type && (o.isDirty = !0);
            });
          }
          getColumnMetrics() {
            var D, H;
            let b = this, p = b.options, C = b.xAxis, o = b.yAxis, t = C.options.reversedStacks, e = C.reversed && !t || !C.reversed && t, n = {}, d, i = 0;
            p.grouping === !1 ? i = 1 : b.chart.series.forEach(function(G) {
              let V, F = G.yAxis, U = G.options;
              G.type === b.type && G.reserveSpace() && o.len === F.len && o.pos === F.pos && (U.stacking && U.stacking !== "group" ? (n[d = G.stackKey] === void 0 && (n[d] = i++), V = n[d]) : U.grouping !== !1 && (V = i++), G.columnIndex = V);
            });
            let g = Math.min(Math.abs(C.transA) * (!((D = C.brokenAxis) != null && D.hasBreaks) && ((H = C.ordinal) == null ? void 0 : H.slope) || p.pointRange || C.closestPointRange || C.tickInterval || 1), C.len), m = g * p.groupPadding, k = (g - 2 * m) / (i || 1), j = Math.min(p.maxPointWidth || C.len, a(p.pointWidth, k * (1 - 2 * p.pointPadding))), P = (b.columnIndex || 0) + (e ? 1 : 0);
            return b.columnMetrics = { width: j, offset: (k - j) / 2 + (m + P * k - g / 2) * (e ? -1 : 1), paddedWidth: k, columnCount: i }, b.columnMetrics;
          }
          crispCol(b, p, C, o) {
            let t = this.borderWidth, e = this.chart.inverted;
            return o = u(p + o, t, e) - (p = u(p, t, e)), this.options.crisp && (C = u(b + C, t) - (b = u(b, t))), { x: b, y: p, width: C, height: o };
          }
          adjustForMissingColumns(b, p, C, o) {
            var t;
            if (!C.isNull && o.columnCount > 1) {
              let e = this.xAxis.series.filter((g) => g.visible).map((g) => g.index), n = 0, d = 0;
              x((t = this.xAxis.stacking) == null ? void 0 : t.stacks, (g) => {
                if (typeof C.x == "number") {
                  let m = g[C.x.toString()];
                  if (m && f(m.points[this.index])) {
                    let k = Object.keys(m.points).filter((j) => !j.match(",") && m.points[j] && m.points[j].length > 1).map(parseFloat).filter((j) => e.indexOf(j) !== -1).sort((j, P) => P - j);
                    n = k.indexOf(this.index), d = k.length;
                  }
                }
              }), n = this.xAxis.reversed ? d - 1 - n : n;
              let i = (d - 1) * o.paddedWidth + p;
              b = (C.plotX || 0) + i / 2 - p - n * o.paddedWidth;
            }
            return b;
          }
          translate() {
            let b = this, p = b.chart, C = b.options, o = b.dense = b.closestPointRange * b.xAxis.transA < 2, t = b.borderWidth = a(C.borderWidth, o ? 0 : 1), e = b.xAxis, n = b.yAxis, d = C.threshold, i = a(C.minPointLength, 5), g = b.getColumnMetrics(), m = g.width, k = b.pointXOffset = g.offset, j = b.dataMin, P = b.dataMax, D = b.translatedThreshold = n.getThreshold(d), H = b.barW = Math.max(m, 1 + 2 * t);
            C.pointPadding && (H = Math.ceil(H)), z.prototype.translate.apply(b), b.points.forEach(function(G) {
              let V = a(G.yBottom, D), F = 999 + Math.abs(V), U = G.plotX || 0, Y = l(G.plotY, -F, n.len + F), q, N = Math.min(Y, V), X = Math.max(Y, V) - N, W = m, _ = U + k, K = H;
              i && Math.abs(X) < i && (X = i, q = !n.reversed && !G.negative || n.reversed && G.negative, y(d) && y(P) && G.y === d && P <= d && (n.min || 0) < d && (j !== P || (n.max || 0) <= d) && (q = !q, G.negative = !G.negative), N = Math.abs(N - D) > i ? V - i : D - (q ? i : 0)), c(G.options.pointWidth) && (_ -= Math.round(((W = K = Math.ceil(G.options.pointWidth)) - m) / 2)), C.centerInCategory && !C.stacking && (_ = b.adjustForMissingColumns(_, W, G, g)), G.barX = _, G.pointWidth = W, G.tooltipPos = p.inverted ? [l(n.len + n.pos - p.plotLeft - Y, n.pos - p.plotLeft, n.len + n.pos - p.plotLeft), e.len + e.pos - p.plotTop - _ - K / 2, X] : [e.left - p.plotLeft + _ + K / 2, l(Y + n.pos - p.plotTop, n.pos - p.plotTop, n.len + n.pos - p.plotTop), X], G.shapeType = b.pointClass.prototype.shapeType || "roundedRect", G.shapeArgs = b.crispCol(_, G.isNull ? D : N, K, G.isNull ? 0 : X);
            }), s(this, "afterColumnTranslate");
          }
          drawGraph() {
            this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
          }
          pointAttribs(b, p) {
            let C = this.options, o = this.pointAttrToOptions || {}, t = o.stroke || "borderColor", e = o["stroke-width"] || "borderWidth", n, d, i, g = b && b.color || this.color, m = b && b[t] || C[t] || g, k = b && b.options.dashStyle || C.dashStyle, j = b && b[e] || C[e] || this[e] || 0, P = a(b && b.opacity, C.opacity, 1);
            b && this.zones.length && (d = b.getZone(), g = b.options.color || d && (d.color || b.nonZonedColor) || this.color, d && (m = d.borderColor || m, k = d.dashStyle || k, j = d.borderWidth || j)), p && b && (i = (n = h(C.states[p], b.options.states && b.options.states[p] || {})).brightness, g = n.color || i !== void 0 && w(g).brighten(n.brightness).get() || g, m = n[t] || m, j = n[e] || j, k = n.dashStyle || k, P = a(n.opacity, P));
            let D = { fill: g, stroke: m, "stroke-width": j, opacity: P };
            return k && (D.dashstyle = k), D;
          }
          drawPoints(b = this.points) {
            let p, C = this, o = this.chart, t = C.options, e = o.renderer, n = t.animationLimit || 250;
            b.forEach(function(d) {
              let i = d.plotY, g = d.graphic, m = !!g, k = g && o.pointCount < n ? "animate" : "attr";
              y(i) && d.y !== null ? (p = d.shapeArgs, g && d.hasNewShapeType() && (g = g.destroy()), C.enabledDataSorting && (d.startXPos = C.xAxis.reversed ? -(p && p.width || 0) : C.xAxis.width), !g && (d.graphic = g = e[d.shapeType](p).add(d.group || C.group), g && C.enabledDataSorting && o.hasRendered && o.pointCount < n && (g.attr({ x: d.startXPos }), m = !0, k = "animate")), g && m && g[k](h(p)), o.styledMode || g[k](C.pointAttribs(d, d.selected && "select")).shadow(d.allowShadow !== !1 && t.shadow), g && (g.addClass(d.getClassName(), !0), g.attr({ visibility: d.visible ? "inherit" : "hidden" }))) : g && (d.graphic = g.destroy());
            });
          }
          drawTracker(b = this.points) {
            let p, C = this, o = C.chart, t = o.pointer, e = function(n) {
              let d = t == null ? void 0 : t.getPointFromEvent(n);
              t && d && C.options.enableMouseTracking && (t.isDirectTouch = !0, d.onMouseOver(n));
            };
            b.forEach(function(n) {
              p = f(n.dataLabels) ? n.dataLabels : n.dataLabel ? [n.dataLabel] : [], n.graphic && (n.graphic.element.point = n), p.forEach(function(d) {
                (d.div || d.element).point = n;
              });
            }), C._hasTracking || (C.trackerGroups.forEach(function(n) {
              C[n] && (C[n].addClass("highcharts-tracker").on("mouseover", e).on("mouseout", function(d) {
                t == null || t.onTrackerMouseOut(d);
              }).on("touchstart", e), !o.styledMode && C.options.cursor && C[n].css({ cursor: C.options.cursor }));
            }), C._hasTracking = !0), s(this, "afterDrawTracker");
          }
          remove() {
            let b = this, p = b.chart;
            p.hasRendered && p.series.forEach(function(C) {
              C.type === b.type && (C.isDirty = !0);
            }), z.prototype.remove.apply(b, arguments);
          }
        }
        return S.defaultOptions = h(z.defaultOptions, I), v(S.prototype, { directTouch: !0, getSymbol: A, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), O.registerSeriesType("column", S), S;
      }), Z(r, "Core/Series/DataLabel.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Templating.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { getDeferredAnimation: z } = T, { format: O } = B, { defined: L, extend: M, fireEvent: w, isArray: A, isString: l, merge: u, objectEach: c, pick: v, pInt: s, splat: f } = I;
        return function(y) {
          function h() {
            return C(this).some((t) => t == null ? void 0 : t.enabled);
          }
          function a(t, e, n, d, i) {
            var Y;
            let { chart: g, enabledDataSorting: m } = this, k = this.isCartesian && g.inverted, j = t.plotX, P = t.plotY, D = n.rotation || 0, H = L(j) && L(P) && g.isInsidePlot(j, Math.round(P), { inverted: k, paneCoordinates: !0, series: this }), G = D === 0 && v(n.overflow, m ? "none" : "justify") === "justify", V = this.visible && t.visible !== !1 && L(j) && (t.series.forceDL || m && !G || H || v(n.inside, !!this.options.stacking) && d && g.isInsidePlot(j, k ? d.x + 1 : d.y + d.height - 1, { inverted: k, paneCoordinates: !0, series: this })), F = t.pos();
            if (V && F) {
              var U;
              let q = e.getBBox(), N = e.getBBox(void 0, 0), X = { right: 1, center: 0.5 }[n.align || 0] || 0, W = { bottom: 1, middle: 0.5 }[n.verticalAlign || 0] || 0;
              if (d = M({ x: F[0], y: Math.round(F[1]), width: 0, height: 0 }, d || {}), n.alignTo === "plotEdges" && this.isCartesian && (d[k ? "x" : "y"] = 0, d[k ? "width" : "height"] = ((Y = this.yAxis) == null ? void 0 : Y.len) || 0), M(n, { width: q.width, height: q.height }), U = d, m && this.xAxis && !G && this.setDataLabelStartPos(t, e, i, H, U), e.align(u(n, { width: N.width, height: N.height }), !1, d, !1), e.alignAttr.x += X * (N.width - q.width), e.alignAttr.y += W * (N.height - q.height), e[e.placed ? "animate" : "attr"]({ x: e.alignAttr.x + (q.width - N.width) / 2, y: e.alignAttr.y + (q.height - N.height) / 2, rotationOriginX: (e.width || 0) / 2, rotationOriginY: (e.height || 0) / 2 }), G && d.height >= 0) this.justifyDataLabel(e, n, e.alignAttr, q, d, i);
              else if (v(n.crop, !0)) {
                let { x: _, y: K } = e.alignAttr;
                V = g.isInsidePlot(_, K, { paneCoordinates: !0, series: this }) && g.isInsidePlot(_ + q.width - 1, K + q.height - 1, { paneCoordinates: !0, series: this });
              }
              n.shape && !D && e[i ? "attr" : "animate"]({ anchorX: F[0], anchorY: F[1] });
            }
            i && m && (e.placed = !1), V || m && !G ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
          }
          function x() {
            return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
          }
          function S(t) {
            let e = this.hasRendered || 0, n = this.initDataLabelsGroup().attr({ opacity: +e });
            return !e && n && (this.visible && n.show(), this.options.animation ? n.animate({ opacity: 1 }, t) : n.attr({ opacity: 1 })), n;
          }
          function E(t) {
            var V;
            let e;
            t = t || this.points;
            let n = this, d = n.chart, i = n.options, g = d.renderer, { backgroundColor: m, plotBackgroundColor: k } = d.options.chart, j = g.getContrast(l(k) && k || l(m) && m || "#000000"), P = C(n), { animation: D, defer: H } = P[0], G = H ? z(d, D, n) : { defer: 0, duration: 0 };
            w(this, "drawDataLabels"), (V = n.hasDataLabels) != null && V.call(n) && (e = this.initDataLabels(G), t.forEach((F) => {
              var q, N;
              let U = F.dataLabels || [];
              f(p(P, F.dlOptions || ((q = F.options) == null ? void 0 : q.dataLabels))).forEach((X, W) => {
                let _ = X.enabled && (F.visible || F.dataLabelOnHidden) && (!F.isNull || F.dataLabelOnNull) && function(ct, dt) {
                  let ut = dt.filter;
                  if (ut) {
                    let pt = ut.operator, gt = ct[ut.property], ft = ut.value;
                    return pt === ">" && gt > ft || pt === "<" && gt < ft || pt === ">=" && gt >= ft || pt === "<=" && gt <= ft || pt === "==" && gt == ft || pt === "===" && gt === ft || pt === "!=" && gt != ft || pt === "!==" && gt !== ft;
                  }
                  return !0;
                }(F, X), { backgroundColor: K, borderColor: J, distance: $, style: et = {} } = X, st, at, lt, it, Q = {}, ot = U[W], nt = !ot, ht;
                _ && (at = v(X[F.formatPrefix + "Format"], X.format), st = F.getLabelConfig(), lt = L(at) ? O(at, st, d) : (X[F.formatPrefix + "Formatter"] || X.formatter).call(st, X), it = X.rotation, !d.styledMode && (et.color = v(X.color, et.color, l(n.color) ? n.color : void 0, "#000000"), et.color === "contrast" ? (K !== "none" && (ht = K), F.contrastColor = g.getContrast(ht !== "auto" && ht || F.color || n.color), et.color = ht || !L($) && X.inside || 0 > s($ || 0) || i.stacking ? F.contrastColor : j) : delete F.contrastColor, i.cursor && (et.cursor = i.cursor)), Q = { r: X.borderRadius || 0, rotation: it, padding: X.padding, zIndex: 1 }, d.styledMode || (Q.fill = K === "auto" ? F.color : K, Q.stroke = J === "auto" ? F.color : J, Q["stroke-width"] = X.borderWidth), c(Q, (ct, dt) => {
                  ct === void 0 && delete Q[dt];
                })), !ot || _ && L(lt) && !!ot.div == !!X.useHTML && (ot.rotation && X.rotation || ot.rotation === X.rotation) || (ot = void 0, nt = !0), _ && L(lt) && (ot ? Q.text = lt : (ot = g.label(lt, 0, 0, X.shape, void 0, void 0, X.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + F.colorIndex + " " + (X.className || "") + (X.useHTML ? " highcharts-tracker" : "")), ot && (ot.options = X, ot.attr(Q), d.styledMode ? et.width && ot.css({ width: et.width, textOverflow: et.textOverflow }) : ot.css(et).shadow(X.shadow), w(ot, "beforeAddingDataLabel", { labelOptions: X, point: F }), ot.added || ot.add(e), n.alignDataLabel(F, ot, X, void 0, nt), ot.isActive = !0, U[W] && U[W] !== ot && U[W].destroy(), U[W] = ot));
              });
              let Y = U.length;
              for (; Y--; ) U[Y] && U[Y].isActive ? U[Y].isActive = !1 : ((N = U[Y]) == null || N.destroy(), U.splice(Y, 1));
              F.dataLabel = U[0], F.dataLabels = U;
            })), w(this, "afterDrawDataLabels");
          }
          function b(t, e, n, d, i, g) {
            let m = this.chart, k = e.align, j = e.verticalAlign, P = t.box ? 0 : t.padding || 0, D = m.inverted ? this.yAxis : this.xAxis, H = D ? D.left - m.plotLeft : 0, G = m.inverted ? this.xAxis : this.yAxis, V = G ? G.top - m.plotTop : 0, { x: F = 0, y: U = 0 } = e, Y, q;
            return (Y = (n.x || 0) + P + H) < 0 && (k === "right" && F >= 0 ? (e.align = "left", e.inside = !0) : F -= Y, q = !0), (Y = (n.x || 0) + d.width - P + H) > m.plotWidth && (k === "left" && F <= 0 ? (e.align = "right", e.inside = !0) : F += m.plotWidth - Y, q = !0), (Y = n.y + P + V) < 0 && (j === "bottom" && U >= 0 ? (e.verticalAlign = "top", e.inside = !0) : U -= Y, q = !0), (Y = (n.y || 0) + d.height - P + V) > m.plotHeight && (j === "top" && U <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : U += m.plotHeight - Y, q = !0), q && (e.x = F, e.y = U, t.placed = !g, t.align(e, void 0, i)), q;
          }
          function p(t, e) {
            let n = [], d;
            if (A(t) && !A(e)) n = t.map(function(i) {
              return u(i, e);
            });
            else if (A(e) && !A(t)) n = e.map(function(i) {
              return u(t, i);
            });
            else if (A(t) || A(e)) {
              if (A(t) && A(e)) for (d = Math.max(t.length, e.length); d--; ) n[d] = u(t[d], e[d]);
            } else n = u(t, e);
            return n;
          }
          function C(t) {
            var n, d;
            let e = t.chart.options.plotOptions;
            return f(p(p((n = e == null ? void 0 : e.series) == null ? void 0 : n.dataLabels, (d = e == null ? void 0 : e[t.type]) == null ? void 0 : d.dataLabels), t.options.dataLabels));
          }
          function o(t, e, n, d, i) {
            let g = this.chart, m = g.inverted, k = this.xAxis, j = k.reversed, P = ((m ? e.height : e.width) || 0) / 2, D = t.pointWidth, H = D ? D / 2 : 0;
            e.startXPos = m ? i.x : j ? -P - H : k.width - P + H, e.startYPos = m ? j ? this.yAxis.height - P + H : -P - H : i.y, d ? e.visibility === "hidden" && (e.show(), e.attr({ opacity: 0 }).animate({ opacity: 1 })) : e.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, e.hide), g.hasRendered && (n && e.attr({ x: e.startXPos, y: e.startYPos }), e.placed = !0);
          }
          y.compose = function(t) {
            let e = t.prototype;
            e.initDataLabels || (e.initDataLabels = S, e.initDataLabelsGroup = x, e.alignDataLabel = a, e.drawDataLabels = E, e.justifyDataLabel = b, e.setDataLabelStartPos = o, e.hasDataLabels = h);
          };
        }(R || (R = {})), R;
      }), Z(r, "Series/Column/ColumnDataLabel.js", [r["Core/Series/DataLabel.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { composed: O } = B, { series: L } = I, { merge: M, pick: w, pushUnique: A } = R;
        return function(l) {
          function u(c, v, s, f, y) {
            let h = this.chart.inverted, a = c.series, x = (a.xAxis ? a.xAxis.len : this.chart.plotSizeX) || 0, S = (a.yAxis ? a.yAxis.len : this.chart.plotSizeY) || 0, E = c.dlBox || c.shapeArgs, b = w(c.below, c.plotY > w(this.translatedThreshold, S)), p = w(s.inside, !!this.options.stacking);
            if (E) {
              if (f = M(E), !(s.overflow === "allow" && s.crop === !1)) {
                f.y < 0 && (f.height += f.y, f.y = 0);
                let C = f.y + f.height - S;
                C > 0 && C < f.height - 1 && (f.height -= C);
              }
              h && (f = { x: S - f.y - f.height, y: x - f.x - f.width, width: f.height, height: f.width }), p || (h ? (f.x += b ? 0 : f.width, f.width = 0) : (f.y += b ? f.height : 0, f.height = 0));
            }
            s.align = w(s.align, !h || p ? "center" : b ? "right" : "left"), s.verticalAlign = w(s.verticalAlign, h || p ? "middle" : b ? "top" : "bottom"), L.prototype.alignDataLabel.call(this, c, v, s, f, y), s.inside && c.contrastColor && v.css({ color: c.contrastColor });
          }
          l.compose = function(c) {
            T.compose(L), A(O, "ColumnDataLabel") && (c.prototype.alignDataLabel = u);
          };
        }(z || (z = {})), z;
      }), Z(r, "Series/Bar/BarSeries.js", [r["Series/Column/ColumnSeries.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { extend: R, merge: z } = I;
        class O extends T {
        }
        return O.defaultOptions = z(T.defaultOptions, {}), R(O.prototype, { inverted: !0 }), B.registerSeriesType("bar", O), O;
      }), Z(r, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
        return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
      }), Z(r, "Series/Scatter/ScatterSeries.js", [r["Series/Scatter/ScatterSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { column: R, line: z } = B.seriesTypes, { addEvent: O, extend: L, merge: M } = I;
        class w extends z {
          applyJitter() {
            let l = this, u = this.options.jitter, c = this.points.length;
            u && this.points.forEach(function(v, s) {
              ["x", "y"].forEach(function(f, y) {
                if (u[f] && !v.isNull) {
                  let h = `plot${f.toUpperCase()}`, a = l[`${f}Axis`], x = u[f] * a.transA;
                  if (a && !a.logarithmic) {
                    let S = Math.max(0, (v[h] || 0) - x), E = Math.min(a.len, (v[h] || 0) + x);
                    v[h] = S + (E - S) * function(b) {
                      let p = 1e4 * Math.sin(b);
                      return p - Math.floor(p);
                    }(s + y * c), f === "x" && (v.clientX = v.plotX);
                  }
                }
              });
            });
          }
          drawGraph() {
            this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
          }
        }
        return w.defaultOptions = M(z.defaultOptions, T), L(w.prototype, { drawTracker: R.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), O(w, "afterTranslate", function() {
          this.applyJitter();
        }), B.registerSeriesType("scatter", w), w;
      }), Z(r, "Series/CenteredUtilities.js", [r["Core/Globals.js"], r["Core/Series/Series.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R, z;
        let { deg2rad: O } = T, { fireEvent: L, isNumber: M, pick: w, relativeLength: A } = I;
        return (z = R || (R = {})).getCenter = function() {
          let l = this.options, u = this.chart, c = 2 * (l.slicedOffset || 0), v = u.plotWidth - 2 * c, s = u.plotHeight - 2 * c, f = l.center, y = Math.min(v, s), h = l.thickness, a, x = l.size, S = l.innerSize || 0, E, b;
          typeof x == "string" && (x = parseFloat(x)), typeof S == "string" && (S = parseFloat(S));
          let p = [w(f[0], "50%"), w(f[1], "50%"), w(x && x < 0 ? void 0 : l.size, "100%"), w(S && S < 0 ? void 0 : l.innerSize || 0, "0%")];
          for (!u.angular || this instanceof B || (p[3] = 0), E = 0; E < 4; ++E) b = p[E], a = E < 2 || E === 2 && /%$/.test(b), p[E] = A(b, [v, s, y, p[2]][E]) + (a ? c : 0);
          return p[3] > p[2] && (p[3] = p[2]), M(h) && 2 * h < p[2] && h > 0 && (p[3] = p[2] - 2 * h), L(this, "afterGetCenter", { positions: p }), p;
        }, z.getStartAndEndRadians = function(l, u) {
          let c = M(l) ? l : 0, v = M(u) && u > c && u - c < 360 ? u : c + 360;
          return { start: O * (c + -90), end: O * (v + -90) };
        }, R;
      }), Z(r, "Series/Pie/PiePoint.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Series/Point.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { setAnimation: R } = T, { addEvent: z, defined: O, extend: L, isNumber: M, pick: w, relativeLength: A } = I;
        class l extends B {
          getConnectorPath(c) {
            let v = c.dataLabelPosition, s = c.options || {}, f = s.connectorShape, y = this.connectorShapes[f] || f;
            return v && y.call(this, { ...v.computed, alignment: v.alignment }, v.connectorPosition, s) || [];
          }
          getTranslate() {
            return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
          }
          haloPath(c) {
            let v = this.shapeArgs;
            return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(v.x, v.y, v.r + c, v.r + c, { innerR: v.r - 1, start: v.start, end: v.end, borderRadius: v.borderRadius });
          }
          constructor(c, v, s) {
            super(c, v, s), this.half = 0, this.name ?? (this.name = "Slice");
            let f = (y) => {
              this.slice(y.type === "select");
            };
            z(this, "select", f), z(this, "unselect", f);
          }
          isValid() {
            return M(this.y) && this.y >= 0;
          }
          setVisible(c, v = !0) {
            c !== this.visible && this.update({ visible: c ?? !this.visible }, v, void 0, !1);
          }
          slice(c, v, s) {
            let f = this.series;
            R(s, f.chart), v = w(v, !0), this.sliced = this.options.sliced = c = O(c) ? c : !this.sliced, f.options.data[f.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
          }
        }
        return L(l.prototype, { connectorShapes: { fixedOffset: function(u, c, v) {
          let s = c.breakAt, f = c.touchingSliceAt, y = v.softConnector ? ["C", u.x + (u.alignment === "left" ? -5 : 5), u.y, 2 * s.x - f.x, 2 * s.y - f.y, s.x, s.y] : ["L", s.x, s.y];
          return [["M", u.x, u.y], y, ["L", f.x, f.y]];
        }, straight: function(u, c) {
          let v = c.touchingSliceAt;
          return [["M", u.x, u.y], ["L", v.x, v.y]];
        }, crookedLine: function(u, c, v) {
          let { breakAt: s, touchingSliceAt: f } = c, { series: y } = this, [h, a, x] = y.center, S = x / 2, { plotLeft: E, plotWidth: b } = y.chart, p = u.alignment === "left", { x: C, y: o } = u, t = s.x;
          if (v.crookDistance) {
            let n = A(v.crookDistance, 1);
            t = p ? h + S + (b + E - h - S) * (1 - n) : E + (h - S) * n;
          } else t = h + (a - o) * Math.tan((this.angle || 0) - Math.PI / 2);
          let e = [["M", C, o]];
          return (p ? t <= C && t >= s.x : t >= C && t <= s.x) && e.push(["L", t, o]), e.push(["L", s.x, s.y], ["L", f.x, f.y]), e;
        } } }), l;
      }), Z(r, "Series/Pie/PieSeriesDefaults.js", [], function() {
        return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
          return this.point.isNull ? void 0 : this.point.name;
        }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
      }), Z(r, "Series/Pie/PieSeries.js", [r["Series/CenteredUtilities.js"], r["Series/Column/ColumnSeries.js"], r["Core/Globals.js"], r["Series/Pie/PiePoint.js"], r["Series/Pie/PieSeriesDefaults.js"], r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/Symbols.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w) {
        let { getStartAndEndRadians: A } = T, { noop: l } = I, { clamp: u, extend: c, fireEvent: v, merge: s, pick: f } = w;
        class y extends O {
          animate(a) {
            let x = this, S = x.points, E = x.startAngleRad;
            a || S.forEach(function(b) {
              let p = b.graphic, C = b.shapeArgs;
              p && C && (p.attr({ r: f(b.startR, x.center && x.center[3] / 2), start: E, end: E }), p.animate({ r: C.r, start: C.start, end: C.end }, x.options.animation));
            });
          }
          drawEmpty() {
            let a, x, S = this.startAngleRad, E = this.endAngleRad, b = this.options;
            this.total === 0 && this.center ? (a = this.center[0], x = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(a, x, this.center[1] / 2, 0, S, E).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: M.arc(a, x, this.center[2] / 2, 0, { start: S, end: E, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": b.borderWidth, fill: b.fillColor || "none", stroke: b.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
          }
          drawPoints() {
            let a = this.chart.renderer;
            this.points.forEach(function(x) {
              x.graphic && x.hasNewShapeType() && (x.graphic = x.graphic.destroy()), x.graphic || (x.graphic = a[x.shapeType](x.shapeArgs).add(x.series.group), x.delayedRendering = !0);
            });
          }
          generatePoints() {
            super.generatePoints(), this.updateTotals();
          }
          getX(a, x, S, E) {
            let b = this.center, p = this.radii ? this.radii[S.index] || 0 : b[2] / 2, C = E.dataLabelPosition, o = (C == null ? void 0 : C.distance) || 0, t = Math.asin(u((a - b[1]) / (p + o), -1, 1));
            return b[0] + Math.cos(t) * (p + o) * (x ? -1 : 1) + (o > 0 ? (x ? -1 : 1) * (E.padding || 0) : 0);
          }
          hasData() {
            return !!this.processedXData.length;
          }
          redrawPoints() {
            let a, x, S, E, b = this, p = b.chart;
            this.drawEmpty(), b.group && !p.styledMode && b.group.shadow(b.options.shadow), b.points.forEach(function(C) {
              let o = {};
              x = C.graphic, !C.isNull && x ? (E = C.shapeArgs, a = C.getTranslate(), p.styledMode || (S = b.pointAttribs(C, C.selected && "select")), C.delayedRendering ? (x.setRadialReference(b.center).attr(E).attr(a), p.styledMode || x.attr(S).attr({ "stroke-linejoin": "round" }), C.delayedRendering = !1) : (x.setRadialReference(b.center), p.styledMode || s(!0, o, S), s(!0, o, E, a), x.animate(o)), x.attr({ visibility: C.visible ? "inherit" : "hidden" }), x.addClass(C.getClassName(), !0)) : x && (C.graphic = x.destroy());
            });
          }
          sortByAngle(a, x) {
            a.sort(function(S, E) {
              return S.angle !== void 0 && (E.angle - S.angle) * x;
            });
          }
          translate(a) {
            v(this, "translate"), this.generatePoints();
            let x = this.options, S = x.slicedOffset, E = A(x.startAngle, x.endAngle), b = this.startAngleRad = E.start, p = (this.endAngleRad = E.end) - b, C = this.points, o = x.ignoreHiddenPoint, t = C.length, e, n, d, i, g, m, k, j = 0;
            for (a || (this.center = a = this.getCenter()), m = 0; m < t; m++) {
              k = C[m], e = b + j * p, k.isValid() && (!o || k.visible) && (j += k.percentage / 100), n = b + j * p;
              let P = { x: a[0], y: a[1], r: a[2] / 2, innerR: a[3] / 2, start: Math.round(1e3 * e) / 1e3, end: Math.round(1e3 * n) / 1e3 };
              k.shapeType = "arc", k.shapeArgs = P, (d = (n + e) / 2) > 1.5 * Math.PI ? d -= 2 * Math.PI : d < -Math.PI / 2 && (d += 2 * Math.PI), k.slicedTranslation = { translateX: Math.round(Math.cos(d) * S), translateY: Math.round(Math.sin(d) * S) }, i = Math.cos(d) * a[2] / 2, g = Math.sin(d) * a[2] / 2, k.tooltipPos = [a[0] + 0.7 * i, a[1] + 0.7 * g], k.half = d < -Math.PI / 2 || d > Math.PI / 2 ? 1 : 0, k.angle = d;
            }
            v(this, "afterTranslate");
          }
          updateTotals() {
            let a = this.points, x = a.length, S = this.options.ignoreHiddenPoint, E, b, p = 0;
            for (E = 0; E < x; E++) (b = a[E]).isValid() && (!S || b.visible) && (p += b.y);
            for (E = 0, this.total = p; E < x; E++) (b = a[E]).percentage = p > 0 && (b.visible || !S) ? b.y / p * 100 : 0, b.total = p;
          }
        }
        return y.defaultOptions = s(O.defaultOptions, z), c(y.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: B.prototype.drawTracker, getCenter: T.getCenter, getSymbol: l, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: B.prototype.pointAttribs, pointClass: R, requireSorting: !1, searchPoint: l, trackerGroups: ["group", "dataLabelsGroup"] }), L.registerSeriesType("pie", y), y;
      }), Z(r, "Series/Pie/PieDataLabel.js", [r["Core/Series/DataLabel.js"], r["Core/Globals.js"], r["Core/Renderer/RendererUtilities.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        var O;
        let { composed: L, noop: M } = B, { distribute: w } = I, { series: A } = R, { arrayMax: l, clamp: u, defined: c, pick: v, pushUnique: s, relativeLength: f } = z;
        return function(y) {
          let h = { radialDistributionY: function(b, p) {
            var C;
            return (((C = p.dataLabelPosition) == null ? void 0 : C.top) || 0) + b.distributeBox.pos;
          }, radialDistributionX: function(b, p, C, o, t) {
            let e = t.dataLabelPosition;
            return b.getX(C < ((e == null ? void 0 : e.top) || 0) + 2 || C > ((e == null ? void 0 : e.bottom) || 0) - 2 ? o : C, p.half, p, t);
          }, justify: function(b, p, C, o) {
            var t;
            return o[0] + (b.half ? -1 : 1) * (C + (((t = p.dataLabelPosition) == null ? void 0 : t.distance) || 0));
          }, alignToPlotEdges: function(b, p, C, o) {
            let t = b.getBBox().width;
            return p ? t + o : C - t - o;
          }, alignToConnectors: function(b, p, C, o) {
            let t = 0, e;
            return b.forEach(function(n) {
              (e = n.dataLabel.getBBox().width) > t && (t = e);
            }), p ? t + o : C - t - o;
          } };
          function a(b, p) {
            let { center: C, options: o } = this, t = C[2] / 2, e = b.angle || 0, n = Math.cos(e), d = Math.sin(e), i = C[0] + n * t, g = C[1] + d * t, m = Math.min((o.slicedOffset || 0) + (o.borderWidth || 0), p / 5);
            return { natural: { x: i + n * p, y: g + d * p }, computed: {}, alignment: p < 0 ? "center" : b.half ? "right" : "left", connectorPosition: { breakAt: { x: i + n * m, y: g + d * m }, touchingSliceAt: { x: i, y: g } }, distance: p };
          }
          function x() {
            var V;
            let b = this, p = b.points, C = b.chart, o = C.plotWidth, t = C.plotHeight, e = C.plotLeft, n = Math.round(C.chartWidth / 3), d = b.center, i = d[2] / 2, g = d[1], m = [[], []], k = [0, 0, 0, 0], j = b.dataLabelPositioners, P, D, H, G = 0;
            b.visible && ((V = b.hasDataLabels) != null && V.call(b)) && (p.forEach((F) => {
              (F.dataLabels || []).forEach((U) => {
                U.shortened && (U.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), U.shortened = !1);
              });
            }), A.prototype.drawDataLabels.apply(b), p.forEach((F) => {
              (F.dataLabels || []).forEach((U, Y) => {
                var W;
                let q = d[2] / 2, N = U.options, X = f((N == null ? void 0 : N.distance) || 0, q);
                Y === 0 && m[F.half].push(F), !c((W = N == null ? void 0 : N.style) == null ? void 0 : W.width) && U.getBBox().width > n && (U.css({ width: Math.round(0.7 * n) + "px" }), U.shortened = !0), U.dataLabelPosition = this.getDataLabelPosition(F, X), G = Math.max(G, X);
              });
            }), m.forEach((F, U) => {
              let Y = F.length, q = [], N, X, W = 0, _;
              Y && (b.sortByAngle(F, U - 0.5), G > 0 && (N = Math.max(0, g - i - G), X = Math.min(g + i + G, C.plotHeight), F.forEach((K) => {
                (K.dataLabels || []).forEach((J) => {
                  var et;
                  let $ = J.dataLabelPosition;
                  $ && $.distance > 0 && ($.top = Math.max(0, g - i - $.distance), $.bottom = Math.min(g + i + $.distance, C.plotHeight), W = J.getBBox().height || 21, J.lineHeight = C.renderer.fontMetrics(J.text || J).h + 2 * J.padding, K.distributeBox = { target: (((et = J.dataLabelPosition) == null ? void 0 : et.natural.y) || 0) - $.top + J.lineHeight / 2, size: W, rank: K.y }, q.push(K.distributeBox));
                });
              }), w(q, _ = X + W - N, _ / 5)), F.forEach((K) => {
                (K.dataLabels || []).forEach((J) => {
                  let $ = J.options || {}, et = K.distributeBox, st = J.dataLabelPosition, at = (st == null ? void 0 : st.natural.y) || 0, lt = $.connectorPadding || 0, it = J.lineHeight || 21, Q = (it - J.getBBox().height) / 2, ot = 0, nt = at, ht = "inherit";
                  if (st) {
                    if (c(et) && st.distance > 0 && (et.pos === void 0 ? ht = "hidden" : (H = et.size, nt = j.radialDistributionY(K, J))), $.justify) ot = j.justify(K, J, i, d);
                    else switch ($.alignTo) {
                      case "connectors":
                        ot = j.alignToConnectors(F, U, o, e);
                        break;
                      case "plotEdges":
                        ot = j.alignToPlotEdges(J, U, o, e);
                        break;
                      default:
                        ot = j.radialDistributionX(b, K, nt - Q, at, J);
                    }
                    if (st.attribs = { visibility: ht, align: st.alignment }, st.posAttribs = { x: ot + ($.x || 0) + ({ left: lt, right: -lt }[st.alignment] || 0), y: nt + ($.y || 0) - it / 2 }, st.computed.x = ot, st.computed.y = nt - Q, v($.crop, !0)) {
                      let ct;
                      ot - (D = J.getBBox().width) < lt && U === 1 ? (ct = Math.round(D - ot + lt), k[3] = Math.max(ct, k[3])) : ot + D > o - lt && U === 0 && (ct = Math.round(ot + D - o + lt), k[1] = Math.max(ct, k[1])), nt - H / 2 < 0 ? k[0] = Math.max(Math.round(-nt + H / 2), k[0]) : nt + H / 2 > t && (k[2] = Math.max(Math.round(nt + H / 2 - t), k[2])), st.sideOverflow = ct;
                    }
                  }
                });
              }));
            }), (l(k) === 0 || this.verifyDataLabelOverflow(k)) && (this.placeDataLabels(), this.points.forEach((F) => {
              (F.dataLabels || []).forEach((U) => {
                var X;
                let { connectorColor: Y, connectorWidth: q = 1 } = U.options || {}, N = U.dataLabelPosition;
                if (q) {
                  let W;
                  P = U.connector, N && N.distance > 0 ? (W = !P, P || (U.connector = P = C.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + F.colorIndex + (F.className ? " " + F.className : "")).add(b.dataLabelsGroup)), C.styledMode || P.attr({ "stroke-width": q, stroke: Y || F.color || "#666666" }), P[W ? "attr" : "animate"]({ d: F.getConnectorPath(U) }), P.attr({ visibility: (X = N.attribs) == null ? void 0 : X.visibility })) : P && (U.connector = P.destroy());
                }
              });
            })));
          }
          function S() {
            this.points.forEach((b) => {
              (b.dataLabels || []).forEach((p) => {
                var o;
                let C = p.dataLabelPosition;
                C ? (C.sideOverflow && (p.css({ width: Math.max(p.getBBox().width - C.sideOverflow, 0) + "px", textOverflow: (((o = p.options) == null ? void 0 : o.style) || {}).textOverflow || "ellipsis" }), p.shortened = !0), p.attr(C.attribs), p[p.moved ? "animate" : "attr"](C.posAttribs), p.moved = !0) : p && p.attr({ y: -9999 });
              }), delete b.distributeBox;
            }, this);
          }
          function E(b) {
            let p = this.center, C = this.options, o = C.center, t = C.minSize || 80, e = t, n = C.size !== null;
            return !n && (o[0] !== null ? e = Math.max(p[2] - Math.max(b[1], b[3]), t) : (e = Math.max(p[2] - b[1] - b[3], t), p[0] += (b[3] - b[1]) / 2), o[1] !== null ? e = u(e, t, p[2] - Math.max(b[0], b[2])) : (e = u(e, t, p[2] - b[0] - b[2]), p[1] += (b[0] - b[2]) / 2), e < p[2] ? (p[2] = e, p[3] = Math.min(C.thickness ? Math.max(0, e - 2 * C.thickness) : Math.max(0, f(C.innerSize || 0, e)), e), this.translate(p), this.drawDataLabels && this.drawDataLabels()) : n = !0), n;
          }
          y.compose = function(b) {
            if (T.compose(A), s(L, "PieDataLabel")) {
              let p = b.prototype;
              p.dataLabelPositioners = h, p.alignDataLabel = M, p.drawDataLabels = x, p.getDataLabelPosition = a, p.placeDataLabels = S, p.verifyDataLabelOverflow = E;
            }
          };
        }(O || (O = {})), O;
      }), Z(r, "Core/Geometry/GeometryUtilities.js", [], function() {
        var T, B;
        return (B = T || (T = {})).getCenterOfPoints = function(I) {
          let R = I.reduce((z, O) => (z.x += O.x, z.y += O.y, z), { x: 0, y: 0 });
          return { x: R.x / I.length, y: R.y / I.length };
        }, B.getDistanceBetweenPoints = function(I, R) {
          return Math.sqrt(Math.pow(R.x - I.x, 2) + Math.pow(R.y - I.y, 2));
        }, B.getAngleBetweenPoints = function(I, R) {
          return Math.atan2(R.x - I.x, R.y - I.y);
        }, B.pointInPolygon = function({ x: I, y: R }, z) {
          let O = z.length, L, M, w = !1;
          for (L = 0, M = O - 1; L < O; M = L++) {
            let [A, l] = z[L], [u, c] = z[M];
            l > R != c > R && I < (u - A) * (R - l) / (c - l) + A && (w = !w);
          }
          return w;
        }, T;
      }), Z(r, "Extensions/OverlappingDataLabels.js", [r["Core/Geometry/GeometryUtilities.js"], r["Core/Utilities.js"]], function(T, B) {
        let { pointInPolygon: I } = T, { addEvent: R, fireEvent: z, objectEach: O, pick: L } = B;
        function M(l) {
          let u = l.length, c = (S, E) => !(E.x >= S.x + S.width || E.x + E.width <= S.x || E.y >= S.y + S.height || E.y + E.height <= S.y), v = (S, E) => {
            for (let b of S) if (I({ x: b[0], y: b[1] }, E)) return !0;
            return !1;
          }, s, f, y, h, a, x = !1;
          for (let S = 0; S < u; S++) (s = l[S]) && (s.oldOpacity = s.opacity, s.newOpacity = 1, s.absoluteBox = function(E) {
            var b, p;
            if (E && (!E.alignAttr || E.placed)) {
              let C = E.box ? 0 : E.padding || 0, o = E.alignAttr || { x: E.attr("x"), y: E.attr("y") }, t = E.getBBox();
              return E.width = t.width, E.height = t.height, { x: o.x + (((b = E.parentGroup) == null ? void 0 : b.translateX) || 0) + C, y: o.y + (((p = E.parentGroup) == null ? void 0 : p.translateY) || 0) + C, width: (E.width || 0) - 2 * C, height: (E.height || 0) - 2 * C, polygon: t == null ? void 0 : t.polygon };
            }
          }(s));
          l.sort((S, E) => (E.labelrank || 0) - (S.labelrank || 0));
          for (let S = 0; S < u; ++S) {
            h = (f = l[S]) && f.absoluteBox;
            let E = h == null ? void 0 : h.polygon;
            for (let b = S + 1; b < u; ++b) {
              a = (y = l[b]) && y.absoluteBox;
              let p = !1;
              if (h && a && f !== y && f.newOpacity !== 0 && y.newOpacity !== 0 && f.visibility !== "hidden" && y.visibility !== "hidden") {
                let C = a.polygon;
                if (E && C && E !== C ? v(E, C) && (p = !0) : c(h, a) && (p = !0), p) {
                  let o = f.labelrank < y.labelrank ? f : y, t = o.text;
                  o.newOpacity = 0, t != null && t.element.querySelector("textPath") && t.hide();
                }
              }
            }
          }
          for (let S of l) w(S, this) && (x = !0);
          x && z(this, "afterHideAllOverlappingLabels");
        }
        function w(l, u) {
          let c, v, s = !1;
          return l && (v = l.newOpacity, l.oldOpacity !== v && (l.hasClass("highcharts-data-label") ? (l[v ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), c = function() {
            u.styledMode || l.css({ pointerEvents: v ? "auto" : "none" });
          }, s = !0, l[l.isOld ? "animate" : "attr"]({ opacity: v }, void 0, c), z(u, "afterHideOverlappingLabel")) : l.attr({ opacity: v })), l.isOld = !0), s;
        }
        function A() {
          var c;
          let l = this, u = [];
          for (let v of l.labelCollectors || []) u = u.concat(v());
          for (let v of l.yAxis || []) v.stacking && v.options.stackLabels && !v.options.stackLabels.allowOverlap && O(v.stacking.stacks, (s) => {
            O(s, (f) => {
              f.label && u.push(f.label);
            });
          });
          for (let v of l.series || []) if (v.visible && ((c = v.hasDataLabels) != null && c.call(v))) {
            let s = (f) => {
              for (let y of f) y.visible && (y.dataLabels || []).forEach((h) => {
                var x;
                let a = h.options || {};
                h.labelrank = L(a.labelrank, y.labelrank, (x = y.shapeArgs) == null ? void 0 : x.height), a.allowOverlap ?? Number(a.distance) > 0 ? (h.oldOpacity = h.opacity, h.newOpacity = 1, w(h, l)) : u.push(h);
              });
            };
            s(v.nodes || []), s(v.points);
          }
          this.hideOverlappingLabels(u);
        }
        return { compose: function(l) {
          let u = l.prototype;
          u.hideOverlappingLabels || (u.hideOverlappingLabels = M, R(l, "render", A));
        } };
      }), Z(r, "Extensions/BorderRadius.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { defaultOptions: R } = T, { noop: z } = B, { addEvent: O, extend: L, isObject: M, merge: w, relativeLength: A } = I, l = { radius: 0, scope: "stack", where: void 0 }, u = z, c = z;
        function v(a, x, S, E, b = {}) {
          let p = u(a, x, S, E, b), { innerR: C = 0, r: o = S, start: t = 0, end: e = 0 } = b;
          if (b.open || !b.borderRadius) return p;
          let n = e - t, d = Math.sin(n / 2), i = Math.max(Math.min(A(b.borderRadius || 0, o - C), (o - C) / 2, o * d / (1 + d)), 0), g = Math.min(i, n / Math.PI * 2 * C), m = p.length - 1;
          for (; m--; ) (function(k, j, P) {
            let D, H, G, V = k[j], F = k[j + 1];
            if (F[0] === "Z" && (F = k[0]), (V[0] === "M" || V[0] === "L") && F[0] === "A" ? (D = V, H = F, G = !0) : V[0] === "A" && (F[0] === "M" || F[0] === "L") && (D = F, H = V), D && H && H.params) {
              let U = H[1], Y = H[5], q = H.params, { start: N, end: X, cx: W, cy: _ } = q, K = Y ? U - P : U + P, J = K ? Math.asin(P / K) : 0, $ = Y ? J : -J, et = Math.cos(J) * K;
              G ? (q.start = N + $, D[1] = W + et * Math.cos(N), D[2] = _ + et * Math.sin(N), k.splice(j + 1, 0, ["A", P, P, 0, 0, 1, W + U * Math.cos(q.start), _ + U * Math.sin(q.start)])) : (q.end = X - $, H[6] = W + U * Math.cos(q.end), H[7] = _ + U * Math.sin(q.end), k.splice(j + 1, 0, ["A", P, P, 0, 0, 1, W + et * Math.cos(X), _ + et * Math.sin(X)])), H[4] = Math.abs(q.end - q.start) < Math.PI ? 0 : 1;
            }
          })(p, m, m > 1 ? g : i);
          return p;
        }
        function s() {
          var a, x;
          if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
            let { options: S, yAxis: E } = this, b = S.stacking === "percent", p = (x = (a = R.plotOptions) == null ? void 0 : a[this.type]) == null ? void 0 : x.borderRadius, C = f(S.borderRadius, M(p) ? p : {}), o = E.options.reversed;
            for (let t of this.points) {
              let { shapeArgs: e } = t;
              if (t.shapeType === "roundedRect" && e) {
                let { width: n = 0, height: d = 0, y: i = 0 } = e, g = i, m = d;
                if (C.scope === "stack" && t.stackTotal) {
                  let D = E.translate(b ? 100 : t.stackTotal, !1, !0, !1, !0), H = E.translate(S.threshold || 0, !1, !0, !1, !0), G = this.crispCol(0, Math.min(D, H), 0, Math.abs(D - H));
                  g = G.y, m = G.height;
                }
                let k = (t.negative ? -1 : 1) * (o ? -1 : 1) == -1, j = C.where;
                !j && this.is("waterfall") && Math.abs((t.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (j = "all"), j || (j = "end");
                let P = Math.min(A(C.radius, n), n / 2, j === "all" ? d / 2 : 1 / 0) || 0;
                j === "end" && (k && (g -= P), m += P), L(e, { brBoxHeight: m, brBoxY: g, r: P });
              }
            }
          }
        }
        function f(a, x) {
          return M(a) || (a = { radius: a || 0 }), w(l, x, a);
        }
        function y() {
          let a = f(this.options.borderRadius);
          for (let x of this.points) {
            let S = x.shapeArgs;
            S && (S.borderRadius = A(a.radius, (S.r || 0) - (S.innerR || 0)));
          }
        }
        function h(a, x, S, E, b = {}) {
          let p = c(a, x, S, E, b), { r: C = 0, brBoxHeight: o = E, brBoxY: t = x } = b, e = x - t, n = t + o - (x + E), d = e - C > -0.1 ? 0 : C, i = n - C > -0.1 ? 0 : C, g = Math.max(d && e, 0), m = Math.max(i && n, 0), k = [a + d, x], j = [a + S - d, x], P = [a + S, x + d], D = [a + S, x + E - i], H = [a + S - i, x + E], G = [a + i, x + E], V = [a, x + E - i], F = [a, x + d], U = (Y, q) => Math.sqrt(Math.pow(Y, 2) - Math.pow(q, 2));
          if (g) {
            let Y = U(d, d - g);
            k[0] -= Y, j[0] += Y, P[1] = F[1] = x + d - g;
          }
          if (E < d - g) {
            let Y = U(d, d - g - E);
            P[0] = D[0] = a + S - d + Y, H[0] = Math.min(P[0], H[0]), G[0] = Math.max(D[0], G[0]), V[0] = F[0] = a + d - Y, P[1] = F[1] = x + E;
          }
          if (m) {
            let Y = U(i, i - m);
            H[0] += Y, G[0] -= Y, D[1] = V[1] = x + E - i + m;
          }
          if (E < i - m) {
            let Y = U(i, i - m - E);
            P[0] = D[0] = a + S - i + Y, j[0] = Math.min(P[0], j[0]), k[0] = Math.max(D[0], k[0]), V[0] = F[0] = a + i - Y, D[1] = V[1] = x;
          }
          return p.length = 0, p.push(["M", ...k], ["L", ...j], ["A", d, d, 0, 0, 1, ...P], ["L", ...D], ["A", i, i, 0, 0, 1, ...H], ["L", ...G], ["A", i, i, 0, 0, 1, ...V], ["L", ...F], ["A", d, d, 0, 0, 1, ...k], ["Z"]), p;
        }
        return { compose: function(a, x, S) {
          let E = a.types.pie;
          if (!x.symbolCustomAttribs.includes("borderRadius")) {
            let b = S.prototype.symbols;
            O(a, "afterColumnTranslate", s, { order: 9 }), O(E, "afterTranslate", y), x.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), u = b.arc, c = b.roundedRect, b.arc = v, b.roundedRect = h;
          }
        }, optionsToObject: f };
      }), Z(r, "Core/Responsive.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { diffObjects: I, extend: R, find: z, merge: O, pick: L, uniqueKey: M } = T;
        return function(w) {
          function A(u, c) {
            let v = u.condition;
            (v.callback || function() {
              return this.chartWidth <= L(v.maxWidth, Number.MAX_VALUE) && this.chartHeight <= L(v.maxHeight, Number.MAX_VALUE) && this.chartWidth >= L(v.minWidth, 0) && this.chartHeight >= L(v.minHeight, 0);
            }).call(this) && c.push(u._id);
          }
          function l(u, c) {
            let v = this.options.responsive, s = this.currentResponsive, f = [], y;
            !c && v && v.rules && v.rules.forEach((x) => {
              x._id === void 0 && (x._id = M()), this.matchResponsiveRule(x, f);
            }, this);
            let h = O(...f.map((x) => z((v || {}).rules || [], (S) => S._id === x)).map((x) => x && x.chartOptions));
            h.isResponsiveOptions = !0, f = f.toString() || void 0;
            let a = s && s.ruleIds;
            f === a || (s && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(s.undoOptions, u, !0), this.updatingResponsive = !1), f ? ((y = I(h, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: f, mergedOptions: h, undoOptions: y }, this.updatingResponsive || this.update(h, u, !0)) : this.currentResponsive = void 0);
          }
          w.compose = function(u) {
            let c = u.prototype;
            return c.matchResponsiveRule || R(c, { matchResponsiveRule: A, setResponsive: l }), u;
          };
        }(B || (B = {})), B;
      }), Z(r, "masters/highcharts.src.js", [r["Core/Globals.js"], r["Core/Utilities.js"], r["Core/Defaults.js"], r["Core/Animation/Fx.js"], r["Core/Animation/AnimationUtilities.js"], r["Core/Renderer/HTML/AST.js"], r["Core/Templating.js"], r["Core/Renderer/RendererRegistry.js"], r["Core/Renderer/RendererUtilities.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Renderer/HTML/HTMLElement.js"], r["Core/Axis/Axis.js"], r["Core/Axis/DateTimeAxis.js"], r["Core/Axis/LogarithmicAxis.js"], r["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], r["Core/Axis/Tick.js"], r["Core/Tooltip.js"], r["Core/Series/Point.js"], r["Core/Pointer.js"], r["Core/Legend/Legend.js"], r["Core/Legend/LegendSymbol.js"], r["Core/Chart/Chart.js"], r["Extensions/ScrollablePlotArea.js"], r["Core/Axis/Stacking/StackingAxis.js"], r["Core/Axis/Stacking/StackItem.js"], r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Series/Column/ColumnDataLabel.js"], r["Series/Pie/PieDataLabel.js"], r["Core/Series/DataLabel.js"], r["Extensions/OverlappingDataLabels.js"], r["Extensions/BorderRadius.js"], r["Core/Responsive.js"], r["Core/Color/Color.js"], r["Core/Time.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u, c, v, s, f, y, h, a, x, S, E, b, p, C, o, t, e, n, d, i, g, m, k, j, P) {
        return T.AST = O, T.Axis = c, T.Chart = b, T.Color = j, T.DataLabel = i, T.Fx = R, T.HTMLElement = u, T.Legend = S, T.LegendSymbol = E, T.OverlappingDataLabels = T.OverlappingDataLabels || g, T.PlotLineOrBand = f, T.Point = a, T.Pointer = x, T.RendererRegistry = M, T.Series = t, T.SeriesRegistry = e, T.StackItem = o, T.SVGElement = A, T.SVGRenderer = l, T.Templating = L, T.Tick = y, T.Time = P, T.Tooltip = h, T.animate = z.animate, T.animObject = z.animObject, T.chart = b.chart, T.color = j.parse, T.dateFormat = L.dateFormat, T.defaultOptions = I.defaultOptions, T.distribute = w.distribute, T.format = L.format, T.getDeferredAnimation = z.getDeferredAnimation, T.getOptions = I.getOptions, T.numberFormat = L.numberFormat, T.seriesType = e.seriesType, T.setAnimation = z.setAnimation, T.setOptions = I.setOptions, T.stop = z.stop, T.time = I.defaultTime, T.timers = R.timers, m.compose(T.Series, T.SVGElement, T.SVGRenderer), n.compose(T.Series.types.column), i.compose(T.Series), v.compose(T.Axis), u.compose(T.SVGRenderer), S.compose(T.Chart), s.compose(T.Axis), g.compose(T.Chart), d.compose(T.Series.types.pie), f.compose(T.Chart, T.Axis), x.compose(T.Chart), k.compose(T.Chart), p.compose(T.Axis, T.Chart, T.Series), C.compose(T.Axis, T.Chart, T.Series), h.compose(T.Pointer), B.extend(T, B), T;
      }), r["masters/highcharts.src.js"]._modules = r, r["masters/highcharts.src.js"];
    });
  }(ae)), ae.exports;
}
var sl = il();
const Ot = /* @__PURE__ */ It(sl);
var ve = { exports: {} }, Bs;
function ol() {
  return Bs || (Bs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * (c) 2009-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Extensions/Pane/PaneComposition.js", [r["Core/Utilities.js"]], function(T) {
        let { addEvent: B, correctFloat: I, defined: R, pick: z } = T;
        function O(l) {
          let u, c = this;
          return l && c.pane.forEach((v) => {
            L(l.chartX - c.plotLeft, l.chartY - c.plotTop, v.center) && (u = v);
          }), u;
        }
        function L(l, u, c, v, s) {
          let f = !0, y = c[0], h = c[1], a = Math.sqrt(Math.pow(l - y, 2) + Math.pow(u - h, 2));
          if (R(v) && R(s)) {
            let x = Math.atan2(I(u - h, 8), I(l - y, 8));
            s !== v && (f = v > s ? x >= v && x <= Math.PI || x <= s && x >= -Math.PI : x >= v && x <= I(s, 8));
          }
          return a <= Math.ceil(c[2] / 2) && f;
        }
        function M(l) {
          this.polar && (l.options.inverted && ([l.x, l.y] = [l.y, l.x]), l.isInsidePlot = this.pane.some((u) => L(l.x, l.y, u.center, u.axis && u.axis.normalizedStartAngleRad, u.axis && u.axis.normalizedEndAngleRad)));
        }
        function w(l) {
          let u = this.chart;
          l.hoverPoint && l.hoverPoint.plotX && l.hoverPoint.plotY && u.hoverPane && !L(l.hoverPoint.plotX, l.hoverPoint.plotY, u.hoverPane.center) && (l.hoverPoint = void 0);
        }
        function A(l) {
          let u = this.chart;
          u.polar ? (u.hoverPane = u.getHoverPane(l), l.filter = function(c) {
            return c.visible && !(!l.shared && c.directTouch) && z(c.options.enableMouseTracking, !0) && (!u.hoverPane || c.xAxis.pane === u.hoverPane);
          }) : u.hoverPane = void 0;
        }
        return { compose: function(l, u) {
          let c = l.prototype;
          c.getHoverPane || (c.collectionsWithUpdate.push("pane"), c.getHoverPane = O, B(l, "afterIsInsidePlot", M), B(u, "afterGetHoverData", w), B(u, "beforeGetHoverData", A));
        } };
      }), Z(r, "Extensions/Pane/PaneDefaults.js", [], function() {
        return { pane: { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, background: { shape: "circle", borderRadius: 0, borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" } };
      }), Z(r, "Extensions/Pane/Pane.js", [r["Series/CenteredUtilities.js"], r["Extensions/Pane/PaneComposition.js"], r["Extensions/Pane/PaneDefaults.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { extend: z, merge: O, splat: L } = R;
        class M {
          constructor(A, l) {
            this.coll = "pane", this.init(A, l);
          }
          init(A, l) {
            this.chart = l, this.background = [], l.pane.push(this), this.setOptions(A);
          }
          setOptions(A) {
            this.options = A = O(I.pane, this.chart.angular ? { background: {} } : void 0, A);
          }
          render() {
            let A = this.options, l = this.chart.renderer;
            this.group || (this.group = l.g("pane-group").attr({ zIndex: A.zIndex || 0 }).add()), this.updateCenter();
            let u = this.options.background;
            if (u) {
              let c = Math.max((u = L(u)).length, this.background.length || 0);
              for (let v = 0; v < c; v++) u[v] && this.axis ? this.renderBackground(O(I.background, u[v]), v) : this.background[v] && (this.background[v] = this.background[v].destroy(), this.background.splice(v, 1));
            }
          }
          renderBackground(A, l) {
            let u = { class: "highcharts-pane " + (A.className || "") }, c = "animate";
            this.chart.styledMode || z(u, { fill: A.backgroundColor, stroke: A.borderColor, "stroke-width": A.borderWidth }), this.background[l] || (this.background[l] = this.chart.renderer.path().add(this.group), c = "attr"), this.background[l][c]({ d: this.axis.getPlotBandPath(A.from, A.to, A) }).attr(u);
          }
          updateCenter(A) {
            this.center = (A || this.axis || {}).center = T.getCenter.call(this);
          }
          update(A, l) {
            O(!0, this.options, A), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(u) {
              u.pane === this && (u.pane = null, u.update({}, l));
            }, this);
          }
        }
        return M.compose = B.compose, M;
      }), Z(r, "Series/AreaRange/AreaRangePoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { area: { prototype: { pointClass: I, pointClass: { prototype: R } } } } = T.seriesTypes, { defined: z, isNumber: O } = B;
        return class extends I {
          setState() {
            let L = this.state, M = this.series, w = M.chart.polar;
            z(this.plotHigh) || (this.plotHigh = M.yAxis.toPixels(this.high, !0)), z(this.plotLow) || (this.plotLow = this.plotY = M.yAxis.toPixels(this.low, !0)), M.lowerStateMarkerGraphic = M.stateMarkerGraphic, M.stateMarkerGraphic = M.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, w && O(this.plotHighX) && (this.plotX = this.plotHighX), R.setState.apply(this, arguments), this.state = L, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], w && O(this.plotLowX) && (this.plotX = this.plotLowX), M.upperStateMarkerGraphic = M.stateMarkerGraphic, M.stateMarkerGraphic = M.lowerStateMarkerGraphic, M.lowerStateMarkerGraphic = void 0;
            let A = M.modifyMarkerSettings();
            R.setState.apply(this, arguments), M.restoreMarkerSettings(A);
          }
          haloPath() {
            let L = this.series.chart.polar, M = [];
            return this.plotY = this.plotLow, L && O(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (M = R.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, L && O(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (M = M.concat(R.haloPath.apply(this, arguments))), M;
          }
          isValid() {
            return O(this.low) && O(this.high);
          }
        };
      }), Z(r, "Series/AreaRange/AreaRangeSeries.js", [r["Series/AreaRange/AreaRangePoint.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { noop: z } = B, { area: O, area: { prototype: L }, column: { prototype: M } } = I.seriesTypes, { addEvent: w, defined: A, extend: l, isArray: u, isNumber: c, pick: v, merge: s } = R;
        class f extends O {
          toYData(h) {
            return [h.low, h.high];
          }
          highToXY(h) {
            let a = this.chart, x = this.xAxis.postTranslate(h.rectPlotX || 0, this.yAxis.len - (h.plotHigh || 0));
            h.plotHighX = x.x - a.plotLeft, h.plotHigh = x.y - a.plotTop, h.plotLowX = h.plotX;
          }
          getGraphPath(h) {
            let a = [], x = [], S = L.getGraphPath, E = this.options, b = this.chart.polar, p = b && E.connectEnds !== !1, C = E.connectNulls, o, t, e, n = E.step;
            for (o = (h = h || this.points).length; o--; ) {
              t = h[o];
              let k = b ? { plotX: t.rectPlotX, plotY: t.yBottom, doCurve: !1 } : { plotX: t.plotX, plotY: t.plotY, doCurve: !1 };
              t.isNull || p || C || h[o + 1] && !h[o + 1].isNull || x.push(k), e = { polarPlotY: t.polarPlotY, rectPlotX: t.rectPlotX, yBottom: t.yBottom, plotX: v(t.plotHighX, t.plotX), plotY: t.plotHigh, isNull: t.isNull }, x.push(e), a.push(e), t.isNull || p || C || h[o - 1] && !h[o - 1].isNull || x.push(k);
            }
            let d = S.call(this, h);
            n && (n === !0 && (n = "left"), E.step = { left: "right", center: "center", right: "left" }[n]);
            let i = S.call(this, a), g = S.call(this, x);
            E.step = n;
            let m = [].concat(d, i);
            return !this.chart.polar && g[0] && g[0][0] === "M" && (g[0] = ["L", g[0][1], g[0][2]]), this.graphPath = m, this.areaPath = d.concat(g), m.isArea = !0, m.xMap = d.xMap, this.areaPath.xMap = d.xMap, m;
          }
          drawDataLabels() {
            var e, n;
            let h, a, x, S, E, b = this.points, p = b.length, C = [], o = this.options.dataLabels, t = this.chart.inverted;
            if (o) {
              if (u(o) ? (S = o[0] || { enabled: !1 }, E = o[1] || { enabled: !1 }) : ((S = l({}, o)).x = o.xHigh, S.y = o.yHigh, (E = l({}, o)).x = o.xLow, E.y = o.yLow), S.enabled || ((e = this.hasDataLabels) == null ? void 0 : e.call(this))) {
                for (h = p; h--; ) if (a = b[h]) {
                  let { plotHigh: d = 0, plotLow: i = 0 } = a;
                  x = S.inside ? d < i : d > i, a.y = a.high, a._plotY = a.plotY, a.plotY = d, C[h] = a.dataLabel, a.dataLabel = a.dataLabelUpper, a.below = x, t ? S.align || (S.align = x ? "right" : "left") : S.verticalAlign || (S.verticalAlign = x ? "top" : "bottom");
                }
                for (this.options.dataLabels = S, L.drawDataLabels && L.drawDataLabels.apply(this, arguments), h = p; h--; ) (a = b[h]) && (a.dataLabelUpper = a.dataLabel, a.dataLabel = C[h], delete a.dataLabels, a.y = a.low, a.plotY = a._plotY);
              }
              if (E.enabled || (n = this.hasDataLabels) != null && n.call(this)) {
                for (h = p; h--; ) if (a = b[h]) {
                  let { plotHigh: d = 0, plotLow: i = 0 } = a;
                  x = E.inside ? d < i : d > i, a.below = !x, t ? E.align || (E.align = x ? "left" : "right") : E.verticalAlign || (E.verticalAlign = x ? "bottom" : "top");
                }
                this.options.dataLabels = E, L.drawDataLabels && L.drawDataLabels.apply(this, arguments);
              }
              if (S.enabled) for (h = p; h--; ) (a = b[h]) && (a.dataLabels = [a.dataLabelUpper, a.dataLabel].filter(function(d) {
                return !!d;
              }));
              this.options.dataLabels = o;
            }
          }
          alignDataLabel() {
            M.alignDataLabel.apply(this, arguments);
          }
          modifyMarkerSettings() {
            let h = { marker: this.options.marker, symbol: this.symbol };
            if (this.options.lowMarker) {
              let { options: { marker: a, lowMarker: x } } = this;
              this.options.marker = s(a, x), x.symbol && (this.symbol = x.symbol);
            }
            return h;
          }
          restoreMarkerSettings(h) {
            this.options.marker = h.marker, this.symbol = h.symbol;
          }
          drawPoints() {
            let h, a, x = this.points.length, S = this.modifyMarkerSettings();
            for (L.drawPoints.apply(this, arguments), this.restoreMarkerSettings(S), h = 0; h < x; ) (a = this.points[h]).graphics = a.graphics || [], a.origProps = { plotY: a.plotY, plotX: a.plotX, isInside: a.isInside, negative: a.negative, zone: a.zone, y: a.y }, (a.graphic || a.graphics[0]) && (a.graphics[0] = a.graphic), a.graphic = a.graphics[1], a.plotY = a.plotHigh, A(a.plotHighX) && (a.plotX = a.plotHighX), a.y = v(a.high, a.origProps.y), a.negative = a.y < (this.options.threshold || 0), this.zones.length && (a.zone = a.getZone()), this.chart.polar || (a.isInside = a.isTopInside = a.plotY !== void 0 && a.plotY >= 0 && a.plotY <= this.yAxis.len && a.plotX >= 0 && a.plotX <= this.xAxis.len), h++;
            for (L.drawPoints.apply(this, arguments), h = 0; h < x; ) (a = this.points[h]).graphics = a.graphics || [], (a.graphic || a.graphics[1]) && (a.graphics[1] = a.graphic), a.graphic = a.graphics[0], a.origProps && (l(a, a.origProps), delete a.origProps), h++;
          }
          hasMarkerChanged(h, a) {
            let x = h.lowMarker, S = a.lowMarker || {};
            return x && (x.enabled === !1 || S.symbol !== x.symbol || S.height !== x.height || S.width !== x.width) || super.hasMarkerChanged(h, a);
          }
        }
        return f.defaultOptions = s(O.defaultOptions, { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: !0, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }), w(f, "afterTranslate", function() {
          this.pointArrayMap.join(",") === "low,high" && this.points.forEach((y) => {
            let h = y.high, a = y.plotY;
            y.isNull ? y.plotY = void 0 : (y.plotLow = a, y.plotHigh = c(h) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(h) : h, !1, !0, void 0, !0) : void 0, this.dataModify && (y.yBottom = y.plotHigh));
          });
        }, { order: 0 }), w(f, "afterTranslate", function() {
          this.points.forEach((y) => {
            if (this.chart.polar) this.highToXY(y), y.plotLow = y.plotY, y.tooltipPos = [((y.plotHighX || 0) + (y.plotLowX || 0)) / 2, ((y.plotHigh || 0) + (y.plotLow || 0)) / 2];
            else {
              let h = y.pos(!1, y.plotLow), a = y.pos(!1, y.plotHigh);
              h && a && (h[0] = (h[0] + a[0]) / 2, h[1] = (h[1] + a[1]) / 2), y.tooltipPos = h;
            }
          });
        }, { order: 3 }), l(f.prototype, { deferTranslatePolar: !0, pointArrayMap: ["low", "high"], pointClass: T, pointValKey: "low", setStackedPoints: z }), I.registerSeriesType("arearange", f), f;
      }), Z(r, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [r["Series/AreaRange/AreaRangeSeries.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { spline: { prototype: R } } = B.seriesTypes, { merge: z, extend: O } = I;
        class L extends T {
        }
        return L.defaultOptions = z(T.defaultOptions), O(L.prototype, { getPointSpline: R.getPointSpline }), B.registerSeriesType("areasplinerange", L), L;
      }), Z(r, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
        return { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 };
      }), Z(r, "Series/BoxPlot/BoxPlotSeries.js", [r["Series/BoxPlot/BoxPlotSeriesDefaults.js"], r["Series/Column/ColumnSeries.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { noop: O } = I, { crisp: L, extend: M, merge: w, pick: A } = z;
        class l extends B {
          pointAttribs() {
            return {};
          }
          translate() {
            let c = this.yAxis, v = this.pointArrayMap;
            super.translate.apply(this), this.points.forEach(function(s) {
              v.forEach(function(f) {
                s[f] !== null && (s[f + "Plot"] = c.translate(s[f], 0, 1, 0, 1));
              }), s.plotHigh = s.highPlot;
            });
          }
          drawPoints() {
            let c, v, s, f, y, h, a, x, S, E, b, p, C, o = this.points, t = this.options, e = this.chart, n = e.renderer, d = this.doQuartiles !== !1, i = this.options.whiskerLength;
            for (let g of o) {
              let m = (x = g.graphic) ? "animate" : "attr", k = g.shapeArgs, j = {}, P = {}, D = {}, H = {}, G = g.color || this.color;
              if (g.plotY !== void 0) {
                let V;
                S = k.width, b = (E = k.x) + S, p = S / 2, c = d ? g.q1Plot : g.lowPlot, v = d ? g.q3Plot : g.lowPlot, s = g.highPlot, f = g.lowPlot, x || (g.graphic = x = n.g("point").add(this.group), g.stem = n.path().addClass("highcharts-boxplot-stem").add(x), i && (g.whiskers = n.path().addClass("highcharts-boxplot-whisker").add(x)), d && (g.box = n.path(a).addClass("highcharts-boxplot-box").add(x)), g.medianShape = n.path(h).addClass("highcharts-boxplot-median").add(x)), e.styledMode || (P.stroke = g.stemColor || t.stemColor || G, P["stroke-width"] = A(g.stemWidth, t.stemWidth, t.lineWidth), P.dashstyle = g.stemDashStyle || t.stemDashStyle || t.dashStyle, g.stem.attr(P), i && (D.stroke = g.whiskerColor || t.whiskerColor || G, D["stroke-width"] = A(g.whiskerWidth, t.whiskerWidth, t.lineWidth), D.dashstyle = g.whiskerDashStyle || t.whiskerDashStyle || t.dashStyle, g.whiskers.attr(D)), d && (j.fill = g.fillColor || t.fillColor || G, j.stroke = t.lineColor || G, j["stroke-width"] = t.lineWidth || 0, j.dashstyle = g.boxDashStyle || t.boxDashStyle || t.dashStyle, g.box.attr(j)), H.stroke = g.medianColor || t.medianColor || G, H["stroke-width"] = A(g.medianWidth, t.medianWidth, t.lineWidth), H.dashstyle = g.medianDashStyle || t.medianDashStyle || t.dashStyle, g.medianShape.attr(H));
                let F = L((g.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, g.stem.strokeWidth());
                if (V = [["M", F, v], ["L", F, s], ["M", F, c], ["L", F, f]], g.stem[m]({ d: V }), d) {
                  let U = g.box.strokeWidth();
                  c = L(c, U), v = L(v, U), V = [["M", E = L(E, U), v], ["L", E, c], ["L", b = L(b, U), c], ["L", b, v], ["L", E, v], ["Z"]], g.box[m]({ d: V });
                }
                if (i) {
                  let U = g.whiskers.strokeWidth();
                  s = L(g.highPlot, U), f = L(g.lowPlot, U), V = [["M", L(F - (C = typeof i == "string" && /%$/.test(i) ? p * parseFloat(i) / 100 : Number(i) / 2)), s], ["L", L(F + C), s], ["M", L(F - C), f], ["L", L(F + C), f]], g.whiskers[m]({ d: V });
                }
                V = [["M", E, y = L(g.medianPlot, g.medianShape.strokeWidth())], ["L", b, y]], g.medianShape[m]({ d: V });
              }
            }
          }
          toYData(c) {
            return [c.low, c.q1, c.median, c.q3, c.high];
          }
        }
        return l.defaultOptions = w(B.defaultOptions, T), M(l.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: O, setStackedPoints: O }), R.registerSeriesType("boxplot", l), l;
      }), Z(r, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
        return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
      }), Z(r, "Series/Bubble/BubbleLegendItem.js", [r["Core/Color/Color.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { parse: z } = T, { noop: O } = I, { arrayMax: L, arrayMin: M, isNumber: w, merge: A, pick: l, stableSort: u } = R;
        return class {
          constructor(c, v) {
            this.setState = O, this.init(c, v);
          }
          init(c, v) {
            this.options = c, this.visible = !0, this.chart = v.chart, this.legend = v;
          }
          addToLegend(c) {
            c.splice(this.options.legendIndex, 0, this);
          }
          drawLegendSymbol(c) {
            let v, s = l(c.options.itemDistance, 20), f = this.legendItem || {}, y = this.options, h = y.ranges, a = y.connectorDistance;
            if (!h || !h.length || !w(h[0].value)) {
              c.options.bubbleLegend.autoRanges = !0;
              return;
            }
            u(h, function(b, p) {
              return p.value - b.value;
            }), this.ranges = h, this.setOptions(), this.render();
            let x = this.getMaxLabelSize(), S = this.ranges[0].radius, E = 2 * S;
            v = (v = a - S + x.width) > 0 ? v : 0, this.maxLabel = x, this.movementX = y.labels.align === "left" ? v : 0, f.labelWidth = E + v + s, f.labelHeight = E + x.height / 2;
          }
          setOptions() {
            let c = this.ranges, v = this.options, s = this.chart.series[v.seriesIndex], f = this.legend.baseline, y = { zIndex: v.zIndex, "stroke-width": v.borderWidth }, h = { zIndex: v.zIndex, "stroke-width": v.connectorWidth }, a = { align: this.legend.options.rtl || v.labels.align === "left" ? "right" : "left", zIndex: v.zIndex }, x = s.options.marker.fillOpacity, S = this.chart.styledMode;
            c.forEach(function(E, b) {
              S || (y.stroke = l(E.borderColor, v.borderColor, s.color), y.fill = l(E.color, v.color, x !== 1 ? z(s.color).setOpacity(x).get("rgba") : s.color), h.stroke = l(E.connectorColor, v.connectorColor, s.color)), c[b].radius = this.getRangeRadius(E.value), c[b] = A(c[b], { center: c[0].radius - c[b].radius + f }), S || A(!0, c[b], { bubbleAttribs: A(y), connectorAttribs: A(h), labelAttribs: a });
            }, this);
          }
          getRangeRadius(c) {
            let v = this.options, s = this.options.seriesIndex, f = this.chart.series[s], y = v.ranges[0].value, h = v.ranges[v.ranges.length - 1].value, a = v.minSize, x = v.maxSize;
            return f.getRadius.call(this, h, y, a, x, c);
          }
          render() {
            let c = this.legendItem || {}, v = this.chart.renderer, s = this.options.zThreshold;
            for (let f of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), c.symbol = v.g("bubble-legend"), c.label = v.g("bubble-legend-item").css(this.legend.itemStyle || {}), c.symbol.translateX = 0, c.symbol.translateY = 0, c.symbol.add(c.label), c.label.add(c.group), this.ranges)) f.value >= s && this.renderRange(f);
            this.hideOverlappingLabels();
          }
          renderRange(c) {
            let v = this.ranges[0], s = this.legend, f = this.options, y = f.labels, h = this.chart, a = h.series[f.seriesIndex], x = h.renderer, S = this.symbols, E = S.labels, b = c.center, p = Math.abs(c.radius), C = f.connectorDistance || 0, o = y.align, t = s.options.rtl, e = f.borderWidth, n = f.connectorWidth, d = v.radius || 0, i = b - p - e / 2 + n / 2, g = (i % 1 ? 1 : 0.5) - (n % 2 ? 0 : 0.5), m = x.styledMode, k = t || o === "left" ? -C : C;
            o === "center" && (k = 0, f.connectorDistance = 0, c.labelAttribs.align = "center"), S.bubbleItems.push(x.circle(d, b + g, p).attr(m ? {} : c.bubbleAttribs).addClass((m ? "highcharts-color-" + a.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (f.className || "")).add(this.legendItem.symbol)), S.connectors.push(x.path(x.crispLine([["M", d, i], ["L", d + k, i]], f.connectorWidth)).attr(m ? {} : c.connectorAttribs).addClass((m ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (f.connectorClassName || "")).add(this.legendItem.symbol));
            let j = x.text(this.formatLabel(c)).attr(m ? {} : c.labelAttribs).css(m ? {} : y.style).addClass("highcharts-bubble-legend-labels " + (f.labels.className || "")).add(this.legendItem.symbol), P = { x: d + k + f.labels.x, y: i + f.labels.y + 0.4 * j.getBBox().height };
            j.attr(P), E.push(j), j.placed = !0, j.alignAttr = P;
          }
          getMaxLabelSize() {
            let c, v;
            return this.symbols.labels.forEach(function(s) {
              v = s.getBBox(!0), c = c ? v.width > c.width ? v : c : v;
            }), c || {};
          }
          formatLabel(c) {
            let v = this.options, s = v.labels.formatter, f = v.labels.format, { numberFormatter: y } = this.chart;
            return f ? B.format(f, c) : s ? s.call(c) : y(c.value, 1);
          }
          hideOverlappingLabels() {
            let c = this.chart, v = this.options.labels.allowOverlap, s = this.symbols;
            !v && s && (c.hideOverlappingLabels(s.labels), s.labels.forEach(function(f, y) {
              f.newOpacity ? f.newOpacity !== f.oldOpacity && s.connectors[y].show() : s.connectors[y].hide();
            }));
          }
          getRanges() {
            let c = this.legend.bubbleLegend, v = c.chart.series, s = c.options.ranges, f, y, h = Number.MAX_VALUE, a = -Number.MAX_VALUE;
            return v.forEach(function(x) {
              x.isBubble && !x.ignoreSeries && (y = x.zData.filter(w)).length && (h = l(x.options.zMin, Math.min(h, Math.max(M(y), x.options.displayNegative === !1 ? x.options.zThreshold : -Number.MAX_VALUE))), a = l(x.options.zMax, Math.max(a, L(y))));
            }), f = h === a ? [{ value: a }] : [{ value: h }, { value: (h + a) / 2 }, { value: a, autoRanges: !0 }], s.length && s[0].radius && f.reverse(), f.forEach(function(x, S) {
              s && s[S] && (f[S] = A(s[S], x));
            }), f;
          }
          predictBubbleSizes() {
            let c = this.chart, v = c.legend.options, s = v.floating, f = v.layout === "horizontal", y = f ? c.legend.lastLineHeight : 0, h = c.plotSizeX, a = c.plotSizeY, x = c.series[this.options.seriesIndex], S = x.getPxExtremes(), E = Math.ceil(S.minPxSize), b = Math.ceil(S.maxPxSize), p = Math.min(a, h), C, o = x.options.maxSize;
            return s || !/%$/.test(o) ? C = b : (C = (p + y) * (o = parseFloat(o)) / 100 / (o / 100 + 1), (f && a - C >= h || !f && h - C >= a) && (C = b)), [E, Math.ceil(C)];
          }
          updateRanges(c, v) {
            let s = this.legend.options.bubbleLegend;
            s.minSize = c, s.maxSize = v, s.ranges = this.getRanges();
          }
          correctSizes() {
            let c = this.legend, v = this.chart.series[this.options.seriesIndex].getPxExtremes();
            Math.abs(Math.ceil(v.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, v.maxPxSize), c.render());
          }
        };
      }), Z(r, "Series/Bubble/BubbleLegendComposition.js", [r["Series/Bubble/BubbleLegendDefaults.js"], r["Series/Bubble/BubbleLegendItem.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { setOptions: O } = I, { composed: L } = R, { addEvent: M, objectEach: w, pushUnique: A, wrap: l } = z;
        function u(h, a, x) {
          let S, E, b, p = this.legend, C = c(this) >= 0;
          p && p.options.enabled && p.bubbleLegend && p.options.bubbleLegend.autoRanges && C ? (S = p.bubbleLegend.options, E = p.bubbleLegend.predictBubbleSizes(), p.bubbleLegend.updateRanges(E[0], E[1]), S.placed || (p.group.placed = !1, p.allItems.forEach((o) => {
            (b = o.legendItem || {}).group && (b.group.translateY = void 0);
          })), p.render(), S.placed || (this.getMargins(), this.axes.forEach(function(o) {
            o.visible && o.render(), S.placed || (o.setScale(), o.updateNames(), w(o.ticks, function(t) {
              t.isNew = !0, t.isNewLabel = !0;
            }));
          }), this.getMargins()), S.placed = !0, h.call(this, a, x), p.bubbleLegend.correctSizes(), y(p, v(p))) : (h.call(this, a, x), p && p.options.enabled && p.bubbleLegend && (p.render(), y(p, v(p))));
        }
        function c(h) {
          let a = h.series, x = 0;
          for (; x < a.length; ) {
            if (a[x] && a[x].isBubble && a[x].visible && a[x].zData.length) return x;
            x++;
          }
          return -1;
        }
        function v(h) {
          let a = h.allItems, x = [], S = a.length, E, b, p, C = 0, o = 0;
          for (C = 0; C < S; C++) if (b = a[C].legendItem || {}, p = (a[C + 1] || {}).legendItem || {}, b.labelHeight && (a[C].itemHeight = b.labelHeight), a[C] === a[S - 1] || b.y !== p.y) {
            for (x.push({ height: 0 }), E = x[x.length - 1]; o <= C; o++) a[o].itemHeight > E.height && (E.height = a[o].itemHeight);
            E.step = C;
          }
          return x;
        }
        function s(h) {
          let a = this.bubbleLegend, x = this.options, S = x.bubbleLegend, E = c(this.chart);
          a && a.ranges && a.ranges.length && (S.ranges.length && (S.autoRanges = !!S.ranges[0].autoRanges), this.destroyItem(a)), E >= 0 && x.enabled && S.enabled && (S.seriesIndex = E, this.bubbleLegend = new B(S, this), this.bubbleLegend.addToLegend(h.allItems));
        }
        function f(h) {
          let a;
          if (h.defaultPrevented) return !1;
          let x = h.legendItem, S = this.chart, E = x.visible;
          this && this.bubbleLegend && (x.visible = !E, x.ignoreSeries = E, a = c(S) >= 0, this.bubbleLegend.visible !== a && (this.update({ bubbleLegend: { enabled: a } }), this.bubbleLegend.visible = a), x.visible = E);
        }
        function y(h, a) {
          let x = h.allItems, S = h.options.rtl, E, b, p, C, o = 0;
          x.forEach((t, e) => {
            (C = t.legendItem || {}).group && (E = C.group.translateX || 0, b = C.y || 0, ((p = t.movementX) || S && t.ranges) && (p = S ? E - t.options.maxSize / 2 : E + p, C.group.attr({ translateX: p })), e > a[o].step && o++, C.group.attr({ translateY: Math.round(b + a[o].height / 2) }), C.y = b + a[o].height / 2);
          });
        }
        return { compose: function(h, a) {
          A(L, "Series.BubbleLegend") && (O({ legend: { bubbleLegend: T } }), l(h.prototype, "drawChartBox", u), M(a, "afterGetAllItems", s), M(a, "itemClick", f));
        } };
      }), Z(r, "Series/Bubble/BubblePoint.js", [r["Core/Series/Point.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { seriesTypes: { scatter: { prototype: { pointClass: R } } } } = B, { extend: z } = I;
        class O extends R {
          haloPath(M) {
            let w = (M && this.marker && this.marker.radius || 0) + M;
            if (this.series.chart.inverted) {
              let A = this.pos() || [0, 0], { xAxis: l, yAxis: u, chart: c } = this.series;
              return c.renderer.symbols.circle(l.len - A[1] - w, u.len - A[0] - w, 2 * w, 2 * w);
            }
            return T.prototype.haloPath.call(this, w);
          }
        }
        return z(O.prototype, { ttBelow: !1 }), O;
      }), Z(r, "Series/Bubble/BubbleSeries.js", [r["Series/Bubble/BubbleLegendComposition.js"], r["Series/Bubble/BubblePoint.js"], r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { parse: L } = I, { composed: M, noop: w } = R, { series: A, seriesTypes: { column: { prototype: l }, scatter: u } } = z, { addEvent: c, arrayMax: v, arrayMin: s, clamp: f, extend: y, isNumber: h, merge: a, pick: x, pushUnique: S } = O;
        function E() {
          let p = this.len, { coll: C, isXAxis: o, min: t } = this, e = o ? "xData" : "yData", n = (this.max || 0) - (t || 0), d = 0, i = p, g = p / n, m;
          (C === "xAxis" || C === "yAxis") && (this.series.forEach((k) => {
            if (k.bubblePadding && k.reserveSpace()) {
              this.allowZoomOutside = !0, m = !0;
              let j = k[e];
              if (o && ((k.onPoint || k).getRadii(0, 0, k), k.onPoint && (k.radii = k.onPoint.radii)), n > 0) {
                let P = j.length;
                for (; P--; ) if (h(j[P]) && this.dataMin <= j[P] && j[P] <= this.max) {
                  let D = k.radii && k.radii[P] || 0;
                  d = Math.min((j[P] - t) * g - D, d), i = Math.max((j[P] - t) * g + D, i);
                }
              }
            }
          }), m && n > 0 && !this.logarithmic && (i -= p, g *= (p + Math.max(0, d) - Math.min(i, p)) / p, [["min", "userMin", d], ["max", "userMax", i]].forEach((k) => {
            x(this.options[k[0]], this[k[1]]) === void 0 && (this[k[0]] += k[2] / g);
          })));
        }
        class b extends u {
          static compose(C, o, t) {
            T.compose(o, t), S(M, "Series.Bubble") && c(C, "foundExtremes", E);
          }
          animate(C) {
            !C && this.points.length < this.options.animationLimit && this.points.forEach(function(o) {
              let { graphic: t, plotX: e = 0, plotY: n = 0 } = o;
              t && t.width && (this.hasRendered || t.attr({ x: e, y: n, width: 1, height: 1 }), t.animate(this.markerAttribs(o), this.options.animation));
            }, this);
          }
          getRadii() {
            let C = this.zData, o = this.yData, t = [], e, n, d, i = this.chart.bubbleZExtremes, { minPxSize: g, maxPxSize: m } = this.getPxExtremes();
            if (!i) {
              let k, j = Number.MAX_VALUE, P = -Number.MAX_VALUE;
              this.chart.series.forEach((D) => {
                if (D.bubblePadding && D.reserveSpace()) {
                  let H = (D.onPoint || D).getZExtremes();
                  H && (j = Math.min(x(j, H.zMin), H.zMin), P = Math.max(x(P, H.zMax), H.zMax), k = !0);
                }
              }), k ? (i = { zMin: j, zMax: P }, this.chart.bubbleZExtremes = i) : i = { zMin: 0, zMax: 0 };
            }
            for (n = 0, e = C.length; n < e; n++) d = C[n], t.push(this.getRadius(i.zMin, i.zMax, g, m, d, o && o[n]));
            this.radii = t;
          }
          getRadius(C, o, t, e, n, d) {
            let i = this.options, g = i.sizeBy !== "width", m = i.zThreshold, k = o - C, j = 0.5;
            if (d === null || n === null) return null;
            if (h(n)) {
              if (i.sizeByAbsoluteValue && (n = Math.abs(n - m), o = k = Math.max(o - m, Math.abs(C - m)), C = 0), n < C) return t / 2 - 1;
              k > 0 && (j = (n - C) / k);
            }
            return g && j >= 0 && (j = Math.sqrt(j)), Math.ceil(t + j * (e - t)) / 2;
          }
          hasData() {
            return !!this.processedXData.length;
          }
          markerAttribs(C, o) {
            let t = super.markerAttribs(C, o), { height: e = 0, width: n = 0 } = t;
            return this.chart.inverted ? y(t, { x: (C.plotX || 0) - n / 2, y: (C.plotY || 0) - e / 2 }) : t;
          }
          pointAttribs(C, o) {
            let t = this.options.marker.fillOpacity, e = A.prototype.pointAttribs.call(this, C, o);
            return t !== 1 && (e.fill = L(e.fill).setOpacity(t).get("rgba")), e;
          }
          translate() {
            super.translate.call(this), this.getRadii(), this.translateBubble();
          }
          translateBubble() {
            let { data: C, options: o, radii: t } = this, { minPxSize: e } = this.getPxExtremes(), n = C.length;
            for (; n--; ) {
              let d = C[n], i = t ? t[n] : 0;
              this.zoneAxis === "z" && (d.negative = (d.z || 0) < (o.zThreshold || 0)), h(i) && i >= e / 2 ? (d.marker = y(d.marker, { radius: i, width: 2 * i, height: 2 * i }), d.dlBox = { x: d.plotX - i, y: d.plotY - i, width: 2 * i, height: 2 * i }) : (d.shapeArgs = d.plotY = d.dlBox = void 0, d.isInside = !1);
            }
          }
          getPxExtremes() {
            let C = Math.min(this.chart.plotWidth, this.chart.plotHeight), o = (n) => {
              let d;
              return typeof n == "string" && (d = /%$/.test(n), n = parseInt(n, 10)), d ? C * n / 100 : n;
            }, t = o(x(this.options.minSize, 8)), e = Math.max(o(x(this.options.maxSize, "20%")), t);
            return { minPxSize: t, maxPxSize: e };
          }
          getZExtremes() {
            let C = this.options, o = (this.zData || []).filter(h);
            if (o.length) {
              let t = x(C.zMin, f(s(o), C.displayNegative === !1 ? C.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), e = x(C.zMax, v(o));
              if (h(t) && h(e)) return { zMin: t, zMax: e };
            }
          }
        }
        return b.defaultOptions = a(u.defaultOptions, { dataLabels: { formatter: function() {
          let { numberFormatter: p } = this.series.chart, { z: C } = this.point;
          return h(C) ? p(C, -1) : "";
        }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), y(b.prototype, { alignDataLabel: l.alignDataLabel, applyZones: w, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: B, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), c(b, "updatedData", (p) => {
          delete p.target.chart.bubbleZExtremes;
        }), c(b, "remove", (p) => {
          delete p.target.chart.bubbleZExtremes;
        }), z.registerSeriesType("bubble", b), b;
      }), Z(r, "Series/ColumnRange/ColumnRangePoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { seriesTypes: { column: { prototype: { pointClass: { prototype: I } } }, arearange: { prototype: { pointClass: R } } } } = T, { extend: z, isNumber: O } = B;
        class L extends R {
          isValid() {
            return O(this.low);
          }
        }
        return z(L.prototype, { setState: I.setState }), L;
      }), Z(r, "Series/ColumnRange/ColumnRangeSeries.js", [r["Series/ColumnRange/ColumnRangePoint.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { noop: z } = B, { seriesTypes: { arearange: O, column: L, column: { prototype: M } } } = I, { addEvent: w, clamp: A, extend: l, isNumber: u, merge: c, pick: v } = R;
        class s extends O {
          setOptions() {
            return c(!0, arguments[0], { stacking: void 0 }), O.prototype.setOptions.apply(this, arguments);
          }
          translate() {
            return M.translate.apply(this);
          }
          pointAttribs() {
            return M.pointAttribs.apply(this, arguments);
          }
          translate3dPoints() {
            return M.translate3dPoints.apply(this, arguments);
          }
          translate3dShapes() {
            return M.translate3dShapes.apply(this, arguments);
          }
          afterColumnTranslate() {
            let y, h, a, x, S = this.yAxis, E = this.xAxis, b = E.startAngleRad, p = this.chart, C = this.xAxis.isRadial, o = Math.max(p.chartWidth, p.chartHeight) + 999;
            this.points.forEach((t) => {
              let e = t.shapeArgs || {}, n = this.options.minPointLength, d = t.plotY, i = S.translate(t.high, 0, 1, 0, 1);
              if (u(i) && u(d))
                if (t.plotHigh = A(i, -o, o), t.plotLow = A(d, -o, o), x = t.plotHigh, Math.abs(y = v(t.rectPlotY, t.plotY) - t.plotHigh) < n ? (h = n - y, y += h, x -= h / 2) : y < 0 && (y *= -1, x -= y), C && this.polar) a = t.barX + b, t.shapeType = "arc", t.shapeArgs = this.polar.arc(x + y, x, a, a + t.pointWidth);
                else {
                  e.height = y, e.y = x;
                  let { x: g = 0, width: m = 0 } = e;
                  t.shapeArgs = c(t.shapeArgs, this.crispCol(g, x, m, y)), t.tooltipPos = p.inverted ? [S.len + S.pos - p.plotLeft - x - y / 2, E.len + E.pos - p.plotTop - g - m / 2, y] : [E.left - p.plotLeft + g + m / 2, S.pos - p.plotTop + x + y / 2, y];
                }
            });
          }
        }
        return s.defaultOptions = c(L.defaultOptions, O.defaultOptions, { borderRadius: { where: "all" }, pointRange: null, legendSymbol: "rectangle", marker: null, states: { hover: { halo: !1 } } }), w(s, "afterColumnTranslate", function() {
          s.prototype.afterColumnTranslate.apply(this);
        }, { order: 5 }), l(s.prototype, { directTouch: !0, pointClass: T, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: M.adjustForMissingColumns, animate: M.animate, crispCol: M.crispCol, drawGraph: z, drawPoints: M.drawPoints, getSymbol: z, drawTracker: M.drawTracker, getColumnMetrics: M.getColumnMetrics }), I.registerSeriesType("columnrange", s), s;
      }), Z(r, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
        return {};
      }), Z(r, "Series/ColumnPyramid/ColumnPyramidSeries.js", [r["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { column: R } = B.seriesTypes, { clamp: z, merge: O, pick: L } = I;
        class M extends R {
          translate() {
            let A = this.chart, l = this.options, u = this.dense = this.closestPointRange * this.xAxis.transA < 2, c = this.borderWidth = L(l.borderWidth, u ? 0 : 1), v = this.yAxis, s = l.threshold, f = L(l.minPointLength, 5), y = this.getColumnMetrics(), h = y.width, a = this.pointXOffset = y.offset, x = this.translatedThreshold = v.getThreshold(s), S = this.barW = Math.max(h, 1 + 2 * c);
            for (let E of (A.inverted && (x -= 0.5), l.pointPadding && (S = Math.ceil(S)), super.translate(), this.points)) {
              let b = L(E.yBottom, x), p = 999 + Math.abs(b), C = z(E.plotY, -p, v.len + p), o = S / 2, t = Math.min(C, b), e = Math.max(C, b) - t, n = E.plotX + a, d, i, g, m, k, j, P, D, H, G, V;
              l.centerInCategory && (n = this.adjustForMissingColumns(n, h, E, y)), E.barX = n, E.pointWidth = h, E.tooltipPos = A.inverted ? [v.len + v.pos - A.plotLeft - C, this.xAxis.len - n - o, e] : [n + o, C + v.pos - A.plotTop, e], d = s + (E.total || E.y), l.stacking === "percent" && (d = s + (E.y < 0) ? -100 : 100);
              let F = v.toPixels(d, !0);
              g = (i = A.plotHeight - F - (A.plotHeight - x)) ? o * (t - F) / i : 0, m = i ? o * (t + e - F) / i : 0, j = n - g + o, P = n + g + o, D = n + m + o, H = n - m + o, G = t - f, V = t + e, E.y < 0 && (G = t, V = t + e + f), A.inverted && (k = v.width - t, i = F - (v.width - x), g = o * (F - k) / i, m = o * (F - (k - e)) / i, P = (j = n + o + g) - 2 * g, D = n - m + o, H = n + m + o, G = t, V = t + e - f, E.y < 0 && (V = t + e + f)), E.shapeType = "path", E.shapeArgs = { x: j, y: G, width: P - j, height: e, d: [["M", j, G], ["L", P, G], ["L", D, V], ["L", H, V], ["Z"]] };
            }
          }
        }
        return M.defaultOptions = O(R.defaultOptions, T), B.registerSeriesType("columnpyramid", M), M;
      }), Z(r, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
        return { color: "#000000", grouping: !1, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
      }), Z(r, "Series/ErrorBar/ErrorBarSeries.js", [r["Series/BoxPlot/BoxPlotSeries.js"], r["Series/Column/ColumnSeries.js"], r["Series/ErrorBar/ErrorBarSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { arearange: O } = R.seriesTypes, { addEvent: L, merge: M, extend: w } = z;
        class A extends T {
          getColumnMetrics() {
            return this.linkedParent && this.linkedParent.columnMetrics || B.prototype.getColumnMetrics.call(this);
          }
          drawDataLabels() {
            let u = this.pointValKey;
            if (O) for (let c of (O.prototype.drawDataLabels.call(this), this.points)) c.y = c[u];
          }
          toYData(u) {
            return [u.low, u.high];
          }
        }
        return A.defaultOptions = M(T.defaultOptions, I), L(A, "afterTranslate", function() {
          for (let l of this.points) l.plotLow = l.plotY;
        }, { order: 0 }), w(A.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: !1 }), R.registerSeriesType("errorbar", A), A;
      }), Z(r, "Series/Gauge/GaugePoint.js", [r["Core/Series/SeriesRegistry.js"]], function(T) {
        let { series: { prototype: { pointClass: B } } } = T;
        return class extends B {
          setState(I) {
            this.state = I;
          }
        };
      }), Z(r, "Series/Gauge/GaugeSeries.js", [r["Series/Gauge/GaugePoint.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { noop: z } = B, { series: O, seriesTypes: { column: L } } = I, { clamp: M, isNumber: w, extend: A, merge: l, pick: u, pInt: c, defined: v } = R;
        class s extends O {
          translate() {
            let y = this.yAxis, h = this.options, a = y.center;
            this.generatePoints(), this.points.forEach((x) => {
              let S = l(h.dial, x.dial), E = c(S.radius) * a[2] / 200, b = c(S.baseLength) * E / 100, p = c(S.rearLength) * E / 100, C = S.baseWidth, o = S.topWidth, t = h.overshoot, e = y.startAngleRad + y.translate(x.y, void 0, void 0, void 0, !0);
              (w(t) || h.wrap === !1) && (t = w(t) ? t / 180 * Math.PI : 0, e = M(e, y.startAngleRad - t, y.endAngleRad + t)), e = 180 * e / Math.PI, x.shapeType = "path";
              let n = S.path || [["M", -p, -C / 2], ["L", b, -C / 2], ["L", E, -o / 2], ["L", E, o / 2], ["L", b, C / 2], ["L", -p, C / 2], ["Z"]];
              x.shapeArgs = { d: n, translateX: a[0], translateY: a[1], rotation: e }, x.plotX = a[0], x.plotY = a[1], v(x.y) && y.max - y.min && (x.percentage = (x.y - y.min) / (y.max - y.min) * 100);
            });
          }
          drawPoints() {
            let y = this, h = y.chart, a = y.yAxis.center, x = y.pivot, S = y.options, E = S.pivot, b = h.renderer;
            y.points.forEach((p) => {
              let C = p.graphic, o = p.shapeArgs, t = o.d, e = l(S.dial, p.dial);
              C ? (C.animate(o), o.d = t) : p.graphic = b[p.shapeType](o).addClass("highcharts-dial").add(y.group), h.styledMode || p.graphic[C ? "animate" : "attr"]({ stroke: e.borderColor, "stroke-width": e.borderWidth, fill: e.backgroundColor });
            }), x ? x.animate({ translateX: a[0], translateY: a[1] }) : E && (y.pivot = b.circle(0, 0, E.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(a[0], a[1]).add(y.group), h.styledMode || y.pivot.attr({ fill: E.backgroundColor, stroke: E.borderColor, "stroke-width": E.borderWidth }));
          }
          animate(y) {
            let h = this;
            y || h.points.forEach((a) => {
              let x = a.graphic;
              x && (x.attr({ rotation: 180 * h.yAxis.startAngleRad / Math.PI }), x.animate({ rotation: a.shapeArgs.rotation }, h.options.animation));
            });
          }
          render() {
            this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), O.prototype.render.call(this), this.group.clip(this.chart.clipRect);
          }
          setData(y, h) {
            O.prototype.setData.call(this, y, !1), this.processData(), this.generatePoints(), u(h, !0) && this.chart.redraw();
          }
          hasData() {
            return !!this.points.length;
          }
        }
        return s.defaultOptions = l(O.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: !1, defer: !1, enabled: !0, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: !1 }), A(s.prototype, { angular: !0, directTouch: !0, drawGraph: z, drawTracker: L.prototype.drawTracker, fixedBox: !0, forceDL: !0, noSharedTooltip: !0, pointClass: T, trackerGroups: ["group", "dataLabelsGroup"] }), I.registerSeriesType("gauge", s), s;
      }), Z(r, "Series/DragNodesComposition.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { composed: I } = T, { addEvent: R, pushUnique: z } = B;
        function O() {
          let L, M, w, A = this;
          A.container && (L = R(A.container, "mousedown", (l) => {
            let u = A.hoverPoint;
            u && u.series && u.series.hasDraggableNodes && u.series.options.draggable && (u.series.onMouseDown(u, l), M = R(A.container, "mousemove", (c) => u && u.series && u.series.onMouseMove(u, c)), w = R(A.container.ownerDocument, "mouseup", (c) => (M(), w(), u && u.series && u.series.onMouseUp(u, c))));
          })), R(A, "destroy", function() {
            L();
          });
        }
        return { compose: function(L) {
          z(I, "DragNodes") && R(L, "load", O);
        }, onMouseDown: function(L, M) {
          var A;
          let w = ((A = this.chart.pointer) == null ? void 0 : A.normalize(M)) || M;
          L.fixedPosition = { chartX: w.chartX, chartY: w.chartY, plotX: L.plotX, plotY: L.plotY }, L.inDragMode = !0;
        }, onMouseMove: function(L, M) {
          var w;
          if (L.fixedPosition && L.inDragMode) {
            let A, l, u = this.chart, c = ((w = u.pointer) == null ? void 0 : w.normalize(M)) || M, v = L.fixedPosition.chartX - c.chartX, s = L.fixedPosition.chartY - c.chartY, f = u.graphLayoutsLookup;
            (Math.abs(v) > 5 || Math.abs(s) > 5) && (A = L.fixedPosition.plotX - v, l = L.fixedPosition.plotY - s, u.isInsidePlot(A, l) && (L.plotX = A, L.plotY = l, L.hasDragged = !0, this.redrawHalo(L), f.forEach((y) => {
              y.restartSimulation();
            })));
          }
        }, onMouseUp: function(L) {
          L.fixedPosition && (L.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), L.inDragMode = L.hasDragged = !1, this.options.fixedDraggable || delete L.fixedPosition);
        }, redrawHalo: function(L) {
          L && this.halo && this.halo.attr({ d: L.haloPath(this.options.states.hover.halo.size) });
        } };
      }), Z(r, "Series/GraphLayoutComposition.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { setAnimation: R } = T, { composed: z } = B, { addEvent: O, pushUnique: L } = I;
        function M() {
          this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((u) => {
            u.updateSimulation();
          }), this.redraw());
        }
        function w() {
          this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((u) => {
            u.updateSimulation(!1);
          }), this.redraw());
        }
        function A() {
          this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((u) => {
            u.stop();
          });
        }
        function l() {
          let u, c = !1, v = (s) => {
            s.maxIterations-- && isFinite(s.temperature) && !s.isStable() && !s.enableSimulation && (s.beforeStep && s.beforeStep(), s.step(), u = !1, c = !0);
          };
          if (this.graphLayoutsLookup) {
            for (R(!1, this), this.graphLayoutsLookup.forEach((s) => s.start()); !u; ) u = !0, this.graphLayoutsLookup.forEach(v);
            c && this.series.forEach((s) => {
              s && s.layout && s.render();
            });
          }
        }
        return { compose: function(u) {
          L(z, "GraphLayout") && (O(u, "afterPrint", M), O(u, "beforePrint", w), O(u, "predraw", A), O(u, "render", l));
        }, integrations: {}, layouts: {} };
      }), Z(r, "Series/PackedBubble/PackedBubblePoint.js", [r["Core/Chart/Chart.js"], r["Core/Series/Point.js"], r["Core/Series/SeriesRegistry.js"]], function(T, B, I) {
        let { seriesTypes: { bubble: { prototype: { pointClass: R } } } } = I;
        return class extends R {
          destroy() {
            var z;
            return (z = this.series) != null && z.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), B.prototype.destroy.apply(this, arguments);
          }
          firePointEvent() {
            let z = this.series.options;
            if (this.isParentNode && z.parentNode) {
              let O = z.allowPointSelect;
              z.allowPointSelect = z.parentNode.allowPointSelect, B.prototype.firePointEvent.apply(this, arguments), z.allowPointSelect = O;
            } else B.prototype.firePointEvent.apply(this, arguments);
          }
          select() {
            let z = this.series.chart;
            this.isParentNode ? (z.getSelectedPoints = z.getSelectedParentNodes, B.prototype.select.apply(this, arguments), z.getSelectedPoints = T.prototype.getSelectedPoints) : B.prototype.select.apply(this, arguments);
          }
        };
      }), Z(r, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { isNumber: B } = T;
        return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: !1, tooltip: { pointFormat: "Value: {point.value}" }, draggable: !0, useSimulation: !0, parentNode: { allowPointSelect: !1 }, dataLabels: { formatter: function() {
          let { numberFormatter: I } = this.series.chart, { value: R } = this.point;
          return B(R) ? I(R, -1) : "";
        }, parentNodeFormatter: function() {
          return this.name;
        }, parentNodeTextPath: { enabled: !0 }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: !1, seriesInteraction: !0, dragBetweenSeries: !1, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: !0, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: !0, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: !1, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
      }), Z(r, "Series/Networkgraph/VerletIntegration.js", [], function() {
        return { attractive: function(T, B, I) {
          let R = T.getMass(), z = -I.x * B * this.diffTemperature, O = -I.y * B * this.diffTemperature;
          T.fromNode.fixedPosition || (T.fromNode.plotX -= z * R.fromNode / T.fromNode.degree, T.fromNode.plotY -= O * R.fromNode / T.fromNode.degree), T.toNode.fixedPosition || (T.toNode.plotX += z * R.toNode / T.toNode.degree, T.toNode.plotY += O * R.toNode / T.toNode.degree);
        }, attractiveForceFunction: function(T, B) {
          return (B - T) / T;
        }, barycenter: function() {
          let T = this.options.gravitationalConstant || 0, B = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * T, I = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * T;
          this.nodes.forEach(function(R) {
            R.fixedPosition || (R.plotX -= B / R.mass / R.degree, R.plotY -= I / R.mass / R.degree);
          });
        }, getK: function(T) {
          return Math.pow(T.box.width * T.box.height / T.nodes.length, 0.5);
        }, integrate: function(T, B) {
          let I = -T.options.friction, R = T.options.maxSpeed, z = B.prevX, O = B.prevY, L = (B.plotX + B.dispX - z) * I, M = (B.plotY + B.dispY - O) * I, w = Math.abs, A = w(L) / (L || 1), l = w(M) / (M || 1), u = A * Math.min(R, Math.abs(L)), c = l * Math.min(R, Math.abs(M));
          B.prevX = B.plotX + B.dispX, B.prevY = B.plotY + B.dispY, B.plotX += u, B.plotY += c, B.temperature = T.vectorLength({ x: u, y: c });
        }, repulsive: function(T, B, I) {
          let R = B * this.diffTemperature / T.mass / T.degree;
          T.fixedPosition || (T.plotX += I.x * R, T.plotY += I.y * R);
        }, repulsiveForceFunction: function(T, B) {
          return (B - T) / T * (B > T ? 1 : 0);
        } };
      }), Z(r, "Series/PackedBubble/PackedBubbleIntegration.js", [r["Core/Globals.js"], r["Series/Networkgraph/VerletIntegration.js"]], function(T, B) {
        let { noop: I } = T;
        return { barycenter: function() {
          let R, z, O = this.options.gravitationalConstant, L = this.box, M = this.nodes;
          for (let w of M) this.options.splitSeries && !w.isParentNode ? (R = w.series.parentNode.plotX, z = w.series.parentNode.plotY) : (R = L.width / 2, z = L.height / 2), w.fixedPosition || (w.plotX -= (w.plotX - R) * O / (w.mass * Math.sqrt(M.length)), w.plotY -= (w.plotY - z) * O / (w.mass * Math.sqrt(M.length)));
        }, getK: I, integrate: B.integrate, repulsive: function(R, z, O, L) {
          let M = z * this.diffTemperature / R.mass / R.degree, w = O.x * M, A = O.y * M;
          R.fixedPosition || (R.plotX += w, R.plotY += A), L.fixedPosition || (L.plotX -= w, L.plotY -= A);
        }, repulsiveForceFunction: function(R, z, O, L) {
          return Math.min(R, (O.marker.radius + L.marker.radius) / 2);
        } };
      }), Z(r, "Series/Networkgraph/EulerIntegration.js", [], function() {
        return { attractive: function(T, B, I, R) {
          let z = T.getMass(), O = I.x / R * B, L = I.y / R * B;
          T.fromNode.fixedPosition || (T.fromNode.dispX -= O * z.fromNode / T.fromNode.degree, T.fromNode.dispY -= L * z.fromNode / T.fromNode.degree), T.toNode.fixedPosition || (T.toNode.dispX += O * z.toNode / T.toNode.degree, T.toNode.dispY += L * z.toNode / T.toNode.degree);
        }, attractiveForceFunction: function(T, B) {
          return T * T / B;
        }, barycenter: function() {
          let T = this.options.gravitationalConstant, B = this.barycenter.xFactor, I = this.barycenter.yFactor;
          this.nodes.forEach(function(R) {
            if (!R.fixedPosition) {
              let z = R.getDegree(), O = z * (1 + z / 2);
              R.dispX += (B - R.plotX) * T * O / R.degree, R.dispY += (I - R.plotY) * T * O / R.degree;
            }
          });
        }, getK: function(T) {
          return Math.pow(T.box.width * T.box.height / T.nodes.length, 0.3);
        }, integrate: function(T, B) {
          B.dispX += B.dispX * T.options.friction, B.dispY += B.dispY * T.options.friction;
          let I = B.temperature = T.vectorLength({ x: B.dispX, y: B.dispY });
          I !== 0 && (B.plotX += B.dispX / I * Math.min(Math.abs(B.dispX), T.temperature), B.plotY += B.dispY / I * Math.min(Math.abs(B.dispY), T.temperature));
        }, repulsive: function(T, B, I, R) {
          T.dispX += I.x / R * B / T.degree, T.dispY += I.y / R * B / T.degree;
        }, repulsiveForceFunction: function(T, B) {
          return B * B / T;
        } };
      }), Z(r, "Series/Networkgraph/QuadTreeNode.js", [], function() {
        class T {
          constructor(I) {
            this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = I, this.boxSize = Math.min(I.width, I.height);
          }
          divideBox() {
            let I = this.box.width / 2, R = this.box.height / 2;
            this.nodes[0] = new T({ left: this.box.left, top: this.box.top, width: I, height: R }), this.nodes[1] = new T({ left: this.box.left + I, top: this.box.top, width: I, height: R }), this.nodes[2] = new T({ left: this.box.left + I, top: this.box.top + R, width: I, height: R }), this.nodes[3] = new T({ left: this.box.left, top: this.box.top + R, width: I, height: R });
          }
          getBoxPosition(I) {
            let R = I.plotX < this.box.left + this.box.width / 2, z = I.plotY < this.box.top + this.box.height / 2;
            return R ? z ? 0 : 3 : z ? 1 : 2;
          }
          insert(I, R) {
            let z;
            this.isInternal ? this.nodes[this.getBoxPosition(I)].insert(I, R - 1) : (this.isEmpty = !1, this.body ? R ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, R - 1), this.body = !0), this.nodes[this.getBoxPosition(I)].insert(I, R - 1)) : ((z = new T({ top: I.plotX || NaN, left: I.plotY || NaN, width: 0.1, height: 0.1 })).body = I, z.isInternal = !1, this.nodes.push(z)) : (this.isInternal = !1, this.body = I));
          }
          updateMassAndCenter() {
            let I = 0, R = 0, z = 0;
            if (this.isInternal) {
              for (let O of this.nodes) O.isEmpty || (I += O.mass, R += O.plotX * O.mass, z += O.plotY * O.mass);
              R /= I, z /= I;
            } else this.body && (I = this.body.mass, R = this.body.plotX, z = this.body.plotY);
            this.mass = I, this.plotX = R, this.plotY = z;
          }
        }
        return T;
      }), Z(r, "Series/Networkgraph/QuadTree.js", [r["Series/Networkgraph/QuadTreeNode.js"]], function(T) {
        return class {
          constructor(B, I, R, z) {
            this.box = { left: B, top: I, width: R, height: z }, this.maxDepth = 25, this.root = new T(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
          }
          calculateMassAndCenter() {
            this.visitNodeRecursive(null, null, function(B) {
              B.updateMassAndCenter();
            });
          }
          insertNodes(B) {
            for (let I of B) this.root.insert(I, this.maxDepth);
          }
          visitNodeRecursive(B, I, R) {
            let z;
            if (B || (B = this.root), B === this.root && I && (z = I(B)), z !== !1) {
              for (let O of B.nodes) {
                if (O.isInternal) {
                  if (I && (z = I(O)), z === !1) continue;
                  this.visitNodeRecursive(O, I, R);
                } else O.body && I && I(O.body);
                R && R(O);
              }
              B === this.root && R && R(B);
            }
          }
        };
      }), Z(r, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [r["Series/Networkgraph/EulerIntegration.js"], r["Core/Globals.js"], r["Series/GraphLayoutComposition.js"], r["Series/Networkgraph/QuadTree.js"], r["Core/Utilities.js"], r["Series/Networkgraph/VerletIntegration.js"]], function(T, B, I, R, z, O) {
        let { win: L } = B, { clamp: M, defined: w, isFunction: A, fireEvent: l, pick: u } = z;
        class c {
          constructor() {
            this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
          }
          static compose(s) {
            I.compose(s), I.integrations.euler = T, I.integrations.verlet = O, I.layouts["reingold-fruchterman"] = c;
          }
          init(s) {
            this.options = s, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(!0), this.integration = I.integrations[s.integration], this.enableSimulation = s.enableSimulation, this.attractiveForce = u(s.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = u(s.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = s.approximation;
          }
          updateSimulation(s) {
            this.enableSimulation = u(s, this.options.enableSimulation);
          }
          start() {
            let s = this.series, f = this.options;
            this.currentStep = 0, this.forces = s[0] && s[0].forces || [], this.chart = s[0] && s[0].chart, this.initialRendering && (this.initPositions(), s.forEach(function(y) {
              y.finishedAnimating = !0, y.render();
            })), this.setK(), this.resetSimulation(f), this.enableSimulation && this.step();
          }
          step() {
            let s = this.series;
            for (let f of (this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || [])) this[f + "Forces"](this.temperature);
            if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
              for (let f of s) f.chart && f.render();
              this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && L.cancelAnimationFrame(this.simulation), this.simulation = L.requestAnimationFrame(() => this.step())) : (this.simulation = !1, this.series.forEach((f) => {
                l(f, "afterSimulation");
              }));
            }
          }
          stop() {
            this.simulation && L.cancelAnimationFrame(this.simulation);
          }
          setArea(s, f, y, h) {
            this.box = { left: s, top: f, width: y, height: h };
          }
          setK() {
            this.k = this.options.linkLength || this.integration.getK(this);
          }
          addElementsToCollection(s, f) {
            for (let y of s) f.indexOf(y) === -1 && f.push(y);
          }
          removeElementFromCollection(s, f) {
            let y = f.indexOf(s);
            y !== -1 && f.splice(y, 1);
          }
          clear() {
            this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
          }
          resetSimulation() {
            this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
          }
          restartSimulation() {
            this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
          }
          setMaxIterations(s) {
            this.maxIterations = u(s, this.options.maxIterations);
          }
          setTemperature() {
            this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
          }
          setDiffTemperature() {
            this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
          }
          setInitialRendering(s) {
            this.initialRendering = s;
          }
          createQuadTree() {
            this.quadTree = new R(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
          }
          initPositions() {
            let s = this.options.initialPositions;
            if (A(s)) for (let f of (s.call(this), this.nodes)) w(f.prevX) || (f.prevX = f.plotX), w(f.prevY) || (f.prevY = f.plotY), f.dispX = 0, f.dispY = 0;
            else s === "circle" ? this.setCircularPositions() : this.setRandomPositions();
          }
          setCircularPositions() {
            let s, f = this.box, y = this.nodes, h = 2 * Math.PI / (y.length + 1), a = y.filter(function(p) {
              return p.linksTo.length === 0;
            }), x = {}, S = this.options.initialPositionRadius, E = (p) => {
              for (let C of p.linksFrom || []) x[C.toNode.id] || (x[C.toNode.id] = !0, b.push(C.toNode), E(C.toNode));
            }, b = [];
            for (let p of a) b.push(p), E(p);
            if (b.length) for (let p of y) b.indexOf(p) === -1 && b.push(p);
            else b = y;
            for (let p = 0, C = b.length; p < C; ++p) (s = b[p]).plotX = s.prevX = u(s.plotX, f.width / 2 + S * Math.cos(p * h)), s.plotY = s.prevY = u(s.plotY, f.height / 2 + S * Math.sin(p * h)), s.dispX = 0, s.dispY = 0;
          }
          setRandomPositions() {
            let s, f = this.box, y = this.nodes, h = y.length + 1, a = (x) => {
              let S = x * x / Math.PI;
              return S - Math.floor(S);
            };
            for (let x = 0, S = y.length; x < S; ++x) (s = y[x]).plotX = s.prevX = u(s.plotX, f.width * a(x)), s.plotY = s.prevY = u(s.plotY, f.height * a(h + x)), s.dispX = 0, s.dispY = 0;
          }
          force(s, ...f) {
            this.integration[s].apply(this, f);
          }
          barycenterForces() {
            this.getBarycenter(), this.force("barycenter");
          }
          getBarycenter() {
            let s = 0, f = 0, y = 0;
            for (let h of this.nodes) f += h.plotX * h.mass, y += h.plotY * h.mass, s += h.mass;
            return this.barycenter = { x: f, y, xFactor: f / s, yFactor: y / s }, this.barycenter;
          }
          barnesHutApproximation(s, f) {
            let y, h, a = this.getDistXY(s, f), x = this.vectorLength(a);
            return s !== f && x !== 0 && (f.isInternal ? f.boxSize / x < this.options.theta && x !== 0 ? (h = this.repulsiveForce(x, this.k), this.force("repulsive", s, h * f.mass, a, x), y = !1) : y = !0 : (h = this.repulsiveForce(x, this.k), this.force("repulsive", s, h * f.mass, a, x))), y;
          }
          repulsiveForces() {
            if (this.approximation === "barnes-hut") for (let s of this.nodes) this.quadTree.visitNodeRecursive(null, (f) => this.barnesHutApproximation(s, f));
            else {
              let s, f, y;
              for (let h of this.nodes) for (let a of this.nodes) h === a || h.fixedPosition || (y = this.getDistXY(h, a), (f = this.vectorLength(y)) !== 0 && (s = this.repulsiveForce(f, this.k), this.force("repulsive", h, s * a.mass, y, f)));
            }
          }
          attractiveForces() {
            let s, f, y;
            for (let h of this.links) h.fromNode && h.toNode && (s = this.getDistXY(h.fromNode, h.toNode), (f = this.vectorLength(s)) !== 0 && (y = this.attractiveForce(f, this.k), this.force("attractive", h, y, s, f)));
          }
          applyLimits() {
            for (let s of this.nodes) s.fixedPosition || (this.integration.integrate(this, s), this.applyLimitBox(s, this.box), s.dispX = 0, s.dispY = 0);
          }
          applyLimitBox(s, f) {
            let y = s.radius;
            s.plotX = M(s.plotX, f.left + y, f.width - y), s.plotY = M(s.plotY, f.top + y, f.height - y);
          }
          coolDown(s, f, y) {
            return s - f * y;
          }
          isStable() {
            return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
          }
          getSystemTemperature() {
            let s = 0;
            for (let f of this.nodes) s += f.temperature;
            return s;
          }
          vectorLength(s) {
            return Math.sqrt(s.x * s.x + s.y * s.y);
          }
          getDistR(s, f) {
            let y = this.getDistXY(s, f);
            return this.vectorLength(y);
          }
          getDistXY(s, f) {
            let y = s.plotX - f.plotX, h = s.plotY - f.plotY;
            return { x: y, y: h, absX: Math.abs(y), absY: Math.abs(h) };
          }
        }
        return c;
      }), Z(r, "Series/PackedBubble/PackedBubbleLayout.js", [r["Series/GraphLayoutComposition.js"], r["Series/PackedBubble/PackedBubbleIntegration.js"], r["Series/Networkgraph/ReingoldFruchtermanLayout.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { addEvent: z, pick: O } = R;
        function L() {
          let A = this.series, l = [];
          return A.forEach((u) => {
            u.parentNode && u.parentNode.selected && l.push(u.parentNode);
          }), l;
        }
        function M() {
          this.allDataPoints && delete this.allDataPoints;
        }
        class w extends I {
          constructor() {
            super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
          }
          static compose(l) {
            I.compose(l), T.integrations.packedbubble = B, T.layouts.packedbubble = w;
            let u = l.prototype;
            u.getSelectedParentNodes || (z(l, "beforeRedraw", M), u.getSelectedParentNodes = L);
          }
          beforeStep() {
            this.options.marker && this.series.forEach((l) => {
              l && l.calculateParentRadius();
            });
          }
          isStable() {
            let l = Math.abs(this.prevSystemTemperature - this.systemTemperature);
            return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && l < 1e-5 || this.temperature <= 0;
          }
          setCircularPositions() {
            let l = this.box, u = this.nodes, c = 2 * Math.PI / (u.length + 1), v = this.options.initialPositionRadius, s, f, y = 0;
            for (let h of u) this.options.splitSeries && !h.isParentNode ? (s = h.series.parentNode.plotX, f = h.series.parentNode.plotY) : (s = l.width / 2, f = l.height / 2), h.plotX = h.prevX = O(h.plotX, s + v * Math.cos(h.index || y * c)), h.plotY = h.prevY = O(h.plotY, f + v * Math.sin(h.index || y * c)), h.dispX = 0, h.dispY = 0, y++;
          }
          repulsiveForces() {
            let l, u, c, v = this, s = v.options.bubblePadding, f = v.nodes;
            f.forEach((y) => {
              y.degree = y.mass, y.neighbours = 0, f.forEach((h) => {
                l = 0, y !== h && !y.fixedPosition && (v.options.seriesInteraction || y.series === h.series) && (c = v.getDistXY(y, h), (u = v.vectorLength(c) - (y.marker.radius + h.marker.radius + s)) < 0 && (y.degree += 0.01, y.neighbours++, l = v.repulsiveForce(-u / Math.sqrt(y.neighbours), v.k, y, h)), v.force("repulsive", y, l * h.mass, c, h, u));
              });
            });
          }
          applyLimitBox(l, u) {
            let c, v;
            this.options.splitSeries && !l.isParentNode && this.options.parentNodeLimit && (c = this.getDistXY(l, l.series.parentNode), (v = l.series.parentNodeRadius - l.marker.radius - this.vectorLength(c)) < 0 && v > -2 * l.marker.radius && (l.plotX -= 0.01 * c.x, l.plotY -= 0.01 * c.y)), super.applyLimitBox(l, u);
          }
        }
        return T.layouts.packedbubble = w, w;
      }), Z(r, "Series/SimulationSeriesUtilities.js", [r["Core/Utilities.js"], r["Core/Animation/AnimationUtilities.js"]], function(T, B) {
        let { merge: I, syncTimeout: R } = T, { animObject: z } = B;
        return { initDataLabels: function() {
          let O = this.options.dataLabels;
          if (!this.dataLabelsGroup) {
            let L = this.initDataLabelsGroup();
            return !this.chart.styledMode && (O != null && O.style) && L.css(O.style), L.attr({ opacity: 0 }), this.visible && L.show(), L;
          }
          return this.dataLabelsGroup.attr(I({ opacity: 1 }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
        }, initDataLabelsDefer: function() {
          var L;
          let O = this.options.dataLabels;
          O != null && O.defer && ((L = this.options.layoutAlgorithm) != null && L.enableSimulation) ? R(() => {
            this.deferDataLabels = !1;
          }, O ? z(O.animation).defer : 0) : this.deferDataLabels = !1;
        } };
      }), Z(r, "Extensions/TextPath.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { deg2rad: I } = T, { addEvent: R, merge: z, uniqueKey: O, defined: L, extend: M } = B;
        function w(u, c) {
          c = z(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, c);
          let v = this.renderer.url, s = this.text || this, f = s.textPath, { attributes: y, enabled: h } = c;
          if (u = u || f && f.path, f && f.undo(), u && h) {
            let a = R(s, "afterModifyTree", (x) => {
              if (u && h) {
                let S = u.attr("id");
                S || u.attr("id", S = O());
                let E = { x: 0, y: 0 };
                L(y.dx) && (E.dx = y.dx, delete y.dx), L(y.dy) && (E.dy = y.dy, delete y.dy), s.attr(E), this.attr({ transform: "" }), this.box && (this.box = this.box.destroy());
                let b = x.nodes.slice(0);
                x.nodes.length = 0, x.nodes[0] = { tagName: "textPath", attributes: M(y, { "text-anchor": y.textAnchor, href: `${v}#${S}` }), children: b };
              }
            });
            s.textPath = { path: u, undo: a };
          } else s.attr({ dx: 0, dy: 0 }), delete s.textPath;
          return this.added && (s.textCache = "", this.renderer.buildText(s)), this;
        }
        function A(u) {
          var s;
          let c = u.bBox, v = (s = this.element) == null ? void 0 : s.querySelector("textPath");
          if (v) {
            let f = [], { b: y, h } = this.renderer.fontMetrics(this.element), a = h - y, x = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), S = v.innerHTML.replace(x, "").split(/<tspan class="highcharts-br"[^>]*>/), E = S.length, b = (p, C) => {
              let { x: o, y: t } = C, e = (v.getRotationOfChar(p) - 90) * I, n = Math.cos(e), d = Math.sin(e);
              return [[o - a * n, t - a * d], [o + y * n, t + y * d]];
            };
            for (let p = 0, C = 0; C < E; C++) {
              let o = S[C].length;
              for (let t = 0; t < o; t += 5) try {
                let e = p + t + C, [n, d] = b(e, v.getStartPositionOfChar(e));
                t === 0 ? (f.push(d), f.push(n)) : (C === 0 && f.unshift(d), C === E - 1 && f.push(n));
              } catch {
                break;
              }
              p += o - 1;
              try {
                let t = p + C, e = v.getEndPositionOfChar(t), [n, d] = b(t, e);
                f.unshift(d), f.unshift(n);
              } catch {
                break;
              }
            }
            f.length && f.push(f[0].slice()), c.polygon = f;
          }
          return c;
        }
        function l(u) {
          var f;
          let c = u.labelOptions, v = u.point, s = c[v.formatPrefix + "TextPath"] || c.textPath;
          s && !c.useHTML && (this.setTextPath(((f = v.getDataLabelPath) == null ? void 0 : f.call(v, this)) || v.graphic, s), v.dataLabelPath && !s.enabled && (v.dataLabelPath = v.dataLabelPath.destroy()));
        }
        return { compose: function(u) {
          R(u, "afterGetBBox", A), R(u, "beforeAddingDataLabel", l);
          let c = u.prototype;
          c.setTextPath || (c.setTextPath = w);
        } };
      }), Z(r, "Series/PackedBubble/PackedBubbleSeries.js", [r["Core/Color/Color.js"], r["Series/DragNodesComposition.js"], r["Series/GraphLayoutComposition.js"], r["Core/Globals.js"], r["Series/PackedBubble/PackedBubblePoint.js"], r["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], r["Series/PackedBubble/PackedBubbleLayout.js"], r["Core/Series/SeriesRegistry.js"], r["Series/SimulationSeriesUtilities.js"], r["Core/Utilities.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Extensions/TextPath.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u) {
        let { parse: c } = T, { noop: v } = R, { series: { prototype: s }, seriesTypes: { bubble: f } } = M, { initDataLabels: y, initDataLabelsDefer: h } = w, { addEvent: a, clamp: x, defined: S, extend: E, fireEvent: b, isArray: p, isNumber: C, merge: o, pick: t } = A;
        u.compose(l);
        class e extends f {
          constructor() {
            super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
          }
          static compose(d, i, g) {
            f.compose(d, i, g), B.compose(i), L.compose(i);
          }
          accumulateAllPoints() {
            let d, i = this.chart, g = [];
            for (let m of i.series) if (m.is("packedbubble") && m.reserveSpace()) {
              d = m.yData || [];
              for (let k = 0; k < d.length; k++) g.push([null, null, d[k], m.index, k, { id: k, marker: { radius: 0 } }]);
            }
            return g;
          }
          addLayout() {
            let d = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, i = d.type || "packedbubble", g = this.chart.options.chart, m = this.chart.graphLayoutsStorage, k = this.chart.graphLayoutsLookup, j;
            m || (this.chart.graphLayoutsStorage = m = {}, this.chart.graphLayoutsLookup = k = []), (j = m[i]) || (d.enableSimulation = S(g.forExport) ? !g.forExport : d.enableSimulation, m[i] = j = new I.layouts[i](), j.init(d), k.splice(j.index, 0, j)), this.layout = j, this.points.forEach((P) => {
              P.mass = 2, P.degree = 1, P.collisionNmb = 1;
            }), j.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), j.addElementsToCollection([this], j.series), j.addElementsToCollection(this.points, j.nodes);
          }
          addSeriesLayout() {
            let d = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, i = d.type || "packedbubble", g = this.chart.graphLayoutsStorage, m = this.chart.graphLayoutsLookup, k = o(d, d.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), j = g[i + "-series"];
            j || (g[i + "-series"] = j = new I.layouts[i](), j.init(k), m.splice(j.index, 0, j)), this.parentNodeLayout = j, this.createParentNodes();
          }
          calculateParentRadius() {
            let d = this.seriesBox();
            this.parentNodeRadius = x(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, d ? Math.max(Math.sqrt(Math.pow(d.width, 2) + Math.pow(d.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
          }
          calculateZExtremes() {
            let d = this.chart.series, i = this.options.zMin, g = this.options.zMax, m = 1 / 0, k = -1 / 0;
            return i && g ? [i, g] : (d.forEach((j) => {
              j.yData.forEach((P) => {
                S(P) && (P > k && (k = P), P < m && (m = P));
              });
            }), [i = t(i, m), g = t(g, k)]);
          }
          checkOverlap(d, i) {
            let g = d[0] - i[0], m = d[1] - i[1];
            return Math.sqrt(g * g + m * m) - Math.abs(d[2] + i[2]) < -1e-3;
          }
          createParentNodes() {
            let d = this.pointClass, i = this.chart, g = this.parentNodeLayout, m = this.layout.options, k, j = this.parentNode, P = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: c(this.color).brighten(0.4).get() };
            m.parentNodeOptions && (P = o(m.parentNodeOptions.marker || {}, P)), this.parentNodeMass = 0, this.points.forEach((D) => {
              this.parentNodeMass += Math.PI * Math.pow(D.marker.radius, 2);
            }), this.calculateParentRadius(), g.nodes.forEach((D) => {
              D.seriesIndex === this.index && (k = !0);
            }), g.setArea(0, 0, i.plotWidth, i.plotHeight), k || (j || (j = new d(this, { mass: this.parentNodeRadius / 2, marker: P, dataLabels: { inside: !1 }, states: { normal: { marker: P }, hover: { marker: P } }, dataLabelOnNull: !0, degree: this.parentNodeRadius, isParentNode: !0, seriesIndex: this.index })), this.parentNode && (j.plotX = this.parentNode.plotX, j.plotY = this.parentNode.plotY), this.parentNode = j, g.addElementsToCollection([this], g.series), g.addElementsToCollection([j], g.nodes));
          }
          deferLayout() {
            let d = this.options.layoutAlgorithm;
            this.visible && (this.addLayout(), d.splitSeries && this.addSeriesLayout());
          }
          destroy() {
            this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((d) => {
              d.removeElementFromCollection(this, d.series);
            }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), s.destroy.apply(this, arguments);
          }
          drawDataLabels() {
            !this.deferDataLabels && (s.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", s.drawDataLabels.call(this, [this.parentNode])));
          }
          drawGraph() {
            var k;
            if (!this.layout || !this.layout.options.splitSeries) return;
            let d = this.chart, i = this.layout.options.parentNodeOptions.marker, g = { fill: i.fillColor || c(this.color).brighten(0.4).get(), opacity: i.fillOpacity, stroke: i.lineColor || this.color, "stroke-width": t(i.lineWidth, this.options.lineWidth) }, m = {};
            this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, d.seriesGroup), (k = this.group) == null || k.attr({ zIndex: 2 }), this.calculateParentRadius(), this.parentNode && S(this.parentNode.plotX) && S(this.parentNode.plotY) && S(this.parentNodeRadius) && (m = o({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, g), this.parentNode.graphic || (this.graph = this.parentNode.graphic = d.renderer.symbol(g.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(m));
          }
          drawTracker() {
            let d, i = this.parentNode;
            super.drawTracker(), i && (d = p(i.dataLabels) ? i.dataLabels : i.dataLabel ? [i.dataLabel] : [], i.graphic && (i.graphic.element.point = i), d.forEach((g) => {
              (g.div || g.element).point = i;
            }));
          }
          getPointRadius() {
            let d, i, g, m, k = this.chart, j = k.plotWidth, P = k.plotHeight, D = this.options, H = D.useSimulation, G = Math.min(j, P), V = {}, F = [], U = k.allDataPoints || [], Y = U.length;
            ["minSize", "maxSize"].forEach((N) => {
              let X = parseInt(D[N], 10), W = /%$/.test(D[N]);
              V[N] = W ? G * X / 100 : X * Math.sqrt(Y);
            }), k.minRadius = d = V.minSize / Math.sqrt(Y), k.maxRadius = i = V.maxSize / Math.sqrt(Y);
            let q = H ? this.calculateZExtremes() : [d, i];
            U.forEach((N, X) => {
              g = H ? x(N[2], q[0], q[1]) : N[2], (m = this.getRadius(q[0], q[1], d, i, g)) === 0 && (m = null), U[X][2] = m, F.push(m);
            }), this.radii = F;
          }
          init() {
            return s.init.apply(this, arguments), h.call(this), this.eventsToUnbind.push(a(this, "updatedData", function() {
              this.chart.series.forEach((d) => {
                d.type === this.type && (d.isDirty = !0);
              }, this);
            })), this;
          }
          onMouseUp(d) {
            if (d.fixedPosition && !d.removed) {
              let i, g = this.layout, m = this.parentNodeLayout;
              m && g.options.dragBetweenSeries && m.nodes.forEach((k) => {
                d && d.marker && k !== d.series.parentNode && (i = g.getDistXY(d, k), g.vectorLength(i) - k.marker.radius - d.marker.radius < 0 && (k.series.addPoint(o(d.options, { plotX: d.plotX, plotY: d.plotY }), !1), g.removeElementFromCollection(d, g.nodes), d.remove()));
              }), B.onMouseUp.apply(this, arguments);
            }
          }
          placeBubbles(d) {
            let i = this.checkOverlap, g = this.positionBubble, m = [], k = 1, j = 0, P = 0, D, H = [], G, V = d.sort((F, U) => U[2] - F[2]);
            if (V.length) {
              if (m.push([[0, 0, V[0][2], V[0][3], V[0][4]]]), V.length > 1) for (m.push([[0, 0 - V[1][2] - V[0][2], V[1][2], V[1][3], V[1][4]]]), G = 2; G < V.length; G++) V[G][2] = V[G][2] || 1, i(D = g(m[k][j], m[k - 1][P], V[G]), m[k][0]) ? (m.push([]), P = 0, m[k + 1].push(g(m[k][j], m[k][0], V[G])), k++, j = 0) : k > 1 && m[k - 1][P + 1] && i(D, m[k - 1][P + 1]) ? (P++, m[k].push(g(m[k][j], m[k - 1][P], V[G])), j++) : (j++, m[k].push(D));
              this.chart.stages = m, this.chart.rawPositions = [].concat.apply([], m), this.resizeRadius(), H = this.chart.rawPositions;
            }
            return H;
          }
          pointAttribs(d, i) {
            let g = this.options, m = d && d.isParentNode, k = g.marker;
            m && g.layoutAlgorithm && g.layoutAlgorithm.parentNodeOptions && (k = g.layoutAlgorithm.parentNodeOptions.marker);
            let j = k.fillOpacity, P = s.pointAttribs.call(this, d, i);
            return j !== 1 && (P["fill-opacity"] = j), P;
          }
          positionBubble(d, i, g) {
            let m = Math.asin, k = Math.acos, j = Math.pow, P = Math.abs, D = (0, Math.sqrt)(j(d[0] - i[0], 2) + j(d[1] - i[1], 2)), H = k((j(D, 2) + j(g[2] + i[2], 2) - j(g[2] + d[2], 2)) / (2 * (g[2] + i[2]) * D)), G = m(P(d[0] - i[0]) / D), V = (d[1] - i[1] < 0 ? 0 : Math.PI) + H + G * ((d[0] - i[0]) * (d[1] - i[1]) < 0 ? 1 : -1), F = Math.cos(V), U = Math.sin(V);
            return [i[0] + (i[2] + g[2]) * U, i[1] - (i[2] + g[2]) * F, g[2], g[3], g[4]];
          }
          render() {
            let d = [];
            s.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((i) => {
              p(i.dataLabels) && i.dataLabels.forEach((g) => {
                d.push(g);
              });
            }), this.options.useSimulation && this.chart.hideOverlappingLabels(d));
          }
          resizeRadius() {
            let d, i, g, m, k, j = this.chart, P = j.rawPositions, D = Math.min, H = Math.max, G = j.plotLeft, V = j.plotTop, F = j.plotHeight, U = j.plotWidth;
            for (let X of (d = g = Number.POSITIVE_INFINITY, i = m = Number.NEGATIVE_INFINITY, P)) k = X[2], d = D(d, X[0] - k), i = H(i, X[0] + k), g = D(g, X[1] - k), m = H(m, X[1] + k);
            let Y = [i - d, m - g], q = [(U - G) / Y[0], (F - V) / Y[1]], N = D.apply([], q);
            if (Math.abs(N - 1) > 1e-10) {
              for (let X of P) X[2] *= N;
              this.placeBubbles(P);
            } else j.diffY = F / 2 + V - g - (m - g) / 2, j.diffX = U / 2 + G - d - (i - d) / 2;
          }
          seriesBox() {
            let d, i = this.chart, g = this.data, m = Math.max, k = Math.min, j = [i.plotLeft, i.plotLeft + i.plotWidth, i.plotTop, i.plotTop + i.plotHeight];
            return g.forEach((P) => {
              S(P.plotX) && S(P.plotY) && P.marker.radius && (d = P.marker.radius, j[0] = k(j[0], P.plotX - d), j[1] = m(j[1], P.plotX + d), j[2] = k(j[2], P.plotY - d), j[3] = m(j[3], P.plotY + d));
            }), C(j.width / j.height) ? j : null;
          }
          setVisible() {
            let d = this;
            s.setVisible.apply(d, arguments), d.parentNodeLayout && d.graph ? d.visible ? (d.graph.show(), d.parentNode.dataLabel && d.parentNode.dataLabel.show()) : (d.graph.hide(), d.parentNodeLayout.removeElementFromCollection(d.parentNode, d.parentNodeLayout.nodes), d.parentNode.dataLabel && d.parentNode.dataLabel.hide()) : d.layout && (d.visible ? d.layout.addElementsToCollection(d.points, d.layout.nodes) : d.points.forEach((i) => {
              d.layout.removeElementFromCollection(i, d.layout.nodes);
            }));
          }
          translate() {
            let d, i, g, m = this.chart, k = this.data, j = this.index, P = this.options.useSimulation;
            for (let D of (this.processedXData = this.xData, this.generatePoints(), S(m.allDataPoints) || (m.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), P ? g = m.allDataPoints : (g = this.placeBubbles(m.allDataPoints), this.options.draggable = !1), g)) D[3] === j && (d = k[D[4]], i = t(D[2], void 0), P || (d.plotX = D[0] - m.plotLeft + m.diffX, d.plotY = D[1] - m.plotTop + m.diffY), C(i) && (d.marker = E(d.marker, { radius: i, width: 2 * i, height: 2 * i }), d.radius = i));
            P && this.deferLayout(), b(this, "afterTranslate");
          }
        }
        return e.defaultOptions = o(f.defaultOptions, O), E(e.prototype, { pointClass: z, axisTypes: [], directTouch: !0, forces: ["barycenter", "repulsive"], hasDraggableNodes: !0, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointArrayMap: ["value"], pointValKey: "value", requireSorting: !1, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], initDataLabels: y, alignDataLabel: s.alignDataLabel, indexateNodes: v, onMouseDown: B.onMouseDown, onMouseMove: B.onMouseMove, redrawHalo: B.redrawHalo, searchPoint: v }), M.registerSeriesType("packedbubble", e), e;
      }), Z(r, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
        return { marker: { enabled: !1, states: { hover: { enabled: !1 } } }, stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "" }, trackByArea: !0, legendSymbol: "rectangle" };
      }), Z(r, "Series/Polygon/PolygonSeries.js", [r["Core/Globals.js"], r["Series/Polygon/PolygonSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { noop: z } = T, { area: O, line: L, scatter: M } = I.seriesTypes, { extend: w, merge: A } = R;
        class l extends M {
          getGraphPath() {
            let c = L.prototype.getGraphPath.call(this), v = c.length + 1;
            for (; v--; ) (v === c.length || c[v][0] === "M") && v > 0 && c.splice(v, 0, ["Z"]);
            return this.areaPath = c, c;
          }
          drawGraph() {
            this.options.fillColor = this.color, O.prototype.drawGraph.call(this);
          }
        }
        return l.defaultOptions = A(M.defaultOptions, B), w(l.prototype, { type: "polygon", drawTracker: L.prototype.drawTracker, setStackedPoints: z }), I.registerSeriesType("polygon", l), l;
      }), Z(r, "Core/Axis/RadialAxisDefaults.js", [], function() {
        return { circular: { gridLineWidth: 1, labels: { align: void 0, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: !1, tickLength: 0 }, radial: { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", padding: 5, x: -3, y: -2 }, showLastLabel: !1, title: { x: 4, text: null, rotation: 90 } }, radialGauge: { endOnTick: !1, gridLineWidth: 0, labels: { align: "center", distance: -25, x: 0, y: void 0 }, lineWidth: 1, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickPosition: "inside", tickWidth: 2, title: { rotation: 0, text: "" }, zIndex: 2 } };
      }), Z(r, "Core/Axis/RadialAxis.js", [r["Core/Axis/RadialAxisDefaults.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { defaultOptions: O } = B, { composed: L, noop: M } = I, { addEvent: w, correctFloat: A, defined: l, extend: u, fireEvent: c, isObject: v, merge: s, pick: f, pushUnique: y, relativeLength: h, wrap: a } = R;
        return function(x) {
          function S() {
            this.autoConnect = this.isCircular && f(this.userMax, this.options.max) === void 0 && A(this.endAngleRad - this.startAngleRad) === A(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
          }
          function E() {
            return () => {
              if (this.isRadial && this.tickPositions && this.options.labels && this.options.labels.allowOverlap !== !0) return this.tickPositions.map((X) => this.ticks[X] && this.ticks[X].label).filter((X) => !!X);
            };
          }
          function b() {
            return M;
          }
          function p(X, W, _) {
            let K = this.pane.center, J = X.value, $, et, st;
            return this.isCircular ? (l(J) ? X.point && (X.point.shapeArgs || {}).start && (J = this.chart.inverted ? this.translate(X.point.rectPlotY, !0) : X.point.x) : (et = X.chartX || 0, st = X.chartY || 0, J = this.translate(Math.atan2(st - _, et - W) - this.startAngleRad, !0)), et = ($ = this.getPosition(J)).x, st = $.y) : (l(J) || (et = X.chartX, st = X.chartY), l(et) && l(st) && (_ = K[1] + this.chart.plotTop, J = this.translate(Math.min(Math.sqrt(Math.pow(et - W, 2) + Math.pow(st - _, 2)), K[2] / 2) - K[3] / 2, !0))), [J, et || 0, st || 0];
          }
          function C(X, W, _) {
            let K = this.pane.center, J = this.chart, $ = this.left || 0, et = this.top || 0, st, at = f(W, K[2] / 2 - this.offset), lt;
            return _ === void 0 && (_ = this.horiz ? 0 : this.center && -this.center[3] / 2), _ && (at += _), this.isCircular || W !== void 0 ? ((lt = this.chart.renderer.symbols.arc($ + K[0], et + K[1], at, at, { start: this.startAngleRad, end: this.endAngleRad, open: !0, innerR: 0 })).xBounds = [$ + K[0]], lt.yBounds = [et + K[1] - at]) : (st = this.postTranslate(this.angleRad, at), lt = [["M", this.center[0] + J.plotLeft, this.center[1] + J.plotTop], ["L", st.x, st.y]]), lt;
          }
          function o() {
            this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
          }
          function t(X, W, _) {
            let K = this.chart, J = (yt) => {
              if (typeof yt == "string") {
                let xt = parseInt(yt, 10);
                return Q.test(yt) && (xt = xt * st / 100), xt;
              }
              return yt;
            }, $ = this.center, et = this.startAngleRad, st = $[2] / 2, at = Math.min(this.offset, 0), lt = this.left || 0, it = this.top || 0, Q = /%$/, ot = this.isCircular, nt, ht, ct, dt, ut, pt, gt = f(J(_.outerRadius), st), ft = J(_.innerRadius), mt = f(J(_.thickness), 10);
            if (this.options.gridLineInterpolation === "polygon") pt = this.getPlotLinePath({ value: X }).concat(this.getPlotLinePath({ value: W, reverse: !0 }));
            else {
              X = Math.max(X, this.min), W = Math.min(W, this.max);
              let yt = this.translate(X), xt = this.translate(W);
              ot || (gt = yt || 0, ft = xt || 0), _.shape !== "circle" && ot ? (nt = et + (yt || 0), ht = et + (xt || 0)) : (nt = -Math.PI / 2, ht = 1.5 * Math.PI, ut = !0), gt -= at, mt -= at, pt = K.renderer.symbols.arc(lt + $[0], it + $[1], gt, gt, { start: Math.min(nt, ht), end: Math.max(nt, ht), innerR: f(ft, gt - mt), open: ut, borderRadius: _.borderRadius }), ot && (ct = (ht + nt) / 2, dt = lt + $[0] + $[2] / 2 * Math.cos(ct), pt.xBounds = ct > -Math.PI / 2 && ct < Math.PI / 2 ? [dt, K.plotWidth] : [0, dt], pt.yBounds = [it + $[1] + $[2] / 2 * Math.sin(ct)], pt.yBounds[0] += ct > -Math.PI && ct < 0 || ct > Math.PI ? -10 : 10);
            }
            return pt;
          }
          function e(X) {
            let W = this.pane.center, _ = this.chart, K = _.inverted, J = X.reverse, $ = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, et = $.innerRadius || "0%", st = $.outerRadius || "100%", at = W[0] + _.plotLeft, lt = W[1] + _.plotTop, it = this.height, Q = X.isCrosshair, ot = W[3] / 2, nt = X.value, ht, ct, dt, ut, pt, gt, ft, mt, yt, xt = this.getPosition(nt), bt = xt.x, vt = xt.y;
            if (Q && (nt = (mt = this.getCrosshairPosition(X, at, lt))[0], bt = mt[1], vt = mt[2]), this.isCircular) ct = Math.sqrt(Math.pow(bt - at, 2) + Math.pow(vt - lt, 2)), dt = typeof et == "string" ? h(et, 1) : et / ct, ut = typeof st == "string" ? h(st, 1) : st / ct, W && ot && (dt < (ht = ot / ct) && (dt = ht), ut < ht && (ut = ht)), yt = [["M", at + dt * (bt - at), lt - dt * (lt - vt)], ["L", bt - (1 - ut) * (bt - at), vt + (1 - ut) * (lt - vt)]];
            else if ((nt = this.translate(nt)) && (nt < 0 || nt > it) && (nt = 0), this.options.gridLineInterpolation === "circle") yt = this.getLinePath(0, nt, ot);
            else if (yt = [], _[K ? "yAxis" : "xAxis"].forEach((Ct) => {
              Ct.pane === this.pane && (pt = Ct);
            }), pt) {
              ft = pt.tickPositions, pt.autoConnect && (ft = ft.concat([ft[0]])), J && (ft = ft.slice().reverse()), nt && (nt += ot);
              for (let Ct = 0; Ct < ft.length; Ct++) gt = pt.getPosition(ft[Ct], nt), yt.push(Ct ? ["L", gt.x, gt.y] : ["M", gt.x, gt.y]);
            }
            return yt;
          }
          function n(X, W) {
            let _ = this.translate(X);
            return this.postTranslate(this.isCircular ? _ : this.angleRad, f(this.isCircular ? W : _ < 0 ? 0 : _, this.center[2] / 2) - this.offset);
          }
          function d() {
            let X = this.center, W = this.chart, _ = this.options.title;
            return { x: W.plotLeft + X[0] + (_.x || 0), y: W.plotTop + X[1] - { high: 0.5, middle: 0.25, low: 0 }[_.align] * X[2] + (_.y || 0) };
          }
          function i(X) {
            X.beforeSetTickPositions = S, X.createLabelCollector = E, X.getCrosshairPosition = p, X.getLinePath = C, X.getOffset = o, X.getPlotBandPath = t, X.getPlotLinePath = e, X.getPosition = n, X.getTitlePosition = d, X.postTranslate = V, X.setAxisSize = U, X.setAxisTranslation = Y, X.setOptions = q;
          }
          function g() {
            let X = this.chart, W = this.options, _ = X.angular && this.isXAxis, K = this.pane, J = K && K.options;
            if (!_ && K && (X.angular || X.polar)) {
              let $ = 2 * Math.PI, et = (f(J.startAngle, 0) - 90) * Math.PI / 180, st = (f(J.endAngle, f(J.startAngle, 0) + 360) - 90) * Math.PI / 180;
              this.angleRad = (W.angle || 0) * Math.PI / 180, this.startAngleRad = et, this.endAngleRad = st, this.offset = W.offset || 0;
              let at = (et % $ + $) % $, lt = (st % $ + $) % $;
              at > Math.PI && (at -= $), lt > Math.PI && (lt -= $), this.normalizedStartAngleRad = at, this.normalizedEndAngleRad = lt;
            }
          }
          function m(X) {
            this.isRadial && (X.align = void 0, X.preventDefault());
          }
          function k() {
            if (this.chart && this.chart.labelCollectors) {
              let X = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
              X >= 0 && this.chart.labelCollectors.splice(X, 1);
            }
          }
          function j(X) {
            let W, _ = this.chart, K = _.angular, J = _.polar, $ = this.isXAxis, et = this.coll, st = X.userOptions.pane || 0, at = this.pane = _.pane && _.pane[st];
            if (et === "colorAxis") {
              this.isRadial = !1;
              return;
            }
            K ? (K && $ ? (this.isHidden = !0, this.createLabelCollector = b, this.getOffset = M, this.redraw = F, this.render = F, this.setScale = M, this.setCategories = M, this.setTitle = M) : i(this), W = !$) : J && (i(this), W = this.horiz), K || J ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && _.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, at && W && (at.axis = this), this.isCircular = W;
          }
          function P() {
            this.isRadial && this.beforeSetTickPositions();
          }
          function D(X) {
            let W = this.label;
            if (!W) return;
            let _ = this.axis, K = W.getBBox(), J = _.options.labels, $ = (_.translate(this.pos) + _.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, et = Math.round($), st = l(J.y) ? 0 : -(0.3 * K.height), at = J.y, lt, it = 20, Q = J.align, ot = "end", nt = et < 0 ? et + 360 : et, ht = nt, ct = 0, dt = 0;
            _.isRadial && (lt = _.getPosition(this.pos, _.center[2] / 2 + h(f(J.distance, -25), _.center[2] / 2, -_.center[2] / 2)), J.rotation === "auto" ? W.attr({ rotation: $ }) : l(at) || (at = _.chart.renderer.fontMetrics(W).b - K.height / 2), l(Q) || (_.isCircular ? (K.width > _.len * _.tickInterval / (_.max - _.min) && (it = 0), Q = $ > it && $ < 180 - it ? "left" : $ > 180 + it && $ < 360 - it ? "right" : "center") : Q = "center", W.attr({ align: Q })), Q === "auto" && _.tickPositions.length === 2 && _.isCircular && (nt > 90 && nt < 180 ? nt = 180 - nt : nt > 270 && nt <= 360 && (nt = 540 - nt), ht > 180 && ht <= 360 && (ht = 360 - ht), (_.pane.options.startAngle === et || _.pane.options.startAngle === et + 360 || _.pane.options.startAngle === et - 360) && (ot = "start"), Q = et >= -90 && et <= 90 || et >= -360 && et <= -270 || et >= 270 && et <= 360 ? ot === "start" ? "right" : "left" : ot === "start" ? "left" : "right", ht > 70 && ht < 110 && (Q = "center"), nt < 15 || nt >= 180 && nt < 195 ? ct = 0.3 * K.height : nt >= 15 && nt <= 35 ? ct = ot === "start" ? 0 : 0.75 * K.height : nt >= 195 && nt <= 215 ? ct = ot === "start" ? 0.75 * K.height : 0 : nt > 35 && nt <= 90 ? ct = ot === "start" ? -(0.25 * K.height) : K.height : nt > 215 && nt <= 270 && (ct = ot === "start" ? K.height : -(0.25 * K.height)), ht < 15 ? dt = ot === "start" ? -(0.15 * K.height) : 0.15 * K.height : ht > 165 && ht <= 180 && (dt = ot === "start" ? 0.15 * K.height : -(0.15 * K.height)), W.attr({ align: Q }), W.translate(dt, ct + st)), X.pos.x = lt.x + (J.x || 0), X.pos.y = lt.y + (at || 0));
          }
          function H(X) {
            this.axis.getPosition && u(X.pos, this.axis.getPosition(this.pos));
          }
          function G({ options: X }) {
            X.xAxis && s(!0, x.radialDefaultOptions.circular, X.xAxis), X.yAxis && s(!0, x.radialDefaultOptions.radialGauge, X.yAxis);
          }
          function V(X, W) {
            let _ = this.chart, K = this.center;
            return X = this.startAngleRad + X, { x: _.plotLeft + K[0] + Math.cos(X) * W, y: _.plotTop + K[1] + Math.sin(X) * W };
          }
          function F() {
            this.isDirty = !1;
          }
          function U() {
            let X, W;
            this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), X = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (W = this.postTranslate(this.angleRad, X[3] / 2), X[0] = W.x - this.chart.plotLeft, X[1] = W.y - this.chart.plotTop), this.len = this.width = this.height = (X[2] - X[3]) * f(this.sector, 1) / 2);
          }
          function Y() {
            this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
          }
          function q(X) {
            let { coll: W } = this, { angular: _, inverted: K, polar: J } = this.chart, $ = {};
            _ ? this.isXAxis || ($ = s(O.yAxis, x.radialDefaultOptions.radialGauge)) : J && ($ = this.horiz ? s(O.xAxis, x.radialDefaultOptions.circular) : s(W === "xAxis" ? O.xAxis : O.yAxis, x.radialDefaultOptions.radial)), K && W === "yAxis" && ($.stackLabels = v(O.yAxis, !0) ? O.yAxis.stackLabels : {}, $.reversedStacks = !0);
            let et = this.options = s($, X);
            et.plotBands || (et.plotBands = []), c(this, "afterSetOptions");
          }
          function N(X, W, _, K, J, $, et) {
            let st, at = this.axis;
            return at.isRadial ? ["M", W, _, "L", (st = at.getPosition(this.pos, at.center[2] / 2 + K)).x, st.y] : X.call(this, W, _, K, J, $, et);
          }
          x.radialDefaultOptions = s(T), x.compose = function(X, W) {
            return y(L, "Axis.Radial") && (w(X, "afterInit", g), w(X, "autoLabelAlign", m), w(X, "destroy", k), w(X, "init", j), w(X, "initialAxisTranslation", P), w(W, "afterGetLabelPosition", D), w(W, "afterGetPosition", H), w(I, "setOptions", G), a(W.prototype, "getMarkPath", N)), X;
          };
        }(z || (z = {})), z;
      }), Z(r, "Series/PolarComposition.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Globals.js"], r["Core/Series/Series.js"], r["Extensions/Pane/Pane.js"], r["Core/Axis/RadialAxis.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { animObject: L } = T, { composed: M } = B, { addEvent: w, defined: A, find: l, isNumber: u, merge: c, pick: v, pushUnique: s, relativeLength: f, splat: y, uniqueKey: h, wrap: a } = O;
        function x() {
          (this.pane || []).forEach((G) => {
            G.render();
          });
        }
        function S(G) {
          let V = G.args[0].xAxis, F = G.args[0].yAxis, U = G.args[0].chart;
          V && F && (F.gridLineInterpolation === "polygon" ? (V.startOnTick = !0, V.endOnTick = !0) : V.gridLineInterpolation === "polygon" && U.inverted && (F.startOnTick = !0, F.endOnTick = !0));
        }
        function E() {
          this.pane || (this.pane = []), this.options.pane = y(this.options.pane), this.options.pane.forEach((G) => {
            new R(G, this);
          }, this);
        }
        function b(G) {
          let V = G.args.marker, F = this.chart.xAxis[0], U = this.chart.yAxis[0], Y = this.chart.inverted, q = Y ? U : F, N = Y ? F : U;
          if (this.chart.polar) {
            G.preventDefault();
            let X = (V.attr ? V.attr("start") : V.start) - q.startAngleRad, W = V.attr ? V.attr("r") : V.r, _ = (V.attr ? V.attr("end") : V.end) - q.startAngleRad, K = V.attr ? V.attr("innerR") : V.innerR;
            G.result.x = X + q.pos, G.result.width = _ - X, G.result.y = N.len + N.pos - W, G.result.height = W - K;
          }
        }
        function p(G) {
          let V = this.chart;
          if (V.polar && V.hoverPane && V.hoverPane.axis) {
            G.preventDefault();
            let F = V.hoverPane.center, U = V.mouseDownX || 0, Y = V.mouseDownY || 0, q = G.args.chartY, N = G.args.chartX, X = 2 * Math.PI, W = V.hoverPane.axis.startAngleRad, _ = V.hoverPane.axis.endAngleRad, K = V.inverted ? V.xAxis[0] : V.yAxis[0], J = {}, $ = "arc";
            if (J.x = F[0] + V.plotLeft, J.y = F[1] + V.plotTop, this.zoomHor) {
              let et = W > 0 ? _ - W : Math.abs(W) + Math.abs(_), st = Math.atan2(Y - V.plotTop - F[1], U - V.plotLeft - F[0]) - W, at = Math.atan2(q - V.plotTop - F[1], N - V.plotLeft - F[0]) - W;
              J.r = F[2] / 2, J.innerR = F[3] / 2, st <= 0 && (st += X), at <= 0 && (at += X), at < st && (at = [st, st = at][0]), et < X && W + at > _ + (X - et) / 2 && (at = st, st = W <= 0 ? W : 0);
              let lt = J.start = Math.max(st + W, W), it = J.end = Math.min(at + W, _);
              if (K.options.gridLineInterpolation === "polygon") {
                let Q = V.hoverPane.axis, ot = lt - Q.startAngleRad + Q.pos, nt = K.getPlotLinePath({ value: K.max }), ht = Q.toValue(ot), ct = Q.toValue(ot + (it - lt));
                if (ht < Q.getExtremes().min) {
                  let { min: dt, max: ut } = Q.getExtremes();
                  ht = ut - (dt - ht);
                }
                if (ct < Q.getExtremes().min) {
                  let { min: dt, max: ut } = Q.getExtremes();
                  ct = ut - (dt - ct);
                }
                ct < ht && (ct = [ht, ht = ct][0]), (nt = e(nt, ht, ct, Q)).push(["L", F[0] + V.plotLeft, V.plotTop + F[1]]), J.d = nt, $ = "path";
              }
            }
            if (this.zoomVert) {
              let et = V.inverted ? V.xAxis[0] : V.yAxis[0], st = Math.sqrt(Math.pow(U - V.plotLeft - F[0], 2) + Math.pow(Y - V.plotTop - F[1], 2)), at = Math.sqrt(Math.pow(N - V.plotLeft - F[0], 2) + Math.pow(q - V.plotTop - F[1], 2));
              if (at < st && (st = [at, at = st][0]), at > F[2] / 2 && (at = F[2] / 2), st < F[3] / 2 && (st = F[3] / 2), this.zoomHor || (J.start = W, J.end = _), J.r = at, J.innerR = st, et.options.gridLineInterpolation === "polygon") {
                let lt = et.toValue(et.len + et.pos - st), it = et.toValue(et.len + et.pos - at), Q = et.getPlotLinePath({ value: it }).concat(et.getPlotLinePath({ value: lt, reverse: !0 }));
                J.d = Q, $ = "path";
              }
            }
            if (this.zoomHor && this.zoomVert && K.options.gridLineInterpolation === "polygon") {
              let et = V.hoverPane.axis, st = J.start || 0, at = J.end || 0, lt = st - et.startAngleRad + et.pos, it = et.toValue(lt), Q = et.toValue(lt + (at - st));
              if (J.d instanceof Array) {
                let ot = J.d.slice(0, J.d.length / 2), nt = J.d.slice(J.d.length / 2, J.d.length);
                nt = [...nt].reverse();
                let ht = V.hoverPane.axis;
                ot = e(ot, it, Q, ht), (nt = e(nt, it, Q, ht)) && (nt[0][0] = "L"), nt = [...nt].reverse(), J.d = ot.concat(nt), $ = "path";
              }
            }
            G.attrs = J, G.shapeType = $;
          }
        }
        function C() {
          let G = this.chart;
          G.polar && (this.polar = new H(this), G.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
        }
        function o() {
          if (this.chart.polar && this.xAxis) {
            let { xAxis: G, yAxis: V } = this, F = this.chart;
            this.kdByAngle = F.tooltip && F.tooltip.shared, this.kdByAngle || F.inverted ? this.searchPoint = t : this.options.findNearestPointBy = "xy";
            let U = this.points, Y = U.length;
            for (; Y--; ) this.is("column") || this.is("columnrange") || this.polar.toXY(U[Y]), F.hasParallelCoordinates || this.yAxis.reversed || (v(U[Y].y, Number.MIN_VALUE) < V.min || U[Y].x < G.min || U[Y].x > G.max ? (U[Y].isNull = !0, U[Y].plotY = NaN) : U[Y].isNull = U[Y].isValid && !U[Y].isValid());
            this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(w(this, "afterRender", function() {
              let q;
              F.polar && this.options.clip !== !1 && (q = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: q[0], y: q[1], r: q[2] / 2, innerR: q[3] / 2 }) : this.clipCircle = function(N, X, W, _, K) {
                let J = h(), $ = N.createElement("clipPath").attr({ id: J }).add(N.defs), et = K ? N.arc(X, W, _, K, 0, 2 * Math.PI).add($) : N.circle(X, W, _).add($);
                return et.id = J, et.clipPath = $, et;
              }(F.renderer, q[0], q[1], q[2] / 2, q[3] / 2), this.group.clip(this.clipCircle), this.setClip = B.noop);
            })));
          }
        }
        function t(G) {
          let V = this.chart, F = this.xAxis, U = this.yAxis, Y = F.pane && F.pane.center, q = G.chartX - (Y && Y[0] || 0) - V.plotLeft, N = G.chartY - (Y && Y[1] || 0) - V.plotTop, X = V.inverted ? { clientX: G.chartX - U.pos, plotY: G.chartY - F.pos } : { clientX: 180 + -180 / Math.PI * Math.atan2(q, N) };
          return this.searchKDTree(X);
        }
        function e(G, V, F, U) {
          let Y = U.tickInterval, q = U.tickPositions, N = l(q, (W) => W >= F), X = l([...q].reverse(), (W) => W <= V);
          return A(N) || (N = q[q.length - 1]), A(X) || (X = q[0], N += Y, G[0][0] = "L", G.unshift(G[G.length - 3])), (G = G.slice(q.indexOf(X), q.indexOf(N) + 1))[0][0] = "M", G;
        }
        function n(G, V) {
          return l(this.pane || [], (F) => F.options.id === V) || G.call(this, V);
        }
        function d(G, V, F, U, Y, q) {
          let N, X, W, _ = this.chart, K = v(U.inside, !!this.options.stacking);
          if (_.polar) {
            if (N = V.rectPlotX / Math.PI * 180, _.inverted) this.forceDL = _.isInsidePlot(V.plotX, V.plotY), K && V.shapeArgs ? (X = V.shapeArgs, Y = c(Y, { x: (W = this.yAxis.postTranslate(((X.start || 0) + (X.end || 0)) / 2 - this.xAxis.startAngleRad, V.barX + V.pointWidth / 2)).x - _.plotLeft, y: W.y - _.plotTop })) : V.tooltipPos && (Y = c(Y, { x: V.tooltipPos[0], y: V.tooltipPos[1] })), U.align = v(U.align, "center"), U.verticalAlign = v(U.verticalAlign, "middle");
            else {
              var J;
              let $, et;
              (J = U).align === null && ($ = N > 20 && N < 160 ? "left" : N > 200 && N < 340 ? "right" : "center", J.align = $), J.verticalAlign === null && (et = N < 45 || N > 315 ? "bottom" : N > 135 && N < 225 ? "top" : "middle", J.verticalAlign = et), U = J;
            }
            I.prototype.alignDataLabel.call(this, V, F, U, Y, q), this.isRadialBar && V.shapeArgs && V.shapeArgs.start === V.shapeArgs.end ? F.hide() : F.show();
          } else G.call(this, V, F, U, Y, q);
        }
        function i() {
          let G = this.options, V = G.stacking, F = this.chart, U = this.xAxis, Y = this.yAxis, q = Y.reversed, N = Y.center, X = U.startAngleRad, W = U.endAngleRad - X, _ = G.threshold, K = 0, J, $, et, st, at, lt = 0, it = 0, Q, ot, nt, ht, ct, dt, ut, pt;
          if (U.isRadial) for (et = (J = this.points).length, st = Y.translate(Y.min), at = Y.translate(Y.max), _ = G.threshold || 0, F.inverted && u(_) && A(K = Y.translate(_)) && (K < 0 ? K = 0 : K > W && (K = W), this.translatedThreshold = K + X); et--; ) {
            if (dt = ($ = J[et]).barX, ot = $.x, nt = $.y, $.shapeType = "arc", F.inverted) {
              $.plotY = Y.translate(nt), V && Y.stacking ? (ct = Y.stacking.stacks[(nt < 0 ? "-" : "") + this.stackKey], this.visible && ct && ct[ot] && !$.isNull && (ht = ct[ot].points[this.getStackIndicator(void 0, ot, this.index).key], lt = Y.translate(ht[0]), it = Y.translate(ht[1]), A(lt) && (lt = O.clamp(lt, 0, W)))) : (lt = K, it = $.plotY), lt > it && (it = [lt, lt = it][0]), q ? it > st ? it = st : lt < at ? lt = at : (lt > st || it < at) && (lt = it = W) : lt < st ? lt = st : it > at ? it = at : (it < st || lt > at) && (lt = it = 0), Y.min > Y.max && (lt = it = q ? W : 0), lt += X, it += X, N && ($.barX = dt += N[3] / 2), ut = Math.max(dt, 0), pt = Math.max(dt + $.pointWidth, 0);
              let gt = G.borderRadius, ft = f((typeof gt == "object" ? gt.radius : gt) || 0, pt - ut);
              $.shapeArgs = { x: N[0], y: N[1], r: pt, innerR: ut, start: lt, end: it, borderRadius: ft }, $.opacity = lt === it ? 0 : void 0, $.plotY = (A(this.translatedThreshold) && (lt < this.translatedThreshold ? lt : it)) - X;
            } else lt = dt + X, $.shapeArgs = this.polar.arc($.yBottom, $.plotY, lt, lt + $.pointWidth), $.shapeArgs.borderRadius = 0;
            this.polar.toXY($), F.inverted ? (Q = Y.postTranslate($.rectPlotY, dt + $.pointWidth / 2), $.tooltipPos = [Q.x - F.plotLeft, Q.y - F.plotTop]) : $.tooltipPos = [$.plotX, $.plotY], N && ($.ttBelow = $.plotY > N[1]);
          }
        }
        function g(G, V) {
          let F, U, Y = this;
          if (this.chart.polar) {
            V = V || this.points;
            for (let N = 0; N < V.length; N++) if (!V[N].isNull) {
              F = N;
              break;
            }
            this.options.connectEnds !== !1 && F !== void 0 && (this.connectEnds = !0, V.splice(V.length, 0, V[F]), U = !0), V.forEach((N) => {
              N.polarPlotY === void 0 && Y.polar.toXY(N);
            });
          }
          let q = G.apply(this, [].slice.call(arguments, 1));
          return U && V.pop(), q;
        }
        function m(G, V) {
          let F = this.chart, U = { xAxis: [], yAxis: [] };
          return F.polar ? F.axes.forEach((Y) => {
            if (Y.coll === "colorAxis") return;
            let q = Y.isXAxis, N = Y.center, X = V.chartX - N[0] - F.plotLeft, W = V.chartY - N[1] - F.plotTop;
            U[q ? "xAxis" : "yAxis"].push({ axis: Y, value: Y.translate(q ? Math.PI - Math.atan2(X, W) : Math.sqrt(Math.pow(X, 2) + Math.pow(W, 2)), !0) });
          }) : U = G.call(this, V), U;
        }
        function k(G, V) {
          this.chart.polar || G.call(this, V);
        }
        function j(G, V) {
          let F = this, U = this.chart, Y = this.group, q = this.markerGroup, N = this.xAxis && this.xAxis.center, X = U.plotLeft, W = U.plotTop, _ = this.options.animation, K, J, $, et, st, at;
          U.polar ? F.isRadialBar ? V || (F.startAngleRad = v(F.translatedThreshold, F.xAxis.startAngleRad), B.seriesTypes.pie.prototype.animate.call(F, V)) : (_ = L(_), F.is("column") ? V || (J = N[3] / 2, F.points.forEach((lt) => {
            $ = lt.graphic, st = (et = lt.shapeArgs) && et.r, at = et && et.innerR, $ && et && ($.attr({ r: J, innerR: J }), $.animate({ r: st, innerR: at }, F.options.animation));
          })) : V ? (K = { translateX: N[0] + X, translateY: N[1] + W, scaleX: 1e-3, scaleY: 1e-3 }, Y.attr(K), q && q.attr(K)) : (K = { translateX: X, translateY: W, scaleX: 1, scaleY: 1 }, Y.animate(K, _), q && q.animate(K, _))) : G.call(this, V);
        }
        function P(G, V, F, U) {
          let Y, q;
          if (this.chart.polar)
            if (U) {
              let N = (q = function W(_, K, J, $) {
                let et, st, at, lt, it, Q, ot = $ ? 1 : 0, nt = (et = K >= 0 && K <= _.length - 1 ? K : K < 0 ? _.length - 1 + K : 0) - 1 < 0 ? _.length - (1 + ot) : et - 1, ht = et + 1 > _.length - 1 ? ot : et + 1, ct = _[nt], dt = _[ht], ut = ct.plotX, pt = ct.plotY, gt = dt.plotX, ft = dt.plotY, mt = _[et].plotX, yt = _[et].plotY;
                st = (1.5 * mt + ut) / 2.5, at = (1.5 * yt + pt) / 2.5, lt = (1.5 * mt + gt) / 2.5, it = (1.5 * yt + ft) / 2.5;
                let xt = Math.sqrt(Math.pow(st - mt, 2) + Math.pow(at - yt, 2)), bt = Math.sqrt(Math.pow(lt - mt, 2) + Math.pow(it - yt, 2)), vt = Math.atan2(at - yt, st - mt);
                Q = Math.PI / 2 + (vt + Math.atan2(it - yt, lt - mt)) / 2, Math.abs(vt - Q) > Math.PI / 2 && (Q -= Math.PI), st = mt + Math.cos(Q) * xt, at = yt + Math.sin(Q) * xt;
                let Ct = { rightContX: lt = mt + Math.cos(Math.PI + Q) * bt, rightContY: it = yt + Math.sin(Math.PI + Q) * bt, leftContX: st, leftContY: at, plotX: mt, plotY: yt };
                return J && (Ct.prevPointCont = W(_, nt, !1, $)), Ct;
              }(V, U, !0, this.connectEnds)).prevPointCont && q.prevPointCont.rightContX, X = q.prevPointCont && q.prevPointCont.rightContY;
              Y = ["C", u(N) ? N : q.plotX, u(X) ? X : q.plotY, u(q.leftContX) ? q.leftContX : q.plotX, u(q.leftContY) ? q.leftContY : q.plotY, q.plotX, q.plotY];
            } else Y = ["M", F.plotX, F.plotY];
          else Y = G.call(this, V, F, U);
          return Y;
        }
        function D(G, V, F = this.plotY) {
          if (!this.destroyed) {
            let { plotX: U, series: Y } = this, { chart: q } = Y;
            return q.polar && u(U) && u(F) ? [U + (V ? q.plotLeft : 0), F + (V ? q.plotTop : 0)] : G.call(this, V, F);
          }
        }
        class H {
          static compose(V, F, U, Y, q, N, X, W, _, K) {
            if (R.compose(F, U), z.compose(V, q), s(M, "Polar")) {
              let J = F.prototype, $ = N.prototype, et = U.prototype, st = Y.prototype;
              if (w(F, "afterDrawChartBox", x), w(F, "getAxes", E), w(F, "init", S), a(J, "get", n), a(et, "getCoordinates", m), a(et, "pinch", k), w(U, "getSelectionMarkerAttrs", p), w(U, "getSelectionBox", b), w(Y, "afterInit", C), w(Y, "afterTranslate", o, { order: 2 }), w(Y, "afterColumnTranslate", i, { order: 4 }), a(st, "animate", j), a($, "pos", D), W) {
                let at = W.prototype;
                a(at, "alignDataLabel", d), a(at, "animate", j);
              }
              if (_ && a(_.prototype, "getGraphPath", g), K) {
                let at = K.prototype;
                a(at, "getPointSpline", P), X && (X.prototype.getPointSpline = at.getPointSpline);
              }
            }
          }
          constructor(V) {
            this.series = V;
          }
          arc(V, F, U, Y) {
            let q = this.series, N = q.xAxis.center, X = q.yAxis.len, W = N[3] / 2, _ = X - F + W, K = X - v(V, X) + W;
            return q.yAxis.reversed && (_ < 0 && (_ = W), K < 0 && (K = W)), { x: N[0], y: N[1], r: _, innerR: K, start: U, end: Y };
          }
          toXY(V) {
            let F = this.series, U = F.chart, Y = F.xAxis, q = F.yAxis, N = V.plotX, X = U.inverted, W = V.y, _ = V.plotY, K = X ? N : q.len - _, J;
            if (X && F && !F.isRadialBar && (V.plotY = _ = u(W) ? q.translate(W) : 0), V.rectPlotX = N, V.rectPlotY = _, q.center && (K += q.center[3] / 2), u(_)) {
              let $ = X ? q.postTranslate(_, K) : Y.postTranslate(N, K);
              V.plotX = V.polarPlotX = $.x - U.plotLeft, V.plotY = V.polarPlotY = $.y - U.plotTop;
            }
            F.kdByAngle ? ((J = (N / Math.PI * 180 + Y.pane.options.startAngle) % 360) < 0 && (J += 360), V.clientX = J) : V.clientX = V.plotX;
          }
        }
        return H;
      }), Z(r, "Core/Axis/WaterfallAxis.js", [r["Core/Globals.js"], r["Core/Axis/Stacking/StackItem.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { composed: z } = T, { addEvent: O, objectEach: L, pushUnique: M } = I;
        return function(w) {
          function A() {
            let s = this.waterfall.stacks;
            s && (s.changed = !1, delete s.alreadyChanged);
          }
          function l() {
            let s = this.options.stackLabels;
            s && s.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
          }
          function u() {
            this.waterfall || (this.waterfall = new v(this));
          }
          function c() {
            let s = this.axes;
            for (let f of this.series) if (f.options.stacking) {
              for (let y of s) y.isXAxis || (y.waterfall.stacks.changed = !0);
              break;
            }
          }
          w.compose = function(s, f) {
            M(z, "Axis.Waterfall") && (O(s, "init", u), O(s, "afterBuildStacks", A), O(s, "afterRender", l), O(f, "beforeRedraw", c));
          };
          class v {
            constructor(f) {
              this.axis = f, this.stacks = { changed: !1 };
            }
            renderStackTotals() {
              let f = this.axis, y = f.waterfall.stacks, h = f.stacking && f.stacking.stackTotalGroup, a = new B(f, f.options.stackLabels || {}, !1, 0, void 0);
              this.dummyStackItem = a, h && L(y, (x) => {
                L(x, (S, E) => {
                  a.total = S.stackTotal, a.x = +E, S.label && (a.label = S.label), B.prototype.render.call(a, h), S.label = a.label, delete a.label;
                });
              }), a.total = null;
            }
          }
          w.Composition = v;
        }(R || (R = {})), R;
      }), Z(r, "Series/Waterfall/WaterfallPoint.js", [r["Series/Column/ColumnSeries.js"], r["Core/Series/Point.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { isNumber: R } = I;
        class z extends T.prototype.pointClass {
          getClassName() {
            let L = B.prototype.getClassName.call(this);
            return this.isSum ? L += " highcharts-sum" : this.isIntermediateSum && (L += " highcharts-intermediate-sum"), L;
          }
          isValid() {
            return R(this.y) || this.isSum || !!this.isIntermediateSum;
          }
        }
        return z;
      }), Z(r, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
        return { dataLabels: { inside: !0 }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } };
      }), Z(r, "Series/Waterfall/WaterfallSeries.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"], r["Core/Axis/WaterfallAxis.js"], r["Series/Waterfall/WaterfallPoint.js"], r["Series/Waterfall/WaterfallSeriesDefaults.js"]], function(T, B, I, R, z) {
        let { column: O, line: L } = T.seriesTypes, { addEvent: M, arrayMax: w, arrayMin: A, correctFloat: l, crisp: u, extend: c, isNumber: v, merge: s, objectEach: f, pick: y } = B;
        function h(x, S) {
          return Object.hasOwnProperty.call(x, S);
        }
        class a extends O {
          generatePoints() {
            O.prototype.generatePoints.apply(this);
            for (let S = 0, E = this.points.length; S < E; S++) {
              let b = this.points[S], p = this.processedYData[S];
              v(p) && (b.isIntermediateSum || b.isSum) && (b.y = l(p));
            }
          }
          processData(S) {
            let E, b, p, C, o, t, e = this.options, n = this.yData, d = e.data, i = n.length, g = e.threshold || 0;
            p = b = C = o = 0;
            for (let m = 0; m < i; m++) t = n[m], E = d && d[m] ? d[m] : {}, t === "sum" || E.isSum ? n[m] = l(p) : t === "intermediateSum" || E.isIntermediateSum ? (n[m] = l(b), b = 0) : (p += t, b += t), C = Math.min(p, C), o = Math.max(p, o);
            super.processData.call(this, S), e.stacking || (this.dataMin = C + g, this.dataMax = o);
          }
          toYData(S) {
            return S.isSum ? "sum" : S.isIntermediateSum ? "intermediateSum" : S.y;
          }
          updateParallelArrays(S, E) {
            super.updateParallelArrays.call(this, S, E), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
          }
          pointAttribs(S, E) {
            let b = this.options.upColor;
            b && !S.options.color && v(S.y) && (S.color = S.y > 0 ? b : void 0);
            let p = O.prototype.pointAttribs.call(this, S, E);
            return delete p.dashstyle, p;
          }
          getGraphPath() {
            return [["M", 0, 0]];
          }
          getCrispPath() {
            var n;
            let S = this.data.filter((d) => v(d.y)), E = this.yAxis, b = S.length, p = ((n = this.graph) == null ? void 0 : n.strokeWidth()) || 0, C = this.xAxis.reversed, o = this.yAxis.reversed, t = this.options.stacking, e = [];
            for (let d = 1; d < b; d++) {
              if (!(this.options.connectNulls || v(this.data[S[d].index - 1].y))) continue;
              let i = S[d].box, g = S[d - 1], m = g.y || 0, k = S[d - 1].box;
              if (!i || !k) continue;
              let j = E.waterfall.stacks[this.stackKey], P = m > 0 ? -k.height : 0;
              if (j && k && i) {
                let D, H = j[d - 1];
                if (t) {
                  let G = H.connectorThreshold;
                  D = u(E.translate(G, !1, !0, !1, !0) + (o ? P : 0), p);
                } else D = u(k.y + (g.minPointLengthOffset || 0), p);
                e.push(["M", (k.x || 0) + (C ? 0 : k.width || 0), D], ["L", (i.x || 0) + (C && i.width || 0), D]);
              }
              if (k && e.length && (!t && m < 0 && !o || m > 0 && o)) {
                let D = e[e.length - 2];
                D && typeof D[2] == "number" && (D[2] += k.height || 0);
                let H = e[e.length - 1];
                H && typeof H[2] == "number" && (H[2] += k.height || 0);
              }
            }
            return e;
          }
          drawGraph() {
            L.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
          }
          setStackedPoints(S) {
            var Y;
            let E = this.options, b = (Y = S.waterfall) == null ? void 0 : Y.stacks, p = E.threshold || 0, C = this.stackKey, o = this.xData, t = o.length, e = p, n = e, d, i = 0, g = 0, m = 0, k, j, P, D, H, G, V, F, U = (q, N, X, W) => {
              if (d) {
                if (k) for (; X < k; X++) d.stackState[X] += W;
                else d.stackState[0] = q, k = d.stackState.length;
                d.stackState.push(d.stackState[k - 1] + N);
              }
            };
            if (S.stacking && b && this.reserveSpace()) {
              F = b.changed, (V = b.alreadyChanged) && 0 > V.indexOf(C) && (F = !0), b[C] || (b[C] = {});
              let q = b[C];
              if (q) for (let N = 0; N < t; N++) (!q[G = o[N]] || F) && (q[G] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: F && q[G] ? q[G].label : void 0 }), d = q[G], (H = this.yData[N]) >= 0 ? d.posTotal += H : d.negTotal += H, D = E.data[N], j = d.absolutePos = d.posTotal, P = d.absoluteNeg = d.negTotal, d.stackTotal = j + P, k = d.stackState.length, D && D.isIntermediateSum ? (U(m, g, 0, m), m = g, g = p, e ^= n, n ^= e, e ^= n) : D && D.isSum ? (U(p, i, k, 0), e = p) : (U(e, H, 0, i), D && (i += H, g += H)), d.stateIndex++, d.threshold = e, e += d.stackTotal;
              b.changed = !1, b.alreadyChanged || (b.alreadyChanged = []), b.alreadyChanged.push(C);
            }
          }
          getExtremes() {
            let S, E, b, p = this.options.stacking;
            return p ? (S = this.yAxis.waterfall.stacks, E = this.stackedYNeg = [], b = this.stackedYPos = [], p === "overlap" ? f(S[this.stackKey], function(C) {
              E.push(A(C.stackState)), b.push(w(C.stackState));
            }) : f(S[this.stackKey], function(C) {
              E.push(C.negTotal + C.threshold), b.push(C.posTotal + C.threshold);
            }), { dataMin: A(E), dataMax: w(b) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
          }
        }
        return a.defaultOptions = s(O.defaultOptions, z), a.compose = I.compose, c(a.prototype, { pointValKey: "y", showLine: !0, pointClass: R }), M(a, "afterColumnTranslate", function() {
          let { options: x, points: S, yAxis: E } = this, b = y(x.minPointLength, 5), p = b / 2, C = x.threshold || 0, o = x.stacking, t = E.waterfall.stacks[this.stackKey], e = C, n = C, d, i, g, m;
          for (let k = 0; k < S.length; k++) {
            let j = S[k], P = this.processedYData[k], D = c({ x: 0, y: 0, width: 0, height: 0 }, j.shapeArgs || {});
            j.box = D;
            let H = [0, P], G = j.y || 0;
            if (o) {
              if (t) {
                let U = t[k];
                o === "overlap" ? (i = U.stackState[U.stateIndex--], d = G >= 0 ? i : i - G, h(U, "absolutePos") && delete U.absolutePos, h(U, "absoluteNeg") && delete U.absoluteNeg) : (G >= 0 ? (i = U.threshold + U.posTotal, U.posTotal -= G, d = i) : (i = U.threshold + U.negTotal, U.negTotal -= G, d = i - G), !U.posTotal && v(U.absolutePos) && h(U, "absolutePos") && (U.posTotal = U.absolutePos, delete U.absolutePos), !U.negTotal && v(U.absoluteNeg) && h(U, "absoluteNeg") && (U.negTotal = U.absoluteNeg, delete U.absoluteNeg)), j.isSum || (U.connectorThreshold = U.threshold + U.stackTotal), E.reversed ? (g = G >= 0 ? d - G : d + G, m = d) : (g = d, m = d - G), j.below = g <= C, D.y = E.translate(g, !1, !0, !1, !0), D.height = Math.abs(D.y - E.translate(m, !1, !0, !1, !0));
                let Y = E.waterfall.dummyStackItem;
                Y && (Y.x = k, Y.label = t[k].label, Y.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[k], this.stackedYPos[k], void 0, this.xAxis));
              }
            } else d = Math.max(n, n + G) + H[0], D.y = E.translate(d, !1, !0, !1, !0), j.isSum ? (D.y = E.translate(H[1], !1, !0, !1, !0), D.height = Math.min(E.translate(H[0], !1, !0, !1, !0), E.len) - D.y, j.below = H[1] <= C) : j.isIntermediateSum ? (G >= 0 ? (g = H[1] + e, m = e) : (g = e, m = H[1] + e), E.reversed && (g ^= m, m ^= g, g ^= m), D.y = E.translate(g, !1, !0, !1, !0), D.height = Math.abs(D.y - Math.min(E.translate(m, !1, !0, !1, !0), E.len)), e += H[1], j.below = g <= C) : (D.height = P > 0 ? E.translate(n, !1, !0, !1, !0) - D.y : E.translate(n, !1, !0, !1, !0) - E.translate(n - P, !1, !0, !1, !0), n += P, j.below = n < C), D.height < 0 && (D.y += D.height, D.height *= -1);
            j.plotY = D.y, j.yBottom = D.y + D.height, D.height <= b && !j.isNull ? (D.height = b, D.y -= p, j.yBottom = D.y + D.height, j.plotY = D.y, G < 0 ? j.minPointLengthOffset = -p : j.minPointLengthOffset = p) : (j.isNull && (D.width = 0), j.minPointLengthOffset = 0);
            let V = j.plotY + (j.negative ? D.height : 0);
            j.below && (j.plotY += D.height), j.tooltipPos && (this.chart.inverted ? j.tooltipPos[0] = E.len - V : j.tooltipPos[1] = V), j.isInside = this.isPointInside(j);
            let F = u(j.yBottom, this.borderWidth);
            D.y = u(D.y, this.borderWidth), D.height = F - D.y, s(!0, j.shapeArgs, D);
          }
        }, { order: 2 }), T.registerSeriesType("waterfall", a), a;
      }), Z(r, "masters/highcharts-more.src.js", [r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Extensions/Pane/Pane.js"], r["Series/Bubble/BubbleSeries.js"], r["Series/PackedBubble/PackedBubbleSeries.js"], r["Series/PolarComposition.js"], r["Core/Axis/RadialAxis.js"], r["Series/Waterfall/WaterfallSeries.js"]], function(T, B, I, R, z, O, L, M) {
        return T.RadialAxis = L, R.compose(T.Axis, T.Chart, T.Legend), z.compose(T.Axis, T.Chart, T.Legend), I.compose(T.Chart, T.Pointer), O.compose(T.Axis, T.Chart, T.Pointer, T.Series, T.Tick, T.Point, B.seriesTypes.areasplinerange, B.seriesTypes.column, B.seriesTypes.line, B.seriesTypes.spline), M.compose(T.Axis, T.Chart), T;
      });
    });
  }(ve)), ve.exports;
}
var rl = ol();
const nl = /* @__PURE__ */ It(rl);
var Ce = { exports: {} }, Rs;
function al() {
  return Rs || (Rs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Data module
    *
    * (c) 2012-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Core/HttpUtilities.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { win: I } = T, { discardElement: R, objectEach: z } = B, O = { ajax: function(L) {
          let M = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, w = new XMLHttpRequest();
          function A(l, u) {
            L.error && L.error(l, u);
          }
          if (!L.url) return !1;
          w.open((L.type || "get").toUpperCase(), L.url, !0), L.headers && L.headers["Content-Type"] || w.setRequestHeader("Content-Type", M[L.dataType || "json"] || M.text), z(L.headers, function(l, u) {
            w.setRequestHeader(u, l);
          }), L.responseType && (w.responseType = L.responseType), w.onreadystatechange = function() {
            let l;
            if (w.readyState === 4) {
              if (w.status === 200) {
                if (L.responseType !== "blob" && (l = w.responseText, L.dataType === "json")) try {
                  l = JSON.parse(l);
                } catch (u) {
                  if (u instanceof Error) return A(w, u);
                }
                return L.success && L.success(l, w);
              }
              A(w, w.responseText);
            }
          }, L.data && typeof L.data != "string" && (L.data = JSON.stringify(L.data)), w.send(L.data);
        }, getJSON: function(L, M) {
          O.ajax({ url: L, success: M, dataType: "json", headers: { "Content-Type": "text/plain" } });
        }, post: function(L, M, w) {
          let A = new I.FormData();
          z(M, function(c, v) {
            A.append(v, c);
          }), A.append("b64", "true");
          let { filename: l, type: u } = M;
          return I.fetch(L, { method: "POST", body: A, ...w }).then((c) => {
            c.ok && c.text().then((v) => {
              let s = document.createElement("a");
              s.href = `data:${u};base64,${v}`, s.download = l, s.click(), R(s);
            });
          });
        } };
        return O;
      }), Z(r, "Extensions/Data.js", [r["Core/Axis/Axis.js"], r["Core/Chart/Chart.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/HttpUtilities.js"], r["Core/Series/Point.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { getOptions: w } = I, { doc: A } = R, { ajax: l } = z, { seriesTypes: u } = L, { addEvent: c, defined: v, extend: s, fireEvent: f, isNumber: y, merge: h, objectEach: a, pick: x, splat: S } = M;
        function E(C) {
          return !!(C && (C.rowsURL || C.csvURL || C.columnsURL));
        }
        class b {
          static data(o, t = {}, e) {
            return new b(o, t, e);
          }
          static rowsToColumns(o) {
            let t, e, n, d, i;
            if (o) for (t = 0, i = [], e = o.length; t < e; t++) for (n = 0, d = o[t].length; n < d; n++) i[n] || (i[n] = []), i[n][t] = o[t][n];
            return i;
          }
          constructor(o, t = {}, e) {
            this.rowsToColumns = b.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(n) {
              return n ? Date.UTC(+n[1], +n[2] - 1, +n[3]) : NaN;
            } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n) {
              return n ? Date.UTC(+n[3], +n[2] - 1, +n[1]) : NaN;
            }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n) {
              return n ? Date.UTC(+n[3], +n[1] - 1, +n[2]) : NaN;
            } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n) {
              if (!n) return NaN;
              let d = /* @__PURE__ */ new Date(), i = +n[3];
              return i > d.getFullYear() - 2e3 ? i += 1900 : i += 2e3, Date.UTC(i, +n[2] - 1, +n[1]);
            }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n) {
              return n ? Date.UTC(+n[3] + 2e3, +n[1] - 1, +n[2]) : NaN;
            } } }, this.chart = e, this.chartOptions = t, this.options = o, this.rawColumns = [], this.init(o, t, e);
          }
          init(o, t, e) {
            let n = o.decimalPoint, d;
            t && (this.chartOptions = t), e && (this.chart = e), n !== "." && n !== "," && (n = void 0), this.options = o, this.columns = o.columns || this.rowsToColumns(o.rows) || [], this.firstRowAsNames = x(o.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = n && RegExp("^(-?[0-9]+)" + n + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), d = !E(o)), d || (d = this.fetchLiveData()), d || (d = !!this.parseCSV().length), d || (d = !!this.parseTable().length), d || (d = this.parseGoogleSpreadsheet()), !d && o.afterComplete && o.afterComplete(this);
          }
          getColumnDistribution() {
            var D, H;
            let o = this.chartOptions, t = this.options, e = [], n = function(G = "line") {
              return (u[G].prototype.pointArrayMap || [0]).length;
            }, d = function(G = "line") {
              return u[G].prototype.pointArrayMap;
            }, i = (D = o == null ? void 0 : o.chart) == null ? void 0 : D.type, g = [], m = [], k = (t == null ? void 0 : t.seriesMapping) || ((H = o == null ? void 0 : o.series) == null ? void 0 : H.map(function() {
              return { x: 0 };
            })) || [], j = 0;
            ((o == null ? void 0 : o.series) || []).forEach((G) => {
              g.push(n(G.type || i));
            }), k.forEach((G) => {
              e.push(G.x || 0);
            }), e.length === 0 && e.push(0), k.forEach((G) => {
              let V = new p(), F = g[j] || n(i), U = ((o == null ? void 0 : o.series) ?? [])[j] ?? {}, Y = d(U.type || i), q = Y ?? ["y"];
              (v(G.x) || U.isCartesian || !Y) && V.addColumnReader(G.x, "x"), a(G, function(N, X) {
                X !== "x" && V.addColumnReader(N, X);
              });
              for (let N = 0; N < F; N++) V.hasReader(q[N]) || V.addColumnReader(void 0, q[N]);
              m.push(V), j++;
            });
            let P = d(i);
            P === void 0 && (P = ["y"]), this.valueCount = { global: n(i), xColumns: e, individual: g, seriesBuilders: m, globalPointArrayMap: P };
          }
          dataFound() {
            this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
          }
          parseCSV(o) {
            let t = this, e = this.columns = [], n = o || this.options, d = n.startColumn || 0, i = n.endColumn || Number.MAX_VALUE, g = [], m = { ",": 0, ";": 0, "	": 0 }, k = n.csv, j = n.startRow || 0, P = n.endRow || Number.MAX_VALUE, D, H, G = 0;
            if (k && n.beforeParse && (k = n.beforeParse.call(this, k)), k) {
              if (H = k.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(n.lineDelimiter || `
`), (!j || j < 0) && (j = 0), (!P || P >= H.length) && (P = H.length - 1), n.itemDelimiter) D = n.itemDelimiter;
              else {
                let F, U, Y;
                F = 0, U = 0, Y = !1, H.some(function(q, N) {
                  let X = !1, W, _, K, J = "";
                  if (N > 13) return !0;
                  for (let $ = 0; $ < q.length; $++) {
                    if (W = q[$], _ = q[$ + 1], K = q[$ - 1], W === "#") return;
                    if (W === '"')
                      if (X) {
                        if (K !== '"' && _ !== '"') {
                          for (; _ === " " && $ < q.length; ) _ = q[++$];
                          m[_] !== void 0 && m[_]++, X = !1;
                        }
                      } else X = !0;
                    else m[W] !== void 0 ? (isNaN(Date.parse(J = J.trim())) ? (isNaN(J) || !isFinite(J)) && m[W]++ : m[W]++, J = "") : J += W;
                    W === "," && U++, W === "." && F++;
                  }
                }), m[";"] > m[","] ? Y = ";" : (m[","], m[";"], Y = ","), n.decimalPoint || (F > U ? n.decimalPoint = "." : n.decimalPoint = ",", t.decimalRegex = RegExp("^(-?[0-9]+)" + n.decimalPoint + "([0-9]+)$")), D = Y;
              }
              let V = 0;
              for (G = j; G <= P; G++) H[G][0] === "#" ? V++ : function(F, U, Y, q) {
                let N = 0, X = "", W = "", _ = "", K = "", J = 0, $ = 0;
                function et(lt) {
                  X = F[lt], W = F[lt - 1], _ = F[lt + 1];
                }
                function st(lt) {
                  g.length < $ + 1 && g.push([lt]), g[$][g[$].length - 1] !== lt && g[$].push(lt);
                }
                function at() {
                  if (d > J || J > i) {
                    ++J, K = "";
                    return;
                  }
                  n.columnTypes || (!isNaN(parseFloat(K)) && isFinite(K) ? (K = parseFloat(K), st("number")) : isNaN(Date.parse(K)) ? st("string") : (K = K.replace(/\//g, "-"), st("date"))), e.length < $ + 1 && e.push([]), e[$][U] = K, K = "", ++$, ++J;
                }
                if (F.trim().length && F.trim()[0] !== "#") {
                  for (; N < F.length; N++) if (et(N), X === '"') for (et(++N); N < F.length && (X !== '"' || W === '"' || _ === '"'); ) (X !== '"' || X === '"' && W !== '"') && (K += X), et(++N);
                  else X === D ? at() : K += X;
                  at();
                }
              }(H[G], G - j - V);
              (!n.columnTypes || n.columnTypes.length === 0) && g.length && g[0].length && g[0][1] === "date" && !n.dateFormat && (n.dateFormat = function(F, U) {
                var et;
                let Y = "YYYY/mm/dd", q = [], N = [], X, W = [], _, K = 0, J = !1, $;
                for ((!U || U > F.length) && (U = F.length); K < U; K++) if (F[K] !== void 0 && ((et = F[K]) != null && et.length)) for ($ = 0, X = F[K].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), W = ["", "", ""]; $ < X.length; $++) $ < W.length && (X[$] = parseInt(X[$], 10), X[$] && (N[$] = !N[$] || N[$] < X[$] ? X[$] : N[$], q[$] !== void 0 ? q[$] !== X[$] && (q[$] = !1) : q[$] = X[$], X[$] > 31 ? X[$] < 100 ? W[$] = "YY" : W[$] = "YYYY" : X[$] > 12 && X[$] <= 31 ? (W[$] = "dd", J = !0) : W[$].length || (W[$] = "mm")));
                if (J) {
                  for ($ = 0; $ < q.length; $++) q[$] !== !1 ? N[$] > 12 && W[$] !== "YY" && W[$] !== "YYYY" && (W[$] = "YY") : N[$] > 12 && W[$] === "mm" && (W[$] = "dd");
                  return W.length === 3 && W[1] === "dd" && W[2] === "dd" && (W[2] = "YY"), _ = W.join("/"), (n.dateFormats || t.dateFormats)[_] ? _ : (f(t, "deduceDateFailed"), Y);
                }
                return Y;
              }(e[0])), this.dataFound();
            }
            return e;
          }
          parseTable() {
            let o = this.options, t = this.columns || [], e = o.startRow || 0, n = o.endRow || Number.MAX_VALUE, d = o.startColumn || 0, i = o.endColumn || Number.MAX_VALUE;
            if (o.table) {
              let g = o.table;
              typeof g == "string" && (g = A.getElementById(g)), [].forEach.call(g.getElementsByTagName("tr"), (m, k) => {
                k >= e && k <= n && [].forEach.call(m.children, (j, P) => {
                  let D = t[P - d], H = 1;
                  if ((j.tagName === "TD" || j.tagName === "TH") && P >= d && P <= i) for (t[P - d] || (t[P - d] = []), t[P - d][k - e] = j.innerHTML; k - e >= H && D[k - e - H] === void 0; ) D[k - e - H] = null, H++;
                });
              }), this.dataFound();
            }
            return t;
          }
          fetchLiveData() {
            let o = this, t = this.chart, e = this.options, n = e.enablePolling, d = h(e), i = 0, g = 1e3 * (e.dataRefreshRate || 2);
            return !!E(e) && (g < 1e3 && (g = 1e3), delete e.csvURL, delete e.rowsURL, delete e.columnsURL, function m(k) {
              function j(P, D, H) {
                if (!P || !/^(http|\/|\.\/|\.\.\/)/.test(P)) return P && e.error && e.error("Invalid URL"), !1;
                function G() {
                  n && t.liveDataURL === P && (o.liveDataTimeout = setTimeout(m, g));
                }
                return k && (clearTimeout(o.liveDataTimeout), t.liveDataURL = P), l({ url: P, dataType: H || "json", success: function(V) {
                  t != null && t.series && D(V), G();
                }, error: function(V, F) {
                  var U;
                  return ++i < 3 && G(), (U = e.error) == null ? void 0 : U.call(e, F, V);
                } }), !0;
              }
              j(d.csvURL, function(P) {
                t.update({ data: { csv: P } });
              }, "text") || j(d.rowsURL, function(P) {
                t.update({ data: { rows: P } });
              }) || j(d.columnsURL, function(P) {
                t.update({ data: { columns: P } });
              });
            }(!0), E(e));
          }
          parseGoogleSpreadsheet() {
            let o = this, t = this.options, e = t.googleSpreadsheetKey, n = this.chart, d = Math.max(1e3 * (t.dataRefreshRate || 2), 4e3), i = () => {
              if (t.googleSpreadsheetRange) return t.googleSpreadsheetRange;
              let g = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", m = (g.charAt(t.startColumn || 0) || "A") + ((t.startRow || 0) + 1), k = g.charAt(x(t.endColumn, -1)) || "ZZ";
              return v(t.endRow) && (k += t.endRow + 1), `${m}:${k}`;
            };
            return e && (delete t.googleSpreadsheetKey, function g(m) {
              l({ url: ["https://sheets.googleapis.com/v4/spreadsheets", e, "values", i(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + t.googleAPIKey].join("/"), dataType: "json", success: function(k) {
                m(k), t.enablePolling && (o.liveDataTimeout = setTimeout(function() {
                  g(m);
                }, d));
              }, error: function(k, j) {
                var P;
                return (P = t.error) == null ? void 0 : P.call(t, j, k);
              } });
            }(function(g) {
              let m = g.values;
              if (!m || m.length === 0) return !1;
              let k = m.reduce((j, P) => Math.max(j, P.length), 0);
              m.forEach((j) => {
                for (let P = 0; P < k; P++) j[P] === void 0 && (j[P] = null);
              }), n != null && n.series ? n.update({ data: { columns: m } }) : (o.columns = m, o.dataFound());
            })), !1;
          }
          trim(o, t) {
            return typeof o == "string" && (o = o.replace(/^\s+|\s+$/g, ""), t && /[\d\s]+/.test(o) && (o = o.replace(/\s/g, "")), this.decimalRegex && (o = o.replace(this.decimalRegex, "$1.$2"))), o;
          }
          parseTypes() {
            let o = this.columns || [], t = o.length;
            for (; t--; ) this.parseColumn(o[t], t);
          }
          parseColumn(o, t) {
            var N;
            let e = this.rawColumns, n = this.columns = this.columns || [], d = this.firstRowAsNames, i = ((N = this.valueCount) == null ? void 0 : N.xColumns.indexOf(t)) !== -1, g = [], m = this.chartOptions, k = (this.options.columnTypes || [])[t], j = i && (m == null ? void 0 : m.xAxis) && S(m.xAxis)[0].type === "category" || k === "string", P = v(o.name), D = o.length, H, G, V, F, U, Y, q;
            for (e[t] || (e[t] = []); D--; ) H = g[D] || o[D], V = this.trim(H), G = parseFloat(F = this.trim(H, !0)), e[t][D] === void 0 && (e[t][D] = V), j || D === 0 && d && !P ? o[D] = "" + V : +F === G ? (o[D] = G, G > 31536e6 && k !== "float" ? o.isDatetime = !0 : o.isNumeric = !0, o[D + 1] !== void 0 && (q = G > o[D + 1])) : (V != null && V.length && (U = this.parseDate(H)), i && y(U) && k !== "float" ? (g[D] = H, o[D] = U, o.isDatetime = !0, o[D + 1] !== void 0 && ((Y = U > o[D + 1]) !== q && q !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, D = o.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : o.unsorted = !0), q = Y)) : (o[D] = V === "" ? null : V, D !== 0 && (o.isDatetime || o.isNumeric) && (o.mixed = !0)));
            if (i && o.mixed && (n[t] = e[t]), i && q && this.options.sort) {
              for (t = 0; t < n.length; t++) if (n[t].reverse(), d) {
                let X = n[t].pop();
                X && n[t].unshift(X);
              }
            }
          }
          parseDate(o) {
            let t = this.options.parseDate, e, n, d, i = this.options.dateFormat || this.dateFormat, g;
            if (t) e = t(o);
            else if (typeof o == "string") {
              if (i) (d = this.dateFormats[i]) || (d = this.dateFormats["YYYY/mm/dd"]), (g = o.match(d.regex)) && (e = d.parser(g));
              else for (n in this.dateFormats) if (d = this.dateFormats[n], g = o.match(d.regex)) {
                this.dateFormat = i = n, this.alternativeFormat = d.alternative, e = d.parser(g);
                break;
              }
              !g && (o.match(/:.+(GMT|UTC|[Z+\-])/) && (o = o.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (g = Date.parse(o)) == "object" && g !== null && g.getTime ? e = g.getTime() - 6e4 * g.getTimezoneOffset() : y(g) && (e = g - 6e4 * new Date(g).getTimezoneOffset()));
            }
            return e;
          }
          getData() {
            var o;
            if (this.columns) return (o = this.rowsToColumns(this.columns)) == null ? void 0 : o.slice(1);
          }
          parsed() {
            if (this.options.parsed) return this.options.parsed.call(this, this.columns);
          }
          complete() {
            var F, U, Y, q;
            let o = this.columns = this.columns || [], t = this.options, e = [], n = "linear", d, i, g, m, k, j, P, D, H, G, V;
            if (o.length, t.complete || t.afterComplete) {
              if (this.firstRowAsNames) for (g = 0; g < o.length; g++) {
                let N = o[g];
                v(N.name) || (N.name = x(N.shift(), "").toString());
              }
              for (j = 0, d = [], H = function(N, X) {
                let W, _, K, J = [], $ = [];
                for (_ = 0; _ < N; _ += 1) J.push(!0);
                for (W = 0; W < X.length; W += 1) for (_ = 0, K = X[W].getReferencedColumnIndexes(); _ < K.length; _ += 1) J[K[_]] = !1;
                for (_ = 0; _ < J.length; _ += 1) J[_] && $.push(_);
                return $;
              }((o == null ? void 0 : o.length) || 0, this.valueCount.seriesBuilders); j < this.valueCount.seriesBuilders.length; j++) (D = this.valueCount.seriesBuilders[j]).populateColumns(H) && e.push(D);
              for (; H.length > 0; ) {
                for ((D = new p()).addColumnReader(0, "x"), (V = H.indexOf(0)) !== -1 && H.splice(V, 1), g = 0; g < this.valueCount.global; g++) D.addColumnReader(void 0, this.valueCount.globalPointArrayMap[g]);
                D.populateColumns(H) && e.push(D);
              }
              if (e.length > 0 && e[0].readers.length > 0 && (G = o == null ? void 0 : o[e[0].readers[0].columnIndex ?? -1]) !== void 0 && (G.isDatetime ? n = "datetime" : G.isNumeric || (n = "category")), n === "category") for (j = 0; j < e.length; j++) for (k = 0, D = e[j]; k < D.readers.length; k++) D.readers[k].configName === "x" && (D.readers[k].configName = "name");
              for (j = 0; j < e.length; j++) {
                for (m = 0, D = e[j], i = []; m < o[0].length; m++) i[m] = D.read(o, m);
                d[j] = { data: i, pointStart: i[0] && (D.pointIsArray ? (F = i[0]) == null ? void 0 : F[0] : (U = i[0]) == null ? void 0 : U.x) || void 0 }, D.name && (d[j].name = D.name), n === "category" && (d[j].turboThreshold = 0, d[j].pointStart = 0);
              }
              P = { series: d }, n !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== n ? (this.xAxisOptions = { type: n }, n === "category" && (this.xAxisOptions.uniqueNames = !1)) : n = this.xAxisOptions = void 0, this.chart || h(!0, P, { xAxis: this.xAxisOptions || {} }), (Y = t.complete) == null || Y.call(t, P), (q = t.afterComplete) == null || q.call(t, this, P);
            }
          }
          xAxisUpdateHandler(o) {
            let t = this.xAxisOptions;
            t && (!o.options.type && t.type && (o.type = t.type), o.options.uniqueNames || t.uniqueNames !== !1 || (o.uniqueNames = t.uniqueNames));
          }
          update(o, t) {
            var d;
            let e = this.chart, n = e.options;
            o && (o.afterComplete = function(i, g) {
              if (!g) return;
              let m = e.xAxis[0], k = i.xAxisOptions;
              k && m && (m.type !== k.type && !m.options.type || m.uniqueNames && k.uniqueNames === !1 && m.options.uniqueNames === void 0) ? m.update({}, !1) : ((g == null ? void 0 : g.series) || []).forEach(function(j) {
                delete j.pointStart;
              }), e.update(g, t, !0);
            }, h(!0, n.data, o), (d = n.data) != null && d.googleSpreadsheetKey && !o.columns && delete n.data.columns, this.init(n.data || {}, n));
          }
        }
        c(T, "afterSetOptions", function() {
          var C;
          this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((C = this.chart.data) == null || C.xAxisUpdateHandler(this));
        }), c(B, "init", function(C) {
          let o = this, t = C.args[1], e = w().data, n = C.args[0] || {};
          if ((e || n && n.data) && !o.hasDataDef) {
            o.hasDataDef = !0;
            let d = h(e, n.data);
            o.data = new b(s(d, { afterComplete: function(i, g) {
              var j, P;
              let m, k;
              if (Object.hasOwnProperty.call(n, "series"))
                if (typeof n.series == "object") for (m = Math.max(n.series.length, ((j = g == null ? void 0 : g.series) == null ? void 0 : j.length) ?? 0); m--; ) k = n.series[m] || {}, n.series[m] = h(k, ((P = g == null ? void 0 : g.series) == null ? void 0 : P[m]) ?? {});
                else delete n.series;
              n = h(g, n), o.data = i, o.init(n, t);
            } }), n, o), C.preventDefault();
          }
        });
        class p {
          constructor() {
            this.readers = [], this.pointIsArray = !0;
          }
          populateColumns(o) {
            let t = !0;
            return this.readers.forEach((e) => {
              e.columnIndex === void 0 && (e.columnIndex = o.shift());
            }), this.readers.forEach((e) => {
              e.columnIndex === void 0 && (t = !1);
            }), t;
          }
          read(o, t) {
            let e = this.pointIsArray, n = e ? [] : {};
            if (this.readers.forEach((d) => {
              let i = o[d.columnIndex][t];
              e ? n.push(i) : d.configName.indexOf(".") > 0 ? O.prototype.setNestedProperty(n, i, d.configName) : n[d.configName] = i;
            }), this.name === void 0 && this.readers.length >= 2) {
              let d = [];
              this.readers.forEach(function(i) {
                (i.configName === "x" || i.configName === "name" || i.configName === "y") && i.columnIndex !== void 0 && d.push(i.columnIndex);
              }), d.length >= 2 && (d.shift(), d.sort(function(i, g) {
                return i - g;
              })), this.name = o[x(d.shift(), 0)].name;
            }
            return n;
          }
          addColumnReader(o, t) {
            this.readers.push({ columnIndex: o, configName: t }), t === "x" || t === "y" || t === void 0 || (this.pointIsArray = !1);
          }
          getReferencedColumnIndexes() {
            let o, t, e = [];
            for (o = 0; o < this.readers.length; o += 1) (t = this.readers[o]).columnIndex !== void 0 && e.push(t.columnIndex);
            return e;
          }
          hasReader(o) {
            let t;
            for (t = 0; t < this.readers.length; t += 1) if (this.readers[t].configName === o) return !0;
          }
        }
        return b;
      }), Z(r, "masters/modules/data.src.js", [r["Core/Globals.js"], r["Core/HttpUtilities.js"], r["Extensions/Data.js"]], function(T, B, I) {
        return T.Data = T.Data || I, T.HttpUtilities = T.HttpUtilities || B, T.ajax = T.HttpUtilities.ajax, T.data = T.Data.data, T.getJSON = T.HttpUtilities.getJSON, T.post = T.HttpUtilities.post, T;
      });
    });
  }(Ce)), Ce.exports;
}
var ll = al();
const hl = /* @__PURE__ */ It(ll);
var Ae = { exports: {} }, Ns;
function dl() {
  return Ns || (Ns = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Exporting module
    *
    * (c) 2010-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Core/Chart/ChartNavigationComposition.js", [], function() {
        var T;
        return function(B) {
          B.compose = function(R) {
            return R.navigation || (R.navigation = new I(R)), R;
          };
          class I {
            constructor(z) {
              this.updates = [], this.chart = z;
            }
            addUpdate(z) {
              this.chart.navigation.updates.push(z);
            }
            update(z, O) {
              this.updates.forEach((L) => {
                L.call(this.chart, z, O);
              });
            }
          }
          B.Additions = I;
        }(T || (T = {})), T;
      }), Z(r, "Extensions/Exporting/ExportingDefaults.js", [r["Core/Globals.js"]], function(T) {
        let { isTouchDevice: B } = T;
        return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
          this.fullscreen && this.fullscreen.toggle();
        } }, printChart: { textKey: "printChart", onclick: function() {
          this.print();
        } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
          this.exportChart();
        } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
          this.exportChart({ type: "image/jpeg" });
        } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
          this.exportChart({ type: "application/pdf" });
        } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
          this.exportChart({ type: "image/svg+xml" });
        } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: B ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
      }), Z(r, "Extensions/Exporting/ExportingSymbols.js", [], function() {
        var T;
        return function(B) {
          let I = [];
          function R(O, L, M, w) {
            return [["M", O, L + 2.5], ["L", O + M, L + 2.5], ["M", O, L + w / 2 + 0.5], ["L", O + M, L + w / 2 + 0.5], ["M", O, L + w - 1.5], ["L", O + M, L + w - 1.5]];
          }
          function z(O, L, M, w) {
            let A = w / 3 - 2;
            return [].concat(this.circle(M - A, L, A, A), this.circle(M - A, L + A + 4, A, A), this.circle(M - A, L + 2 * (A + 4), A, A));
          }
          B.compose = function(O) {
            if (I.indexOf(O) === -1) {
              I.push(O);
              let L = O.prototype.symbols;
              L.menu = R, L.menuball = z.bind(L);
            }
          };
        }(T || (T = {})), T;
      }), Z(r, "Extensions/Exporting/Fullscreen.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { composed: R } = B, { addEvent: z, fireEvent: O, pushUnique: L } = I;
        function M() {
          this.fullscreen = new w(this);
        }
        class w {
          static compose(l) {
            L(R, "Fullscreen") && z(l, "beforeRender", M);
          }
          constructor(l) {
            this.chart = l, this.isOpen = !1;
            let u = l.renderTo;
            !this.browserProps && (typeof u.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : u.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : u.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : u.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
          }
          close() {
            let l = this, u = l.chart, c = u.options.chart;
            O(u, "fullscreenClose", null, function() {
              l.isOpen && l.browserProps && u.container.ownerDocument instanceof Document && u.container.ownerDocument[l.browserProps.exitFullscreen](), l.unbindFullscreenEvent && (l.unbindFullscreenEvent = l.unbindFullscreenEvent()), u.setSize(l.origWidth, l.origHeight, !1), l.origWidth = void 0, l.origHeight = void 0, c.width = l.origWidthOption, c.height = l.origHeightOption, l.origWidthOption = void 0, l.origHeightOption = void 0, l.isOpen = !1, l.setButtonText();
            });
          }
          open() {
            let l = this, u = l.chart, c = u.options.chart;
            O(u, "fullscreenOpen", null, function() {
              if (c && (l.origWidthOption = c.width, l.origHeightOption = c.height), l.origWidth = u.chartWidth, l.origHeight = u.chartHeight, l.browserProps) {
                let v = z(u.container.ownerDocument, l.browserProps.fullscreenChange, function() {
                  l.isOpen ? (l.isOpen = !1, l.close()) : (u.setSize(null, null, !1), l.isOpen = !0, l.setButtonText());
                }), s = z(u, "destroy", v);
                l.unbindFullscreenEvent = () => {
                  v(), s();
                };
                let f = u.renderTo[l.browserProps.requestFullscreen]();
                f && f.catch(function() {
                  alert("Full screen is not supported inside a frame.");
                });
              }
            });
          }
          setButtonText() {
            let l = this.chart, u = l.exportDivElements, c = l.options.exporting, v = c && c.buttons && c.buttons.contextButton.menuItems, s = l.options.lang;
            if (c && c.menuItemDefinitions && s && s.exitFullscreen && s.viewFullscreen && v && u) {
              let f = u[v.indexOf("viewFullscreen")];
              f && T.setElementHTML(f, this.isOpen ? s.exitFullscreen : c.menuItemDefinitions.viewFullscreen.text || s.viewFullscreen);
            }
          }
          toggle() {
            this.isOpen ? this.close() : this.open();
          }
        }
        return w;
      }), Z(r, "Core/HttpUtilities.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { win: I } = T, { discardElement: R, objectEach: z } = B, O = { ajax: function(L) {
          let M = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, w = new XMLHttpRequest();
          function A(l, u) {
            L.error && L.error(l, u);
          }
          if (!L.url) return !1;
          w.open((L.type || "get").toUpperCase(), L.url, !0), L.headers && L.headers["Content-Type"] || w.setRequestHeader("Content-Type", M[L.dataType || "json"] || M.text), z(L.headers, function(l, u) {
            w.setRequestHeader(u, l);
          }), L.responseType && (w.responseType = L.responseType), w.onreadystatechange = function() {
            let l;
            if (w.readyState === 4) {
              if (w.status === 200) {
                if (L.responseType !== "blob" && (l = w.responseText, L.dataType === "json")) try {
                  l = JSON.parse(l);
                } catch (u) {
                  if (u instanceof Error) return A(w, u);
                }
                return L.success && L.success(l, w);
              }
              A(w, w.responseText);
            }
          }, L.data && typeof L.data != "string" && (L.data = JSON.stringify(L.data)), w.send(L.data);
        }, getJSON: function(L, M) {
          O.ajax({ url: L, success: M, dataType: "json", headers: { "Content-Type": "text/plain" } });
        }, post: function(L, M, w) {
          let A = new I.FormData();
          z(M, function(c, v) {
            A.append(v, c);
          }), A.append("b64", "true");
          let { filename: l, type: u } = M;
          return I.fetch(L, { method: "POST", body: A, ...w }).then((c) => {
            c.ok && c.text().then((v) => {
              let s = document.createElement("a");
              s.href = `data:${u};base64,${v}`, s.download = l, s.click(), R(s);
            });
          });
        } };
        return O;
      }), Z(r, "Extensions/Exporting/Exporting.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Chart/Chart.js"], r["Core/Chart/ChartNavigationComposition.js"], r["Core/Defaults.js"], r["Extensions/Exporting/ExportingDefaults.js"], r["Extensions/Exporting/ExportingSymbols.js"], r["Extensions/Exporting/Fullscreen.js"], r["Core/Globals.js"], r["Core/HttpUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A) {
        var l;
        let { defaultOptions: u } = R, { doc: c, SVG_NS: v, win: s } = M, { addEvent: f, css: y, createElement: h, discardElement: a, extend: x, find: S, fireEvent: E, isObject: b, merge: p, objectEach: C, pick: o, removeEvent: t, uniqueKey: e } = A;
        return function(n) {
          let d, i = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], g = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
          n.inlineAllowlist = [];
          let m = ["clipPath", "defs", "desc"];
          function k($) {
            let et, st, at = this, lt = at.renderer, it = p(at.options.navigation.buttonOptions, $), Q = it.onclick, ot = it.menuItems, nt = it.symbolSize || 12;
            if (at.btnCount || (at.btnCount = 0), at.exportDivElements || (at.exportDivElements = [], at.exportSVGElements = []), it.enabled === !1 || !it.theme) return;
            let ht = at.styledMode ? {} : it.theme;
            Q ? st = function(dt) {
              dt && dt.stopPropagation(), Q.call(at, dt);
            } : ot && (st = function(dt) {
              dt && dt.stopPropagation(), at.contextMenu(ct.menuClassName, ot, ct.translateX || 0, ct.translateY || 0, ct.width || 0, ct.height || 0, ct), ct.setState(2);
            }), it.text && it.symbol ? ht.paddingLeft = o(ht.paddingLeft, 30) : it.text || x(ht, { width: it.width, height: it.height, padding: 0 });
            let ct = lt.button(it.text, 0, 0, st, ht, void 0, void 0, void 0, void 0, it.useHTML).addClass($.className).attr({ title: o(at.options.lang[it._titleKey || it.titleKey], "") });
            ct.menuClassName = $.menuClassName || "highcharts-menu-" + at.btnCount++, it.symbol && (et = lt.symbol(it.symbol, Math.round((it.symbolX || 0) - nt / 2), Math.round((it.symbolY || 0) - nt / 2), nt, nt, { width: nt, height: nt }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(ct), at.styledMode || et.attr({ stroke: it.symbolStroke, fill: it.symbolFill, "stroke-width": it.symbolStrokeWidth || 1 })), ct.add(at.exportingGroup).align(x(it, { width: ct.width, x: o(it.x, at.buttonOffset) }), !0, "spacingBox"), at.buttonOffset += ((ct.width || 0) + it.buttonSpacing) * (it.align === "right" ? -1 : 1), at.exportSVGElements.push(ct, et);
          }
          function j() {
            if (!this.printReverseInfo) return;
            let { childNodes: $, origDisplay: et, resetParams: st } = this.printReverseInfo;
            this.moveContainers(this.renderTo), [].forEach.call($, function(at, lt) {
              at.nodeType === 1 && (at.style.display = et[lt] || "");
            }), this.isPrinting = !1, st && this.setSize.apply(this, st), delete this.printReverseInfo, d = void 0, E(this, "afterPrint");
          }
          function P() {
            var at;
            let $ = c.body, et = this.options.exporting.printMaxWidth, st = { childNodes: $.childNodes, origDisplay: [], resetParams: void 0 };
            this.isPrinting = !0, (at = this.pointer) == null || at.reset(void 0, 0), E(this, "beforePrint"), et && this.chartWidth > et && (st.resetParams = [this.options.chart.width, void 0, !1], this.setSize(et, void 0, !1)), [].forEach.call(st.childNodes, function(lt, it) {
              lt.nodeType === 1 && (st.origDisplay[it] = lt.style.display, lt.style.display = "none");
            }), this.moveContainers($), this.printReverseInfo = st;
          }
          function D($) {
            $.renderExporting(), f($, "redraw", $.renderExporting), f($, "destroy", $.destroyExport);
          }
          function H($, et, st, at, lt, it, Q) {
            var mt, yt;
            let ot = this, nt = ot.options.navigation, ht = ot.chartWidth, ct = ot.chartHeight, dt = "cache-" + $, ut = Math.max(lt, it), pt, gt = ot[dt];
            gt || (ot.exportContextMenu = ot[dt] = gt = h("div", { className: $ }, { position: "absolute", zIndex: 1e3, padding: ut + "px", pointerEvents: "auto", ...ot.renderer.style }, ((mt = ot.scrollablePlotArea) == null ? void 0 : mt.fixedDiv) || ot.container), pt = h("ul", { className: "highcharts-menu" }, ot.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, gt), ot.styledMode || y(pt, x({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, nt.menuStyle)), gt.hideMenu = function() {
              y(gt, { display: "none" }), Q && Q.setState(0), ot.openMenu = !1, y(ot.renderTo, { overflow: "hidden" }), y(ot.container, { overflow: "hidden" }), A.clearTimeout(gt.hideTimer), E(ot, "exportMenuHidden");
            }, ot.exportEvents.push(f(gt, "mouseleave", function() {
              gt.hideTimer = s.setTimeout(gt.hideMenu, 500);
            }), f(gt, "mouseenter", function() {
              A.clearTimeout(gt.hideTimer);
            }), f(c, "mouseup", function(xt) {
              var bt;
              (bt = ot.pointer) != null && bt.inClass(xt.target, $) || gt.hideMenu();
            }), f(gt, "click", function() {
              ot.openMenu && gt.hideMenu();
            })), et.forEach(function(xt) {
              if (typeof xt == "string" && (xt = ot.options.exporting.menuItemDefinitions[xt]), b(xt, !0)) {
                let bt;
                xt.separator ? bt = h("hr", void 0, void 0, pt) : (xt.textKey === "viewData" && ot.isDataTableVisible && (xt.textKey = "hideData"), bt = h("li", { className: "highcharts-menu-item", onclick: function(vt) {
                  vt && vt.stopPropagation(), gt.hideMenu(), typeof xt != "string" && xt.onclick && xt.onclick.apply(ot, arguments);
                } }, void 0, pt), T.setElementHTML(bt, xt.text || ot.options.lang[xt.textKey]), ot.styledMode || (bt.onmouseover = function() {
                  y(this, nt.menuItemHoverStyle);
                }, bt.onmouseout = function() {
                  y(this, nt.menuItemStyle);
                }, y(bt, x({ cursor: "pointer" }, nt.menuItemStyle || {})))), ot.exportDivElements.push(bt);
              }
            }), ot.exportDivElements.push(pt, gt), ot.exportMenuWidth = gt.offsetWidth, ot.exportMenuHeight = gt.offsetHeight);
            let ft = { display: "block" };
            st + (ot.exportMenuWidth || 0) > ht ? ft.right = ht - st - lt - ut + "px" : ft.left = st - ut + "px", at + it + (ot.exportMenuHeight || 0) > ct && ((yt = Q.alignOptions) == null ? void 0 : yt.verticalAlign) !== "top" ? ft.bottom = ct - at - ut + "px" : ft.top = at + it - ut + "px", y(gt, ft), y(ot.renderTo, { overflow: "" }), y(ot.container, { overflow: "" }), ot.openMenu = !0, E(ot, "exportMenuShown");
          }
          function G($) {
            let et, st = $ ? $.target : this, at = st.exportSVGElements, lt = st.exportDivElements, it = st.exportEvents;
            at && (at.forEach((Q, ot) => {
              Q && (Q.onclick = Q.ontouchstart = null, st[et = "cache-" + Q.menuClassName] && delete st[et], at[ot] = Q.destroy());
            }), at.length = 0), st.exportingGroup && (st.exportingGroup.destroy(), delete st.exportingGroup), lt && (lt.forEach(function(Q, ot) {
              Q && (A.clearTimeout(Q.hideTimer), t(Q, "mouseleave"), lt[ot] = Q.onmouseout = Q.onmouseover = Q.ontouchstart = Q.onclick = null, a(Q));
            }), lt.length = 0), it && (it.forEach(function(Q) {
              Q();
            }), it.length = 0);
          }
          function V($, et) {
            let st = this.getSVGForExport($, et);
            $ = p(this.options.exporting, $), w.post($.url, { filename: $.filename ? $.filename.replace(/\//g, "-") : this.getFilename(), type: $.type, width: $.width, scale: $.scale, svg: st }, $.fetchOptions);
          }
          function F() {
            return this.styledMode && this.inlineStyles(), this.container.innerHTML;
          }
          function U() {
            let $ = this.userOptions.title && this.userOptions.title.text, et = this.options.exporting.filename;
            return et ? et.replace(/\//g, "-") : (typeof $ == "string" && (et = $.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!et || et.length < 5) && (et = "chart"), et);
          }
          function Y($) {
            let et, st, at = p(this.options, $);
            at.plotOptions = p(this.userOptions.plotOptions, $ && $.plotOptions), at.time = p(this.userOptions.time, $ && $.time);
            let lt = h("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, c.body), it = this.renderTo.style.width, Q = this.renderTo.style.height, ot = at.exporting.sourceWidth || at.chart.width || /px$/.test(it) && parseInt(it, 10) || (at.isGantt ? 800 : 600), nt = at.exporting.sourceHeight || at.chart.height || /px$/.test(Q) && parseInt(Q, 10) || 400;
            x(at.chart, { animation: !1, renderTo: lt, forExport: !0, renderer: "SVGRenderer", width: ot, height: nt }), at.exporting.enabled = !1, delete at.data, at.series = [], this.series.forEach(function(dt) {
              (st = p(dt.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: dt.visible })).isInternal || at.series.push(st);
            });
            let ht = {};
            this.axes.forEach(function(dt) {
              dt.userOptions.internalKey || (dt.userOptions.internalKey = e()), dt.options.isInternal || (ht[dt.coll] || (ht[dt.coll] = !0, at[dt.coll] = []), at[dt.coll].push(p(dt.userOptions, { visible: dt.visible, type: dt.type, uniqueNames: dt.uniqueNames })));
            }), at.colorAxis = this.userOptions.colorAxis;
            let ct = new this.constructor(at, this.callback);
            return $ && ["xAxis", "yAxis", "series"].forEach(function(dt) {
              let ut = {};
              $[dt] && (ut[dt] = $[dt], ct.update(ut));
            }), this.axes.forEach(function(dt) {
              let ut = S(ct.axes, function(mt) {
                return mt.options.internalKey === dt.userOptions.internalKey;
              }), pt = dt.getExtremes(), gt = pt.userMin, ft = pt.userMax;
              ut && (gt !== void 0 && gt !== ut.min || ft !== void 0 && ft !== ut.max) && ut.setExtremes(gt, ft, !0, !1);
            }), et = ct.getChartHTML(), E(this, "getSVG", { chartCopy: ct }), et = this.sanitizeSVG(et, at), at = null, ct.destroy(), a(lt), et;
          }
          function q($, et) {
            let st = this.options.exporting;
            return this.getSVG(p({ chart: { borderRadius: 0 } }, st.chartOptions, et, { exporting: { sourceWidth: $ && $.sourceWidth || st.sourceWidth, sourceHeight: $ && $.sourceHeight || st.sourceHeight } }));
          }
          function N() {
            let $, et = n.inlineAllowlist, st = {}, at = c.createElement("iframe");
            y(at, { width: "1px", height: "1px", visibility: "hidden" }), c.body.appendChild(at);
            let lt = at.contentWindow && at.contentWindow.document;
            lt && lt.body.appendChild(lt.createElementNS(v, "svg")), function it(Q) {
              let ot, nt, ht, ct, dt, ut, pt = {};
              if (lt && Q.nodeType === 1 && m.indexOf(Q.nodeName) === -1) {
                if (ot = s.getComputedStyle(Q, null), nt = Q.nodeName === "svg" ? {} : s.getComputedStyle(Q.parentNode, null), !st[Q.nodeName]) {
                  $ = lt.getElementsByTagName("svg")[0], ht = lt.createElementNS(Q.namespaceURI, Q.nodeName), $.appendChild(ht);
                  let gt = s.getComputedStyle(ht, null), ft = {};
                  for (let mt in gt) mt.length < 1e3 && typeof gt[mt] == "string" && !/^\d+$/.test(mt) && (ft[mt] = gt[mt]);
                  st[Q.nodeName] = ft, Q.nodeName === "text" && delete st.text.fill, $.removeChild(ht);
                }
                for (let gt in ot) (M.isFirefox || M.isMS || M.isSafari || Object.hasOwnProperty.call(ot, gt)) && function(ft, mt) {
                  if (ct = dt = !1, et.length) {
                    for (ut = et.length; ut-- && !dt; ) dt = et[ut].test(mt);
                    ct = !dt;
                  }
                  for (mt === "transform" && ft === "none" && (ct = !0), ut = i.length; ut-- && !ct; ) {
                    if (mt.length > 1e3) throw Error("Input too long");
                    ct = i[ut].test(mt) || typeof ft == "function";
                  }
                  !ct && (nt[mt] !== ft || Q.nodeName === "svg") && st[Q.nodeName][mt] !== ft && (g.indexOf(mt) === -1 ? pt[mt] = ft : ft && Q.setAttribute(mt.replace(/[A-Z]/g, function(yt) {
                    return "-" + yt.toLowerCase();
                  }), ft));
                }(ot[gt], gt);
                if (y(Q, pt), Q.nodeName === "svg" && Q.setAttribute("stroke-width", "1px"), Q.nodeName === "text") return;
                [].forEach.call(Q.children || Q.childNodes, it);
              }
            }(this.container.querySelector("svg")), $.parentNode.removeChild($), at.parentNode.removeChild(at);
          }
          function X($) {
            let { scrollablePlotArea: et } = this;
            (et ? [et.fixedDiv, et.scrollingContainer] : [this.container]).forEach(function(st) {
              $.appendChild(st);
            });
          }
          function W() {
            let $ = this, et = (st, at, lt) => {
              $.isDirtyExporting = !0, p(!0, $.options[st], at), o(lt, !0) && $.redraw();
            };
            $.exporting = { update: function(st, at) {
              et("exporting", st, at);
            } }, I.compose($).navigation.addUpdate((st, at) => {
              et("navigation", st, at);
            });
          }
          function _() {
            let $ = this;
            $.isPrinting || (d = $, M.isSafari || $.beforePrint(), setTimeout(() => {
              s.focus(), s.print(), M.isSafari || setTimeout(() => {
                $.afterPrint();
              }, 1e3);
            }, 1));
          }
          function K() {
            let $ = this, et = $.options.exporting, st = et.buttons, at = $.isDirtyExporting || !$.exportSVGElements;
            $.buttonOffset = 0, $.isDirtyExporting && $.destroyExport(), at && et.enabled !== !1 && ($.exportEvents = [], $.exportingGroup = $.exportingGroup || $.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), C(st, function(lt) {
              $.addButton(lt);
            }), $.isDirtyExporting = !1);
          }
          function J($, et) {
            let st = $.indexOf("</svg>") + 6, at = $.substr(st);
            return $ = $.substr(0, st), et && et.exporting && et.exporting.allowHTML && at && (at = '<foreignObject x="0" y="0" width="' + et.chart.width + '" height="' + et.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + at.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", $ = $.replace("</svg>", at + "</svg>")), $ = $.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
          }
          n.compose = function($, et) {
            O.compose(et), L.compose($);
            let st = $.prototype;
            st.exportChart || (st.afterPrint = j, st.exportChart = V, st.inlineStyles = N, st.print = _, st.sanitizeSVG = J, st.getChartHTML = F, st.getSVG = Y, st.getSVGForExport = q, st.getFilename = U, st.moveContainers = X, st.beforePrint = P, st.contextMenu = H, st.addButton = k, st.destroyExport = G, st.renderExporting = K, st.callbacks.push(D), f($, "init", W), M.isSafari && s.matchMedia("print").addListener(function(at) {
              d && (at.matches ? d.beforePrint() : d.afterPrint());
            }), u.exporting = p(z.exporting, u.exporting), u.lang = p(z.lang, u.lang), u.navigation = p(z.navigation, u.navigation));
          };
        }(l || (l = {})), l;
      }), Z(r, "masters/modules/exporting.src.js", [r["Core/Globals.js"], r["Extensions/Exporting/Exporting.js"], r["Core/HttpUtilities.js"]], function(T, B, I) {
        return T.HttpUtilities = T.HttpUtilities || I, T.ajax = T.HttpUtilities.ajax, T.getJSON = T.HttpUtilities.getJSON, T.post = T.HttpUtilities.post, B.compose(T.Chart, T.Renderer), T;
      });
    });
  }(Ae)), Ae.exports;
}
var cl = dl();
const pl = /* @__PURE__ */ It(cl);
var Me = { exports: {} }, zs;
function ul() {
  return zs || (zs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Highcharts funnel module
    *
    * (c) 2010-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Series/Funnel/FunnelSeriesDefaults.js", [], function() {
        return { animation: !1, borderRadius: 0, center: ["50%", "50%"], width: "90%", neckWidth: "30%", height: "100%", neckHeight: "25%", reversed: !1, size: !0, dataLabels: { connectorWidth: 1, verticalAlign: "middle" }, states: { select: { color: "#cccccc", borderColor: "#000000" } } };
      }), Z(r, "Series/Funnel/FunnelSeries.js", [r["Series/Funnel/FunnelSeriesDefaults.js"], r["Core/Globals.js"], r["Extensions/BorderRadius.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { composed: O, noop: L } = B, { column: M, pie: w } = R.seriesTypes, { addEvent: A, correctFloat: l, extend: u, fireEvent: c, isArray: v, merge: s, pick: f, pushUnique: y, relativeLength: h, splat: a } = z, x = R.series.prototype.alignDataLabel;
        function S(b, p) {
          return /%$/.test(b) ? p * parseInt(b, 10) / 100 : parseInt(b, 10);
        }
        class E extends w {
          alignDataLabel(p, C, o, t, e) {
            let n = p.series, d = n.options.reversed, i = p.dlBox || p.shapeArgs, { align: g, padding: m = 0, verticalAlign: k } = o, j = ((n.options || {}).dataLabels || {}).inside, P = n.center[1], D = p.plotY || 0, H = C.height ?? C.getBBox().height, G = n.getWidthAt((d ? 2 * P - D : D) - i.height / 2 + H), V = k === "middle" ? (i.topWidth - i.bottomWidth) / 4 : (G - i.bottomWidth) / 2, F = i.y, U = i.x;
            k === "middle" ? F = i.y - i.height / 2 + H / 2 : k === "top" && (F = i.y - i.height + H + m), (k === "top" && !d || k === "bottom" && d || k === "middle") && (g === "right" ? U = i.x - m + V : g === "left" && (U = i.x + m - V)), t = { x: U, y: d ? F - i.height : F, width: i.bottomWidth, height: i.height }, o.verticalAlign = "bottom", j && (o.distance = void 0), j && p.visible && x.call(n, p, C, o, t, e), j && (!p.visible && p.dataLabel && (p.dataLabel.placed = !1), p.contrastColor && C.css({ color: p.contrastColor }));
          }
          drawDataLabels() {
            (a(this.options.dataLabels)[0].inside ? M : w).prototype.drawDataLabels.call(this);
          }
          getDataLabelPosition(p, C) {
            let o = p.plotY || 0, t = p.half ? 1 : -1, e = this.getX(o, !!p.half, p);
            return { distance: C, natural: { x: 0, y: o }, computed: {}, alignment: p.half ? "right" : "left", connectorPosition: { breakAt: { x: e + (C - 5) * t, y: o }, touchingSliceAt: { x: e + C * t, y: o } } };
          }
          translate() {
            let p = this, C = p.chart, o = p.options, t = o.reversed, e = o.ignoreHiddenPoint, n = I.optionsToObject(o.borderRadius), d = C.plotWidth, i = C.plotHeight, g = o.center, m = S(g[0], d), k = S(g[1], i), j = S(o.width, d), P = S(o.height, i), D = S(o.neckWidth, d), H = S(o.neckHeight, i), G = k - P / 2 + P - H, V = p.points, F = h(n.radius, j), U = n.scope, Y = o.dataLabels.position === "left" ? 1 : 0, q = (nt) => {
              let ht = Math.tan(nt / 2), ct = Math.cos(J), dt = Math.sin(J), ut = F, pt = ut / ht, gt = Math.tan((Math.PI - nt) / 3.2104);
              return pt > $ && (ut = (pt = $) * ht), { dx: [pt * ct, (pt - (gt *= ut)) * ct, pt - gt, pt], dy: [pt * dt, (pt - gt) * dt, pt - gt, pt].map((ft) => t ? -ft : ft) };
            }, N = 0, X = 0, W, _, K, J, $, et, st, at, lt, it, Q, ot;
            for (let nt of (p.getWidthAt = function(ht) {
              let ct = k - P / 2;
              return ht > G || P === H ? D : D + (j - D) * (1 - (ht - ct) / (P - H));
            }, p.getX = function(ht, ct, dt) {
              var ut, pt, gt;
              return m + (ct ? -1 : 1) * (p.getWidthAt(t ? 2 * k - ht : ht) / 2 + (((pt = (ut = dt.dataLabel) == null ? void 0 : ut.dataLabelPosition) == null ? void 0 : pt.distance) ?? h(((gt = this.options.dataLabels) == null ? void 0 : gt.distance) || 0, j)));
            }, p.center = [m, k, P], p.centerX = m, V)) nt.y && nt.isValid() && (!e || nt.visible !== !1) && (N += nt.y);
            for (let nt of V) {
              if (ot = null, K = N ? nt.y / N : 0, it = (st = k - P / 2 + X * P) + K * P, at = (et = m - (W = p.getWidthAt(st)) / 2) + W, Q = (lt = m - (W = p.getWidthAt(it)) / 2) + W, l(st) >= G ? (et = lt = m - D / 2, at = Q = m + D / 2) : it > G && (ot = it, Q = (lt = m - (W = p.getWidthAt(G)) / 2) + W, it = G), t && (st = 2 * k - st, it = 2 * k - it, ot !== null && (ot = 2 * k - ot)), F && (U === "point" || nt.index === 0 || nt.index === V.length - 1 || ot !== null)) {
                let ht = Math.abs(it - st), ct = at - Q, dt = Q - lt, ut = Math.sqrt(ct * ct + ht * ht);
                J = Math.atan(ct !== 0 ? ht / ct : 1 / 0), $ = ut / 2, ot !== null && ($ = Math.min($, Math.abs(ot - it) / 2)), dt >= 1 && ($ = Math.min($, dt / 2));
                let pt = q(J);
                if (_ = U === "stack" && nt.index !== 0 ? [["M", et, st], ["L", at, st]] : [["M", et + pt.dx[0], st + pt.dy[0]], ["C", et + pt.dx[1], st + pt.dy[1], et + pt.dx[2], st, et + pt.dx[3], st], ["L", at - pt.dx[3], st], ["C", at - pt.dx[2], st, at - pt.dx[1], st + pt.dy[1], at - pt.dx[0], st + pt.dy[0]]], ot !== null) {
                  let gt = q(Math.PI / 2);
                  pt = q(Math.PI / 2 + J), _.push(["L", Q + pt.dx[0], it - pt.dy[0]], ["C", Q + pt.dx[1], it - pt.dy[1], Q, it + pt.dy[2], Q, it + pt.dy[3]]), U === "stack" && nt.index !== V.length - 1 ? _.push(["L", Q, ot], ["L", lt, ot]) : _.push(["L", Q, ot - gt.dy[3]], ["C", Q, ot - gt.dy[2], Q - gt.dx[2], ot, Q - gt.dx[3], ot], ["L", lt + gt.dx[3], ot], ["C", lt + gt.dx[2], ot, lt, ot - gt.dy[2], lt, ot - gt.dy[3]]), _.push(["L", lt, it + pt.dy[3]], ["C", lt, it + pt.dy[2], lt - pt.dx[1], it - pt.dy[1], lt - pt.dx[0], it - pt.dy[0]]);
                } else dt >= 1 ? (pt = q(Math.PI - J), U === "stack" && nt.index === 0 ? _.push(["L", Q, it], ["L", lt, it]) : _.push(["L", Q + pt.dx[0], it - pt.dy[0]], ["C", Q + pt.dx[1], it - pt.dy[1], Q - pt.dx[2], it, Q - pt.dx[3], it], ["L", lt + pt.dx[3], it], ["C", lt + pt.dx[2], it, lt - pt.dx[1], it - pt.dy[1], lt - pt.dx[0], it - pt.dy[0]])) : (pt = q(Math.PI - 2 * J), _.push(["L", lt + pt.dx[0], it - pt.dy[0]], ["C", lt + pt.dx[1], it - pt.dy[1], lt - pt.dx[1], it - pt.dy[1], lt - pt.dx[0], it - pt.dy[0]]));
              } else _ = [["M", et, st], ["L", at, st], ["L", Q, it]], ot !== null && _.push(["L", Q, ot], ["L", lt, ot]), _.push(["L", lt, it]);
              _.push(["Z"]), nt.shapeType = "path", nt.shapeArgs = { d: _ }, nt.percentage = 100 * K, nt.plotX = m, nt.plotY = (st + (ot || it)) / 2, nt.tooltipPos = [m, nt.plotY], nt.dlBox = { x: lt, y: st, topWidth: at - et, bottomWidth: Q - lt, height: Math.abs(f(ot, it) - st), width: NaN }, nt.slice = L, nt.half = Y, nt.isValid() && (!e || nt.visible !== !1) && (X += K);
            }
            c(p, "afterTranslate");
          }
          sortByAngle(p) {
            p.sort((C, o) => C.plotY - o.plotY);
          }
        }
        return E.defaultOptions = s(w.defaultOptions, T), u(E.prototype, { animate: L }), function(b) {
          function p() {
            for (let C of this.series) {
              let o = C.options && C.options.dataLabels;
              v(o) && (o = o[0]), C.is("pie") && C.placeDataLabels && o && !o.inside && C.placeDataLabels();
            }
          }
          b.compose = function(C) {
            y(O, "FunnelSeries") && A(C, "afterHideAllOverlappingLabels", p);
          };
        }(E), R.registerSeriesType("funnel", E), E;
      }), Z(r, "Series/Pyramid/PyramidSeriesDefaults.js", [], function() {
        return { neckHeight: "0%", neckWidth: "0%", reversed: !0 };
      }), Z(r, "Series/Pyramid/PyramidSeries.js", [r["Series/Funnel/FunnelSeries.js"], r["Series/Pyramid/PyramidSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z } = R;
        class O extends T {
        }
        return O.defaultOptions = z(T.defaultOptions, B), I.registerSeriesType("pyramid", O), O;
      }), Z(r, "masters/modules/funnel.src.js", [r["Core/Globals.js"], r["Series/Funnel/FunnelSeries.js"]], function(T, B) {
        return B.compose(T.Chart), T;
      });
    });
  }(Me)), Me.exports;
}
var gl = ul();
const fl = /* @__PURE__ */ It(gl);
var we = { exports: {} }, Fs;
function ml() {
  return Fs || (Fs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Accessibility module
    *
    * (c) 2010-2024 Highsoft AS
    * Author: Oystein Moseng
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Accessibility/Utils/HTMLUtilities.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I, win: R } = T, { css: z } = B, O = R.EventTarget && new R.EventTarget() || "none";
        function L(w) {
          if (typeof R.MouseEvent == "function") return new R.MouseEvent(w.type, w);
          if (I.createEvent) {
            let A = I.createEvent("MouseEvent");
            if (A.initMouseEvent) return A.initMouseEvent(w.type, w.bubbles, w.cancelable, w.view || R, w.detail, w.screenX, w.screenY, w.clientX, w.clientY, w.ctrlKey, w.altKey, w.shiftKey, w.metaKey, w.button, w.relatedTarget), A;
          }
          return M(w.type);
        }
        function M(w, A, l) {
          let u = A || { x: 0, y: 0 };
          if (typeof R.MouseEvent == "function") return new R.MouseEvent(w, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: l || O, view: R, detail: w === "click" ? 1 : 0, screenX: u.x, screenY: u.y, clientX: u.x, clientY: u.y });
          if (I.createEvent) {
            let c = I.createEvent("MouseEvent");
            if (c.initMouseEvent) return c.initMouseEvent(w, !0, !0, R, w === "click" ? 1 : 0, u.x, u.y, u.x, u.y, !1, !1, !1, !1, 0, null), c;
          }
          return { type: w };
        }
        return { addClass: function(w, A) {
          w.classList ? w.classList.add(A) : 0 > w.className.indexOf(A) && (w.className += " " + A);
        }, cloneMouseEvent: L, cloneTouchEvent: function(w) {
          let A = (u) => {
            let c = [];
            for (let v = 0; v < u.length; ++v) {
              let s = u.item(v);
              s && c.push(s);
            }
            return c;
          };
          if (typeof R.TouchEvent == "function") {
            let u = new R.TouchEvent(w.type, { touches: A(w.touches), targetTouches: A(w.targetTouches), changedTouches: A(w.changedTouches), ctrlKey: w.ctrlKey, shiftKey: w.shiftKey, altKey: w.altKey, metaKey: w.metaKey, bubbles: w.bubbles, cancelable: w.cancelable, composed: w.composed, detail: w.detail, view: w.view });
            return w.defaultPrevented && u.preventDefault(), u;
          }
          let l = L(w);
          return l.touches = w.touches, l.changedTouches = w.changedTouches, l.targetTouches = w.targetTouches, l;
        }, escapeStringForHTML: function(w) {
          return w.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
        }, getElement: function(w) {
          return I.getElementById(w);
        }, getFakeMouseEvent: M, getHeadingTagNameForElement: function(w) {
          let A = (v) => "h" + Math.min(6, parseInt(v.slice(1), 10) + 1), l = (v) => /^H[1-6]$/i.test(v), u = (v) => {
            let s = v;
            for (; s = s.previousSibling; ) {
              let f = s.tagName || "";
              if (l(f)) return f;
            }
            return "";
          }, c = (v) => {
            let s = u(v);
            if (s) return A(s);
            let f = v.parentElement;
            if (!f) return "p";
            let y = f.tagName;
            return l(y) ? A(y) : c(f);
          };
          return c(w);
        }, removeChildNodes: function(w) {
          for (; w.lastChild; ) w.removeChild(w.lastChild);
        }, removeClass: function(w, A) {
          w.classList ? w.classList.remove(A) : w.className = w.className.replace(RegExp(A, "g"), "");
        }, removeElement: function(w) {
          w && w.parentNode && w.parentNode.removeChild(w);
        }, reverseChildNodes: function(w) {
          let A = w.childNodes.length;
          for (; A--; ) w.appendChild(w.childNodes[A]);
        }, simulatedEventTarget: O, stripHTMLTagsFromString: function(w, A = !1) {
          return typeof w == "string" ? A ? w.replace(/<\/?[^>]+(>|$)/g, "") : w.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : w;
        }, visuallyHideElement: function(w) {
          z(w, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
        } };
      }), Z(r, "Accessibility/A11yI18n.js", [r["Core/Templating.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { format: R } = T, { getNestedProperty: z, pick: O } = B;
        return function(L) {
          function M(A, l, u) {
            let c = (h, a) => {
              let x = h.slice(a || 0), S = x.indexOf("{"), E = x.indexOf("}");
              if (S > -1 && E > S) return { statement: x.substring(S + 1, E), begin: a + S + 1, end: a + E };
            }, v = [], s, f, y = 0;
            do
              s = c(A, y), (f = A.substring(y, s && s.begin - 1)).length && v.push({ value: f, type: "constant" }), s && v.push({ value: s.statement, type: "statement" }), y = s ? s.end + 1 : y + 1;
            while (s);
            return v.forEach((h) => {
              h.type === "statement" && (h.value = function(a, x) {
                let S, E, b = a.indexOf("#each("), p = a.indexOf("#plural("), C = a.indexOf("["), o = a.indexOf("]");
                if (b > -1) {
                  let e = a.slice(b).indexOf(")") + b, n = a.substring(0, b), d = a.substring(e + 1), i = a.substring(b + 6, e).split(","), g = Number(i[1]), m;
                  if (E = "", S = z(i[0], x)) {
                    m = (g = isNaN(g) ? S.length : g) < 0 ? S.length + g : Math.min(g, S.length);
                    for (let k = 0; k < m; ++k) E += n + S[k] + d;
                  }
                  return E.length ? E : "";
                }
                if (p > -1) {
                  var t;
                  let e = a.slice(p).indexOf(")") + p, n = a.substring(p + 8, e).split(",");
                  switch (Number(z(n[0], x))) {
                    case 0:
                      E = O(n[4], n[1]);
                      break;
                    case 1:
                      E = O(n[2], n[1]);
                      break;
                    case 2:
                      E = O(n[3], n[1]);
                      break;
                    default:
                      E = n[1];
                  }
                  return E ? (t = E).trim && t.trim() || t.replace(/^\s+|\s+$/g, "") : "";
                }
                if (C > -1) {
                  let e, n = a.substring(0, C), d = Number(a.substring(C + 1, o));
                  return S = z(n, x), !isNaN(d) && S && (d < 0 ? (e = S[S.length + d]) === void 0 && (e = S[0]) : (e = S[d]) === void 0 && (e = S[S.length - 1])), e !== void 0 ? e : "";
                }
                return "{" + a + "}";
              }(h.value, l));
            }), R(v.reduce((h, a) => h + a.value, ""), l, u);
          }
          function w(A, l) {
            let u = A.split("."), c = this.options.lang, v = 0;
            for (; v < u.length; ++v) c = c && c[u[v]];
            return typeof c == "string" ? M(c, l, this) : "";
          }
          L.compose = function(A) {
            let l = A.prototype;
            l.langFormat || (l.langFormat = w);
          }, L.i18nFormat = M;
        }(I || (I = {})), I;
      }), Z(r, "Accessibility/Utils/ChartUtilities.js", [r["Core/Globals.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { doc: R } = T, { stripHTMLTagsFromString: z } = B, { defined: O, find: L, fireEvent: M } = I;
        function w(l) {
          if (l.points && l.points.length) {
            let u = L(l.points, (c) => !!c.graphic);
            return u && u.graphic && u.graphic.element;
          }
        }
        function A(l) {
          let u = w(l);
          return u && u.parentNode || l.graph && l.graph.element || l.group && l.group.element;
        }
        return { fireEventOnWrappedOrUnwrappedElement: function l(u, c) {
          let v = c.type, s = u.hcEvents;
          R.createEvent && (u.dispatchEvent || u.fireEvent) ? u.dispatchEvent ? u.dispatchEvent(c) : u.fireEvent(v, c) : s && s[v] ? M(u, v, c) : u.element && l(u.element, c);
        }, getChartTitle: function(l) {
          return z(l.options.title.text || l.langFormat("accessibility.defaultChartTitle", { chart: l }), l.renderer.forExport);
        }, getAxisDescription: function(l) {
          var u, c;
          return l && (((u = l.options.accessibility) == null ? void 0 : u.description) || ((c = l.axisTitle) == null ? void 0 : c.textStr) || l.options.id || l.categories && "categories" || l.dateTime && "Time" || "values");
        }, getAxisRangeDescription: function(l) {
          let u = l.options || {};
          return u.accessibility && u.accessibility.rangeDescription !== void 0 ? u.accessibility.rangeDescription : l.categories ? function(c) {
            let v = c.chart;
            return c.dataMax && c.dataMin ? v.langFormat("accessibility.axis.rangeCategories", { chart: v, axis: c, numCategories: c.dataMax - c.dataMin + 1 }) : "";
          }(l) : l.dateTime && (l.min === 0 || l.dataMin === 0) ? function(c) {
            let v = c.chart, s = {}, f = c.dataMin || c.min || 0, y = c.dataMax || c.max || 0, h = "Seconds";
            s.Seconds = (y - f) / 1e3, s.Minutes = s.Seconds / 60, s.Hours = s.Minutes / 60, s.Days = s.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(x) {
              s[x] > 2 && (h = x);
            });
            let a = s[h].toFixed(h !== "Seconds" && h !== "Minutes" ? 1 : 0);
            return v.langFormat("accessibility.axis.timeRange" + h, { chart: v, axis: c, range: a.replace(".0", "") });
          }(l) : function(c) {
            let v = c.chart, s = v.options, f = s && s.accessibility && s.accessibility.screenReaderSection.axisRangeDateFormat || "", y = { min: c.dataMin || c.min || 0, max: c.dataMax || c.max || 0 }, h = function(a) {
              return c.dateTime ? v.time.dateFormat(f, y[a]) : y[a].toString();
            };
            return v.langFormat("accessibility.axis.rangeFromTo", { chart: v, axis: c, rangeFrom: h("min"), rangeTo: h("max") });
          }(l);
        }, getPointFromXY: function(l, u, c) {
          let v = l.length, s;
          for (; v--; ) if (s = L(l[v].points || [], function(f) {
            return f.x === u && f.y === c;
          })) return s;
        }, getSeriesFirstPointElement: w, getSeriesFromName: function(l, u) {
          return u ? (l.series || []).filter(function(c) {
            return c.name === u;
          }) : l.series;
        }, getSeriesA11yElement: A, unhideChartElementFromAT: function l(u, c) {
          c.setAttribute("aria-hidden", !1), c !== u.renderTo && c.parentNode && c.parentNode !== R.body && (Array.prototype.forEach.call(c.parentNode.childNodes, function(v) {
            v.hasAttribute("aria-hidden") || v.setAttribute("aria-hidden", !0);
          }), l(u, c.parentNode));
        }, hideSeriesFromAT: function(l) {
          let u = A(l);
          u && u.setAttribute("aria-hidden", !0);
        }, scrollAxisToPoint: function(l) {
          let u = l.series.xAxis, c = l.series.yAxis, v = u && u.scrollbar ? u : c, s = v && v.scrollbar;
          if (s && O(s.to) && O(s.from)) {
            let f = s.to - s.from, y = function(h, a) {
              if (!O(h.dataMin) || !O(h.dataMax)) return 0;
              let x = h.toPixels(h.dataMin), S = h.toPixels(h.dataMax), E = h.coll === "xAxis" ? "x" : "y";
              return (h.toPixels(a[E] || 0) - x) / (S - x);
            }(v, l);
            s.updatePosition(y - f / 2, y + f / 2), M(s, "changed", { from: s.from, to: s.to, trigger: "scrollbar", DOMEvent: null });
          }
        } };
      }), Z(r, "Accessibility/Utils/DOMElementProvider.js", [r["Core/Globals.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B) {
        let { doc: I } = T, { removeElement: R } = B;
        return class {
          constructor() {
            this.elements = [];
          }
          createElement() {
            let z = I.createElement.apply(I, arguments);
            return this.elements.push(z), z;
          }
          removeElement(z) {
            R(z), this.elements.splice(this.elements.indexOf(z), 1);
          }
          destroyCreatedElements() {
            this.elements.forEach(function(z) {
              R(z);
            }), this.elements = [];
          }
        };
      }), Z(r, "Accessibility/Utils/EventProvider.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { addEvent: I } = B;
        return class {
          constructor() {
            this.eventRemovers = [];
          }
          addEvent() {
            let R = I.apply(T, arguments);
            return this.eventRemovers.push({ element: arguments[0], remover: R }), R;
          }
          removeEvent(R) {
            let z = this.eventRemovers.map((O) => O.remover).indexOf(R);
            this.eventRemovers[z].remover(), this.eventRemovers.splice(z, 1);
          }
          removeAddedEvents() {
            this.eventRemovers.map((R) => R.remover).forEach((R) => R()), this.eventRemovers = [];
          }
        };
      }), Z(r, "Accessibility/AccessibilityComponent.js", [r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/DOMElementProvider.js"], r["Accessibility/Utils/EventProvider.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R) {
        let { fireEventOnWrappedOrUnwrappedElement: z } = T, { getFakeMouseEvent: O } = R;
        return class {
          destroy() {
          }
          getKeyboardNavigation() {
            return [];
          }
          init() {
          }
          onChartRender() {
          }
          onChartUpdate() {
          }
          initBase(L, M) {
            this.chart = L, this.eventProvider = new I(), this.domElementProvider = new B(), this.proxyProvider = M, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
          }
          addEvent(L, M, w, A) {
            return this.eventProvider.addEvent(L, M, w, A);
          }
          createElement(L, M) {
            return this.domElementProvider.createElement(L, M);
          }
          fakeClickEvent(L) {
            z(L, O("click"));
          }
          destroyBase() {
            this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
          }
        };
      }), Z(r, "Accessibility/KeyboardNavigationHandler.js", [r["Core/Utilities.js"]], function(T) {
        let { find: B } = T;
        return class {
          constructor(I, R) {
            this.chart = I, this.keyCodeMap = R.keyCodeMap || [], this.validate = R.validate, this.init = R.init, this.terminate = R.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
          }
          run(I) {
            let R = I.which || I.keyCode, z = this.response.noHandler, O = B(this.keyCodeMap, function(L) {
              return L[0].indexOf(R) > -1;
            });
            return O ? z = O[1].call(this, R, I) : R === 9 && (z = this.response[I.shiftKey ? "prev" : "next"]), z;
          }
        };
      }), Z(r, "Accessibility/Components/ContainerComponent.js", [r["Accessibility/AccessibilityComponent.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Core/Globals.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R, z) {
        let { unhideChartElementFromAT: O, getChartTitle: L } = I, { doc: M } = R, { stripHTMLTagsFromString: w } = z;
        return class extends T {
          onChartUpdate() {
            this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
          }
          handleSVGTitleElement() {
            let A = this.chart, l = "highcharts-title-" + A.index, u = w(A.langFormat("accessibility.svgContainerTitle", { chartTitle: L(A) }));
            if (u.length) {
              let c = this.svgTitleElement = this.svgTitleElement || M.createElementNS("http://www.w3.org/2000/svg", "title");
              c.textContent = u, c.id = l, A.renderTo.insertBefore(c, A.renderTo.firstChild);
            }
          }
          setSVGContainerLabel() {
            let A = this.chart, l = A.langFormat("accessibility.svgContainerLabel", { chartTitle: L(A) });
            A.renderer.box && l.length && A.renderer.box.setAttribute("aria-label", l);
          }
          setGraphicContainerAttrs() {
            let A = this.chart, l = A.langFormat("accessibility.graphicContainerLabel", { chartTitle: L(A) });
            l.length && A.container.setAttribute("aria-label", l);
          }
          setRenderToAttrs() {
            let A = this.chart, l = A.options.accessibility.landmarkVerbosity !== "disabled", u = A.langFormat("accessibility.chartContainerLabel", { title: L(A), chart: A });
            u && (A.renderTo.setAttribute("role", l ? "region" : "group"), A.renderTo.setAttribute("aria-label", u));
          }
          makeCreditsAccessible() {
            let A = this.chart, l = A.credits;
            l && (l.textStr && l.element.setAttribute("aria-label", A.langFormat("accessibility.credits", { creditsStr: w(l.textStr, A.renderer.forExport) })), O(A, l.element));
          }
          getKeyboardNavigation() {
            let A = this.chart;
            return new B(A, { keyCodeMap: [], validate: function() {
              return !0;
            }, init: function() {
              let l = A.accessibility;
              l && l.keyboardNavigation.tabindexContainer.focus();
            } });
          }
          destroy() {
            this.chart.renderTo.setAttribute("aria-hidden", !0);
          }
        };
      }), Z(r, "Accessibility/FocusBorder.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, pick: R } = T;
        return function(z) {
          let O = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
          function L() {
            let l = this.focusElement, u = this.options.accessibility.keyboardNavigation.focusBorder;
            l && (l.removeFocusBorder(), u.enabled && l.addFocusBorder(u.margin, { stroke: u.style.color, strokeWidth: u.style.lineWidth, r: u.style.borderRadius }));
          }
          function M(l, u) {
            let c = this.options.accessibility.keyboardNavigation.focusBorder, v = u || l.element;
            v && v.focus && (v.hcEvents && v.hcEvents.focusin || I(v, "focusin", function() {
            }), v.focus(), c.hideBrowserFocusOutline && (v.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = l, this.renderFocusBorder();
          }
          function w(l, u) {
            this.focusBorder && this.removeFocusBorder();
            let c = this.getBBox(), v = R(l, 3), s = this.parentGroup, f = this.scaleX || s && s.scaleX, y = this.scaleY || s && s.scaleY, h = (f ? !y : y) ? Math.abs(f || y || 1) : (Math.abs(f || 1) + Math.abs(y || 1)) / 2;
            c.x += this.translateX ? this.translateX : 0, c.y += this.translateY ? this.translateY : 0;
            let a = c.x - v, x = c.y - v, S = c.width + 2 * v, E = c.height + 2 * v, b = !!this.text;
            if (this.element.nodeName === "text" || b) {
              let p, C, o = !!this.rotation, t = b ? { x: o ? 1 : 0, y: 0 } : (p = 0, C = 0, this.attr("text-anchor") === "middle" ? p = C = 0.5 : this.rotation ? p = 0.25 : C = 0.75, { x: p, y: C }), e = +this.attr("x"), n = +this.attr("y");
              if (isNaN(e) || (a = e - c.width * t.x - v), isNaN(n) || (x = n - c.height * t.y - v), b && o) {
                let d = S;
                S = E, E = d, isNaN(e) || (a = e - c.height * t.x - v), isNaN(n) || (x = n - c.width * t.y - v);
              }
            }
            this.focusBorder = this.renderer.rect(a, x, S, E, parseInt((u && u.r || 0).toString(), 10) / h).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(s), this.renderer.styledMode || this.focusBorder.attr({ stroke: u && u.stroke, "stroke-width": (u && u.strokeWidth || 0) / h }), function(p, ...C) {
              p.focusBorderUpdateHooks || (p.focusBorderUpdateHooks = {}, O.forEach((o) => {
                let t = o + "Setter", e = p[t] || p._defaultSetter;
                p.focusBorderUpdateHooks[t] = e, p[t] = function() {
                  let n = e.apply(p, arguments);
                  return p.addFocusBorder.apply(p, C), n;
                };
              }));
            }(this, l, u), function(p) {
              if (p.focusBorderDestroyHook) return;
              let C = p.destroy;
              p.destroy = function() {
                return p.focusBorder && p.focusBorder.destroy && p.focusBorder.destroy(), C.apply(p, arguments);
              }, p.focusBorderDestroyHook = C;
            }(this);
          }
          function A() {
            var l;
            l = this, l.focusBorderUpdateHooks && (Object.keys(l.focusBorderUpdateHooks).forEach((u) => {
              let c = l.focusBorderUpdateHooks[u];
              c === l._defaultSetter ? delete l[u] : l[u] = c;
            }), delete l.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
          }
          z.compose = function(l, u) {
            let c = l.prototype, v = u.prototype;
            c.renderFocusBorder || (c.renderFocusBorder = L, c.setFocusToElement = M), v.addFocusBorder || (v.addFocusBorder = w, v.removeFocusBorder = A);
          };
        }(B || (B = {})), B;
      }), Z(r, "Accessibility/Utils/Announcer.js", [r["Core/Renderer/HTML/AST.js"], r["Accessibility/Utils/DOMElementProvider.js"], r["Core/Globals.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { doc: O } = I, { addClass: L, visuallyHideElement: M } = R, { attr: w } = z;
        return class {
          constructor(A, l) {
            this.chart = A, this.domElementProvider = new B(), this.announceRegion = this.addAnnounceRegion(l);
          }
          destroy() {
            this.domElementProvider.destroyCreatedElements();
          }
          announce(A) {
            T.setElementHTML(this.announceRegion, A), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
              this.announceRegion.innerHTML = T.emptyHTML, delete this.clearAnnouncementRegionTimer;
            }, 3e3);
          }
          addAnnounceRegion(A) {
            let l = this.chart.announcerContainer || this.createAnnouncerContainer(), u = this.domElementProvider.createElement("div");
            return w(u, { "aria-hidden": !1, "aria-live": A, "aria-atomic": !0 }), this.chart.styledMode ? L(u, "highcharts-visually-hidden") : M(u), l.appendChild(u), u;
          }
          createAnnouncerContainer() {
            let A = this.chart, l = O.createElement("div");
            return w(l, { "aria-hidden": !1, class: "highcharts-announcer-container" }), l.style.position = "relative", A.renderTo.insertBefore(l, A.renderTo.firstChild), A.announcerContainer = l, l;
          }
        };
      }), Z(r, "Accessibility/Components/AnnotationsA11y.js", [r["Accessibility/Utils/HTMLUtilities.js"]], function(T) {
        let { escapeStringForHTML: B, stripHTMLTagsFromString: I } = T;
        function R(M) {
          return (M.annotations || []).reduce((w, A) => (A.options && A.options.visible !== !1 && (w = w.concat(A.labels)), w), []);
        }
        function z(M) {
          return M.options && M.options.accessibility && M.options.accessibility.description || M.graphic && M.graphic.text && M.graphic.text.textStr || "";
        }
        function O(M) {
          let w = M.options && M.options.accessibility && M.options.accessibility.description;
          if (w) return w;
          let A = M.chart, l = z(M), u = M.points, c = (h) => h.graphic && h.graphic.element && h.graphic.element.getAttribute("aria-label") || "", v = u.filter((h) => !!h.graphic).map((h) => {
            let a = h.accessibility && h.accessibility.valueDescription || c(h), x = h && h.series.name || "";
            return (x ? x + ", " : "") + "data point " + a;
          }).filter((h) => !!h), s = v.length, f = s > 1 ? "MultiplePoints" : s ? "SinglePoint" : "NoPoints", y = { annotationText: l, annotation: M, numPoints: s, annotationPoint: v[0], additionalAnnotationPoints: v.slice(1) };
          return A.langFormat("accessibility.screenReaderSection.annotations.description" + f, y);
        }
        function L(M) {
          return R(M).map((w) => {
            let A = B(I(O(w), M.renderer.forExport));
            return A ? `<li>${A}</li>` : "";
          });
        }
        return { getAnnotationsInfoHTML: function(M) {
          let w = M.annotations;
          return w && w.length ? `<ul style="list-style-type: none">${L(M).join(" ")}</ul>` : "";
        }, getAnnotationLabelDescription: O, getAnnotationListItems: L, getPointAnnotationTexts: function(M) {
          let w = R(M.series.chart).filter((A) => A.points.indexOf(M) > -1);
          return w.length ? w.map((A) => `${z(A)}`) : [];
        } };
      }), Z(r, "Accessibility/Components/InfoRegionsComponent.js", [r["Accessibility/A11yI18n.js"], r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/Announcer.js"], r["Accessibility/Components/AnnotationsA11y.js"], r["Core/Renderer/HTML/AST.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A) {
        let { getAnnotationsInfoHTML: l } = R, { getAxisDescription: u, getAxisRangeDescription: c, getChartTitle: v, unhideChartElementFromAT: s } = O, { format: f } = L, { doc: y } = M, { addClass: h, getElement: a, getHeadingTagNameForElement: x, stripHTMLTagsFromString: S, visuallyHideElement: E } = w, { attr: b, pick: p, replaceNested: C } = A;
        function o(t) {
          return C(t, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
        }
        return class extends B {
          constructor() {
            super(...arguments), this.screenReaderSections = {};
          }
          init() {
            let t = this.chart, e = this;
            this.initRegionsDefinitions(), this.addEvent(t, "aftergetTableAST", function(n) {
              e.onDataTableCreated(n);
            }), this.addEvent(t, "afterViewData", function(n) {
              n.wasHidden && (e.dataTableDiv = n.element, setTimeout(function() {
                e.focusDataTable();
              }, 300));
            }), this.addEvent(t, "afterHideData", function() {
              e.viewDataTableButton && e.viewDataTableButton.setAttribute("aria-expanded", "false");
            }), t.exporting && this.addEvent(t, "afterPrint", function() {
              e.updateAllScreenReaderSections();
            }), this.announcer = new I(t, "assertive");
          }
          initRegionsDefinitions() {
            let t = this, e = this.chart.options.accessibility;
            this.screenReaderSections = { before: { element: null, buildContent: function(n) {
              let d = e.screenReaderSection.beforeChartFormatter;
              return d ? d(n) : t.defaultBeforeChartFormatter(n);
            }, insertIntoDOM: function(n, d) {
              d.renderTo.insertBefore(n, d.renderTo.firstChild);
            }, afterInserted: function() {
              t.sonifyButtonId !== void 0 && t.initSonifyButton(t.sonifyButtonId), t.dataTableButtonId !== void 0 && t.initDataTableButton(t.dataTableButtonId);
            } }, after: { element: null, buildContent: function(n) {
              let d = e.screenReaderSection.afterChartFormatter;
              return d ? d(n) : t.defaultAfterChartFormatter();
            }, insertIntoDOM: function(n, d) {
              d.renderTo.insertBefore(n, d.container.nextSibling);
            }, afterInserted: function() {
              t.chart.accessibility && e.keyboardNavigation.enabled && t.chart.accessibility.keyboardNavigation.updateExitAnchor();
            } } };
          }
          onChartRender() {
            this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
          }
          updateAllScreenReaderSections() {
            let t = this;
            Object.keys(this.screenReaderSections).forEach(function(e) {
              t.updateScreenReaderSection(e);
            });
          }
          getLinkedDescriptionElement() {
            let t = this.chart.options.accessibility.linkedDescription;
            if (!t) return;
            if (typeof t != "string") return t;
            let e = f(t, this.chart), n = y.querySelectorAll(e);
            if (n.length === 1) return n[0];
          }
          setLinkedDescriptionAttrs() {
            let t = this.linkedDescriptionElement;
            t && (t.setAttribute("aria-hidden", "true"), h(t, "highcharts-linked-description"));
          }
          updateScreenReaderSection(t) {
            let e = this.chart, n = this.screenReaderSections[t], d = n.buildContent(e), i = n.element = n.element || this.createElement("div"), g = i.firstChild || this.createElement("div");
            d ? (this.setScreenReaderSectionAttribs(i, t), z.setElementHTML(g, d), i.appendChild(g), n.insertIntoDOM(i, e), e.styledMode ? h(g, "highcharts-visually-hidden") : E(g), s(e, g), n.afterInserted && n.afterInserted()) : (i.parentNode && i.parentNode.removeChild(i), n.element = null);
          }
          setScreenReaderSectionAttribs(t, e) {
            let n = this.chart, d = n.langFormat("accessibility.screenReaderSection." + e + "RegionLabel", { chart: n, chartTitle: v(n) });
            b(t, { id: `highcharts-screen-reader-region-${e}-${n.index}`, "aria-label": d || void 0 }), t.style.position = "relative", d && t.setAttribute("role", n.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
          }
          defaultBeforeChartFormatter() {
            let t = this.chart, e = t.options.accessibility.screenReaderSection.beforeChartFormat;
            if (!e) return "";
            let n = this.getAxesDescription(), d = t.sonify && t.options.sonification && t.options.sonification.enabled, i = "highcharts-a11y-sonify-data-btn-" + t.index, g = "hc-linkto-highcharts-data-table-" + t.index, m = l(t), k = t.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: t }), j = { headingTagName: x(t.renderTo), chartTitle: v(t), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: n.xAxis, yAxisDescription: n.yAxis, playAsSoundButton: d ? this.getSonifyButtonText(i) : "", viewTableButton: t.getCSV ? this.getDataTableButtonText(g) : "", annotationsTitle: m ? k : "", annotationsList: m }, P = T.i18nFormat(e, j, t);
            return this.dataTableButtonId = g, this.sonifyButtonId = i, o(P);
          }
          defaultAfterChartFormatter() {
            let t = this.chart, e = t.options.accessibility.screenReaderSection.afterChartFormat;
            if (!e) return "";
            let n = { endOfChartMarker: this.getEndOfChartMarkerText() };
            return o(T.i18nFormat(e, n, t));
          }
          getLinkedDescription() {
            let t = this.linkedDescriptionElement;
            return S(t && t.innerHTML || "", this.chart.renderer.forExport);
          }
          getLongdescText() {
            let t = this.chart.options, e = t.caption, n = e && e.text, d = this.getLinkedDescription();
            return t.accessibility.description || d || n || "";
          }
          getTypeDescriptionText() {
            let t = this.chart;
            return t.types ? t.options.accessibility.typeDescription || function(e, n) {
              let d = n[0], i = e.series && e.series[0] || {}, g = e.mapView && e.mapView.geoMap && e.mapView.geoMap.title, m = { numSeries: e.series.length, numPoints: i.points && i.points.length, chart: e, mapTitle: g };
              return d ? d === "map" || d === "tiledwebmap" ? m.mapTitle ? e.langFormat("accessibility.chartTypes.mapTypeDescription", m) : e.langFormat("accessibility.chartTypes.unknownMap", m) : e.types.length > 1 ? e.langFormat("accessibility.chartTypes.combinationChart", m) : function(k, j, P) {
                let D = j[0], H = k.langFormat("accessibility.seriesTypeDescriptions." + D, P), G = k.series && k.series.length < 2 ? "Single" : "Multiple";
                return (k.langFormat("accessibility.chartTypes." + D + G, P) || k.langFormat("accessibility.chartTypes.default" + G, P)) + (H ? " " + H : "");
              }(e, n, m) : e.langFormat("accessibility.chartTypes.emptyChart", m);
            }(t, t.types) : "";
          }
          getDataTableButtonText(t) {
            let e = this.chart;
            return '<button id="' + t + '">' + e.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: e, chartTitle: v(e) }) + "</button>";
          }
          getSonifyButtonText(t) {
            let e = this.chart;
            return e.options.sonification && e.options.sonification.enabled === !1 ? "" : '<button id="' + t + '">' + e.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: e, chartTitle: v(e) }) + "</button>";
          }
          getSubtitleText() {
            let t = this.chart.options.subtitle;
            return S(t && t.text || "", this.chart.renderer.forExport);
          }
          getEndOfChartMarkerText() {
            let t = a(`highcharts-end-of-chart-marker-${this.chart.index}`);
            if (t) return t.outerHTML;
            let e = this.chart, n = e.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: e });
            return '<div id="highcharts-end-of-chart-marker-' + e.index + '">' + n + "</div>";
          }
          onDataTableCreated(t) {
            let e = this.chart;
            if (e.options.accessibility.enabled) {
              this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
              let n = t.tree.attributes || {};
              n.tabindex = -1, n.summary = e.langFormat("accessibility.table.tableSummary", { chart: e }), t.tree.attributes = n;
            }
          }
          focusDataTable() {
            let t = this.dataTableDiv, e = t && t.getElementsByTagName("table")[0];
            e && e.focus && e.focus();
          }
          initSonifyButton(t) {
            let e = this.sonifyButton = a(t), n = this.chart, d = (i) => {
              e && (e.setAttribute("aria-hidden", "true"), e.setAttribute("aria-label", "")), i.preventDefault(), i.stopPropagation();
              let g = n.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: n });
              this.announcer.announce(g), setTimeout(() => {
                e && (e.removeAttribute("aria-hidden"), e.removeAttribute("aria-label")), n.sonify && n.sonify();
              }, 1e3);
            };
            e && n && (e.setAttribute("tabindex", -1), e.onclick = function(i) {
              (n.options.accessibility && n.options.accessibility.screenReaderSection.onPlayAsSoundClick || d).call(this, i, n);
            });
          }
          initDataTableButton(t) {
            let e = this.viewDataTableButton = a(t), n = this.chart, d = t.replace("hc-linkto-", "");
            e && (b(e, { tabindex: -1, "aria-expanded": !!a(d) }), e.onclick = n.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
              n.viewData();
            });
          }
          getAxesDescription() {
            let t = this.chart, e = function(k, j) {
              let P = t[k];
              return P.length > 1 || P[0] && p(P[0].options.accessibility && P[0].options.accessibility.enabled, j);
            }, n = !!t.types && 0 > t.types.indexOf("map") && 0 > t.types.indexOf("treemap") && 0 > t.types.indexOf("tilemap"), d = !!t.hasCartesianSeries, i = e("xAxis", !t.angular && d && n), g = e("yAxis", d && n), m = {};
            return i && (m.xAxis = this.getAxisDescriptionText("xAxis")), g && (m.yAxis = this.getAxisDescriptionText("yAxis")), m;
          }
          getAxisDescriptionText(t) {
            let e = this.chart, n = e[t];
            return e.langFormat("accessibility.axis." + t + "Description" + (n.length > 1 ? "Plural" : "Singular"), { chart: e, names: n.map(function(d) {
              return u(d);
            }), ranges: n.map(function(d) {
              return c(d);
            }), numAxes: n.length });
          }
          destroy() {
            this.announcer && this.announcer.destroy();
          }
        };
      }), Z(r, "Accessibility/Components/MenuComponent.js", [r["Core/Utilities.js"], r["Accessibility/AccessibilityComponent.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R, z) {
        let { attr: O } = T, { getChartTitle: L, unhideChartElementFromAT: M } = R, { getFakeMouseEvent: w } = z;
        function A(u) {
          return u.exportSVGElements && u.exportSVGElements[0];
        }
        class l extends B {
          init() {
            let c = this.chart, v = this;
            this.addEvent(c, "exportMenuShown", function() {
              v.onMenuShown();
            }), this.addEvent(c, "exportMenuHidden", function() {
              v.onMenuHidden();
            }), this.createProxyGroup();
          }
          onMenuHidden() {
            let c = this.chart.exportContextMenu;
            c && c.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
          }
          onMenuShown() {
            let c = this.chart, v = c.exportContextMenu;
            v && (this.addAccessibleContextMenuAttribs(), M(c, v)), this.setExportButtonExpandedState("true");
          }
          setExportButtonExpandedState(c) {
            this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", c);
          }
          onChartRender() {
            let c = this.chart, v = c.focusElement, s = c.accessibility;
            this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && v && v === c.exportingGroup && (v.focusBorder ? c.setFocusToElement(v, this.exportButtonProxy.innerElement) : s && s.keyboardNavigation.tabindexContainer.focus());
          }
          proxyMenuButton() {
            let c = this.chart, v = this.proxyProvider, s = A(c);
            (function(f) {
              let y = f.options.exporting, h = A(f);
              return !!(y && y.enabled !== !1 && y.accessibility && y.accessibility.enabled && h && h.element);
            })(c) && s && (this.exportButtonProxy = v.addProxyElement("chartMenu", { click: s }, "button", { "aria-label": c.langFormat("accessibility.exporting.menuButtonLabel", { chart: c, chartTitle: L(c) }), "aria-expanded": !1, title: c.options.lang.contextButtonTitle || null }));
          }
          createProxyGroup() {
            this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
          }
          addAccessibleContextMenuAttribs() {
            let c = this.chart, v = c.exportDivElements;
            if (v && v.length) {
              v.forEach((f) => {
                f && (f.tagName !== "LI" || f.children && f.children.length ? f.setAttribute("aria-hidden", "true") : f.setAttribute("tabindex", -1));
              });
              let s = v[0] && v[0].parentNode;
              s && O(s, { "aria-hidden": void 0, "aria-label": c.langFormat("accessibility.exporting.chartMenuLabel", { chart: c }), role: "list" });
            }
          }
          getKeyboardNavigation() {
            let c = this.keyCodes, v = this.chart, s = this;
            return new I(v, { keyCodeMap: [[[c.left, c.up], function() {
              return s.onKbdPrevious(this);
            }], [[c.right, c.down], function() {
              return s.onKbdNext(this);
            }], [[c.enter, c.space], function() {
              return s.onKbdClick(this);
            }]], validate: function() {
              return !!v.exporting && v.options.exporting.enabled !== !1 && v.options.exporting.accessibility.enabled !== !1;
            }, init: function() {
              let f = s.exportButtonProxy, y = s.chart.exportingGroup;
              f && y && v.setFocusToElement(y, f.innerElement);
            }, terminate: function() {
              v.hideExportMenu();
            } });
          }
          onKbdPrevious(c) {
            let v = this.chart, s = v.options.accessibility, f = c.response, y = v.highlightedExportItemIx || 0;
            for (; y--; ) if (v.highlightExportItem(y)) return f.success;
            return s.keyboardNavigation.wrapAround ? (v.highlightLastExportItem(), f.success) : f.prev;
          }
          onKbdNext(c) {
            let v = this.chart, s = v.options.accessibility, f = c.response;
            for (let y = (v.highlightedExportItemIx || 0) + 1; y < v.exportDivElements.length; ++y) if (v.highlightExportItem(y)) return f.success;
            return s.keyboardNavigation.wrapAround ? (v.highlightExportItem(0), f.success) : f.next;
          }
          onKbdClick(c) {
            let v = this.chart, s = v.exportDivElements[v.highlightedExportItemIx], f = A(v).element;
            return v.openMenu ? this.fakeClickEvent(s) : (this.fakeClickEvent(f), v.highlightExportItem(0)), c.response.success;
          }
        }
        return function(u) {
          function c() {
            let y = A(this);
            if (y) {
              let h = y.element;
              h.onclick && h.onclick(w("click"));
            }
          }
          function v() {
            let y = this.exportDivElements;
            y && this.exportContextMenu && this.openMenu && (y.forEach((h) => {
              h && h.className === "highcharts-menu-item" && h.onmouseout && h.onmouseout(w("mouseout"));
            }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
          }
          function s(y) {
            let h = this.exportDivElements && this.exportDivElements[y], a = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
            if (h && h.tagName === "LI" && !(h.children && h.children.length)) {
              let x = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
              return h.focus && x && h.focus(), a && a.onmouseout && a.onmouseout(w("mouseout")), h.onmouseover && h.onmouseover(w("mouseover")), this.highlightedExportItemIx = y, !0;
            }
            return !1;
          }
          function f() {
            if (this.exportDivElements) {
              let y = this.exportDivElements.length;
              for (; y--; ) if (this.highlightExportItem(y)) return !0;
            }
            return !1;
          }
          u.compose = function(y) {
            let h = y.prototype;
            h.hideExportMenu || (h.hideExportMenu = v, h.highlightExportItem = s, h.highlightLastExportItem = f, h.showExportMenu = c);
          };
        }(l), l;
      }), Z(r, "Accessibility/KeyboardNavigation.js", [r["Core/Globals.js"], r["Accessibility/Components/MenuComponent.js"], r["Core/Utilities.js"], r["Accessibility/Utils/EventProvider.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R, z) {
        let { doc: O, win: L } = T, { addEvent: M, defined: w, fireEvent: A } = I, { getElement: l, simulatedEventTarget: u } = z;
        class c {
          constructor(s, f) {
            this.currentModuleIx = NaN, this.modules = [], this.init(s, f);
          }
          init(s, f) {
            let y = this.eventProvider = new R();
            this.chart = s, this.components = f, this.modules = [], this.currentModuleIx = 0, this.update(), y.addEvent(this.tabindexContainer, "keydown", (h) => this.onKeydown(h)), y.addEvent(this.tabindexContainer, "focus", (h) => this.onFocus(h)), ["mouseup", "touchend"].forEach((h) => y.addEvent(O, h, (a) => this.onMouseUp(a))), ["mousedown", "touchstart"].forEach((h) => y.addEvent(s.renderTo, h, () => {
              this.isClickingChart = !0;
            }));
          }
          update(s) {
            let f = this.chart.options.accessibility, y = f && f.keyboardNavigation, h = this.components;
            this.updateContainerTabindex(), y && y.enabled && s && s.length ? (this.modules = s.reduce(function(a, x) {
              let S = h[x].getKeyboardNavigation();
              return a.concat(S);
            }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
          }
          updateExitAnchor() {
            let s = l(`highcharts-end-of-chart-marker-${this.chart.index}`);
            this.removeExitAnchor(), s ? (this.makeElementAnExitAnchor(s), this.exitAnchor = s) : this.createExitAnchor();
          }
          move(s) {
            let f = this.modules && this.modules[this.currentModuleIx];
            f && f.terminate && f.terminate(s), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += s;
            let y = this.modules && this.modules[this.currentModuleIx];
            if (y) {
              if (y.validate && !y.validate()) return this.move(s);
              if (y.init) return y.init(s), !0;
            }
            return this.currentModuleIx = 0, this.exiting = !0, s > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
          }
          onFocus(s) {
            let f = this.chart, y = s.relatedTarget && f.container.contains(s.relatedTarget), h = f.options.accessibility, a = h && h.keyboardNavigation;
            if (a && a.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !y) {
              let x = this.getFirstValidModuleIx();
              x !== null && (this.currentModuleIx = x, this.modules[x].init(1));
            }
            this.keyboardReset = !1, this.exiting = !1;
          }
          onMouseUp(s) {
            if (delete this.isClickingChart, !this.keyboardReset && s.relatedTarget !== u) {
              let f = this.chart;
              if (!s.target || !f.container.contains(s.target)) {
                let y = this.modules && this.modules[this.currentModuleIx || 0];
                y && y.terminate && y.terminate(), this.currentModuleIx = 0;
              }
              f.focusElement && (f.focusElement.removeFocusBorder(), delete f.focusElement), this.keyboardReset = !0;
            }
          }
          onKeydown(s) {
            let f, y = s || L.event, h = this.modules && this.modules.length && this.modules[this.currentModuleIx], a = y.target;
            if ((!a || a.nodeName !== "INPUT" || a.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, h)) {
              let x = h.run(y);
              x === h.response.success ? f = !0 : x === h.response.prev ? f = this.move(-1) : x === h.response.next && (f = this.move(1)), f && (y.preventDefault(), y.stopPropagation());
            }
          }
          updateContainerTabindex() {
            let s, f = this.chart.options.accessibility, y = f && f.keyboardNavigation, h = !(y && y.enabled === !1), a = this.chart, x = a.container;
            a.renderTo.hasAttribute("tabindex") ? (x.removeAttribute("tabindex"), s = a.renderTo) : s = x, this.tabindexContainer = s;
            let S = s.getAttribute("tabindex");
            h && !S ? s.setAttribute("tabindex", "0") : h || a.container.removeAttribute("tabindex");
          }
          createExitAnchor() {
            let s = this.chart, f = this.exitAnchor = O.createElement("div");
            s.renderTo.appendChild(f), this.makeElementAnExitAnchor(f);
          }
          makeElementAnExitAnchor(s) {
            let f = this.tabindexContainer.getAttribute("tabindex") || 0;
            s.setAttribute("class", "highcharts-exit-anchor"), s.setAttribute("tabindex", f), s.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(s);
          }
          removeExitAnchor() {
            if (this.exitAnchor) {
              let s = this.eventProvider.eventRemovers.find((f) => f.element === this.exitAnchor);
              s && w(s.remover) && this.eventProvider.removeEvent(s.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
            }
          }
          addExitAnchorEventsToEl(s) {
            let f = this.chart, y = this;
            this.eventProvider.addEvent(s, "focus", function(h) {
              let a = h || L.event, x = !(a.relatedTarget && f.container.contains(a.relatedTarget) || y.exiting);
              if (f.focusElement && delete f.focusElement, x) {
                if (y.tabbingInBackwards = !0, y.tabindexContainer.focus(), delete y.tabbingInBackwards, a.preventDefault(), y.modules && y.modules.length) {
                  y.currentModuleIx = y.modules.length - 1;
                  let S = y.modules[y.currentModuleIx];
                  S && S.validate && !S.validate() ? y.move(-1) : S && S.init(-1);
                }
              } else y.exiting = !1;
            });
          }
          getFirstValidModuleIx() {
            let s = this.modules.length;
            for (let f = 0; f < s; ++f) {
              let y = this.modules[f];
              if (!y.validate || y.validate()) return f;
            }
            return null;
          }
          destroy() {
            this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
          }
        }
        return function(v) {
          function s() {
            let y = this;
            A(this, "dismissPopupContent", {}, function() {
              y.tooltip && y.tooltip.hide(0), y.hideExportMenu();
            });
          }
          function f(y) {
            (y.which || y.keyCode) === 27 && T.charts && T.charts.forEach((h) => {
              h && h.dismissPopupContent && h.dismissPopupContent();
            });
          }
          v.compose = function(y) {
            B.compose(y);
            let h = y.prototype;
            return h.dismissPopupContent || (h.dismissPopupContent = s, M(O, "keydown", f)), y;
          };
        }(c), c;
      }), Z(r, "Accessibility/Components/LegendComponent.js", [r["Core/Animation/AnimationUtilities.js"], r["Core/Globals.js"], r["Core/Legend/Legend.js"], r["Core/Utilities.js"], r["Accessibility/AccessibilityComponent.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { animObject: w } = T, { doc: A } = B, { addEvent: l, fireEvent: u, isNumber: c, pick: v, syncTimeout: s } = R, { getChartTitle: f } = L, { stripHTMLTagsFromString: y, addClass: h, removeClass: a } = M;
        function x(b) {
          let p = b.legend && b.legend.allItems, C = b.options.legend.accessibility || {}, o = b.colorAxis && b.colorAxis.some((t) => !t.dataClasses || !t.dataClasses.length);
          return !!(p && p.length && !o && C.enabled !== !1);
        }
        function S(b, p) {
          let C = p.legendItem || {};
          for (let o of (p.setState(b ? "hover" : "", !0), ["group", "label", "symbol"])) {
            let t = C[o], e = t && t.element || t;
            e && u(e, b ? "mouseover" : "mouseout");
          }
        }
        class E extends z {
          constructor() {
            super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
          }
          init() {
            let p = this;
            this.recreateProxies(), this.addEvent(I, "afterScroll", function() {
              this.chart === p.chart && (p.proxyProvider.updateGroupProxyElementPositions("legend"), p.updateLegendItemProxyVisibility(), p.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(p.highlightedLegendItemIx));
            }), this.addEvent(I, "afterPositionItem", function(C) {
              this.chart === p.chart && this.chart.renderer && p.updateProxyPositionForItem(C.item);
            }), this.addEvent(I, "afterRender", function() {
              this.chart === p.chart && this.chart.renderer && p.recreateProxies() && s(() => p.proxyProvider.updateGroupProxyElementPositions("legend"), w(v(this.chart.renderer.globalAnimation, !0)).duration);
            });
          }
          updateLegendItemProxyVisibility() {
            let p, C = this.chart, o = C.legend, t = o.allItems || [], e = o.currentPage || 1, n = o.clipHeight || 0;
            t.forEach((d) => {
              if (d.a11yProxyElement) {
                let i = o.pages && o.pages.length, g = d.a11yProxyElement.element, m = !1;
                if (p = d.legendItem || {}, i) {
                  let k = p.pageIx || 0;
                  m = (p.y || 0) + (p.label ? Math.round(p.label.getBBox().height) : 0) - o.pages[k] > n || k !== e - 1;
                }
                m ? C.styledMode ? h(g, "highcharts-a11y-invisible") : g.style.visibility = "hidden" : (a(g, "highcharts-a11y-invisible"), g.style.visibility = "");
              }
            });
          }
          onChartRender() {
            x(this.chart) || this.removeProxies();
          }
          highlightAdjacentLegendPage(p) {
            let C = this.chart, o = C.legend, t = (o.currentPage || 1) + p, e = o.pages || [];
            if (t > 0 && t <= e.length) {
              let n = 0;
              for (let d of o.allItems) ((d.legendItem || {}).pageIx || 0) + 1 === t && C.highlightLegendItem(n) && (this.highlightedLegendItemIx = n), ++n;
            }
          }
          updateProxyPositionForItem(p) {
            p.a11yProxyElement && p.a11yProxyElement.refreshPosition();
          }
          recreateProxies() {
            let p = A.activeElement, C = this.proxyGroup, o = p && C && C.contains(p);
            return this.removeProxies(), !!x(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), o && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
          }
          removeProxies() {
            this.proxyProvider.removeGroup("legend");
          }
          updateLegendTitle() {
            let p = this.chart, C = y((p.legend && p.legend.options.title && p.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), p.renderer.forExport), o = p.langFormat("accessibility.legend.legendLabel" + (C ? "" : "NoTitle"), { chart: p, legendTitle: C, chartTitle: f(p) });
            this.proxyProvider.updateGroupAttrs("legend", { "aria-label": o });
          }
          addLegendProxyGroup() {
            let p = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
            this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: p });
          }
          proxyLegendItems() {
            let p, C = this;
            ((this.chart.legend || {}).allItems || []).forEach((o) => {
              (p = o.legendItem || {}).label && p.label.element && C.proxyLegendItem(o);
            });
          }
          proxyLegendItem(p) {
            let C = p.legendItem || {};
            if (!C.label || !C.group) return;
            let o = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: y(p.name, this.chart.renderer.forExport), item: p }), t = { tabindex: -1, "aria-pressed": p.visible, "aria-label": o }, e = C.group.div ? C.label : C.group;
            p.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: C.label, visual: e.element }, "button", t);
          }
          getKeyboardNavigation() {
            let p = this.keyCodes, C = this, o = this.chart;
            return new O(o, { keyCodeMap: [[[p.left, p.right, p.up, p.down], function(t) {
              return C.onKbdArrowKey(this, t);
            }], [[p.enter, p.space], function() {
              return C.onKbdClick(this);
            }], [[p.pageDown, p.pageUp], function(t) {
              let e = t === p.pageDown ? 1 : -1;
              return C.highlightAdjacentLegendPage(e), this.response.success;
            }]], validate: function() {
              return C.shouldHaveLegendNavigation();
            }, init: function() {
              o.highlightLegendItem(0), C.highlightedLegendItemIx = 0;
            }, terminate: function() {
              C.highlightedLegendItemIx = -1, o.legend.allItems.forEach((t) => S(!1, t));
            } });
          }
          onKbdArrowKey(p, C) {
            let { keyCodes: { left: o, up: t }, highlightedLegendItemIx: e, chart: n } = this, d = n.legend.allItems.length, i = n.options.accessibility.keyboardNavigation.wrapAround, g = C === o || C === t ? -1 : 1;
            return n.highlightLegendItem(e + g) ? this.highlightedLegendItemIx += g : i && d > 1 && (this.highlightedLegendItemIx = g > 0 ? 0 : d - 1, n.highlightLegendItem(this.highlightedLegendItemIx)), p.response.success;
          }
          onKbdClick(p) {
            let C = this.chart.legend.allItems[this.highlightedLegendItemIx];
            return C && C.a11yProxyElement && C.a11yProxyElement.click(), p.response.success;
          }
          shouldHaveLegendNavigation() {
            if (!x(this.chart)) return !1;
            let p = this.chart, C = (p.options.legend || {}).accessibility || {};
            return !!(p.legend.display && C.keyboardNavigation && C.keyboardNavigation.enabled);
          }
          destroy() {
            this.removeProxies();
          }
        }
        return function(b) {
          function p(o) {
            let t = this.legend.allItems, e = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, n = t[o], d = (n == null ? void 0 : n.legendItem) || {};
            if (n) {
              c(e) && t[e] && S(!1, t[e]), function(m, k) {
                let j = (m.allItems[k].legendItem || {}).pageIx, P = m.currentPage;
                j !== void 0 && j + 1 !== P && m.scroll(1 + j - P);
              }(this.legend, o);
              let i = d.label, g = n.a11yProxyElement && n.a11yProxyElement.innerElement;
              return i && i.element && g && this.setFocusToElement(i, g), S(!0, n), !0;
            }
            return !1;
          }
          function C(o) {
            let t = this.chart.options.accessibility, e = o.item;
            t.enabled && e && e.a11yProxyElement && e.a11yProxyElement.innerElement.setAttribute("aria-pressed", o.visible ? "true" : "false");
          }
          b.compose = function(o, t) {
            let e = o.prototype;
            e.highlightLegendItem || (e.highlightLegendItem = p, l(t, "afterColorizeItem", C));
          };
        }(E), E;
      }), Z(r, "Stock/Navigator/ChartNavigatorComposition.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let I, { isTouchDevice: R } = T, { addEvent: z, merge: O, pick: L } = B, M = [];
        function w() {
          this.navigator && this.navigator.setBaseSeries(null, !1);
        }
        function A() {
          var S;
          let f, y, h, a = this.legend, x = this.navigator;
          if (x) {
            f = a && a.options, y = x.xAxis, h = x.yAxis;
            let { scrollbarHeight: E, scrollButtonSize: b } = x;
            this.inverted ? (x.left = x.opposite ? this.chartWidth - E - x.height : this.spacing[3] + E, x.top = this.plotTop + b) : (x.left = L(y.left, this.plotLeft + b), x.top = x.navigatorOptions.top || this.chartHeight - x.height - E - (((S = this.scrollbar) == null ? void 0 : S.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (f && f.verticalAlign === "bottom" && f.layout !== "proximate" && f.enabled && !f.floating ? a.legendHeight + L(f.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), y && h && (this.inverted ? y.options.left = h.options.left = x.left : y.options.top = h.options.top = x.top, y.setAxisSize(), h.setAxisSize());
          }
        }
        function l(f) {
          !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new I(this), L(f.redraw, !0) && this.redraw(f.animation));
        }
        function u() {
          let f = this.options;
          (f.navigator.enabled || f.scrollbar.enabled) && (this.scroller = this.navigator = new I(this));
        }
        function c() {
          let f = this.options, y = f.navigator, h = f.rangeSelector;
          if ((y && y.enabled || h && h.enabled) && (!R && this.zooming.type === "x" || R && this.zooming.pinchType === "x")) return !1;
        }
        function v(f) {
          let y = f.navigator;
          if (y && f.xAxis[0]) {
            let h = f.xAxis[0].getExtremes();
            y.render(h.min, h.max);
          }
        }
        function s(f) {
          let y = f.options.navigator || {}, h = f.options.scrollbar || {};
          !this.navigator && !this.scroller && (y.enabled || h.enabled) && (O(!0, this.options.navigator, y), O(!0, this.options.scrollbar, h), delete f.options.navigator, delete f.options.scrollbar);
        }
        return { compose: function(f, y) {
          if (B.pushUnique(M, f)) {
            let h = f.prototype;
            I = y, h.callbacks.push(v), z(f, "afterAddSeries", w), z(f, "afterSetChartSize", A), z(f, "afterUpdate", l), z(f, "beforeRender", u), z(f, "beforeShowResetZoom", c), z(f, "update", s);
          }
        } };
      }), Z(r, "Core/Axis/NavigatorAxisComposition.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { isTouchDevice: I } = T, { addEvent: R, correctFloat: z, defined: O, isNumber: L, pick: M } = B;
        function w() {
          this.navigatorAxis || (this.navigatorAxis = new l(this));
        }
        function A(u) {
          let c, v = this.chart, s = v.options, f = s.navigator, y = this.navigatorAxis, h = v.zooming.pinchType, a = s.rangeSelector, x = v.zooming.type;
          if (this.isXAxis && (f != null && f.enabled || a != null && a.enabled)) {
            if (x === "y" && u.trigger === "zoom") c = !1;
            else if ((u.trigger === "zoom" && x === "xy" || I && h === "xy") && this.options.range) {
              let S = y.previousZoom;
              O(u.min) ? y.previousZoom = [this.min, this.max] : S && (u.min = S[0], u.max = S[1], y.previousZoom = void 0);
            }
          }
          c !== void 0 && u.preventDefault();
        }
        class l {
          static compose(c) {
            c.keepProps.includes("navigatorAxis") || (c.keepProps.push("navigatorAxis"), R(c, "init", w), R(c, "setExtremes", A));
          }
          constructor(c) {
            this.axis = c;
          }
          destroy() {
            this.axis = void 0;
          }
          toFixedRange(c, v, s, f) {
            let y = this.axis, h = (y.pointRange || 0) / 2, a = M(s, y.translate(c, !0, !y.horiz)), x = M(f, y.translate(v, !0, !y.horiz));
            return O(s) || (a = z(a + h)), O(f) || (x = z(x - h)), L(a) && L(x) || (a = x = void 0), { min: a, max: x };
          }
        }
        return l;
      }), Z(r, "Stock/Navigator/NavigatorDefaults.js", [r["Core/Color/Color.js"], r["Core/Series/SeriesRegistry.js"]], function(T, B) {
        let { parse: I } = T, { seriesTypes: R } = B;
        return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: I("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: R.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
      }), Z(r, "Stock/Navigator/NavigatorSymbols.js", [r["Core/Renderer/SVG/Symbols.js"], r["Core/Utilities.js"]], function(T, B) {
        let { relativeLength: I } = B;
        return { "navigator-handle": function(R, z, O, L, M = {}) {
          let w = M.width ? M.width / 2 : O, A = I(M.borderRadius || 0, Math.min(2 * w, L));
          return [["M", -1.5, (L = M.height || L) / 2 - 3.5], ["L", -1.5, L / 2 + 4.5], ["M", 0.5, L / 2 - 3.5], ["L", 0.5, L / 2 + 4.5], ...T.rect(-w - 1, 0.5, 2 * w + 1, L, { r: A })];
        } };
      }), Z(r, "Stock/Utilities/StockUtilities.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B } = T;
        return { setFixedRange: function(I) {
          let R = this.xAxis[0];
          B(R.dataMax) && B(R.dataMin) && I ? this.fixedRange = Math.min(I, R.dataMax - R.dataMin) : this.fixedRange = I;
        } };
      }), Z(r, "Stock/Navigator/NavigatorComposition.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/NavigatorAxisComposition.js"], r["Stock/Navigator/NavigatorDefaults.js"], r["Stock/Navigator/NavigatorSymbols.js"], r["Core/Renderer/RendererRegistry.js"], r["Stock/Utilities/StockUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { setOptions: w } = T, { composed: A } = B, { getRendererType: l } = O, { setFixedRange: u } = L, { addEvent: c, extend: v, pushUnique: s } = M;
        function f() {
          this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
        }
        return { compose: function(y, h, a) {
          I.compose(h), s(A, "Navigator") && (y.prototype.setFixedRange = u, v(l().prototype.symbols, z), c(a, "afterUpdate", f), w({ navigator: R }));
        } };
      }), Z(r, "Core/Axis/ScrollbarAxis.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { composed: R } = T, { addEvent: z, defined: O, pick: L, pushUnique: M } = B;
        return function(w) {
          let A;
          function l(s) {
            let f = L(s.options && s.options.min, s.min), y = L(s.options && s.options.max, s.max);
            return { axisMin: f, axisMax: y, scrollMin: O(s.dataMin) ? Math.min(f, s.min, s.dataMin, L(s.threshold, 1 / 0)) : f, scrollMax: O(s.dataMax) ? Math.max(y, s.max, s.dataMax, L(s.threshold, -1 / 0)) : y };
          }
          function u() {
            let s = this.scrollbar, f = s && !s.options.opposite, y = this.horiz ? 2 : f ? 3 : 1;
            s && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[y] += s.size + (s.options.margin || 0));
          }
          function c() {
            let s = this;
            s.options && s.options.scrollbar && s.options.scrollbar.enabled && (s.options.scrollbar.vertical = !s.horiz, s.options.startOnTick = s.options.endOnTick = !1, s.scrollbar = new A(s.chart.renderer, s.options.scrollbar, s.chart), z(s.scrollbar, "changed", function(f) {
              let y, h, { axisMin: a, axisMax: x, scrollMin: S, scrollMax: E } = l(s), b = E - S;
              if (O(a) && O(x))
                if (s.horiz && !s.reversed || !s.horiz && s.reversed ? (y = S + b * this.to, h = S + b * this.from) : (y = S + b * (1 - this.from), h = S + b * (1 - this.to)), this.shouldUpdateExtremes(f.DOMType)) {
                  let p = f.DOMType !== "mousemove" && f.DOMType !== "touchmove" && void 0;
                  s.setExtremes(h, y, !0, p, f);
                } else this.setRange(this.from, this.to);
            }));
          }
          function v() {
            let s, f, y, { scrollMin: h, scrollMax: a } = l(this), x = this.scrollbar, S = this.axisTitleMargin + (this.titleOffset || 0), E = this.chart.scrollbarsOffsets, b = this.options.margin || 0;
            if (x && E) {
              if (this.horiz) this.opposite || (E[1] += S), x.position(this.left, this.top + this.height + 2 + E[1] - (this.opposite ? b : 0), this.width, this.height), this.opposite || (E[1] += b), s = 1;
              else {
                let p;
                this.opposite && (E[0] += S), p = x.options.opposite ? this.left + this.width + 2 + E[0] - (this.opposite ? 0 : b) : this.opposite ? 0 : b, x.position(p, this.top, this.width, this.height), this.opposite && (E[0] += b), s = 0;
              }
              if (E[s] += x.size + (x.options.margin || 0), isNaN(h) || isNaN(a) || !O(this.min) || !O(this.max) || this.dataMin === this.dataMax) x.setRange(0, 1);
              else if (this.min === this.max) {
                let p = this.pointRange / (this.dataMax + 1);
                f = p * this.min, y = p * (this.max + 1), x.setRange(f, y);
              } else f = (this.min - h) / (a - h), y = (this.max - h) / (a - h), this.horiz && !this.reversed || !this.horiz && this.reversed ? x.setRange(f, y) : x.setRange(1 - y, 1 - f);
            }
          }
          w.compose = function(s, f) {
            M(R, "Axis.Scrollbar") && (A = f, z(s, "afterGetOffset", u), z(s, "afterInit", c), z(s, "afterRender", v));
          };
        }(I || (I = {})), I;
      }), Z(r, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
        return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
      }), Z(r, "Stock/Scrollbar/Scrollbar.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/ScrollbarAxis.js"], r["Stock/Scrollbar/ScrollbarDefaults.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { defaultOptions: O } = T, { addEvent: L, correctFloat: M, crisp: w, defined: A, destroyObjectProperties: l, fireEvent: u, merge: c, pick: v, removeEvent: s } = z;
        class f {
          static compose(h) {
            I.compose(h, f);
          }
          static swapXY(h, a) {
            return a && h.forEach((x) => {
              let S, E = x.length;
              for (let b = 0; b < E; b += 2) typeof (S = x[b + 1]) == "number" && (x[b + 1] = x[b + 2], x[b + 2] = S);
            }), h;
          }
          constructor(h, a, x) {
            this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(h, a, x);
          }
          addEvents() {
            let h = this.options.inverted ? [1, 0] : [0, 1], a = this.scrollbarButtons, x = this.scrollbarGroup.element, S = this.track.element, E = this.mouseDownHandler.bind(this), b = this.mouseMoveHandler.bind(this), p = this.mouseUpHandler.bind(this), C = [[a[h[0]].element, "click", this.buttonToMinClick.bind(this)], [a[h[1]].element, "click", this.buttonToMaxClick.bind(this)], [S, "click", this.trackClick.bind(this)], [x, "mousedown", E], [x.ownerDocument, "mousemove", b], [x.ownerDocument, "mouseup", p], [x, "touchstart", E], [x.ownerDocument, "touchmove", b], [x.ownerDocument, "touchend", p]];
            C.forEach(function(o) {
              L.apply(null, o);
            }), this._events = C;
          }
          buttonToMaxClick(h) {
            let a = (this.to - this.from) * v(this.options.step, 0.2);
            this.updatePosition(this.from + a, this.to + a), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          buttonToMinClick(h) {
            let a = M(this.to - this.from) * v(this.options.step, 0.2);
            this.updatePosition(M(this.from - a), M(this.to - a)), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          cursorToScrollbarPosition(h) {
            let a = this.options, x = a.minWidth > this.calculatedWidth ? a.minWidth : 0;
            return { chartX: (h.chartX - this.x - this.xOffset) / (this.barWidth - x), chartY: (h.chartY - this.y - this.yOffset) / (this.barWidth - x) };
          }
          destroy() {
            let h = this, a = h.chart.scroller;
            h.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(x) {
              h[x] && h[x].destroy && (h[x] = h[x].destroy());
            }), a && h === a.scrollbar && (a.scrollbar = null, l(a.scrollbarButtons));
          }
          drawScrollbarButton(h) {
            let a = this.renderer, x = this.scrollbarButtons, S = this.options, E = this.size, b = a.g().add(this.group);
            if (x.push(b), S.buttonsEnabled) {
              let p = a.rect().addClass("highcharts-scrollbar-button").add(b);
              this.chart.styledMode || p.attr({ stroke: S.buttonBorderColor, "stroke-width": S.buttonBorderWidth, fill: S.buttonBackgroundColor }), p.attr(p.crisp({ x: -0.5, y: -0.5, width: E, height: E, r: S.buttonBorderRadius }, p.strokeWidth()));
              let C = a.path(f.swapXY([["M", E / 2 + (h ? -1 : 1), E / 2 - 3], ["L", E / 2 + (h ? -1 : 1), E / 2 + 3], ["L", E / 2 + (h ? 2 : -2), E / 2]], S.vertical)).addClass("highcharts-scrollbar-arrow").add(x[h]);
              this.chart.styledMode || C.attr({ fill: S.buttonArrowColor });
            }
          }
          init(h, a, x) {
            this.scrollbarButtons = [], this.renderer = h, this.userOptions = a, this.options = c(R, O.scrollbar, a), this.options.margin = v(this.options.margin, 10), this.chart = x, this.size = v(this.options.size, this.options.height), a.enabled && (this.render(), this.addEvents());
          }
          mouseDownHandler(h) {
            var S;
            let a = ((S = this.chart.pointer) == null ? void 0 : S.normalize(h)) || h, x = this.cursorToScrollbarPosition(a);
            this.chartX = x.chartX, this.chartY = x.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
          }
          mouseMoveHandler(h) {
            var b;
            let a, x = ((b = this.chart.pointer) == null ? void 0 : b.normalize(h)) || h, S = this.options.vertical ? "chartY" : "chartX", E = this.initPositions || [];
            this.grabbedCenter && (!h.touches || h.touches[0][S] !== 0) && (a = this.cursorToScrollbarPosition(x)[S] - this[S], this.hasDragged = !0, this.updatePosition(E[0] + a, E[1] + a), this.hasDragged && u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h.type, DOMEvent: h }));
          }
          mouseUpHandler(h) {
            this.hasDragged && u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h.type, DOMEvent: h }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
          }
          position(h, a, x, S) {
            let { buttonsEnabled: E, margin: b = 0, vertical: p } = this.options, C = this.rendered ? "animate" : "attr", o = S, t = 0;
            this.group.show(), this.x = h, this.y = a + this.trackBorderWidth, this.width = x, this.height = S, this.xOffset = o, this.yOffset = t, p ? (this.width = this.yOffset = x = t = this.size, this.xOffset = o = 0, this.yOffset = t = E ? this.size : 0, this.barWidth = S - (E ? 2 * x : 0), this.x = h += b) : (this.height = S = this.size, this.xOffset = o = E ? this.size : 0, this.barWidth = x - (E ? 2 * S : 0), this.y = this.y + b), this.group[C]({ translateX: h, translateY: this.y }), this.track[C]({ width: x, height: S }), this.scrollbarButtons[1][C]({ translateX: p ? 0 : x - o, translateY: p ? S - t : 0 });
          }
          removeEvents() {
            this._events.forEach(function(h) {
              s.apply(null, h);
            }), this._events.length = 0;
          }
          render() {
            let h = this.renderer, a = this.options, x = this.size, S = this.chart.styledMode, E = h.g("scrollbar").attr({ zIndex: a.zIndex }).hide().add();
            this.group = E, this.track = h.rect().addClass("highcharts-scrollbar-track").attr({ r: a.trackBorderRadius || 0, height: x, width: x }).add(E), S || this.track.attr({ fill: a.trackBackgroundColor, stroke: a.trackBorderColor, "stroke-width": a.trackBorderWidth });
            let b = this.trackBorderWidth = this.track.strokeWidth();
            this.track.attr({ x: -w(0, b), y: -w(0, b) }), this.scrollbarGroup = h.g().add(E), this.scrollbar = h.rect().addClass("highcharts-scrollbar-thumb").attr({ height: x - b, width: x - b, r: a.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = h.path(f.swapXY([["M", -3, x / 4], ["L", -3, 2 * x / 3], ["M", 0, x / 4], ["L", 0, 2 * x / 3], ["M", 3, x / 4], ["L", 3, 2 * x / 3]], a.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), S || (this.scrollbar.attr({ fill: a.barBackgroundColor, stroke: a.barBorderColor, "stroke-width": a.barBorderWidth }), this.scrollbarRifles.attr({ stroke: a.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-w(0, this.scrollbarStrokeWidth), -w(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
          }
          setRange(h, a) {
            let x, S, E = this.options, b = E.vertical, p = E.minWidth, C = this.barWidth, o = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
            if (!A(C)) return;
            let t = C * Math.min(a, 1);
            x = Math.ceil(C * (h = Math.max(h, 0))), this.calculatedWidth = S = M(t - x), S < p && (x = (C - p + S) * h, S = p);
            let e = Math.floor(x + this.xOffset + this.yOffset), n = S / 2 - 0.5;
            this.from = h, this.to = a, b ? (this.scrollbarGroup[o]({ translateY: e }), this.scrollbar[o]({ height: S }), this.scrollbarRifles[o]({ translateY: n }), this.scrollbarTop = e, this.scrollbarLeft = 0) : (this.scrollbarGroup[o]({ translateX: e }), this.scrollbar[o]({ width: S }), this.scrollbarRifles[o]({ translateX: n }), this.scrollbarLeft = e, this.scrollbarTop = 0), S <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), E.showFull === !1 && (h <= 0 && a >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
          }
          shouldUpdateExtremes(h) {
            return v(this.options.liveRedraw, B.svg && !B.isTouchDevice && !this.chart.boosted) || h === "mouseup" || h === "touchend" || !A(h);
          }
          trackClick(h) {
            var b;
            let a = ((b = this.chart.pointer) == null ? void 0 : b.normalize(h)) || h, x = this.to - this.from, S = this.y + this.scrollbarTop, E = this.x + this.scrollbarLeft;
            this.options.vertical && a.chartY > S || !this.options.vertical && a.chartX > E ? this.updatePosition(this.from + x, this.to + x) : this.updatePosition(this.from - x, this.to - x), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          update(h) {
            this.destroy(), this.init(this.chart.renderer, c(!0, this.options, h), this.chart);
          }
          updatePosition(h, a) {
            a > 1 && (h = M(1 - M(a - h)), a = 1), h < 0 && (a = M(a - h), h = 0), this.from = h, this.to = a;
          }
        }
        return f.defaultOptions = R, O.scrollbar = c(!0, f.defaultOptions, O.scrollbar), f;
      }), Z(r, "Stock/Navigator/Navigator.js", [r["Core/Axis/Axis.js"], r["Stock/Navigator/ChartNavigatorComposition.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/NavigatorAxisComposition.js"], r["Stock/Navigator/NavigatorComposition.js"], r["Stock/Scrollbar/Scrollbar.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w) {
        let { defaultOptions: A } = I, { isTouchDevice: l } = R, { prototype: { symbols: u } } = M, { addEvent: c, clamp: v, correctFloat: s, defined: f, destroyObjectProperties: y, erase: h, extend: a, find: x, fireEvent: S, isArray: E, isNumber: b, merge: p, pick: C, removeEvent: o, splat: t } = w;
        function e(d, ...i) {
          let g = [].filter.call(i, b);
          if (g.length) return Math[d].apply(0, g);
        }
        class n {
          static compose(i, g, m) {
            B.compose(i, n), O.compose(i, g, m);
          }
          constructor(i) {
            this.isDirty = !1, this.scrollbarHeight = 0, this.init(i);
          }
          drawHandle(i, g, m, k) {
            let j = this.navigatorOptions.handles.height;
            this.handles[g][k](m ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(i, 10) + 0.5 - j) } : { translateX: Math.round(this.left + parseInt(i, 10)), translateY: Math.round(this.top + this.height / 2 - j / 2 - 1) });
          }
          drawOutline(i, g, m, k) {
            let j = this.navigatorOptions.maskInside, P = this.outline.strokeWidth(), D = P / 2, H = P % 2 / 2, G = this.scrollButtonSize, V = this.size, F = this.top, U = this.height, Y = F - D, q = F + U, N = this.left, X, W;
            m ? (X = F + g + H, g = F + i + H, W = [["M", N + U, F - G - H], ["L", N + U, X], ["L", N, X], ["M", N, g], ["L", N + U, g], ["L", N + U, F + V + G]], j && W.push(["M", N + U, X - D], ["L", N + U, g + D])) : (N -= G, i += N + G - H, g += N + G - H, W = [["M", N, Y], ["L", i, Y], ["L", i, q], ["M", g, q], ["L", g, Y], ["L", N + V + 2 * G, Y]], j && W.push(["M", i - D, Y], ["L", g + D, Y])), this.outline[k]({ d: W });
          }
          drawMasks(i, g, m, k) {
            let j, P, D, H, G = this.left, V = this.top, F = this.height;
            m ? (D = [G, G, G], H = [V, V + i, V + g], P = [F, F, F], j = [i, g - i, this.size - g]) : (D = [G, G + i, G + g], H = [V, V, V], P = [i, g - i, this.size - g], j = [F, F, F]), this.shades.forEach((U, Y) => {
              U[k]({ x: D[Y], y: H[Y], width: P[Y], height: j[Y] });
            });
          }
          renderElements() {
            var G;
            let i = this, g = i.navigatorOptions, m = g.maskInside, k = i.chart, j = k.inverted, P = k.renderer, D = { cursor: j ? "ns-resize" : "ew-resize" }, H = i.navigatorGroup ?? (i.navigatorGroup = P.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add());
            if ([!m, m, !m].forEach((V, F) => {
              let U = i.shades[F] ?? (i.shades[F] = P.rect().addClass("highcharts-navigator-mask" + (F === 1 ? "-inside" : "-outside")).add(H));
              k.styledMode || (U.attr({ fill: V ? g.maskFill : "rgba(0,0,0,0)" }), F === 1 && U.css(D));
            }), i.outline || (i.outline = P.path().addClass("highcharts-navigator-outline").add(H)), k.styledMode || i.outline.attr({ "stroke-width": g.outlineWidth, stroke: g.outlineColor }), (G = g.handles) == null ? void 0 : G.enabled) {
              let V = g.handles, { height: F, width: U } = V;
              [0, 1].forEach((Y) => {
                var N;
                let q = V.symbols[Y];
                if (i.handles[Y] && i.handles[Y].symbolUrl === q) {
                  if (!i.handles[Y].isImg && i.handles[Y].symbolName !== q) {
                    let X = u[q].call(u, -U / 2 - 1, 0, U, F);
                    i.handles[Y].attr({ d: X }), i.handles[Y].symbolName = q;
                  }
                } else (N = i.handles[Y]) == null || N.destroy(), i.handles[Y] = P.symbol(q, -U / 2 - 1, 0, U, F, V), i.handles[Y].attr({ zIndex: 7 - Y }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][Y]).add(H), i.addMouseEvents();
                k.inverted && i.handles[Y].attr({ rotation: 90, rotationOriginX: Math.floor(-U / 2), rotationOriginY: (F + U) / 2 }), k.styledMode || i.handles[Y].attr({ fill: V.backgroundColor, stroke: V.borderColor, "stroke-width": V.lineWidth, width: V.width, height: V.height, x: -U / 2 - 1, y: 0 }).css(D);
              });
            }
          }
          update(i, g = !1) {
            var j;
            let m = this.chart, k = m.options.chart.inverted !== ((j = m.scrollbar) == null ? void 0 : j.options.vertical);
            if (p(!0, m.options.navigator, i), this.navigatorOptions = m.options.navigator || {}, this.setOpposite(), f(i.enabled) || k) return this.destroy(), this.navigatorEnabled = i.enabled || this.navigatorEnabled, this.init(m);
            if (this.navigatorEnabled && (this.isDirty = !0, i.adaptToUpdatedData === !1 && this.baseSeries.forEach((P) => {
              o(P, "updatedData", this.updatedDataHandler);
            }, this), i.adaptToUpdatedData && this.baseSeries.forEach((P) => {
              P.eventsToUnbind.push(c(P, "updatedData", this.updatedDataHandler));
            }, this), (i.series || i.baseSeries) && this.setBaseSeries(void 0, !1), i.height || i.xAxis || i.yAxis)) {
              this.height = i.height ?? this.height;
              let P = this.getXAxisOffsets();
              this.xAxis.update({ ...i.xAxis, offsets: P, [m.inverted ? "width" : "height"]: this.height, [m.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...i.yAxis, [m.inverted ? "width" : "height"]: this.height }, !1);
            }
            g && m.redraw();
          }
          render(i, g, m, k) {
            let j = this.chart, P = this.xAxis, D = P.pointRange || 0, H = P.navigatorAxis.fake ? j.xAxis[0] : P, G = this.navigatorEnabled, V = this.rendered, F = j.inverted, U = j.xAxis[0].minRange, Y = j.xAxis[0].options.maxRange, q = this.scrollButtonSize, N, X, W, _ = this.scrollbarHeight, K, J;
            if (this.hasDragged && !f(m)) return;
            if (this.isDirty && this.renderElements(), i = s(i - D / 2), g = s(g + D / 2), !b(i) || !b(g)) {
              if (!V) return;
              m = 0, k = C(P.width, H.width);
            }
            this.left = C(P.left, j.plotLeft + q + (F ? j.plotWidth : 0));
            let $ = this.size = K = C(P.len, (F ? j.plotHeight : j.plotWidth) - 2 * q);
            N = F ? _ : K + 2 * q, m = C(m, P.toPixels(i, !0)), k = C(k, P.toPixels(g, !0)), b(m) && Math.abs(m) !== 1 / 0 || (m = 0, k = N);
            let et = P.toValue(m, !0), st = P.toValue(k, !0), at = Math.abs(s(st - et));
            at < U ? this.grabbedLeft ? m = P.toPixels(st - U - D, !0) : this.grabbedRight && (k = P.toPixels(et + U + D, !0)) : f(Y) && s(at - D) > Y && (this.grabbedLeft ? m = P.toPixels(st - Y - D, !0) : this.grabbedRight && (k = P.toPixels(et + Y + D, !0))), this.zoomedMax = v(Math.max(m, k), 0, $), this.zoomedMin = v(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(m, k), 0, $), this.range = this.zoomedMax - this.zoomedMin, $ = Math.round(this.zoomedMax);
            let lt = Math.round(this.zoomedMin);
            G && (this.navigatorGroup.attr({ visibility: "inherit" }), J = V && !this.hasDragged ? "animate" : "attr", this.drawMasks(lt, $, F, J), this.drawOutline(lt, $, F, J), this.navigatorOptions.handles.enabled && (this.drawHandle(lt, 0, F, J), this.drawHandle($, 1, F, J))), this.scrollbar && (F ? (W = this.top - q, X = this.left - _ + (G || !H.opposite ? 0 : (H.titleOffset || 0) + H.axisTitleMargin), _ = K + 2 * q) : (W = this.top + (G ? this.height : -_), X = this.left - q), this.scrollbar.position(X, W, N, _), this.scrollbar.setRange(this.zoomedMin / (K || 1), this.zoomedMax / (K || 1))), this.rendered = !0, this.isDirty = !1, S(this, "afterRender");
          }
          addMouseEvents() {
            let i = this, g = i.chart, m = g.container, k = [], j, P;
            i.mouseMoveHandler = j = function(D) {
              i.onMouseMove(D);
            }, i.mouseUpHandler = P = function(D) {
              i.onMouseUp(D);
            }, (k = i.getPartsEvents("mousedown")).push(c(g.renderTo, "mousemove", j), c(m.ownerDocument, "mouseup", P), c(g.renderTo, "touchmove", j), c(m.ownerDocument, "touchend", P)), k.concat(i.getPartsEvents("touchstart")), i.eventsToUnbind = k, i.series && i.series[0] && k.push(c(i.series[0].xAxis, "foundExtremes", function() {
              g.navigator.modifyNavigatorAxisExtremes();
            }));
          }
          getPartsEvents(i) {
            let g = this, m = [];
            return ["shades", "handles"].forEach(function(k) {
              g[k].forEach(function(j, P) {
                m.push(c(j.element, i, function(D) {
                  g[k + "Mousedown"](D, P);
                }));
              });
            }), m;
          }
          shadesMousedown(i, g) {
            var q;
            i = ((q = this.chart.pointer) == null ? void 0 : q.normalize(i)) || i;
            let m = this.chart, k = this.xAxis, j = this.zoomedMin, P = this.size, D = this.range, H = this.left, G = i.chartX, V, F, U, Y;
            m.inverted && (G = i.chartY, H = this.top), g === 1 ? (this.grabbedCenter = G, this.fixedWidth = D, this.dragOffset = G - j) : (Y = G - H - D / 2, g === 0 ? Y = Math.max(0, Y) : g === 2 && Y + D >= P && (Y = P - D, this.reversedExtremes ? (Y -= D, F = this.getUnionExtremes().dataMin) : V = this.getUnionExtremes().dataMax), Y !== j && (this.fixedWidth = D, f((U = k.navigatorAxis.toFixedRange(Y, Y + D, F, V)).min) && S(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
          }
          handlesMousedown(i, g) {
            var P;
            i = ((P = this.chart.pointer) == null ? void 0 : P.normalize(i)) || i;
            let m = this.chart, k = m.xAxis[0], j = this.reversedExtremes;
            g === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = j ? k.min : k.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = j ? k.max : k.min), m.setFixedRange(void 0);
          }
          onMouseMove(i) {
            var V;
            let g = this, m = g.chart, k = g.navigatorSize, j = g.range, P = g.dragOffset, D = m.inverted, H = g.left, G;
            (!i.touches || i.touches[0].pageX !== 0) && (G = (i = ((V = m.pointer) == null ? void 0 : V.normalize(i)) || i).chartX, D && (H = g.top, G = i.chartY), g.grabbedLeft ? (g.hasDragged = !0, g.render(0, 0, G - H, g.otherHandlePos)) : g.grabbedRight ? (g.hasDragged = !0, g.render(0, 0, g.otherHandlePos, G - H)) : g.grabbedCenter && (g.hasDragged = !0, G < P ? G = P : G > k + P - j && (G = k + P - j), g.render(0, 0, G - P, G - P + j)), g.hasDragged && g.scrollbar && C(g.scrollbar.options.liveRedraw, !l && !this.chart.boosted) && (i.DOMType = i.type, setTimeout(function() {
              g.onMouseUp(i);
            }, 0)));
          }
          onMouseUp(i) {
            let g, m, k, j, P, D, H = this.chart, G = this.xAxis, V = this.scrollbar, F = i.DOMEvent || i, U = H.inverted, Y = this.rendered && !this.hasDragged ? "animate" : "attr";
            (this.hasDragged && (!V || !V.hasDragged) || i.trigger === "scrollbar") && (k = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? j = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (P = this.fixedExtreme), this.zoomedMax === this.size && (P = this.reversedExtremes ? k.dataMin : k.dataMax), this.zoomedMin === 0 && (j = this.reversedExtremes ? k.dataMax : k.dataMin), f((D = G.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, j, P)).min) && S(this, "setRange", { min: Math.min(D.min, D.max), max: Math.max(D.min, D.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: F } })), i.DOMType !== "mousemove" && i.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && b(this.zoomedMin) && b(this.zoomedMax) && (m = Math.round(this.zoomedMin), g = Math.round(this.zoomedMax), this.shades && this.drawMasks(m, g, U, Y), this.outline && this.drawOutline(m, g, U, Y), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(m, 0, U, Y), this.drawHandle(g, 1, U, Y)));
          }
          removeEvents() {
            this.eventsToUnbind && (this.eventsToUnbind.forEach(function(i) {
              i();
            }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
          }
          removeBaseSeriesEvents() {
            let i = this.baseSeries || [];
            this.navigatorEnabled && i[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && i.forEach(function(g) {
              o(g, "updatedData", this.updatedDataHandler);
            }, this), i[0].xAxis && o(i[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
          }
          getXAxisOffsets() {
            return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
          }
          init(i) {
            var N;
            let g = i.options, m = g.navigator || {}, k = m.enabled, j = g.scrollbar || {}, P = j.enabled, D = k && m.height || 0, H = P && j.height || 0, G = j.buttonsEnabled && H || 0;
            this.handles = [], this.shades = [], this.chart = i, this.setBaseSeries(), this.height = D, this.scrollbarHeight = H, this.scrollButtonSize = G, this.scrollbarEnabled = P, this.navigatorEnabled = k, this.navigatorOptions = m, this.scrollbarOptions = j, this.setOpposite();
            let V = this, F = V.baseSeries, U = i.xAxis.length, Y = i.yAxis.length, q = F && F[0] && F[0].xAxis || i.xAxis[0] || { options: {} };
            if (i.isDirtyBox = !0, V.navigatorEnabled) {
              let X = this.getXAxisOffsets();
              V.xAxis = new T(i, p({ breaks: q.options.breaks, ordinal: q.options.ordinal, overscroll: q.options.overscroll }, m.xAxis, { type: "datetime", yAxis: (N = m.yAxis) == null ? void 0 : N.id, index: U, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: q.options.ordinal ? 0 : q.options.minPadding, maxPadding: q.options.ordinal ? 0 : q.options.maxPadding, zoomEnabled: !1 }, i.inverted ? { offsets: X, width: D } : { offsets: X, height: D }), "xAxis"), V.yAxis = new T(i, p(m.yAxis, { alignTicks: !1, offset: 0, index: Y, isInternal: !0, reversed: C(m.yAxis && m.yAxis.reversed, i.yAxis[0] && i.yAxis[0].reversed, !1), zoomEnabled: !1 }, i.inverted ? { width: D } : { height: D }), "yAxis"), F || m.series.data ? V.updateNavigatorSeries(!1) : i.series.length === 0 && (V.unbindRedraw = c(i, "beforeRedraw", function() {
                i.series.length > 0 && !V.series && (V.setBaseSeries(), V.unbindRedraw());
              })), V.reversedExtremes = i.inverted && !V.xAxis.reversed || !i.inverted && V.xAxis.reversed, V.renderElements(), V.addMouseEvents();
            } else V.xAxis = { chart: i, navigatorAxis: { fake: !0 }, translate: function(X, W) {
              let _ = i.xAxis[0], K = _.getExtremes(), J = _.len - 2 * G, $ = e("min", _.options.min, K.dataMin), et = e("max", _.options.max, K.dataMax) - $;
              return W ? X * et / J + $ : J * (X - $) / et;
            }, toPixels: function(X) {
              return this.translate(X);
            }, toValue: function(X) {
              return this.translate(X, !0);
            } }, V.xAxis.navigatorAxis.axis = V.xAxis, V.xAxis.navigatorAxis.toFixedRange = z.prototype.toFixedRange.bind(V.xAxis.navigatorAxis);
            if (i.options.scrollbar.enabled) {
              let X = p(i.options.scrollbar, { vertical: i.inverted });
              !b(X.margin) && V.navigatorEnabled && (X.margin = i.inverted ? -3 : 3), i.scrollbar = V.scrollbar = new L(i.renderer, X, i), c(V.scrollbar, "changed", function(W) {
                let _ = V.size, K = _ * this.to, J = _ * this.from;
                V.hasDragged = V.scrollbar.hasDragged, V.render(0, 0, J, K), this.shouldUpdateExtremes(W.DOMType) && setTimeout(function() {
                  V.onMouseUp(W);
                });
              });
            }
            V.addBaseSeriesEvents(), V.addChartEvents();
          }
          setOpposite() {
            let i = this.navigatorOptions, g = this.navigatorEnabled, m = this.chart;
            this.opposite = C(i.opposite, !!(!g && m.inverted));
          }
          getUnionExtremes(i) {
            let g, m = this.chart.xAxis[0], k = this.xAxis, j = k.options, P = m.options;
            return i && m.dataMin === null || (g = { dataMin: C(j && j.min, e("min", P.min, m.dataMin, k.dataMin, k.min)), dataMax: C(j && j.max, e("max", P.max, m.dataMax, k.dataMax, k.max)) }), g;
          }
          setBaseSeries(i, g) {
            let m = this.chart, k = this.baseSeries = [];
            i = i || m.options && m.options.navigator.baseSeries || (m.series.length ? x(m.series, (j) => !j.options.isInternal).index : 0), (m.series || []).forEach((j, P) => {
              !j.options.isInternal && (j.options.showInNavigator || (P === i || j.options.id === i) && j.options.showInNavigator !== !1) && k.push(j);
            }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, g);
          }
          updateNavigatorSeries(i, g) {
            var U, Y;
            let m = this, k = m.chart, j = m.baseSeries, P = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (U = this.navigatorOptions.xAxis) == null ? void 0 : U.id, yAxis: (Y = this.navigatorOptions.yAxis) == null ? void 0 : Y.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, D = m.series = (m.series || []).filter((q) => {
              let N = q.baseSeries;
              return !(0 > j.indexOf(N)) || (N && (o(N, "updatedData", m.updatedDataHandler), delete N.navigatorSeries), q.chart && q.destroy(), !1);
            }), H, G, V = m.navigatorOptions.series, F;
            j && j.length && j.forEach((q) => {
              let N = q.navigatorSeries, X = a({ color: q.color, visible: q.visible }, E(V) ? A.navigator.series : V);
              if (N && m.navigatorOptions.adaptToUpdatedData === !1) return;
              P.name = "Navigator " + j.length, F = (H = q.options || {}).navigatorOptions || {}, X.dataLabels = t(X.dataLabels), (G = p(H, P, X, F)).pointRange = C(X.pointRange, F.pointRange, A.plotOptions[G.type || "line"].pointRange);
              let W = F.data || X.data;
              m.hasNavigatorData = m.hasNavigatorData || !!W, G.data = W || H.data && H.data.slice(0), N && N.options ? N.update(G, g) : (q.navigatorSeries = k.initSeries(G), k.setSortedData(), q.navigatorSeries.baseSeries = q, D.push(q.navigatorSeries));
            }), (V.data && !(j && j.length) || E(V)) && (m.hasNavigatorData = !1, (V = t(V)).forEach((q, N) => {
              P.name = "Navigator " + (D.length + 1), (G = p(A.navigator.series, { color: k.series[N] && !k.series[N].options.isInternal && k.series[N].color || k.options.colors[N] || k.options.colors[0] }, P, q)).data = q.data, G.data && (m.hasNavigatorData = !0, D.push(k.initSeries(G)));
            })), i && this.addBaseSeriesEvents();
          }
          addBaseSeriesEvents() {
            let i = this, g = i.baseSeries || [];
            g[0] && g[0].xAxis && g[0].eventsToUnbind.push(c(g[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), g.forEach((m) => {
              m.eventsToUnbind.push(c(m, "show", function() {
                this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
              })), m.eventsToUnbind.push(c(m, "hide", function() {
                this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
              })), this.navigatorOptions.adaptToUpdatedData !== !1 && m.xAxis && m.eventsToUnbind.push(c(m, "updatedData", this.updatedDataHandler)), m.eventsToUnbind.push(c(m, "remove", function() {
                h(g, m), this.navigatorSeries && (h(i.series, this.navigatorSeries), f(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
              }));
            });
          }
          getBaseSeriesMin(i) {
            return this.baseSeries.reduce(function(g, m) {
              return Math.min(g, m.xData && m.xData.length ? m.xData[0] : g);
            }, i);
          }
          modifyNavigatorAxisExtremes() {
            let i = this.xAxis;
            if (i.getExtremes !== void 0) {
              let g = this.getUnionExtremes(!0);
              g && (g.dataMin !== i.min || g.dataMax !== i.max) && (i.min = g.dataMin, i.max = g.dataMax);
            }
          }
          modifyBaseAxisExtremes() {
            var N;
            let i, g, m = this.chart.navigator, k = this.getExtremes(), j = k.min, P = k.max, D = k.dataMin, H = k.dataMax, G = P - j, V = m.stickToMin, F = m.stickToMax, U = C((N = this.ordinal) == null ? void 0 : N.convertOverscroll(this.options.overscroll), 0), Y = m.series && m.series[0], q = !!this.setExtremes;
            !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (V && (i = (g = D) + G), F && (i = H + U, V || (g = Math.max(D, i - G, m.getBaseSeriesMin(Y && Y.xData ? Y.xData[0] : -Number.MAX_VALUE)))), q && (V || F) && b(g) && (this.min = this.userMin = g, this.max = this.userMax = i)), m.stickToMin = m.stickToMax = null;
          }
          updatedDataHandler() {
            let i = this.chart.navigator, g = this.navigatorSeries, m = i.reversedExtremes ? Math.round(i.zoomedMin) === 0 : Math.round(i.zoomedMax) >= Math.round(i.size);
            i.stickToMax = C(this.chart.options.navigator && this.chart.options.navigator.stickToMax, m), i.stickToMin = i.shouldStickToMin(this, i), g && !i.hasNavigatorData && (g.options.pointStart = this.xData[0], g.setData(this.options.data, !1, null, !1));
          }
          shouldStickToMin(i, g) {
            let m = g.getBaseSeriesMin(i.xData[0]), k = i.xAxis, j = k.max, P = k.min, D = k.options.range;
            return !!(b(j) && b(P)) && (D && j - m > 0 ? j - m < D : P <= m);
          }
          addChartEvents() {
            this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(c(this.chart, "redraw", function() {
              let i = this.navigator, g = i && (i.baseSeries && i.baseSeries[0] && i.baseSeries[0].xAxis || this.xAxis[0]);
              g && i.render(g.min, g.max);
            }), c(this.chart, "getMargins", function() {
              let i = this.navigator, g = i.opposite ? "plotTop" : "marginBottom";
              this.inverted && (g = i.opposite ? "marginRight" : "plotLeft"), this[g] = (this[g] || 0) + (i.navigatorEnabled || !this.inverted ? i.height + i.scrollbarHeight : 0) + i.navigatorOptions.margin;
            }), c(n, "setRange", function(i) {
              this.chart.xAxis[0].setExtremes(i.min, i.max, i.redraw, i.animation, i.eventArguments);
            }));
          }
          destroy() {
            this.removeEvents(), this.xAxis && (h(this.chart.xAxis, this.xAxis), h(this.chart.axes, this.xAxis)), this.yAxis && (h(this.chart.yAxis, this.yAxis), h(this.chart.axes, this.yAxis)), (this.series || []).forEach((i) => {
              i.destroy && i.destroy();
            }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((i) => {
              this[i] && this[i].destroy && this[i].destroy(), this[i] = null;
            }), [this.handles].forEach((i) => {
              y(i);
            }), this.navigatorEnabled = !1;
          }
        }
        return n;
      }), Z(r, "Accessibility/Components/NavigatorComponent.js", [r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/Announcer.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Stock/Navigator/Navigator.js"], r["Core/Animation/AnimationUtilities.js"], r["Core/Templating.js"], r["Core/Utilities.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Accessibility/Utils/ChartUtilities.js"]], function(T, B, I, R, z, O, L, M, w) {
        let { animObject: A } = z, { format: l } = O, { clamp: u, pick: c, syncTimeout: v } = L, { getFakeMouseEvent: s } = M, { getAxisRangeDescription: f, fireEventOnWrappedOrUnwrappedElement: y } = w;
        return class extends T {
          init() {
            let h = this.chart, a = this;
            this.announcer = new B(h, "polite"), this.addEvent(R, "afterRender", function() {
              this.chart === a.chart && this.chart.renderer && v(() => {
                a.proxyProvider.updateGroupProxyElementPositions("navigator"), a.updateHandleValues();
              }, A(c(this.chart.renderer.globalAnimation, !0)).duration);
            });
          }
          onChartUpdate() {
            var S, E, b;
            let h = this.chart, a = h.options, x = a.navigator;
            if (x.enabled && ((S = x.accessibility) != null && S.enabled)) {
              let p = a.accessibility.landmarkVerbosity, C = (E = a.lang.accessibility) == null ? void 0 : E.navigator.groupLabel;
              this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: p === "all" ? "region" : "group", "aria-label": l(C, { chart: h }, h) });
              let o = (b = a.lang.accessibility) == null ? void 0 : b.navigator.handleLabel;
              [0, 1].forEach((t) => {
                let e = this.getHandleByIx(t);
                if (e) {
                  let n = this.proxyProvider.addProxyElement("navigator", { click: e }, "input", { type: "range", "aria-label": l(o, { handleIx: t, chart: h }, h) });
                  this[t ? "maxHandleProxy" : "minHandleProxy"] = n.innerElement, n.innerElement.style.pointerEvents = "none", n.innerElement.oninput = () => this.updateNavigator();
                }
              }), this.updateHandleValues();
            } else this.proxyProvider.removeGroup("navigator");
          }
          getNavigatorHandleNavigation(h) {
            let a = this, x = this.chart, S = h ? this.maxHandleProxy : this.minHandleProxy, E = this.keyCodes;
            return new I(x, { keyCodeMap: [[[E.left, E.right, E.up, E.down], function(b) {
              if (S) {
                let p = b === E.left || b === E.up ? -1 : 1;
                S.value = "" + u(parseFloat(S.value) + p, 0, 100), a.updateNavigator(() => {
                  let C = a.getHandleByIx(h);
                  C && x.setFocusToElement(C, S);
                });
              }
              return this.response.success;
            }]], init: () => {
              x.setFocusToElement(this.getHandleByIx(h), S);
            }, validate: () => {
              var b;
              return !!(this.getHandleByIx(h) && S && ((b = x.options.navigator.accessibility) != null && b.enabled));
            } });
          }
          getKeyboardNavigation() {
            return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
          }
          destroy() {
            this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
          }
          updateHandleValues() {
            let h = this.chart.navigator;
            if (h && this.minHandleProxy && this.maxHandleProxy) {
              let a = h.size;
              this.minHandleProxy.value = "" + Math.round(h.zoomedMin / a * 100), this.maxHandleProxy.value = "" + Math.round(h.zoomedMax / a * 100);
            }
          }
          getHandleByIx(h) {
            let a = this.chart.navigator;
            return a && a.handles && a.handles[h];
          }
          updateNavigator(h) {
            this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((a) => {
              var b;
              let x = this.chart, { navigator: S, pointer: E } = x;
              if (S && E && this.minHandleProxy && this.maxHandleProxy) {
                let p = E.getChartPosition(), C = parseFloat(this.minHandleProxy.value) / 100 * S.size, o = parseFloat(this.maxHandleProxy.value) / 100 * S.size;
                [[0, "mousedown", S.zoomedMin], [0, "mousemove", C], [0, "mouseup", C], [1, "mousedown", S.zoomedMax], [1, "mousemove", o], [1, "mouseup", o]].forEach(([n, d, i]) => {
                  var m;
                  let g = (m = this.getHandleByIx(n)) == null ? void 0 : m.element;
                  g && y(g, s(d, { x: p.left + S.left + i, y: p.top + S.top }, g));
                }), a && a();
                let t = (b = x.options.lang.accessibility) == null ? void 0 : b.navigator.changeAnnouncement, e = f(x.xAxis[0]);
                this.announcer.announce(l(t, { axisRangeDescription: e, chart: x }, x));
              }
            }).bind(this, h), 20);
          }
        };
      }), Z(r, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [r["Accessibility/Components/AnnotationsA11y.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Core/Templating.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { getPointAnnotationTexts: O } = T, { getAxisDescription: L, getSeriesFirstPointElement: M, getSeriesA11yElement: w, unhideChartElementFromAT: A } = B, { format: l, numberFormat: u } = I, { reverseChildNodes: c, stripHTMLTagsFromString: v } = R, { find: s, isNumber: f, isString: y, pick: h, defined: a } = z;
        function x(C) {
          let o = C.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
          return !!(o !== !1 && C.points && C.points.length >= +o);
        }
        function S(C, o) {
          let t = C.series, e = t.chart, n = e.options.accessibility.point || {}, d = t.options.accessibility && t.options.accessibility.point || {}, i = t.tooltipOptions || {}, g = e.options.lang;
          return f(o) ? u(o, d.valueDecimals || n.valueDecimals || i.valueDecimals || -1, g.decimalPoint, g.accessibility.thousandsSep || g.thousandsSep) : o;
        }
        function E(C, o) {
          let t = C[o];
          return C.chart.langFormat("accessibility.series." + o + "Description", { name: L(t), series: C });
        }
        function b(C) {
          let o = C.series, t = o.chart.series.length > 1 || o.options.name, e = function(g) {
            let m = g.series, k = m.chart, j = m.options.accessibility, P = j && j.point && j.point.valueDescriptionFormat || k.options.accessibility.point.valueDescriptionFormat, D = h(m.xAxis && m.xAxis.options.accessibility && m.xAxis.options.accessibility.enabled, !k.angular && m.type !== "flowmap"), H = D ? function(G) {
              let V = function(q) {
                let N = q.series, X = N.chart, W = N.options.accessibility && N.options.accessibility.point || {}, _ = X.options.accessibility.point || {}, K = N.xAxis && N.xAxis.dateTime;
                if (K) {
                  let J = K.getXDateFormat(q.x || 0, X.options.tooltip.dateTimeLabelFormats), $ = W.dateFormatter && W.dateFormatter(q) || _.dateFormatter && _.dateFormatter(q) || W.dateFormat || _.dateFormat || J;
                  return X.time.dateFormat($, q.x || 0, void 0);
                }
              }(G), F = (G.series.xAxis || {}).categories && a(G.category) && ("" + G.category).replace("<br/>", " "), U = a(G.id) && 0 > ("" + G.id).indexOf("highcharts-"), Y = "x, " + G.x;
              return G.name || V || F || (U ? G.id : Y);
            }(g) : "";
            return l(P, { point: g, index: a(g.index) ? g.index + 1 : "", xDescription: H, value: function(G) {
              let V = G.series, F = V.chart.options.accessibility.point || {}, U = V.chart.options.accessibility && V.chart.options.accessibility.point || {}, Y = V.tooltipOptions || {}, q = U.valuePrefix || F.valuePrefix || Y.valuePrefix || "", N = U.valueSuffix || F.valueSuffix || Y.valueSuffix || "", X = G.value !== void 0 ? "value" : "y", W = S(G, G[X]);
              return G.isNull ? V.chart.langFormat("accessibility.series.nullPointValue", { point: G }) : V.pointArrayMap ? function(_, K, J) {
                let $ = K || "", et = J || "", st = function(at) {
                  let lt = S(_, h(_[at], _.options[at]));
                  return lt !== void 0 ? at + ": " + $ + lt + et : lt;
                };
                return _.series.pointArrayMap.reduce(function(at, lt) {
                  let it = st(lt);
                  return it ? at + (at.length ? ", " : "") + it : at;
                }, "");
              }(G, q, N) : q + W + N;
            }(g), separator: D ? ", " : "" }, k);
          }(C), n = C.options && C.options.accessibility && C.options.accessibility.description, d = t ? " " + o.name + "." : "", i = function(g) {
            let m = g.series.chart, k = O(g);
            return k.length ? m.langFormat("accessibility.series.pointAnnotationsDescription", { point: g, annotations: k }) : "";
          }(C);
          return C.accessibility = C.accessibility || {}, C.accessibility.valueDescription = e, e + (n ? " " + n : "") + d + (i ? " " + i : "");
        }
        function p(C) {
          let o = C.chart, t = o.types || [], e = function(D) {
            let H = (D.options.accessibility || {}).description;
            return H && D.chart.langFormat("accessibility.series.description", { description: H, series: D }) || "";
          }(C), n = function(D) {
            return o[D] && o[D].length > 1 && C[D];
          }, d = C.index + 1, i = E(C, "xAxis"), g = E(C, "yAxis"), m = { seriesNumber: d, series: C, chart: o }, k = t.length > 1 ? "Combination" : "", j = o.langFormat("accessibility.series.summary." + C.type + k, m) || o.langFormat("accessibility.series.summary.default" + k, m), P = (n("yAxis") ? " " + g + "." : "") + (n("xAxis") ? " " + i + "." : "");
          return l(h(C.options.accessibility && C.options.accessibility.descriptionFormat, o.options.accessibility.series.descriptionFormat, ""), { seriesDescription: j, authorDescription: e ? " " + e : "", axisDescription: P, series: C, chart: o, seriesNumber: d }, void 0);
        }
        return { defaultPointDescriptionFormatter: b, defaultSeriesDescriptionFormatter: p, describeSeries: function(C) {
          let o = C.chart, t = M(C), e = w(C), n = o.is3d && o.is3d();
          e && (e.lastChild !== t || n || c(e), function(d) {
            let i = function(k) {
              let j = k.options.accessibility || {};
              return !x(k) && !j.exposeAsGroupOnly;
            }(d), g = function(k) {
              let j = k.chart.options.accessibility.keyboardNavigation.seriesNavigation;
              return !!(k.points && (k.points.length < +j.pointNavigationEnabledThreshold || j.pointNavigationEnabledThreshold === !1));
            }(d), m = d.chart.options.accessibility.point.describeNull;
            (i || g) && d.points.forEach((k) => {
              let j = k.graphic && k.graphic.element || function(D) {
                let H = D.series, G = H && H.chart, V = H && H.is("sunburst"), F = D.isNull, U = G && G.options.accessibility.point.describeNull;
                return F && !V && U;
              }(k) && function(D) {
                let H = D.series, G = function(q) {
                  let N = q.index;
                  return q.series && q.series.data && a(N) && s(q.series.data, function(X) {
                    return !!(X && X.index !== void 0 && X.index > N && X.graphic && X.graphic.element);
                  }) || null;
                }(D), V = G && G.graphic, F = V ? V.parentGroup : H.graph || H.group, U = G ? { x: h(D.plotX, G.plotX, 0), y: h(D.plotY, G.plotY, 0) } : { x: h(D.plotX, 0), y: h(D.plotY, 0) }, Y = function(q, N) {
                  let X = q.series.chart.renderer.rect(N.x, N.y, 1, 1);
                  return X.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), X;
                }(D, U);
                if (F && F.element) return D.graphic = Y, D.hasMockGraphic = !0, Y.add(F), F.element.insertBefore(Y.element, V ? V.element : null), Y.element;
              }(k), P = k.options && k.options.accessibility && k.options.accessibility.enabled === !1;
              if (j) {
                if (k.isNull && !m) {
                  j.setAttribute("aria-hidden", !0);
                  return;
                }
                j.setAttribute("tabindex", "-1"), d.chart.styledMode || (j.style.outline = "none"), i && !P ? function(D, H) {
                  var Y, q, N;
                  let G = D.series, V = ((Y = G.options.accessibility) == null ? void 0 : Y.point) || {}, F = G.chart.options.accessibility.point || {}, U = v(y(V.descriptionFormat) && l(V.descriptionFormat, D, G.chart) || ((q = V.descriptionFormatter) == null ? void 0 : q.call(V, D)) || y(F.descriptionFormat) && l(F.descriptionFormat, D, G.chart) || ((N = F.descriptionFormatter) == null ? void 0 : N.call(F, D)) || b(D), G.chart.renderer.forExport);
                  H.setAttribute("role", "img"), H.setAttribute("aria-label", U);
                }(k, j) : j.setAttribute("aria-hidden", !0);
              }
            });
          }(C), A(o, e), function(d) {
            let i = d.chart, g = i.options.chart, m = g.options3d && g.options3d.enabled, k = i.series.length > 1, j = i.options.accessibility.series.describeSingleSeries, P = (d.options.accessibility || {}).exposeAsGroupOnly;
            return !(m && k) && (k || j || P || x(d));
          }(C) ? function(d, i) {
            let g = d.options.accessibility || {}, m = d.chart.options.accessibility, k = m.landmarkVerbosity;
            g.exposeAsGroupOnly ? i.setAttribute("role", "img") : k === "all" ? i.setAttribute("role", "region") : i.setAttribute("role", "group"), i.setAttribute("tabindex", "-1"), d.chart.styledMode || (i.style.outline = "none"), i.setAttribute("aria-label", v(m.series.descriptionFormatter && m.series.descriptionFormatter(d) || p(d), d.chart.renderer.forExport));
          }(C, e) : e.removeAttribute("aria-label"));
        } };
      }), Z(r, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [r["Core/Globals.js"], r["Core/Utilities.js"], r["Accessibility/Utils/Announcer.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/EventProvider.js"], r["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(T, B, I, R, z, O) {
        let { composed: L } = T, { addEvent: M, defined: w, pushUnique: A } = B, { getChartTitle: l } = R, { defaultPointDescriptionFormatter: u, defaultSeriesDescriptionFormatter: c } = O;
        function v(f) {
          return !!f.options.accessibility.announceNewData.enabled;
        }
        class s {
          constructor(y) {
            this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = y;
          }
          init() {
            let y = this.chart, h = y.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
            this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new z(), this.announcer = new I(y, h), this.addEventListeners();
          }
          destroy() {
            this.eventProvider.removeAddedEvents(), this.announcer.destroy();
          }
          addEventListeners() {
            let y = this, h = this.chart, a = this.eventProvider;
            a.addEvent(h, "afterApplyDrilldown", function() {
              y.lastAnnouncementTime = 0;
            }), a.addEvent(h, "afterAddSeries", function(x) {
              y.onSeriesAdded(x.series);
            }), a.addEvent(h, "redraw", function() {
              y.announceDirtyData();
            });
          }
          onSeriesAdded(y) {
            v(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[y.name + y.index] = y, this.dirty.newSeries = w(this.dirty.newSeries) ? void 0 : y);
          }
          announceDirtyData() {
            let y = this.chart, h = this;
            if (y.options.accessibility.announceNewData && this.dirty.hasDirty) {
              let a = this.dirty.newPoint;
              a && (a = function(x) {
                let S = x.series.data.filter((E) => x.x === E.x && x.y === E.y);
                return S.length === 1 ? S[0] : x;
              }(a)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((x) => h.dirty.allSeries[x]), this.dirty.newSeries, a), this.dirty = { allSeries: {} };
            }
          }
          queueAnnouncement(y, h, a) {
            let x = this.chart.options.accessibility.announceNewData;
            if (x.enabled) {
              let S = +/* @__PURE__ */ new Date(), E = S - this.lastAnnouncementTime, b = Math.max(0, x.minAnnounceInterval - E), p = function(o, t) {
                let e = (o || []).concat(t || []).reduce((n, d) => (n[d.name + d.index] = d, n), {});
                return Object.keys(e).map((n) => e[n]);
              }(this.queuedAnnouncement && this.queuedAnnouncement.series, y), C = this.buildAnnouncementMessage(p, h, a);
              C && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: S, message: C, series: p }, this.queuedAnnouncementTimer = setTimeout(() => {
                this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
              }, b));
            }
          }
          buildAnnouncementMessage(y, h, a) {
            let x = this.chart, S = x.options.accessibility.announceNewData;
            if (S.announcementFormatter) {
              let C = S.announcementFormatter(y, h, a);
              if (C !== !1) return C.length ? C : null;
            }
            let E = T.charts && T.charts.length > 1 ? "Multiple" : "Single", b = h ? "newSeriesAnnounce" + E : a ? "newPointAnnounce" + E : "newDataAnnounce", p = l(x);
            return x.langFormat("accessibility.announceNewData." + b, { chartTitle: p, seriesDesc: h ? c(h) : null, pointDesc: a ? u(a) : null, point: a, series: h });
          }
        }
        return function(f) {
          function y(a) {
            var E;
            let x = this.chart, S = (E = x.accessibility) == null ? void 0 : E.components.series.newDataAnnouncer;
            S && S.chart === x && v(x) && (S.dirty.newPoint = w(S.dirty.newPoint) ? void 0 : a.point);
          }
          function h() {
            var S;
            let a = this.chart, x = (S = a.accessibility) == null ? void 0 : S.components.series.newDataAnnouncer;
            x && x.chart === a && v(a) && (x.dirty.hasDirty = !0, x.dirty.allSeries[this.name + this.index] = this);
          }
          f.compose = function(a) {
            A(L, "A11y.NDA") && (M(a, "addPoint", y), M(a, "updatedData", h));
          };
        }(s), s;
      }), Z(r, "Accessibility/ProxyElement.js", [r["Core/Globals.js"], r["Core/Utilities.js"], r["Accessibility/Utils/EventProvider.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/HTMLUtilities.js"]], function(T, B, I, R, z) {
        let { doc: O } = T, { attr: L, css: M, merge: w } = B, { fireEventOnWrappedOrUnwrappedElement: A } = R, { cloneMouseEvent: l, cloneTouchEvent: u, getFakeMouseEvent: c, removeElement: v } = z;
        return class {
          constructor(s, f, y = "button", h, a) {
            this.chart = s, this.target = f, this.eventProvider = new I();
            let x = this.innerElement = O.createElement(y), S = this.element = h ? O.createElement(h) : x;
            s.styledMode || this.hideElementVisually(x), h && (h !== "li" || s.styledMode || (S.style.listStyle = "none"), S.appendChild(x), this.element = S), this.updateTarget(f, a);
          }
          click() {
            let s = this.getTargetPosition();
            s.x += s.width / 2, s.y += s.height / 2;
            let f = c("click", s);
            A(this.target.click, f);
          }
          updateTarget(s, f) {
            this.target = s, this.updateCSSClassName();
            let y = f || {};
            Object.keys(y).forEach((a) => {
              y[a] === null && delete y[a];
            });
            let h = this.getTargetAttr(s.click, "aria-label");
            L(this.innerElement, w(h ? { "aria-label": h } : {}, y)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, s.click), this.refreshPosition();
          }
          refreshPosition() {
            let s = this.getTargetPosition();
            M(this.innerElement, { width: (s.width || 1) + "px", height: (s.height || 1) + "px", left: (Math.round(s.x) || 0) + "px", top: (Math.round(s.y) || 0) + "px" });
          }
          remove() {
            this.eventProvider.removeAddedEvents(), v(this.element);
          }
          updateCSSClassName() {
            let s = (x) => x.indexOf("highcharts-no-tooltip") > -1, f = this.chart.legend, y = f.group && f.group.div, h = s(y && y.className || ""), a = s(this.getTargetAttr(this.target.click, "class") || "");
            this.innerElement.className = h || a ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
          }
          addProxyEventsToElement(s, f) {
            ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((y) => {
              let h = y.indexOf("touch") === 0;
              this.eventProvider.addEvent(s, y, (a) => {
                let x = h ? u(a) : l(a);
                f && A(f, x), a.stopPropagation(), h || a.preventDefault();
              }, { passive: !1 });
            });
          }
          hideElementVisually(s) {
            M(s, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
          }
          getTargetPosition() {
            let s = this.target.click, f = s.element ? s.element : s, y = this.target.visual || f, h = this.chart.renderTo, a = this.chart.pointer;
            if (h && (y != null && y.getBoundingClientRect) && a) {
              let x = y.getBoundingClientRect(), S = a.getChartPosition();
              return { x: (x.left - S.left) / S.scaleX, y: (x.top - S.top) / S.scaleY, width: x.right / S.scaleX - x.left / S.scaleX, height: x.bottom / S.scaleY - x.top / S.scaleY };
            }
            return { x: 0, y: 0, width: 1, height: 1 };
          }
          getTargetAttr(s, f) {
            return s.element ? s.element.getAttribute(f) : s.getAttribute(f);
          }
        };
      }), Z(r, "Accessibility/ProxyProvider.js", [r["Core/Globals.js"], r["Core/Utilities.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/DOMElementProvider.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Accessibility/ProxyElement.js"]], function(T, B, I, R, z, O) {
        let { doc: L } = T, { attr: M, css: w } = B, { unhideChartElementFromAT: A } = I, { removeChildNodes: l } = z;
        return class {
          constructor(u) {
            this.chart = u, this.domElementProvider = new R(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
          }
          addProxyElement(u, c, v = "button", s) {
            let f = this.groups[u];
            if (!f) throw Error("ProxyProvider.addProxyElement: Invalid group key " + u);
            let y = f.type === "ul" || f.type === "ol" ? "li" : void 0, h = new O(this.chart, c, v, y, s);
            return f.proxyContainerElement.appendChild(h.element), f.proxyElements.push(h), h;
          }
          addGroup(u, c = "div", v) {
            let s, f = this.groups[u];
            if (f) return f.groupElement;
            let y = this.domElementProvider.createElement(c);
            return v && v.role && c !== "div" ? (s = this.domElementProvider.createElement("div")).appendChild(y) : s = y, s.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + u.replace(/\W/g, "-"), this.groups[u] = { proxyContainerElement: y, groupElement: s, type: c, proxyElements: [] }, M(s, v || {}), c === "ul" && y.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(s), this.updateGroupOrder(this.groupOrder), s;
          }
          updateGroupAttrs(u, c) {
            let v = this.groups[u];
            if (!v) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + u);
            M(v.groupElement, c);
          }
          updateGroupOrder(u) {
            if (this.groupOrder = u.slice(), this.isDOMOrderGroupOrder()) return;
            let c = u.indexOf("series"), v = c > -1 ? u.slice(0, c) : u, s = c > -1 ? u.slice(c + 1) : [], f = L.activeElement;
            ["before", "after"].forEach((y) => {
              let h = this[y === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
              l(h), (y === "before" ? v : s).forEach((a) => {
                let x = this.groups[a];
                x && h.appendChild(x.groupElement);
              });
            }), (this.beforeChartProxyPosContainer.contains(f) || this.afterChartProxyPosContainer.contains(f)) && f && f.focus && f.focus();
          }
          clearGroup(u) {
            let c = this.groups[u];
            if (!c) throw Error("ProxyProvider.clearGroup: Invalid group key " + u);
            l(c.proxyContainerElement);
          }
          removeGroup(u) {
            let c = this.groups[u];
            c && (this.domElementProvider.removeElement(c.groupElement), c.groupElement !== c.proxyContainerElement && this.domElementProvider.removeElement(c.proxyContainerElement), delete this.groups[u]);
          }
          update() {
            this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
          }
          updateProxyElementPositions() {
            Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
          }
          updateGroupProxyElementPositions(u) {
            let c = this.groups[u];
            c && c.proxyElements.forEach((v) => v.refreshPosition());
          }
          destroy() {
            this.domElementProvider.destroyCreatedElements();
          }
          createProxyPosContainer(u) {
            let c = this.domElementProvider.createElement("div");
            return c.setAttribute("aria-hidden", "false"), c.className = "highcharts-a11y-proxy-container" + (u ? "-" + u : ""), w(c, { top: "0", left: "0" }), this.chart.styledMode || (c.style.whiteSpace = "nowrap", c.style.position = "absolute"), c;
          }
          getCurrentGroupOrderInDOM() {
            let u = (f) => {
              let y = Object.keys(this.groups), h = y.length;
              for (; h--; ) {
                let a = y[h], x = this.groups[a];
                if (x && f === x.groupElement) return a;
              }
            }, c = (f) => {
              let y = [], h = f.children;
              for (let a = 0; a < h.length; ++a) {
                let x = u(h[a]);
                x && y.push(x);
              }
              return y;
            }, v = c(this.beforeChartProxyPosContainer), s = c(this.afterChartProxyPosContainer);
            return v.push("series"), v.concat(s);
          }
          isDOMOrderGroupOrder() {
            let u = this.getCurrentGroupOrderInDOM(), c = this.groupOrder.filter((s) => s === "series" || !!this.groups[s]), v = u.length;
            if (v !== c.length) return !1;
            for (; v--; ) if (u[v] !== c[v]) return !1;
            return !0;
          }
          updatePosContainerPositions() {
            let u = this.chart;
            if (u.renderer.forExport) return;
            let c = u.renderer.box;
            u.container.insertBefore(this.afterChartProxyPosContainer, c.nextSibling), u.container.insertBefore(this.beforeChartProxyPosContainer, c), A(this.chart, this.afterChartProxyPosContainer), A(this.chart, this.beforeChartProxyPosContainer);
          }
        };
      }), Z(r, "Accessibility/Components/RangeSelectorComponent.js", [r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/Announcer.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { unhideChartElementFromAT: O, getAxisRangeDescription: L } = I, { addEvent: M, attr: w } = z;
        class A extends T {
          init() {
            let u = this.chart;
            this.announcer = new B(u, "polite");
          }
          onChartUpdate() {
            let u = this.chart, c = this, v = u.rangeSelector;
            v && (this.updateSelectorVisibility(), this.setDropdownAttrs(), v.buttons && v.buttons.length && v.buttons.forEach((s) => {
              c.setRangeButtonAttrs(s);
            }), v.maxInput && v.minInput && ["minInput", "maxInput"].forEach(function(s, f) {
              let y = v[s];
              y && (O(u, y), c.setRangeInputAttrs(y, "accessibility.rangeSelector." + (f ? "max" : "min") + "InputLabel"));
            }));
          }
          updateSelectorVisibility() {
            let u = this.chart, c = u.rangeSelector, v = c && c.dropdown, s = c && c.buttons || [], f = (y) => y.setAttribute("aria-hidden", !0);
            c && c.hasVisibleDropdown && v ? (O(u, v), s.forEach((y) => f(y.element))) : (v && f(v), s.forEach((y) => O(u, y.element)));
          }
          setDropdownAttrs() {
            let u = this.chart, c = u.rangeSelector && u.rangeSelector.dropdown;
            if (c) {
              let v = u.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: u.options.lang.rangeSelectorZoom });
              c.setAttribute("aria-label", v), c.setAttribute("tabindex", -1);
            }
          }
          setRangeButtonAttrs(u) {
            w(u.element, { tabindex: -1, role: "button" });
          }
          setRangeInputAttrs(u, c) {
            let v = this.chart;
            w(u, { tabindex: -1, "aria-label": v.langFormat(c, { chart: v }) });
          }
          onButtonNavKbdArrowKey(u, c) {
            let v = u.response, s = this.keyCodes, f = this.chart, y = f.options.accessibility.keyboardNavigation.wrapAround, h = c === s.left || c === s.up ? -1 : 1;
            return f.highlightRangeSelectorButton(f.highlightedRangeSelectorItemIx + h) ? v.success : y ? (u.init(h), v.success) : v[h > 0 ? "next" : "prev"];
          }
          onButtonNavKbdClick(u) {
            let c = u.response, v = this.chart;
            return v.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(v.rangeSelector.buttons[v.highlightedRangeSelectorItemIx].element), c.success;
          }
          onAfterBtnClick() {
            let u = this.chart, c = L(u.xAxis[0]), v = u.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: u, axisRangeDescription: c });
            v && this.announcer.announce(v);
          }
          onInputKbdMove(u) {
            let c = this.chart, v = c.rangeSelector, s = c.highlightedInputRangeIx = (c.highlightedInputRangeIx || 0) + u;
            if (s > 1 || s < 0) {
              if (c.accessibility) return c.accessibility.keyboardNavigation.exiting = !0, c.accessibility.keyboardNavigation.tabindexContainer.focus(), c.accessibility.keyboardNavigation.move(u);
            } else if (v) {
              let f = v[s ? "maxDateBox" : "minDateBox"], y = v[s ? "maxInput" : "minInput"];
              f && y && c.setFocusToElement(f, y);
            }
            return !0;
          }
          onInputNavInit(u) {
            let c = this, v = this.chart, s = u > 0 ? 0 : 1, f = v.rangeSelector, y = f && f[s ? "maxDateBox" : "minDateBox"], h = f && f.minInput, a = f && f.maxInput;
            if (v.highlightedInputRangeIx = s, y && h && a) {
              v.setFocusToElement(y, s ? a : h), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
              let x = (b) => {
                (b.which || b.keyCode) === this.keyCodes.tab && c.onInputKbdMove(b.shiftKey ? -1 : 1) && (b.preventDefault(), b.stopPropagation());
              }, S = M(h, "keydown", x), E = M(a, "keydown", x);
              this.removeInputKeydownHandler = () => {
                S(), E();
              };
            }
          }
          onInputNavTerminate() {
            let u = this.chart.rangeSelector || {};
            u.maxInput && u.hideInput("max"), u.minInput && u.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
          }
          initDropdownNav() {
            let u = this.chart, c = u.rangeSelector, v = c && c.dropdown;
            c && v && (u.setFocusToElement(c.buttonGroup, v), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = M(v, "keydown", (s) => {
              let f = (s.which || s.keyCode) === this.keyCodes.tab, y = u.accessibility;
              f && (s.preventDefault(), s.stopPropagation(), y && (y.keyboardNavigation.tabindexContainer.focus(), y.keyboardNavigation.move(s.shiftKey ? -1 : 1)));
            }));
          }
          getRangeSelectorButtonNavigation() {
            let u = this.chart, c = this.keyCodes, v = this;
            return new R(u, { keyCodeMap: [[[c.left, c.right, c.up, c.down], function(s) {
              return v.onButtonNavKbdArrowKey(this, s);
            }], [[c.enter, c.space], function() {
              return v.onButtonNavKbdClick(this);
            }]], validate: function() {
              return !!(u.rangeSelector && u.rangeSelector.buttons && u.rangeSelector.buttons.length);
            }, init: function(s) {
              let f = u.rangeSelector;
              if (f && f.hasVisibleDropdown) v.initDropdownNav();
              else if (f) {
                let y = f.buttons.length - 1;
                u.highlightRangeSelectorButton(s > 0 ? 0 : y);
              }
            }, terminate: function() {
              v.removeDropdownKeydownHandler && (v.removeDropdownKeydownHandler(), delete v.removeDropdownKeydownHandler);
            } });
          }
          getRangeSelectorInputNavigation() {
            let u = this.chart, c = this;
            return new R(u, { keyCodeMap: [], validate: function() {
              return !!(u.rangeSelector && u.rangeSelector.inputGroup && u.rangeSelector.inputGroup.element.style.visibility !== "hidden" && u.options.rangeSelector.inputEnabled !== !1 && u.rangeSelector.minInput && u.rangeSelector.maxInput);
            }, init: function(v) {
              c.onInputNavInit(v);
            }, terminate: function() {
              c.onInputNavTerminate();
            } });
          }
          getKeyboardNavigation() {
            return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
          }
          destroy() {
            this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
          }
        }
        return function(l) {
          function u(v) {
            let s = this.rangeSelector && this.rangeSelector.buttons || [], f = this.highlightedRangeSelectorItemIx, y = this.rangeSelector && this.rangeSelector.selected;
            return f !== void 0 && s[f] && f !== y && s[f].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = v, !!s[v] && (this.setFocusToElement(s[v].box, s[v].element), v !== y && (this.oldRangeSelectorItemState = s[v].state, s[v].setState(1)), !0);
          }
          function c() {
            let v = this.chart.accessibility;
            if (v && v.components.rangeSelector) return v.components.rangeSelector.onAfterBtnClick();
          }
          l.compose = function(v, s) {
            let f = v.prototype;
            f.highlightRangeSelectorButton || (f.highlightRangeSelectorButton = u, M(s, "afterBtnClick", c));
          };
        }(A), A;
      }), Z(r, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { composed: R } = T, { addEvent: z, merge: O, pushUnique: L } = B;
        return function(M) {
          function w(f) {
            O(!0, f, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
          }
          function A(f) {
            return f.marker.states && f.marker.states.normal && f.marker.states.normal.opacity;
          }
          function l(f) {
            return !!(f._hasPointMarkers && f.points && f.points.length);
          }
          function u() {
            this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), l(this) && this.points.forEach((f) => {
              f.graphic && (f.graphic[f.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), f.graphic[f.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
            }));
          }
          function c(f) {
            this.resetA11yMarkerOptions = O(f.options.marker || {}, this.userOptions.marker || {});
          }
          function v() {
            let f = this.options;
            (function(y) {
              let h = y.chart.options.accessibility.enabled, a = (y.options.accessibility && y.options.accessibility.enabled) !== !1;
              return h && a && function(x) {
                let S = x.chart.options.accessibility;
                return x.points.length < S.series.pointDescriptionEnabledThreshold || S.series.pointDescriptionEnabledThreshold === !1;
              }(y);
            })(this) ? (f.marker && f.marker.enabled === !1 && (this.a11yMarkersForced = !0, w(this.options)), l(this) && function(y) {
              let h = y.points.length;
              for (; h--; ) {
                let a = y.points[h], x = a.options, S = a.hasForcedA11yMarker;
                if (delete a.hasForcedA11yMarker, x.marker) {
                  let E = S && A(x) === 0;
                  x.marker.enabled && !E ? (O(!0, x.marker, { states: { normal: { opacity: A(x) || 1 } } }), a.hasForcedA11yMarker = !1) : x.marker.enabled === !1 && (w(x), a.hasForcedA11yMarker = !0);
                }
              }
            }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(y) {
              let h = y.resetA11yMarkerOptions;
              if (h) {
                let a = h.states && h.states.normal && h.states.normal.opacity;
                y.userOptions && y.userOptions.marker && (y.userOptions.marker.enabled = !0), y.update({ marker: { enabled: h.enabled, states: { normal: { opacity: a } } } });
              }
            }(this), delete this.resetA11yMarkerOptions);
          }
          function s() {
            this.boosted && this.a11yMarkersForced && (O(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
          }
          M.compose = function(f) {
            L(R, "A11y.FM") && (z(f, "afterSetOptions", c), z(f, "render", v), z(f, "afterRender", u), z(f, "renderCanvas", s));
          };
        }(I || (I = {})), I;
      }), Z(r, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [r["Core/Series/Point.js"], r["Core/Series/Series.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Globals.js"], r["Core/Utilities.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Accessibility/Utils/EventProvider.js"], r["Accessibility/Utils/ChartUtilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { seriesTypes: w } = I, { doc: A } = R, { defined: l, fireEvent: u } = z, { getPointFromXY: c, getSeriesFromName: v, scrollAxisToPoint: s } = M;
        function f(b) {
          let p = b.index, C = b.series.points, o = C.length;
          if (C[p] === b) return p;
          for (; o--; ) if (C[o] === b) return o;
        }
        function y(b) {
          let p = b.chart.options.accessibility.keyboardNavigation.seriesNavigation, C = b.options.accessibility || {}, o = C.keyboardNavigation;
          return o && o.enabled === !1 || C.enabled === !1 || b.options.enableMouseTracking === !1 || !b.visible || p.pointNavigationEnabledThreshold && +p.pointNavigationEnabledThreshold <= b.points.length;
        }
        function h(b) {
          let p = b.series.chart.options.accessibility, C = b.options.accessibility && b.options.accessibility.enabled === !1;
          return b.isNull && p.keyboardNavigation.seriesNavigation.skipNullPoints || b.visible === !1 || b.isInside === !1 || C || y(b.series);
        }
        function a(b) {
          let p = b.series || [], C = p.length;
          for (let o = 0; o < C; ++o) if (!y(p[o])) {
            let t = function(e) {
              let n = e.points || [], d = n.length;
              for (let i = 0; i < d; ++i) if (!h(n[i])) return n[i];
              return null;
            }(p[o]);
            if (t) return t;
          }
          return null;
        }
        function x(b) {
          let p = b.series.length, C = !1;
          for (; p-- && (b.highlightedPoint = b.series[p].points[b.series[p].points.length - 1], !(C = b.series[p].highlightNextValidPoint())); ) ;
          return C;
        }
        function S(b) {
          delete b.highlightedPoint;
          let p = a(b);
          return !!p && p.highlight();
        }
        class E {
          constructor(p, C) {
            this.keyCodes = C, this.chart = p;
          }
          init() {
            let p = this, C = this.chart, o = this.eventProvider = new L();
            o.addEvent(B, "destroy", function() {
              return p.onSeriesDestroy(this);
            }), o.addEvent(C, "afterApplyDrilldown", function() {
              (function(t) {
                let e = a(t);
                e && e.highlight(!1);
              })(this);
            }), o.addEvent(C, "drilldown", function(t) {
              let e = t.point, n = e.series;
              p.lastDrilledDownPoint = { x: e.x, y: e.y, seriesName: n ? n.name : "" };
            }), o.addEvent(C, "drillupall", function() {
              setTimeout(function() {
                p.onDrillupAll();
              }, 10);
            }), o.addEvent(T, "afterSetState", function() {
              let t = this.graphic && this.graphic.element, e = A.activeElement, n = e && e.getAttribute("class"), d = n && n.indexOf("highcharts-a11y-proxy-element") > -1;
              C.highlightedPoint === this && e !== t && !d && t && t.focus && t.focus();
            });
          }
          onDrillupAll() {
            let p, C = this.lastDrilledDownPoint, o = this.chart, t = C && v(o, C.seriesName);
            C && t && l(C.x) && l(C.y) && (p = c(t, C.x, C.y)), p = p || a(o), o.container && o.container.focus(), p && p.highlight && p.highlight(!1);
          }
          getKeyboardNavigationHandler() {
            let p = this, C = this.keyCodes, o = this.chart, t = o.inverted;
            return new O(o, { keyCodeMap: [[t ? [C.up, C.down] : [C.left, C.right], function(e) {
              return p.onKbdSideways(this, e);
            }], [t ? [C.left, C.right] : [C.up, C.down], function(e) {
              return p.onKbdVertical(this, e);
            }], [[C.enter, C.space], function(e, n) {
              var i;
              let d = o.highlightedPoint;
              if (d) {
                let { plotLeft: g, plotTop: m } = this.chart, { plotX: k = 0, plotY: j = 0 } = d;
                n = { ...n, chartX: g + k, chartY: m + j, point: d, target: ((i = d.graphic) == null ? void 0 : i.element) || n.target }, u(d.series, "click", n), d.firePointEvent("click", n);
              }
              return this.response.success;
            }], [[C.home], function() {
              return S(o), this.response.success;
            }], [[C.end], function() {
              return x(o), this.response.success;
            }], [[C.pageDown, C.pageUp], function(e) {
              return o.highlightAdjacentSeries(e === C.pageDown), this.response.success;
            }]], init: function() {
              return p.onHandlerInit(this);
            }, validate: function() {
              return !!a(o);
            }, terminate: function() {
              return p.onHandlerTerminate();
            } });
          }
          onKbdSideways(p, C) {
            let o = this.keyCodes, t = C === o.right || C === o.down;
            return this.attemptHighlightAdjacentPoint(p, t);
          }
          onHandlerInit(p) {
            let C = this.chart;
            return C.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && C.highlightedPoint ? C.highlightedPoint.highlight() : S(C), p.response.success;
          }
          onKbdVertical(p, C) {
            let o = this.chart, t = this.keyCodes, e = C === t.down || C === t.right, n = o.options.accessibility.keyboardNavigation.seriesNavigation;
            if (n.mode && n.mode === "serialize") return this.attemptHighlightAdjacentPoint(p, e);
            let d = o.highlightedPoint && o.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
            return o[d](e), p.response.success;
          }
          onHandlerTerminate() {
            let p = this.chart, C = p.options.accessibility.keyboardNavigation;
            p.tooltip && p.tooltip.hide(0);
            let o = p.highlightedPoint && p.highlightedPoint.series;
            o && o.onMouseOut && o.onMouseOut(), p.highlightedPoint && p.highlightedPoint.onMouseOut && p.highlightedPoint.onMouseOut(), C.seriesNavigation.rememberPointFocus || delete p.highlightedPoint;
          }
          attemptHighlightAdjacentPoint(p, C) {
            let o = this.chart, t = o.options.accessibility.keyboardNavigation.wrapAround;
            return o.highlightAdjacentPoint(C) || t && (C ? S(o) : x(o)) ? p.response.success : p.response[C ? "next" : "prev"];
          }
          onSeriesDestroy(p) {
            let C = this.chart;
            C.highlightedPoint && C.highlightedPoint.series === p && (delete C.highlightedPoint, C.focusElement && C.focusElement.removeFocusBorder());
          }
          destroy() {
            this.eventProvider.removeAddedEvents();
          }
        }
        return function(b) {
          function p(n) {
            let d, i, g = this.series, m = this.highlightedPoint, k = m && f(m) || 0, j = m && m.series.points || [], P = this.series && this.series[this.series.length - 1], D = P && P.points && P.points[P.points.length - 1];
            if (!g[0] || !g[0].points) return !1;
            if (m) {
              if (d = g[m.series.index + (n ? 1 : -1)], (i = j[k + (n ? 1 : -1)]) || !d || (i = d.points[n ? 0 : d.points.length - 1]), !i) return !1;
            } else i = n ? g[0].points[0] : D;
            return h(i) ? (y(d = i.series) ? this.highlightedPoint = n ? d.points[d.points.length - 1] : d.points[0] : this.highlightedPoint = i, this.highlightAdjacentPoint(n)) : i.highlight();
          }
          function C(n) {
            let d = this.highlightedPoint, i = 1 / 0, g;
            return !!(l(d.plotX) && l(d.plotY)) && (this.series.forEach((m) => {
              y(m) || m.points.forEach((k) => {
                if (!l(k.plotY) || !l(k.plotX) || k === d) return;
                let j = k.plotY - d.plotY, P = Math.abs(k.plotX - d.plotX), D = Math.abs(j) * Math.abs(j) + P * P * 4;
                m.yAxis && m.yAxis.reversed && (j *= -1), !(j <= 0 && n || j >= 0 && !n || D < 5 || h(k)) && D < i && (i = D, g = k);
              });
            }), !!g && g.highlight());
          }
          function o(n) {
            let d, i, g, m = this.highlightedPoint, k = this.series && this.series[this.series.length - 1], j = k && k.points && k.points[k.points.length - 1];
            return this.highlightedPoint ? !!((d = this.series[m.series.index + (n ? -1 : 1)]) && (i = function(P, D, H, G) {
              let V = 1 / 0, F, U, Y, q = D.points.length, N = (X) => !(l(X.plotX) && l(X.plotY));
              if (!N(P)) {
                for (; q--; ) !N(F = D.points[q]) && (Y = (P.plotX - F.plotX) * (P.plotX - F.plotX) * 4 + (P.plotY - F.plotY) * (P.plotY - F.plotY) * 1) < V && (V = Y, U = q);
                return l(U) ? D.points[U] : void 0;
              }
            }(m, d))) && (y(d) ? (i.highlight(), (g = this.highlightAdjacentSeries(n)) ? g : (m.highlight(), !1)) : (i.highlight(), i.series.highlightNextValidPoint())) : (d = n ? this.series && this.series[0] : k, !!(i = n ? d && d.points && d.points[0] : j) && i.highlight());
          }
          function t(n = !0) {
            var m, k;
            let d = this.series.chart, i = (k = (m = d.tooltip) == null ? void 0 : m.label) == null ? void 0 : k.element;
            !this.isNull && n ? this.onMouseOver() : d.tooltip && d.tooltip.hide(0), s(this), this.graphic && (d.setFocusToElement(this.graphic), !n && d.focusElement && d.focusElement.removeFocusBorder()), d.highlightedPoint = this;
            let g = i == null ? void 0 : i.getBoundingClientRect().top;
            if (i && g && g < 0) {
              let j = window.scrollY;
              window.scrollTo({ behavior: "smooth", top: j + g });
            }
            return this;
          }
          function e() {
            let n = this.chart.highlightedPoint, d = (n && n.series) === this ? f(n) : 0, i = this.points, g = i.length;
            if (i && g) {
              for (let m = d; m < g; ++m) if (!h(i[m])) return i[m].highlight();
              for (let m = d; m >= 0; --m) if (!h(i[m])) return i[m].highlight();
            }
            return !1;
          }
          b.compose = function(n, d, i) {
            let g = n.prototype, m = d.prototype, k = i.prototype;
            g.highlightAdjacentPoint || (g.highlightAdjacentPoint = p, g.highlightAdjacentPointVertical = C, g.highlightAdjacentSeries = o, m.highlight = t, k.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((j) => {
              w[j] && (w[j].prototype.keyboardMoveVertical = !1);
            }), k.highlightNextValidPoint = e);
          };
        }(E), E;
      }), Z(r, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], r["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], r["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], r["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(T, B, I, R, z, O) {
        let { hideSeriesFromAT: L } = B, { describeSeries: M } = z;
        return class extends T {
          static compose(w, A, l) {
            R.compose(l), I.compose(l), O.compose(w, A, l);
          }
          init() {
            this.newDataAnnouncer = new R(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new O(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
          }
          hideTooltipFromATWhenShown() {
            let w = this;
            this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
              this.chart === w.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
            });
          }
          hideSeriesLabelsFromATWhenShown() {
            this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
              this.series.forEach(function(w) {
                w.labelBySeries && w.labelBySeries.attr("aria-hidden", !0);
              });
            });
          }
          onChartRender() {
            this.chart.series.forEach(function(w) {
              (w.options.accessibility && w.options.accessibility.enabled) !== !1 && w.visible && w.getPointsCollection().length !== 0 ? M(w) : L(w);
            });
          }
          getKeyboardNavigation() {
            return this.keyboardNavigation.getKeyboardNavigationHandler();
          }
          destroy() {
            this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
          }
        };
      }), Z(r, "Accessibility/Components/ZoomComponent.js", [r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { unhideChartElementFromAT: O } = B, { getFakeMouseEvent: L } = I, { attr: M, pick: w } = z;
        return class extends T {
          constructor() {
            super(...arguments), this.focusedMapNavButtonIx = -1;
          }
          init() {
            let A = this, l = this.chart;
            this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((u) => {
              A.addEvent(l, u, function() {
                A.updateProxyOverlays();
              });
            });
          }
          onChartUpdate() {
            let A = this.chart, l = this;
            A.mapNavigation && A.mapNavigation.navButtons.forEach((u, c) => {
              O(A, u.element), l.setMapNavButtonAttrs(u.element, "accessibility.zoom.mapZoom" + (c ? "Out" : "In"));
            });
          }
          setMapNavButtonAttrs(A, l) {
            let u = this.chart;
            M(A, { tabindex: -1, role: "button", "aria-label": u.langFormat(l, { chart: u }) });
          }
          onChartRender() {
            this.updateProxyOverlays();
          }
          updateProxyOverlays() {
            let A = this.chart;
            if (this.proxyProvider.clearGroup("zoom"), A.resetZoomButton && this.createZoomProxyButton(A.resetZoomButton, "resetZoomProxyButton", A.langFormat("accessibility.zoom.resetZoomButton", { chart: A })), A.drillUpButton && A.breadcrumbs && A.breadcrumbs.list) {
              let l = A.breadcrumbs.list[A.breadcrumbs.list.length - 1];
              this.createZoomProxyButton(A.drillUpButton, "drillUpProxyButton", A.langFormat("accessibility.drillUpButton", { chart: A, buttonText: A.breadcrumbs.getButtonText(l) }));
            }
          }
          createZoomProxyButton(A, l, u) {
            this[l] = this.proxyProvider.addProxyElement("zoom", { click: A }, "button", { "aria-label": u, tabindex: -1 });
          }
          getMapZoomNavigation() {
            let A = this.keyCodes, l = this.chart, u = this;
            return new R(l, { keyCodeMap: [[[A.up, A.down, A.left, A.right], function(c) {
              return u.onMapKbdArrow(this, c);
            }], [[A.tab], function(c, v) {
              return u.onMapKbdTab(this, v);
            }], [[A.space, A.enter], function() {
              return u.onMapKbdClick(this);
            }]], validate: function() {
              return !!(l.mapView && l.mapNavigation && l.mapNavigation.navButtons.length);
            }, init: function(c) {
              return u.onMapNavInit(c);
            } });
          }
          onMapKbdArrow(A, l) {
            let u = this.chart, c = this.keyCodes, v = u.container, s = l === c.up || l === c.down, f = l === c.left || l === c.up ? 1 : -1, y = (s ? u.plotHeight : u.plotWidth) / 10 * f, h = 10 * Math.random(), a = { x: v.offsetLeft + u.plotLeft + u.plotWidth / 2 + h, y: v.offsetTop + u.plotTop + u.plotHeight / 2 + h }, x = s ? { x: a.x, y: a.y + y } : { x: a.x + y, y: a.y };
            return [L("mousedown", a), L("mousemove", x), L("mouseup", x)].forEach((S) => v.dispatchEvent(S)), A.response.success;
          }
          onMapKbdTab(A, l) {
            let u = this.chart, c = A.response, v = l.shiftKey, s = v && !this.focusedMapNavButtonIx || !v && this.focusedMapNavButtonIx;
            if (u.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), s) return u.mapView && u.mapView.zoomBy(), c[v ? "prev" : "next"];
            this.focusedMapNavButtonIx += v ? -1 : 1;
            let f = u.mapNavigation.navButtons[this.focusedMapNavButtonIx];
            return u.setFocusToElement(f.box, f.element), f.setState(2), c.success;
          }
          onMapKbdClick(A) {
            let l = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
            return this.fakeClickEvent(l), A.response.success;
          }
          onMapNavInit(A) {
            let l = this.chart, u = l.mapNavigation.navButtons[0], c = l.mapNavigation.navButtons[1], v = A > 0 ? u : c;
            l.setFocusToElement(v.box, v.element), v.setState(2), this.focusedMapNavButtonIx = A > 0 ? 0 : 1;
          }
          simpleButtonNavigation(A, l, u) {
            let c = this.keyCodes, v = this, s = this.chart;
            return new R(s, { keyCodeMap: [[[c.tab, c.up, c.down, c.left, c.right], function(f, y) {
              let h = f === c.tab && y.shiftKey || f === c.left || f === c.up;
              return this.response[h ? "prev" : "next"];
            }], [[c.space, c.enter], function() {
              return w(u(this, s), this.response.success);
            }]], validate: function() {
              return s[A] && s[A].box && v[l].innerElement;
            }, init: function() {
              s.setFocusToElement(s[A].box, v[l].innerElement);
            } });
          }
          getKeyboardNavigation() {
            return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(A, l) {
              l.zoomOut();
            }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(A, l) {
              return l.drillUp(), A.response.prev;
            }), this.getMapZoomNavigation()];
          }
        };
      }), Z(r, "Accessibility/HighContrastMode.js", [r["Core/Globals.js"]], function(T) {
        let { doc: B, isMS: I, win: R } = T;
        return { isHighContrastModeActive: function() {
          let z = /(Edg)/.test(R.navigator.userAgent);
          if (R.matchMedia && z) return R.matchMedia("(-ms-high-contrast: active)").matches;
          if (I && R.getComputedStyle) {
            let O = B.createElement("div");
            O.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", B.body.appendChild(O);
            let L = (O.currentStyle || R.getComputedStyle(O)).backgroundImage;
            return B.body.removeChild(O), L === "none";
          }
          return R.matchMedia && R.matchMedia("(forced-colors: active)").matches;
        }, setHighContrastTheme: function(z) {
          var M;
          z.highContrastModeActive = !0;
          let O = z.options.accessibility.highContrastTheme;
          z.update(O, !1);
          let L = ((M = O.colors) == null ? void 0 : M.length) > 1;
          z.series.forEach(function(w) {
            let A = O.plotOptions[w.type] || {}, l = L && w.colorIndex !== void 0 ? O.colors[w.colorIndex] : A.color || "window", u = { color: A.color || "windowText", colors: L ? O.colors : [A.color || "windowText"], borderColor: A.borderColor || "window", fillColor: l };
            w.update(u, !1), w.points && w.points.forEach(function(c) {
              c.options && c.options.color && c.update({ color: A.color || "windowText", borderColor: A.borderColor || "window" }, !1);
            });
          }), z.redraw();
        } };
      }), Z(r, "Accessibility/HighContrastTheme.js", [], function() {
        return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
      }), Z(r, "Accessibility/Options/A11yDefaults.js", [], function() {
        return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
      }), Z(r, "Accessibility/Options/LangDefaults.js", [], function() {
        return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
      }), Z(r, "Accessibility/Options/DeprecatedOptions.js", [r["Core/Utilities.js"]], function(T) {
        let { error: B, pick: I } = T;
        function R(O, L, M) {
          let w = O, A, l = 0;
          for (; l < L.length - 1; ++l) w = w[A = L[l]] = I(w[A], {});
          w[L[L.length - 1]] = M;
        }
        function z(O, L, M, w) {
          function A(c, v) {
            return v.reduce(function(s, f) {
              return s[f];
            }, c);
          }
          let l = A(O.options, L), u = A(O.options, M);
          Object.keys(w).forEach(function(c) {
            let v = l[c];
            v !== void 0 && (R(u, w[c], v), B(32, !1, O, { [L.join(".") + "." + c]: M.join(".") + "." + w[c].join(".") }));
          });
        }
        return function(O) {
          (function(L) {
            let M = L.options.chart, w = L.options.accessibility || {};
            ["description", "typeDescription"].forEach(function(A) {
              M[A] && (w[A] = M[A], B(32, !1, L, { [`chart.${A}`]: `use accessibility.${A}` }));
            });
          })(O), function(L) {
            L.axes.forEach(function(M) {
              let w = M.options;
              w && w.description && (w.accessibility = w.accessibility || {}, w.accessibility.description = w.description, B(32, !1, L, { "axis.description": "use axis.accessibility.description" }));
            });
          }(O), O.series && function(L) {
            let M = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
            L.series.forEach(function(w) {
              Object.keys(M).forEach(function(A) {
                let l = w.options[A];
                A === "accessibility.pointDescriptionFormatter" && (l = w.options.accessibility && w.options.accessibility.pointDescriptionFormatter), l !== void 0 && (R(w.options, M[A], A === "skipKeyboardNavigation" ? !l : l), B(32, !1, L, { [`series.${A}`]: "series." + M[A].join(".") }));
              });
            });
          }(O), z(O, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), z(O, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), z(O, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
        };
      }), Z(r, "Accessibility/Accessibility.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Accessibility/A11yI18n.js"], r["Accessibility/Components/ContainerComponent.js"], r["Accessibility/FocusBorder.js"], r["Accessibility/Components/InfoRegionsComponent.js"], r["Accessibility/KeyboardNavigation.js"], r["Accessibility/Components/LegendComponent.js"], r["Accessibility/Components/MenuComponent.js"], r["Accessibility/Components/NavigatorComponent.js"], r["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], r["Accessibility/ProxyProvider.js"], r["Accessibility/Components/RangeSelectorComponent.js"], r["Accessibility/Components/SeriesComponent/SeriesComponent.js"], r["Accessibility/Components/ZoomComponent.js"], r["Accessibility/HighContrastMode.js"], r["Accessibility/HighContrastTheme.js"], r["Accessibility/Options/A11yDefaults.js"], r["Accessibility/Options/LangDefaults.js"], r["Accessibility/Options/DeprecatedOptions.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u, c, v, s, f, y, h, a, x, S, E) {
        let { defaultOptions: b } = T, { doc: p } = B, { addEvent: C, extend: o, fireEvent: t, merge: e } = I, { removeElement: n } = R;
        class d {
          constructor(g) {
            this.init(g);
          }
          init(g) {
            if (this.chart = g, !p.addEventListener) {
              this.zombie = !0, this.components = {}, g.renderTo.setAttribute("aria-hidden", !0);
              return;
            }
            E(g), this.proxyProvider = new v(this.chart), this.initComponents(), this.keyboardNavigation = new w(g, this.components);
          }
          initComponents() {
            let g = this.chart, m = this.proxyProvider, k = g.options.accessibility;
            this.components = { container: new O(), infoRegions: new M(), legend: new A(), chartMenu: new l(), rangeSelector: new s(), series: new f(), zoom: new y(), navigator: new u() }, k.customComponents && o(this.components, k.customComponents);
            let j = this.components;
            this.getComponentOrder().forEach(function(P) {
              j[P].initBase(g, m), j[P].init();
            });
          }
          getComponentOrder() {
            return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((g) => g !== "series")) : Object.keys(this.components) : [];
          }
          update() {
            let g = this.components, m = this.chart, k = m.options.accessibility;
            t(m, "beforeA11yUpdate"), m.types = this.getChartTypes();
            let j = k.keyboardNavigation.order;
            this.proxyProvider.updateGroupOrder(j), this.getComponentOrder().forEach(function(P) {
              g[P].onChartUpdate(), t(m, "afterA11yComponentUpdate", { name: P, component: g[P] });
            }), this.keyboardNavigation.update(j), !m.highContrastModeActive && k.highContrastMode !== !1 && (h.isHighContrastModeActive() || k.highContrastMode === !0) && h.setHighContrastTheme(m), t(m, "afterA11yUpdate", { accessibility: this });
          }
          destroy() {
            let g = this.chart || {}, m = this.components;
            Object.keys(m).forEach(function(k) {
              m[k].destroy(), m[k].destroyBase();
            }), this.proxyProvider && this.proxyProvider.destroy(), g.announcerContainer && n(g.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), g.renderTo && g.renderTo.setAttribute("aria-hidden", !0), g.focusElement && g.focusElement.removeFocusBorder();
          }
          getChartTypes() {
            let g = {};
            return this.chart.series.forEach(function(m) {
              g[m.type] = 1;
            }), Object.keys(g);
          }
        }
        return function(i) {
          function g() {
            this.accessibility && this.accessibility.destroy();
          }
          function m() {
            this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
            let D = this.accessibility;
            D && !D.zombie && (D.proxyProvider.updateProxyElementPositions(), D.getComponentOrder().forEach(function(H) {
              D.components[H].onChartRender();
            }));
          }
          function k(D) {
            let H = D.options.accessibility;
            H && (H.customComponents && (this.options.accessibility.customComponents = H.customComponents, delete H.customComponents), e(!0, this.options.accessibility, H), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
          }
          function j() {
            let D = this.accessibility, H = this.options.accessibility, G = this.renderer.boxWrapper.element, V = this.title;
            if (H && H.enabled) D && !D.zombie ? D.update() : (this.accessibility = D = new i(this), D && !D.zombie && D.update(), G.getAttribute("role") === "img" && G.removeAttribute("role"));
            else if (D) D.destroy && D.destroy(), delete this.accessibility;
            else {
              this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (V && V.element.textContent || "").replace(/</g, "&lt;")), G.setAttribute("aria-hidden", !0);
              let F = document.getElementsByClassName("highcharts-description")[0];
              F && (F.setAttribute("aria-hidden", !1), F.classList.remove("highcharts-linked-description"));
            }
          }
          function P() {
            this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
          }
          i.i18nFormat = z.i18nFormat, i.compose = function(D, H, G, V, F, U) {
            w.compose(D), c.compose(V), A.compose(D, H), l.compose(D), f.compose(D, G, V), z.compose(D), L.compose(D, F), U && s.compose(D, U);
            let Y = D.prototype;
            Y.updateA11yEnabled || (Y.updateA11yEnabled = j, C(D, "destroy", g), C(D, "render", m), C(D, "update", k), ["addSeries", "init"].forEach((q) => {
              C(D, q, function() {
                this.a11yDirty = !0;
              });
            }), ["afterApplyDrilldown", "drillupall"].forEach((q) => {
              C(D, q, function() {
                let N = this.accessibility;
                N && !N.zombie && N.update();
              });
            }), C(G, "update", P), ["update", "updatedData", "remove"].forEach((q) => {
              C(V, q, function() {
                this.chart.accessibility && (this.chart.a11yDirty = !0);
              });
            }));
          };
        }(d), e(!0, b, x, { accessibility: { highContrastTheme: a }, lang: S }), d;
      }), Z(r, "masters/modules/accessibility.src.js", [r["Core/Globals.js"], r["Accessibility/Accessibility.js"], r["Accessibility/AccessibilityComponent.js"], r["Accessibility/Utils/ChartUtilities.js"], r["Accessibility/Utils/HTMLUtilities.js"], r["Accessibility/KeyboardNavigationHandler.js"], r["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(T, B, I, R, z, O, L) {
        return T.i18nFormat = B.i18nFormat, T.A11yChartUtilities = R, T.A11yHTMLUtilities = z, T.AccessibilityComponent = I, T.KeyboardNavigationHandler = O, T.SeriesAccessibilityDescriber = L, B.compose(T.Chart, T.Legend, T.Point, T.Series, T.SVGElement, T.RangeSelector), T;
      });
    });
  }(we)), we.exports;
}
var xl = ml();
const yl = /* @__PURE__ */ It(xl);
var Se = { exports: {} }, Us;
function bl() {
  return Us || (Us = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Annotations module
    *
    * (c) 2009-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Extensions/Annotations/AnnotationChart.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, erase: R, find: z, fireEvent: O, pick: L, wrap: M } = T;
        function w(s, f) {
          let y = this.initAnnotation(s);
          return this.options.annotations.push(y.options), L(f, !0) && (y.redraw(), y.graphic.attr({ opacity: 1 })), y;
        }
        function A() {
          let s = this;
          s.plotBoxClip = this.renderer.clipRect(this.plotBox), s.controlPointsGroup = s.renderer.g("control-points").attr({ zIndex: 99 }).clip(s.plotBoxClip).add(), s.options.annotations.forEach((f, y) => {
            if (!s.annotations.some((h) => h.options === f)) {
              let h = s.initAnnotation(f);
              s.options.annotations[y] = h.options;
            }
          }), s.drawAnnotations(), I(s, "redraw", s.drawAnnotations), I(s, "destroy", function() {
            s.plotBoxClip.destroy(), s.controlPointsGroup.destroy();
          }), I(s, "exportData", function(f) {
            let y = s.annotations, h = (this.options.exporting && this.options.exporting.csv || {}).columnHeaderFormatter, a = !f.dataRows[1].xValues, x = s.options.lang && s.options.lang.exportData && s.options.lang.exportData.annotationHeader, S = f.dataRows[0].length, E = s.options.exporting && s.options.exporting.csv && s.options.exporting.csv.annotations && s.options.exporting.csv.annotations.itemDelimiter, b = s.options.exporting && s.options.exporting.csv && s.options.exporting.csv.annotations && s.options.exporting.csv.annotations.join;
            y.forEach((o) => {
              o.options.labelOptions && o.options.labelOptions.includeInDataExport && o.labels.forEach((t) => {
                if (t.options.text) {
                  let e = t.options.text;
                  t.points.forEach((n) => {
                    let d = n.x, i = n.series.xAxis ? n.series.xAxis.index : -1, g = !1;
                    if (i === -1) {
                      let m = f.dataRows[0].length, k = Array(m);
                      for (let j = 0; j < m; ++j) k[j] = "";
                      k.push(e), k.xValues = [], k.xValues[i] = d, f.dataRows.push(k), g = !0;
                    }
                    if (g || f.dataRows.forEach((m) => {
                      !g && m.xValues && i !== void 0 && d === m.xValues[i] && (b && m.length > S ? m[m.length - 1] += E + e : m.push(e), g = !0);
                    }), !g) {
                      let m = f.dataRows[0].length, k = Array(m);
                      for (let j = 0; j < m; ++j) k[j] = "";
                      k[0] = d, k.push(e), k.xValues = [], i !== void 0 && (k.xValues[i] = d), f.dataRows.push(k);
                    }
                  });
                }
              });
            });
            let p = 0;
            f.dataRows.forEach((o) => {
              p = Math.max(p, o.length);
            });
            let C = p - f.dataRows[0].length;
            for (let o = 0; o < C; o++) {
              let t = function(e) {
                let n;
                return h && (n = h(e)) !== !1 ? n : (n = x + " " + e, a ? { columnTitle: n, topLevelColumnTitle: n } : n);
              }(o + 1);
              a ? (f.dataRows[0].push(t.topLevelColumnTitle), f.dataRows[1].push(t.columnTitle)) : f.dataRows[0].push(t);
            }
          });
        }
        function l() {
          this.plotBoxClip.attr(this.plotBox), this.annotations.forEach((s) => {
            s.redraw(), s.graphic.animate({ opacity: 1 }, s.animationConfig);
          });
        }
        function u(s) {
          let f = this.annotations, y = s.coll === "annotations" ? s : z(f, function(h) {
            return h.options.id === s;
          });
          y && (O(y, "remove"), R(this.options.annotations, y.options), R(f, y), y.destroy());
        }
        function c() {
          this.annotations = [], this.options.annotations || (this.options.annotations = []);
        }
        function v(s) {
          this.chart.hasDraggedAnnotation || s.apply(this, Array.prototype.slice.call(arguments, 1));
        }
        return (B || (B = {})).compose = function(s, f, y) {
          let h = f.prototype;
          if (!h.addAnnotation) {
            let a = y.prototype;
            I(f, "afterInit", c), h.addAnnotation = w, h.callbacks.push(A), h.collectionsWithInit.annotations = [w], h.collectionsWithUpdate.push("annotations"), h.drawAnnotations = l, h.removeAnnotation = u, h.initAnnotation = function(x) {
              let S = new (s.types[x.type] || s)(this, x);
              return this.annotations.push(S), S;
            }, M(a, "onContainerMouseDown", v);
          }
        }, B;
      }), Z(r, "Extensions/Annotations/AnnotationDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B } = T;
        return { visible: !0, animation: {}, crop: !0, draggable: "xy", labelOptions: { align: "center", allowOverlap: !1, backgroundColor: "rgba(0, 0, 0, 0.75)", borderColor: "#000000", borderRadius: 3, borderWidth: 1, className: "highcharts-no-tooltip", crop: !1, formatter: function() {
          return B(this.y) ? "" + this.y : "Annotation label";
        }, includeInDataExport: !0, overflow: "justify", padding: 5, shadow: !1, shape: "callout", style: { fontSize: "0.7em", fontWeight: "normal", color: "contrast" }, useHTML: !1, verticalAlign: "bottom", x: 0, y: -16 }, shapeOptions: { stroke: "rgba(0, 0, 0, 0.75)", strokeWidth: 1, fill: "rgba(0, 0, 0, 0.75)", r: 0, snap: 2 }, controlPointOptions: { events: {}, style: { cursor: "pointer", fill: "#ffffff", stroke: "#000000", "stroke-width": 2 }, height: 10, symbol: "circle", visible: !1, width: 10 }, events: {}, zIndex: 6 };
      }), Z(r, "Extensions/Annotations/EventEmitter.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I, isTouchDevice: R } = T, { addEvent: z, fireEvent: O, objectEach: L, pick: M, removeEvent: w } = B;
        return class {
          addEvents() {
            let A = this, l = function(u) {
              z(u, R ? "touchstart" : "mousedown", (c) => {
                A.onMouseDown(c);
              }, { passive: !1 });
            };
            if (l(this.graphic.element), (A.labels || []).forEach((u) => {
              u.options.useHTML && u.graphic.text && l(u.graphic.text.element);
            }), L(A.options.events, (u, c) => {
              let v = function(s) {
                var f;
                c === "click" && A.cancelClick || u.call(A, (f = A.chart.pointer) == null ? void 0 : f.normalize(s), A.target);
              };
              (A.nonDOMEvents || []).indexOf(c) === -1 ? (z(A.graphic.element, c, v, { passive: !1 }), A.graphic.div && z(A.graphic.div, c, v, { passive: !1 })) : z(A, c, v, { passive: !1 });
            }), A.options.draggable && (z(A, "drag", A.onDrag), !A.graphic.renderer.styledMode)) {
              let u = { cursor: { x: "ew-resize", y: "ns-resize", xy: "move" }[A.options.draggable] };
              A.graphic.css(u), (A.labels || []).forEach((c) => {
                c.options.useHTML && c.graphic.text && c.graphic.text.css(u);
              });
            }
            A.isUpdating || O(A, "add");
          }
          destroy() {
            this.removeDocEvents(), w(this), this.hcEvents = null;
          }
          mouseMoveToRadians(A, l, u) {
            let c = A.prevChartY - u, v = A.prevChartX - l, s = A.chartY - u, f = A.chartX - l, y;
            return this.chart.inverted && (y = v, v = c, c = y, y = f, f = s, s = y), Math.atan2(s, f) - Math.atan2(c, v);
          }
          mouseMoveToScale(A, l, u) {
            let c = A.prevChartX - l, v = A.prevChartY - u, s = A.chartX - l, f = A.chartY - u, y = (s || 1) / (c || 1), h = (f || 1) / (v || 1);
            if (this.chart.inverted) {
              let a = h;
              h = y, y = a;
            }
            return { x: y, y: h };
          }
          mouseMoveToTranslation(A) {
            let l = A.chartX - A.prevChartX, u = A.chartY - A.prevChartY, c;
            return this.chart.inverted && (c = u, u = l, l = c), { x: l, y: u };
          }
          onDrag(A) {
            if (this.chart.isInsidePlot(A.chartX - this.chart.plotLeft, A.chartY - this.chart.plotTop, { visiblePlotOnly: !0 })) {
              let l = this.mouseMoveToTranslation(A);
              this.options.draggable === "x" && (l.y = 0), this.options.draggable === "y" && (l.x = 0), this.points.length ? this.translate(l.x, l.y) : (this.shapes.forEach((u) => u.translate(l.x, l.y)), this.labels.forEach((u) => u.translate(l.x, l.y))), this.redraw(!1);
            }
          }
          onMouseDown(A) {
            var f;
            if (A.preventDefault && A.preventDefault(), A.button === 2) return;
            let l = this, u = l.chart.pointer, c = ((f = A == null ? void 0 : A.sourceCapabilities) == null ? void 0 : f.firesTouchEvents) || !1, v = (A = (u == null ? void 0 : u.normalize(A)) || A).chartX, s = A.chartY;
            l.cancelClick = !1, l.chart.hasDraggedAnnotation = !0, l.removeDrag = z(I, R || c ? "touchmove" : "mousemove", function(y) {
              l.hasDragged = !0, (y = (u == null ? void 0 : u.normalize(y)) || y).prevChartX = v, y.prevChartY = s, O(l, "drag", y), v = y.chartX, s = y.chartY;
            }, R || c ? { passive: !1 } : void 0), l.removeMouseUp = z(I, R || c ? "touchend" : "mouseup", function() {
              let y = M(l.target && l.target.annotation, l.target);
              y && (y.cancelClick = l.hasDragged), l.cancelClick = l.hasDragged, l.chart.hasDraggedAnnotation = !1, l.hasDragged && O(M(y, l), "afterUpdate"), l.hasDragged = !1, l.onMouseUp();
            }, R || c ? { passive: !1 } : void 0);
          }
          onMouseUp() {
            this.removeDocEvents();
          }
          removeDocEvents() {
            this.removeDrag && (this.removeDrag = this.removeDrag()), this.removeMouseUp && (this.removeMouseUp = this.removeMouseUp());
          }
        };
      }), Z(r, "Extensions/Annotations/ControlPoint.js", [r["Extensions/Annotations/EventEmitter.js"], r["Core/Utilities.js"]], function(T, B) {
        let { merge: I, pick: R } = B;
        return class extends T {
          constructor(z, O, L, M) {
            super(), this.nonDOMEvents = ["drag"], this.chart = z, this.target = O, this.options = L, this.index = R(L.index, M);
          }
          destroy() {
            super.destroy(), this.graphic && (this.graphic = this.graphic.destroy()), this.chart = null, this.target = null, this.options = null;
          }
          redraw(z) {
            this.graphic[z ? "animate" : "attr"](this.options.positioner.call(this, this.target));
          }
          render() {
            let z = this.chart, O = this.options;
            this.graphic = z.renderer.symbol(O.symbol, 0, 0, O.width, O.height).add(z.controlPointsGroup).css(O.style), this.setVisibility(O.visible), this.addEvents();
          }
          setVisibility(z) {
            this.graphic[z ? "show" : "hide"](), this.options.visible = z;
          }
          update(z) {
            let O = this.chart, L = this.target, M = this.index, w = I(!0, this.options, z);
            this.destroy(), this.constructor(O, L, w, M), this.render(O.controlPointsGroup), this.redraw();
          }
        };
      }), Z(r, "Extensions/Annotations/MockPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { series: { prototype: I } } = T, { defined: R, fireEvent: z } = B;
        class O {
          static fromPoint(M) {
            return new O(M.series.chart, null, { x: M.x, y: M.y, xAxis: M.series.xAxis, yAxis: M.series.yAxis });
          }
          static pointToPixels(M, w) {
            let A = M.series, l = A.chart, u = M.plotX || 0, c = M.plotY || 0, v;
            return l.inverted && (M.mock ? (u = M.plotY, c = M.plotX) : (u = l.plotWidth - (M.plotY || 0), c = l.plotHeight - (M.plotX || 0))), A && !w && (u += (v = A.getPlotBox()).translateX, c += v.translateY), { x: u, y: c };
          }
          static pointToOptions(M) {
            return { x: M.x, y: M.y, xAxis: M.series.xAxis, yAxis: M.series.yAxis };
          }
          constructor(M, w, A) {
            this.mock = !0, this.series = { visible: !0, chart: M, getPlotBox: I.getPlotBox }, this.target = w || null, this.options = A, this.applyOptions(this.getOptions());
          }
          applyOptions(M) {
            this.command = M.command, this.setAxis(M, "x"), this.setAxis(M, "y"), this.refresh();
          }
          getLabelConfig() {
            return { x: this.x, y: this.y, point: this };
          }
          getOptions() {
            return this.hasDynamicOptions() ? this.options(this.target) : this.options;
          }
          hasDynamicOptions() {
            return typeof this.options == "function";
          }
          isInsidePlot() {
            let M = this.plotX, w = this.plotY, A = this.series.xAxis, l = this.series.yAxis, u = { x: M, y: w, isInsidePlot: !0, options: {} };
            return A && (u.isInsidePlot = R(M) && M >= 0 && M <= A.len), l && (u.isInsidePlot = u.isInsidePlot && R(w) && w >= 0 && w <= l.len), z(this.series.chart, "afterIsInsidePlot", u), u.isInsidePlot;
          }
          refresh() {
            let M = this.series, w = M.xAxis, A = M.yAxis, l = this.getOptions();
            w ? (this.x = l.x, this.plotX = w.toPixels(l.x, !0)) : (this.x = void 0, this.plotX = l.x), A ? (this.y = l.y, this.plotY = A.toPixels(l.y, !0)) : (this.y = null, this.plotY = l.y), this.isInside = this.isInsidePlot();
          }
          refreshOptions() {
            let M = this.series, w = M.xAxis, A = M.yAxis;
            this.x = this.options.x = w ? this.options.x = w.toValue(this.plotX, !0) : this.plotX, this.y = this.options.y = A ? A.toValue(this.plotY, !0) : this.plotY;
          }
          rotate(M, w, A) {
            if (!this.hasDynamicOptions()) {
              let l = Math.cos(A), u = Math.sin(A), c = this.plotX - M, v = this.plotY - w;
              this.plotX = c * l - v * u + M, this.plotY = c * u + v * l + w, this.refreshOptions();
            }
          }
          scale(M, w, A, l) {
            if (!this.hasDynamicOptions()) {
              let u = this.plotX * A, c = this.plotY * l;
              this.plotX = (1 - A) * M + u, this.plotY = (1 - l) * w + c, this.refreshOptions();
            }
          }
          setAxis(M, w) {
            let A = w + "Axis", l = M[A], u = this.series.chart;
            this.series[A] = typeof l == "object" ? l : R(l) ? u[A][l] || u.get(l) : null;
          }
          toAnchor() {
            let M = [this.plotX, this.plotY, 0, 0];
            return this.series.chart.inverted && (M[0] = this.plotY, M[1] = this.plotX), M;
          }
          translate(M, w, A, l) {
            this.hasDynamicOptions() || (this.plotX += A, this.plotY += l, this.refreshOptions());
          }
        }
        return O;
      }), Z(r, "Extensions/Annotations/ControlTarget.js", [r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        return function(z) {
          function O() {
            let h = this.controlPoints, a = this.options.controlPoints || [];
            a.forEach((x, S) => {
              let E = I.merge(this.options.controlPointOptions, x);
              E.index || (E.index = S), a[S] = E, h.push(new T(this.chart, this, E));
            });
          }
          function L(h) {
            let a = h.series.getPlotBox(), x = h.series.chart, S = h.mock ? h.toAnchor() : x.tooltip && x.tooltip.getAnchor.call({ chart: h.series.chart }, h) || [0, 0, 0, 0], E = { x: S[0] + (this.options.x || 0), y: S[1] + (this.options.y || 0), height: S[2] || 0, width: S[3] || 0 };
            return { relativePosition: E, absolutePosition: I.merge(E, { x: E.x + (h.mock ? a.translateX : x.plotLeft), y: E.y + (h.mock ? a.translateY : x.plotTop) }) };
          }
          function M() {
            this.controlPoints.forEach((h) => h.destroy()), this.chart = null, this.controlPoints = null, this.points = null, this.options = null, this.annotation && (this.annotation = null);
          }
          function w() {
            let h = this.options;
            return h.points || h.point && I.splat(h.point);
          }
          function A() {
            let h, a, x = this.getPointsOptions(), S = this.points, E = x && x.length || 0;
            for (h = 0; h < E; h++) {
              if (!(a = this.point(x[h], S[h]))) {
                S.length = 0;
                return;
              }
              a.mock && a.refresh(), S[h] = a;
            }
            return S;
          }
          function l(h, a) {
            if (h && h.series) return h;
            if (!a || a.series === null) {
              if (I.isObject(h)) a = new B(this.chart, this, h);
              else if (I.isString(h)) a = this.chart.get(h) || null;
              else if (typeof h == "function") {
                let x = h.call(a, this);
                a = x.series ? x : new B(this.chart, this, h);
              }
            }
            return a;
          }
          function u(h) {
            this.controlPoints.forEach((a) => a.redraw(h));
          }
          function c() {
            this.controlPoints.forEach((h) => h.render());
          }
          function v(h, a, x, S, E) {
            if (this.chart.inverted) {
              let b = a;
              a = x, x = b;
            }
            this.points.forEach((b, p) => this.transformPoint(h, a, x, S, E, p), this);
          }
          function s(h, a, x, S, E, b) {
            let p = this.points[b];
            p.mock || (p = this.points[b] = B.fromPoint(p)), p[h](a, x, S, E);
          }
          function f(h, a) {
            this.transform("translate", null, null, h, a);
          }
          function y(h, a, x) {
            this.transformPoint("translate", null, null, h, a, x);
          }
          z.compose = function(h) {
            let a = h.prototype;
            a.addControlPoints || I.merge(!0, a, { addControlPoints: O, anchor: L, destroyControlTarget: M, getPointsOptions: w, linkPoints: A, point: l, redrawControlPoints: u, renderControlPoints: c, transform: v, transformPoint: s, translate: f, translatePoint: y });
          };
        }(R || (R = {})), R;
      }), Z(r, "Extensions/Annotations/Controllables/Controllable.js", [r["Extensions/Annotations/ControlTarget.js"], r["Core/Utilities.js"]], function(T, B) {
        let { merge: I } = B;
        class R {
          constructor(O, L, M, w) {
            this.annotation = O, this.chart = O.chart, this.collection = w === "label" ? "labels" : "shapes", this.controlPoints = [], this.options = L, this.points = [], this.index = M, this.itemType = w, this.init(O, L, M);
          }
          attr(...O) {
            this.graphic.attr.apply(this.graphic, arguments);
          }
          attrsFromOptions(O) {
            let L, M, w = this.constructor.attrsMap, A = {}, l = this.chart.styledMode;
            for (L in O) M = w[L], w[L] === void 0 || l && ["fill", "stroke", "stroke-width"].indexOf(M) !== -1 || (A[M] = O[L]);
            return A;
          }
          destroy() {
            this.graphic && (this.graphic = this.graphic.destroy()), this.tracker && (this.tracker = this.tracker.destroy()), this.destroyControlTarget();
          }
          init(O, L, M) {
            this.annotation = O, this.chart = O.chart, this.options = L, this.points = [], this.controlPoints = [], this.index = M, this.linkPoints(), this.addControlPoints();
          }
          redraw(O) {
            this.redrawControlPoints(O);
          }
          render(O) {
            this.options.className && this.graphic && this.graphic.addClass(this.options.className), this.renderControlPoints();
          }
          rotate(O, L, M) {
            this.transform("rotate", O, L, M);
          }
          scale(O, L, M, w) {
            this.transform("scale", O, L, M, w);
          }
          setControlPointsVisibility(O) {
            this.controlPoints.forEach((L) => {
              L.setVisibility(O);
            });
          }
          shouldBeDrawn() {
            return !!this.points.length;
          }
          translateShape(O, L, M) {
            let w = this.annotation.chart, A = this.annotation.userOptions, l = w.annotations.indexOf(this.annotation), u = w.options.annotations[l];
            this.translatePoint(O, L, 0), M && this.translatePoint(O, L, 1), u[this.collection][this.index].point = this.options.point, A[this.collection][this.index].point = this.options.point;
          }
          update(O) {
            let L = this.annotation, M = I(!0, this.options, O), w = this.graphic.parentGroup, A = this.constructor;
            this.destroy(), I(!0, this, new A(L, M, this.index, this.itemType)), this.render(w), this.redraw();
          }
        }
        return T.compose(R), R;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableDefaults.js", [], function() {
        return { defaultMarkers: { arrow: { tagName: "marker", attributes: { id: "arrow", refY: 5, refX: 9, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 0 L 10 5 L 0 10 Z", "stroke-width": 0 } }] }, "reverse-arrow": { tagName: "marker", attributes: { id: "reverse-arrow", refY: 5, refX: 1, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 5 L 10 0 L 10 10 Z", "stroke-width": 0 } }] } } };
      }), Z(r, "Extensions/Annotations/Controllables/ControllablePath.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllableDefaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { defaultMarkers: z } = B, { addEvent: O, defined: L, extend: M, merge: w, uniqueKey: A } = R, l = v("marker-end"), u = v("marker-start"), c = "rgba(192,192,192," + (I.svg ? 1e-4 : 2e-3) + ")";
        function v(h) {
          return function(a) {
            this.attr(h, "url(#" + a + ")");
          };
        }
        function s() {
          this.options.defs = w(z, this.options.defs || {});
        }
        function f(h, a) {
          let x = { attributes: { id: h } }, S = { stroke: a.color || "none", fill: a.color || "rgba(0, 0, 0, 0.75)" };
          x.children = a.children && a.children.map(function(p) {
            return w(S, p);
          });
          let E = w(!0, { attributes: { markerWidth: 20, markerHeight: 20, refX: 0, refY: 0, orient: "auto" } }, a, x), b = this.definition(E);
          return b.id = h, b;
        }
        class y extends T {
          static compose(a, x) {
            let S = x.prototype;
            S.addMarker || (O(a, "afterGetContainer", s), S.addMarker = f);
          }
          constructor(a, x, S) {
            super(a, x, S, "shape"), this.type = "path";
          }
          toD() {
            let a = this.options.d;
            if (a) return typeof a == "function" ? a.call(this) : a;
            let x = this.points, S = x.length, E = [], b = S, p = x[0], C = b && this.anchor(p).absolutePosition, o = 0, t;
            if (C) for (E.push(["M", C.x, C.y]); ++o < S && b; ) t = (p = x[o]).command || "L", C = this.anchor(p).absolutePosition, t === "M" ? E.push([t, C.x, C.y]) : t === "L" ? E.push([t, C.x, C.y]) : t === "Z" && E.push([t]), b = p.series.visible;
            return b && this.graphic ? this.chart.renderer.crispLine(E, this.graphic.strokeWidth()) : null;
          }
          shouldBeDrawn() {
            return super.shouldBeDrawn() || !!this.options.d;
          }
          render(a) {
            let x = this.options, S = this.attrsFromOptions(x);
            this.graphic = this.annotation.chart.renderer.path([["M", 0, 0]]).attr(S).add(a), this.tracker = this.annotation.chart.renderer.path([["M", 0, 0]]).addClass("highcharts-tracker-line").attr({ zIndex: 2 }).add(a), this.annotation.chart.styledMode || this.tracker.attr({ "stroke-linejoin": "round", stroke: c, fill: c, "stroke-width": this.graphic.strokeWidth() + 2 * x.snap }), super.render(), M(this.graphic, { markerStartSetter: u, markerEndSetter: l }), this.setMarkers(this);
          }
          redraw(a) {
            if (this.graphic) {
              let x = this.toD(), S = a ? "animate" : "attr";
              x ? (this.graphic[S]({ d: x }), this.tracker[S]({ d: x })) : (this.graphic.attr({ d: "M 0 -9000000000" }), this.tracker.attr({ d: "M 0 -9000000000" })), this.graphic.placed = this.tracker.placed = !!x;
            }
            super.redraw(a);
          }
          setMarkers(a) {
            let x = a.options, S = a.chart, E = S.options.defs, b = x.fill, p = L(b) && b !== "none" ? b : x.stroke;
            ["markerStart", "markerEnd"].forEach(function(C) {
              let o, t, e, n, d = x[C];
              if (d) {
                for (e in E) if ((d === ((o = E[e]).attributes && o.attributes.id) || d === o.id) && o.tagName === "marker") {
                  t = o;
                  break;
                }
                t && (n = a[C] = S.renderer.addMarker((x.id || A()) + "-" + d, w(t, { color: p })), a.attr(C, n.getAttribute("id")));
              }
            });
          }
        }
        return y.attrsMap = { dashStyle: "dashstyle", strokeWidth: "stroke-width", stroke: "stroke", fill: "fill", zIndex: "zIndex" }, y;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableRect.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends T {
          constructor(L, M, w) {
            super(L, M, w, "shape"), this.type = "rect", this.translate = super.translateShape;
          }
          render(L) {
            let M = this.attrsFromOptions(this.options);
            this.graphic = this.annotation.chart.renderer.rect(0, -9e9, 0, 0).attr(M).add(L), super.render();
          }
          redraw(L) {
            if (this.graphic) {
              let M = this.anchor(this.points[0]).absolutePosition;
              M ? this.graphic[L ? "animate" : "attr"]({ x: M.x, y: M.y, width: this.options.width, height: this.options.height }) : this.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!M;
            }
            super.redraw(L);
          }
        }
        return z.attrsMap = R(B.attrsMap, { width: "width", height: "height" }), z;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableCircle.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends T {
          constructor(L, M, w) {
            super(L, M, w, "shape"), this.type = "circle", this.translate = super.translateShape;
          }
          redraw(L) {
            if (this.graphic) {
              let M = this.anchor(this.points[0]).absolutePosition;
              M ? this.graphic[L ? "animate" : "attr"]({ x: M.x, y: M.y, r: this.options.r }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!M;
            }
            super.redraw.call(this, L);
          }
          render(L) {
            let M = this.attrsFromOptions(this.options);
            this.graphic = this.annotation.chart.renderer.circle(0, -9e9, 0).attr(M).add(L), super.render();
          }
          setRadius(L) {
            this.options.r = L;
          }
        }
        return z.attrsMap = R(B.attrsMap, { r: "r" }), z;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableEllipse.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R, defined: z } = I;
        class O extends T {
          constructor(M, w, A) {
            super(M, w, A, "shape"), this.type = "ellipse";
          }
          init(M, w, A) {
            z(w.yAxis) && w.points.forEach((l) => {
              l.yAxis = w.yAxis;
            }), z(w.xAxis) && w.points.forEach((l) => {
              l.xAxis = w.xAxis;
            }), super.init(M, w, A);
          }
          render(M) {
            this.graphic = this.annotation.chart.renderer.createElement("ellipse").attr(this.attrsFromOptions(this.options)).add(M), super.render();
          }
          translate(M, w) {
            super.translateShape(M, w, !0);
          }
          getDistanceFromLine(M, w, A, l) {
            return Math.abs((w.y - M.y) * A - (w.x - M.x) * l + w.x * M.y - w.y * M.x) / Math.sqrt((w.y - M.y) * (w.y - M.y) + (w.x - M.x) * (w.x - M.x));
          }
          getAttrs(M, w) {
            let A = M.x, l = M.y, u = w.x, c = w.y, v = (A + u) / 2, s = Math.sqrt((A - u) * (A - u) / 4 + (l - c) * (l - c) / 4), f = 180 * Math.atan((c - l) / (u - A)) / Math.PI;
            return v < A && (f += 180), { cx: v, cy: (l + c) / 2, rx: s, ry: this.getRY(), angle: f };
          }
          getRY() {
            let M = this.getYAxis();
            return z(M) ? Math.abs(M.toPixels(this.options.ry) - M.toPixels(0)) : this.options.ry;
          }
          getYAxis() {
            let M = this.options.yAxis;
            return this.chart.yAxis[M];
          }
          getAbsolutePosition(M) {
            return this.anchor(M).absolutePosition;
          }
          redraw(M) {
            if (this.graphic) {
              let w = this.getAbsolutePosition(this.points[0]), A = this.getAbsolutePosition(this.points[1]), l = this.getAttrs(w, A);
              w ? this.graphic[M ? "animate" : "attr"]({ cx: l.cx, cy: l.cy, rx: l.rx, ry: l.ry, rotation: l.angle, rotationOriginX: l.cx, rotationOriginY: l.cy }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!w;
            }
            super.redraw(M);
          }
          setYRadius(M) {
            let w = this.annotation.userOptions.shapes;
            this.options.ry = M, w && w[0] && (w[0].ry = M, w[0].ry = M);
          }
        }
        return O.attrsMap = R(B.attrsMap, { ry: "ry" }), O;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableLabel.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Core/Templating.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { format: z } = B, { extend: O, isNumber: L, pick: M } = R;
        function w(l, u, c, v, s) {
          let f = s && s.anchorX, y = s && s.anchorY, h, a, x = c / 2;
          return L(f) && L(y) && (h = [["M", f, y]], (a = u - y) < 0 && (a = -v - a), a < c && (x = f < l + c / 2 ? a : c - a), y > u + v ? h.push(["L", l + x, u + v]) : y < u ? h.push(["L", l + x, u]) : f < l ? h.push(["L", l, u + v / 2]) : f > l + c && h.push(["L", l + c, u + v / 2])), h || [];
        }
        class A extends T {
          static alignedPosition(u, c) {
            let v = u.align, s = u.verticalAlign, f = (c.x || 0) + (u.x || 0), y = (c.y || 0) + (u.y || 0), h, a;
            return v === "right" ? h = 1 : v === "center" && (h = 2), h && (f += (c.width - (u.width || 0)) / h), s === "bottom" ? a = 1 : s === "middle" && (a = 2), a && (y += (c.height - (u.height || 0)) / a), { x: Math.round(f), y: Math.round(y) };
          }
          static compose(u) {
            u.prototype.symbols.connector = w;
          }
          static justifiedOptions(u, c, v, s) {
            let f, y = v.align, h = v.verticalAlign, a = c.box ? 0 : c.padding || 0, x = c.getBBox(), S = { align: y, verticalAlign: h, x: v.x, y: v.y, width: c.width, height: c.height }, E = (s.x || 0) - u.plotLeft, b = (s.y || 0) - u.plotTop;
            return (f = E + a) < 0 && (y === "right" ? S.align = "left" : S.x = (S.x || 0) - f), (f = E + x.width - a) > u.plotWidth && (y === "left" ? S.align = "right" : S.x = (S.x || 0) + u.plotWidth - f), (f = b + a) < 0 && (h === "bottom" ? S.verticalAlign = "top" : S.y = (S.y || 0) - f), (f = b + x.height - a) > u.plotHeight && (h === "top" ? S.verticalAlign = "bottom" : S.y = (S.y || 0) + u.plotHeight - f), S;
          }
          constructor(u, c, v) {
            super(u, c, v, "label");
          }
          translatePoint(u, c) {
            super.translatePoint(u, c, 0);
          }
          translate(u, c) {
            let v = this.annotation.chart, s = this.annotation.userOptions, f = v.annotations.indexOf(this.annotation), y = v.options.annotations[f];
            if (v.inverted) {
              let h = u;
              u = c, c = h;
            }
            this.options.x += u, this.options.y += c, y[this.collection][this.index].x = this.options.x, y[this.collection][this.index].y = this.options.y, s[this.collection][this.index].x = this.options.x, s[this.collection][this.index].y = this.options.y;
          }
          render(u) {
            let c = this.options, v = this.attrsFromOptions(c), s = c.style;
            this.graphic = this.annotation.chart.renderer.label("", 0, -9999, c.shape, null, null, c.useHTML, null, "annotation-label").attr(v).add(u), this.annotation.chart.styledMode || (s.color === "contrast" && (s.color = this.annotation.chart.renderer.getContrast(A.shapesWithoutBackground.indexOf(c.shape) > -1 ? "#FFFFFF" : c.backgroundColor)), this.graphic.css(c.style).shadow(c.shadow)), this.graphic.labelrank = c.labelrank, super.render();
          }
          redraw(u) {
            let c = this.options, v = this.text || c.format || c.text, s = this.graphic, f = this.points[0];
            if (!s) {
              this.redraw(u);
              return;
            }
            s.attr({ text: v ? z(String(v), f.getLabelConfig(), this.annotation.chart) : c.formatter.call(f, this) });
            let y = this.anchor(f), h = this.position(y);
            h ? (s.alignAttr = h, h.anchorX = y.absolutePosition.x, h.anchorY = y.absolutePosition.y, s[u ? "animate" : "attr"](h)) : s.attr({ x: 0, y: -9999 }), s.placed = !!h, super.redraw(u);
          }
          anchor(u) {
            let c = super.anchor.apply(this, arguments), v = this.options.x || 0, s = this.options.y || 0;
            return c.absolutePosition.x -= v, c.absolutePosition.y -= s, c.relativePosition.x -= v, c.relativePosition.y -= s, c;
          }
          position(u) {
            let c = this.graphic, v = this.annotation.chart, s = v.tooltip, f = this.points[0], y = this.options, h = u.absolutePosition, a = u.relativePosition, x, S, E, b, p = f.series.visible && I.prototype.isInsidePlot.call(f);
            if (c && p) {
              let { width: C = 0, height: o = 0 } = c;
              y.distance && s ? x = s.getPosition.call({ chart: v, distance: M(y.distance, 16), getPlayingField: s.getPlayingField, pointer: s.pointer }, C, o, { plotX: a.x, plotY: a.y, negative: f.negative, ttBelow: f.ttBelow, h: a.height || a.width }) : y.positioner ? x = y.positioner.call(this) : (S = { x: h.x, y: h.y, width: 0, height: 0 }, x = A.alignedPosition(O(y, { width: C, height: o }), S), this.options.overflow === "justify" && (x = A.alignedPosition(A.justifiedOptions(v, c, y, x), S))), y.crop && (E = x.x - v.plotLeft, b = x.y - v.plotTop, p = v.isInsidePlot(E, b) && v.isInsidePlot(E + C, b + o));
            }
            return p ? x : null;
          }
        }
        return A.attrsMap = { backgroundColor: "fill", borderColor: "stroke", borderWidth: "stroke-width", zIndex: "zIndex", borderRadius: "r", padding: "padding" }, A.shapesWithoutBackground = ["connector"], A;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableImage.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllableLabel.js"]], function(T, B) {
        class I extends T {
          constructor(z, O, L) {
            super(z, O, L, "shape"), this.type = "image", this.translate = super.translateShape;
          }
          render(z) {
            let O = this.attrsFromOptions(this.options), L = this.options;
            this.graphic = this.annotation.chart.renderer.image(L.src, 0, -9e9, L.width, L.height).attr(O).add(z), this.graphic.width = L.width, this.graphic.height = L.height, super.render();
          }
          redraw(z) {
            if (this.graphic) {
              let O = this.anchor(this.points[0]), L = B.prototype.position.call(this, O);
              L ? this.graphic[z ? "animate" : "attr"]({ x: L.x, y: L.y }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!L;
            }
            super.redraw(z);
          }
        }
        return I.attrsMap = { width: "width", height: "height", zIndex: "zIndex" }, I;
      }), Z(r, "Shared/BaseForm.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Utilities.js"]], function(T, B) {
        let { addEvent: I, createElement: R } = B;
        return class {
          constructor(z, O) {
            this.iconsURL = O, this.container = this.createPopupContainer(z), this.closeButton = this.addCloseButton();
          }
          createPopupContainer(z, O = "highcharts-popup highcharts-no-tooltip") {
            return R("div", { className: O }, void 0, z);
          }
          addCloseButton(z = "highcharts-popup-close") {
            let O = this, L = this.iconsURL, M = R("button", { className: z }, void 0, this.container);
            return M.style["background-image"] = "url(" + (L.match(/png|svg|jpeg|jpg|gif/ig) ? L : L + "close.svg") + ")", ["click", "touchstart"].forEach((w) => {
              I(M, w, O.closeButtonEvents.bind(O));
            }), I(document, "keydown", function(w) {
              w.code === "Escape" && O.closeButtonEvents();
            }), M;
          }
          closeButtonEvents() {
            this.closePopup();
          }
          showPopup(z = "highcharts-annotation-toolbar") {
            let O = this.container, L = this.closeButton;
            this.type = void 0, O.innerHTML = T.emptyHTML, O.className.indexOf(z) >= 0 && (O.classList.remove(z), O.removeAttribute("style")), O.appendChild(L), O.style.display = "block", O.style.height = "";
          }
          closePopup() {
            this.container.style.display = "none";
          }
        };
      }), Z(r, "Extensions/Annotations/Popup/PopupAnnotations.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I, isFirefox: R } = T, { createElement: z, isArray: O, isObject: L, objectEach: M, pick: w, stableSort: A } = B;
        function l(u, c, v, s, f, y) {
          let h, a;
          if (!c) return;
          let x = this.addInput, S = this.lang;
          M(s, (E, b) => {
            h = v !== "" ? v + "." + b : b, L(E) && (!O(E) || O(E) && L(E[0]) ? ((a = S[b] || b).match(/\d/g) || f.push([!0, a, u]), l.call(this, u, c, h, E, f, !1)) : f.push([this, h, "annotation", u, E]));
          }), y && (A(f, (E) => E[1].match(/format/g) ? -1 : 1), R && f.reverse(), f.forEach((E) => {
            E[0] === !0 ? z("span", { className: "highcharts-annotation-title" }, void 0, E[2]).appendChild(I.createTextNode(E[1])) : (E[4] = { value: E[4][0], type: E[4][1] }, x.apply(E[0], E.splice(1)));
          }));
        }
        return { addForm: function(u, c, v, s) {
          if (!u) return;
          let f = this.container, y = this.lang, h = z("h2", { className: "highcharts-popup-main-title" }, void 0, f);
          h.appendChild(I.createTextNode(y[c.langKey] || c.langKey || "")), h = z("div", { className: "highcharts-popup-lhs-col highcharts-popup-lhs-full" }, void 0, f);
          let a = z("div", { className: "highcharts-popup-bottom-row" }, void 0, f);
          l.call(this, h, u, "", c, [], !0), this.addButton(a, s ? y.addButton || "Add" : y.saveButton || "Save", s ? "add" : "save", f, v);
        }, addToolbar: function(u, c, v) {
          let s = this.lang, f = this.container, y = this.showForm, h = "highcharts-annotation-toolbar";
          f.className.indexOf(h) === -1 && (f.className += " " + h + " highcharts-no-mousewheel"), u && (f.style.top = u.plotTop + 10 + "px");
          let a = z("p", { className: "highcharts-annotation-label" }, void 0, f);
          a.setAttribute("aria-label", "Annotation type"), a.appendChild(I.createTextNode(w(s[c.langKey] || c.langKey, c.shapes && c.shapes[0].type, "")));
          let x = this.addButton(f, s.editButton || "Edit", "edit", f, () => {
            y.call(this, "annotation-edit", u, c, v);
          });
          x.className += " highcharts-annotation-edit-button", x.style["background-image"] = "url(" + this.iconsURL + "edit.svg)", x = this.addButton(f, s.removeButton || "Remove", "remove", f, v), x.className += " highcharts-annotation-remove-button", x.style["background-image"] = "url(" + this.iconsURL + "destroy.svg)";
        } };
      }), Z(r, "Extensions/Annotations/Popup/PopupIndicators.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z, O;
        let { doc: L } = B, { seriesTypes: M } = I, { addEvent: w, createElement: A, defined: l, isArray: u, isObject: c, objectEach: v, stableSort: s } = R;
        (O = z || (z = {}))[O["params.algorithm"] = 0] = "params.algorithm", O[O["params.average"] = 1] = "params.average";
        let f = { "algorithm-pivotpoints": ["standard", "fibonacci", "camarilla"], "average-disparityindex": ["sma", "ema", "dema", "tema", "wma"] };
        function y(e) {
          let n = A("div", { className: "highcharts-popup-lhs-col" }, void 0, e), d = A("div", { className: "highcharts-popup-rhs-col" }, void 0, e);
          return A("div", { className: "highcharts-popup-rhs-col-wrapper" }, void 0, d), { lhsCol: n, rhsCol: d };
        }
        function h(e, n, d, i) {
          let g = n.params || n.options.params;
          i.innerHTML = T.emptyHTML, A("h3", { className: "highcharts-indicator-title" }, void 0, i).appendChild(L.createTextNode(o(n, d).indicatorFullName)), A("input", { type: "hidden", name: "highcharts-type-" + d, value: d }, void 0, i), t.call(this, d, "series", e, i, n, n.linkedParent && n.linkedParent.options.id), g.volumeSeriesID && t.call(this, d, "volume", e, i, n, n.linkedParent && g.volumeSeriesID), x.call(this, e, "params", g, d, i);
        }
        function a(e, n, d, i) {
          function g(Y, q) {
            let N = U.parentNode.children[1];
            h.call(m, e, Y, q, U), N && (N.style.display = "block"), D && Y.options && A("input", { type: "hidden", name: "highcharts-id-" + q, value: Y.options.id }, void 0, U).setAttribute("highcharts-data-series-id", Y.options.id);
          }
          let m = this, k = m.lang, j = n.querySelectorAll(".highcharts-popup-lhs-col")[0], P = n.querySelectorAll(".highcharts-popup-rhs-col")[0], D = d === "edit", H = D ? e.series : e.options.plotOptions || {};
          if (!e && H) return;
          let G, V = [];
          D || u(H) ? u(H) && (V = C.call(this, H)) : V = p.call(this, H, i), s(V, (Y, q) => {
            let N = Y.indicatorFullName.toLowerCase(), X = q.indicatorFullName.toLowerCase();
            return N < X ? -1 : N > X ? 1 : 0;
          }), j.children[1] && j.children[1].remove();
          let F = A("ul", { className: "highcharts-indicator-list" }, void 0, j), U = P.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
          if (V.forEach((Y) => {
            let { indicatorFullName: q, indicatorType: N, series: X } = Y;
            G = A("li", { className: "highcharts-indicator-list" }, void 0, F);
            let W = A("button", { className: "highcharts-indicator-list-item", textContent: q }, void 0, G);
            ["click", "touchstart"].forEach((_) => {
              w(W, _, function() {
                g(X, N);
              });
            });
          }), V.length > 0) {
            let { series: Y, indicatorType: q } = V[0];
            g(Y, q);
          } else D || (T.setElementHTML(U.parentNode.children[0], k.noFilterMatch || ""), U.parentNode.children[1].style.display = "none");
        }
        function x(e, n, d, i, g) {
          if (!e) return;
          let m = this.addInput;
          v(d, (k, j) => {
            let P = n + "." + j;
            if (l(k) && P)
              if (c(k) && (m.call(this, P, i, g, {}), x.call(this, e, P, k, i, g)), P in z) {
                let D = E.call(this, i, P, g);
                b.call(this, e, n, D, i, j, k);
              } else P === "params.volumeSeriesID" || u(k) || m.call(this, P, i, g, { value: k, type: "number" });
          });
        }
        function S(e, n) {
          let d = this, i = n.querySelectorAll(".highcharts-popup-lhs-col")[0], g = this.lang.clearFilter, m = A("div", { className: "highcharts-input-wrapper" }, void 0, i), k = function(D) {
            a.call(d, e, d.container, "add", D);
          }, j = this.addInput("searchIndicators", "input", m, { value: "", type: "text", htmlFor: "search-indicators", labelClassName: "highcharts-input-search-indicators-label" }), P = A("a", { textContent: g }, void 0, m);
          j.classList.add("highcharts-input-search-indicators"), P.classList.add("clear-filter-button"), w(j, "input", function() {
            k(this.value), this.value.length ? P.style.display = "inline-block" : P.style.display = "none";
          }), ["click", "touchstart"].forEach((D) => {
            w(P, D, function() {
              j.value = "", k(""), P.style.display = "none";
            });
          });
        }
        function E(e, n, d) {
          let i = n.split("."), g = i[i.length - 1], m = "highcharts-" + n + "-type-" + e, k = this.lang;
          A("label", { htmlFor: m }, null, d).appendChild(L.createTextNode(k[g] || n));
          let j = A("select", { name: m, className: "highcharts-popup-field", id: "highcharts-select-" + n }, null, d);
          return j.setAttribute("id", "highcharts-select-" + n), j;
        }
        function b(e, n, d, i, g, m, k) {
          n === "series" || n === "volume" ? e.series.forEach((j) => {
            let P = j.options, D = P.name || P.params ? j.name : P.id || "";
            P.id !== "highcharts-navigator-series" && P.id !== (k && k.options && k.options.id) && (l(m) || n !== "volume" || j.type !== "column" || (m = P.id), A("option", { value: P.id }, void 0, d).appendChild(L.createTextNode(D)));
          }) : i && g && f[g + "-" + i].forEach((j) => {
            A("option", { value: j }, void 0, d).appendChild(L.createTextNode(j));
          }), l(m) && (d.value = m);
        }
        function p(e, n) {
          let d, i = this.chart && this.chart.options.lang, g = i && i.navigation && i.navigation.popup && i.navigation.popup.indicatorAliases, m = [];
          return v(e, (k, j) => {
            let P = k && k.options;
            if (k.params || P && P.params) {
              let { indicatorFullName: D, indicatorType: H } = o(k, j);
              if (n) {
                let G = RegExp(n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), V = g && g[H] && g[H].join(" ") || "";
                (D.match(G) || V.match(G)) && (d = { indicatorFullName: D, indicatorType: H, series: k }, m.push(d));
              } else d = { indicatorFullName: D, indicatorType: H, series: k }, m.push(d);
            }
          }), m;
        }
        function C(e) {
          let n = [];
          return e.forEach((d) => {
            d.is("sma") && n.push({ indicatorFullName: d.name, indicatorType: d.type, series: d });
          }), n;
        }
        function o(e, n) {
          let d = e.options, i = M[n] && M[n].prototype.nameBase || n.toUpperCase(), g = n;
          return d && d.type && (g = e.options.type, i = e.name), { indicatorFullName: i, indicatorType: g };
        }
        function t(e, n, d, i, g, m) {
          if (!d) return;
          let k = E.call(this, e, n, i);
          b.call(this, d, n, k, void 0, void 0, void 0, g), l(m) && (k.value = m);
        }
        return { addForm: function(e, n, d) {
          let i, g = this.lang;
          if (!e) return;
          this.tabs.init.call(this, e);
          let m = this.container.querySelectorAll(".highcharts-tab-item-content");
          y(m[0]), S.call(this, e, m[0]), a.call(this, e, m[0], "add"), i = m[0].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(i, g.addButton || "add", "add", i, d), y(m[1]), a.call(this, e, m[1], "edit"), i = m[1].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(i, g.saveButton || "save", "edit", i, d), this.addButton(i, g.removeButton || "remove", "remove", i, d);
        }, getAmount: function() {
          let e = 0;
          return this.series.forEach((n) => {
            (n.params || n.options.params) && e++;
          }), e;
        } };
      }), Z(r, "Extensions/Annotations/Popup/PopupTabs.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I } = T, { addEvent: R, createElement: z } = B;
        function O() {
          return z("div", { className: "highcharts-tab-item-content highcharts-no-mousewheel" }, void 0, this.container);
        }
        function L(l, u) {
          let c = this.container, v = this.lang, s = "highcharts-tab-item";
          u === 0 && (s += " highcharts-tab-disabled");
          let f = z("button", { className: s }, void 0, c);
          return f.appendChild(I.createTextNode(v[l + "Button"] || l)), f.setAttribute("highcharts-data-tab-type", l), f;
        }
        function M() {
          let l = this.container, u = l.querySelectorAll(".highcharts-tab-item"), c = l.querySelectorAll(".highcharts-tab-item-content");
          for (let v = 0; v < u.length; v++) u[v].classList.remove("highcharts-tab-item-active"), c[v].classList.remove("highcharts-tab-item-show");
        }
        function w(l, u) {
          let c = this.container.querySelectorAll(".highcharts-tab-item-content");
          l.className += " highcharts-tab-item-active", c[u].className += " highcharts-tab-item-show";
        }
        function A(l) {
          let u = this;
          this.container.querySelectorAll(".highcharts-tab-item").forEach((c, v) => {
            (l !== 0 || c.getAttribute("highcharts-data-tab-type") !== "edit") && ["click", "touchstart"].forEach((s) => {
              R(c, s, function() {
                M.call(u), w.call(u, this, v);
              });
            });
          });
        }
        return { init: function(l) {
          if (!l) return;
          let u = this.indicators.getAmount.call(l), c = L.call(this, "add");
          L.call(this, "edit", u), O.call(this), O.call(this), A.call(this, u), w.call(this, c, 0);
        } };
      }), Z(r, "Extensions/Annotations/Popup/Popup.js", [r["Shared/BaseForm.js"], r["Core/Globals.js"], r["Core/Defaults.js"], r["Extensions/Annotations/Popup/PopupAnnotations.js"], r["Extensions/Annotations/Popup/PopupIndicators.js"], r["Extensions/Annotations/Popup/PopupTabs.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { doc: M } = B, { getOptions: w } = I, { addEvent: A, createElement: l, extend: u, fireEvent: c, pick: v } = L;
        class s extends T {
          constructor(y, h, a) {
            super(y, h), this.chart = a, this.lang = (w().lang.navigation || {}).popup || {}, A(this.container, "mousedown", () => {
              let x = a && a.navigationBindings && a.navigationBindings.activeAnnotation;
              if (x) {
                x.cancelClick = !0;
                let S = A(M, "click", () => {
                  setTimeout(() => {
                    x.cancelClick = !1;
                  }, 0), S();
                });
              }
            });
          }
          addInput(y, h, a, x) {
            let S = y.split("."), E = S[S.length - 1], b = this.lang, p = "highcharts-" + h + "-" + v(x.htmlFor, E);
            E.match(/^\d+$/) || l("label", { htmlFor: p, className: x.labelClassName }, void 0, a).appendChild(M.createTextNode(b[E] || E));
            let C = l("input", { name: p, value: x.value, type: x.type, className: "highcharts-popup-field" }, void 0, a);
            return C.setAttribute("highcharts-data-name", y), C;
          }
          closeButtonEvents() {
            if (this.chart) {
              let y = this.chart.navigationBindings;
              c(y, "closePopup"), y && y.selectedButtonElement && c(y, "deselectButton", { button: y.selectedButtonElement });
            } else super.closeButtonEvents();
          }
          addButton(y, h, a, x, S) {
            let E = l("button", void 0, void 0, y);
            return E.appendChild(M.createTextNode(h)), S && ["click", "touchstart"].forEach((b) => {
              A(E, b, () => (this.closePopup(), S(function(p, C) {
                let o = Array.prototype.slice.call(p.querySelectorAll("input")), t = Array.prototype.slice.call(p.querySelectorAll("select")), e = p.querySelectorAll("#highcharts-select-series > option:checked")[0], n = p.querySelectorAll("#highcharts-select-volume > option:checked")[0], d = { actionType: C, linkedTo: e && e.getAttribute("value") || "", fields: {} };
                return o.forEach((i) => {
                  let g = i.getAttribute("highcharts-data-name");
                  i.getAttribute("highcharts-data-series-id") ? d.seriesId = i.value : g ? d.fields[g] = i.value : d.type = i.value;
                }), t.forEach((i) => {
                  let g = i.id;
                  if (g !== "highcharts-select-series" && g !== "highcharts-select-volume") {
                    let m = g.split("highcharts-select-")[1];
                    d.fields[m] = i.value;
                  }
                }), n && (d.fields["params.volumeSeriesID"] = n.getAttribute("value") || ""), d;
              }(x, a))));
            }), E;
          }
          showForm(y, h, a, x) {
            h && (this.showPopup(), y === "indicators" && this.indicators.addForm.call(this, h, a, x), y === "annotation-toolbar" && this.annotations.addToolbar.call(this, h, a, x), y === "annotation-edit" && this.annotations.addForm.call(this, h, a, x), y === "flag" && this.annotations.addForm.call(this, h, a, x, !0), this.type = y, this.container.style.height = this.container.offsetHeight + "px");
          }
        }
        return u(s.prototype, { annotations: R, indicators: z, tabs: O }), s;
      }), Z(r, "Extensions/Annotations/Popup/PopupComposition.js", [r["Core/Globals.js"], r["Extensions/Annotations/Popup/Popup.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { composed: R } = T, { addEvent: z, pushUnique: O, wrap: L } = I;
        function M() {
          this.popup && this.popup.closePopup();
        }
        function w(l) {
          this.popup || (this.popup = new B(this.chart.container, this.chart.options.navigation.iconsURL || this.chart.options.stockTools && this.chart.options.stockTools.gui.iconsURL || "https://code.highcharts.com/11.4.8/gfx/stock-icons/", this.chart)), this.popup.showForm(l.formType, this.chart, l.options, l.onSubmit);
        }
        function A(l, u) {
          this.inClass(u.target, "highcharts-popup") || l.apply(this, Array.prototype.slice.call(arguments, 1));
        }
        return { compose: function(l, u) {
          O(R, "Popup") && (z(l, "closePopup", M), z(l, "showPopup", w), L(u.prototype, "onContainerMouseDown", A));
        } };
      }), Z(r, "Extensions/Annotations/Annotation.js", [r["Core/Animation/AnimationUtilities.js"], r["Extensions/Annotations/AnnotationChart.js"], r["Extensions/Annotations/AnnotationDefaults.js"], r["Extensions/Annotations/Controllables/ControllableRect.js"], r["Extensions/Annotations/Controllables/ControllableCircle.js"], r["Extensions/Annotations/Controllables/ControllableEllipse.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Extensions/Annotations/Controllables/ControllableImage.js"], r["Extensions/Annotations/Controllables/ControllableLabel.js"], r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/ControlTarget.js"], r["Extensions/Annotations/EventEmitter.js"], r["Extensions/Annotations/MockPoint.js"], r["Extensions/Annotations/Popup/PopupComposition.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u, c, v, s) {
        let { getDeferredAnimation: f } = T, { destroyObjectProperties: y, erase: h, fireEvent: a, merge: x, pick: S, splat: E } = s;
        function b(C, o) {
          let t = {};
          return ["labels", "shapes"].forEach((e) => {
            let n = C[e];
            n && (o[e] ? t[e] = E(o[e]).map(function(d, i) {
              return x(n[i], d);
            }) : t[e] = C[e]);
          }), t;
        }
        class p extends u {
          static compose(o, t, e, n) {
            B.compose(p, o, e), w.compose(n), L.compose(o, n), t.compose(p, o), v.compose(t, e);
          }
          constructor(o, t) {
            super(), this.coll = "annotations", this.chart = o, this.points = [], this.controlPoints = [], this.coll = "annotations", this.index = -1, this.labels = [], this.shapes = [], this.options = x(this.defaultOptions, t), this.userOptions = t;
            let e = b(this.options, t);
            this.options.labels = e.labels, this.options.shapes = e.shapes, this.init(o, this.options);
          }
          addClipPaths() {
            this.setClipAxes(), this.clipXAxis && this.clipYAxis && this.options.crop && (this.clipRect = this.chart.renderer.clipRect(this.getClipBox()));
          }
          addLabels() {
            let o = this.options.labels || [];
            o.forEach((t, e) => {
              let n = this.initLabel(t, e);
              x(!0, o[e], n.options);
            });
          }
          addShapes() {
            let o = this.options.shapes || [];
            o.forEach((t, e) => {
              let n = this.initShape(t, e);
              x(!0, o[e], n.options);
            });
          }
          destroy() {
            let o = this.chart, t = function(e) {
              e.destroy();
            };
            this.labels.forEach(t), this.shapes.forEach(t), this.clipXAxis = null, this.clipYAxis = null, h(o.labelCollectors, this.labelCollector), super.destroy(), this.destroyControlTarget(), y(this, o);
          }
          destroyItem(o) {
            h(this[o.itemType + "s"], o), o.destroy();
          }
          getClipBox() {
            if (this.clipXAxis && this.clipYAxis) return { x: this.clipXAxis.left, y: this.clipYAxis.top, width: this.clipXAxis.width, height: this.clipYAxis.height };
          }
          initProperties(o, t) {
            this.setOptions(t);
            let e = b(this.options, t);
            this.options.labels = e.labels, this.options.shapes = e.shapes, this.chart = o, this.points = [], this.controlPoints = [], this.coll = "annotations", this.userOptions = t, this.labels = [], this.shapes = [];
          }
          init(o, t, e = this.index) {
            let n = this.chart, d = this.options.animation;
            this.index = e, this.linkPoints(), this.addControlPoints(), this.addShapes(), this.addLabels(), this.setLabelCollector(), this.animationConfig = f(n, d);
          }
          initLabel(o, t) {
            let e = new w(this, x(this.options.labelOptions, { controlPointOptions: this.options.controlPointOptions }, o), t);
            return e.itemType = "label", this.labels.push(e), e;
          }
          initShape(o, t) {
            let e = x(this.options.shapeOptions, { controlPointOptions: this.options.controlPointOptions }, o), n = new p.shapesMap[e.type](this, e, t);
            return n.itemType = "shape", this.shapes.push(n), n;
          }
          redraw(o) {
            this.linkPoints(), this.graphic || this.render(), this.clipRect && this.clipRect.animate(this.getClipBox()), this.redrawItems(this.shapes, o), this.redrawItems(this.labels, o), this.redrawControlPoints(o);
          }
          redrawItem(o, t) {
            o.linkPoints(), o.shouldBeDrawn() ? (o.graphic || this.renderItem(o), o.redraw(S(t, !0) && o.graphic.placed), o.points.length && function(e) {
              let n = e.graphic, d = e.points.some((i) => i.series.visible !== !1 && i.visible !== !1);
              n && (d ? n.visibility === "hidden" && n.show() : n.hide());
            }(o)) : this.destroyItem(o);
          }
          redrawItems(o, t) {
            let e = o.length;
            for (; e--; ) this.redrawItem(o[e], t);
          }
          remove() {
            return this.chart.removeAnnotation(this);
          }
          render() {
            let o = this.chart.renderer;
            this.graphic = o.g("annotation").attr({ opacity: 0, zIndex: this.options.zIndex, visibility: this.options.visible ? "inherit" : "hidden" }).add(), this.shapesGroup = o.g("annotation-shapes").add(this.graphic), this.options.crop && this.shapesGroup.clip(this.chart.plotBoxClip), this.labelsGroup = o.g("annotation-labels").attr({ translateX: 0, translateY: 0 }).add(this.graphic), this.addClipPaths(), this.clipRect && this.graphic.clip(this.clipRect), this.renderItems(this.shapes), this.renderItems(this.labels), this.addEvents(), this.renderControlPoints();
          }
          renderItem(o) {
            o.render(o.itemType === "label" ? this.labelsGroup : this.shapesGroup);
          }
          renderItems(o) {
            let t = o.length;
            for (; t--; ) this.renderItem(o[t]);
          }
          setClipAxes() {
            let o = this.chart.xAxis, t = this.chart.yAxis, e = (this.options.labels || []).concat(this.options.shapes || []).reduce((n, d) => {
              let i = d && (d.point || d.points && d.points[0]);
              return [o[i && i.xAxis] || n[0], t[i && i.yAxis] || n[1]];
            }, []);
            this.clipXAxis = e[0], this.clipYAxis = e[1];
          }
          setControlPointsVisibility(o) {
            let t = function(e) {
              e.setControlPointsVisibility(o);
            };
            this.controlPoints.forEach((e) => {
              e.setVisibility(o);
            }), this.shapes.forEach(t), this.labels.forEach(t);
          }
          setLabelCollector() {
            let o = this;
            o.labelCollector = function() {
              return o.labels.reduce(function(t, e) {
                return e.options.allowOverlap || t.push(e.graphic), t;
              }, []);
            }, o.chart.labelCollectors.push(o.labelCollector);
          }
          setOptions(o) {
            this.options = x(this.defaultOptions, o);
          }
          setVisibility(o) {
            let t = this.options, e = this.chart.navigationBindings, n = S(o, !t.visible);
            if (this.graphic.attr("visibility", n ? "inherit" : "hidden"), !n) {
              let d = function(i) {
                i.setControlPointsVisibility(n);
              };
              this.shapes.forEach(d), this.labels.forEach(d), e.activeAnnotation === this && e.popup && e.popup.type === "annotation-toolbar" && a(e, "closePopup");
            }
            t.visible = n;
          }
          update(o, t) {
            let e = this.chart, n = b(this.userOptions, o), d = e.annotations.indexOf(this), i = x(!0, this.userOptions, o);
            i.labels = n.labels, i.shapes = n.shapes, this.destroy(), this.initProperties(e, i), this.init(e, i), e.options.annotations[d] = this.options, this.isUpdating = !0, S(t, !0) && e.drawAnnotations(), a(this, "afterUpdate"), this.isUpdating = !1;
          }
        }
        return p.ControlPoint = A, p.MockPoint = c, p.shapesMap = { rect: R, circle: z, ellipse: O, path: L, image: M }, p.types = {}, p.prototype.defaultOptions = I, p.prototype.nonDOMEvents = ["add", "afterUpdate", "drag", "remove"], l.compose(p), p;
      }), Z(r, "Core/Chart/ChartNavigationComposition.js", [], function() {
        var T;
        return function(B) {
          B.compose = function(R) {
            return R.navigation || (R.navigation = new I(R)), R;
          };
          class I {
            constructor(z) {
              this.updates = [], this.chart = z;
            }
            addUpdate(z) {
              this.chart.navigation.updates.push(z);
            }
            update(z, O) {
              this.updates.forEach((L) => {
                L.call(this.chart, z, O);
              });
            }
          }
          B.Additions = I;
        }(T || (T = {})), T;
      }), Z(r, "Extensions/Annotations/NavigationBindingsUtilities.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B, isNumber: I, pick: R } = T, z = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
        return { annotationsFieldsTypes: z, getAssignedAxis: function(O) {
          return O.filter((L) => {
            let M = L.axis.getExtremes(), w = M.min, A = M.max, l = R(L.axis.minPointOffset, 0);
            return I(w) && I(A) && L.value >= w - l && L.value <= A + l && !L.axis.options.isInternal;
          })[0];
        }, getFieldType: function(O, L) {
          let M = z[O], w = typeof L;
          return B(M) && (w = M), { string: "text", number: "number", boolean: "checkbox" }[w];
        } };
      }), Z(r, "Extensions/Annotations/NavigationBindingsDefaults.js", [r["Extensions/Annotations/NavigationBindingsUtilities.js"], r["Core/Utilities.js"]], function(T, B) {
        let { getAssignedAxis: I } = T, { isNumber: R, merge: z } = B;
        return { lang: { navigation: { popup: { simpleShapes: "Simple shapes", lines: "Lines", circle: "Circle", ellipse: "Ellipse", rectangle: "Rectangle", label: "Label", shapeOptions: "Shape options", typeOptions: "Details", fill: "Fill", format: "Text", strokeWidth: "Line width", stroke: "Line color", title: "Title", name: "Name", labelOptions: "Label options", labels: "Labels", backgroundColor: "Background color", backgroundColors: "Background colors", borderColor: "Border color", borderRadius: "Border radius", borderWidth: "Border width", style: "Style", padding: "Padding", fontSize: "Font size", color: "Color", height: "Height", shapes: "Shape options" } } }, navigation: { bindingsClassName: "highcharts-bindings-container", bindings: { circleAnnotation: { className: "highcharts-circle-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "circle", type: "basicAnnotation", shapes: [{ type: "circle", point: { x: M.value, y: w.value, xAxis: M.axis.index, yAxis: w.axis.index }, r: 5 }] }, A.annotationsOptions, A.bindings.circleAnnotation.annotationsOptions));
        }, steps: [function(O, L) {
          let M, w = L.options.shapes, A = w && w[0] && w[0].point || {};
          if (R(A.xAxis) && R(A.yAxis)) {
            let l = this.chart.inverted, u = this.chart.xAxis[A.xAxis].toPixels(A.x), c = this.chart.yAxis[A.yAxis].toPixels(A.y);
            M = Math.max(Math.sqrt(Math.pow(l ? c - O.chartX : u - O.chartX, 2) + Math.pow(l ? u - O.chartY : c - O.chartY, 2)), 5);
          }
          L.update({ shapes: [{ r: M }] });
        }] }, ellipseAnnotation: { className: "highcharts-ellipse-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "ellipse", type: "basicAnnotation", shapes: [{ type: "ellipse", xAxis: M.axis.index, yAxis: w.axis.index, points: [{ x: M.value, y: w.value }, { x: M.value, y: w.value }], ry: 1 }] }, A.annotationsOptions, A.bindings.ellipseAnnotation.annotationOptions));
        }, steps: [function(O, L) {
          let M = L.shapes[0], w = M.getAbsolutePosition(M.points[1]);
          M.translatePoint(O.chartX - w.x, O.chartY - w.y, 1), M.redraw(!1);
        }, function(O, L) {
          let M = L.shapes[0], w = M.getAbsolutePosition(M.points[0]), A = M.getAbsolutePosition(M.points[1]), l = M.getDistanceFromLine(w, A, O.chartX, O.chartY), u = M.getYAxis(), c = Math.abs(u.toValue(0) - u.toValue(l));
          M.setYRadius(c), M.redraw(!1);
        }] }, rectangleAnnotation: { className: "highcharts-rectangle-annotation", start: function(O) {
          var s;
          let L = (s = this.chart.pointer) == null ? void 0 : s.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis);
          if (!M || !w) return;
          let A = M.value, l = w.value, u = M.axis.index, c = w.axis.index, v = this.chart.options.navigation;
          return this.chart.addAnnotation(z({ langKey: "rectangle", type: "basicAnnotation", shapes: [{ type: "path", points: [{ xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { command: "Z" }] }] }, v.annotationsOptions, v.bindings.rectangleAnnotation.annotationsOptions));
        }, steps: [function(O, L) {
          var c;
          let M = L.options.shapes, w = M && M[0] && M[0].points || [], A = (c = this.chart.pointer) == null ? void 0 : c.getCoordinates(O), l = A && I(A.xAxis), u = A && I(A.yAxis);
          if (l && u) {
            let v = l.value, s = u.value;
            w[1].x = v, w[2].x = v, w[2].y = s, w[3].y = s, L.update({ shapes: [{ points: w }] });
          }
        }] }, labelAnnotation: { className: "highcharts-label-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "label", type: "basicAnnotation", labelOptions: { format: "{y:.2f}", overflow: "none", crop: !0 }, labels: [{ point: { xAxis: M.axis.index, yAxis: w.axis.index, x: M.value, y: w.value } }] }, A.annotationsOptions, A.bindings.labelAnnotation.annotationsOptions));
        } } }, events: {}, annotationsOptions: { animation: { defer: 0 } } } };
      }), Z(r, "Extensions/Annotations/NavigationBindings.js", [r["Core/Chart/ChartNavigationComposition.js"], r["Core/Defaults.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Extensions/Annotations/NavigationBindingsDefaults.js"], r["Extensions/Annotations/NavigationBindingsUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { setOptions: M } = B, { format: w } = I, { composed: A, doc: l, win: u } = R, { getAssignedAxis: c, getFieldType: v } = O, { addEvent: s, attr: f, defined: y, fireEvent: h, isArray: a, isFunction: x, isNumber: S, isObject: E, merge: b, objectEach: p, pick: C, pushUnique: o } = L;
        function t() {
          this.chart.navigationBindings && this.chart.navigationBindings.deselectAnnotation();
        }
        function e() {
          this.navigationBindings && this.navigationBindings.destroy();
        }
        function n() {
          let j = this.options;
          j && j.navigation && j.navigation.bindings && (this.navigationBindings = new k(this, j.navigation), this.navigationBindings.initEvents(), this.navigationBindings.initUpdate());
        }
        function d() {
          let j = this.navigationBindings, P = "highcharts-disabled-btn";
          if (this && j) {
            let D = !1;
            if (this.series.forEach((H) => {
              !H.options.isInternal && H.visible && (D = !0);
            }), this.navigationBindings && this.navigationBindings.container && this.navigationBindings.container[0]) {
              let H = this.navigationBindings.container[0];
              p(j.boundClassNames, (G, V) => {
                let F = H.querySelectorAll("." + V);
                if (F) for (let U = 0; U < F.length; U++) {
                  let Y = F[U], q = Y.className;
                  G.noDataState === "normal" || D ? q.indexOf(P) !== -1 && Y.classList.remove(P) : q.indexOf(P) === -1 && (Y.className += " " + P);
                }
              });
            }
          }
        }
        function i() {
          this.deselectAnnotation();
        }
        function g() {
          this.selectedButtonElement = null;
        }
        function m(j) {
          let P, D, H = j.prototype.defaultOptions.events && j.prototype.defaultOptions.events.click;
          function G(V) {
            let F = this, U = F.chart.navigationBindings, Y = U.activeAnnotation;
            H && H.call(F, V), Y !== F ? (U.deselectAnnotation(), U.activeAnnotation = F, F.setControlPointsVisibility(!0), h(U, "showPopup", { annotation: F, formType: "annotation-toolbar", options: U.annotationToFields(F), onSubmit: function(q) {
              if (q.actionType === "remove") U.activeAnnotation = !1, U.chart.removeAnnotation(F);
              else {
                let N = {};
                U.fieldsToOptions(q.fields, N), U.deselectAnnotation();
                let X = N.typeOptions;
                F.options.type === "measure" && (X.crosshairY.enabled = X.crosshairY.strokeWidth !== 0, X.crosshairX.enabled = X.crosshairX.strokeWidth !== 0), F.update(N);
              }
            } })) : h(U, "closePopup"), V.activeAnnotation = !0;
          }
          b(!0, j.prototype.defaultOptions.events, { click: G, touchstart: function(V) {
            P = V.touches[0].clientX, D = V.touches[0].clientY;
          }, touchend: function(V) {
            P && Math.sqrt(Math.pow(P - V.changedTouches[0].clientX, 2) + Math.pow(D - V.changedTouches[0].clientY, 2)) >= 4 || G.call(this, V);
          } });
        }
        class k {
          static compose(P, D) {
            o(A, "NavigationBindings") && (s(P, "remove", t), m(P), p(P.types, (H) => {
              m(H);
            }), s(D, "destroy", e), s(D, "load", n), s(D, "render", d), s(k, "closePopup", i), s(k, "deselectButton", g), M(z));
          }
          constructor(P, D) {
            this.boundClassNames = void 0, this.chart = P, this.options = D, this.eventsToUnbind = [], this.container = this.chart.container.getElementsByClassName(this.options.bindingsClassName || ""), this.container.length || (this.container = l.getElementsByClassName(this.options.bindingsClassName || ""));
          }
          getCoords(P) {
            var H;
            let D = (H = this.chart.pointer) == null ? void 0 : H.getCoordinates(P);
            return [D && c(D.xAxis), D && c(D.yAxis)];
          }
          initEvents() {
            let P = this, D = P.chart, H = P.container, G = P.options;
            P.boundClassNames = {}, p(G.bindings || {}, (V) => {
              P.boundClassNames[V.className] = V;
            }), [].forEach.call(H, (V) => {
              P.eventsToUnbind.push(s(V, "click", (F) => {
                let U = P.getButtonEvents(V, F);
                U && !U.button.classList.contains("highcharts-disabled-btn") && P.bindingsButtonClick(U.button, U.events, F);
              }));
            }), p(G.events || {}, (V, F) => {
              x(V) && P.eventsToUnbind.push(s(P, F, V, { passive: !1 }));
            }), P.eventsToUnbind.push(s(D.container, "click", function(V) {
              !D.cancelClick && D.isInsidePlot(V.chartX - D.plotLeft, V.chartY - D.plotTop, { visiblePlotOnly: !0 }) && P.bindingsChartClick(this, V);
            })), P.eventsToUnbind.push(s(D.container, R.isTouchDevice ? "touchmove" : "mousemove", function(V) {
              P.bindingsContainerMouseMove(this, V);
            }, R.isTouchDevice ? { passive: !1 } : void 0));
          }
          initUpdate() {
            let P = this;
            T.compose(this.chart).navigation.addUpdate((D) => {
              P.update(D);
            });
          }
          bindingsButtonClick(P, D, H) {
            let G = this.chart, V = G.renderer.boxWrapper, F = !0;
            this.selectedButtonElement && (this.selectedButtonElement.classList === P.classList && (F = !1), h(this, "deselectButton", { button: this.selectedButtonElement }), this.nextEvent && (this.currentUserDetails && this.currentUserDetails.coll === "annotations" && G.removeAnnotation(this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1)), F ? (this.selectedButton = D, this.selectedButtonElement = P, h(this, "selectButton", { button: P }), D.init && D.init.call(this, P, H), (D.start || D.steps) && G.renderer.boxWrapper.addClass("highcharts-draw-mode")) : (G.stockTools && P.classList.remove("highcharts-active"), V.removeClass("highcharts-draw-mode"), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null);
          }
          bindingsChartClick(P, D) {
            P = this.chart;
            let H = this.activeAnnotation, G = this.selectedButton, V = P.renderer.boxWrapper;
            H && (H.cancelClick || D.activeAnnotation || !D.target.parentNode || function(F, U) {
              let Y = u.Element.prototype, q = Y.matches || Y.msMatchesSelector || Y.webkitMatchesSelector, N = null;
              if (Y.closest) N = Y.closest.call(F, U);
              else do {
                if (q.call(F, U)) return F;
                F = F.parentElement || F.parentNode;
              } while (F !== null && F.nodeType === 1);
              return N;
            }(D.target, ".highcharts-popup") ? H.cancelClick && setTimeout(() => {
              H.cancelClick = !1;
            }, 0) : h(this, "closePopup")), G && G.start && (this.nextEvent ? (this.nextEvent(D, this.currentUserDetails), this.steps && (this.stepIndex++, G.steps[this.stepIndex] ? this.mouseMoveEvent = this.nextEvent = G.steps[this.stepIndex] : (h(this, "deselectButton", { button: this.selectedButtonElement }), V.removeClass("highcharts-draw-mode"), G.end && G.end.call(this, D, this.currentUserDetails), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null))) : (this.currentUserDetails = G.start.call(this, D), this.currentUserDetails && G.steps ? (this.stepIndex = 0, this.steps = !0, this.mouseMoveEvent = this.nextEvent = G.steps[this.stepIndex]) : (h(this, "deselectButton", { button: this.selectedButtonElement }), V.removeClass("highcharts-draw-mode"), this.steps = !1, this.selectedButton = null, G.end && G.end.call(this, D, this.currentUserDetails))));
          }
          bindingsContainerMouseMove(P, D) {
            this.mouseMoveEvent && this.mouseMoveEvent(D, this.currentUserDetails);
          }
          fieldsToOptions(P, D) {
            return p(P, (H, G) => {
              let V = parseFloat(H), F = G.split("."), U = F.length - 1;
              if (!S(V) || H.match(/px|em/g) || G.match(/format/g) || (H = V), H !== "undefined") {
                let Y = D;
                F.forEach((q, N) => {
                  if (q !== "__proto__" && q !== "constructor") {
                    let X = C(F[N + 1], "");
                    U === N ? Y[q] = H : (Y[q] || (Y[q] = X.match(/\d/g) ? [] : {}), Y = Y[q]);
                  }
                });
              }
            }), D;
          }
          deselectAnnotation() {
            this.activeAnnotation && (this.activeAnnotation.setControlPointsVisibility(!1), this.activeAnnotation = !1);
          }
          annotationToFields(P) {
            let D = P.options, H = k.annotationsEditable, G = H.nestedOptions, V = C(D.type, D.shapes && D.shapes[0] && D.shapes[0].type, D.labels && D.labels[0] && D.labels[0].type, "label"), F = k.annotationsNonEditable[D.langKey] || [], U = { langKey: D.langKey, type: V };
            function Y(q, N, X, W, _) {
              let K;
              X && y(q) && F.indexOf(N) === -1 && ((X.indexOf && X.indexOf(N)) >= 0 || X[N] || X === !0) && (a(q) ? (W[N] = [], q.forEach((J, $) => {
                E(J) ? (W[N][$] = {}, p(J, (et, st) => {
                  Y(et, st, G[N], W[N][$], N);
                })) : Y(J, 0, G[N], W[N], N);
              })) : E(q) ? (K = {}, a(W) ? (W.push(K), K[N] = {}, K = K[N]) : W[N] = K, p(q, (J, $) => {
                Y(J, $, N === 0 ? X : G[N], K, N);
              })) : N === "format" ? W[N] = [w(q, P.labels[0].points[0]).toString(), "text"] : a(W) ? W.push([q, v(_, q)]) : W[N] = [q, v(N, q)]);
            }
            return p(D, (q, N) => {
              N === "typeOptions" ? (U[N] = {}, p(D[N], (X, W) => {
                Y(X, W, G, U[N], W);
              })) : Y(q, N, H[V], U, N);
            }), U;
          }
          getClickedClassNames(P, D) {
            let H = D.target, G = [], V;
            for (; H && H.tagName && ((V = f(H, "class")) && (G = G.concat(V.split(" ").map((F) => [F, H]))), (H = H.parentNode) !== P); ) ;
            return G;
          }
          getButtonEvents(P, D) {
            let H, G = this;
            return this.getClickedClassNames(P, D).forEach((V) => {
              G.boundClassNames[V[0]] && !H && (H = { events: G.boundClassNames[V[0]], button: V[1] });
            }), H;
          }
          update(P) {
            this.options = b(!0, this.options, P), this.removeEvents(), this.initEvents();
          }
          removeEvents() {
            this.eventsToUnbind.forEach((P) => P());
          }
          destroy() {
            this.removeEvents();
          }
        }
        return k.annotationsEditable = { nestedOptions: { labelOptions: ["style", "format", "backgroundColor"], labels: ["style"], label: ["style"], style: ["fontSize", "color"], background: ["fill", "strokeWidth", "stroke"], innerBackground: ["fill", "strokeWidth", "stroke"], outerBackground: ["fill", "strokeWidth", "stroke"], shapeOptions: ["fill", "strokeWidth", "stroke"], shapes: ["fill", "strokeWidth", "stroke"], line: ["strokeWidth", "stroke"], backgroundColors: [!0], connector: ["fill", "strokeWidth", "stroke"], crosshairX: ["strokeWidth", "stroke"], crosshairY: ["strokeWidth", "stroke"] }, circle: ["shapes"], ellipse: ["shapes"], verticalLine: [], label: ["labelOptions"], measure: ["background", "crosshairY", "crosshairX"], fibonacci: [], tunnel: ["background", "line", "height"], pitchfork: ["innerBackground", "outerBackground"], rect: ["shapes"], crookedLine: [], basicAnnotation: ["shapes", "labelOptions"] }, k.annotationsNonEditable = { rectangle: ["crosshairX", "crosshairY", "labelOptions"], ellipse: ["labelOptions"], circle: ["labelOptions"] }, k;
      }), Z(r, "masters/modules/annotations.src.js", [r["Core/Globals.js"], r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/NavigationBindings.js"]], function(T, B, I) {
        return T.Annotation = T.Annotation || B, T.NavigationBindings = T.NavigationBindings || I, T.Annotation.compose(T.Chart, T.NavigationBindings, T.Pointer, T.SVGRenderer), T;
      });
    });
  }(Se)), Se.exports;
}
var vl = bl();
const Cl = /* @__PURE__ */ It(vl);
var ke = { exports: {} }, Gs;
function Al() {
  return Gs || (Gs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Annotations module
    *
    * (c) 2009-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Extensions/Annotations/AnnotationChart.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { addEvent: I, erase: R, find: z, fireEvent: O, pick: L, wrap: M } = T;
        function w(s, f) {
          let y = this.initAnnotation(s);
          return this.options.annotations.push(y.options), L(f, !0) && (y.redraw(), y.graphic.attr({ opacity: 1 })), y;
        }
        function A() {
          let s = this;
          s.plotBoxClip = this.renderer.clipRect(this.plotBox), s.controlPointsGroup = s.renderer.g("control-points").attr({ zIndex: 99 }).clip(s.plotBoxClip).add(), s.options.annotations.forEach((f, y) => {
            if (!s.annotations.some((h) => h.options === f)) {
              let h = s.initAnnotation(f);
              s.options.annotations[y] = h.options;
            }
          }), s.drawAnnotations(), I(s, "redraw", s.drawAnnotations), I(s, "destroy", function() {
            s.plotBoxClip.destroy(), s.controlPointsGroup.destroy();
          }), I(s, "exportData", function(f) {
            let y = s.annotations, h = (this.options.exporting && this.options.exporting.csv || {}).columnHeaderFormatter, a = !f.dataRows[1].xValues, x = s.options.lang && s.options.lang.exportData && s.options.lang.exportData.annotationHeader, S = f.dataRows[0].length, E = s.options.exporting && s.options.exporting.csv && s.options.exporting.csv.annotations && s.options.exporting.csv.annotations.itemDelimiter, b = s.options.exporting && s.options.exporting.csv && s.options.exporting.csv.annotations && s.options.exporting.csv.annotations.join;
            y.forEach((o) => {
              o.options.labelOptions && o.options.labelOptions.includeInDataExport && o.labels.forEach((t) => {
                if (t.options.text) {
                  let e = t.options.text;
                  t.points.forEach((n) => {
                    let d = n.x, i = n.series.xAxis ? n.series.xAxis.index : -1, g = !1;
                    if (i === -1) {
                      let m = f.dataRows[0].length, k = Array(m);
                      for (let j = 0; j < m; ++j) k[j] = "";
                      k.push(e), k.xValues = [], k.xValues[i] = d, f.dataRows.push(k), g = !0;
                    }
                    if (g || f.dataRows.forEach((m) => {
                      !g && m.xValues && i !== void 0 && d === m.xValues[i] && (b && m.length > S ? m[m.length - 1] += E + e : m.push(e), g = !0);
                    }), !g) {
                      let m = f.dataRows[0].length, k = Array(m);
                      for (let j = 0; j < m; ++j) k[j] = "";
                      k[0] = d, k.push(e), k.xValues = [], i !== void 0 && (k.xValues[i] = d), f.dataRows.push(k);
                    }
                  });
                }
              });
            });
            let p = 0;
            f.dataRows.forEach((o) => {
              p = Math.max(p, o.length);
            });
            let C = p - f.dataRows[0].length;
            for (let o = 0; o < C; o++) {
              let t = function(e) {
                let n;
                return h && (n = h(e)) !== !1 ? n : (n = x + " " + e, a ? { columnTitle: n, topLevelColumnTitle: n } : n);
              }(o + 1);
              a ? (f.dataRows[0].push(t.topLevelColumnTitle), f.dataRows[1].push(t.columnTitle)) : f.dataRows[0].push(t);
            }
          });
        }
        function l() {
          this.plotBoxClip.attr(this.plotBox), this.annotations.forEach((s) => {
            s.redraw(), s.graphic.animate({ opacity: 1 }, s.animationConfig);
          });
        }
        function u(s) {
          let f = this.annotations, y = s.coll === "annotations" ? s : z(f, function(h) {
            return h.options.id === s;
          });
          y && (O(y, "remove"), R(this.options.annotations, y.options), R(f, y), y.destroy());
        }
        function c() {
          this.annotations = [], this.options.annotations || (this.options.annotations = []);
        }
        function v(s) {
          this.chart.hasDraggedAnnotation || s.apply(this, Array.prototype.slice.call(arguments, 1));
        }
        return (B || (B = {})).compose = function(s, f, y) {
          let h = f.prototype;
          if (!h.addAnnotation) {
            let a = y.prototype;
            I(f, "afterInit", c), h.addAnnotation = w, h.callbacks.push(A), h.collectionsWithInit.annotations = [w], h.collectionsWithUpdate.push("annotations"), h.drawAnnotations = l, h.removeAnnotation = u, h.initAnnotation = function(x) {
              let S = new (s.types[x.type] || s)(this, x);
              return this.annotations.push(S), S;
            }, M(a, "onContainerMouseDown", v);
          }
        }, B;
      }), Z(r, "Extensions/Annotations/AnnotationDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B } = T;
        return { visible: !0, animation: {}, crop: !0, draggable: "xy", labelOptions: { align: "center", allowOverlap: !1, backgroundColor: "rgba(0, 0, 0, 0.75)", borderColor: "#000000", borderRadius: 3, borderWidth: 1, className: "highcharts-no-tooltip", crop: !1, formatter: function() {
          return B(this.y) ? "" + this.y : "Annotation label";
        }, includeInDataExport: !0, overflow: "justify", padding: 5, shadow: !1, shape: "callout", style: { fontSize: "0.7em", fontWeight: "normal", color: "contrast" }, useHTML: !1, verticalAlign: "bottom", x: 0, y: -16 }, shapeOptions: { stroke: "rgba(0, 0, 0, 0.75)", strokeWidth: 1, fill: "rgba(0, 0, 0, 0.75)", r: 0, snap: 2 }, controlPointOptions: { events: {}, style: { cursor: "pointer", fill: "#ffffff", stroke: "#000000", "stroke-width": 2 }, height: 10, symbol: "circle", visible: !1, width: 10 }, events: {}, zIndex: 6 };
      }), Z(r, "Extensions/Annotations/EventEmitter.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I, isTouchDevice: R } = T, { addEvent: z, fireEvent: O, objectEach: L, pick: M, removeEvent: w } = B;
        return class {
          addEvents() {
            let A = this, l = function(u) {
              z(u, R ? "touchstart" : "mousedown", (c) => {
                A.onMouseDown(c);
              }, { passive: !1 });
            };
            if (l(this.graphic.element), (A.labels || []).forEach((u) => {
              u.options.useHTML && u.graphic.text && l(u.graphic.text.element);
            }), L(A.options.events, (u, c) => {
              let v = function(s) {
                var f;
                c === "click" && A.cancelClick || u.call(A, (f = A.chart.pointer) == null ? void 0 : f.normalize(s), A.target);
              };
              (A.nonDOMEvents || []).indexOf(c) === -1 ? (z(A.graphic.element, c, v, { passive: !1 }), A.graphic.div && z(A.graphic.div, c, v, { passive: !1 })) : z(A, c, v, { passive: !1 });
            }), A.options.draggable && (z(A, "drag", A.onDrag), !A.graphic.renderer.styledMode)) {
              let u = { cursor: { x: "ew-resize", y: "ns-resize", xy: "move" }[A.options.draggable] };
              A.graphic.css(u), (A.labels || []).forEach((c) => {
                c.options.useHTML && c.graphic.text && c.graphic.text.css(u);
              });
            }
            A.isUpdating || O(A, "add");
          }
          destroy() {
            this.removeDocEvents(), w(this), this.hcEvents = null;
          }
          mouseMoveToRadians(A, l, u) {
            let c = A.prevChartY - u, v = A.prevChartX - l, s = A.chartY - u, f = A.chartX - l, y;
            return this.chart.inverted && (y = v, v = c, c = y, y = f, f = s, s = y), Math.atan2(s, f) - Math.atan2(c, v);
          }
          mouseMoveToScale(A, l, u) {
            let c = A.prevChartX - l, v = A.prevChartY - u, s = A.chartX - l, f = A.chartY - u, y = (s || 1) / (c || 1), h = (f || 1) / (v || 1);
            if (this.chart.inverted) {
              let a = h;
              h = y, y = a;
            }
            return { x: y, y: h };
          }
          mouseMoveToTranslation(A) {
            let l = A.chartX - A.prevChartX, u = A.chartY - A.prevChartY, c;
            return this.chart.inverted && (c = u, u = l, l = c), { x: l, y: u };
          }
          onDrag(A) {
            if (this.chart.isInsidePlot(A.chartX - this.chart.plotLeft, A.chartY - this.chart.plotTop, { visiblePlotOnly: !0 })) {
              let l = this.mouseMoveToTranslation(A);
              this.options.draggable === "x" && (l.y = 0), this.options.draggable === "y" && (l.x = 0), this.points.length ? this.translate(l.x, l.y) : (this.shapes.forEach((u) => u.translate(l.x, l.y)), this.labels.forEach((u) => u.translate(l.x, l.y))), this.redraw(!1);
            }
          }
          onMouseDown(A) {
            var f;
            if (A.preventDefault && A.preventDefault(), A.button === 2) return;
            let l = this, u = l.chart.pointer, c = ((f = A == null ? void 0 : A.sourceCapabilities) == null ? void 0 : f.firesTouchEvents) || !1, v = (A = (u == null ? void 0 : u.normalize(A)) || A).chartX, s = A.chartY;
            l.cancelClick = !1, l.chart.hasDraggedAnnotation = !0, l.removeDrag = z(I, R || c ? "touchmove" : "mousemove", function(y) {
              l.hasDragged = !0, (y = (u == null ? void 0 : u.normalize(y)) || y).prevChartX = v, y.prevChartY = s, O(l, "drag", y), v = y.chartX, s = y.chartY;
            }, R || c ? { passive: !1 } : void 0), l.removeMouseUp = z(I, R || c ? "touchend" : "mouseup", function() {
              let y = M(l.target && l.target.annotation, l.target);
              y && (y.cancelClick = l.hasDragged), l.cancelClick = l.hasDragged, l.chart.hasDraggedAnnotation = !1, l.hasDragged && O(M(y, l), "afterUpdate"), l.hasDragged = !1, l.onMouseUp();
            }, R || c ? { passive: !1 } : void 0);
          }
          onMouseUp() {
            this.removeDocEvents();
          }
          removeDocEvents() {
            this.removeDrag && (this.removeDrag = this.removeDrag()), this.removeMouseUp && (this.removeMouseUp = this.removeMouseUp());
          }
        };
      }), Z(r, "Extensions/Annotations/ControlPoint.js", [r["Extensions/Annotations/EventEmitter.js"], r["Core/Utilities.js"]], function(T, B) {
        let { merge: I, pick: R } = B;
        return class extends T {
          constructor(z, O, L, M) {
            super(), this.nonDOMEvents = ["drag"], this.chart = z, this.target = O, this.options = L, this.index = R(L.index, M);
          }
          destroy() {
            super.destroy(), this.graphic && (this.graphic = this.graphic.destroy()), this.chart = null, this.target = null, this.options = null;
          }
          redraw(z) {
            this.graphic[z ? "animate" : "attr"](this.options.positioner.call(this, this.target));
          }
          render() {
            let z = this.chart, O = this.options;
            this.graphic = z.renderer.symbol(O.symbol, 0, 0, O.width, O.height).add(z.controlPointsGroup).css(O.style), this.setVisibility(O.visible), this.addEvents();
          }
          setVisibility(z) {
            this.graphic[z ? "show" : "hide"](), this.options.visible = z;
          }
          update(z) {
            let O = this.chart, L = this.target, M = this.index, w = I(!0, this.options, z);
            this.destroy(), this.constructor(O, L, w, M), this.render(O.controlPointsGroup), this.redraw();
          }
        };
      }), Z(r, "Extensions/Annotations/MockPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { series: { prototype: I } } = T, { defined: R, fireEvent: z } = B;
        class O {
          static fromPoint(M) {
            return new O(M.series.chart, null, { x: M.x, y: M.y, xAxis: M.series.xAxis, yAxis: M.series.yAxis });
          }
          static pointToPixels(M, w) {
            let A = M.series, l = A.chart, u = M.plotX || 0, c = M.plotY || 0, v;
            return l.inverted && (M.mock ? (u = M.plotY, c = M.plotX) : (u = l.plotWidth - (M.plotY || 0), c = l.plotHeight - (M.plotX || 0))), A && !w && (u += (v = A.getPlotBox()).translateX, c += v.translateY), { x: u, y: c };
          }
          static pointToOptions(M) {
            return { x: M.x, y: M.y, xAxis: M.series.xAxis, yAxis: M.series.yAxis };
          }
          constructor(M, w, A) {
            this.mock = !0, this.series = { visible: !0, chart: M, getPlotBox: I.getPlotBox }, this.target = w || null, this.options = A, this.applyOptions(this.getOptions());
          }
          applyOptions(M) {
            this.command = M.command, this.setAxis(M, "x"), this.setAxis(M, "y"), this.refresh();
          }
          getLabelConfig() {
            return { x: this.x, y: this.y, point: this };
          }
          getOptions() {
            return this.hasDynamicOptions() ? this.options(this.target) : this.options;
          }
          hasDynamicOptions() {
            return typeof this.options == "function";
          }
          isInsidePlot() {
            let M = this.plotX, w = this.plotY, A = this.series.xAxis, l = this.series.yAxis, u = { x: M, y: w, isInsidePlot: !0, options: {} };
            return A && (u.isInsidePlot = R(M) && M >= 0 && M <= A.len), l && (u.isInsidePlot = u.isInsidePlot && R(w) && w >= 0 && w <= l.len), z(this.series.chart, "afterIsInsidePlot", u), u.isInsidePlot;
          }
          refresh() {
            let M = this.series, w = M.xAxis, A = M.yAxis, l = this.getOptions();
            w ? (this.x = l.x, this.plotX = w.toPixels(l.x, !0)) : (this.x = void 0, this.plotX = l.x), A ? (this.y = l.y, this.plotY = A.toPixels(l.y, !0)) : (this.y = null, this.plotY = l.y), this.isInside = this.isInsidePlot();
          }
          refreshOptions() {
            let M = this.series, w = M.xAxis, A = M.yAxis;
            this.x = this.options.x = w ? this.options.x = w.toValue(this.plotX, !0) : this.plotX, this.y = this.options.y = A ? A.toValue(this.plotY, !0) : this.plotY;
          }
          rotate(M, w, A) {
            if (!this.hasDynamicOptions()) {
              let l = Math.cos(A), u = Math.sin(A), c = this.plotX - M, v = this.plotY - w;
              this.plotX = c * l - v * u + M, this.plotY = c * u + v * l + w, this.refreshOptions();
            }
          }
          scale(M, w, A, l) {
            if (!this.hasDynamicOptions()) {
              let u = this.plotX * A, c = this.plotY * l;
              this.plotX = (1 - A) * M + u, this.plotY = (1 - l) * w + c, this.refreshOptions();
            }
          }
          setAxis(M, w) {
            let A = w + "Axis", l = M[A], u = this.series.chart;
            this.series[A] = typeof l == "object" ? l : R(l) ? u[A][l] || u.get(l) : null;
          }
          toAnchor() {
            let M = [this.plotX, this.plotY, 0, 0];
            return this.series.chart.inverted && (M[0] = this.plotY, M[1] = this.plotX), M;
          }
          translate(M, w, A, l) {
            this.hasDynamicOptions() || (this.plotX += A, this.plotY += l, this.refreshOptions());
          }
        }
        return O;
      }), Z(r, "Extensions/Annotations/ControlTarget.js", [r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        return function(z) {
          function O() {
            let h = this.controlPoints, a = this.options.controlPoints || [];
            a.forEach((x, S) => {
              let E = I.merge(this.options.controlPointOptions, x);
              E.index || (E.index = S), a[S] = E, h.push(new T(this.chart, this, E));
            });
          }
          function L(h) {
            let a = h.series.getPlotBox(), x = h.series.chart, S = h.mock ? h.toAnchor() : x.tooltip && x.tooltip.getAnchor.call({ chart: h.series.chart }, h) || [0, 0, 0, 0], E = { x: S[0] + (this.options.x || 0), y: S[1] + (this.options.y || 0), height: S[2] || 0, width: S[3] || 0 };
            return { relativePosition: E, absolutePosition: I.merge(E, { x: E.x + (h.mock ? a.translateX : x.plotLeft), y: E.y + (h.mock ? a.translateY : x.plotTop) }) };
          }
          function M() {
            this.controlPoints.forEach((h) => h.destroy()), this.chart = null, this.controlPoints = null, this.points = null, this.options = null, this.annotation && (this.annotation = null);
          }
          function w() {
            let h = this.options;
            return h.points || h.point && I.splat(h.point);
          }
          function A() {
            let h, a, x = this.getPointsOptions(), S = this.points, E = x && x.length || 0;
            for (h = 0; h < E; h++) {
              if (!(a = this.point(x[h], S[h]))) {
                S.length = 0;
                return;
              }
              a.mock && a.refresh(), S[h] = a;
            }
            return S;
          }
          function l(h, a) {
            if (h && h.series) return h;
            if (!a || a.series === null) {
              if (I.isObject(h)) a = new B(this.chart, this, h);
              else if (I.isString(h)) a = this.chart.get(h) || null;
              else if (typeof h == "function") {
                let x = h.call(a, this);
                a = x.series ? x : new B(this.chart, this, h);
              }
            }
            return a;
          }
          function u(h) {
            this.controlPoints.forEach((a) => a.redraw(h));
          }
          function c() {
            this.controlPoints.forEach((h) => h.render());
          }
          function v(h, a, x, S, E) {
            if (this.chart.inverted) {
              let b = a;
              a = x, x = b;
            }
            this.points.forEach((b, p) => this.transformPoint(h, a, x, S, E, p), this);
          }
          function s(h, a, x, S, E, b) {
            let p = this.points[b];
            p.mock || (p = this.points[b] = B.fromPoint(p)), p[h](a, x, S, E);
          }
          function f(h, a) {
            this.transform("translate", null, null, h, a);
          }
          function y(h, a, x) {
            this.transformPoint("translate", null, null, h, a, x);
          }
          z.compose = function(h) {
            let a = h.prototype;
            a.addControlPoints || I.merge(!0, a, { addControlPoints: O, anchor: L, destroyControlTarget: M, getPointsOptions: w, linkPoints: A, point: l, redrawControlPoints: u, renderControlPoints: c, transform: v, transformPoint: s, translate: f, translatePoint: y });
          };
        }(R || (R = {})), R;
      }), Z(r, "Extensions/Annotations/Controllables/Controllable.js", [r["Extensions/Annotations/ControlTarget.js"], r["Core/Utilities.js"]], function(T, B) {
        let { merge: I } = B;
        class R {
          constructor(O, L, M, w) {
            this.annotation = O, this.chart = O.chart, this.collection = w === "label" ? "labels" : "shapes", this.controlPoints = [], this.options = L, this.points = [], this.index = M, this.itemType = w, this.init(O, L, M);
          }
          attr(...O) {
            this.graphic.attr.apply(this.graphic, arguments);
          }
          attrsFromOptions(O) {
            let L, M, w = this.constructor.attrsMap, A = {}, l = this.chart.styledMode;
            for (L in O) M = w[L], w[L] === void 0 || l && ["fill", "stroke", "stroke-width"].indexOf(M) !== -1 || (A[M] = O[L]);
            return A;
          }
          destroy() {
            this.graphic && (this.graphic = this.graphic.destroy()), this.tracker && (this.tracker = this.tracker.destroy()), this.destroyControlTarget();
          }
          init(O, L, M) {
            this.annotation = O, this.chart = O.chart, this.options = L, this.points = [], this.controlPoints = [], this.index = M, this.linkPoints(), this.addControlPoints();
          }
          redraw(O) {
            this.redrawControlPoints(O);
          }
          render(O) {
            this.options.className && this.graphic && this.graphic.addClass(this.options.className), this.renderControlPoints();
          }
          rotate(O, L, M) {
            this.transform("rotate", O, L, M);
          }
          scale(O, L, M, w) {
            this.transform("scale", O, L, M, w);
          }
          setControlPointsVisibility(O) {
            this.controlPoints.forEach((L) => {
              L.setVisibility(O);
            });
          }
          shouldBeDrawn() {
            return !!this.points.length;
          }
          translateShape(O, L, M) {
            let w = this.annotation.chart, A = this.annotation.userOptions, l = w.annotations.indexOf(this.annotation), u = w.options.annotations[l];
            this.translatePoint(O, L, 0), M && this.translatePoint(O, L, 1), u[this.collection][this.index].point = this.options.point, A[this.collection][this.index].point = this.options.point;
          }
          update(O) {
            let L = this.annotation, M = I(!0, this.options, O), w = this.graphic.parentGroup, A = this.constructor;
            this.destroy(), I(!0, this, new A(L, M, this.index, this.itemType)), this.render(w), this.redraw();
          }
        }
        return T.compose(R), R;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableDefaults.js", [], function() {
        return { defaultMarkers: { arrow: { tagName: "marker", attributes: { id: "arrow", refY: 5, refX: 9, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 0 L 10 5 L 0 10 Z", "stroke-width": 0 } }] }, "reverse-arrow": { tagName: "marker", attributes: { id: "reverse-arrow", refY: 5, refX: 1, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 5 L 10 0 L 10 10 Z", "stroke-width": 0 } }] } } };
      }), Z(r, "Extensions/Annotations/Controllables/ControllablePath.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllableDefaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { defaultMarkers: z } = B, { addEvent: O, defined: L, extend: M, merge: w, uniqueKey: A } = R, l = v("marker-end"), u = v("marker-start"), c = "rgba(192,192,192," + (I.svg ? 1e-4 : 2e-3) + ")";
        function v(h) {
          return function(a) {
            this.attr(h, "url(#" + a + ")");
          };
        }
        function s() {
          this.options.defs = w(z, this.options.defs || {});
        }
        function f(h, a) {
          let x = { attributes: { id: h } }, S = { stroke: a.color || "none", fill: a.color || "rgba(0, 0, 0, 0.75)" };
          x.children = a.children && a.children.map(function(p) {
            return w(S, p);
          });
          let E = w(!0, { attributes: { markerWidth: 20, markerHeight: 20, refX: 0, refY: 0, orient: "auto" } }, a, x), b = this.definition(E);
          return b.id = h, b;
        }
        class y extends T {
          static compose(a, x) {
            let S = x.prototype;
            S.addMarker || (O(a, "afterGetContainer", s), S.addMarker = f);
          }
          constructor(a, x, S) {
            super(a, x, S, "shape"), this.type = "path";
          }
          toD() {
            let a = this.options.d;
            if (a) return typeof a == "function" ? a.call(this) : a;
            let x = this.points, S = x.length, E = [], b = S, p = x[0], C = b && this.anchor(p).absolutePosition, o = 0, t;
            if (C) for (E.push(["M", C.x, C.y]); ++o < S && b; ) t = (p = x[o]).command || "L", C = this.anchor(p).absolutePosition, t === "M" ? E.push([t, C.x, C.y]) : t === "L" ? E.push([t, C.x, C.y]) : t === "Z" && E.push([t]), b = p.series.visible;
            return b && this.graphic ? this.chart.renderer.crispLine(E, this.graphic.strokeWidth()) : null;
          }
          shouldBeDrawn() {
            return super.shouldBeDrawn() || !!this.options.d;
          }
          render(a) {
            let x = this.options, S = this.attrsFromOptions(x);
            this.graphic = this.annotation.chart.renderer.path([["M", 0, 0]]).attr(S).add(a), this.tracker = this.annotation.chart.renderer.path([["M", 0, 0]]).addClass("highcharts-tracker-line").attr({ zIndex: 2 }).add(a), this.annotation.chart.styledMode || this.tracker.attr({ "stroke-linejoin": "round", stroke: c, fill: c, "stroke-width": this.graphic.strokeWidth() + 2 * x.snap }), super.render(), M(this.graphic, { markerStartSetter: u, markerEndSetter: l }), this.setMarkers(this);
          }
          redraw(a) {
            if (this.graphic) {
              let x = this.toD(), S = a ? "animate" : "attr";
              x ? (this.graphic[S]({ d: x }), this.tracker[S]({ d: x })) : (this.graphic.attr({ d: "M 0 -9000000000" }), this.tracker.attr({ d: "M 0 -9000000000" })), this.graphic.placed = this.tracker.placed = !!x;
            }
            super.redraw(a);
          }
          setMarkers(a) {
            let x = a.options, S = a.chart, E = S.options.defs, b = x.fill, p = L(b) && b !== "none" ? b : x.stroke;
            ["markerStart", "markerEnd"].forEach(function(C) {
              let o, t, e, n, d = x[C];
              if (d) {
                for (e in E) if ((d === ((o = E[e]).attributes && o.attributes.id) || d === o.id) && o.tagName === "marker") {
                  t = o;
                  break;
                }
                t && (n = a[C] = S.renderer.addMarker((x.id || A()) + "-" + d, w(t, { color: p })), a.attr(C, n.getAttribute("id")));
              }
            });
          }
        }
        return y.attrsMap = { dashStyle: "dashstyle", strokeWidth: "stroke-width", stroke: "stroke", fill: "fill", zIndex: "zIndex" }, y;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableRect.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends T {
          constructor(L, M, w) {
            super(L, M, w, "shape"), this.type = "rect", this.translate = super.translateShape;
          }
          render(L) {
            let M = this.attrsFromOptions(this.options);
            this.graphic = this.annotation.chart.renderer.rect(0, -9e9, 0, 0).attr(M).add(L), super.render();
          }
          redraw(L) {
            if (this.graphic) {
              let M = this.anchor(this.points[0]).absolutePosition;
              M ? this.graphic[L ? "animate" : "attr"]({ x: M.x, y: M.y, width: this.options.width, height: this.options.height }) : this.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!M;
            }
            super.redraw(L);
          }
        }
        return z.attrsMap = R(B.attrsMap, { width: "width", height: "height" }), z;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableCircle.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends T {
          constructor(L, M, w) {
            super(L, M, w, "shape"), this.type = "circle", this.translate = super.translateShape;
          }
          redraw(L) {
            if (this.graphic) {
              let M = this.anchor(this.points[0]).absolutePosition;
              M ? this.graphic[L ? "animate" : "attr"]({ x: M.x, y: M.y, r: this.options.r }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!M;
            }
            super.redraw.call(this, L);
          }
          render(L) {
            let M = this.attrsFromOptions(this.options);
            this.graphic = this.annotation.chart.renderer.circle(0, -9e9, 0).attr(M).add(L), super.render();
          }
          setRadius(L) {
            this.options.r = L;
          }
        }
        return z.attrsMap = R(B.attrsMap, { r: "r" }), z;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableEllipse.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R, defined: z } = I;
        class O extends T {
          constructor(M, w, A) {
            super(M, w, A, "shape"), this.type = "ellipse";
          }
          init(M, w, A) {
            z(w.yAxis) && w.points.forEach((l) => {
              l.yAxis = w.yAxis;
            }), z(w.xAxis) && w.points.forEach((l) => {
              l.xAxis = w.xAxis;
            }), super.init(M, w, A);
          }
          render(M) {
            this.graphic = this.annotation.chart.renderer.createElement("ellipse").attr(this.attrsFromOptions(this.options)).add(M), super.render();
          }
          translate(M, w) {
            super.translateShape(M, w, !0);
          }
          getDistanceFromLine(M, w, A, l) {
            return Math.abs((w.y - M.y) * A - (w.x - M.x) * l + w.x * M.y - w.y * M.x) / Math.sqrt((w.y - M.y) * (w.y - M.y) + (w.x - M.x) * (w.x - M.x));
          }
          getAttrs(M, w) {
            let A = M.x, l = M.y, u = w.x, c = w.y, v = (A + u) / 2, s = Math.sqrt((A - u) * (A - u) / 4 + (l - c) * (l - c) / 4), f = 180 * Math.atan((c - l) / (u - A)) / Math.PI;
            return v < A && (f += 180), { cx: v, cy: (l + c) / 2, rx: s, ry: this.getRY(), angle: f };
          }
          getRY() {
            let M = this.getYAxis();
            return z(M) ? Math.abs(M.toPixels(this.options.ry) - M.toPixels(0)) : this.options.ry;
          }
          getYAxis() {
            let M = this.options.yAxis;
            return this.chart.yAxis[M];
          }
          getAbsolutePosition(M) {
            return this.anchor(M).absolutePosition;
          }
          redraw(M) {
            if (this.graphic) {
              let w = this.getAbsolutePosition(this.points[0]), A = this.getAbsolutePosition(this.points[1]), l = this.getAttrs(w, A);
              w ? this.graphic[M ? "animate" : "attr"]({ cx: l.cx, cy: l.cy, rx: l.rx, ry: l.ry, rotation: l.angle, rotationOriginX: l.cx, rotationOriginY: l.cy }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!w;
            }
            super.redraw(M);
          }
          setYRadius(M) {
            let w = this.annotation.userOptions.shapes;
            this.options.ry = M, w && w[0] && (w[0].ry = M, w[0].ry = M);
          }
        }
        return O.attrsMap = R(B.attrsMap, { ry: "ry" }), O;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableLabel.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Core/Templating.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { format: z } = B, { extend: O, isNumber: L, pick: M } = R;
        function w(l, u, c, v, s) {
          let f = s && s.anchorX, y = s && s.anchorY, h, a, x = c / 2;
          return L(f) && L(y) && (h = [["M", f, y]], (a = u - y) < 0 && (a = -v - a), a < c && (x = f < l + c / 2 ? a : c - a), y > u + v ? h.push(["L", l + x, u + v]) : y < u ? h.push(["L", l + x, u]) : f < l ? h.push(["L", l, u + v / 2]) : f > l + c && h.push(["L", l + c, u + v / 2])), h || [];
        }
        class A extends T {
          static alignedPosition(u, c) {
            let v = u.align, s = u.verticalAlign, f = (c.x || 0) + (u.x || 0), y = (c.y || 0) + (u.y || 0), h, a;
            return v === "right" ? h = 1 : v === "center" && (h = 2), h && (f += (c.width - (u.width || 0)) / h), s === "bottom" ? a = 1 : s === "middle" && (a = 2), a && (y += (c.height - (u.height || 0)) / a), { x: Math.round(f), y: Math.round(y) };
          }
          static compose(u) {
            u.prototype.symbols.connector = w;
          }
          static justifiedOptions(u, c, v, s) {
            let f, y = v.align, h = v.verticalAlign, a = c.box ? 0 : c.padding || 0, x = c.getBBox(), S = { align: y, verticalAlign: h, x: v.x, y: v.y, width: c.width, height: c.height }, E = (s.x || 0) - u.plotLeft, b = (s.y || 0) - u.plotTop;
            return (f = E + a) < 0 && (y === "right" ? S.align = "left" : S.x = (S.x || 0) - f), (f = E + x.width - a) > u.plotWidth && (y === "left" ? S.align = "right" : S.x = (S.x || 0) + u.plotWidth - f), (f = b + a) < 0 && (h === "bottom" ? S.verticalAlign = "top" : S.y = (S.y || 0) - f), (f = b + x.height - a) > u.plotHeight && (h === "top" ? S.verticalAlign = "bottom" : S.y = (S.y || 0) + u.plotHeight - f), S;
          }
          constructor(u, c, v) {
            super(u, c, v, "label");
          }
          translatePoint(u, c) {
            super.translatePoint(u, c, 0);
          }
          translate(u, c) {
            let v = this.annotation.chart, s = this.annotation.userOptions, f = v.annotations.indexOf(this.annotation), y = v.options.annotations[f];
            if (v.inverted) {
              let h = u;
              u = c, c = h;
            }
            this.options.x += u, this.options.y += c, y[this.collection][this.index].x = this.options.x, y[this.collection][this.index].y = this.options.y, s[this.collection][this.index].x = this.options.x, s[this.collection][this.index].y = this.options.y;
          }
          render(u) {
            let c = this.options, v = this.attrsFromOptions(c), s = c.style;
            this.graphic = this.annotation.chart.renderer.label("", 0, -9999, c.shape, null, null, c.useHTML, null, "annotation-label").attr(v).add(u), this.annotation.chart.styledMode || (s.color === "contrast" && (s.color = this.annotation.chart.renderer.getContrast(A.shapesWithoutBackground.indexOf(c.shape) > -1 ? "#FFFFFF" : c.backgroundColor)), this.graphic.css(c.style).shadow(c.shadow)), this.graphic.labelrank = c.labelrank, super.render();
          }
          redraw(u) {
            let c = this.options, v = this.text || c.format || c.text, s = this.graphic, f = this.points[0];
            if (!s) {
              this.redraw(u);
              return;
            }
            s.attr({ text: v ? z(String(v), f.getLabelConfig(), this.annotation.chart) : c.formatter.call(f, this) });
            let y = this.anchor(f), h = this.position(y);
            h ? (s.alignAttr = h, h.anchorX = y.absolutePosition.x, h.anchorY = y.absolutePosition.y, s[u ? "animate" : "attr"](h)) : s.attr({ x: 0, y: -9999 }), s.placed = !!h, super.redraw(u);
          }
          anchor(u) {
            let c = super.anchor.apply(this, arguments), v = this.options.x || 0, s = this.options.y || 0;
            return c.absolutePosition.x -= v, c.absolutePosition.y -= s, c.relativePosition.x -= v, c.relativePosition.y -= s, c;
          }
          position(u) {
            let c = this.graphic, v = this.annotation.chart, s = v.tooltip, f = this.points[0], y = this.options, h = u.absolutePosition, a = u.relativePosition, x, S, E, b, p = f.series.visible && I.prototype.isInsidePlot.call(f);
            if (c && p) {
              let { width: C = 0, height: o = 0 } = c;
              y.distance && s ? x = s.getPosition.call({ chart: v, distance: M(y.distance, 16), getPlayingField: s.getPlayingField, pointer: s.pointer }, C, o, { plotX: a.x, plotY: a.y, negative: f.negative, ttBelow: f.ttBelow, h: a.height || a.width }) : y.positioner ? x = y.positioner.call(this) : (S = { x: h.x, y: h.y, width: 0, height: 0 }, x = A.alignedPosition(O(y, { width: C, height: o }), S), this.options.overflow === "justify" && (x = A.alignedPosition(A.justifiedOptions(v, c, y, x), S))), y.crop && (E = x.x - v.plotLeft, b = x.y - v.plotTop, p = v.isInsidePlot(E, b) && v.isInsidePlot(E + C, b + o));
            }
            return p ? x : null;
          }
        }
        return A.attrsMap = { backgroundColor: "fill", borderColor: "stroke", borderWidth: "stroke-width", zIndex: "zIndex", borderRadius: "r", padding: "padding" }, A.shapesWithoutBackground = ["connector"], A;
      }), Z(r, "Extensions/Annotations/Controllables/ControllableImage.js", [r["Extensions/Annotations/Controllables/Controllable.js"], r["Extensions/Annotations/Controllables/ControllableLabel.js"]], function(T, B) {
        class I extends T {
          constructor(z, O, L) {
            super(z, O, L, "shape"), this.type = "image", this.translate = super.translateShape;
          }
          render(z) {
            let O = this.attrsFromOptions(this.options), L = this.options;
            this.graphic = this.annotation.chart.renderer.image(L.src, 0, -9e9, L.width, L.height).attr(O).add(z), this.graphic.width = L.width, this.graphic.height = L.height, super.render();
          }
          redraw(z) {
            if (this.graphic) {
              let O = this.anchor(this.points[0]), L = B.prototype.position.call(this, O);
              L ? this.graphic[z ? "animate" : "attr"]({ x: L.x, y: L.y }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!L;
            }
            super.redraw(z);
          }
        }
        return I.attrsMap = { width: "width", height: "height", zIndex: "zIndex" }, I;
      }), Z(r, "Shared/BaseForm.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Utilities.js"]], function(T, B) {
        let { addEvent: I, createElement: R } = B;
        return class {
          constructor(z, O) {
            this.iconsURL = O, this.container = this.createPopupContainer(z), this.closeButton = this.addCloseButton();
          }
          createPopupContainer(z, O = "highcharts-popup highcharts-no-tooltip") {
            return R("div", { className: O }, void 0, z);
          }
          addCloseButton(z = "highcharts-popup-close") {
            let O = this, L = this.iconsURL, M = R("button", { className: z }, void 0, this.container);
            return M.style["background-image"] = "url(" + (L.match(/png|svg|jpeg|jpg|gif/ig) ? L : L + "close.svg") + ")", ["click", "touchstart"].forEach((w) => {
              I(M, w, O.closeButtonEvents.bind(O));
            }), I(document, "keydown", function(w) {
              w.code === "Escape" && O.closeButtonEvents();
            }), M;
          }
          closeButtonEvents() {
            this.closePopup();
          }
          showPopup(z = "highcharts-annotation-toolbar") {
            let O = this.container, L = this.closeButton;
            this.type = void 0, O.innerHTML = T.emptyHTML, O.className.indexOf(z) >= 0 && (O.classList.remove(z), O.removeAttribute("style")), O.appendChild(L), O.style.display = "block", O.style.height = "";
          }
          closePopup() {
            this.container.style.display = "none";
          }
        };
      }), Z(r, "Extensions/Annotations/Popup/PopupAnnotations.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I, isFirefox: R } = T, { createElement: z, isArray: O, isObject: L, objectEach: M, pick: w, stableSort: A } = B;
        function l(u, c, v, s, f, y) {
          let h, a;
          if (!c) return;
          let x = this.addInput, S = this.lang;
          M(s, (E, b) => {
            h = v !== "" ? v + "." + b : b, L(E) && (!O(E) || O(E) && L(E[0]) ? ((a = S[b] || b).match(/\d/g) || f.push([!0, a, u]), l.call(this, u, c, h, E, f, !1)) : f.push([this, h, "annotation", u, E]));
          }), y && (A(f, (E) => E[1].match(/format/g) ? -1 : 1), R && f.reverse(), f.forEach((E) => {
            E[0] === !0 ? z("span", { className: "highcharts-annotation-title" }, void 0, E[2]).appendChild(I.createTextNode(E[1])) : (E[4] = { value: E[4][0], type: E[4][1] }, x.apply(E[0], E.splice(1)));
          }));
        }
        return { addForm: function(u, c, v, s) {
          if (!u) return;
          let f = this.container, y = this.lang, h = z("h2", { className: "highcharts-popup-main-title" }, void 0, f);
          h.appendChild(I.createTextNode(y[c.langKey] || c.langKey || "")), h = z("div", { className: "highcharts-popup-lhs-col highcharts-popup-lhs-full" }, void 0, f);
          let a = z("div", { className: "highcharts-popup-bottom-row" }, void 0, f);
          l.call(this, h, u, "", c, [], !0), this.addButton(a, s ? y.addButton || "Add" : y.saveButton || "Save", s ? "add" : "save", f, v);
        }, addToolbar: function(u, c, v) {
          let s = this.lang, f = this.container, y = this.showForm, h = "highcharts-annotation-toolbar";
          f.className.indexOf(h) === -1 && (f.className += " " + h + " highcharts-no-mousewheel"), u && (f.style.top = u.plotTop + 10 + "px");
          let a = z("p", { className: "highcharts-annotation-label" }, void 0, f);
          a.setAttribute("aria-label", "Annotation type"), a.appendChild(I.createTextNode(w(s[c.langKey] || c.langKey, c.shapes && c.shapes[0].type, "")));
          let x = this.addButton(f, s.editButton || "Edit", "edit", f, () => {
            y.call(this, "annotation-edit", u, c, v);
          });
          x.className += " highcharts-annotation-edit-button", x.style["background-image"] = "url(" + this.iconsURL + "edit.svg)", x = this.addButton(f, s.removeButton || "Remove", "remove", f, v), x.className += " highcharts-annotation-remove-button", x.style["background-image"] = "url(" + this.iconsURL + "destroy.svg)";
        } };
      }), Z(r, "Extensions/Annotations/Popup/PopupIndicators.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z, O;
        let { doc: L } = B, { seriesTypes: M } = I, { addEvent: w, createElement: A, defined: l, isArray: u, isObject: c, objectEach: v, stableSort: s } = R;
        (O = z || (z = {}))[O["params.algorithm"] = 0] = "params.algorithm", O[O["params.average"] = 1] = "params.average";
        let f = { "algorithm-pivotpoints": ["standard", "fibonacci", "camarilla"], "average-disparityindex": ["sma", "ema", "dema", "tema", "wma"] };
        function y(e) {
          let n = A("div", { className: "highcharts-popup-lhs-col" }, void 0, e), d = A("div", { className: "highcharts-popup-rhs-col" }, void 0, e);
          return A("div", { className: "highcharts-popup-rhs-col-wrapper" }, void 0, d), { lhsCol: n, rhsCol: d };
        }
        function h(e, n, d, i) {
          let g = n.params || n.options.params;
          i.innerHTML = T.emptyHTML, A("h3", { className: "highcharts-indicator-title" }, void 0, i).appendChild(L.createTextNode(o(n, d).indicatorFullName)), A("input", { type: "hidden", name: "highcharts-type-" + d, value: d }, void 0, i), t.call(this, d, "series", e, i, n, n.linkedParent && n.linkedParent.options.id), g.volumeSeriesID && t.call(this, d, "volume", e, i, n, n.linkedParent && g.volumeSeriesID), x.call(this, e, "params", g, d, i);
        }
        function a(e, n, d, i) {
          function g(Y, q) {
            let N = U.parentNode.children[1];
            h.call(m, e, Y, q, U), N && (N.style.display = "block"), D && Y.options && A("input", { type: "hidden", name: "highcharts-id-" + q, value: Y.options.id }, void 0, U).setAttribute("highcharts-data-series-id", Y.options.id);
          }
          let m = this, k = m.lang, j = n.querySelectorAll(".highcharts-popup-lhs-col")[0], P = n.querySelectorAll(".highcharts-popup-rhs-col")[0], D = d === "edit", H = D ? e.series : e.options.plotOptions || {};
          if (!e && H) return;
          let G, V = [];
          D || u(H) ? u(H) && (V = C.call(this, H)) : V = p.call(this, H, i), s(V, (Y, q) => {
            let N = Y.indicatorFullName.toLowerCase(), X = q.indicatorFullName.toLowerCase();
            return N < X ? -1 : N > X ? 1 : 0;
          }), j.children[1] && j.children[1].remove();
          let F = A("ul", { className: "highcharts-indicator-list" }, void 0, j), U = P.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
          if (V.forEach((Y) => {
            let { indicatorFullName: q, indicatorType: N, series: X } = Y;
            G = A("li", { className: "highcharts-indicator-list" }, void 0, F);
            let W = A("button", { className: "highcharts-indicator-list-item", textContent: q }, void 0, G);
            ["click", "touchstart"].forEach((_) => {
              w(W, _, function() {
                g(X, N);
              });
            });
          }), V.length > 0) {
            let { series: Y, indicatorType: q } = V[0];
            g(Y, q);
          } else D || (T.setElementHTML(U.parentNode.children[0], k.noFilterMatch || ""), U.parentNode.children[1].style.display = "none");
        }
        function x(e, n, d, i, g) {
          if (!e) return;
          let m = this.addInput;
          v(d, (k, j) => {
            let P = n + "." + j;
            if (l(k) && P)
              if (c(k) && (m.call(this, P, i, g, {}), x.call(this, e, P, k, i, g)), P in z) {
                let D = E.call(this, i, P, g);
                b.call(this, e, n, D, i, j, k);
              } else P === "params.volumeSeriesID" || u(k) || m.call(this, P, i, g, { value: k, type: "number" });
          });
        }
        function S(e, n) {
          let d = this, i = n.querySelectorAll(".highcharts-popup-lhs-col")[0], g = this.lang.clearFilter, m = A("div", { className: "highcharts-input-wrapper" }, void 0, i), k = function(D) {
            a.call(d, e, d.container, "add", D);
          }, j = this.addInput("searchIndicators", "input", m, { value: "", type: "text", htmlFor: "search-indicators", labelClassName: "highcharts-input-search-indicators-label" }), P = A("a", { textContent: g }, void 0, m);
          j.classList.add("highcharts-input-search-indicators"), P.classList.add("clear-filter-button"), w(j, "input", function() {
            k(this.value), this.value.length ? P.style.display = "inline-block" : P.style.display = "none";
          }), ["click", "touchstart"].forEach((D) => {
            w(P, D, function() {
              j.value = "", k(""), P.style.display = "none";
            });
          });
        }
        function E(e, n, d) {
          let i = n.split("."), g = i[i.length - 1], m = "highcharts-" + n + "-type-" + e, k = this.lang;
          A("label", { htmlFor: m }, null, d).appendChild(L.createTextNode(k[g] || n));
          let j = A("select", { name: m, className: "highcharts-popup-field", id: "highcharts-select-" + n }, null, d);
          return j.setAttribute("id", "highcharts-select-" + n), j;
        }
        function b(e, n, d, i, g, m, k) {
          n === "series" || n === "volume" ? e.series.forEach((j) => {
            let P = j.options, D = P.name || P.params ? j.name : P.id || "";
            P.id !== "highcharts-navigator-series" && P.id !== (k && k.options && k.options.id) && (l(m) || n !== "volume" || j.type !== "column" || (m = P.id), A("option", { value: P.id }, void 0, d).appendChild(L.createTextNode(D)));
          }) : i && g && f[g + "-" + i].forEach((j) => {
            A("option", { value: j }, void 0, d).appendChild(L.createTextNode(j));
          }), l(m) && (d.value = m);
        }
        function p(e, n) {
          let d, i = this.chart && this.chart.options.lang, g = i && i.navigation && i.navigation.popup && i.navigation.popup.indicatorAliases, m = [];
          return v(e, (k, j) => {
            let P = k && k.options;
            if (k.params || P && P.params) {
              let { indicatorFullName: D, indicatorType: H } = o(k, j);
              if (n) {
                let G = RegExp(n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), V = g && g[H] && g[H].join(" ") || "";
                (D.match(G) || V.match(G)) && (d = { indicatorFullName: D, indicatorType: H, series: k }, m.push(d));
              } else d = { indicatorFullName: D, indicatorType: H, series: k }, m.push(d);
            }
          }), m;
        }
        function C(e) {
          let n = [];
          return e.forEach((d) => {
            d.is("sma") && n.push({ indicatorFullName: d.name, indicatorType: d.type, series: d });
          }), n;
        }
        function o(e, n) {
          let d = e.options, i = M[n] && M[n].prototype.nameBase || n.toUpperCase(), g = n;
          return d && d.type && (g = e.options.type, i = e.name), { indicatorFullName: i, indicatorType: g };
        }
        function t(e, n, d, i, g, m) {
          if (!d) return;
          let k = E.call(this, e, n, i);
          b.call(this, d, n, k, void 0, void 0, void 0, g), l(m) && (k.value = m);
        }
        return { addForm: function(e, n, d) {
          let i, g = this.lang;
          if (!e) return;
          this.tabs.init.call(this, e);
          let m = this.container.querySelectorAll(".highcharts-tab-item-content");
          y(m[0]), S.call(this, e, m[0]), a.call(this, e, m[0], "add"), i = m[0].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(i, g.addButton || "add", "add", i, d), y(m[1]), a.call(this, e, m[1], "edit"), i = m[1].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(i, g.saveButton || "save", "edit", i, d), this.addButton(i, g.removeButton || "remove", "remove", i, d);
        }, getAmount: function() {
          let e = 0;
          return this.series.forEach((n) => {
            (n.params || n.options.params) && e++;
          }), e;
        } };
      }), Z(r, "Extensions/Annotations/Popup/PopupTabs.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I } = T, { addEvent: R, createElement: z } = B;
        function O() {
          return z("div", { className: "highcharts-tab-item-content highcharts-no-mousewheel" }, void 0, this.container);
        }
        function L(l, u) {
          let c = this.container, v = this.lang, s = "highcharts-tab-item";
          u === 0 && (s += " highcharts-tab-disabled");
          let f = z("button", { className: s }, void 0, c);
          return f.appendChild(I.createTextNode(v[l + "Button"] || l)), f.setAttribute("highcharts-data-tab-type", l), f;
        }
        function M() {
          let l = this.container, u = l.querySelectorAll(".highcharts-tab-item"), c = l.querySelectorAll(".highcharts-tab-item-content");
          for (let v = 0; v < u.length; v++) u[v].classList.remove("highcharts-tab-item-active"), c[v].classList.remove("highcharts-tab-item-show");
        }
        function w(l, u) {
          let c = this.container.querySelectorAll(".highcharts-tab-item-content");
          l.className += " highcharts-tab-item-active", c[u].className += " highcharts-tab-item-show";
        }
        function A(l) {
          let u = this;
          this.container.querySelectorAll(".highcharts-tab-item").forEach((c, v) => {
            (l !== 0 || c.getAttribute("highcharts-data-tab-type") !== "edit") && ["click", "touchstart"].forEach((s) => {
              R(c, s, function() {
                M.call(u), w.call(u, this, v);
              });
            });
          });
        }
        return { init: function(l) {
          if (!l) return;
          let u = this.indicators.getAmount.call(l), c = L.call(this, "add");
          L.call(this, "edit", u), O.call(this), O.call(this), A.call(this, u), w.call(this, c, 0);
        } };
      }), Z(r, "Extensions/Annotations/Popup/Popup.js", [r["Shared/BaseForm.js"], r["Core/Globals.js"], r["Core/Defaults.js"], r["Extensions/Annotations/Popup/PopupAnnotations.js"], r["Extensions/Annotations/Popup/PopupIndicators.js"], r["Extensions/Annotations/Popup/PopupTabs.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { doc: M } = B, { getOptions: w } = I, { addEvent: A, createElement: l, extend: u, fireEvent: c, pick: v } = L;
        class s extends T {
          constructor(y, h, a) {
            super(y, h), this.chart = a, this.lang = (w().lang.navigation || {}).popup || {}, A(this.container, "mousedown", () => {
              let x = a && a.navigationBindings && a.navigationBindings.activeAnnotation;
              if (x) {
                x.cancelClick = !0;
                let S = A(M, "click", () => {
                  setTimeout(() => {
                    x.cancelClick = !1;
                  }, 0), S();
                });
              }
            });
          }
          addInput(y, h, a, x) {
            let S = y.split("."), E = S[S.length - 1], b = this.lang, p = "highcharts-" + h + "-" + v(x.htmlFor, E);
            E.match(/^\d+$/) || l("label", { htmlFor: p, className: x.labelClassName }, void 0, a).appendChild(M.createTextNode(b[E] || E));
            let C = l("input", { name: p, value: x.value, type: x.type, className: "highcharts-popup-field" }, void 0, a);
            return C.setAttribute("highcharts-data-name", y), C;
          }
          closeButtonEvents() {
            if (this.chart) {
              let y = this.chart.navigationBindings;
              c(y, "closePopup"), y && y.selectedButtonElement && c(y, "deselectButton", { button: y.selectedButtonElement });
            } else super.closeButtonEvents();
          }
          addButton(y, h, a, x, S) {
            let E = l("button", void 0, void 0, y);
            return E.appendChild(M.createTextNode(h)), S && ["click", "touchstart"].forEach((b) => {
              A(E, b, () => (this.closePopup(), S(function(p, C) {
                let o = Array.prototype.slice.call(p.querySelectorAll("input")), t = Array.prototype.slice.call(p.querySelectorAll("select")), e = p.querySelectorAll("#highcharts-select-series > option:checked")[0], n = p.querySelectorAll("#highcharts-select-volume > option:checked")[0], d = { actionType: C, linkedTo: e && e.getAttribute("value") || "", fields: {} };
                return o.forEach((i) => {
                  let g = i.getAttribute("highcharts-data-name");
                  i.getAttribute("highcharts-data-series-id") ? d.seriesId = i.value : g ? d.fields[g] = i.value : d.type = i.value;
                }), t.forEach((i) => {
                  let g = i.id;
                  if (g !== "highcharts-select-series" && g !== "highcharts-select-volume") {
                    let m = g.split("highcharts-select-")[1];
                    d.fields[m] = i.value;
                  }
                }), n && (d.fields["params.volumeSeriesID"] = n.getAttribute("value") || ""), d;
              }(x, a))));
            }), E;
          }
          showForm(y, h, a, x) {
            h && (this.showPopup(), y === "indicators" && this.indicators.addForm.call(this, h, a, x), y === "annotation-toolbar" && this.annotations.addToolbar.call(this, h, a, x), y === "annotation-edit" && this.annotations.addForm.call(this, h, a, x), y === "flag" && this.annotations.addForm.call(this, h, a, x, !0), this.type = y, this.container.style.height = this.container.offsetHeight + "px");
          }
        }
        return u(s.prototype, { annotations: R, indicators: z, tabs: O }), s;
      }), Z(r, "Extensions/Annotations/Popup/PopupComposition.js", [r["Core/Globals.js"], r["Extensions/Annotations/Popup/Popup.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { composed: R } = T, { addEvent: z, pushUnique: O, wrap: L } = I;
        function M() {
          this.popup && this.popup.closePopup();
        }
        function w(l) {
          this.popup || (this.popup = new B(this.chart.container, this.chart.options.navigation.iconsURL || this.chart.options.stockTools && this.chart.options.stockTools.gui.iconsURL || "https://code.highcharts.com/11.4.8/gfx/stock-icons/", this.chart)), this.popup.showForm(l.formType, this.chart, l.options, l.onSubmit);
        }
        function A(l, u) {
          this.inClass(u.target, "highcharts-popup") || l.apply(this, Array.prototype.slice.call(arguments, 1));
        }
        return { compose: function(l, u) {
          O(R, "Popup") && (z(l, "closePopup", M), z(l, "showPopup", w), L(u.prototype, "onContainerMouseDown", A));
        } };
      }), Z(r, "Extensions/Annotations/Annotation.js", [r["Core/Animation/AnimationUtilities.js"], r["Extensions/Annotations/AnnotationChart.js"], r["Extensions/Annotations/AnnotationDefaults.js"], r["Extensions/Annotations/Controllables/ControllableRect.js"], r["Extensions/Annotations/Controllables/ControllableCircle.js"], r["Extensions/Annotations/Controllables/ControllableEllipse.js"], r["Extensions/Annotations/Controllables/ControllablePath.js"], r["Extensions/Annotations/Controllables/ControllableImage.js"], r["Extensions/Annotations/Controllables/ControllableLabel.js"], r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/ControlTarget.js"], r["Extensions/Annotations/EventEmitter.js"], r["Extensions/Annotations/MockPoint.js"], r["Extensions/Annotations/Popup/PopupComposition.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A, l, u, c, v, s) {
        let { getDeferredAnimation: f } = T, { destroyObjectProperties: y, erase: h, fireEvent: a, merge: x, pick: S, splat: E } = s;
        function b(C, o) {
          let t = {};
          return ["labels", "shapes"].forEach((e) => {
            let n = C[e];
            n && (o[e] ? t[e] = E(o[e]).map(function(d, i) {
              return x(n[i], d);
            }) : t[e] = C[e]);
          }), t;
        }
        class p extends u {
          static compose(o, t, e, n) {
            B.compose(p, o, e), w.compose(n), L.compose(o, n), t.compose(p, o), v.compose(t, e);
          }
          constructor(o, t) {
            super(), this.coll = "annotations", this.chart = o, this.points = [], this.controlPoints = [], this.coll = "annotations", this.index = -1, this.labels = [], this.shapes = [], this.options = x(this.defaultOptions, t), this.userOptions = t;
            let e = b(this.options, t);
            this.options.labels = e.labels, this.options.shapes = e.shapes, this.init(o, this.options);
          }
          addClipPaths() {
            this.setClipAxes(), this.clipXAxis && this.clipYAxis && this.options.crop && (this.clipRect = this.chart.renderer.clipRect(this.getClipBox()));
          }
          addLabels() {
            let o = this.options.labels || [];
            o.forEach((t, e) => {
              let n = this.initLabel(t, e);
              x(!0, o[e], n.options);
            });
          }
          addShapes() {
            let o = this.options.shapes || [];
            o.forEach((t, e) => {
              let n = this.initShape(t, e);
              x(!0, o[e], n.options);
            });
          }
          destroy() {
            let o = this.chart, t = function(e) {
              e.destroy();
            };
            this.labels.forEach(t), this.shapes.forEach(t), this.clipXAxis = null, this.clipYAxis = null, h(o.labelCollectors, this.labelCollector), super.destroy(), this.destroyControlTarget(), y(this, o);
          }
          destroyItem(o) {
            h(this[o.itemType + "s"], o), o.destroy();
          }
          getClipBox() {
            if (this.clipXAxis && this.clipYAxis) return { x: this.clipXAxis.left, y: this.clipYAxis.top, width: this.clipXAxis.width, height: this.clipYAxis.height };
          }
          initProperties(o, t) {
            this.setOptions(t);
            let e = b(this.options, t);
            this.options.labels = e.labels, this.options.shapes = e.shapes, this.chart = o, this.points = [], this.controlPoints = [], this.coll = "annotations", this.userOptions = t, this.labels = [], this.shapes = [];
          }
          init(o, t, e = this.index) {
            let n = this.chart, d = this.options.animation;
            this.index = e, this.linkPoints(), this.addControlPoints(), this.addShapes(), this.addLabels(), this.setLabelCollector(), this.animationConfig = f(n, d);
          }
          initLabel(o, t) {
            let e = new w(this, x(this.options.labelOptions, { controlPointOptions: this.options.controlPointOptions }, o), t);
            return e.itemType = "label", this.labels.push(e), e;
          }
          initShape(o, t) {
            let e = x(this.options.shapeOptions, { controlPointOptions: this.options.controlPointOptions }, o), n = new p.shapesMap[e.type](this, e, t);
            return n.itemType = "shape", this.shapes.push(n), n;
          }
          redraw(o) {
            this.linkPoints(), this.graphic || this.render(), this.clipRect && this.clipRect.animate(this.getClipBox()), this.redrawItems(this.shapes, o), this.redrawItems(this.labels, o), this.redrawControlPoints(o);
          }
          redrawItem(o, t) {
            o.linkPoints(), o.shouldBeDrawn() ? (o.graphic || this.renderItem(o), o.redraw(S(t, !0) && o.graphic.placed), o.points.length && function(e) {
              let n = e.graphic, d = e.points.some((i) => i.series.visible !== !1 && i.visible !== !1);
              n && (d ? n.visibility === "hidden" && n.show() : n.hide());
            }(o)) : this.destroyItem(o);
          }
          redrawItems(o, t) {
            let e = o.length;
            for (; e--; ) this.redrawItem(o[e], t);
          }
          remove() {
            return this.chart.removeAnnotation(this);
          }
          render() {
            let o = this.chart.renderer;
            this.graphic = o.g("annotation").attr({ opacity: 0, zIndex: this.options.zIndex, visibility: this.options.visible ? "inherit" : "hidden" }).add(), this.shapesGroup = o.g("annotation-shapes").add(this.graphic), this.options.crop && this.shapesGroup.clip(this.chart.plotBoxClip), this.labelsGroup = o.g("annotation-labels").attr({ translateX: 0, translateY: 0 }).add(this.graphic), this.addClipPaths(), this.clipRect && this.graphic.clip(this.clipRect), this.renderItems(this.shapes), this.renderItems(this.labels), this.addEvents(), this.renderControlPoints();
          }
          renderItem(o) {
            o.render(o.itemType === "label" ? this.labelsGroup : this.shapesGroup);
          }
          renderItems(o) {
            let t = o.length;
            for (; t--; ) this.renderItem(o[t]);
          }
          setClipAxes() {
            let o = this.chart.xAxis, t = this.chart.yAxis, e = (this.options.labels || []).concat(this.options.shapes || []).reduce((n, d) => {
              let i = d && (d.point || d.points && d.points[0]);
              return [o[i && i.xAxis] || n[0], t[i && i.yAxis] || n[1]];
            }, []);
            this.clipXAxis = e[0], this.clipYAxis = e[1];
          }
          setControlPointsVisibility(o) {
            let t = function(e) {
              e.setControlPointsVisibility(o);
            };
            this.controlPoints.forEach((e) => {
              e.setVisibility(o);
            }), this.shapes.forEach(t), this.labels.forEach(t);
          }
          setLabelCollector() {
            let o = this;
            o.labelCollector = function() {
              return o.labels.reduce(function(t, e) {
                return e.options.allowOverlap || t.push(e.graphic), t;
              }, []);
            }, o.chart.labelCollectors.push(o.labelCollector);
          }
          setOptions(o) {
            this.options = x(this.defaultOptions, o);
          }
          setVisibility(o) {
            let t = this.options, e = this.chart.navigationBindings, n = S(o, !t.visible);
            if (this.graphic.attr("visibility", n ? "inherit" : "hidden"), !n) {
              let d = function(i) {
                i.setControlPointsVisibility(n);
              };
              this.shapes.forEach(d), this.labels.forEach(d), e.activeAnnotation === this && e.popup && e.popup.type === "annotation-toolbar" && a(e, "closePopup");
            }
            t.visible = n;
          }
          update(o, t) {
            let e = this.chart, n = b(this.userOptions, o), d = e.annotations.indexOf(this), i = x(!0, this.userOptions, o);
            i.labels = n.labels, i.shapes = n.shapes, this.destroy(), this.initProperties(e, i), this.init(e, i), e.options.annotations[d] = this.options, this.isUpdating = !0, S(t, !0) && e.drawAnnotations(), a(this, "afterUpdate"), this.isUpdating = !1;
          }
        }
        return p.ControlPoint = A, p.MockPoint = c, p.shapesMap = { rect: R, circle: z, ellipse: O, path: L, image: M }, p.types = {}, p.prototype.defaultOptions = I, p.prototype.nonDOMEvents = ["add", "afterUpdate", "drag", "remove"], l.compose(p), p;
      }), Z(r, "Core/Chart/ChartNavigationComposition.js", [], function() {
        var T;
        return function(B) {
          B.compose = function(R) {
            return R.navigation || (R.navigation = new I(R)), R;
          };
          class I {
            constructor(z) {
              this.updates = [], this.chart = z;
            }
            addUpdate(z) {
              this.chart.navigation.updates.push(z);
            }
            update(z, O) {
              this.updates.forEach((L) => {
                L.call(this.chart, z, O);
              });
            }
          }
          B.Additions = I;
        }(T || (T = {})), T;
      }), Z(r, "Extensions/Annotations/NavigationBindingsUtilities.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B, isNumber: I, pick: R } = T, z = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
        return { annotationsFieldsTypes: z, getAssignedAxis: function(O) {
          return O.filter((L) => {
            let M = L.axis.getExtremes(), w = M.min, A = M.max, l = R(L.axis.minPointOffset, 0);
            return I(w) && I(A) && L.value >= w - l && L.value <= A + l && !L.axis.options.isInternal;
          })[0];
        }, getFieldType: function(O, L) {
          let M = z[O], w = typeof L;
          return B(M) && (w = M), { string: "text", number: "number", boolean: "checkbox" }[w];
        } };
      }), Z(r, "Extensions/Annotations/NavigationBindingsDefaults.js", [r["Extensions/Annotations/NavigationBindingsUtilities.js"], r["Core/Utilities.js"]], function(T, B) {
        let { getAssignedAxis: I } = T, { isNumber: R, merge: z } = B;
        return { lang: { navigation: { popup: { simpleShapes: "Simple shapes", lines: "Lines", circle: "Circle", ellipse: "Ellipse", rectangle: "Rectangle", label: "Label", shapeOptions: "Shape options", typeOptions: "Details", fill: "Fill", format: "Text", strokeWidth: "Line width", stroke: "Line color", title: "Title", name: "Name", labelOptions: "Label options", labels: "Labels", backgroundColor: "Background color", backgroundColors: "Background colors", borderColor: "Border color", borderRadius: "Border radius", borderWidth: "Border width", style: "Style", padding: "Padding", fontSize: "Font size", color: "Color", height: "Height", shapes: "Shape options" } } }, navigation: { bindingsClassName: "highcharts-bindings-container", bindings: { circleAnnotation: { className: "highcharts-circle-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "circle", type: "basicAnnotation", shapes: [{ type: "circle", point: { x: M.value, y: w.value, xAxis: M.axis.index, yAxis: w.axis.index }, r: 5 }] }, A.annotationsOptions, A.bindings.circleAnnotation.annotationsOptions));
        }, steps: [function(O, L) {
          let M, w = L.options.shapes, A = w && w[0] && w[0].point || {};
          if (R(A.xAxis) && R(A.yAxis)) {
            let l = this.chart.inverted, u = this.chart.xAxis[A.xAxis].toPixels(A.x), c = this.chart.yAxis[A.yAxis].toPixels(A.y);
            M = Math.max(Math.sqrt(Math.pow(l ? c - O.chartX : u - O.chartX, 2) + Math.pow(l ? u - O.chartY : c - O.chartY, 2)), 5);
          }
          L.update({ shapes: [{ r: M }] });
        }] }, ellipseAnnotation: { className: "highcharts-ellipse-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "ellipse", type: "basicAnnotation", shapes: [{ type: "ellipse", xAxis: M.axis.index, yAxis: w.axis.index, points: [{ x: M.value, y: w.value }, { x: M.value, y: w.value }], ry: 1 }] }, A.annotationsOptions, A.bindings.ellipseAnnotation.annotationOptions));
        }, steps: [function(O, L) {
          let M = L.shapes[0], w = M.getAbsolutePosition(M.points[1]);
          M.translatePoint(O.chartX - w.x, O.chartY - w.y, 1), M.redraw(!1);
        }, function(O, L) {
          let M = L.shapes[0], w = M.getAbsolutePosition(M.points[0]), A = M.getAbsolutePosition(M.points[1]), l = M.getDistanceFromLine(w, A, O.chartX, O.chartY), u = M.getYAxis(), c = Math.abs(u.toValue(0) - u.toValue(l));
          M.setYRadius(c), M.redraw(!1);
        }] }, rectangleAnnotation: { className: "highcharts-rectangle-annotation", start: function(O) {
          var s;
          let L = (s = this.chart.pointer) == null ? void 0 : s.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis);
          if (!M || !w) return;
          let A = M.value, l = w.value, u = M.axis.index, c = w.axis.index, v = this.chart.options.navigation;
          return this.chart.addAnnotation(z({ langKey: "rectangle", type: "basicAnnotation", shapes: [{ type: "path", points: [{ xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { xAxis: u, yAxis: c, x: A, y: l }, { command: "Z" }] }] }, v.annotationsOptions, v.bindings.rectangleAnnotation.annotationsOptions));
        }, steps: [function(O, L) {
          var c;
          let M = L.options.shapes, w = M && M[0] && M[0].points || [], A = (c = this.chart.pointer) == null ? void 0 : c.getCoordinates(O), l = A && I(A.xAxis), u = A && I(A.yAxis);
          if (l && u) {
            let v = l.value, s = u.value;
            w[1].x = v, w[2].x = v, w[2].y = s, w[3].y = s, L.update({ shapes: [{ points: w }] });
          }
        }] }, labelAnnotation: { className: "highcharts-label-annotation", start: function(O) {
          var l;
          let L = (l = this.chart.pointer) == null ? void 0 : l.getCoordinates(O), M = L && I(L.xAxis), w = L && I(L.yAxis), A = this.chart.options.navigation;
          if (M && w) return this.chart.addAnnotation(z({ langKey: "label", type: "basicAnnotation", labelOptions: { format: "{y:.2f}", overflow: "none", crop: !0 }, labels: [{ point: { xAxis: M.axis.index, yAxis: w.axis.index, x: M.value, y: w.value } }] }, A.annotationsOptions, A.bindings.labelAnnotation.annotationsOptions));
        } } }, events: {}, annotationsOptions: { animation: { defer: 0 } } } };
      }), Z(r, "Extensions/Annotations/NavigationBindings.js", [r["Core/Chart/ChartNavigationComposition.js"], r["Core/Defaults.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Extensions/Annotations/NavigationBindingsDefaults.js"], r["Extensions/Annotations/NavigationBindingsUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { setOptions: M } = B, { format: w } = I, { composed: A, doc: l, win: u } = R, { getAssignedAxis: c, getFieldType: v } = O, { addEvent: s, attr: f, defined: y, fireEvent: h, isArray: a, isFunction: x, isNumber: S, isObject: E, merge: b, objectEach: p, pick: C, pushUnique: o } = L;
        function t() {
          this.chart.navigationBindings && this.chart.navigationBindings.deselectAnnotation();
        }
        function e() {
          this.navigationBindings && this.navigationBindings.destroy();
        }
        function n() {
          let j = this.options;
          j && j.navigation && j.navigation.bindings && (this.navigationBindings = new k(this, j.navigation), this.navigationBindings.initEvents(), this.navigationBindings.initUpdate());
        }
        function d() {
          let j = this.navigationBindings, P = "highcharts-disabled-btn";
          if (this && j) {
            let D = !1;
            if (this.series.forEach((H) => {
              !H.options.isInternal && H.visible && (D = !0);
            }), this.navigationBindings && this.navigationBindings.container && this.navigationBindings.container[0]) {
              let H = this.navigationBindings.container[0];
              p(j.boundClassNames, (G, V) => {
                let F = H.querySelectorAll("." + V);
                if (F) for (let U = 0; U < F.length; U++) {
                  let Y = F[U], q = Y.className;
                  G.noDataState === "normal" || D ? q.indexOf(P) !== -1 && Y.classList.remove(P) : q.indexOf(P) === -1 && (Y.className += " " + P);
                }
              });
            }
          }
        }
        function i() {
          this.deselectAnnotation();
        }
        function g() {
          this.selectedButtonElement = null;
        }
        function m(j) {
          let P, D, H = j.prototype.defaultOptions.events && j.prototype.defaultOptions.events.click;
          function G(V) {
            let F = this, U = F.chart.navigationBindings, Y = U.activeAnnotation;
            H && H.call(F, V), Y !== F ? (U.deselectAnnotation(), U.activeAnnotation = F, F.setControlPointsVisibility(!0), h(U, "showPopup", { annotation: F, formType: "annotation-toolbar", options: U.annotationToFields(F), onSubmit: function(q) {
              if (q.actionType === "remove") U.activeAnnotation = !1, U.chart.removeAnnotation(F);
              else {
                let N = {};
                U.fieldsToOptions(q.fields, N), U.deselectAnnotation();
                let X = N.typeOptions;
                F.options.type === "measure" && (X.crosshairY.enabled = X.crosshairY.strokeWidth !== 0, X.crosshairX.enabled = X.crosshairX.strokeWidth !== 0), F.update(N);
              }
            } })) : h(U, "closePopup"), V.activeAnnotation = !0;
          }
          b(!0, j.prototype.defaultOptions.events, { click: G, touchstart: function(V) {
            P = V.touches[0].clientX, D = V.touches[0].clientY;
          }, touchend: function(V) {
            P && Math.sqrt(Math.pow(P - V.changedTouches[0].clientX, 2) + Math.pow(D - V.changedTouches[0].clientY, 2)) >= 4 || G.call(this, V);
          } });
        }
        class k {
          static compose(P, D) {
            o(A, "NavigationBindings") && (s(P, "remove", t), m(P), p(P.types, (H) => {
              m(H);
            }), s(D, "destroy", e), s(D, "load", n), s(D, "render", d), s(k, "closePopup", i), s(k, "deselectButton", g), M(z));
          }
          constructor(P, D) {
            this.boundClassNames = void 0, this.chart = P, this.options = D, this.eventsToUnbind = [], this.container = this.chart.container.getElementsByClassName(this.options.bindingsClassName || ""), this.container.length || (this.container = l.getElementsByClassName(this.options.bindingsClassName || ""));
          }
          getCoords(P) {
            var H;
            let D = (H = this.chart.pointer) == null ? void 0 : H.getCoordinates(P);
            return [D && c(D.xAxis), D && c(D.yAxis)];
          }
          initEvents() {
            let P = this, D = P.chart, H = P.container, G = P.options;
            P.boundClassNames = {}, p(G.bindings || {}, (V) => {
              P.boundClassNames[V.className] = V;
            }), [].forEach.call(H, (V) => {
              P.eventsToUnbind.push(s(V, "click", (F) => {
                let U = P.getButtonEvents(V, F);
                U && !U.button.classList.contains("highcharts-disabled-btn") && P.bindingsButtonClick(U.button, U.events, F);
              }));
            }), p(G.events || {}, (V, F) => {
              x(V) && P.eventsToUnbind.push(s(P, F, V, { passive: !1 }));
            }), P.eventsToUnbind.push(s(D.container, "click", function(V) {
              !D.cancelClick && D.isInsidePlot(V.chartX - D.plotLeft, V.chartY - D.plotTop, { visiblePlotOnly: !0 }) && P.bindingsChartClick(this, V);
            })), P.eventsToUnbind.push(s(D.container, R.isTouchDevice ? "touchmove" : "mousemove", function(V) {
              P.bindingsContainerMouseMove(this, V);
            }, R.isTouchDevice ? { passive: !1 } : void 0));
          }
          initUpdate() {
            let P = this;
            T.compose(this.chart).navigation.addUpdate((D) => {
              P.update(D);
            });
          }
          bindingsButtonClick(P, D, H) {
            let G = this.chart, V = G.renderer.boxWrapper, F = !0;
            this.selectedButtonElement && (this.selectedButtonElement.classList === P.classList && (F = !1), h(this, "deselectButton", { button: this.selectedButtonElement }), this.nextEvent && (this.currentUserDetails && this.currentUserDetails.coll === "annotations" && G.removeAnnotation(this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1)), F ? (this.selectedButton = D, this.selectedButtonElement = P, h(this, "selectButton", { button: P }), D.init && D.init.call(this, P, H), (D.start || D.steps) && G.renderer.boxWrapper.addClass("highcharts-draw-mode")) : (G.stockTools && P.classList.remove("highcharts-active"), V.removeClass("highcharts-draw-mode"), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null);
          }
          bindingsChartClick(P, D) {
            P = this.chart;
            let H = this.activeAnnotation, G = this.selectedButton, V = P.renderer.boxWrapper;
            H && (H.cancelClick || D.activeAnnotation || !D.target.parentNode || function(F, U) {
              let Y = u.Element.prototype, q = Y.matches || Y.msMatchesSelector || Y.webkitMatchesSelector, N = null;
              if (Y.closest) N = Y.closest.call(F, U);
              else do {
                if (q.call(F, U)) return F;
                F = F.parentElement || F.parentNode;
              } while (F !== null && F.nodeType === 1);
              return N;
            }(D.target, ".highcharts-popup") ? H.cancelClick && setTimeout(() => {
              H.cancelClick = !1;
            }, 0) : h(this, "closePopup")), G && G.start && (this.nextEvent ? (this.nextEvent(D, this.currentUserDetails), this.steps && (this.stepIndex++, G.steps[this.stepIndex] ? this.mouseMoveEvent = this.nextEvent = G.steps[this.stepIndex] : (h(this, "deselectButton", { button: this.selectedButtonElement }), V.removeClass("highcharts-draw-mode"), G.end && G.end.call(this, D, this.currentUserDetails), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null))) : (this.currentUserDetails = G.start.call(this, D), this.currentUserDetails && G.steps ? (this.stepIndex = 0, this.steps = !0, this.mouseMoveEvent = this.nextEvent = G.steps[this.stepIndex]) : (h(this, "deselectButton", { button: this.selectedButtonElement }), V.removeClass("highcharts-draw-mode"), this.steps = !1, this.selectedButton = null, G.end && G.end.call(this, D, this.currentUserDetails))));
          }
          bindingsContainerMouseMove(P, D) {
            this.mouseMoveEvent && this.mouseMoveEvent(D, this.currentUserDetails);
          }
          fieldsToOptions(P, D) {
            return p(P, (H, G) => {
              let V = parseFloat(H), F = G.split("."), U = F.length - 1;
              if (!S(V) || H.match(/px|em/g) || G.match(/format/g) || (H = V), H !== "undefined") {
                let Y = D;
                F.forEach((q, N) => {
                  if (q !== "__proto__" && q !== "constructor") {
                    let X = C(F[N + 1], "");
                    U === N ? Y[q] = H : (Y[q] || (Y[q] = X.match(/\d/g) ? [] : {}), Y = Y[q]);
                  }
                });
              }
            }), D;
          }
          deselectAnnotation() {
            this.activeAnnotation && (this.activeAnnotation.setControlPointsVisibility(!1), this.activeAnnotation = !1);
          }
          annotationToFields(P) {
            let D = P.options, H = k.annotationsEditable, G = H.nestedOptions, V = C(D.type, D.shapes && D.shapes[0] && D.shapes[0].type, D.labels && D.labels[0] && D.labels[0].type, "label"), F = k.annotationsNonEditable[D.langKey] || [], U = { langKey: D.langKey, type: V };
            function Y(q, N, X, W, _) {
              let K;
              X && y(q) && F.indexOf(N) === -1 && ((X.indexOf && X.indexOf(N)) >= 0 || X[N] || X === !0) && (a(q) ? (W[N] = [], q.forEach((J, $) => {
                E(J) ? (W[N][$] = {}, p(J, (et, st) => {
                  Y(et, st, G[N], W[N][$], N);
                })) : Y(J, 0, G[N], W[N], N);
              })) : E(q) ? (K = {}, a(W) ? (W.push(K), K[N] = {}, K = K[N]) : W[N] = K, p(q, (J, $) => {
                Y(J, $, N === 0 ? X : G[N], K, N);
              })) : N === "format" ? W[N] = [w(q, P.labels[0].points[0]).toString(), "text"] : a(W) ? W.push([q, v(_, q)]) : W[N] = [q, v(N, q)]);
            }
            return p(D, (q, N) => {
              N === "typeOptions" ? (U[N] = {}, p(D[N], (X, W) => {
                Y(X, W, G, U[N], W);
              })) : Y(q, N, H[V], U, N);
            }), U;
          }
          getClickedClassNames(P, D) {
            let H = D.target, G = [], V;
            for (; H && H.tagName && ((V = f(H, "class")) && (G = G.concat(V.split(" ").map((F) => [F, H]))), (H = H.parentNode) !== P); ) ;
            return G;
          }
          getButtonEvents(P, D) {
            let H, G = this;
            return this.getClickedClassNames(P, D).forEach((V) => {
              G.boundClassNames[V[0]] && !H && (H = { events: G.boundClassNames[V[0]], button: V[1] });
            }), H;
          }
          update(P) {
            this.options = b(!0, this.options, P), this.removeEvents(), this.initEvents();
          }
          removeEvents() {
            this.eventsToUnbind.forEach((P) => P());
          }
          destroy() {
            this.removeEvents();
          }
        }
        return k.annotationsEditable = { nestedOptions: { labelOptions: ["style", "format", "backgroundColor"], labels: ["style"], label: ["style"], style: ["fontSize", "color"], background: ["fill", "strokeWidth", "stroke"], innerBackground: ["fill", "strokeWidth", "stroke"], outerBackground: ["fill", "strokeWidth", "stroke"], shapeOptions: ["fill", "strokeWidth", "stroke"], shapes: ["fill", "strokeWidth", "stroke"], line: ["strokeWidth", "stroke"], backgroundColors: [!0], connector: ["fill", "strokeWidth", "stroke"], crosshairX: ["strokeWidth", "stroke"], crosshairY: ["strokeWidth", "stroke"] }, circle: ["shapes"], ellipse: ["shapes"], verticalLine: [], label: ["labelOptions"], measure: ["background", "crosshairY", "crosshairX"], fibonacci: [], tunnel: ["background", "line", "height"], pitchfork: ["innerBackground", "outerBackground"], rect: ["shapes"], crookedLine: [], basicAnnotation: ["shapes", "labelOptions"] }, k.annotationsNonEditable = { rectangle: ["crosshairX", "crosshairY", "labelOptions"], ellipse: ["labelOptions"], circle: ["labelOptions"] }, k;
      }), Z(r, "masters/modules/annotations.src.js", [r["Core/Globals.js"], r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/NavigationBindings.js"]], function(T, B, I) {
        return T.Annotation = T.Annotation || B, T.NavigationBindings = T.NavigationBindings || I, T.Annotation.compose(T.Chart, T.NavigationBindings, T.Pointer, T.SVGRenderer), T;
      }), Z(r, "Extensions/Annotations/Types/BasicAnnotation.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends T {
          addControlPoints() {
            let L = this.options, M = z.basicControlPoints, w = this.basicType;
            (L.labels || L.shapes || []).forEach((A) => {
              A.controlPoints = M[w];
            });
          }
          init() {
            let L = this.options;
            if (L.shapes) {
              delete L.labelOptions;
              let M = L.shapes[0].type;
              L.shapes[0].className = (L.shapes[0].className || "") + " highcharts-basic-shape", M && M !== "path" ? this.basicType = M : this.basicType = "rectangle";
            } else delete L.shapes, this.basicType = "label";
            super.init.apply(this, arguments);
          }
        }
        return z.basicControlPoints = { label: [{ symbol: "triangle-down", positioner: function(O) {
          if (!O.graphic.placed) return { x: 0, y: -9e7 };
          let L = B.pointToPixels(O.points[0]);
          return { x: L.x - (this.graphic.width || 0) / 2, y: L.y - (this.graphic.height || 0) / 2 };
        }, events: { drag: function(O, L) {
          let M = this.mouseMoveToTranslation(O);
          L.translatePoint(M.x, M.y), L.annotation.userOptions.labels[0].point = L.options.point, L.redraw(!1);
        } } }, { symbol: "square", positioner: function(O) {
          return O.graphic.placed ? { x: O.graphic.alignAttr.x - (this.graphic.width || 0) / 2, y: O.graphic.alignAttr.y - (this.graphic.height || 0) / 2 } : { x: 0, y: -9e7 };
        }, events: { drag: function(O, L) {
          let M = this.mouseMoveToTranslation(O);
          L.translate(M.x, M.y), L.annotation.userOptions.labels[0].point = L.options.point, L.redraw(!1);
        } } }], rectangle: [{ positioner: function(O) {
          let L = B.pointToPixels(O.points[2]);
          return { x: L.x - 4, y: L.y - 4 };
        }, events: { drag: function(O, L) {
          var v, s, f;
          let M = L.annotation, w = (v = this.chart.pointer) == null ? void 0 : v.getCoordinates(O), A = L.options.points, l = M.userOptions.shapes, u = ((s = M.clipXAxis) == null ? void 0 : s.index) || 0, c = ((f = M.clipYAxis) == null ? void 0 : f.index) || 0;
          if (w) {
            let y = w.xAxis[u].value, h = w.yAxis[c].value;
            A[1].x = y, A[2].x = y, A[2].y = h, A[3].y = h, l && l[0] && (l[0].points = L.options.points);
          }
          M.redraw(!1);
        } } }], circle: [{ positioner: function(O) {
          let L = B.pointToPixels(O.points[0]), M = O.options.r;
          return { x: L.x + M * Math.cos(Math.PI / 4) - (this.graphic.width || 0) / 2, y: L.y + M * Math.sin(Math.PI / 4) - (this.graphic.height || 0) / 2 };
        }, events: { drag: function(O, L) {
          let M = L.annotation, w = this.mouseMoveToTranslation(O), A = M.userOptions.shapes;
          L.setRadius(Math.max(L.options.r + w.y / Math.sin(Math.PI / 4), 5)), A && A[0] && (A[0].r = L.options.r, A[0].point = L.options.point), L.redraw(!1);
        } } }], ellipse: [{ positioner: function(O) {
          let L = O.getAbsolutePosition(O.points[0]);
          return { x: L.x - (this.graphic.width || 0) / 2, y: L.y - (this.graphic.height || 0) / 2 };
        }, events: { drag: function(O, L) {
          let M = L.getAbsolutePosition(L.points[0]);
          L.translatePoint(O.chartX - M.x, O.chartY - M.y, 0), L.redraw(!1);
        } } }, { positioner: function(O) {
          let L = O.getAbsolutePosition(O.points[1]);
          return { x: L.x - (this.graphic.width || 0) / 2, y: L.y - (this.graphic.height || 0) / 2 };
        }, events: { drag: function(O, L) {
          let M = L.getAbsolutePosition(L.points[1]);
          L.translatePoint(O.chartX - M.x, O.chartY - M.y, 1), L.redraw(!1);
        } } }, { positioner: function(O) {
          let L = O.getAbsolutePosition(O.points[0]), M = O.getAbsolutePosition(O.points[1]), w = O.getAttrs(L, M);
          return { x: w.cx - (this.graphic.width || 0) / 2 + w.ry * Math.sin(w.angle * Math.PI / 180), y: w.cy - (this.graphic.height || 0) / 2 - w.ry * Math.cos(w.angle * Math.PI / 180) };
        }, events: { drag: function(O, L) {
          let M = L.getAbsolutePosition(L.points[0]), w = L.getAbsolutePosition(L.points[1]), A = L.getDistanceFromLine(M, w, O.chartX, O.chartY), l = L.getYAxis(), u = Math.abs(l.toValue(0) - l.toValue(A));
          L.setYRadius(u), L.redraw(!1);
        } } }] }, z.prototype.defaultOptions = R(T.prototype.defaultOptions, {}), T.types.basicAnnotation = z, z;
      }), Z(r, "Extensions/Annotations/Types/CrookedLine.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z } = R;
        class O extends T {
          setClipAxes() {
            this.clipXAxis = this.chart.xAxis[this.options.typeOptions.xAxis], this.clipYAxis = this.chart.yAxis[this.options.typeOptions.yAxis];
          }
          getPointsOptions() {
            let M = this.options.typeOptions;
            return (M.points || []).map((w) => (w.xAxis = M.xAxis, w.yAxis = M.yAxis, w));
          }
          getControlPointsOptions() {
            return this.getPointsOptions();
          }
          addControlPoints() {
            this.getControlPointsOptions().forEach(function(M, w) {
              let A = new B(this.chart, this, z(this.options.controlPointOptions, M.controlPoint), w);
              this.controlPoints.push(A), M.controlPoint = A.options;
            }, this);
          }
          addShapes() {
            let M = this.options.typeOptions, w = this.initShape(z(M.line, { type: "path", className: "highcharts-crooked-lines", points: this.points.map((A, l) => function(u) {
              return u.annotation.points[l];
            }) }), 0);
            M.line = w.options;
          }
        }
        return O.prototype.defaultOptions = z(T.prototype.defaultOptions, { typeOptions: { xAxis: 0, yAxis: 0, line: { fill: "none" } }, controlPointOptions: { positioner: function(L) {
          let M = this.graphic, w = I.pointToPixels(L.points[this.index]);
          return { x: w.x - (M.width || 0) / 2, y: w.y - (M.height || 0) / 2 };
        }, events: { drag: function(L, M) {
          if (M.chart.isInsidePlot(L.chartX - M.chart.plotLeft, L.chartY - M.chart.plotTop, { visiblePlotOnly: !0 })) {
            let w = this.mouseMoveToTranslation(L), A = M.options.typeOptions;
            M.translatePoint(w.x, w.y, this.index), A.points[this.index].x = M.points[this.index].x, A.points[this.index].y = M.points[this.index].y, M.redraw(!1);
          }
        } } } }), T.types.crookedLine = O, O;
      }), Z(r, "Extensions/Annotations/Types/ElliottWave.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/Types/CrookedLine.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R } = I;
        class z extends B {
          addLabels() {
            this.getPointsOptions().forEach((L, M) => {
              let w = this.options.typeOptions, A = this.initLabel(R(L.label, { text: w.labels[M], point: function(l) {
                return l.annotation.points[M];
              } }), !1);
              L.label = A.options;
            });
          }
        }
        return z.prototype.defaultOptions = R(B.prototype.defaultOptions, { typeOptions: { labels: ["(0)", "(A)", "(B)", "(C)", "(D)", "(E)"], line: { strokeWidth: 1 } }, labelOptions: { align: "center", allowOverlap: !0, crop: !0, overflow: "none", type: "rect", backgroundColor: "none", borderWidth: 0, y: -5 } }), T.types.elliottWave = z, z;
      }), Z(r, "Extensions/Annotations/Types/Tunnel.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/Types/CrookedLine.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { merge: O } = z;
        class L extends I {
          getPointsOptions() {
            let w = I.prototype.getPointsOptions.call(this), A = this.options.typeOptions.yAxis || 0, l = this.chart.yAxis[A];
            if (w[2] = this.heightPointOptions(w[1]), w[3] = this.heightPointOptions(w[0]), l && l.logarithmic) {
              let u = l.toPixels(w[2].y) - l.toPixels(w[1].y), c = l.toPixels(w[0].y) + u;
              w[3].y = l.toValue(c);
            }
            return w;
          }
          getControlPointsOptions() {
            return this.getPointsOptions().slice(0, 2);
          }
          heightPointOptions(w) {
            let A = O(w), l = this.options.typeOptions;
            return A.y += l.height, A;
          }
          addControlPoints() {
            I.prototype.addControlPoints.call(this);
            let w = this.options, A = w.typeOptions, l = new B(this.chart, this, O(w.controlPointOptions, A.heightControlPoint), 2);
            this.controlPoints.push(l), A.heightControlPoint = l.options;
          }
          addShapes() {
            this.addLine(), this.addBackground();
          }
          addLine() {
            let w = this.initShape(O(this.options.typeOptions.line, { type: "path", points: [this.points[0], this.points[1], function(A) {
              let l = R.pointToOptions(A.annotation.points[2]);
              return l.command = "M", l;
            }, this.points[3]], className: "highcharts-tunnel-lines" }), 0);
            this.options.typeOptions.line = w.options;
          }
          addBackground() {
            let w = this.initShape(O(this.options.typeOptions.background, { type: "path", points: this.points.slice(), className: "highcharts-tunnel-background" }), 1);
            this.options.typeOptions.background = w.options;
          }
          translateSide(w, A, l) {
            let u = Number(l);
            this.translatePoint(w, A, u), this.translatePoint(w, A, u === 0 ? 3 : 2);
          }
          translateHeight(w) {
            this.translatePoint(0, w, 2), this.translatePoint(0, w, 3), this.options.typeOptions.height = this.points[3].y - this.points[0].y, this.userOptions.typeOptions.height = this.options.typeOptions.height;
          }
        }
        return L.prototype.defaultOptions = O(I.prototype.defaultOptions, { typeOptions: { background: { fill: "rgba(130, 170, 255, 0.4)", strokeWidth: 0 }, line: { strokeWidth: 1 }, height: -2, heightControlPoint: { positioner: function(M) {
          let w = R.pointToPixels(M.points[2]), A = R.pointToPixels(M.points[3]), l = (w.x + A.x) / 2;
          return { x: l - (this.graphic.width || 0) / 2, y: (A.y - w.y) / (A.x - w.x) * (l - w.x) + w.y - (this.graphic.height || 0) / 2 };
        }, events: { drag: function(M, w) {
          w.chart.isInsidePlot(M.chartX - w.chart.plotLeft, M.chartY - w.chart.plotTop, { visiblePlotOnly: !0 }) && (w.translateHeight(this.mouseMoveToTranslation(M).y), w.redraw(!1));
        } } } }, controlPointOptions: { events: { drag: function(M, w) {
          if (w.chart.isInsidePlot(M.chartX - w.chart.plotLeft, M.chartY - w.chart.plotTop, { visiblePlotOnly: !0 })) {
            let A = this.mouseMoveToTranslation(M);
            w.translateSide(A.x, A.y, !!this.index), w.redraw(!1);
          }
        } } } }), T.types.tunnel = L, L;
      }), Z(r, "Extensions/Annotations/Types/InfinityLine.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/Types/CrookedLine.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z } = R;
        class O extends B {
          static edgePoint(M, w) {
            return function(A) {
              let l = A.annotation, u = l.options.typeOptions.type, c = l.points;
              return (u === "horizontalLine" || u === "verticalLine") && (c = [c[0], new I(l.chart, c[0].target, { x: c[0].x + +(u === "horizontalLine"), y: c[0].y + +(u === "verticalLine"), xAxis: c[0].options.xAxis, yAxis: c[0].options.yAxis })]), O.findEdgePoint(c[M], c[w]);
            };
          }
          static findEdgeCoordinate(M, w, A, l) {
            let u = A === "x" ? "y" : "x";
            return (w[A] - M[A]) * (l - M[u]) / (w[u] - M[u]) + M[A];
          }
          static findEdgePoint(M, w) {
            let A, l, u, c = M.series.chart, v = M.series.xAxis, s = w.series.yAxis, f = I.pointToPixels(M), y = I.pointToPixels(w), h = y.x - f.x, a = y.y - f.y, x = v.left, S = x + v.width, E = s.top, b = E + s.height, p = h < 0 ? x : S, C = a < 0 ? E : b, o = { x: h === 0 ? f.x : p, y: a === 0 ? f.y : C };
            return h !== 0 && a !== 0 && (l = O.findEdgeCoordinate(f, y, "y", p), A = O.findEdgeCoordinate(f, y, "x", C), l >= E && l <= b ? (o.x = p, o.y = l) : (o.x = A, o.y = C)), o.x -= c.plotLeft, o.y -= c.plotTop, M.series.chart.inverted && (u = o.x, o.x = o.y, o.y = u), o;
          }
          addShapes() {
            let M = this.options.typeOptions, w = [this.points[0], O.endEdgePoint];
            M.type.match(/line/gi) && (w[0] = O.startEdgePoint);
            let A = this.initShape(z(M.line, { type: "path", points: w, className: "highcharts-infinity-lines" }), 0);
            M.line = A.options;
          }
        }
        return O.endEdgePoint = O.edgePoint(0, 1), O.startEdgePoint = O.edgePoint(1, 0), O.prototype.defaultOptions = z(B.prototype.defaultOptions, {}), T.types.infinityLine = O, O;
      }), Z(r, "Extensions/Annotations/Types/TimeCycles.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/Types/CrookedLine.js"], r["Extensions/Annotations/ControlPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z, isNumber: O, defined: L } = R;
        class M extends B {
          init(A, l, u) {
            L(l.yAxis) && l.points.forEach((c) => {
              c.yAxis = l.yAxis;
            }), L(l.xAxis) && l.points.forEach((c) => {
              c.xAxis = l.xAxis;
            }), super.init(A, l, u);
          }
          setPath() {
            this.shapes[0].options.d = this.getPath();
          }
          getPath() {
            return [["M", this.startX, this.y]].concat(function(A, l, u, c) {
              let v = [];
              for (let s = 1; s <= l; s++) v.push(["A", A / 2, A / 2, 0, 1, 1, u + s * A, c]);
              return v;
            }(this.pixelInterval, this.numberOfCircles, this.startX, this.y));
          }
          addShapes() {
            let A = this.options.typeOptions;
            this.setPathProperties();
            let l = this.initShape(z(A.line, { type: "path", d: this.getPath(), points: this.options.points, className: "highcharts-timecycles-lines" }), 0);
            A.line = l.options;
          }
          addControlPoints() {
            let A = this.options, l = A.typeOptions;
            A.controlPointOptions.style.cursor = this.chart.inverted ? "ns-resize" : "ew-resize", l.controlPointOptions.forEach((u) => {
              let c = z(A.controlPointOptions, u), v = new I(this.chart, this, c, 0);
              this.controlPoints.push(v);
            });
          }
          setPathProperties() {
            let A = this.options.typeOptions, l = A.points;
            if (!l) return;
            let u = l[0], c = l[1], v = A.xAxis || 0, s = A.yAxis || 0, f = this.chart.xAxis[v], y = this.chart.yAxis[s], h = u.x, a = u.y, x = c.x;
            if (!h || !x) return;
            let S = O(a) ? y.toPixels(a) : y.top + y.height, E = O(h) ? f.toPixels(h) : f.left, b = O(x) ? f.toPixels(x) : f.left + 30, p = f.len, C = Math.round(Math.max(Math.abs(b - E), 2)), o = Math.floor(p / C) + 2, t = (Math.floor((E - f.left) / C) + 1) * C;
            this.startX = E - t, this.y = S, this.pixelInterval = C, this.numberOfCircles = o;
          }
          redraw(A) {
            this.setPathProperties(), this.setPath(), super.redraw(A);
          }
        }
        return M.prototype.defaultOptions = z(B.prototype.defaultOptions, { typeOptions: { controlPointOptions: [{ positioner: function(w) {
          let A = w.points[0];
          return { x: w.anchor(A).absolutePosition.x - (this.graphic.width || 0) / 2, y: w.y - (this.graphic.height || 0) };
        }, events: { drag: function(w, A) {
          let l = A.anchor(A.points[0]).absolutePosition;
          A.translatePoint(w.chartX - l.x, 0, 0), A.redraw(!1);
        } } }, { positioner: function(w) {
          let A = w.points[1];
          return { x: w.anchor(A).absolutePosition.x - (this.graphic.width || 0) / 2, y: w.y - (this.graphic.height || 0) };
        }, events: { drag: function(w, A) {
          let l = A.anchor(A.points[1]).absolutePosition;
          A.translatePoint(w.chartX - l.x, 0, 1), A.redraw(!1);
        } } }] } }), T.types.timeCycles = M, M;
      }), Z(r, "Extensions/Annotations/Types/Fibonacci.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/MockPoint.js"], r["Extensions/Annotations/Types/Tunnel.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z } = R;
        function O(M, w) {
          return function() {
            let A = this.annotation;
            if (!A.startRetracements || !A.endRetracements) return [];
            let l = this.anchor(A.startRetracements[M]).absolutePosition, u = this.anchor(A.endRetracements[M]).absolutePosition, c = [["M", Math.round(l.x), Math.round(l.y)], ["L", Math.round(u.x), Math.round(u.y)]];
            if (w) {
              let v = this.anchor(A.endRetracements[M - 1]).absolutePosition, s = this.anchor(A.startRetracements[M - 1]).absolutePosition;
              c.push(["L", Math.round(v.x), Math.round(v.y)], ["L", Math.round(s.x), Math.round(s.y)]);
            }
            return c;
          };
        }
        class L extends I {
          linkPoints() {
            super.linkPoints(), this.linkRetracementsPoints();
          }
          linkRetracementsPoints() {
            let w = this.points, A = w[0].y - w[3].y, l = w[1].y - w[2].y, u = w[0].x, c = w[1].x;
            L.levels.forEach((v, s) => {
              let f = w[0].y - A * v, y = w[1].y - l * v, h = this.options.typeOptions.reversed ? L.levels.length - s - 1 : s;
              this.startRetracements = this.startRetracements || [], this.endRetracements = this.endRetracements || [], this.linkRetracementPoint(h, u, f, this.startRetracements), this.linkRetracementPoint(h, c, y, this.endRetracements);
            });
          }
          linkRetracementPoint(w, A, l, u) {
            let c = u[w], v = this.options.typeOptions;
            c ? (c.options.x = A, c.options.y = l, c.refresh()) : u[w] = new B(this.chart, this, { x: A, y: l, xAxis: v.xAxis, yAxis: v.yAxis });
          }
          addShapes() {
            L.levels.forEach(function(w, A) {
              let { backgroundColors: l, lineColor: u, lineColors: c } = this.options.typeOptions;
              this.initShape({ type: "path", d: O(A), stroke: c[A] || u, className: "highcharts-fibonacci-line" }, A), A > 0 && this.initShape({ type: "path", fill: l[A - 1], strokeWidth: 0, d: O(A, !0), className: "highcharts-fibonacci-background-" + (A - 1) });
            }, this);
          }
          addLabels() {
            L.levels.forEach(function(w, A) {
              let l = this.options.typeOptions, u = this.initLabel(z(l.labels[A], { point: function(c) {
                return B.pointToOptions(c.annotation.startRetracements[A]);
              }, text: w.toString() }));
              l.labels[A] = u.options;
            }, this);
          }
        }
        return L.levels = [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1], L.prototype.defaultOptions = z(I.prototype.defaultOptions, { typeOptions: { reversed: !1, height: 2, backgroundColors: ["rgba(130, 170, 255, 0.4)", "rgba(139, 191, 216, 0.4)", "rgba(150, 216, 192, 0.4)", "rgba(156, 229, 161, 0.4)", "rgba(162, 241, 130, 0.4)", "rgba(169, 255, 101, 0.4)"], lineColor: "#999999", lineColors: [], labels: [] }, labelOptions: { allowOverlap: !0, align: "right", backgroundColor: "none", borderWidth: 0, crop: !1, overflow: "none", shape: "rect", style: { color: "grey" }, verticalAlign: "middle", y: 0 } }), T.types.fibonacci = L, L;
      }), Z(r, "Extensions/Annotations/Types/FibonacciTimeZones.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/ControlPoint.js"], r["Extensions/Annotations/Types/CrookedLine.js"], r["Extensions/Annotations/Types/InfinityLine.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { merge: L } = O;
        function M(A, l, u) {
          return function(c) {
            let v = c.annotation.chart, s = v.inverted ? v.plotTop : v.plotLeft, f = c.annotation.points, y = f[0].series.xAxis, h = f.length > 1 ? f[1].plotX - f[0].plotX : 0, a = y.toValue(f[0].plotX + s + u * h);
            return f = [new z(v, f[0].target, { x: a, y: 0, xAxis: f[0].options.xAxis, yAxis: f[0].options.yAxis }), new z(v, f[0].target, { x: a, y: 1, xAxis: f[0].options.xAxis, yAxis: f[0].options.yAxis })], R.findEdgePoint(f[A], f[l]);
          };
        }
        class w extends I {
          addShapes() {
            let l = 1, u = 1;
            for (let c = 0; c < 11; c++) {
              let v = c ? l : 0, s = [M(1, 0, v), M(0, 1, v)];
              l = (u = l + u) - l, c === 1 && (this.secondLineEdgePoints = [s[0], s[1]]), this.initShape(L(this.options.typeOptions.line, { type: "path", points: s, className: "highcharts-fibonacci-timezones-lines" }), c);
            }
          }
          addControlPoints() {
            let l = this.options, u = l.typeOptions, c = new B(this.chart, this, L(l.controlPointOptions, u.controlPointOptions), 0);
            this.controlPoints.push(c), u.controlPointOptions = c.options;
          }
        }
        return w.prototype.defaultOptions = L(I.prototype.defaultOptions, { typeOptions: { line: { stroke: "rgba(0, 0, 0, 0.75)", strokeWidth: 1, fill: void 0 }, controlPointOptions: { positioner: function() {
          let A = this.target, l = this.graphic, u = A.secondLineEdgePoints, c = { annotation: A }, v = u[0](c).y, s = u[1](c).y, f = this.chart.plotLeft, y = this.chart.plotTop, h = u[0](c).x, a = (v + s) / 2;
          return this.chart.inverted && ([h, a] = [a, h]), { x: f + h - (l.width || 0) / 2, y: y + a - (l.height || 0) / 2 };
        }, events: { drag: function(A, l) {
          if (l.chart.isInsidePlot(A.chartX - l.chart.plotLeft, A.chartY - l.chart.plotTop, { visiblePlotOnly: !0 })) {
            let u = this.mouseMoveToTranslation(A);
            l.translatePoint(u.x, 0, 1), l.redraw(!1);
          }
        } } } } }), T.types.fibonacciTimeZones = w, w;
      }), Z(r, "Extensions/Annotations/Types/Pitchfork.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/Types/InfinityLine.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { merge: z } = R;
        class O extends B {
          static outerLineEdgePoint(M) {
            return function(w) {
              let A = w.annotation, l = A.points;
              return O.findEdgePoint(l[M], l[0], new I(A.chart, w, A.midPointOptions()));
            };
          }
          static findEdgePoint(M, w, A) {
            let l = Math.atan2(A.plotY - w.plotY, A.plotX - w.plotX);
            return { x: M.plotX + 1e7 * Math.cos(l), y: M.plotY + 1e7 * Math.sin(l) };
          }
          static middleLineEdgePoint(M) {
            let w = M.annotation, A = w.points;
            return B.findEdgePoint(A[0], new I(w.chart, M, w.midPointOptions()));
          }
          midPointOptions() {
            let M = this.points;
            return { x: (M[1].x + M[2].x) / 2, y: (M[1].y + M[2].y) / 2, xAxis: M[0].series.xAxis, yAxis: M[0].series.yAxis };
          }
          addShapes() {
            this.addLines(), this.addBackgrounds();
          }
          addLines() {
            let M = "highcharts-pitchfork-lines";
            this.initShape({ type: "path", points: [this.points[0], O.middleLineEdgePoint], className: M }, 0), this.initShape({ type: "path", points: [this.points[1], O.topLineEdgePoint], className: M }, 1), this.initShape({ type: "path", points: [this.points[2], O.bottomLineEdgePoint], className: M }, 2);
          }
          addBackgrounds() {
            let M = this.shapes, w = this.options.typeOptions, A = this.initShape(z(w.innerBackground, { type: "path", points: [function(u) {
              let c = u.annotation, v = c.points, s = c.midPointOptions();
              return { x: (v[1].x + s.x) / 2, y: (v[1].y + s.y) / 2, xAxis: s.xAxis, yAxis: s.yAxis };
            }, M[1].points[1], M[2].points[1], function(u) {
              let c = u.annotation, v = c.points, s = c.midPointOptions();
              return { x: (s.x + v[2].x) / 2, y: (s.y + v[2].y) / 2, xAxis: s.xAxis, yAxis: s.yAxis };
            }], className: "highcharts-pitchfork-inner-background" }), 3), l = this.initShape(z(w.outerBackground, { type: "path", points: [this.points[1], M[1].points[1], M[2].points[1], this.points[2]], className: "highcharts-pitchfork-outer-background" }), 4);
            w.innerBackground = A.options, w.outerBackground = l.options;
          }
        }
        return O.topLineEdgePoint = O.outerLineEdgePoint(1), O.bottomLineEdgePoint = O.outerLineEdgePoint(0), O.prototype.defaultOptions = z(B.prototype.defaultOptions, { typeOptions: { innerBackground: { fill: "rgba(130, 170, 255, 0.4)", strokeWidth: 0 }, outerBackground: { fill: "rgba(156, 229, 161, 0.4)", strokeWidth: 0 } } }), T.types.pitchfork = O, O;
      }), Z(r, "Extensions/Annotations/Types/VerticalLine.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/MockPoint.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { merge: R, pick: z } = I;
        class O extends T {
          static connectorFirstPoint(M) {
            let w = M.annotation, A = w.chart, l = A.inverted, u = w.points[0], c = z(u.series.yAxis && u.series.yAxis.left, 0), v = z(u.series.yAxis && u.series.yAxis.top, 0), s = w.options.typeOptions.label.offset, f = B.pointToPixels(u, !0)[l ? "x" : "y"];
            return { x: u.x, xAxis: u.series.xAxis, y: f + s + (l ? c - A.plotLeft : v - A.plotTop) };
          }
          static connectorSecondPoint(M) {
            let w = M.annotation, A = w.chart, l = A.inverted, u = w.options.typeOptions, c = w.points[0], v = z(c.series.yAxis && c.series.yAxis.left, 0), s = z(c.series.yAxis && c.series.yAxis.top, 0), f = B.pointToPixels(c, !0)[l ? "x" : "y"], y = u.yOffset;
            return u.label.offset < 0 && (y *= -1), { x: c.x, xAxis: c.series.xAxis, y: f + y + (l ? v - A.plotLeft : s - A.plotTop) };
          }
          getPointsOptions() {
            return [this.options.typeOptions.point];
          }
          addShapes() {
            let M = this.options.typeOptions, w = this.initShape(R(M.connector, { type: "path", points: [O.connectorFirstPoint, O.connectorSecondPoint], className: "highcharts-vertical-line" }), 0);
            M.connector = w.options, this.userOptions.typeOptions.point = M.point;
          }
          addLabels() {
            let M = this.options.typeOptions, w = M.label, A = 0, l = w.offset, u = w.offset < 0 ? "bottom" : "top", c = "center";
            this.chart.inverted && (A = w.offset, l = 0, u = "middle", c = w.offset < 0 ? "right" : "left");
            let v = this.initLabel(R(w, { verticalAlign: u, align: c, x: A, y: l }));
            M.label = v.options;
          }
        }
        return O.prototype.defaultOptions = R(T.prototype.defaultOptions, { typeOptions: { yOffset: 10, label: { offset: -40, point: function(L) {
          return L.annotation.points[0];
        }, allowOverlap: !0, backgroundColor: "none", borderWidth: 0, crop: !0, overflow: "none", shape: "rect", text: "{y:.2f}" }, connector: { strokeWidth: 1, markerEnd: "arrow" } } }), T.types.verticalLine = O, O;
      }), Z(r, "Extensions/Annotations/Types/Measure.js", [r["Extensions/Annotations/Annotation.js"], r["Extensions/Annotations/ControlPoint.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { defined: R, extend: z, isNumber: O, merge: L, pick: M } = I;
        function w() {
          let x = "";
          return this.max !== "" && this.min !== "" && (x = (this.max + this.min) / 2), x;
        }
        function A() {
          let x = this.chart.series, S = u(this.xAxisMin, this.xAxisMax, this.yAxisMin, this.yAxisMax), E = 0, b = !1;
          return x.forEach((p) => {
            p.visible && p.options.id !== "highcharts-navigator-series" && p.points.forEach((C) => {
              !C.isNull && C.x > S.xAxisMin && C.x <= S.xAxisMax && C.y > S.yAxisMin && C.y <= S.yAxisMax && (E++, b = !0);
            });
          }), b || (E = ""), E;
        }
        function l() {
          return "Min: " + this.min + "<br>Max: " + this.max + "<br>Average: " + this.average + "<br>Bins: " + this.bins;
        }
        function u(x, S, E, b) {
          return { xAxisMin: Math.min(S, x), xAxisMax: Math.max(S, x), yAxisMin: Math.min(b, E), yAxisMax: Math.max(b, E) };
        }
        function c(x, S, E) {
          return x.toValue(x.toPixels(S) + E);
        }
        function v() {
          let x = this.options.typeOptions, S = this.chart, E = S.inverted, b = S.xAxis[x.xAxis], p = S.yAxis[x.yAxis], C = x.background, o = E ? C.height : C.width, t = E ? C.width : C.height, e = x.selectType, n = E ? b.left : p.top, d = E ? p.top : b.left;
          this.startXMin = x.point.x, this.startYMin = x.point.y, O(o) ? this.startXMax = this.startXMin + o : this.startXMax = c(b, this.startXMin, parseFloat(o)), O(t) ? this.startYMax = this.startYMin - t : this.startYMax = c(p, this.startYMin, parseFloat(t)), e === "x" ? (this.startYMin = p.toValue(n), this.startYMax = p.toValue(n + p.len)) : e === "y" && (this.startXMin = b.toValue(d), this.startXMax = b.toValue(d + b.len));
        }
        function s() {
          let x = this.chart.series, S = u(this.xAxisMin, this.xAxisMax, this.yAxisMin, this.yAxisMax), E = -1 / 0, b = !1;
          return x.forEach((p) => {
            p.visible && p.options.id !== "highcharts-navigator-series" && p.points.forEach((C) => {
              !C.isNull && C.y > E && C.x > S.xAxisMin && C.x <= S.xAxisMax && C.y > S.yAxisMin && C.y <= S.yAxisMax && (E = C.y, b = !0);
            });
          }), b || (E = ""), E;
        }
        function f() {
          let x = this.chart.series, S = u(this.xAxisMin, this.xAxisMax, this.yAxisMin, this.yAxisMax), E = 1 / 0, b = !1;
          return x.forEach((p) => {
            p.visible && p.options.id !== "highcharts-navigator-series" && p.points.forEach((C) => {
              !C.isNull && C.y < E && C.x > S.xAxisMin && C.x <= S.xAxisMax && C.y > S.yAxisMin && C.y <= S.yAxisMax && (E = C.y, b = !0);
            });
          }), b || (E = ""), E;
        }
        function y(x) {
          let S = this.options.typeOptions, E = this.chart.xAxis[S.xAxis], b = this.chart.yAxis[S.yAxis], p = this.offsetX, C = this.offsetY;
          this.xAxisMin = c(E, this.startXMin, p), this.xAxisMax = c(E, this.startXMax, p), this.yAxisMin = c(b, this.startYMin, C), this.yAxisMax = c(b, this.startYMax, C), this.min = f.call(this), this.max = s.call(this), this.average = w.call(this), this.bins = A.call(this), x && this.resize(0, 0);
        }
        function h(x, S, E, b, p) {
          let C = this.options.typeOptions, o = C.selectType, t = this.chart.xAxis[C.xAxis], e = this.chart.yAxis[C.yAxis], n = this.startXMin, d = this.startXMax, i = this.startYMin, g = this.startYMax, m = this.offsetX, k = this.offsetY;
          S && (o === "x" ? E === 0 ? this.startXMin = c(t, n, b) : this.startXMax = c(t, d, b) : o === "y" ? E === 0 ? this.startYMin = c(e, i, p) : this.startYMax = c(e, g, p) : (this.startXMax = c(t, d, b), this.startYMax = c(e, g, p))), x && (this.startXMin = c(t, n, m), this.startXMax = c(t, d, m), this.startYMin = c(e, i, k), this.startYMax = c(e, g, k), this.offsetX = 0, this.offsetY = 0), this.options.typeOptions.point = { x: this.startXMin, y: this.startYMin }, this.userOptions.typeOptions.point = { x: this.startXMin, y: this.startYMin };
        }
        class a extends T {
          init(S, E, b) {
            super.init(S, E, b), this.offsetX = 0, this.offsetY = 0, this.resizeX = 0, this.resizeY = 0, v.call(this), this.addValues(), this.addShapes();
          }
          setClipAxes() {
            this.clipXAxis = this.chart.xAxis[this.options.typeOptions.xAxis], this.clipYAxis = this.chart.yAxis[this.options.typeOptions.yAxis];
          }
          pointsOptions() {
            return this.options.points;
          }
          shapePointsOptions() {
            let S = this.options.typeOptions, E = S.xAxis, b = S.yAxis;
            return [{ x: this.xAxisMin, y: this.yAxisMin, xAxis: E, yAxis: b }, { x: this.xAxisMax, y: this.yAxisMin, xAxis: E, yAxis: b }, { x: this.xAxisMax, y: this.yAxisMax, xAxis: E, yAxis: b }, { x: this.xAxisMin, y: this.yAxisMax, xAxis: E, yAxis: b }];
          }
          addControlPoints() {
            let S = this.chart.inverted, E = this.options.controlPointOptions, b = this.options.typeOptions.selectType;
            R(this.userOptions.controlPointOptions && this.userOptions.controlPointOptions.style.cursor) || (b === "x" ? E.style.cursor = S ? "ns-resize" : "ew-resize" : b !== "y" || (E.style.cursor = S ? "ew-resize" : "ns-resize"));
            let p = new B(this.chart, this, this.options.controlPointOptions, 0);
            this.controlPoints.push(p), b !== "xy" && (p = new B(this.chart, this, this.options.controlPointOptions, 1), this.controlPoints.push(p));
          }
          addValues(S) {
            let E = this.options.typeOptions, b = E.label.formatter;
            y.call(this, S), E.label.enabled && (this.labels.length > 0 ? this.labels[0].text = b && b.call(this) || l.call(this) : this.initLabel(z({ shape: "rect", backgroundColor: "none", color: "black", borderWidth: 0, dashStyle: "Dash", overflow: "allow", align: "left", y: 0, x: 0, verticalAlign: "top", crop: !0, xAxis: 0, yAxis: 0, point: function(p) {
              let C = p.annotation, o = p.options;
              return { x: C.xAxisMin, y: C.yAxisMin, xAxis: M(E.xAxis, o.xAxis), yAxis: M(E.yAxis, o.yAxis) };
            }, text: b && b.call(this) || l.call(this) }, E.label), void 0));
          }
          addShapes() {
            this.addCrosshairs(), this.addBackground();
          }
          addBackground() {
            this.shapePointsOptions()[0].x !== void 0 && this.initShape(z({ type: "path", points: this.shapePointsOptions(), className: "highcharts-measure-background" }, this.options.typeOptions.background), 2);
          }
          addCrosshairs() {
            let S = this.chart, E = this.options.typeOptions, b = this.options.typeOptions.point, p = S.xAxis[E.xAxis], C = S.yAxis[E.yAxis], o = S.inverted, t = { point: b, type: "path" }, e = p.toPixels(this.xAxisMin), n = p.toPixels(this.xAxisMax), d = C.toPixels(this.yAxisMin), i = C.toPixels(this.yAxisMax), g = [], m = [], k, j, P;
            o && (P = e, e = d, d = P, P = n, n = i, i = P), E.crosshairX.enabled && (g = [["M", e, d + (i - d) / 2], ["L", n, d + (i - d) / 2]]), E.crosshairY.enabled && (m = [["M", e + (n - e) / 2, d], ["L", e + (n - e) / 2, i]]), this.shapes.length > 0 ? (this.shapes[0].options.d = g, this.shapes[1].options.d = m) : (k = L(t, { className: "highcharts-measure-crosshair-x" }, E.crosshairX), j = L(t, { className: "highcharts-measure-crosshair-y" }, E.crosshairY), this.initShape(z({ d: g }, k), 0), this.initShape(z({ d: m }, j), 1));
          }
          onDrag(S) {
            let E = this.mouseMoveToTranslation(S), b = this.options.typeOptions.selectType, p = b === "y" ? 0 : E.x, C = b === "x" ? 0 : E.y;
            this.translate(p, C), this.offsetX += p, this.offsetY += C, this.redraw(!1, !1, !0);
          }
          resize(S, E, b, p) {
            let C = this.shapes[2];
            p === "x" ? b === 0 ? (C.translatePoint(S, 0, 0), C.translatePoint(S, E, 3)) : (C.translatePoint(S, 0, 1), C.translatePoint(S, E, 2)) : p === "y" ? b === 0 ? (C.translatePoint(0, E, 0), C.translatePoint(0, E, 1)) : (C.translatePoint(0, E, 2), C.translatePoint(0, E, 3)) : (C.translatePoint(S, 0, 1), C.translatePoint(S, E, 2), C.translatePoint(0, E, 3)), h.call(this, !1, !0, b, S, E), this.options.typeOptions.background.height = Math.abs(this.startYMax - this.startYMin), this.options.typeOptions.background.width = Math.abs(this.startXMax - this.startXMin);
          }
          redraw(S, E, b) {
            this.linkPoints(), this.graphic || this.render(), b && h.call(this, !0, !1), this.clipRect && this.clipRect.animate(this.getClipBox()), this.addValues(E), this.addCrosshairs(), this.redrawItems(this.shapes, S), this.redrawItems(this.labels, S), this.controlPoints.forEach((p) => p.redraw());
          }
          translate(S, E) {
            this.shapes.forEach((b) => b.translate(S, E));
          }
        }
        return a.prototype.defaultOptions = L(T.prototype.defaultOptions, { typeOptions: { selectType: "xy", xAxis: 0, yAxis: 0, background: { fill: "rgba(130, 170, 255, 0.4)", strokeWidth: 0, stroke: void 0 }, crosshairX: { enabled: !0, zIndex: 6, dashStyle: "Dash", markerEnd: "arrow" }, crosshairY: { enabled: !0, zIndex: 6, dashStyle: "Dash", markerEnd: "arrow" }, label: { enabled: !0, style: { fontSize: "0.7em", color: "#666666" }, formatter: void 0 } }, controlPointOptions: { positioner: function(x) {
          let S = this.index, E = x.chart, b = x.options, p = b.typeOptions, C = p.selectType, o = b.controlPointOptions, t = E.inverted, e = E.xAxis[p.xAxis], n = E.yAxis[p.yAxis], d = u(x.xAxisMin, x.xAxisMax, x.yAxisMin, x.yAxisMax), i = x.xAxisMax, g = x.yAxisMax, m, k;
          return C === "x" && (g = (d.yAxisMax + d.yAxisMin) / 2, S === 0 && (i = x.xAxisMin)), C === "y" && (i = d.xAxisMin + (d.xAxisMax - d.xAxisMin) / 2, S === 0 && (g = x.yAxisMin)), t ? (m = n.toPixels(g), k = e.toPixels(i)) : (m = e.toPixels(i), k = n.toPixels(g)), { x: m - o.width / 2, y: k - o.height / 2 };
        }, events: { drag: function(x, S) {
          let E = this.mouseMoveToTranslation(x), b = S.options.typeOptions.selectType, p = this.index, C = b === "y" ? 0 : E.x, o = b === "x" ? 0 : E.y;
          S.resize(C, o, p, b), S.resizeX += C, S.resizeY += o, S.redraw(!1, !0);
        } } } }), T.types.measure = a, a;
      }), Z(r, "masters/modules/annotations-advanced.src.js", [r["Core/Globals.js"]], function(T) {
        return T;
      });
    });
  }(ke)), ke.exports;
}
var Ml = Al();
const wl = /* @__PURE__ */ It(Ml);
var Pe = { exports: {} }, Xs;
function Sl() {
  return Xs || (Xs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Solid angular gauge module
    *
    * (c) 2010-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Core/Axis/Color/ColorAxisLike.js", [r["Core/Color/Color.js"], r["Core/Utilities.js"]], function(T, B) {
        var I, R;
        let { parse: z } = T, { merge: O } = B;
        return (R = I || (I = {})).initDataClasses = function(L) {
          let M = this.chart, w = this.legendItem = this.legendItem || {}, A = this.options, l = L.dataClasses || [], u, c, v = M.options.chart.colorCount, s = 0, f;
          this.dataClasses = c = [], w.labels = [];
          for (let y = 0, h = l.length; y < h; ++y) u = O(u = l[y]), c.push(u), (M.styledMode || !u.color) && (A.dataClassColor === "category" ? (M.styledMode || (v = (f = M.options.colors || []).length, u.color = f[s]), u.colorIndex = s, ++s === v && (s = 0)) : u.color = z(A.minColor).tweenTo(z(A.maxColor), h < 2 ? 0.5 : y / (h - 1)));
        }, R.initStops = function() {
          let L = this.options, M = this.stops = L.stops || [[0, L.minColor || ""], [1, L.maxColor || ""]];
          for (let w = 0, A = M.length; w < A; ++w) M[w].color = z(M[w][1]);
        }, R.normalizedValue = function(L) {
          let M = this.max || 0, w = this.min || 0;
          return this.logarithmic && (L = this.logarithmic.log2lin(L)), 1 - (M - L) / (M - w || 1);
        }, R.toColor = function(L, M) {
          let w, A, l, u, c, v, s = this.dataClasses, f = this.stops;
          if (s) {
            for (v = s.length; v--; ) if (A = (c = s[v]).from, l = c.to, (A === void 0 || L >= A) && (l === void 0 || L <= l)) {
              u = c.color, M && (M.dataClass = v, M.colorIndex = c.colorIndex);
              break;
            }
          } else {
            for (w = this.normalizedValue(L), v = f.length; v-- && !(w > f[v][0]); ) ;
            A = f[v] || f[v + 1], w = 1 - ((l = f[v + 1] || A)[0] - w) / (l[0] - A[0] || 1), u = A.color.tweenTo(l.color, w);
          }
          return u;
        }, I;
      }), Z(r, "Core/Axis/SolidGaugeAxis.js", [r["Core/Axis/Color/ColorAxisLike.js"], r["Core/Utilities.js"]], function(T, B) {
        let { extend: I } = B;
        return { init: function(R) {
          I(R, T);
        } };
      }), Z(r, "Series/SolidGauge/SolidGaugeSeriesDefaults.js", [], function() {
        return { colorByPoint: !0, dataLabels: { y: 0 } };
      }), Z(r, "Series/SolidGauge/SolidGaugeSeries.js", [r["Extensions/BorderRadius.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Axis/SolidGaugeAxis.js"], r["Series/SolidGauge/SolidGaugeSeriesDefaults.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { gauge: O, pie: L } = B.seriesTypes, { clamp: M, extend: w, isNumber: A, merge: l, pick: u, pInt: c } = z;
        class v extends O {
          translate() {
            let f = this.yAxis;
            I.init(f), !f.dataClasses && f.options.dataClasses && f.initDataClasses(f.options), f.initStops(), O.prototype.translate.call(this);
          }
          drawPoints() {
            let f, y = this.yAxis, h = y.center, a = this.options, x = this.chart.renderer, S = a.overshoot, E = a.rounded && a.borderRadius === void 0, b = A(S) ? S / 180 * Math.PI : 0;
            for (let p of (A(a.threshold) && (f = y.startAngleRad + y.translate(a.threshold, void 0, void 0, void 0, !0)), this.thresholdAngleRad = u(f, y.startAngleRad), this.points)) if (!p.isNull) {
              let C = c(u(p.options.radius, a.radius, 100)) * h[2] / 200, o = c(u(p.options.innerRadius, a.innerRadius, 60)) * h[2] / 200, t = Math.min(y.startAngleRad, y.endAngleRad), e = Math.max(y.startAngleRad, y.endAngleRad), n = p.graphic, d = y.startAngleRad + y.translate(p.y, void 0, void 0, void 0, !0), i, g, m = y.toColor(p.y, p);
              m === "none" && (m = p.color || this.color || "none"), m !== "none" && (p.color = m), d = M(d, t - b, e + b), a.wrap === !1 && (d = M(d, t, e));
              let k = E ? (C - o) / 2 / C : 0, j = Math.min(d, this.thresholdAngleRad) - k, P = Math.max(d, this.thresholdAngleRad) + k;
              P - j > 2 * Math.PI && (P = j + 2 * Math.PI);
              let D = E ? "50%" : 0;
              a.borderRadius && (D = T.optionsToObject(a.borderRadius).radius), p.shapeArgs = i = { x: h[0], y: h[1], r: C, innerR: o, start: j, end: P, borderRadius: D }, p.startR = C, n ? (g = i.d, n.animate(w({ fill: m }, i)), g && (i.d = g)) : p.graphic = n = x.arc(i).attr({ fill: m, "sweep-flag": 0 }).add(this.group), this.chart.styledMode || (a.linecap !== "square" && n.attr({ "stroke-linecap": "round", "stroke-linejoin": "round" }), n.attr({ stroke: a.borderColor || "none", "stroke-width": a.borderWidth || 0 })), n && n.addClass(p.getClassName(), !0);
            }
          }
          animate(f) {
            f || (this.startAngleRad = this.thresholdAngleRad, L.prototype.animate.call(this, f));
          }
        }
        return v.defaultOptions = l(O.defaultOptions, R), B.registerSeriesType("solidgauge", v), v;
      }), Z(r, "masters/modules/solid-gauge.src.js", [r["Core/Globals.js"]], function(T) {
        return T;
      });
    });
  }(Pe)), Pe.exports;
}
var kl = Sl();
const Pl = /* @__PURE__ */ It(kl);
var Te = { exports: {} }, Hs;
function Tl() {
  return Hs || (Hs = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Exporting module
    *
    * (c) 2010-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Extensions/DownloadURL.js", [r["Core/Globals.js"]], function(T) {
        let { isSafari: B, win: I, win: { document: R } } = T, z = I.URL || I.webkitURL || I;
        function O(L) {
          let M = L.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
          if (M && M.length > 3 && I.atob && I.ArrayBuffer && I.Uint8Array && I.Blob && z.createObjectURL) {
            let w = I.atob(M[3]), A = new I.ArrayBuffer(w.length), l = new I.Uint8Array(A);
            for (let u = 0; u < l.length; ++u) l[u] = w.charCodeAt(u);
            return z.createObjectURL(new I.Blob([l], { type: M[1] }));
          }
        }
        return { dataURLtoBlob: O, downloadURL: function(L, M) {
          let w = I.navigator, A = R.createElement("a");
          if (typeof L != "string" && !(L instanceof String) && w.msSaveOrOpenBlob) {
            w.msSaveOrOpenBlob(L, M);
            return;
          }
          if (L = "" + L, w.userAgent.length > 1e3) throw Error("Input too long");
          let l = /Edge\/\d+/.test(w.userAgent);
          if ((B && typeof L == "string" && L.indexOf("data:application/pdf") === 0 || l || L.length > 2e6) && !(L = O(L) || "")) throw Error("Failed to convert to blob");
          if (A.download !== void 0) A.href = L, A.download = M, R.body.appendChild(A), A.click(), R.body.removeChild(A);
          else try {
            if (!I.open(L, "chart")) throw Error("Failed to open window");
          } catch {
            I.location.href = L;
          }
        } };
      }), Z(r, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
        return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
      }), Z(r, "Extensions/ExportData/ExportData.js", [r["Core/Renderer/HTML/AST.js"], r["Core/Defaults.js"], r["Extensions/DownloadURL.js"], r["Extensions/ExportData/ExportDataDefaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { getOptions: L, setOptions: M } = B, { downloadURL: w } = I, { doc: A, win: l } = z, { addEvent: u, defined: c, extend: v, find: s, fireEvent: f, isNumber: y, pick: h } = O;
        function a(m) {
          var P;
          let k = !!((P = this.options.exporting) != null && P.showExportInProgress), j = l.requestAnimationFrame || setTimeout;
          j(() => {
            k && this.showLoading(this.options.lang.exportInProgress), j(() => {
              try {
                m.call(this);
              } finally {
                k && this.hideLoading();
              }
            });
          });
        }
        function x() {
          a.call(this, () => {
            let m = this.getCSV(!0);
            w(n(m, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(m), this.getFilename() + ".csv");
          });
        }
        function S() {
          a.call(this, () => {
            let m = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
            w(n(m, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + l.btoa(unescape(encodeURIComponent(m))), this.getFilename() + ".xls");
          });
        }
        function E(m) {
          let k = "", j = this.getDataRows(), P = this.options.exporting.csv, D = h(P.decimalPoint, P.itemDelimiter !== "," && m ? 1.1.toLocaleString()[1] : "."), H = h(P.itemDelimiter, D === "," ? ";" : ","), G = P.lineDelimiter;
          return j.forEach((V, F) => {
            let U = "", Y = V.length;
            for (; Y--; ) typeof (U = V[Y]) == "string" && (U = `"${U}"`), typeof U == "number" && D !== "." && (U = U.toString().replace(".", D)), V[Y] = U;
            V.length = j.length ? j[0].length : 0, k += V.join(H), F < j.length - 1 && (k += G);
          }), k;
        }
        function b(m) {
          let k, j, P = this.hasParallelCoordinates, D = this.time, H = this.options.exporting && this.options.exporting.csv || {}, G = this.xAxis, V = {}, F = [], U = [], Y = [], q = this.options.lang.exportData, N = q.categoryHeader, X = q.categoryDatetimeHeader, W = function(Q, ot, nt) {
            if (H.columnHeaderFormatter) {
              let ht = H.columnHeaderFormatter(Q, ot, nt);
              if (ht !== !1) return ht;
            }
            return Q ? Q.bindAxes ? m ? { columnTitle: nt > 1 ? ot : Q.name, topLevelColumnTitle: Q.name } : Q.name + (nt > 1 ? " (" + ot + ")" : "") : Q.options.title && Q.options.title.text || (Q.dateTime ? X : N) : N;
          }, _ = function(Q, ot, nt) {
            let ht = {}, ct = {};
            return ot.forEach(function(dt) {
              let ut = (Q.keyToAxis && Q.keyToAxis[dt] || dt) + "Axis", pt = y(nt) ? Q.chart[ut][nt] : Q[ut];
              ht[dt] = pt && pt.categories || [], ct[dt] = pt && pt.dateTime;
            }), { categoryMap: ht, dateTimeValueAxisMap: ct };
          }, K = function(Q, ot) {
            let nt = Q.pointArrayMap || ["y"];
            return Q.data.some((ht) => ht.y !== void 0 && ht.name) && ot && !ot.categories && Q.exportKey !== "name" ? ["x", ...nt] : nt;
          }, J = [], $, et, st, at = 0, lt, it;
          for (lt in this.series.forEach(function(Q) {
            let ot = Q.options.keys, nt = Q.xAxis, ht = ot || K(Q, nt), ct = ht.length, dt = !Q.requireSorting && {}, ut = G.indexOf(nt), pt = _(Q, ht), gt, ft;
            if (Q.options.includeInDataExport !== !1 && !Q.options.isInternal && Q.visible !== !1) {
              for (s(J, function(mt) {
                return mt[0] === ut;
              }) || J.push([ut, at]), ft = 0; ft < ct; ) st = W(Q, ht[ft], ht.length), Y.push(st.columnTitle || st), m && U.push(st.topLevelColumnTitle || st), ft++;
              gt = { chart: Q.chart, autoIncrement: Q.autoIncrement, options: Q.options, pointArrayMap: Q.pointArrayMap, index: Q.index }, Q.options.data.forEach(function(mt, yt) {
                let xt, bt, vt, Ct = { series: gt };
                P && (pt = _(Q, ht, yt)), Q.pointClass.prototype.applyOptions.apply(Ct, [mt]);
                let At = Q.data[yt] && Q.data[yt].name;
                if (xt = (Ct.x ?? "") + "," + At, ft = 0, (!nt || Q.exportKey === "name" || !P && nt && nt.hasNames && At) && (xt = At), dt && (dt[xt] && (xt += "|" + yt), dt[xt] = !0), V[xt]) {
                  let Mt = `${xt},${V[xt].pointers[Q.index]}`, kt = xt;
                  V[xt].pointers[Q.index] && (V[Mt] || (V[Mt] = [], V[Mt].xValues = [], V[Mt].pointers = []), xt = Mt), V[kt].pointers[Q.index] += 1;
                } else {
                  V[xt] = [], V[xt].xValues = [];
                  let Mt = [];
                  for (let kt = 0; kt < Q.chart.series.length; kt++) Mt[kt] = 0;
                  V[xt].pointers = Mt, V[xt].pointers[Q.index] = 1;
                }
                for (V[xt].x = Ct.x, V[xt].name = At, V[xt].xValues[ut] = Ct.x; ft < ct; ) vt = Ct[bt = ht[ft]], V[xt][at + ft] = h(pt.categoryMap[bt][vt], pt.dateTimeValueAxisMap[bt] ? D.dateFormat(H.dateFormat, vt) : null, vt), ft++;
              }), at += ft;
            }
          }), V) Object.hasOwnProperty.call(V, lt) && F.push(V[lt]);
          for (et = m ? [U, Y] : [Y], at = J.length; at--; ) k = J[at][0], j = J[at][1], $ = G[k], F.sort(function(Q, ot) {
            return Q.xValues[k] - ot.xValues[k];
          }), it = W($), et[0].splice(j, 0, it), m && et[1] && et[1].splice(j, 0, it), F.forEach(function(Q) {
            let ot = Q.name;
            $ && !c(ot) && ($.dateTime ? (Q.x instanceof Date && (Q.x = Q.x.getTime()), ot = D.dateFormat(H.dateFormat, Q.x)) : ot = $.categories ? h($.names[Q.x], $.categories[Q.x], Q.x) : Q.x), Q.splice(j, 0, ot);
          });
          return f(this, "exportData", { dataRows: et = et.concat(F) }), et;
        }
        function p(m) {
          let k = (j) => {
            if (!j.tagName || j.tagName === "#text") return j.textContent || "";
            let P = j.attributes, D = `<${j.tagName}`;
            return P && Object.keys(P).forEach((H) => {
              let G = P[H];
              D += ` ${H}="${G}"`;
            }), D += ">" + (j.textContent || ""), (j.children || []).forEach((H) => {
              D += k(H);
            }), D += `</${j.tagName}>`;
          };
          return k(this.getTableAST(m));
        }
        function C(m) {
          let k = 0, j = [], P = this.options, D = m ? 1.1.toLocaleString()[1] : ".", H = h(P.exporting.useMultiLevelHeaders, !0), G = this.getDataRows(H), V = H ? G.shift() : null, F = G.shift(), U = function(X, W) {
            let _ = X.length;
            if (W.length !== _) return !1;
            for (; _--; ) if (X[_] !== W[_]) return !1;
            return !0;
          }, Y = function(X, W, _, K) {
            let J = h(K, ""), $ = "highcharts-text" + (W ? " " + W : "");
            return typeof J == "number" ? (J = J.toString(), D === "," && (J = J.replace(".", D)), $ = "highcharts-number") : K || ($ = "highcharts-empty"), { tagName: X, attributes: _ = v({ class: $ }, _), textContent: J };
          };
          P.exporting.tableCaption !== !1 && j.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: h(P.exporting.tableCaption, P.title.text ? P.title.text : "Chart") });
          for (let X = 0, W = G.length; X < W; ++X) G[X].length > k && (k = G[X].length);
          j.push(function(X, W, _) {
            let K = [], J = 0, $ = _ || W && W.length, et, st = 0, at;
            if (H && X && W && !U(X, W)) {
              let lt = [];
              for (; J < $; ++J) if ((et = X[J]) === X[J + 1]) ++st;
              else if (st) lt.push(Y("th", "highcharts-table-topheading", { scope: "col", colspan: st + 1 }, et)), st = 0;
              else {
                et === W[J] ? P.exporting.useRowspanHeaders ? (at = 2, delete W[J]) : (at = 1, W[J] = "") : at = 1;
                let it = Y("th", "highcharts-table-topheading", { scope: "col" }, et);
                at > 1 && it.attributes && (it.attributes.valign = "top", it.attributes.rowspan = at), lt.push(it);
              }
              K.push({ tagName: "tr", children: lt });
            }
            if (W) {
              let lt = [];
              for (J = 0, $ = W.length; J < $; ++J) W[J] !== void 0 && lt.push(Y("th", null, { scope: "col" }, W[J]));
              K.push({ tagName: "tr", children: lt });
            }
            return { tagName: "thead", children: K };
          }(V, F, Math.max(k, F.length)));
          let q = [];
          G.forEach(function(X) {
            let W = [];
            for (let _ = 0; _ < k; _++) W.push(Y(_ ? "td" : "th", null, _ ? {} : { scope: "row" }, X[_]));
            q.push({ tagName: "tr", children: W });
          }), j.push({ tagName: "tbody", children: q });
          let N = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: j } };
          return f(this, "aftergetTableAST", N), N.tree;
        }
        function o() {
          this.toggleDataTable(!1);
        }
        function t(m) {
          let k = (m = h(m, !this.isDataTableVisible)) && !this.dataTableDiv;
          if (k && (this.dataTableDiv = A.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
            let G = this.dataTableDiv.style, V = G.display;
            G.display = m ? "block" : "none", m ? (this.dataTableDiv.innerHTML = T.emptyHTML, new T([this.getTableAST()]).addToDOM(this.dataTableDiv), f(this, "afterViewData", { element: this.dataTableDiv, wasHidden: k || V !== G.display })) : f(this, "afterHideData");
          }
          this.isDataTableVisible = m;
          let j = this.exportDivElements, P = this.options.exporting, D = P && P.buttons && P.buttons.contextButton.menuItems, H = this.options.lang;
          if (P && P.menuItemDefinitions && H && H.viewData && H.hideData && D && j) {
            let G = j[D.indexOf("viewData")];
            G && T.setElementHTML(G, this.isDataTableVisible ? H.hideData : H.viewData);
          }
        }
        function e() {
          this.toggleDataTable(!0);
        }
        function n(m, k) {
          let j = l.navigator, P = l.URL || l.webkitURL || l;
          try {
            if (j.msSaveOrOpenBlob && l.MSBlobBuilder) {
              let D = new l.MSBlobBuilder();
              return D.append(m), D.getBlob("image/svg+xml");
            }
            return P.createObjectURL(new l.Blob(["\uFEFF" + m], { type: k }));
          } catch {
          }
        }
        function d() {
          let m = this, k = m.dataTableDiv, j = (D, H) => D.children[H].textContent, P = (D, H) => (G, V) => {
            let F, U;
            return F = j(H ? G : V, D), U = j(H ? V : G, D), F === "" || U === "" || isNaN(F) || isNaN(U) ? F.toString().localeCompare(U) : F - U;
          };
          if (k && m.options.exporting && m.options.exporting.allowTableSorting) {
            let D = k.querySelector("thead tr");
            D && D.childNodes.forEach((H) => {
              let G = H.closest("table");
              H.addEventListener("click", function() {
                let V = [...k.querySelectorAll("tr:not(thead tr)")], F = [...H.parentNode.children];
                V.sort(P(F.indexOf(H), m.ascendingOrderInTable = !m.ascendingOrderInTable)).forEach((U) => {
                  G.appendChild(U);
                }), F.forEach((U) => {
                  ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((Y) => {
                    U.classList.contains(Y) && U.classList.remove(Y);
                  });
                }), H.classList.add(m.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
              });
            });
          }
        }
        function i() {
          this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
        }
        function g() {
          var m;
          (m = this.dataTableDiv) == null || m.remove();
        }
        return { compose: function(m, k) {
          let j = m.prototype;
          if (!j.getCSV) {
            let P = L().exporting;
            u(m, "afterViewData", d), u(m, "render", i), u(m, "destroy", g), j.downloadCSV = x, j.downloadXLS = S, j.getCSV = E, j.getDataRows = b, j.getTable = p, j.getTableAST = C, j.hideData = o, j.toggleDataTable = t, j.viewData = e, P && (v(P.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
              this.downloadCSV();
            } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
              this.downloadXLS();
            } }, viewData: { textKey: "viewData", onclick: function() {
              a.call(this, this.toggleDataTable);
            } } }), P.buttons && P.buttons.contextButton.menuItems && P.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), M(R);
            let { arearange: D, gantt: H, map: G, mapbubble: V, treemap: F, xrange: U } = k.types;
            D && (D.prototype.keyToAxis = { low: "y", high: "y" }), H && (H.prototype.exportKey = "name", H.prototype.keyToAxis = { start: "x", end: "x" }), G && (G.prototype.exportKey = "name"), V && (V.prototype.exportKey = "name"), F && (F.prototype.exportKey = "name"), U && (U.prototype.keyToAxis = { x2: "x" });
          }
        } };
      }), Z(r, "masters/modules/export-data.src.js", [r["Core/Globals.js"], r["Extensions/DownloadURL.js"], r["Extensions/ExportData/ExportData.js"]], function(T, B, I) {
        return T.dataURLtoBlob = T.dataURLtoBlob || B.dataURLtoBlob, T.downloadURL = T.downloadURL || B.downloadURL, I.compose(T.Chart, T.Series), T;
      });
    });
  }(Te)), Te.exports;
}
var El = Tl();
const Ll = /* @__PURE__ */ It(El);
var Ee = { exports: {} }, Ys;
function Ol() {
  return Ys || (Ys = 1, function(rt) {
    /**
    * Highstock JS v11.4.8 (2024-08-29)
    *
    * Highcharts Stock as a plugin for Highcharts
    *
    * (c) 2010-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Series/DataModifyComposition.js", [r["Core/Axis/Axis.js"], r["Core/Series/Point.js"], r["Core/Series/Series.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { tooltipFormatter: O } = B.prototype, { addEvent: L, arrayMax: M, arrayMin: w, correctFloat: A, defined: l, isArray: u, isNumber: c, isString: v, pick: s } = R;
        return function(f) {
          function y(t, e, n) {
            !this.isXAxis && (this.series.forEach(function(d) {
              t === "compare" && typeof e != "boolean" ? d.setCompare(e, !1) : t !== "cumulative" || v(e) || d.setCumulative(e, !1);
            }), s(n, !0) && this.chart.redraw());
          }
          function h(t) {
            let e = this, { numberFormatter: n } = e.series.chart, d = function(i) {
              t = t.replace("{point." + i + "}", (e[i] > 0 && i === "change" ? "+" : "") + n(e[i], s(e.series.tooltipOptions.changeDecimals, 2)));
            };
            return l(e.change) && d("change"), l(e.cumulativeSum) && d("cumulativeSum"), O.apply(this, [t]);
          }
          function a() {
            let t, e = this.options.compare;
            (e === "percent" || e === "value" || this.options.cumulative) && (t = new o(this), e === "percent" || e === "value" ? t.initCompare(e) : t.initCumulative()), this.dataModify = t;
          }
          function x(t) {
            let e = t.dataExtremes, n = e.activeYData;
            if (this.dataModify && e) {
              let d;
              this.options.compare ? d = [this.dataModify.modifyValue(e.dataMin), this.dataModify.modifyValue(e.dataMax)] : this.options.cumulative && u(n) && n.length >= 2 && (d = o.getCumulativeExtremes(n)), d && (e.dataMin = w(d), e.dataMax = M(d));
            }
          }
          function S(t, e) {
            this.options.compare = this.userOptions.compare = t, this.update({}, s(e, !0)), this.dataModify && (t === "value" || t === "percent") ? this.dataModify.initCompare(t) : this.points.forEach((n) => {
              delete n.change;
            });
          }
          function E() {
            if (this.xAxis && this.processedYData && this.dataModify) {
              let t = this.processedXData, e = this.processedYData, n = e.length, d = this.options.compareStart === !0 ? 0 : 1, i = -1, g;
              for (this.pointArrayMap && (i = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), g = 0; g < n - d; g++) {
                let m = e[g] && i > -1 ? e[g][i] : e[g];
                if (c(m) && m !== 0 && t[g + d] >= (this.xAxis.min || 0)) {
                  this.dataModify.compareValue = m;
                  break;
                }
              }
            }
          }
          function b(t, e) {
            this.setModifier("compare", t, e);
          }
          function p(t, e) {
            t = s(t, !1), this.options.cumulative = this.userOptions.cumulative = t, this.update({}, s(e, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((n) => {
              delete n.cumulativeSum;
            });
          }
          function C(t, e) {
            this.setModifier("cumulative", t, e);
          }
          f.compose = function(t, e, n) {
            let d = e.prototype, i = n.prototype, g = t.prototype;
            return g.setCompare || (g.setCompare = S, g.setCumulative = p, L(t, "afterInit", a), L(t, "afterGetExtremes", x), L(t, "afterProcessData", E)), d.setCompare || (d.setCompare = b, d.setModifier = y, d.setCumulative = C, i.tooltipFormatter = h), t;
          };
          class o {
            constructor(e) {
              this.series = e;
            }
            modifyValue() {
              return 0;
            }
            static getCumulativeExtremes(e) {
              let n = 1 / 0, d = -1 / 0;
              return e.reduce((i, g) => {
                let m = i + g;
                return n = Math.min(n, m, i), d = Math.max(d, m, i), m;
              }), [n, d];
            }
            initCompare(e) {
              this.modifyValue = function(n, d) {
                n === null && (n = 0);
                let i = this.compareValue;
                if (n !== void 0 && i !== void 0) {
                  if (e === "value" ? n -= i : n = n / i * 100 - (this.series.options.compareBase === 100 ? 0 : 100), d !== void 0) {
                    let g = this.series.points[d];
                    g && (g.change = n);
                  }
                  return n;
                }
                return 0;
              };
            }
            initCumulative() {
              this.modifyValue = function(e, n) {
                if (e === null && (e = 0), e !== void 0 && n !== void 0) {
                  let d = n > 0 ? this.series.points[n - 1] : null;
                  d && d.cumulativeSum && (e = A(d.cumulativeSum + e));
                  let i = this.series.points[n], g = i.series.options.cumulativeStart, m = i.x <= this.series.xAxis.max && i.x >= this.series.xAxis.min;
                  return i && (!g || m ? i.cumulativeSum = e : i.cumulativeSum = void 0), e;
                }
                return 0;
              };
            }
          }
          f.Additions = o;
        }(z || (z = {})), z;
      }), Z(r, "Stock/Navigator/ChartNavigatorComposition.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let I, { isTouchDevice: R } = T, { addEvent: z, merge: O, pick: L } = B, M = [];
        function w() {
          this.navigator && this.navigator.setBaseSeries(null, !1);
        }
        function A() {
          var S;
          let f, y, h, a = this.legend, x = this.navigator;
          if (x) {
            f = a && a.options, y = x.xAxis, h = x.yAxis;
            let { scrollbarHeight: E, scrollButtonSize: b } = x;
            this.inverted ? (x.left = x.opposite ? this.chartWidth - E - x.height : this.spacing[3] + E, x.top = this.plotTop + b) : (x.left = L(y.left, this.plotLeft + b), x.top = x.navigatorOptions.top || this.chartHeight - x.height - E - (((S = this.scrollbar) == null ? void 0 : S.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (f && f.verticalAlign === "bottom" && f.layout !== "proximate" && f.enabled && !f.floating ? a.legendHeight + L(f.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), y && h && (this.inverted ? y.options.left = h.options.left = x.left : y.options.top = h.options.top = x.top, y.setAxisSize(), h.setAxisSize());
          }
        }
        function l(f) {
          !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new I(this), L(f.redraw, !0) && this.redraw(f.animation));
        }
        function u() {
          let f = this.options;
          (f.navigator.enabled || f.scrollbar.enabled) && (this.scroller = this.navigator = new I(this));
        }
        function c() {
          let f = this.options, y = f.navigator, h = f.rangeSelector;
          if ((y && y.enabled || h && h.enabled) && (!R && this.zooming.type === "x" || R && this.zooming.pinchType === "x")) return !1;
        }
        function v(f) {
          let y = f.navigator;
          if (y && f.xAxis[0]) {
            let h = f.xAxis[0].getExtremes();
            y.render(h.min, h.max);
          }
        }
        function s(f) {
          let y = f.options.navigator || {}, h = f.options.scrollbar || {};
          !this.navigator && !this.scroller && (y.enabled || h.enabled) && (O(!0, this.options.navigator, y), O(!0, this.options.scrollbar, h), delete f.options.navigator, delete f.options.scrollbar);
        }
        return { compose: function(f, y) {
          if (B.pushUnique(M, f)) {
            let h = f.prototype;
            I = y, h.callbacks.push(v), z(f, "afterAddSeries", w), z(f, "afterSetChartSize", A), z(f, "afterUpdate", l), z(f, "beforeRender", u), z(f, "beforeShowResetZoom", c), z(f, "update", s);
          }
        } };
      }), Z(r, "Core/Axis/NavigatorAxisComposition.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { isTouchDevice: I } = T, { addEvent: R, correctFloat: z, defined: O, isNumber: L, pick: M } = B;
        function w() {
          this.navigatorAxis || (this.navigatorAxis = new l(this));
        }
        function A(u) {
          let c, v = this.chart, s = v.options, f = s.navigator, y = this.navigatorAxis, h = v.zooming.pinchType, a = s.rangeSelector, x = v.zooming.type;
          if (this.isXAxis && (f != null && f.enabled || a != null && a.enabled)) {
            if (x === "y" && u.trigger === "zoom") c = !1;
            else if ((u.trigger === "zoom" && x === "xy" || I && h === "xy") && this.options.range) {
              let S = y.previousZoom;
              O(u.min) ? y.previousZoom = [this.min, this.max] : S && (u.min = S[0], u.max = S[1], y.previousZoom = void 0);
            }
          }
          c !== void 0 && u.preventDefault();
        }
        class l {
          static compose(c) {
            c.keepProps.includes("navigatorAxis") || (c.keepProps.push("navigatorAxis"), R(c, "init", w), R(c, "setExtremes", A));
          }
          constructor(c) {
            this.axis = c;
          }
          destroy() {
            this.axis = void 0;
          }
          toFixedRange(c, v, s, f) {
            let y = this.axis, h = (y.pointRange || 0) / 2, a = M(s, y.translate(c, !0, !y.horiz)), x = M(f, y.translate(v, !0, !y.horiz));
            return O(s) || (a = z(a + h)), O(f) || (x = z(x - h)), L(a) && L(x) || (a = x = void 0), { min: a, max: x };
          }
        }
        return l;
      }), Z(r, "Stock/Navigator/NavigatorDefaults.js", [r["Core/Color/Color.js"], r["Core/Series/SeriesRegistry.js"]], function(T, B) {
        let { parse: I } = T, { seriesTypes: R } = B;
        return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: I("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: R.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
      }), Z(r, "Stock/Navigator/NavigatorSymbols.js", [r["Core/Renderer/SVG/Symbols.js"], r["Core/Utilities.js"]], function(T, B) {
        let { relativeLength: I } = B;
        return { "navigator-handle": function(R, z, O, L, M = {}) {
          let w = M.width ? M.width / 2 : O, A = I(M.borderRadius || 0, Math.min(2 * w, L));
          return [["M", -1.5, (L = M.height || L) / 2 - 3.5], ["L", -1.5, L / 2 + 4.5], ["M", 0.5, L / 2 - 3.5], ["L", 0.5, L / 2 + 4.5], ...T.rect(-w - 1, 0.5, 2 * w + 1, L, { r: A })];
        } };
      }), Z(r, "Stock/Utilities/StockUtilities.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B } = T;
        return { setFixedRange: function(I) {
          let R = this.xAxis[0];
          B(R.dataMax) && B(R.dataMin) && I ? this.fixedRange = Math.min(I, R.dataMax - R.dataMin) : this.fixedRange = I;
        } };
      }), Z(r, "Stock/Navigator/NavigatorComposition.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/NavigatorAxisComposition.js"], r["Stock/Navigator/NavigatorDefaults.js"], r["Stock/Navigator/NavigatorSymbols.js"], r["Core/Renderer/RendererRegistry.js"], r["Stock/Utilities/StockUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { setOptions: w } = T, { composed: A } = B, { getRendererType: l } = O, { setFixedRange: u } = L, { addEvent: c, extend: v, pushUnique: s } = M;
        function f() {
          this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
        }
        return { compose: function(y, h, a) {
          I.compose(h), s(A, "Navigator") && (y.prototype.setFixedRange = u, v(l().prototype.symbols, z), c(a, "afterUpdate", f), w({ navigator: R }));
        } };
      }), Z(r, "Core/Axis/ScrollbarAxis.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { composed: R } = T, { addEvent: z, defined: O, pick: L, pushUnique: M } = B;
        return function(w) {
          let A;
          function l(s) {
            let f = L(s.options && s.options.min, s.min), y = L(s.options && s.options.max, s.max);
            return { axisMin: f, axisMax: y, scrollMin: O(s.dataMin) ? Math.min(f, s.min, s.dataMin, L(s.threshold, 1 / 0)) : f, scrollMax: O(s.dataMax) ? Math.max(y, s.max, s.dataMax, L(s.threshold, -1 / 0)) : y };
          }
          function u() {
            let s = this.scrollbar, f = s && !s.options.opposite, y = this.horiz ? 2 : f ? 3 : 1;
            s && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[y] += s.size + (s.options.margin || 0));
          }
          function c() {
            let s = this;
            s.options && s.options.scrollbar && s.options.scrollbar.enabled && (s.options.scrollbar.vertical = !s.horiz, s.options.startOnTick = s.options.endOnTick = !1, s.scrollbar = new A(s.chart.renderer, s.options.scrollbar, s.chart), z(s.scrollbar, "changed", function(f) {
              let y, h, { axisMin: a, axisMax: x, scrollMin: S, scrollMax: E } = l(s), b = E - S;
              if (O(a) && O(x))
                if (s.horiz && !s.reversed || !s.horiz && s.reversed ? (y = S + b * this.to, h = S + b * this.from) : (y = S + b * (1 - this.from), h = S + b * (1 - this.to)), this.shouldUpdateExtremes(f.DOMType)) {
                  let p = f.DOMType !== "mousemove" && f.DOMType !== "touchmove" && void 0;
                  s.setExtremes(h, y, !0, p, f);
                } else this.setRange(this.from, this.to);
            }));
          }
          function v() {
            let s, f, y, { scrollMin: h, scrollMax: a } = l(this), x = this.scrollbar, S = this.axisTitleMargin + (this.titleOffset || 0), E = this.chart.scrollbarsOffsets, b = this.options.margin || 0;
            if (x && E) {
              if (this.horiz) this.opposite || (E[1] += S), x.position(this.left, this.top + this.height + 2 + E[1] - (this.opposite ? b : 0), this.width, this.height), this.opposite || (E[1] += b), s = 1;
              else {
                let p;
                this.opposite && (E[0] += S), p = x.options.opposite ? this.left + this.width + 2 + E[0] - (this.opposite ? 0 : b) : this.opposite ? 0 : b, x.position(p, this.top, this.width, this.height), this.opposite && (E[0] += b), s = 0;
              }
              if (E[s] += x.size + (x.options.margin || 0), isNaN(h) || isNaN(a) || !O(this.min) || !O(this.max) || this.dataMin === this.dataMax) x.setRange(0, 1);
              else if (this.min === this.max) {
                let p = this.pointRange / (this.dataMax + 1);
                f = p * this.min, y = p * (this.max + 1), x.setRange(f, y);
              } else f = (this.min - h) / (a - h), y = (this.max - h) / (a - h), this.horiz && !this.reversed || !this.horiz && this.reversed ? x.setRange(f, y) : x.setRange(1 - y, 1 - f);
            }
          }
          w.compose = function(s, f) {
            M(R, "Axis.Scrollbar") && (A = f, z(s, "afterGetOffset", u), z(s, "afterInit", c), z(s, "afterRender", v));
          };
        }(I || (I = {})), I;
      }), Z(r, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
        return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
      }), Z(r, "Stock/Scrollbar/Scrollbar.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/ScrollbarAxis.js"], r["Stock/Scrollbar/ScrollbarDefaults.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { defaultOptions: O } = T, { addEvent: L, correctFloat: M, crisp: w, defined: A, destroyObjectProperties: l, fireEvent: u, merge: c, pick: v, removeEvent: s } = z;
        class f {
          static compose(h) {
            I.compose(h, f);
          }
          static swapXY(h, a) {
            return a && h.forEach((x) => {
              let S, E = x.length;
              for (let b = 0; b < E; b += 2) typeof (S = x[b + 1]) == "number" && (x[b + 1] = x[b + 2], x[b + 2] = S);
            }), h;
          }
          constructor(h, a, x) {
            this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(h, a, x);
          }
          addEvents() {
            let h = this.options.inverted ? [1, 0] : [0, 1], a = this.scrollbarButtons, x = this.scrollbarGroup.element, S = this.track.element, E = this.mouseDownHandler.bind(this), b = this.mouseMoveHandler.bind(this), p = this.mouseUpHandler.bind(this), C = [[a[h[0]].element, "click", this.buttonToMinClick.bind(this)], [a[h[1]].element, "click", this.buttonToMaxClick.bind(this)], [S, "click", this.trackClick.bind(this)], [x, "mousedown", E], [x.ownerDocument, "mousemove", b], [x.ownerDocument, "mouseup", p], [x, "touchstart", E], [x.ownerDocument, "touchmove", b], [x.ownerDocument, "touchend", p]];
            C.forEach(function(o) {
              L.apply(null, o);
            }), this._events = C;
          }
          buttonToMaxClick(h) {
            let a = (this.to - this.from) * v(this.options.step, 0.2);
            this.updatePosition(this.from + a, this.to + a), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          buttonToMinClick(h) {
            let a = M(this.to - this.from) * v(this.options.step, 0.2);
            this.updatePosition(M(this.from - a), M(this.to - a)), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          cursorToScrollbarPosition(h) {
            let a = this.options, x = a.minWidth > this.calculatedWidth ? a.minWidth : 0;
            return { chartX: (h.chartX - this.x - this.xOffset) / (this.barWidth - x), chartY: (h.chartY - this.y - this.yOffset) / (this.barWidth - x) };
          }
          destroy() {
            let h = this, a = h.chart.scroller;
            h.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(x) {
              h[x] && h[x].destroy && (h[x] = h[x].destroy());
            }), a && h === a.scrollbar && (a.scrollbar = null, l(a.scrollbarButtons));
          }
          drawScrollbarButton(h) {
            let a = this.renderer, x = this.scrollbarButtons, S = this.options, E = this.size, b = a.g().add(this.group);
            if (x.push(b), S.buttonsEnabled) {
              let p = a.rect().addClass("highcharts-scrollbar-button").add(b);
              this.chart.styledMode || p.attr({ stroke: S.buttonBorderColor, "stroke-width": S.buttonBorderWidth, fill: S.buttonBackgroundColor }), p.attr(p.crisp({ x: -0.5, y: -0.5, width: E, height: E, r: S.buttonBorderRadius }, p.strokeWidth()));
              let C = a.path(f.swapXY([["M", E / 2 + (h ? -1 : 1), E / 2 - 3], ["L", E / 2 + (h ? -1 : 1), E / 2 + 3], ["L", E / 2 + (h ? 2 : -2), E / 2]], S.vertical)).addClass("highcharts-scrollbar-arrow").add(x[h]);
              this.chart.styledMode || C.attr({ fill: S.buttonArrowColor });
            }
          }
          init(h, a, x) {
            this.scrollbarButtons = [], this.renderer = h, this.userOptions = a, this.options = c(R, O.scrollbar, a), this.options.margin = v(this.options.margin, 10), this.chart = x, this.size = v(this.options.size, this.options.height), a.enabled && (this.render(), this.addEvents());
          }
          mouseDownHandler(h) {
            var S;
            let a = ((S = this.chart.pointer) == null ? void 0 : S.normalize(h)) || h, x = this.cursorToScrollbarPosition(a);
            this.chartX = x.chartX, this.chartY = x.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
          }
          mouseMoveHandler(h) {
            var b;
            let a, x = ((b = this.chart.pointer) == null ? void 0 : b.normalize(h)) || h, S = this.options.vertical ? "chartY" : "chartX", E = this.initPositions || [];
            this.grabbedCenter && (!h.touches || h.touches[0][S] !== 0) && (a = this.cursorToScrollbarPosition(x)[S] - this[S], this.hasDragged = !0, this.updatePosition(E[0] + a, E[1] + a), this.hasDragged && u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h.type, DOMEvent: h }));
          }
          mouseUpHandler(h) {
            this.hasDragged && u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: h.type, DOMEvent: h }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
          }
          position(h, a, x, S) {
            let { buttonsEnabled: E, margin: b = 0, vertical: p } = this.options, C = this.rendered ? "animate" : "attr", o = S, t = 0;
            this.group.show(), this.x = h, this.y = a + this.trackBorderWidth, this.width = x, this.height = S, this.xOffset = o, this.yOffset = t, p ? (this.width = this.yOffset = x = t = this.size, this.xOffset = o = 0, this.yOffset = t = E ? this.size : 0, this.barWidth = S - (E ? 2 * x : 0), this.x = h += b) : (this.height = S = this.size, this.xOffset = o = E ? this.size : 0, this.barWidth = x - (E ? 2 * S : 0), this.y = this.y + b), this.group[C]({ translateX: h, translateY: this.y }), this.track[C]({ width: x, height: S }), this.scrollbarButtons[1][C]({ translateX: p ? 0 : x - o, translateY: p ? S - t : 0 });
          }
          removeEvents() {
            this._events.forEach(function(h) {
              s.apply(null, h);
            }), this._events.length = 0;
          }
          render() {
            let h = this.renderer, a = this.options, x = this.size, S = this.chart.styledMode, E = h.g("scrollbar").attr({ zIndex: a.zIndex }).hide().add();
            this.group = E, this.track = h.rect().addClass("highcharts-scrollbar-track").attr({ r: a.trackBorderRadius || 0, height: x, width: x }).add(E), S || this.track.attr({ fill: a.trackBackgroundColor, stroke: a.trackBorderColor, "stroke-width": a.trackBorderWidth });
            let b = this.trackBorderWidth = this.track.strokeWidth();
            this.track.attr({ x: -w(0, b), y: -w(0, b) }), this.scrollbarGroup = h.g().add(E), this.scrollbar = h.rect().addClass("highcharts-scrollbar-thumb").attr({ height: x - b, width: x - b, r: a.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = h.path(f.swapXY([["M", -3, x / 4], ["L", -3, 2 * x / 3], ["M", 0, x / 4], ["L", 0, 2 * x / 3], ["M", 3, x / 4], ["L", 3, 2 * x / 3]], a.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), S || (this.scrollbar.attr({ fill: a.barBackgroundColor, stroke: a.barBorderColor, "stroke-width": a.barBorderWidth }), this.scrollbarRifles.attr({ stroke: a.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-w(0, this.scrollbarStrokeWidth), -w(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
          }
          setRange(h, a) {
            let x, S, E = this.options, b = E.vertical, p = E.minWidth, C = this.barWidth, o = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
            if (!A(C)) return;
            let t = C * Math.min(a, 1);
            x = Math.ceil(C * (h = Math.max(h, 0))), this.calculatedWidth = S = M(t - x), S < p && (x = (C - p + S) * h, S = p);
            let e = Math.floor(x + this.xOffset + this.yOffset), n = S / 2 - 0.5;
            this.from = h, this.to = a, b ? (this.scrollbarGroup[o]({ translateY: e }), this.scrollbar[o]({ height: S }), this.scrollbarRifles[o]({ translateY: n }), this.scrollbarTop = e, this.scrollbarLeft = 0) : (this.scrollbarGroup[o]({ translateX: e }), this.scrollbar[o]({ width: S }), this.scrollbarRifles[o]({ translateX: n }), this.scrollbarLeft = e, this.scrollbarTop = 0), S <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), E.showFull === !1 && (h <= 0 && a >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
          }
          shouldUpdateExtremes(h) {
            return v(this.options.liveRedraw, B.svg && !B.isTouchDevice && !this.chart.boosted) || h === "mouseup" || h === "touchend" || !A(h);
          }
          trackClick(h) {
            var b;
            let a = ((b = this.chart.pointer) == null ? void 0 : b.normalize(h)) || h, x = this.to - this.from, S = this.y + this.scrollbarTop, E = this.x + this.scrollbarLeft;
            this.options.vertical && a.chartY > S || !this.options.vertical && a.chartX > E ? this.updatePosition(this.from + x, this.to + x) : this.updatePosition(this.from - x, this.to - x), u(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: h });
          }
          update(h) {
            this.destroy(), this.init(this.chart.renderer, c(!0, this.options, h), this.chart);
          }
          updatePosition(h, a) {
            a > 1 && (h = M(1 - M(a - h)), a = 1), h < 0 && (a = M(a - h), h = 0), this.from = h, this.to = a;
          }
        }
        return f.defaultOptions = R, O.scrollbar = c(!0, f.defaultOptions, O.scrollbar), f;
      }), Z(r, "Stock/Navigator/Navigator.js", [r["Core/Axis/Axis.js"], r["Stock/Navigator/ChartNavigatorComposition.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Axis/NavigatorAxisComposition.js"], r["Stock/Navigator/NavigatorComposition.js"], r["Stock/Scrollbar/Scrollbar.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w) {
        let { defaultOptions: A } = I, { isTouchDevice: l } = R, { prototype: { symbols: u } } = M, { addEvent: c, clamp: v, correctFloat: s, defined: f, destroyObjectProperties: y, erase: h, extend: a, find: x, fireEvent: S, isArray: E, isNumber: b, merge: p, pick: C, removeEvent: o, splat: t } = w;
        function e(d, ...i) {
          let g = [].filter.call(i, b);
          if (g.length) return Math[d].apply(0, g);
        }
        class n {
          static compose(i, g, m) {
            B.compose(i, n), O.compose(i, g, m);
          }
          constructor(i) {
            this.isDirty = !1, this.scrollbarHeight = 0, this.init(i);
          }
          drawHandle(i, g, m, k) {
            let j = this.navigatorOptions.handles.height;
            this.handles[g][k](m ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(i, 10) + 0.5 - j) } : { translateX: Math.round(this.left + parseInt(i, 10)), translateY: Math.round(this.top + this.height / 2 - j / 2 - 1) });
          }
          drawOutline(i, g, m, k) {
            let j = this.navigatorOptions.maskInside, P = this.outline.strokeWidth(), D = P / 2, H = P % 2 / 2, G = this.scrollButtonSize, V = this.size, F = this.top, U = this.height, Y = F - D, q = F + U, N = this.left, X, W;
            m ? (X = F + g + H, g = F + i + H, W = [["M", N + U, F - G - H], ["L", N + U, X], ["L", N, X], ["M", N, g], ["L", N + U, g], ["L", N + U, F + V + G]], j && W.push(["M", N + U, X - D], ["L", N + U, g + D])) : (N -= G, i += N + G - H, g += N + G - H, W = [["M", N, Y], ["L", i, Y], ["L", i, q], ["M", g, q], ["L", g, Y], ["L", N + V + 2 * G, Y]], j && W.push(["M", i - D, Y], ["L", g + D, Y])), this.outline[k]({ d: W });
          }
          drawMasks(i, g, m, k) {
            let j, P, D, H, G = this.left, V = this.top, F = this.height;
            m ? (D = [G, G, G], H = [V, V + i, V + g], P = [F, F, F], j = [i, g - i, this.size - g]) : (D = [G, G + i, G + g], H = [V, V, V], P = [i, g - i, this.size - g], j = [F, F, F]), this.shades.forEach((U, Y) => {
              U[k]({ x: D[Y], y: H[Y], width: P[Y], height: j[Y] });
            });
          }
          renderElements() {
            var G;
            let i = this, g = i.navigatorOptions, m = g.maskInside, k = i.chart, j = k.inverted, P = k.renderer, D = { cursor: j ? "ns-resize" : "ew-resize" }, H = i.navigatorGroup ?? (i.navigatorGroup = P.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add());
            if ([!m, m, !m].forEach((V, F) => {
              let U = i.shades[F] ?? (i.shades[F] = P.rect().addClass("highcharts-navigator-mask" + (F === 1 ? "-inside" : "-outside")).add(H));
              k.styledMode || (U.attr({ fill: V ? g.maskFill : "rgba(0,0,0,0)" }), F === 1 && U.css(D));
            }), i.outline || (i.outline = P.path().addClass("highcharts-navigator-outline").add(H)), k.styledMode || i.outline.attr({ "stroke-width": g.outlineWidth, stroke: g.outlineColor }), (G = g.handles) == null ? void 0 : G.enabled) {
              let V = g.handles, { height: F, width: U } = V;
              [0, 1].forEach((Y) => {
                var N;
                let q = V.symbols[Y];
                if (i.handles[Y] && i.handles[Y].symbolUrl === q) {
                  if (!i.handles[Y].isImg && i.handles[Y].symbolName !== q) {
                    let X = u[q].call(u, -U / 2 - 1, 0, U, F);
                    i.handles[Y].attr({ d: X }), i.handles[Y].symbolName = q;
                  }
                } else (N = i.handles[Y]) == null || N.destroy(), i.handles[Y] = P.symbol(q, -U / 2 - 1, 0, U, F, V), i.handles[Y].attr({ zIndex: 7 - Y }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][Y]).add(H), i.addMouseEvents();
                k.inverted && i.handles[Y].attr({ rotation: 90, rotationOriginX: Math.floor(-U / 2), rotationOriginY: (F + U) / 2 }), k.styledMode || i.handles[Y].attr({ fill: V.backgroundColor, stroke: V.borderColor, "stroke-width": V.lineWidth, width: V.width, height: V.height, x: -U / 2 - 1, y: 0 }).css(D);
              });
            }
          }
          update(i, g = !1) {
            var j;
            let m = this.chart, k = m.options.chart.inverted !== ((j = m.scrollbar) == null ? void 0 : j.options.vertical);
            if (p(!0, m.options.navigator, i), this.navigatorOptions = m.options.navigator || {}, this.setOpposite(), f(i.enabled) || k) return this.destroy(), this.navigatorEnabled = i.enabled || this.navigatorEnabled, this.init(m);
            if (this.navigatorEnabled && (this.isDirty = !0, i.adaptToUpdatedData === !1 && this.baseSeries.forEach((P) => {
              o(P, "updatedData", this.updatedDataHandler);
            }, this), i.adaptToUpdatedData && this.baseSeries.forEach((P) => {
              P.eventsToUnbind.push(c(P, "updatedData", this.updatedDataHandler));
            }, this), (i.series || i.baseSeries) && this.setBaseSeries(void 0, !1), i.height || i.xAxis || i.yAxis)) {
              this.height = i.height ?? this.height;
              let P = this.getXAxisOffsets();
              this.xAxis.update({ ...i.xAxis, offsets: P, [m.inverted ? "width" : "height"]: this.height, [m.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...i.yAxis, [m.inverted ? "width" : "height"]: this.height }, !1);
            }
            g && m.redraw();
          }
          render(i, g, m, k) {
            let j = this.chart, P = this.xAxis, D = P.pointRange || 0, H = P.navigatorAxis.fake ? j.xAxis[0] : P, G = this.navigatorEnabled, V = this.rendered, F = j.inverted, U = j.xAxis[0].minRange, Y = j.xAxis[0].options.maxRange, q = this.scrollButtonSize, N, X, W, _ = this.scrollbarHeight, K, J;
            if (this.hasDragged && !f(m)) return;
            if (this.isDirty && this.renderElements(), i = s(i - D / 2), g = s(g + D / 2), !b(i) || !b(g)) {
              if (!V) return;
              m = 0, k = C(P.width, H.width);
            }
            this.left = C(P.left, j.plotLeft + q + (F ? j.plotWidth : 0));
            let $ = this.size = K = C(P.len, (F ? j.plotHeight : j.plotWidth) - 2 * q);
            N = F ? _ : K + 2 * q, m = C(m, P.toPixels(i, !0)), k = C(k, P.toPixels(g, !0)), b(m) && Math.abs(m) !== 1 / 0 || (m = 0, k = N);
            let et = P.toValue(m, !0), st = P.toValue(k, !0), at = Math.abs(s(st - et));
            at < U ? this.grabbedLeft ? m = P.toPixels(st - U - D, !0) : this.grabbedRight && (k = P.toPixels(et + U + D, !0)) : f(Y) && s(at - D) > Y && (this.grabbedLeft ? m = P.toPixels(st - Y - D, !0) : this.grabbedRight && (k = P.toPixels(et + Y + D, !0))), this.zoomedMax = v(Math.max(m, k), 0, $), this.zoomedMin = v(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(m, k), 0, $), this.range = this.zoomedMax - this.zoomedMin, $ = Math.round(this.zoomedMax);
            let lt = Math.round(this.zoomedMin);
            G && (this.navigatorGroup.attr({ visibility: "inherit" }), J = V && !this.hasDragged ? "animate" : "attr", this.drawMasks(lt, $, F, J), this.drawOutline(lt, $, F, J), this.navigatorOptions.handles.enabled && (this.drawHandle(lt, 0, F, J), this.drawHandle($, 1, F, J))), this.scrollbar && (F ? (W = this.top - q, X = this.left - _ + (G || !H.opposite ? 0 : (H.titleOffset || 0) + H.axisTitleMargin), _ = K + 2 * q) : (W = this.top + (G ? this.height : -_), X = this.left - q), this.scrollbar.position(X, W, N, _), this.scrollbar.setRange(this.zoomedMin / (K || 1), this.zoomedMax / (K || 1))), this.rendered = !0, this.isDirty = !1, S(this, "afterRender");
          }
          addMouseEvents() {
            let i = this, g = i.chart, m = g.container, k = [], j, P;
            i.mouseMoveHandler = j = function(D) {
              i.onMouseMove(D);
            }, i.mouseUpHandler = P = function(D) {
              i.onMouseUp(D);
            }, (k = i.getPartsEvents("mousedown")).push(c(g.renderTo, "mousemove", j), c(m.ownerDocument, "mouseup", P), c(g.renderTo, "touchmove", j), c(m.ownerDocument, "touchend", P)), k.concat(i.getPartsEvents("touchstart")), i.eventsToUnbind = k, i.series && i.series[0] && k.push(c(i.series[0].xAxis, "foundExtremes", function() {
              g.navigator.modifyNavigatorAxisExtremes();
            }));
          }
          getPartsEvents(i) {
            let g = this, m = [];
            return ["shades", "handles"].forEach(function(k) {
              g[k].forEach(function(j, P) {
                m.push(c(j.element, i, function(D) {
                  g[k + "Mousedown"](D, P);
                }));
              });
            }), m;
          }
          shadesMousedown(i, g) {
            var q;
            i = ((q = this.chart.pointer) == null ? void 0 : q.normalize(i)) || i;
            let m = this.chart, k = this.xAxis, j = this.zoomedMin, P = this.size, D = this.range, H = this.left, G = i.chartX, V, F, U, Y;
            m.inverted && (G = i.chartY, H = this.top), g === 1 ? (this.grabbedCenter = G, this.fixedWidth = D, this.dragOffset = G - j) : (Y = G - H - D / 2, g === 0 ? Y = Math.max(0, Y) : g === 2 && Y + D >= P && (Y = P - D, this.reversedExtremes ? (Y -= D, F = this.getUnionExtremes().dataMin) : V = this.getUnionExtremes().dataMax), Y !== j && (this.fixedWidth = D, f((U = k.navigatorAxis.toFixedRange(Y, Y + D, F, V)).min) && S(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
          }
          handlesMousedown(i, g) {
            var P;
            i = ((P = this.chart.pointer) == null ? void 0 : P.normalize(i)) || i;
            let m = this.chart, k = m.xAxis[0], j = this.reversedExtremes;
            g === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = j ? k.min : k.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = j ? k.max : k.min), m.setFixedRange(void 0);
          }
          onMouseMove(i) {
            var V;
            let g = this, m = g.chart, k = g.navigatorSize, j = g.range, P = g.dragOffset, D = m.inverted, H = g.left, G;
            (!i.touches || i.touches[0].pageX !== 0) && (G = (i = ((V = m.pointer) == null ? void 0 : V.normalize(i)) || i).chartX, D && (H = g.top, G = i.chartY), g.grabbedLeft ? (g.hasDragged = !0, g.render(0, 0, G - H, g.otherHandlePos)) : g.grabbedRight ? (g.hasDragged = !0, g.render(0, 0, g.otherHandlePos, G - H)) : g.grabbedCenter && (g.hasDragged = !0, G < P ? G = P : G > k + P - j && (G = k + P - j), g.render(0, 0, G - P, G - P + j)), g.hasDragged && g.scrollbar && C(g.scrollbar.options.liveRedraw, !l && !this.chart.boosted) && (i.DOMType = i.type, setTimeout(function() {
              g.onMouseUp(i);
            }, 0)));
          }
          onMouseUp(i) {
            let g, m, k, j, P, D, H = this.chart, G = this.xAxis, V = this.scrollbar, F = i.DOMEvent || i, U = H.inverted, Y = this.rendered && !this.hasDragged ? "animate" : "attr";
            (this.hasDragged && (!V || !V.hasDragged) || i.trigger === "scrollbar") && (k = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? j = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (P = this.fixedExtreme), this.zoomedMax === this.size && (P = this.reversedExtremes ? k.dataMin : k.dataMax), this.zoomedMin === 0 && (j = this.reversedExtremes ? k.dataMax : k.dataMin), f((D = G.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, j, P)).min) && S(this, "setRange", { min: Math.min(D.min, D.max), max: Math.max(D.min, D.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: F } })), i.DOMType !== "mousemove" && i.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && b(this.zoomedMin) && b(this.zoomedMax) && (m = Math.round(this.zoomedMin), g = Math.round(this.zoomedMax), this.shades && this.drawMasks(m, g, U, Y), this.outline && this.drawOutline(m, g, U, Y), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(m, 0, U, Y), this.drawHandle(g, 1, U, Y)));
          }
          removeEvents() {
            this.eventsToUnbind && (this.eventsToUnbind.forEach(function(i) {
              i();
            }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
          }
          removeBaseSeriesEvents() {
            let i = this.baseSeries || [];
            this.navigatorEnabled && i[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && i.forEach(function(g) {
              o(g, "updatedData", this.updatedDataHandler);
            }, this), i[0].xAxis && o(i[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
          }
          getXAxisOffsets() {
            return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
          }
          init(i) {
            var N;
            let g = i.options, m = g.navigator || {}, k = m.enabled, j = g.scrollbar || {}, P = j.enabled, D = k && m.height || 0, H = P && j.height || 0, G = j.buttonsEnabled && H || 0;
            this.handles = [], this.shades = [], this.chart = i, this.setBaseSeries(), this.height = D, this.scrollbarHeight = H, this.scrollButtonSize = G, this.scrollbarEnabled = P, this.navigatorEnabled = k, this.navigatorOptions = m, this.scrollbarOptions = j, this.setOpposite();
            let V = this, F = V.baseSeries, U = i.xAxis.length, Y = i.yAxis.length, q = F && F[0] && F[0].xAxis || i.xAxis[0] || { options: {} };
            if (i.isDirtyBox = !0, V.navigatorEnabled) {
              let X = this.getXAxisOffsets();
              V.xAxis = new T(i, p({ breaks: q.options.breaks, ordinal: q.options.ordinal, overscroll: q.options.overscroll }, m.xAxis, { type: "datetime", yAxis: (N = m.yAxis) == null ? void 0 : N.id, index: U, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: q.options.ordinal ? 0 : q.options.minPadding, maxPadding: q.options.ordinal ? 0 : q.options.maxPadding, zoomEnabled: !1 }, i.inverted ? { offsets: X, width: D } : { offsets: X, height: D }), "xAxis"), V.yAxis = new T(i, p(m.yAxis, { alignTicks: !1, offset: 0, index: Y, isInternal: !0, reversed: C(m.yAxis && m.yAxis.reversed, i.yAxis[0] && i.yAxis[0].reversed, !1), zoomEnabled: !1 }, i.inverted ? { width: D } : { height: D }), "yAxis"), F || m.series.data ? V.updateNavigatorSeries(!1) : i.series.length === 0 && (V.unbindRedraw = c(i, "beforeRedraw", function() {
                i.series.length > 0 && !V.series && (V.setBaseSeries(), V.unbindRedraw());
              })), V.reversedExtremes = i.inverted && !V.xAxis.reversed || !i.inverted && V.xAxis.reversed, V.renderElements(), V.addMouseEvents();
            } else V.xAxis = { chart: i, navigatorAxis: { fake: !0 }, translate: function(X, W) {
              let _ = i.xAxis[0], K = _.getExtremes(), J = _.len - 2 * G, $ = e("min", _.options.min, K.dataMin), et = e("max", _.options.max, K.dataMax) - $;
              return W ? X * et / J + $ : J * (X - $) / et;
            }, toPixels: function(X) {
              return this.translate(X);
            }, toValue: function(X) {
              return this.translate(X, !0);
            } }, V.xAxis.navigatorAxis.axis = V.xAxis, V.xAxis.navigatorAxis.toFixedRange = z.prototype.toFixedRange.bind(V.xAxis.navigatorAxis);
            if (i.options.scrollbar.enabled) {
              let X = p(i.options.scrollbar, { vertical: i.inverted });
              !b(X.margin) && V.navigatorEnabled && (X.margin = i.inverted ? -3 : 3), i.scrollbar = V.scrollbar = new L(i.renderer, X, i), c(V.scrollbar, "changed", function(W) {
                let _ = V.size, K = _ * this.to, J = _ * this.from;
                V.hasDragged = V.scrollbar.hasDragged, V.render(0, 0, J, K), this.shouldUpdateExtremes(W.DOMType) && setTimeout(function() {
                  V.onMouseUp(W);
                });
              });
            }
            V.addBaseSeriesEvents(), V.addChartEvents();
          }
          setOpposite() {
            let i = this.navigatorOptions, g = this.navigatorEnabled, m = this.chart;
            this.opposite = C(i.opposite, !!(!g && m.inverted));
          }
          getUnionExtremes(i) {
            let g, m = this.chart.xAxis[0], k = this.xAxis, j = k.options, P = m.options;
            return i && m.dataMin === null || (g = { dataMin: C(j && j.min, e("min", P.min, m.dataMin, k.dataMin, k.min)), dataMax: C(j && j.max, e("max", P.max, m.dataMax, k.dataMax, k.max)) }), g;
          }
          setBaseSeries(i, g) {
            let m = this.chart, k = this.baseSeries = [];
            i = i || m.options && m.options.navigator.baseSeries || (m.series.length ? x(m.series, (j) => !j.options.isInternal).index : 0), (m.series || []).forEach((j, P) => {
              !j.options.isInternal && (j.options.showInNavigator || (P === i || j.options.id === i) && j.options.showInNavigator !== !1) && k.push(j);
            }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, g);
          }
          updateNavigatorSeries(i, g) {
            var U, Y;
            let m = this, k = m.chart, j = m.baseSeries, P = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (U = this.navigatorOptions.xAxis) == null ? void 0 : U.id, yAxis: (Y = this.navigatorOptions.yAxis) == null ? void 0 : Y.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, D = m.series = (m.series || []).filter((q) => {
              let N = q.baseSeries;
              return !(0 > j.indexOf(N)) || (N && (o(N, "updatedData", m.updatedDataHandler), delete N.navigatorSeries), q.chart && q.destroy(), !1);
            }), H, G, V = m.navigatorOptions.series, F;
            j && j.length && j.forEach((q) => {
              let N = q.navigatorSeries, X = a({ color: q.color, visible: q.visible }, E(V) ? A.navigator.series : V);
              if (N && m.navigatorOptions.adaptToUpdatedData === !1) return;
              P.name = "Navigator " + j.length, F = (H = q.options || {}).navigatorOptions || {}, X.dataLabels = t(X.dataLabels), (G = p(H, P, X, F)).pointRange = C(X.pointRange, F.pointRange, A.plotOptions[G.type || "line"].pointRange);
              let W = F.data || X.data;
              m.hasNavigatorData = m.hasNavigatorData || !!W, G.data = W || H.data && H.data.slice(0), N && N.options ? N.update(G, g) : (q.navigatorSeries = k.initSeries(G), k.setSortedData(), q.navigatorSeries.baseSeries = q, D.push(q.navigatorSeries));
            }), (V.data && !(j && j.length) || E(V)) && (m.hasNavigatorData = !1, (V = t(V)).forEach((q, N) => {
              P.name = "Navigator " + (D.length + 1), (G = p(A.navigator.series, { color: k.series[N] && !k.series[N].options.isInternal && k.series[N].color || k.options.colors[N] || k.options.colors[0] }, P, q)).data = q.data, G.data && (m.hasNavigatorData = !0, D.push(k.initSeries(G)));
            })), i && this.addBaseSeriesEvents();
          }
          addBaseSeriesEvents() {
            let i = this, g = i.baseSeries || [];
            g[0] && g[0].xAxis && g[0].eventsToUnbind.push(c(g[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), g.forEach((m) => {
              m.eventsToUnbind.push(c(m, "show", function() {
                this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
              })), m.eventsToUnbind.push(c(m, "hide", function() {
                this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
              })), this.navigatorOptions.adaptToUpdatedData !== !1 && m.xAxis && m.eventsToUnbind.push(c(m, "updatedData", this.updatedDataHandler)), m.eventsToUnbind.push(c(m, "remove", function() {
                h(g, m), this.navigatorSeries && (h(i.series, this.navigatorSeries), f(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
              }));
            });
          }
          getBaseSeriesMin(i) {
            return this.baseSeries.reduce(function(g, m) {
              return Math.min(g, m.xData && m.xData.length ? m.xData[0] : g);
            }, i);
          }
          modifyNavigatorAxisExtremes() {
            let i = this.xAxis;
            if (i.getExtremes !== void 0) {
              let g = this.getUnionExtremes(!0);
              g && (g.dataMin !== i.min || g.dataMax !== i.max) && (i.min = g.dataMin, i.max = g.dataMax);
            }
          }
          modifyBaseAxisExtremes() {
            var N;
            let i, g, m = this.chart.navigator, k = this.getExtremes(), j = k.min, P = k.max, D = k.dataMin, H = k.dataMax, G = P - j, V = m.stickToMin, F = m.stickToMax, U = C((N = this.ordinal) == null ? void 0 : N.convertOverscroll(this.options.overscroll), 0), Y = m.series && m.series[0], q = !!this.setExtremes;
            !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (V && (i = (g = D) + G), F && (i = H + U, V || (g = Math.max(D, i - G, m.getBaseSeriesMin(Y && Y.xData ? Y.xData[0] : -Number.MAX_VALUE)))), q && (V || F) && b(g) && (this.min = this.userMin = g, this.max = this.userMax = i)), m.stickToMin = m.stickToMax = null;
          }
          updatedDataHandler() {
            let i = this.chart.navigator, g = this.navigatorSeries, m = i.reversedExtremes ? Math.round(i.zoomedMin) === 0 : Math.round(i.zoomedMax) >= Math.round(i.size);
            i.stickToMax = C(this.chart.options.navigator && this.chart.options.navigator.stickToMax, m), i.stickToMin = i.shouldStickToMin(this, i), g && !i.hasNavigatorData && (g.options.pointStart = this.xData[0], g.setData(this.options.data, !1, null, !1));
          }
          shouldStickToMin(i, g) {
            let m = g.getBaseSeriesMin(i.xData[0]), k = i.xAxis, j = k.max, P = k.min, D = k.options.range;
            return !!(b(j) && b(P)) && (D && j - m > 0 ? j - m < D : P <= m);
          }
          addChartEvents() {
            this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(c(this.chart, "redraw", function() {
              let i = this.navigator, g = i && (i.baseSeries && i.baseSeries[0] && i.baseSeries[0].xAxis || this.xAxis[0]);
              g && i.render(g.min, g.max);
            }), c(this.chart, "getMargins", function() {
              let i = this.navigator, g = i.opposite ? "plotTop" : "marginBottom";
              this.inverted && (g = i.opposite ? "marginRight" : "plotLeft"), this[g] = (this[g] || 0) + (i.navigatorEnabled || !this.inverted ? i.height + i.scrollbarHeight : 0) + i.navigatorOptions.margin;
            }), c(n, "setRange", function(i) {
              this.chart.xAxis[0].setExtremes(i.min, i.max, i.redraw, i.animation, i.eventArguments);
            }));
          }
          destroy() {
            this.removeEvents(), this.xAxis && (h(this.chart.xAxis, this.xAxis), h(this.chart.axes, this.xAxis)), this.yAxis && (h(this.chart.yAxis, this.yAxis), h(this.chart.axes, this.yAxis)), (this.series || []).forEach((i) => {
              i.destroy && i.destroy();
            }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((i) => {
              this[i] && this[i].destroy && this[i].destroy(), this[i] = null;
            }), [this.handles].forEach((i) => {
              y(i);
            }), this.navigatorEnabled = !1;
          }
        }
        return n;
      }), Z(r, "Core/Axis/OrdinalAxis.js", [r["Core/Axis/Axis.js"], r["Core/Globals.js"], r["Core/Series/Series.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { addEvent: O, correctFloat: L, css: M, defined: w, error: A, isNumber: l, pick: u, timeUnits: c, isString: v } = R;
        return function(s) {
          function f(e, n, d, i, g = [], m = 0, k) {
            let j = {}, P = this.options.tickPixelInterval, D = this.chart.time, H = [], G, V, F, U, Y, q = 0, N = [], X = -Number.MAX_VALUE;
            if (!this.options.ordinal && !this.options.breaks || !g || g.length < 3 || n === void 0) return D.getTimeTicks.apply(D, arguments);
            let W = g.length;
            for (G = 0; G < W; G++) {
              if (Y = G && g[G - 1] > d, g[G] < n && (q = G), G === W - 1 || g[G + 1] - g[G] > 5 * m || Y) {
                if (g[G] > X) {
                  for (V = D.getTimeTicks(e, g[q], g[G], i); V.length && V[0] <= X; ) V.shift();
                  V.length && (X = V[V.length - 1]), H.push(N.length), N = N.concat(V);
                }
                q = G + 1;
              }
              if (Y) break;
            }
            if (V) {
              if (U = V.info, k && U.unitRange <= c.hour) {
                for (q = 1, G = N.length - 1; q < G; q++) D.dateFormat("%d", N[q]) !== D.dateFormat("%d", N[q - 1]) && (j[N[q]] = "day", F = !0);
                F && (j[N[0]] = "day"), U.higherRanks = j;
              }
              U.segmentStarts = H, N.info = U;
            } else A(12, !1, this.chart);
            if (k && w(P)) {
              let _ = N.length, K = [], J = [], $, et, st, at, lt, it = _;
              for (; it--; ) et = this.translate(N[it]), st && (J[it] = st - et), K[it] = st = et;
              for (J.sort((Q, ot) => Q - ot), (at = J[Math.floor(J.length / 2)]) < 0.6 * P && (at = null), it = N[_ - 1] > d ? _ - 1 : _, st = void 0; it--; ) lt = Math.abs(st - (et = K[it])), st && lt < 0.8 * P && (at === null || lt < 0.8 * at) ? (j[N[it]] && !j[N[it + 1]] ? ($ = it + 1, st = et) : $ = it, N.splice($, 1)) : st = et;
            }
            return N;
          }
          function y(e) {
            let n = this.ordinal.positions;
            if (!n) return e;
            let d = n.length - 1, i;
            return e < 0 ? e = n[0] : e > d ? e = n[d] : (d = Math.floor(e), i = e - d), i !== void 0 && n[d] !== void 0 ? n[d] + (i ? i * (n[d + 1] - n[d]) : 0) : e;
          }
          function h(e) {
            let n = this.ordinal, d = this.old ? this.old.min : this.min, i = this.old ? this.old.transA : this.transA, g = n.getExtendedPositions();
            if (g && g.length) {
              let m = L((e - d) * i + this.minPixelPadding), k = L(n.getIndexOfPoint(m, g)), j = L(k % 1);
              if (k >= 0 && k <= g.length - 1) {
                let P = g[Math.floor(k)], D = g[Math.ceil(k)];
                return g[Math.floor(k)] + j * (D - P);
              }
            }
            return e;
          }
          function a(e, n) {
            let d = s.Additions.findIndexOf(e, n, !0);
            if (e[d] === n) return d;
            let i = (n - e[d]) / (e[d + 1] - e[d]);
            return d + i;
          }
          function x() {
            this.ordinal || (this.ordinal = new s.Additions(this));
          }
          function S() {
            let { eventArgs: e, options: n } = this;
            if (this.isXAxis && w(n.overscroll) && n.overscroll !== 0 && l(this.max) && l(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && ((e == null ? void 0 : e.trigger) !== "pan" || this.isInternal) && (e == null ? void 0 : e.trigger) !== "navigator")) {
              let d = this.ordinal.convertOverscroll(n.overscroll);
              this.max += d, !this.isInternal && w(this.userMin) && (e == null ? void 0 : e.trigger) !== "mousewheel" && (this.min += d);
            }
          }
          function E() {
            this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
          }
          function b() {
            this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
          }
          function p(e) {
            let n = this.xAxis[0], d = n.ordinal.convertOverscroll(n.options.overscroll), i = e.originalEvent.chartX, g = this.options.chart.panning, m = !1;
            if (g && g.type !== "y" && n.options.ordinal && n.series.length && (!e.touches || e.touches.length <= 1)) {
              let k, j, P = this.mouseDownX, D = n.getExtremes(), H = D.dataMin, G = D.dataMax, V = D.min, F = D.max, U = this.hoverPoints, Y = n.closestPointRange || n.ordinal && n.ordinal.overscrollPointsRange, q = Math.round((P - i) / (n.translationSlope * (n.ordinal.slope || Y))), N = n.ordinal.getExtendedPositions(), X = { ordinal: { positions: N, extendedOrdinalPositions: N } }, W = n.index2val, _ = n.val2lin;
              if (V <= H && q < 0 || F + d >= G && q > 0) return;
              X.ordinal.positions ? Math.abs(q) > 1 && (U && U.forEach(function(K) {
                K.setState();
              }), G > (j = X.ordinal.positions)[j.length - 1] && j.push(G), this.setFixedRange(F - V), (k = n.navigatorAxis.toFixedRange(void 0, void 0, W.apply(X, [_.apply(X, [V, !0]) + q]), W.apply(X, [_.apply(X, [F, !0]) + q]))).min >= Math.min(D.dataMin, V) && k.max <= Math.max(G, F) + d && n.setExtremes(k.min, k.max, !0, !1, { trigger: "pan" }), this.mouseDownX = i, M(this.container, { cursor: "move" })) : m = !0;
            } else m = !0;
            m || g && /y/.test(g.type) ? d && (n.max = n.dataMax + d) : e.preventDefault();
          }
          function C() {
            let e = this.xAxis;
            e && e.options.ordinal && (delete e.ordinal.index, delete e.ordinal.originalOrdinalRange);
          }
          function o(e, n) {
            let d, i = this.ordinal, g = i.positions, m = i.slope, k;
            if (!g) return e;
            let j = g.length;
            if (g[0] <= e && g[j - 1] >= e) d = a(g, e);
            else {
              if (!((k = i.getExtendedPositions && i.getExtendedPositions()) && k.length)) return e;
              let P = k.length;
              m || (m = (k[P - 1] - k[0]) / P);
              let D = a(k, g[0]);
              if (e >= k[0] && e <= k[P - 1]) d = a(k, e) - D;
              else {
                if (!n) return e;
                d = e < k[0] ? -D - (k[0] - e) / m : (e - k[P - 1]) / m + P - D;
              }
            }
            return n ? d : m * (d || 0) + i.offset;
          }
          s.compose = function(e, n, d) {
            let i = e.prototype;
            return i.ordinal2lin || (i.getTimeTicks = f, i.index2val = y, i.lin2val = h, i.val2lin = o, i.ordinal2lin = i.val2lin, O(e, "afterInit", x), O(e, "foundExtremes", S), O(e, "afterSetScale", E), O(e, "initialAxisTranslation", b), O(d, "pan", p), O(d, "touchpan", p), O(n, "updatedData", C)), e;
          };
          class t {
            constructor(n) {
              this.index = {}, this.axis = n;
            }
            beforeSetTickPositions() {
              var _;
              let n = this.axis, d = n.ordinal, i = n.getExtremes(), g = i.min, m = i.max, k = (_ = n.brokenAxis) == null ? void 0 : _.hasBreaks, j = n.options.ordinal, P, D, H, G, V, F, U, Y = [], q = Number.MAX_VALUE, N = !1, X = !1, W = !1;
              if (j || k) {
                let K = 0;
                if (n.series.forEach(function(J, $) {
                  if (D = [], $ > 0 && J.options.id !== "highcharts-navigator-series" && J.processedXData.length > 1 && (X = K !== J.processedXData[1] - J.processedXData[0]), K = J.processedXData[1] - J.processedXData[0], J.boosted && (W = J.boosted), J.reserveSpace() && (J.takeOrdinalPosition !== !1 || k) && (P = (Y = Y.concat(J.processedXData)).length, Y.sort(function(et, st) {
                    return et - st;
                  }), q = Math.min(q, u(J.closestPointRange, q)), P)) {
                    for ($ = 0; $ < P - 1; ) Y[$] !== Y[$ + 1] && D.push(Y[$ + 1]), $++;
                    D[0] !== Y[0] && D.unshift(Y[0]), Y = D;
                  }
                }), n.ordinal.originalOrdinalRange || (n.ordinal.originalOrdinalRange = (Y.length - 1) * q), X && W && (Y.pop(), Y.shift()), (P = Y.length) > 2) {
                  for (H = Y[1] - Y[0], U = P - 1; U-- && !N; ) Y[U + 1] - Y[U] !== H && (N = !0);
                  !n.options.keepOrdinalPadding && (Y[0] - g > H || m - Y[Y.length - 1] > H) && (N = !0);
                } else n.options.overscroll && (P === 2 ? q = Y[1] - Y[0] : P === 1 ? (q = n.ordinal.convertOverscroll(n.options.overscroll), Y = [Y[0], Y[0] + q]) : q = d.overscrollPointsRange);
                N || n.forceOrdinal ? (n.options.overscroll && (d.overscrollPointsRange = q, Y = Y.concat(d.getOverscrollPositions())), d.positions = Y, G = n.ordinal2lin(Math.max(g, Y[0]), !0), V = Math.max(n.ordinal2lin(Math.min(m, Y[Y.length - 1]), !0), 1), d.slope = F = (m - g) / (V - G), d.offset = g - G * F) : (d.overscrollPointsRange = u(n.closestPointRange, d.overscrollPointsRange), d.positions = n.ordinal.slope = d.offset = void 0);
              }
              n.isOrdinal = j && N, d.groupIntervalFactor = null;
            }
            static findIndexOf(n, d, i) {
              let g = 0, m = n.length - 1, k;
              for (; g < m; ) n[k = Math.ceil((g + m) / 2)] <= d ? g = k : m = k - 1;
              return n[g] === d || i ? g : -1;
            }
            getExtendedPositions(n = !0) {
              var F;
              let d = this, i = d.axis, g = i.constructor.prototype, m = i.chart, k = (F = i.series[0]) == null ? void 0 : F.currentDataGrouping, j = k ? k.count + k.unitName : "raw", P = n ? i.ordinal.convertOverscroll(i.options.overscroll) : 0, D = i.getExtremes(), H, G, V = d.index;
              return V || (V = d.index = {}), V[j] || ((H = { series: [], chart: m, forceOrdinal: !1, getExtremes: function() {
                return { min: D.dataMin, max: D.dataMax + P };
              }, applyGrouping: g.applyGrouping, getGroupPixelWidth: g.getGroupPixelWidth, getTimeTicks: g.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: g.ordinal2lin, getIndexOfPoint: g.getIndexOfPoint, val2lin: g.val2lin }).ordinal.axis = H, i.series.forEach(function(U) {
                var Y, q, N;
                G = { xAxis: H, xData: U.xData.slice(), chart: m, groupPixelWidth: U.groupPixelWidth, destroyGroupedData: B.noop, getProcessedData: I.prototype.getProcessedData, applyGrouping: I.prototype.applyGrouping, reserveSpace: I.prototype.reserveSpace, visible: U.visible }, n && (G.xData = G.xData.concat(d.getOverscrollPositions())), G.options = { dataGrouping: k ? { firstAnchor: (Y = U.options.dataGrouping) == null ? void 0 : Y.firstAnchor, anchor: (q = U.options.dataGrouping) == null ? void 0 : q.anchor, lastAnchor: (N = U.options.dataGrouping) == null ? void 0 : N.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[k.unitName, [k.count]]] } : { enabled: !1 } }, H.series.push(G), U.processData.apply(G);
              }), H.applyGrouping({ hasExtremesChanged: !0 }), (G == null ? void 0 : G.closestPointRange) !== (G == null ? void 0 : G.basePointRange) && G.currentDataGrouping && (H.forceOrdinal = !0), i.ordinal.beforeSetTickPositions.apply({ axis: H }), !i.ordinal.originalOrdinalRange && H.ordinal.originalOrdinalRange && (i.ordinal.originalOrdinalRange = H.ordinal.originalOrdinalRange), V[j] = H.ordinal.positions), V[j];
            }
            getGroupIntervalFactor(n, d, i) {
              let g = i.processedXData, m = g.length, k = [], j, P, D = this.groupIntervalFactor;
              if (!D) {
                for (P = 0; P < m - 1; P++) k[P] = g[P + 1] - g[P];
                k.sort(function(H, G) {
                  return H - G;
                }), j = k[Math.floor(m / 2)], n = Math.max(n, g[0]), d = Math.min(d, g[m - 1]), this.groupIntervalFactor = D = m * j / (d - n);
              }
              return D;
            }
            getIndexOfPoint(n, d) {
              let i, g = this.axis, m = 0, k = function(D) {
                let { min: H, max: G } = g;
                return !!(w(H) && w(G)) && D.points.some((V) => V.x >= H && V.x <= G);
              };
              g.series.forEach((D) => {
                var G;
                let H = (G = D.points) == null ? void 0 : G[0];
                w(H == null ? void 0 : H.plotX) && (H.plotX < i || !w(i)) && k(D) && (i = H.plotX, m = H.x);
              }), i ?? (i = g.minPixelPadding);
              let j = g.translationSlope * (this.slope || g.closestPointRange || this.overscrollPointsRange), P = L((n - i) / j);
              return t.findIndexOf(d, m, !0) + P;
            }
            getOverscrollPositions() {
              let n = this.axis, d = this.convertOverscroll(n.options.overscroll), i = this.overscrollPointsRange, g = [], m = n.dataMax;
              if (w(i)) for (; m <= n.dataMax + d; ) g.push(m += i);
              return g;
            }
            postProcessTickInterval(n) {
              let d = this.axis, i = this.slope;
              return i ? d.options.breaks ? d.closestPointRange || n : n / (i / d.closestPointRange) : n;
            }
            convertOverscroll(n = 0) {
              let d = this, i = d.axis, g = function(m) {
                return u(d.originalOrdinalRange, w(i.dataMax) && w(i.dataMin) ? i.dataMax - i.dataMin : 0) * m;
              };
              if (v(n)) {
                let m = parseInt(n, 10);
                if (/%$/.test(n)) return g(m / 100);
                if (/px/.test(n)) {
                  let k = Math.min(m, 0.9 * i.len) / i.len;
                  return g(k / (1 - k));
                }
                return 0;
              }
              return n;
            }
          }
          s.Additions = t;
        }(z || (z = {})), z;
      }), Z(r, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
        return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
      }), Z(r, "Stock/RangeSelector/RangeSelectorComposition.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Stock/RangeSelector/RangeSelectorDefaults.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let z, { defaultOptions: O } = T, { composed: L } = B, { addEvent: M, defined: w, extend: A, isNumber: l, merge: u, pick: c, pushUnique: v } = R, s = [];
        function f() {
          let b, p, C = this.range, o = C.type, t = this.max, e = this.chart.time, n = function(i, g) {
            let m = o === "year" ? "FullYear" : "Month", k = new e.Date(i), j = e.get(m, k);
            return e.set(m, k, j + g), j === e.get(m, k) && e.set("Date", k, 0), k.getTime() - i;
          };
          l(C) ? (b = t - C, p = C) : C && (b = t + n(t, -(C.count || 1)), this.chart && this.chart.setFixedRange(t - b));
          let d = c(this.dataMin, Number.MIN_VALUE);
          return l(b) || (b = d), b <= d && (b = d, p === void 0 && (p = n(b, C.count)), this.newMax = Math.min(b + p, c(this.dataMax, Number.MAX_VALUE))), l(t) ? !l(C) && C && C._offsetMin && (b += C._offsetMin) : b = void 0, b;
        }
        function y() {
          this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new z(this));
        }
        function h() {
          let b = this.rangeSelector;
          if (b) {
            l(b.deferredYTDClick) && (b.clickButton(b.deferredYTDClick), delete b.deferredYTDClick);
            let p = b.options.verticalAlign;
            b.options.floating || (p === "bottom" ? this.extraBottomMargin = !0 : p === "middle" || (this.extraTopMargin = !0));
          }
        }
        function a() {
          let b, p = this.rangeSelector;
          if (!p) return;
          let C = this.xAxis[0].getExtremes(), o = this.legend, t = p && p.options.verticalAlign;
          l(C.min) && p.render(C.min, C.max), o.display && t === "top" && t === o.options.verticalAlign && (b = u(this.spacingBox), o.options.layout === "vertical" ? b.y = this.plotTop : b.y += p.getHeight(), o.group.placed = !1, o.align(b));
        }
        function x() {
          for (let b = 0, p = s.length; b < p; ++b) {
            let C = s[b];
            if (C[0] === this) {
              C[1].forEach((o) => o()), s.splice(b, 1);
              return;
            }
          }
        }
        function S() {
          let b = this.rangeSelector;
          if (b) {
            let p = b.getHeight();
            this.extraTopMargin && (this.plotTop += p), this.extraBottomMargin && (this.marginBottom += p);
          }
        }
        function E(b) {
          let p = b.options.rangeSelector, C = this.extraBottomMargin, o = this.extraTopMargin, t = this.rangeSelector;
          if (p && p.enabled && !w(t) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = t = new z(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, t) {
            let e = p && p.verticalAlign || t.options && t.options.verticalAlign;
            t.options.floating || (e === "bottom" ? this.extraBottomMargin = !0 : e === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== C || this.extraTopMargin !== o) && (this.isDirtyBox = !0);
          }
        }
        return { compose: function(b, p, C) {
          if (z = C, v(L, "RangeSelector")) {
            let o = p.prototype;
            b.prototype.minFromRange = f, M(p, "afterGetContainer", y), M(p, "beforeRender", h), M(p, "destroy", x), M(p, "getMargins", S), M(p, "redraw", a), M(p, "update", E), o.callbacks.push(a), A(O, { rangeSelector: I.rangeSelector }), A(O.lang, I.lang);
          }
        } };
      }), Z(r, "Stock/RangeSelector/RangeSelector.js", [r["Core/Axis/Axis.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Stock/RangeSelector/RangeSelectorComposition.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"], r["Core/Axis/OrdinalAxis.js"]], function(T, B, I, R, z, O, L) {
        let { defaultOptions: M } = B, { addEvent: w, createElement: A, css: l, defined: u, destroyObjectProperties: c, discardElement: v, extend: s, fireEvent: f, isNumber: y, merge: h, objectEach: a, pad: x, pick: S, pInt: E, splat: b } = O;
        class p {
          static compose(o, t) {
            R.compose(o, t, p);
          }
          constructor(o) {
            this.buttonOptions = p.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(o);
          }
          clickButton(o, t) {
            let e = this.chart, n = this.buttonOptions[o], d = e.xAxis[0], i = e.scroller && e.scroller.getUnionExtremes() || d || {}, g = n.type, m = n.dataGrouping, k = i.dataMin, j = i.dataMax, P, D = d && Math.round(Math.min(d.max, S(j, d.max))), H, G = n._range, V, F, U, Y = !0;
            if (k !== null && j !== null) {
              if (this.setSelected(o), m && (this.forcedDataGrouping = !0, T.prototype.setDataGrouping.call(d || { chart: this.chart }, m, !1), this.frozenStates = n.preserveDataGrouping), g === "month" || g === "year") d ? (F = { range: n, max: D, chart: e, dataMin: k, dataMax: j }, P = d.minFromRange.call(F), y(F.newMax) && (D = F.newMax), Y = !1) : G = n;
              else if (G) D = Math.min((P = Math.max(D - G, k)) + G, j), Y = !1;
              else if (g === "ytd")
                if (d) (j === void 0 || k === void 0) && (k = Number.MAX_VALUE, j = Number.MIN_VALUE, e.series.forEach((q) => {
                  let N = q.xData;
                  N && (k = Math.min(N[0], k), j = Math.max(N[N.length - 1], j));
                }), t = !1), P = V = (U = this.getYTDExtremes(j, k, e.time.useUTC)).min, D = U.max;
                else {
                  this.deferredYTDClick = o;
                  return;
                }
              else g === "all" && d && (e.navigator && e.navigator.baseSeries[0] && (e.navigator.baseSeries[0].xAxis.options.range = void 0), P = k, D = j);
              if (Y && n._offsetMin && u(P) && (P += n._offsetMin), n._offsetMax && u(D) && (D += n._offsetMax), this.dropdown && (this.dropdown.selectedIndex = o + 1), d) d.setExtremes(P, D, S(t, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: n }), e.setFixedRange(n._range);
              else {
                H = b(e.options.xAxis)[0];
                let q = w(e, "afterGetAxes", function() {
                  let N = e.xAxis[0];
                  N.range = N.options.range = G, N.min = N.options.min = V;
                });
                w(e, "load", function() {
                  let N = e.xAxis[0];
                  e.setFixedRange(n._range), N.options.range = H.range, N.options.min = H.min, q();
                });
              }
              f(this, "afterBtnClick");
            }
          }
          setSelected(o) {
            this.selected = this.options.selected = o;
          }
          init(o) {
            let t = this, e = o.options.rangeSelector, n = e.buttons || t.defaultButtons.slice(), d = e.selected, i = function() {
              let g = t.minInput, m = t.maxInput;
              g && g.blur && f(g, "blur"), m && m.blur && f(m, "blur");
            };
            t.chart = o, t.options = e, t.buttons = [], t.buttonOptions = n, this.eventsToUnbind = [], this.eventsToUnbind.push(w(o.container, "mousedown", i)), this.eventsToUnbind.push(w(o, "resize", i)), n.forEach(t.computeButtonRange), d !== void 0 && n[d] && this.clickButton(d, !1), this.eventsToUnbind.push(w(o, "load", function() {
              o.xAxis && o.xAxis[0] && w(o.xAxis[0], "setExtremes", function(g) {
                y(this.max) && y(this.min) && this.max - this.min !== o.fixedRange && g.trigger !== "rangeSelectorButton" && g.trigger !== "updatedData" && t.forcedDataGrouping && !t.frozenStates && this.setDataGrouping(!1, !1);
              });
            })), this.createElements();
          }
          updateButtonStates() {
            let o = this, t = this.chart, e = this.dropdown, n = this.dropdownLabel, d = t.xAxis[0], i = Math.round(d.max - d.min), g = !d.hasVisibleSeries, m = 24 * 36e5, k = t.scroller && t.scroller.getUnionExtremes() || d, j = k.dataMin, P = k.dataMax, D = o.getYTDExtremes(P, j, t.time.useUTC), H = D.min, G = D.max, V = o.selected, F = o.options.allButtonsEnabled, U = Array(o.buttonOptions.length).fill(0), Y = y(V), q = o.buttons, N = !1, X = null;
            o.buttonOptions.forEach((W, _) => {
              var ht;
              let K = W._range, J = W.type, $ = W.count || 1, et = W._offsetMax - W._offsetMin, st = _ === V, at = K > P - j, lt = K < d.minRange, it = !1, Q = K === i;
              if (st && at && (N = !0), d.isOrdinal && ((ht = d.ordinal) == null ? void 0 : ht.positions) && K && i < K) {
                let ct = d.ordinal.positions, dt = L.Additions.findIndexOf(ct, d.min, !0), ut = Math.min(L.Additions.findIndexOf(ct, d.max, !0) + 1, ct.length - 1);
                ct[ut] - ct[dt] > K && (Q = !0);
              } else (J === "month" || J === "year") && i + 36e5 >= { month: 28, year: 365 }[J] * m * $ - et && i - 36e5 <= { month: 31, year: 366 }[J] * m * $ + et ? Q = !0 : J === "ytd" ? (Q = G - H + et === i, it = !st) : J === "all" && (Q = d.max - d.min >= P - j);
              let ot = !F && !(N && J === "all") && (at || lt || g), nt = N && J === "all" || !it && Q || st && o.frozenStates;
              ot ? U[_] = 3 : nt && (!Y || _ === V) && (X = _);
            }), X !== null ? (U[X] = 2, o.setSelected(X)) : (o.setSelected(), n && (n.setState(0), n.attr({ text: (M.lang.rangeSelectorZoom || "") + " ▾" })));
            for (let W = 0; W < U.length; W++) {
              let _ = U[W], K = q[W];
              if (K.state !== _ && (K.setState(_), e)) {
                e.options[W + 1].disabled = _ === 3, _ === 2 && (n && (n.setState(2), n.attr({ text: o.buttonOptions[W].text + " ▾" })), e.selectedIndex = W + 1);
                let J = n.getBBox();
                l(e, { width: `${J.width}px`, height: `${J.height}px` });
              }
            }
          }
          computeButtonRange(o) {
            let t = o.type, e = o.count || 1, n = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
            n[t] ? o._range = n[t] * e : (t === "month" || t === "year") && (o._range = 24 * { month: 30, year: 365 }[t] * 36e5 * e), o._offsetMin = S(o.offsetMin, 0), o._offsetMax = S(o.offsetMax, 0), o._range += o._offsetMax - o._offsetMin;
          }
          getInputValue(o) {
            let t = o === "min" ? this.minInput : this.maxInput, e = this.chart.options.rangeSelector, n = this.chart.time;
            return t ? (t.type === "text" && e.inputDateParser || this.defaultInputDateParser)(t.value, n.useUTC, n) : 0;
          }
          setInputValue(o, t) {
            let e = this.options, n = this.chart.time, d = o === "min" ? this.minInput : this.maxInput, i = o === "min" ? this.minDateBox : this.maxDateBox;
            if (d) {
              let g = d.getAttribute("data-hc-time"), m = u(g) ? Number(g) : void 0;
              if (u(t)) {
                let k = m;
                u(k) && d.setAttribute("data-hc-time-previous", k), d.setAttribute("data-hc-time", t), m = t;
              }
              d.value = n.dateFormat(this.inputTypeFormats[d.type] || e.inputEditDateFormat, m), i && i.attr({ text: n.dateFormat(e.inputDateFormat, m) });
            }
          }
          setInputExtremes(o, t, e) {
            let n = o === "min" ? this.minInput : this.maxInput;
            if (n) {
              let d = this.inputTypeFormats[n.type], i = this.chart.time;
              if (d) {
                let g = i.dateFormat(d, t);
                n.min !== g && (n.min = g);
                let m = i.dateFormat(d, e);
                n.max !== m && (n.max = m);
              }
            }
          }
          showInput(o) {
            let t = o === "min" ? this.minDateBox : this.maxDateBox, e = o === "min" ? this.minInput : this.maxInput;
            if (e && t && this.inputGroup) {
              let n = e.type === "text", { translateX: d = 0, translateY: i = 0 } = this.inputGroup, { x: g = 0, width: m = 0, height: k = 0 } = t, { inputBoxWidth: j } = this.options;
              l(e, { width: n ? m + (j ? -2 : 20) + "px" : "auto", height: k - 2 + "px", border: "2px solid silver" }), n && j ? l(e, { left: d + g + "px", top: i + "px" }) : l(e, { left: Math.min(Math.round(g + d - (e.offsetWidth - m) / 2), this.chart.chartWidth - e.offsetWidth) + "px", top: i - (e.offsetHeight - k) / 2 + "px" });
            }
          }
          hideInput(o) {
            let t = o === "min" ? this.minInput : this.maxInput;
            t && l(t, { top: "-9999em", border: 0, width: "1px", height: "1px" });
          }
          defaultInputDateParser(o, t, e) {
            let n = o.split("/").join("-").split(" ").join("T");
            if (n.indexOf("T") === -1 && (n += "T00:00"), t) n += "Z";
            else {
              let i;
              if (I.isSafari && !((i = n).length > 6 && (i.lastIndexOf("-") === i.length - 6 || i.lastIndexOf("+") === i.length - 6))) {
                let g = new Date(n).getTimezoneOffset() / 60;
                n += g <= 0 ? `+${x(-g)}:00` : `-${x(g)}:00`;
              }
            }
            let d = Date.parse(n);
            if (!y(d)) {
              let i = o.split("-");
              d = Date.UTC(E(i[0]), E(i[1]) - 1, E(i[2]));
            }
            return e && t && y(d) && (d += e.getTimezoneOffset(d)), d;
          }
          drawInput(o) {
            let { chart: t, div: e, inputGroup: n } = this, d = this, i = t.renderer.style || {}, g = t.renderer, m = t.options.rangeSelector, k = M.lang, j = o === "min";
            function P(U) {
              var $;
              let { maxInput: Y, minInput: q } = d, N = t.xAxis[0], X = (($ = t.scroller) == null ? void 0 : $.getUnionExtremes()) || N, W = X.dataMin, _ = X.dataMax, K = t.xAxis[0].getExtremes()[U], J = d.getInputValue(U);
              y(J) && J !== K && (j && Y && y(W) ? J > Number(Y.getAttribute("data-hc-time")) ? J = void 0 : J < W && (J = W) : q && y(_) && (J < Number(q.getAttribute("data-hc-time")) ? J = void 0 : J > _ && (J = _)), J !== void 0 && N.setExtremes(j ? J : N.min, j ? N.max : J, void 0, void 0, { trigger: "rangeSelectorInput" }));
            }
            let D = k[j ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", H = g.label(D, 0).addClass("highcharts-range-label").attr({ padding: D ? 2 : 0, height: D ? m.inputBoxHeight : 0 }).add(n), G = g.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: m.inputBoxWidth, height: m.inputBoxHeight, "text-align": "center" }).on("click", function() {
              d.showInput(o), d[o + "Input"].focus();
            });
            t.styledMode || G.attr({ stroke: m.inputBoxBorderColor, "stroke-width": 1 }), G.add(n);
            let V = A("input", { name: o, className: "highcharts-range-selector" }, void 0, e);
            V.setAttribute("type", function(U) {
              if (U.indexOf("%L") !== -1) return "text";
              let Y = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((N) => U.indexOf("%" + N) !== -1), q = ["H", "k", "I", "l", "M", "S"].some((N) => U.indexOf("%" + N) !== -1);
              return Y && q ? "datetime-local" : Y ? "date" : q ? "time" : "text";
            }(m.inputDateFormat || "%e %b %Y")), t.styledMode || (H.css(h(i, m.labelStyle)), G.css(h({ color: "#333333" }, i, m.inputStyle)), l(V, s({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: i.fontSize, fontFamily: i.fontFamily, top: "-9999em" }, m.inputStyle))), V.onfocus = () => {
              d.showInput(o);
            }, V.onblur = () => {
              V === I.doc.activeElement && P(o), d.hideInput(o), d.setInputValue(o), V.blur();
            };
            let F = !1;
            return V.onchange = () => {
              F || (P(o), d.hideInput(o), V.blur());
            }, V.onkeypress = (U) => {
              U.keyCode === 13 && P(o);
            }, V.onkeydown = (U) => {
              F = !0, (U.key === "ArrowUp" || U.key === "ArrowDown" || U.key === "Tab") && P(o);
            }, V.onkeyup = () => {
              F = !1;
            }, { dateBox: G, input: V, label: H };
          }
          getPosition() {
            let o = this.chart, t = o.options.rangeSelector, e = t.verticalAlign === "top" ? o.plotTop - o.axisOffset[0] : 0;
            return { buttonTop: e + t.buttonPosition.y, inputTop: e + t.inputPosition.y - 10 };
          }
          getYTDExtremes(o, t, e) {
            let n = this.chart.time, d = new n.Date(o), i = n.get("FullYear", d), g = Math.max(t, e ? n.Date.UTC(i, 0, 1) : +new n.Date(i, 0, 1)), m = d.getTime();
            return { max: Math.min(o || m, m), min: g };
          }
          createElements() {
            var m;
            let o = this.chart, t = o.renderer, e = o.container, n = o.options, d = n.rangeSelector, i = d.inputEnabled, g = S((m = n.chart.style) == null ? void 0 : m.zIndex, 0) + 1;
            if (d.enabled !== !1 && (this.group = t.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = A("div", void 0, { position: "relative", height: 0, zIndex: g }), this.buttonOptions.length && this.renderButtons(), e.parentNode && e.parentNode.insertBefore(this.div, e), i)) {
              this.inputGroup = t.g("input-group").add(this.group);
              let k = this.drawInput("min");
              this.minDateBox = k.dateBox, this.minLabel = k.label, this.minInput = k.input;
              let j = this.drawInput("max");
              this.maxDateBox = j.dateBox, this.maxLabel = j.label, this.maxInput = j.input;
            }
          }
          render(o, t) {
            let e = this.chart, n = e.options.rangeSelector, d = n.inputEnabled;
            if (n.enabled !== !1) {
              if (d) {
                this.setInputValue("min", o), this.setInputValue("max", t);
                let i = e.scroller && e.scroller.getUnionExtremes() || e.xAxis[0] || {};
                if (u(i.dataMin) && u(i.dataMax)) {
                  let g = e.xAxis[0].minRange || 0;
                  this.setInputExtremes("min", i.dataMin, Math.min(i.dataMax, this.getInputValue("max")) - g), this.setInputExtremes("max", Math.max(i.dataMin, this.getInputValue("min")) + g, i.dataMax);
                }
                if (this.inputGroup) {
                  let g = 0;
                  [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((m) => {
                    if (m) {
                      let { width: k } = m.getBBox();
                      k && (m.attr({ x: g }), g += k + n.inputSpacing);
                    }
                  });
                }
              }
              this.alignElements(), this.updateButtonStates();
            }
          }
          renderButtons() {
            var H;
            let { buttons: o, chart: t, options: e } = this, n = M.lang, d = t.renderer, i = h(e.buttonTheme), g = i && i.states, m = i.width || 28;
            delete i.width, delete i.states, this.buttonGroup = d.g("range-selector-buttons").add(this.group);
            let k = this.dropdown = A("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), j = (H = t.userOptions.rangeSelector) == null ? void 0 : H.buttonTheme;
            this.dropdownLabel = d.button("", 0, 0, () => {
            }, h(i, { "stroke-width": S(i["stroke-width"], 0), width: "auto", paddingLeft: S(e.buttonTheme.paddingLeft, j == null ? void 0 : j.padding, 8), paddingRight: S(e.buttonTheme.paddingRight, j == null ? void 0 : j.padding, 8) }), g && g.hover, g && g.select, g && g.disabled).hide().add(this.group), w(k, "touchstart", () => {
              k.style.fontSize = "16px";
            });
            let P = I.isMS ? "mouseover" : "mouseenter", D = I.isMS ? "mouseout" : "mouseleave";
            w(k, P, () => {
              f(this.dropdownLabel.element, P);
            }), w(k, D, () => {
              f(this.dropdownLabel.element, D);
            }), w(k, "change", () => {
              f(this.buttons[k.selectedIndex - 1].element, "click");
            }), this.zoomText = d.label(n.rangeSelectorZoom || "", 0).attr({ padding: e.buttonTheme.padding, height: e.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(e.labelStyle), i["stroke-width"] = S(i["stroke-width"], 0)), A("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, k), this.buttonOptions.forEach((G, V) => {
              A("option", { textContent: G.title || G.text }, void 0, k), o[V] = d.button(G.text, 0, 0, (F) => {
                let U, Y = G.events && G.events.click;
                Y && (U = Y.call(G, F)), U !== !1 && this.clickButton(V), this.isActive = !0;
              }, i, g && g.hover, g && g.select, g && g.disabled).attr({ "text-align": "center", width: m }).add(this.buttonGroup), G.title && o[V].attr("title", G.title);
            });
          }
          alignElements() {
            var V;
            let { buttonGroup: o, buttons: t, chart: e, group: n, inputGroup: d, options: i, zoomText: g } = this, m = e.options, k = m.exporting && m.exporting.enabled !== !1 && m.navigation && m.navigation.buttonOptions, { buttonPosition: j, inputPosition: P, verticalAlign: D } = i, H = (F, U) => k && this.titleCollision(e) && D === "top" && U.align === "right" && U.y - F.getBBox().height - 12 < (k.y || 0) + (k.height || 0) + e.spacing[0] ? -40 : 0, G = e.plotLeft;
            if (n && j && P) {
              let F = j.x - e.spacing[3];
              if (o) {
                if (this.positionButtons(), !this.initialButtonGroupWidth) {
                  let J = 0;
                  g && (J += g.getBBox().width + 5), t.forEach(($, et) => {
                    J += $.width || 0, et !== t.length - 1 && (J += i.buttonSpacing);
                  }), this.initialButtonGroupWidth = J;
                }
                G -= e.spacing[3];
                let K = H(o, j);
                this.alignButtonGroup(K), (V = this.buttonGroup) != null && V.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), n.placed = o.placed = e.hasLoaded;
              }
              let U = 0;
              d && (U = H(d, P), P.align === "left" ? F = G : P.align === "right" && (F = -Math.max(e.axisOffset[1], -U)), d.align({ y: P.y, width: d.getBBox().width, align: P.align, x: P.x + F - 2 }, !0, e.spacingBox), d.placed = e.hasLoaded), this.handleCollision(U), n.align({ verticalAlign: D }, !0, e.spacingBox);
              let Y = n.alignAttr.translateY, q = n.getBBox().height + 20, N = 0;
              if (D === "bottom") {
                let K = e.legend && e.legend.options;
                N = Y - (q = q + (K && K.verticalAlign === "bottom" && K.enabled && !K.floating ? e.legend.legendHeight + S(K.margin, 10) : 0) - 20) - (i.floating ? 0 : i.y) - (e.titleOffset ? e.titleOffset[2] : 0) - 10;
              }
              D === "top" ? (i.floating && (N = 0), e.titleOffset && e.titleOffset[0] && (N = e.titleOffset[0]), N += e.margin[0] - e.spacing[0] || 0) : D === "middle" && (P.y === j.y ? N = Y : (P.y || j.y) && (P.y < 0 || j.y < 0 ? N -= Math.min(P.y, j.y) : N = Y - q)), n.translate(i.x, i.y + Math.floor(N));
              let { minInput: X, maxInput: W, dropdown: _ } = this;
              i.inputEnabled && X && W && (X.style.marginTop = n.translateY + "px", W.style.marginTop = n.translateY + "px"), _ && (_.style.marginTop = n.translateY + "px");
            }
          }
          alignButtonGroup(o, t) {
            let { chart: e, options: n, buttonGroup: d } = this, { buttonPosition: i } = n, g = e.plotLeft - e.spacing[3], m = i.x - e.spacing[3];
            i.align === "right" ? m += o - g : i.align === "center" && (m -= g / 2), d && d.align({ y: i.y, width: S(t, this.initialButtonGroupWidth), align: i.align, x: m }, !0, e.spacingBox);
          }
          positionButtons() {
            let { buttons: o, chart: t, options: e, zoomText: n } = this, d = t.hasLoaded ? "animate" : "attr", { buttonPosition: i } = e, g = t.plotLeft, m = g;
            n && n.visibility !== "hidden" && (n[d]({ x: S(g + i.x, g) }), m += i.x + n.getBBox().width + 5);
            for (let k = 0, j = this.buttonOptions.length; k < j; ++k) o[k].visibility !== "hidden" ? (o[k][d]({ x: m }), m += (o[k].width || 0) + e.buttonSpacing) : o[k][d]({ x: g });
          }
          handleCollision(o) {
            let { chart: t, buttonGroup: e, inputGroup: n } = this, { buttonPosition: d, dropdown: i, inputPosition: g } = this.options, m = () => {
              let P = 0;
              return this.buttons.forEach((D) => {
                let H = D.getBBox();
                H.width > P && (P = H.width);
              }), P;
            }, k = (P) => {
              if (n != null && n.alignOptions && e) {
                let D = n.alignAttr.translateX + n.alignOptions.x - o + n.getBBox().x + 2, H = n.alignOptions.width || 0, G = e.alignAttr.translateX + e.getBBox().x;
                return G + P > D && D + H > G && d.y < g.y + n.getBBox().height;
              }
              return !1;
            }, j = () => {
              n && e && n.attr({ translateX: n.alignAttr.translateX + (t.axisOffset[1] >= -o ? 0 : -o), translateY: n.alignAttr.translateY + e.getBBox().height + 10 });
            };
            if (e) {
              if (i === "always") {
                this.collapseButtons(), k(m()) && j();
                return;
              }
              i === "never" && this.expandButtons();
            }
            n && e ? g.align === d.align || k(this.initialButtonGroupWidth + 20) ? i === "responsive" ? (this.collapseButtons(), k(m()) && j()) : j() : i === "responsive" && this.expandButtons() : e && i === "responsive" && (this.initialButtonGroupWidth > t.plotWidth ? this.collapseButtons() : this.expandButtons());
          }
          collapseButtons() {
            let { buttons: o, zoomText: t } = this;
            this.isCollapsed !== !0 && (this.isCollapsed = !0, t.hide(), o.forEach((e) => void e.hide()), this.showDropdown());
          }
          expandButtons() {
            let { buttons: o, zoomText: t } = this;
            this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), t.show(), o.forEach((e) => void e.show()), this.positionButtons());
          }
          showDropdown() {
            let { buttonGroup: o, chart: t, dropdownLabel: e, dropdown: n } = this;
            if (o && n) {
              let { translateX: d = 0, translateY: i = 0 } = o, g = t.plotLeft + d;
              e.attr({ x: g, y: i }).show(), l(n, { left: g + "px", top: i + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
            }
          }
          hideDropdown() {
            let { dropdown: o } = this;
            o && (this.dropdownLabel.hide(), l(o, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
          }
          getHeight() {
            let o = this.options, t = this.group, e = o.inputPosition, n = o.buttonPosition, d = o.y, i = n.y, g = e.y, m = 0;
            if (o.height) return o.height;
            this.alignElements(), m = t ? t.getBBox(!0).height + 13 + d : 0;
            let k = Math.min(g, i);
            return (g < 0 && i < 0 || g > 0 && i > 0) && (m += Math.abs(k)), m;
          }
          titleCollision(o) {
            return !(o.options.title.text || o.options.subtitle.text);
          }
          update(o, t = !0) {
            let e = this.chart;
            h(!0, e.options.rangeSelector, o), this.destroy(), this.init(e), t && this.render();
          }
          destroy() {
            let o = this, t = o.minInput, e = o.maxInput;
            o.eventsToUnbind && (o.eventsToUnbind.forEach((n) => n()), o.eventsToUnbind = void 0), c(o.buttons), t && (t.onfocus = t.onblur = t.onchange = null), e && (e.onfocus = e.onblur = e.onchange = null), a(o, function(n, d) {
              n && d !== "chart" && (n instanceof z ? n.destroy() : n instanceof window.HTMLElement && v(n)), n !== p.prototype[d] && (o[d] = null);
            }, this);
          }
        }
        return s(p.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), p;
      }), Z(r, "Core/Chart/StockChart.js", [r["Core/Chart/Chart.js"], r["Core/Templating.js"], r["Core/Defaults.js"], r["Stock/Navigator/NavigatorDefaults.js"], r["Stock/RangeSelector/RangeSelectorDefaults.js"], r["Stock/Scrollbar/ScrollbarDefaults.js"], r["Stock/Utilities/StockUtilities.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { format: w } = B, { getOptions: A } = I, { setFixedRange: l } = L, { addEvent: u, clamp: c, crisp: v, defined: s, extend: f, find: y, isNumber: h, isString: a, merge: x, pick: S, splat: E } = M;
        function b(o, t, e) {
          var n, d;
          return o === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : o === "yAxis" ? { labels: { y: -2 }, opposite: e.opposite ?? t.opposite ?? !0, showLastLabel: !!(t.categories || t.type === "category"), title: { text: ((n = e.title) == null ? void 0 : n.text) !== "Values" ? (d = e.title) == null ? void 0 : d.text : null } } : {};
        }
        function p(o, t) {
          if (o === "xAxis") {
            let e = S(t.navigator && t.navigator.enabled, R.enabled, !0), n = { type: "datetime", categories: void 0 };
            return e && (n.startOnTick = !1, n.endOnTick = !1), n;
          }
          return {};
        }
        class C extends T {
          init(t, e) {
            let n = A(), d = t.xAxis, i = t.yAxis, g = S(t.navigator && t.navigator.enabled, R.enabled, !0);
            t.xAxis = t.yAxis = void 0;
            let m = x({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: g }, scrollbar: { enabled: S(O.enabled, !0) }, rangeSelector: { enabled: S(z.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: S(n.tooltip && n.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, t, { isStock: !0 });
            t.xAxis = d, t.yAxis = i, m.xAxis = E(t.xAxis || {}).map((k) => x(b("xAxis", k, n.xAxis), k, p("xAxis", t))), m.yAxis = E(t.yAxis || {}).map((k) => x(b("yAxis", k, n.yAxis), k)), super.init(m, e);
          }
          createAxis(t, e) {
            return e.axis = x(b(t, e.axis, A()[t]), e.axis, p(t, this.userOptions)), super.createAxis(t, e);
          }
        }
        return u(T, "update", function(o) {
          let t = o.options;
          "scrollbar" in t && this.navigator && (x(!0, this.options.scrollbar, t.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete t.scrollbar);
        }), function(o) {
          function t(j) {
            if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !h(this.min) || !h(this.max)) return;
            let P = this.chart, D = this.logarithmic, H = this.crosshair.label, G = this.horiz, V = this.opposite, F = this.left, U = this.top, Y = this.width, q = this.options.tickPosition === "inside", N = this.crosshair.snap !== !1, X = j.e || this.cross && this.cross.e, W = j.point, _ = this.crossLabel, K, J, $ = H.format, et = "", st, at = 0, lt = this.min, it = this.max;
            D && (lt = D.lin2log(this.min), it = D.lin2log(this.max));
            let Q = G ? "center" : V ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
            _ || (_ = this.crossLabel = P.renderer.label("", 0, void 0, H.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (W && W.series ? W.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: H.align || Q, padding: S(H.padding, 8), r: S(H.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), P.styledMode || _.attr({ fill: H.backgroundColor || W && W.series && W.series.color || "#666666", stroke: H.borderColor || "", "stroke-width": H.borderWidth || 0 }).css(f({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, H.style || {}))), G ? (K = N ? (W.plotX || 0) + F : X.chartX, J = U + (V ? 0 : this.height)) : (K = F + this.offset + (V ? Y : 0), J = N ? (W.plotY || 0) + U : X.chartY), $ || H.formatter || (this.dateTime && (et = "%b %d, %Y"), $ = "{value" + (et ? ":" + et : "") + "}");
            let ot = N ? this.isXAxis ? W.x : W.y : this.toValue(G ? X.chartX : X.chartY), nt = W && W.series ? W.series.isPointInside(W) : h(ot) && ot > lt && ot < it, ht = "";
            $ ? ht = w($, { value: ot }, P) : H.formatter && h(ot) && (ht = H.formatter.call(this, ot)), _.attr({ text: ht, x: K, y: J, visibility: nt ? "inherit" : "hidden" });
            let ct = _.getBBox();
            !h(_.x) || G || V || (K = _.x - ct.width / 2), h(_.y) && (G ? (q && !V || !q && V) && (J = _.y - ct.height) : J = _.y - ct.height / 2), st = G ? { left: F, right: F + this.width } : { left: this.labelAlign === "left" ? F : 0, right: this.labelAlign === "right" ? F + this.width : P.chartWidth };
            let dt = _.translateX || 0;
            dt < st.left && (at = st.left - dt), dt + ct.width >= st.right && (at = -(dt + ct.width - st.right)), _.attr({ x: K + at, y: J, anchorX: G ? K : this.opposite ? 0 : P.chartWidth, anchorY: G ? this.opposite ? P.chartHeight : 0 : J + ct.height / 2 });
          }
          function e() {
            this.crossLabel && (this.crossLabel = this.crossLabel.hide());
          }
          function n(j) {
            let P = this.chart, D = this.options, H = P._labelPanes = P._labelPanes || {}, G = D.labels;
            if (P.options.isStock && this.coll === "yAxis") {
              let V = D.top + "," + D.height;
              !H[V] && G.enabled && (G.distance === 15 && this.side === 1 && (G.distance = 0), G.align === void 0 && (G.align = "right"), H[V] = this, j.align = "right", j.preventDefault());
            }
          }
          function d() {
            let j = this.chart, P = this.options && this.options.top + "," + this.options.height;
            P && j._labelPanes && j._labelPanes[P] === this && delete j._labelPanes[P];
          }
          function i(j) {
            let P = this, D = P.isLinked && !P.series && P.linkedParent ? P.linkedParent.series : P.series, H = P.chart, G = H.renderer, V = P.left, F = P.top, U = [], Y = j.translatedValue, q = j.value, N = j.force, X, W, _, K, J = [], $, et;
            if (H.options.isStock && j.acrossPanes !== !1 && P.coll === "xAxis" || P.coll === "yAxis") {
              for (let st of (j.preventDefault(), J = ((at) => {
                let lt = at === "xAxis" ? "yAxis" : "xAxis", it = P.options[lt];
                return h(it) ? [H[lt][it]] : a(it) ? [H.get(it)] : D.map((Q) => Q[lt]);
              })(P.coll), P.isXAxis ? H.yAxis : H.xAxis)) if (!st.options.isInternal) {
                let at = st.isXAxis ? "yAxis" : "xAxis";
                P === (s(st.options[at]) ? H[at][st.options[at]] : H[at][0]) && J.push(st);
              }
              for (let st of ($ = J.length ? [] : [P.isXAxis ? H.yAxis[0] : H.xAxis[0]], J)) $.indexOf(st) !== -1 || y($, (at) => at.pos === st.pos && at.len === st.len) || $.push(st);
              if (h(et = S(Y, P.translate(q || 0, void 0, void 0, j.old))))
                if (P.horiz) for (let st of $) {
                  let at;
                  K = (W = st.pos) + st.len, X = _ = Math.round(et + P.transB), N !== "pass" && (X < V || X > V + P.width) && (N ? X = _ = c(X, V, V + P.width) : at = !0), at || U.push(["M", X, W], ["L", _, K]);
                }
                else for (let st of $) {
                  let at;
                  _ = (X = st.pos) + st.len, W = K = Math.round(F + P.height - et), N !== "pass" && (W < F || W > F + P.height) && (N ? W = K = c(W, F, F + P.height) : at = !0), at || U.push(["M", X, W], ["L", _, K]);
                }
              j.path = U.length > 0 ? G.crispPolyLine(U, j.lineWidth || 1) : void 0;
            }
          }
          function g(j) {
            if (this.chart.options.isStock) {
              let P;
              this.is("column") || this.is("columnrange") ? P = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (P = { marker: { enabled: !1, radius: 2 } }), P && (j.plotOptions[this.type] = x(j.plotOptions[this.type], P));
            }
          }
          function m() {
            let j = this.chart, P = this.options.dataGrouping;
            return this.allowDG !== !1 && P && S(P.enabled, j.options.isStock);
          }
          function k(j, P) {
            for (let D = 0; D < j.length; D += 2) {
              let H = j[D], G = j[D + 1];
              s(H[1]) && H[1] === G[1] && (H[1] = G[1] = v(H[1], P)), s(H[2]) && H[2] === G[2] && (H[2] = G[2] = v(H[2], P));
            }
            return j;
          }
          o.compose = function(j, P, D, H) {
            let G = D.prototype;
            G.forceCropping || (u(P, "afterDrawCrosshair", t), u(P, "afterHideCrosshair", e), u(P, "autoLabelAlign", n), u(P, "destroy", d), u(P, "getPlotLinePath", i), j.prototype.setFixedRange = l, G.forceCropping = m, u(D, "setOptions", g), H.prototype.crispPolyLine = k);
          }, o.stockChart = function(j, P, D) {
            return new o(j, P, D);
          };
        }(C), C;
      }), Z(r, "Series/HLC/HLCPoint.js", [r["Core/Series/SeriesRegistry.js"]], function(T) {
        let { column: { prototype: { pointClass: B } } } = T.seriesTypes;
        return class extends B {
        };
      }), Z(r, "Series/HLC/HLCSeriesDefaults.js", [], function() {
        return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
      }), Z(r, "Series/HLC/HLCSeries.js", [r["Series/HLC/HLCPoint.js"], r["Series/HLC/HLCSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { column: z } = I.seriesTypes, { crisp: O, extend: L, merge: M } = R;
        class w extends z {
          extendStem(l, u, c) {
            let v = l[0], s = l[1];
            typeof v[2] == "number" && (v[2] = Math.max(c + u, v[2])), typeof s[2] == "number" && (s[2] = Math.min(c - u, s[2]));
          }
          getPointPath(l, u) {
            let c = u.strokeWidth(), v = l.series, s = O(l.plotX || 0, c), f = Math.round(l.shapeArgs.width / 2), y = [["M", s, Math.round(l.yBottom)], ["L", s, Math.round(l.plotHigh)]];
            if (l.close !== null) {
              let h = O(l.plotClose, c);
              y.push(["M", s, h], ["L", s + f, h]), v.extendStem(y, c / 2, h);
            }
            return y;
          }
          drawSinglePoint(l) {
            let u = l.series, c = u.chart, v, s = l.graphic;
            l.plotY !== void 0 && (s || (l.graphic = s = c.renderer.path().add(u.group)), c.styledMode || s.attr(u.pointAttribs(l, l.selected && "select")), v = u.getPointPath(l, s), s[s ? "animate" : "attr"]({ d: v }).addClass(l.getClassName(), !0));
          }
          drawPoints() {
            this.points.forEach(this.drawSinglePoint);
          }
          init() {
            super.init.apply(this, arguments), this.options.stacking = void 0;
          }
          pointAttribs(l, u) {
            let c = super.pointAttribs.call(this, l, u);
            return delete c.fill, c;
          }
          toYData(l) {
            return [l.high, l.low, l.close];
          }
          translate() {
            let l = this, u = l.yAxis, c = this.pointArrayMap && this.pointArrayMap.slice() || [], v = c.map((s) => `plot${s.charAt(0).toUpperCase() + s.slice(1)}`);
            v.push("yBottom"), c.push("low"), super.translate.apply(l), l.points.forEach(function(s) {
              c.forEach(function(f, y) {
                let h = s[f];
                h !== null && (l.dataModify && (h = l.dataModify.modifyValue(h)), s[v[y]] = u.toPixels(h, !0));
              }), s.tooltipPos[1] = s.plotHigh + u.pos - l.chart.plotTop;
            });
          }
        }
        return w.defaultOptions = M(z.defaultOptions, B), L(w.prototype, { pointClass: T, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), I.registerSeriesType("hlc", w), w;
      }), Z(r, "Series/OHLC/OHLCPoint.js", [r["Core/Series/SeriesRegistry.js"]], function(T) {
        let { seriesTypes: { hlc: B } } = T;
        class I extends B.prototype.pointClass {
          getClassName() {
            return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
          }
          resolveUpColor() {
            this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
          }
          resolveColor() {
            super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
          }
          getZone() {
            let z = super.getZone();
            return this.resolveUpColor(), z;
          }
          applyOptions() {
            return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
          }
        }
        return I;
      }), Z(r, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
        return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
      }), Z(r, "Series/OHLC/OHLCSeries.js", [r["Core/Globals.js"], r["Series/OHLC/OHLCPoint.js"], r["Series/OHLC/OHLCSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { composed: O } = T, { hlc: L } = R.seriesTypes, { addEvent: M, crisp: w, extend: A, merge: l, pushUnique: u } = z;
        function c(f) {
          let y = f.options, h = y.dataGrouping;
          h && y.useOhlcData && y.id !== "highcharts-navigator-series" && (h.approximation = "ohlc");
        }
        function v(f) {
          let y = f.options;
          y.useOhlcData && y.id !== "highcharts-navigator-series" && A(this, { pointValKey: s.prototype.pointValKey, pointArrayMap: s.prototype.pointArrayMap, toYData: s.prototype.toYData });
        }
        class s extends L {
          static compose(y, ...h) {
            u(O, "OHLCSeries") && (M(y, "afterSetOptions", c), M(y, "init", v));
          }
          getPointPath(y, h) {
            let a = super.getPointPath(y, h), x = h.strokeWidth(), S = w(y.plotX || 0, x), E = Math.round(y.shapeArgs.width / 2);
            if (y.open !== null) {
              let b = w(y.plotOpen, x);
              a.push(["M", S, b], ["L", S - E, b]), super.extendStem(a, x / 2, b);
            }
            return a;
          }
          pointAttribs(y, h) {
            let a = super.pointAttribs.call(this, y, h), x = this.options;
            return delete a.fill, !y.options.color && x.upColor && y.open < y.close && (a.stroke = x.upColor), a;
          }
          toYData(y) {
            return [y.open, y.high, y.low, y.close];
          }
        }
        return s.defaultOptions = l(L.defaultOptions, I), A(s.prototype, { pointClass: B, pointArrayMap: ["open", "high", "low", "close"] }), R.registerSeriesType("ohlc", s), s;
      }), Z(r, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
        return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
      }), Z(r, "Series/Candlestick/CandlestickSeries.js", [r["Series/Candlestick/CandlestickSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { column: R, ohlc: z } = B.seriesTypes, { crisp: O, merge: L } = I;
        class M extends z {
          pointAttribs(A, l) {
            let u = R.prototype.pointAttribs.call(this, A, l), c = this.options, v = A.open < A.close, s = c.lineColor || this.color, f = A.color || this.color;
            if (u["stroke-width"] = c.lineWidth, u.fill = A.options.color || v && c.upColor || f, u.stroke = A.options.lineColor || v && c.upLineColor || s, l) {
              let y = c.states[l];
              u.fill = y.color || u.fill, u.stroke = y.lineColor || u.stroke, u["stroke-width"] = y.lineWidth || u["stroke-width"];
            }
            return u;
          }
          drawPoints() {
            let A = this.points, l = this.chart, u = this.yAxis.reversed;
            for (let c of A) {
              let v = c.graphic, s, f, y, h, a, x, S, E, b, p = !v;
              if (c.plotY !== void 0) {
                v || (c.graphic = v = l.renderer.path().add(this.group)), this.chart.styledMode || v.attr(this.pointAttribs(c, c.selected && "select")).shadow(this.options.shadow);
                let C = v.strokeWidth();
                S = O(c.plotX || 0, C), y = Math.min(s = c.plotOpen, f = c.plotClose), h = Math.max(s, f), b = Math.round(c.shapeArgs.width / 2), a = u ? h !== c.yBottom : Math.round(y) !== Math.round(c.plotHigh || 0), x = u ? Math.round(y) !== Math.round(c.plotHigh || 0) : h !== c.yBottom, y = O(y, C), h = O(h, C), (E = []).push(["M", S - b, h], ["L", S - b, y], ["L", S + b, y], ["L", S + b, h], ["Z"], ["M", S, y], ["L", S, a ? Math.round(u ? c.yBottom : c.plotHigh) : y], ["M", S, h], ["L", S, x ? Math.round(u ? c.plotHigh : c.yBottom) : h]), v[p ? "attr" : "animate"]({ d: E }).addClass(c.getClassName(), !0);
              }
            }
          }
        }
        return M.defaultOptions = L(z.defaultOptions, { tooltip: z.defaultOptions.tooltip }, T), B.registerSeriesType("candlestick", M), M;
      }), Z(r, "Series/Flags/FlagsPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { column: { prototype: { pointClass: I } } } = T.seriesTypes, { isNumber: R } = B;
        return class extends I {
          constructor() {
            super(...arguments), this.ttBelow = !1;
          }
          isValid() {
            return R(this.y) || this.y === void 0;
          }
          hasNewShapeType() {
            let z = this.options.shape || this.series.options.shape;
            return this.graphic && z && z !== this.graphic.symbolKey;
          }
        };
      }), Z(r, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
        return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
      }), Z(r, "Series/Flags/FlagsSymbols.js", [r["Core/Renderer/RendererRegistry.js"]], function(T) {
        var B;
        return function(I) {
          let R = [];
          function z(L, M, w, A, l) {
            let u = l && l.anchorX || L, c = l && l.anchorY || M, v = this.circle(u - 1, c - 1, 2, 2);
            return v.push(["M", u, c], ["L", L, M + A], ["L", L, M], ["L", L + w, M], ["L", L + w, M + A], ["L", L, M + A], ["Z"]), v;
          }
          function O(L, M) {
            L[M + "pin"] = function(w, A, l, u, c) {
              let v, s = c && c.anchorX, f = c && c.anchorY;
              if (M === "circle" && u > l && (w -= Math.round((u - l) / 2), l = u), v = L[M](w, A, l, u, c), s && f) {
                let y = s;
                if (M === "circle") y = w + l / 2;
                else {
                  let a = v[0], x = v[1];
                  a[0] === "M" && x[0] === "L" && (y = (a[1] + x[1]) / 2);
                }
                let h = A > f ? A : A + u;
                v.push(["M", y, h], ["L", s, f]), v = v.concat(L.circle(s - 1, f - 1, 2, 2));
              }
              return v;
            };
          }
          I.compose = function(L) {
            if (R.indexOf(L) === -1) {
              R.push(L);
              let w = L.prototype.symbols;
              w.flag = z, O(w, "circle"), O(w, "square");
            }
            let M = T.getRendererType();
            R.indexOf(M) && R.push(M);
          };
        }(B || (B = {})), B;
      }), Z(r, "Series/OnSeriesComposition.js", [r["Series/Column/ColumnSeries.js"], r["Core/Globals.js"], r["Core/Series/Series.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { composed: O } = B, { prototype: L } = T, { prototype: M } = I, { defined: w, pushUnique: A, stableSort: l } = R;
        return function(u) {
          function c(s) {
            return M.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, s);
          }
          function v() {
            var D, H;
            L.translate.apply(this);
            let s = this, f = s.options, y = s.chart, h = s.points, a = f.onSeries, x = a && y.get(a), S = x && x.options.step, E = x && x.points, b = y.inverted, p = s.xAxis, C = s.yAxis, o = h.length - 1, t, e, n = f.onKey || "y", d = E && E.length, i = 0, g, m, k, j, P;
            if (x && x.visible && d) {
              for (i = (x.pointXOffset || 0) + (x.barW || 0) / 2, j = x.currentDataGrouping, m = E[d - 1].x + (j ? j.totalRange : 0), l(h, (G, V) => G.x - V.x), n = "plot" + n[0].toUpperCase() + n.substr(1); d-- && h[o]; ) if (g = E[d], (t = h[o]).y = g.y, g.x <= t.x && g[n] !== void 0) {
                if (t.x <= m && (t.plotY = g[n], g.x < t.x && !S && (k = E[d + 1]) && k[n] !== void 0))
                  if (w(t.plotX) && x.is("spline")) {
                    let G = [g.plotX || 0, g.plotY || 0], V = [k.plotX || 0, k.plotY || 0], F = ((D = g.controlPoints) == null ? void 0 : D.high) || G, U = ((H = k.controlPoints) == null ? void 0 : H.low) || V, Y = (W, _) => Math.pow(1 - W, 3) * G[_] + 3 * (1 - W) * (1 - W) * W * F[_] + 3 * (1 - W) * W * W * U[_] + W * W * W * V[_], q = 0, N = 1, X;
                    for (let W = 0; W < 100; W++) {
                      let _ = (q + N) / 2, K = Y(_, 0);
                      if (K === null) break;
                      if (0.25 > Math.abs(K - t.plotX)) {
                        X = _;
                        break;
                      }
                      K < t.plotX ? q = _ : N = _;
                    }
                    w(X) && (t.plotY = Y(X, 1), t.y = C.toValue(t.plotY, !0));
                  } else P = (t.x - g.x) / (k.x - g.x), t.plotY += P * (k[n] - g[n]), t.y += P * (k.y - g.y);
                if (o--, d++, o < 0) break;
              }
            }
            h.forEach((G, V) => {
              let F;
              G.plotX += i, (G.plotY === void 0 || b) && (G.plotX >= 0 && G.plotX <= p.len ? b ? (G.plotY = p.translate(G.x, 0, 1, 0, 1), G.plotX = w(G.y) ? C.translate(G.y, 0, 0, 0, 1) : 0) : G.plotY = (p.opposite ? 0 : s.yAxis.len) + p.offset : G.shapeArgs = {}), (e = h[V - 1]) && e.plotX === G.plotX && (e.stackIndex === void 0 && (e.stackIndex = 0), F = e.stackIndex + 1), G.stackIndex = F;
            }), this.onSeries = x;
          }
          u.compose = function(s) {
            if (A(O, "OnSeries")) {
              let f = s.prototype;
              f.getPlotBox = c, f.translate = v;
            }
            return s;
          }, u.getPlotBox = c, u.translate = v;
        }(z || (z = {})), z;
      }), Z(r, "Series/Flags/FlagsSeries.js", [r["Series/Flags/FlagsPoint.js"], r["Series/Flags/FlagsSeriesDefaults.js"], r["Series/Flags/FlagsSymbols.js"], r["Core/Globals.js"], r["Series/OnSeriesComposition.js"], r["Core/Renderer/RendererUtilities.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w) {
        let { noop: A } = R, { distribute: l } = O, { series: u, seriesTypes: { column: c } } = L, { addEvent: v, defined: s, extend: f, isNumber: y, merge: h, objectEach: a, wrap: x } = w;
        class S extends c {
          animate(b) {
            b && this.setClip();
          }
          drawPoints() {
            let b, p, C, o, t, e, n, d, i, g, m, k = this.points, j = this.chart, P = j.renderer, D = j.inverted, H = this.options, G = H.y, V = this.yAxis, F = {}, U = [], Y = y(H.borderRadius) ? H.borderRadius : 0;
            for (o = k.length; o--; ) t = k[o], g = (D ? t.plotY : t.plotX) > this.xAxis.len, b = t.plotX, n = t.stackIndex, C = t.options.shape || H.shape, (p = t.plotY) !== void 0 && (p = t.plotY + G - (n !== void 0 && n * H.stackDistance)), t.anchorX = n ? void 0 : t.plotX, d = n ? void 0 : t.plotY, m = C !== "flag", e = t.graphic, p !== void 0 && b >= 0 && !g ? (e && t.hasNewShapeType() && (e = e.destroy()), e || (e = t.graphic = P.label("", 0, void 0, C, void 0, void 0, H.useHTML).addClass("highcharts-point").add(this.markerGroup), t.graphic.div && (t.graphic.div.point = t), e.isNew = !0), e.attr({ align: m ? "center" : "left", width: H.width, height: H.height, "text-align": H.textAlign, r: Y }), j.styledMode || e.attr(this.pointAttribs(t)).css(h(H.style, t.style)).shadow(H.shadow), b > 0 && (b -= e.strokeWidth() % 2), i = { y: p, anchorY: d }, H.allowOverlapX && (i.x = b, i.anchorX = t.anchorX), e.attr({ text: t.options.title ?? H.title ?? "A" })[e.isNew ? "attr" : "animate"](i), H.allowOverlapX || (F[t.plotX] ? F[t.plotX].size = Math.max(F[t.plotX].size, e.width || 0) : F[t.plotX] = { align: m ? 0.5 : 0, size: e.width || 0, target: b, anchorX: b }), t.tooltipPos = [b, p + V.pos - j.plotTop]) : e && (t.graphic = e.destroy());
            if (!H.allowOverlapX) {
              let q = 100;
              for (let N of (a(F, function(X) {
                X.plotX = X.anchorX, U.push(X), q = Math.max(X.size, q);
              }), l(U, D ? V.len : this.xAxis.len, q), k)) {
                let X = N.plotX, W = N.graphic, _ = W && F[X];
                _ && W && (s(_.pos) ? W[W.isNew ? "attr" : "animate"]({ x: _.pos + (_.align || 0) * _.size, anchorX: N.anchorX }).show().isNew = !1 : W.hide().isNew = !0);
              }
            }
            H.useHTML && this.markerGroup && x(this.markerGroup, "on", function(q) {
              return M.prototype.on.apply(q.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
            });
          }
          drawTracker() {
            let b = this.points;
            for (let p of (super.drawTracker(), b)) {
              let C = p.graphic;
              C && (p.unbindMouseOver && p.unbindMouseOver(), p.unbindMouseOver = v(C.element, "mouseover", function() {
                for (let o of (p.stackIndex > 0 && !p.raised && (p._y = C.y, C.attr({ y: p._y - 8 }), p.raised = !0), b)) o !== p && o.raised && o.graphic && (o.graphic.attr({ y: o._y }), o.raised = !1);
              }));
            }
          }
          pointAttribs(b, p) {
            let C = this.options, o = b && b.color || this.color, t = C.lineColor, e = b && b.lineWidth, n = b && b.fillColor || C.fillColor;
            return p && (n = C.states[p].fillColor, t = C.states[p].lineColor, e = C.states[p].lineWidth), { fill: n || o, stroke: t || o, "stroke-width": e || C.lineWidth || 0 };
          }
          setClip() {
            u.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
          }
        }
        return S.compose = I.compose, S.defaultOptions = h(c.defaultOptions, B), z.compose(S), f(S.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: T, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: A, init: u.prototype.init }), L.registerSeriesType("flags", S), S;
      }), Z(r, "Core/Axis/BrokenAxis.js", [r["Core/Axis/Stacking/StackItem.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { addEvent: R, find: z, fireEvent: O, isArray: L, isNumber: M, pick: w } = B;
        return function(A) {
          function l() {
            this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
          }
          function u() {
            var x;
            (x = this.brokenAxis) != null && x.hasBreaks && (this.options.ordinal = !1);
          }
          function c() {
            let x = this.brokenAxis;
            if (x != null && x.hasBreaks) {
              let S = this.tickPositions, E = this.tickPositions.info, b = [];
              for (let p = 0; p < S.length; p++) x.isInAnyBreak(S[p]) || b.push(S[p]);
              this.tickPositions = b, this.tickPositions.info = E;
            }
          }
          function v() {
            this.brokenAxis || (this.brokenAxis = new a(this));
          }
          function s() {
            var C, o;
            let { isDirty: x, options: { connectNulls: S }, points: E, xAxis: b, yAxis: p } = this;
            if (x) {
              let t = E.length;
              for (; t--; ) {
                let e = E[t], n = !(e.y === null && S === !1) && (((C = b == null ? void 0 : b.brokenAxis) == null ? void 0 : C.isInAnyBreak(e.x, !0)) || ((o = p == null ? void 0 : p.brokenAxis) == null ? void 0 : o.isInAnyBreak(e.y, !0)));
                e.visible = !n && e.options.visible !== !1;
              }
            }
          }
          function f() {
            this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, w(this.pointArrayMap, ["y"]));
          }
          function y(x, S) {
            var t;
            let E, b, p, C = this, o = C.points;
            if ((t = x == null ? void 0 : x.brokenAxis) != null && t.hasBreaks) {
              let e = x.brokenAxis;
              S.forEach(function(n) {
                var i, g;
                E = (e == null ? void 0 : e.breakArray) || [], b = x.isXAxis ? x.min : w(C.options.threshold, x.min);
                let d = (g = (i = x == null ? void 0 : x.options) == null ? void 0 : i.breaks) == null ? void 0 : g.filter(function(m) {
                  let k = !0;
                  for (let j = 0; j < E.length; j++) {
                    let P = E[j];
                    if (P.from === m.from && P.to === m.to) {
                      k = !1;
                      break;
                    }
                  }
                  return k;
                });
                o.forEach(function(m) {
                  p = w(m["stack" + n.toUpperCase()], m[n]), E.forEach(function(k) {
                    if (M(b) && M(p)) {
                      let j = "";
                      b < k.from && p > k.to || b > k.from && p < k.from ? j = "pointBreak" : (b < k.from && p > k.from && p < k.to || b > k.from && p > k.to && p < k.from) && (j = "pointInBreak"), j && O(x, j, { point: m, brk: k });
                    }
                  }), d == null || d.forEach(function(k) {
                    O(x, "pointOutsideOfBreak", { point: m, brk: k });
                  });
                });
              });
            }
          }
          function h() {
            let x = this.currentDataGrouping, S = x == null ? void 0 : x.gapSize, E = this.points.slice(), b = this.yAxis, p = this.options.gapSize, C = E.length - 1;
            if (p && C > 0) {
              let o, t;
              for (this.options.gapUnit !== "value" && (p *= this.basePointRange), S && S > p && S >= this.basePointRange && (p = S); C--; ) if (t && t.visible !== !1 || (t = E[C + 1]), o = E[C], t.visible !== !1 && o.visible !== !1) {
                if (t.x - o.x > p) {
                  let e = (o.x + t.x) / 2;
                  E.splice(C + 1, 0, { isNull: !0, x: e }), b.stacking && this.options.stacking && ((b.stacking.stacks[this.stackKey][e] = new T(b, b.options.stackLabels, !1, e, this.stack)).total = 0);
                }
                t = o;
              }
            }
            return this.getGraphPath(E);
          }
          A.compose = function(x, S) {
            if (!x.keepProps.includes("brokenAxis")) {
              x.keepProps.push("brokenAxis"), R(x, "init", v), R(x, "afterInit", l), R(x, "afterSetTickPositions", c), R(x, "afterSetOptions", u);
              let E = S.prototype;
              E.drawBreaks = y, E.gappedPath = h, R(S, "afterGeneratePoints", s), R(S, "afterRender", f);
            }
            return x;
          };
          class a {
            static isInBreak(S, E) {
              let b = S.repeat || 1 / 0, p = S.from, C = S.to - S.from, o = E >= p ? (E - p) % b : b - (p - E) % b;
              return S.inclusive ? o <= C : o < C && o !== 0;
            }
            static lin2Val(S) {
              let E = this.brokenAxis, b = E && E.breakArray;
              if (!b || !M(S)) return S;
              let p = S, C, o;
              for (o = 0; o < b.length && !((C = b[o]).from >= p); o++) (C.to < p || a.isInBreak(C, p)) && (p += C.len);
              return p;
            }
            static val2Lin(S) {
              let E = this.brokenAxis, b = E && E.breakArray;
              if (!b || !M(S)) return S;
              let p = S, C, o;
              for (o = 0; o < b.length; o++) if ((C = b[o]).to <= S) p -= C.len;
              else {
                if (C.from >= S) break;
                if (a.isInBreak(C, S)) {
                  p -= S - C.from;
                  break;
                }
              }
              return p;
            }
            constructor(S) {
              this.hasBreaks = !1, this.axis = S;
            }
            findBreakAt(S, E) {
              return z(E, function(b) {
                return b.from < S && S < b.to;
              });
            }
            isInAnyBreak(S, E) {
              let b = this.axis, p = b.options.breaks || [], C = p.length, o, t, e;
              if (C && M(S)) {
                for (; C--; ) a.isInBreak(p[C], S) && (o = !0, t || (t = w(p[C].showPoints, !b.isXAxis)));
                e = o && E ? o && !t : o;
              }
              return e;
            }
            setBreaks(S, E) {
              let b = this, p = b.axis, C = L(S) && !!S.length && !!Object.keys(S[0]).length;
              p.isDirty = b.hasBreaks !== C, b.hasBreaks = C, S !== p.options.breaks && (p.options.breaks = p.userOptions.breaks = S), p.forceRedraw = !0, p.series.forEach(function(o) {
                o.isDirty = !0;
              }), C || p.val2lin !== a.val2Lin || (delete p.val2lin, delete p.lin2val), C && (p.userOptions.ordinal = !1, p.lin2val = a.lin2Val, p.val2lin = a.val2Lin, p.setExtremes = function(o, t, e, n, d) {
                if (b.hasBreaks) {
                  let i, g = this.options.breaks || [];
                  for (; i = b.findBreakAt(o, g); ) o = i.to;
                  for (; i = b.findBreakAt(t, g); ) t = i.from;
                  t < o && (t = o);
                }
                p.constructor.prototype.setExtremes.call(this, o, t, e, n, d);
              }, p.setAxisTranslation = function() {
                if (p.constructor.prototype.setAxisTranslation.call(this), b.unitLength = void 0, b.hasBreaks) {
                  let o = p.options.breaks || [], t = [], e = [], n = w(p.pointRangePadding, 0), d = 0, i, g, m = p.userMin || p.min, k = p.userMax || p.max, j, P;
                  o.forEach(function(D) {
                    g = D.repeat || 1 / 0, M(m) && M(k) && (a.isInBreak(D, m) && (m += D.to % g - m % g), a.isInBreak(D, k) && (k -= k % g - D.from % g));
                  }), o.forEach(function(D) {
                    if (j = D.from, g = D.repeat || 1 / 0, M(m) && M(k)) {
                      for (; j - g > m; ) j -= g;
                      for (; j < m; ) j += g;
                      for (P = j; P < k; P += g) t.push({ value: P, move: "in" }), t.push({ value: P + D.to - D.from, move: "out", size: D.breakSize });
                    }
                  }), t.sort(function(D, H) {
                    return D.value === H.value ? (D.move === "in" ? 0 : 1) - (H.move === "in" ? 0 : 1) : D.value - H.value;
                  }), i = 0, j = m, t.forEach(function(D) {
                    (i += D.move === "in" ? 1 : -1) === 1 && D.move === "in" && (j = D.value), i === 0 && M(j) && (e.push({ from: j, to: D.value, len: D.value - j - (D.size || 0) }), d += D.value - j - (D.size || 0));
                  }), b.breakArray = e, M(m) && M(k) && M(p.min) && (b.unitLength = k - m - d + n, O(p, "afterBreaks"), p.staticScale ? p.transA = p.staticScale : b.unitLength && (p.transA *= (k - p.min + n) / b.unitLength), n && (p.minPixelPadding = p.transA * (p.minPointOffset || 0)), p.min = m, p.max = k);
                }
              }), w(E, !0) && p.chart.redraw();
            }
          }
          A.Additions = a;
        }(I || (I = {})), I;
      }), Z(r, "masters/modules/broken-axis.src.js", [r["Core/Globals.js"], r["Core/Axis/BrokenAxis.js"]], function(T, B) {
        return T.BrokenAxis = T.BrokenAxis || B, T.BrokenAxis.compose(T.Axis, T.Series), T;
      }), Z(r, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
        return {};
      }), Z(r, "Extensions/DataGrouping/ApproximationDefaults.js", [r["Extensions/DataGrouping/ApproximationRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { arrayMax: I, arrayMin: R, correctFloat: z, extend: O, isNumber: L } = B;
        function M(l) {
          let u = l.length, c = w(l);
          return L(c) && u && (c = z(c / u)), c;
        }
        function w(l) {
          let u = l.length, c;
          if (!u && l.hasNulls) c = null;
          else if (u) for (c = 0; u--; ) c += l[u];
          return c;
        }
        let A = { average: M, averages: function() {
          let l = [];
          return [].forEach.call(arguments, function(u) {
            l.push(M(u));
          }), l[0] === void 0 ? void 0 : l;
        }, close: function(l) {
          return l.length ? l[l.length - 1] : l.hasNulls ? null : void 0;
        }, high: function(l) {
          return l.length ? I(l) : l.hasNulls ? null : void 0;
        }, hlc: function(l, u, c) {
          if (l = T.high(l), u = T.low(u), c = T.close(c), L(l) || L(u) || L(c)) return [l, u, c];
        }, low: function(l) {
          return l.length ? R(l) : l.hasNulls ? null : void 0;
        }, ohlc: function(l, u, c, v) {
          if (l = T.open(l), u = T.high(u), c = T.low(c), v = T.close(v), L(l) || L(u) || L(c) || L(v)) return [l, u, c, v];
        }, open: function(l) {
          return l.length ? l[0] : l.hasNulls ? null : void 0;
        }, range: function(l, u) {
          return l = T.low(l), u = T.high(u), L(l) || L(u) ? [l, u] : l === null && u === null ? null : void 0;
        }, sum: w };
        return O(T, A), A;
      }), Z(r, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
        return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
      }), Z(r, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [r["Extensions/DataGrouping/DataGroupingDefaults.js"], r["Core/Utilities.js"]], function(T, B) {
        let I, { addEvent: R, extend: z, merge: O, pick: L } = B;
        function M(u) {
          let c = this, v = c.series;
          v.forEach(function(s) {
            s.groupPixelWidth = void 0;
          }), v.forEach(function(s) {
            s.groupPixelWidth = c.getGroupPixelWidth && c.getGroupPixelWidth(), s.groupPixelWidth && (s.hasProcessed = !0), s.applyGrouping(!!u.hasExtremesChanged);
          });
        }
        function w() {
          let u = this.series, c = u.length, v = 0, s = !1, f, y;
          for (; c--; ) (y = u[c].options.dataGrouping) && (v = Math.max(v, L(y.groupPixelWidth, T.common.groupPixelWidth)), f = (u[c].processedXData || u[c].data).length, (u[c].groupPixelWidth || f > this.chart.plotSizeX / v || f && y.forced) && (s = !0));
          return s ? v : 0;
        }
        function A() {
          this.series.forEach(function(u) {
            u.hasProcessed = !1;
          });
        }
        function l(u, c) {
          let v;
          if (c = L(c, !0), u || (u = { forced: !1, units: null }), this instanceof I) for (v = this.series.length; v--; ) this.series[v].update({ dataGrouping: u }, !1);
          else this.chart.options.series.forEach(function(s) {
            s.dataGrouping = typeof u == "boolean" ? u : O(u, s.dataGrouping);
          });
          this.ordinal && (this.ordinal.slope = void 0), c && this.chart.redraw();
        }
        return { compose: function(u) {
          I = u;
          let c = u.prototype;
          c.applyGrouping || (R(u, "afterSetScale", A), R(u, "postProcessData", M), z(c, { applyGrouping: M, getGroupPixelWidth: w, setDataGrouping: l }));
        } };
      }), Z(r, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [r["Extensions/DataGrouping/ApproximationRegistry.js"], r["Extensions/DataGrouping/DataGroupingDefaults.js"], r["Core/Axis/DateTimeAxis.js"], r["Core/Defaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { series: { prototype: L } } = z, { addEvent: M, defined: w, error: A, extend: l, isNumber: u, merge: c, pick: v } = O, s = L.generatePoints;
        function f(E) {
          var b;
          let p, C, o = this.chart, t = this.options.dataGrouping, e = this.allowDG !== !1 && t && v(t.enabled, o.options.isStock), n = this.reserveSpace(), d = this.currentDataGrouping, i, g, m = !1;
          e && !this.requireSorting && (this.requireSorting = m = !0);
          let k = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !E) || !e;
          if (m && (this.requireSorting = !1), k) return;
          this.destroyGroupedData();
          let j = t.groupAll ? this.xData : this.processedXData, P = t.groupAll ? this.yData : this.processedYData, D = o.plotSizeX, H = this.xAxis, G = H.options.ordinal, V = this.groupPixelWidth;
          if (V && j && j.length && D) {
            C = !0, this.isDirty = !0, this.points = null;
            let F = H.getExtremes(), U = F.min, Y = F.max, q = G && H.ordinal && H.ordinal.getGroupIntervalFactor(U, Y, this) || 1, N = V * (Y - U) / D * q, X = H.getTimeTicks(I.Additions.prototype.normalizeTimeTickInterval(N, t.units || B.units), Math.min(U, j[0]), Math.max(Y, j[j.length - 1]), H.options.startOfWeek, j, this.closestPointRange), W = L.groupData.apply(this, [j, P, X, t.approximation]), _ = W.groupedXData, K = W.groupedYData, J = 0;
            for (t && t.smoothed && _.length && (t.firstAnchor = "firstPoint", t.anchor = "middle", t.lastAnchor = "lastPoint", A(32, !1, o, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), p = 1; p < X.length; p++) X.info.segmentStarts && X.info.segmentStarts.indexOf(p) !== -1 || (J = Math.max(X[p] - X[p - 1], J));
            (i = X.info).gapSize = J, this.closestPointRange = X.info.totalRange, this.groupMap = W.groupMap, this.currentDataGrouping = i, function($, et, st) {
              let at = $.options.dataGrouping, lt = $.currentDataGrouping && $.currentDataGrouping.gapSize;
              if (!(at && $.xData && lt && $.groupMap)) return;
              let it = et.length - 1, Q = at.anchor, ot = at.firstAnchor, nt = at.lastAnchor, ht = et.length - 1, ct = 0;
              if (ot && $.xData[0] >= et[0]) {
                let dt;
                ct++;
                let ut = $.groupMap[0].start, pt = $.groupMap[0].length;
                u(ut) && u(pt) && (dt = ut + (pt - 1)), et[0] = { start: et[0], middle: et[0] + 0.5 * lt, end: et[0] + lt, firstPoint: $.xData[0], lastPoint: dt && $.xData[dt] }[ot];
              }
              if (it > 0 && nt && lt && et[it] >= st - lt) {
                ht--;
                let dt = $.groupMap[$.groupMap.length - 1].start;
                et[it] = { start: et[it], middle: et[it] + 0.5 * lt, end: et[it] + lt, firstPoint: dt && $.xData[dt], lastPoint: $.xData[$.xData.length - 1] }[nt];
              }
              if (Q && Q !== "start") {
                let dt = lt * { middle: 0.5, end: 1 }[Q];
                for (; ht >= ct; ) et[ht] += dt, ht--;
              }
            }(this, _, Y), n && (w((b = _)[0]) && u(H.min) && u(H.dataMin) && b[0] < H.min && ((!w(H.options.min) && H.min <= H.dataMin || H.min === H.dataMin) && (H.min = Math.min(b[0], H.min)), H.dataMin = Math.min(b[0], H.dataMin)), w(b[b.length - 1]) && u(H.max) && u(H.dataMax) && b[b.length - 1] > H.max && ((!w(H.options.max) && u(H.dataMax) && H.max >= H.dataMax || H.max === H.dataMax) && (H.max = Math.max(b[b.length - 1], H.max)), H.dataMax = Math.max(b[b.length - 1], H.dataMax))), t.groupAll && (this.allGroupedData = K, _ = (g = this.cropData(_, K, H.min, H.max)).xData, K = g.yData, this.cropStart = g.start), this.processedXData = _, this.processedYData = K;
          } else this.groupMap = null, this.currentDataGrouping = void 0;
          this.hasGroupedData = C, this.preventGraphAnimation = (d && d.totalRange) !== (i && i.totalRange);
        }
        function y() {
          this.groupedData && (this.groupedData.forEach(function(E, b) {
            E && (this.groupedData[b] = E.destroy ? E.destroy() : null);
          }, this), this.groupedData.length = 0, delete this.allGroupedData);
        }
        function h() {
          s.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
        }
        function a() {
          return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
        }
        function x(E, b, p, C) {
          let o = this, t = o.data, e = o.options && o.options.data, n = [], d = [], i = [], g = E.length, m = !!b, k = [], j = o.pointArrayMap, P = j && j.length, D = ["x"].concat(j || ["y"]), H = this.options.dataGrouping && this.options.dataGrouping.groupAll, G, V, F, U = 0, Y = 0, q = typeof C == "function" ? C : C && T[C] ? T[C] : T[o.getDGApproximation && o.getDGApproximation() || "average"];
          if (P) {
            let X = j.length;
            for (; X--; ) k.push([]);
          } else k.push([]);
          let N = P || 1;
          for (let X = 0; X <= g; X++) if (!(E[X] < p[0])) {
            for (; p[U + 1] !== void 0 && E[X] >= p[U + 1] || X === g; ) {
              G = p[U], o.dataGroupInfo = { start: H ? Y : o.cropStart + Y, length: k[0].length, groupStart: G }, F = q.apply(o, k), o.pointClass && !w(o.dataGroupInfo.options) && (o.dataGroupInfo.options = c(o.pointClass.prototype.optionsToObject.call({ series: o }, o.options.data[o.cropStart + Y])), D.forEach(function(W) {
                delete o.dataGroupInfo.options[W];
              })), F !== void 0 && (n.push(G), d.push(F), i.push(o.dataGroupInfo)), Y = X;
              for (let W = 0; W < N; W++) k[W].length = 0, k[W].hasNulls = !1;
              if (U += 1, X === g) break;
            }
            if (X === g) break;
            if (j) {
              let W, _ = o.options.dataGrouping && o.options.dataGrouping.groupAll ? X : o.cropStart + X, K = t && t[_] || o.pointClass.prototype.applyOptions.apply({ series: o }, [e[_]]);
              for (let J = 0; J < P; J++) u(W = K[j[J]]) ? k[J].push(W) : W === null && (k[J].hasNulls = !0);
            } else u(V = m ? b[X] : null) ? k[0].push(V) : V === null && (k[0].hasNulls = !0);
          }
          return { groupedXData: n, groupedYData: d, groupMap: i };
        }
        function S(E) {
          let b = E.options, p = this.type, C = this.chart.options.plotOptions, o = this.useCommonDataGrouping && B.common, t = B.seriesSpecific, e = R.defaultOptions.plotOptions[p].dataGrouping;
          if (C && (t[p] || o)) {
            let n = this.chart.rangeSelector;
            e || (e = c(B.common, t[p])), b.dataGrouping = c(o, e, C.series && C.series.dataGrouping, C[p].dataGrouping, this.userOptions.dataGrouping, !b.isInternal && n && u(n.selected) && n.buttonOptions[n.selected].dataGrouping);
          }
        }
        return { compose: function(E) {
          let b = E.prototype;
          b.applyGrouping || (M(E.prototype.pointClass, "update", function() {
            if (this.dataGroup) return A(24, !1, this.series.chart), !1;
          }), M(E, "afterSetOptions", S), M(E, "destroy", y), l(b, { applyGrouping: f, destroyGroupedData: y, generatePoints: h, getDGApproximation: a, groupData: x }));
        }, groupData: x };
      }), Z(r, "Extensions/DataGrouping/DataGrouping.js", [r["Extensions/DataGrouping/DataGroupingAxisComposition.js"], r["Extensions/DataGrouping/DataGroupingDefaults.js"], r["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { format: L } = R, { composed: M } = z, { addEvent: w, extend: A, isNumber: l, pick: u, pushUnique: c } = O;
        function v(s) {
          var g;
          let f = this.chart, y = f.time, h = s.labelConfig, a = h.series, x = h.point, S = a.options, E = a.tooltipOptions, b = S.dataGrouping, p = a.xAxis, C = E.xDateFormat, o, t, e, n, d, i = E[s.isFooter ? "footerFormat" : "headerFormat"];
          if (p && p.options.type === "datetime" && b && l(h.key)) {
            t = a.currentDataGrouping, e = b.dateTimeLabelFormats || B.common.dateTimeLabelFormats, t ? (n = e[t.unitName], t.count === 1 ? C = n[0] : (C = n[1], o = n[2])) : !C && e && p.dateTime && (C = p.dateTime.getXDateFormat(h.x, E.dateTimeLabelFormats));
            let m = u((g = a.groupMap) == null ? void 0 : g[x.index].groupStart, h.key), k = m + (t == null ? void 0 : t.totalRange) - 1;
            d = y.dateFormat(C, m), o && (d += y.dateFormat(o, k)), a.chart.styledMode && (i = this.styledModeFormat(i)), s.text = L(i, { point: A(h.point, { key: d }), series: a }, f), s.preventDefault();
          }
        }
        return { compose: function(s, f, y) {
          T.compose(s), I.compose(f), y && c(M, "DataGrouping") && w(y, "headerFormatter", v);
        }, groupData: I.groupData };
      }), Z(r, "masters/modules/datagrouping.src.js", [r["Core/Globals.js"], r["Extensions/DataGrouping/ApproximationDefaults.js"], r["Extensions/DataGrouping/ApproximationRegistry.js"], r["Extensions/DataGrouping/DataGrouping.js"]], function(T, B, I, R) {
        return T.dataGrouping = T.dataGrouping || {}, T.dataGrouping.approximationDefaults = T.dataGrouping.approximationDefaults || B, T.dataGrouping.approximations = T.dataGrouping.approximations || I, R.compose(T.Axis, T.Series, T.Tooltip), T;
      }), Z(r, "Extensions/Annotations/NavigationBindingsUtilities.js", [r["Core/Utilities.js"]], function(T) {
        let { defined: B, isNumber: I, pick: R } = T, z = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
        return { annotationsFieldsTypes: z, getAssignedAxis: function(O) {
          return O.filter((L) => {
            let M = L.axis.getExtremes(), w = M.min, A = M.max, l = R(L.axis.minPointOffset, 0);
            return I(w) && I(A) && L.value >= w - l && L.value <= A + l && !L.axis.options.isInternal;
          })[0];
        }, getFieldType: function(O, L) {
          let M = z[O], w = typeof L;
          return B(M) && (w = M), { string: "text", number: "number", boolean: "checkbox" }[w];
        } };
      }), Z(r, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [r["Core/Utilities.js"], r["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(T, B) {
        let I, { addEvent: R, isObject: z, pick: O, defined: L, merge: M } = T, { getAssignedAxis: w } = B, A = [], l = { enabled: !0, sensitivity: 1.1 }, u = (s) => (z(s) || (s = { enabled: s ?? !0 }), M(l, s)), c = function(s, f, y, h, a, x, S) {
          let E = O(S.type, s.zooming.type, ""), b = [];
          E === "x" ? b = y : E === "y" ? b = h : E === "xy" && (b = s.axes);
          let p = s.transform({ axes: b, to: { x: a - 5, y: x - 5, width: 10, height: 10 }, from: { x: a - 5 * f, y: x - 5 * f, width: 10 * f, height: 10 * f }, trigger: "mousewheel" });
          return p && (L(I) && clearTimeout(I), I = setTimeout(() => {
            var C;
            (C = s.pointer) == null || C.drop();
          }, 400)), p;
        };
        function v() {
          let s = u(this.zooming.mouseWheel);
          s.enabled && R(this.container, "wheel", (f) => {
            var a, x;
            f = ((a = this.pointer) == null ? void 0 : a.normalize(f)) || f;
            let { pointer: y } = this, h = y && !y.inClass(f.target, "highcharts-no-mousewheel");
            if (this.isInsidePlot(f.chartX - this.plotLeft, f.chartY - this.plotTop) && h) {
              let S = s.sensitivity || 1.1, E = f.detail || (f.deltaY || 0) / 120, b = w(y.getCoordinates(f).xAxis), p = w(y.getCoordinates(f).yAxis);
              c(this, Math.pow(S, E), b ? [b.axis] : this.xAxis, p ? [p.axis] : this.yAxis, f.chartX, f.chartY, s) && ((x = f.preventDefault) == null || x.call(f));
            }
          });
        }
        return { compose: function(s) {
          A.indexOf(s) === -1 && (A.push(s), R(s, "afterGetContainer", v));
        } };
      }), Z(r, "masters/modules/mouse-wheel-zoom.src.js", [r["Core/Globals.js"], r["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(T, B) {
        return T.MouseWheelZoom = T.MouseWheelZoom || B, T.MouseWheelZoom.compose(T.Chart), T;
      }), Z(r, "masters/modules/stock.src.js", [r["Core/Globals.js"], r["Series/DataModifyComposition.js"], r["Stock/Navigator/Navigator.js"], r["Core/Axis/OrdinalAxis.js"], r["Stock/RangeSelector/RangeSelector.js"], r["Stock/Scrollbar/Scrollbar.js"], r["Core/Chart/StockChart.js"], r["Series/OHLC/OHLCSeries.js"], r["Series/Flags/FlagsSeries.js"]], function(T, B, I, R, z, O, L, M, w) {
        return T.Navigator = T.Navigator || I, T.OrdinalAxis = T.OrdinalAxis || R, T.RangeSelector = T.RangeSelector || z, T.Scrollbar = T.Scrollbar || O, T.stockChart = T.stockChart || L.stockChart, T.StockChart = T.StockChart || T.stockChart, T.extend(T.StockChart, L), B.compose(T.Series, T.Axis, T.Point), w.compose(T.Renderer), M.compose(T.Series), T.Navigator.compose(T.Chart, T.Axis, T.Series), T.OrdinalAxis.compose(T.Axis, T.Series, T.Chart), T.RangeSelector.compose(T.Axis, T.Chart), T.Scrollbar.compose(T.Axis), T.StockChart.compose(T.Chart, T.Axis, T.Series, T.SVGRenderer), T;
      });
    });
  }(Ee)), Ee.exports;
}
var jl = Ol();
const Dl = /* @__PURE__ */ It(jl);
var Le = { exports: {} }, Ws;
function Il() {
  return Ws || (Ws = 1, function(rt) {
    /**
    * Highcharts JS v11.4.8 (2024-08-29)
    *
    * Item series type for Highcharts
    *
    * (c) 2019 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Series/Item/ItemPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { series: { prototype: { pointClass: I } }, seriesTypes: { pie: { prototype: { pointClass: R } } } } = T, { extend: z } = B;
        class O extends R {
        }
        return z(O.prototype, { haloPath: I.prototype.haloPath }), O;
      }), Z(r, "Series/Item/ItemSeriesDefaults.js", [r["Core/Series/SeriesDefaults.js"], r["Core/Utilities.js"]], function(T, B) {
        let { merge: I } = B;
        return { endAngle: void 0, innerSize: "40%", itemPadding: 0.1, layout: "vertical", marker: I(T.marker, { radius: null }), rows: void 0, crisp: !1, showInLegend: !0, startAngle: void 0 };
      }), Z(r, "Series/Item/ItemSeries.js", [r["Series/Item/ItemPoint.js"], r["Series/Item/ItemSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { pie: z } = I.seriesTypes, { defined: O, extend: L, fireEvent: M, isNumber: w, merge: A, pick: l } = R;
        class u extends z {
          animate(v) {
            let s = this.group;
            s && (v ? s.attr({ opacity: 0 }) : s.animate({ opacity: 1 }, this.options.animation));
          }
          drawDataLabels() {
            if (this.center && this.slots) super.drawDataLabels();
            else for (let v of this.points) v.destroyElements({ dataLabel: 1 });
          }
          drawPoints() {
            let v = this.options, s = this.chart.renderer, f = v.marker, y = this.borderWidth % 2 ? 0.5 : 1, h = this.getRows(), a = Math.ceil(this.total / h), x = this.chart.plotWidth / a, S = this.chart.plotHeight / h, E = this.itemSize || Math.min(x, S), b = 0;
            for (let p of this.points) {
              let C, o, t, e, n, d, i = p.marker || {}, g = i.symbol || f.symbol, m = l(i.radius, f.radius), k = O(m) ? 2 * m : E, j = k * v.itemPadding;
              if (p.graphics = o = p.graphics || [], this.chart.styledMode || (t = this.pointAttribs(p, p.selected && "select")), !p.isNull && p.visible) {
                p.graphic || (p.graphic = s.g("point").add(this.group));
                for (let P = 0; P < (p.y || 0); ++P) {
                  if (this.center && this.slots) {
                    let H = this.slots.shift();
                    e = H.x - E / 2, n = H.y - E / 2;
                  } else v.layout === "horizontal" ? (e = b % a * x, n = S * Math.floor(b / a)) : (e = x * Math.floor(b / h), n = b % h * S);
                  e += j, n += j, d = Math.round(k - 2 * j), this.options.crisp && (e = Math.round(e) - y, n = Math.round(n) + y), C = { x: e, y: n, width: d, height: d }, m !== void 0 && (C.r = m), t && L(C, t);
                  let D = o[P];
                  D ? D.animate(C) : D = s.symbol(g, void 0, void 0, void 0, void 0, { backgroundSize: "within" }).attr(C).add(p.graphic), D.isActive = !0, o[P] = D, ++b;
                }
              }
              for (let P = 0; P < o.length; P++) {
                let D = o[P];
                if (!D) return;
                D.isActive ? D.isActive = !1 : (D.destroy(), o.splice(P, 1), P--);
              }
            }
          }
          getRows() {
            let v = this.chart, s = this.total || 0, f = this.options.rows, y;
            if (!f)
              if (y = v.plotWidth / v.plotHeight, f = Math.sqrt(s), y > 1) for (f = Math.ceil(f); f > 0 && !(s / f / f > y); ) f--;
              else for (f = Math.floor(f); f < s && !(s / f / f < y); ) f++;
            return f;
          }
          getSlots() {
            let v = this.center, s = v[2], f = this.slots = this.slots || [], y = this.endAngleRad - this.startAngleRad, h = this.options.rows, a = y % (2 * Math.PI) == 0, x = this.total || 0, S = v[3], E, b, p, C, o, t, e, n, d = 0, i, g = Number.MAX_VALUE, m, k, j, P = (s - S) / s;
            for (; g > x + (k && a ? k.length : 0); ) {
              m = g, f.length = 0, g = 0, k = j, j = [], i = s / ++d / 2, h ? (S = (i - h) / i * s) >= 0 ? i = h : (S = 0, P = 1) : i = Math.floor(i * P);
              for (let G = i; G > 0; G--) o = Math.ceil((C = y * (p = (S + G / i * (s - S - d)) / 2)) / d), j.push({ rowRadius: p, rowLength: C, colCount: o }), g += o + 1;
            }
            if (!k) return;
            let D = m - this.total - (a ? k.length : 0), H = (G) => {
              D > 0 && (G.row.colCount--, D--);
            };
            for (; D > 0; ) k.map((G) => ({ angle: G.colCount / G.rowLength, row: G })).sort((G, V) => V.angle - G.angle).slice(0, Math.min(D, Math.ceil(k.length / 2))).forEach(H);
            for (let G of k) {
              let V = G.rowRadius, F = G.colCount;
              for (n = 0, t = F ? y / F : 0; n <= F; n += 1) e = this.startAngleRad + n * t, E = v[0] + Math.cos(e) * V, b = v[1] + Math.sin(e) * V, f.push({ x: E, y: b, angle: e });
            }
            return f.sort((G, V) => G.angle - V.angle), this.itemSize = d, f;
          }
          translate(v) {
            this.total === 0 && w(this.options.startAngle) && w(this.options.endAngle) && (this.center = this.getCenter()), this.slots || (this.slots = []), w(this.options.startAngle) && w(this.options.endAngle) ? (super.translate(v), this.slots = this.getSlots()) : (this.generatePoints(), M(this, "afterTranslate"));
          }
        }
        return u.defaultOptions = A(z.defaultOptions, B), L(u.prototype, { markerAttribs: void 0, pointClass: T }), I.registerSeriesType("item", u), u;
      }), Z(r, "masters/modules/item-series.src.js", [r["Core/Globals.js"]], function(T) {
        return T;
      });
    });
  }(Le)), Le.exports;
}
var Bl = Il();
const Rl = /* @__PURE__ */ It(Bl);
var Oe = { exports: {} }, Vs;
function Nl() {
  return Vs || (Vs = 1, function(rt) {
    /**
    * Highmaps JS v11.4.8 (2024-08-29)
    *
    * Highmaps as a plugin for Highcharts or Highcharts Stock.
    *
    * (c) 2011-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Core/Axis/Color/ColorAxisComposition.js", [r["Core/Color/Color.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { parse: R } = T, { addEvent: z, extend: O, merge: L, pick: M, splat: w } = B;
        return function(A) {
          let l;
          function u() {
            let { userOptions: E } = this;
            this.colorAxis = [], E.colorAxis && (E.colorAxis = w(E.colorAxis), E.colorAxis.map((b) => new l(this, b)));
          }
          function c(E) {
            let b = this.chart.colorAxis || [], p = (e) => {
              let n = E.allItems.indexOf(e);
              n !== -1 && (this.destroyItem(E.allItems[n]), E.allItems.splice(n, 1));
            }, C = [], o, t;
            for (b.forEach(function(e) {
              (o = e.options) && o.showInLegend && (o.dataClasses && o.visible ? C = C.concat(e.getDataClassLegendSymbols()) : o.visible && C.push(e), e.series.forEach(function(n) {
                (!n.options.showInLegend || o.dataClasses) && (n.options.legendType === "point" ? n.points.forEach(function(d) {
                  p(d);
                }) : p(n));
              }));
            }), t = C.length; t--; ) E.allItems.unshift(C[t]);
          }
          function v(E) {
            E.visible && E.item.legendColor && E.item.legendItem.symbol.attr({ fill: E.item.legendColor });
          }
          function s(E) {
            var b;
            (b = this.chart.colorAxis) == null || b.forEach((p) => {
              p.update({}, E.redraw);
            });
          }
          function f() {
            (this.chart.colorAxis && this.chart.colorAxis.length || this.colorAttribs) && this.translateColors();
          }
          function y() {
            let E = this.axisTypes;
            E ? E.indexOf("colorAxis") === -1 && E.push("colorAxis") : this.axisTypes = ["colorAxis"];
          }
          function h(E) {
            let b = this, p = E ? "show" : "hide";
            b.visible = b.options.visible = !!E, ["graphic", "dataLabel"].forEach(function(C) {
              b[C] && b[C][p]();
            }), this.series.buildKDTree();
          }
          function a() {
            let E = this, b = this.getPointsCollection(), p = this.options.nullColor, C = this.colorAxis, o = this.colorKey;
            b.forEach((t) => {
              let e = t.getNestedProperty(o), n = t.options.color || (t.isNull || t.value === null ? p : C && e !== void 0 ? C.toColor(e, t) : t.color || E.color);
              n && t.color !== n && (t.color = n, E.options.legendType === "point" && t.legendItem && t.legendItem.label && E.chart.legend.colorizeItem(t, t.visible));
            });
          }
          function x() {
            this.elem.attr("fill", R(this.start).tweenTo(R(this.end), this.pos), void 0, !0);
          }
          function S() {
            this.elem.attr("stroke", R(this.start).tweenTo(R(this.end), this.pos), void 0, !0);
          }
          A.compose = function(E, b, p, C, o) {
            let t = b.prototype, e = p.prototype, n = o.prototype;
            t.collectionsWithUpdate.includes("colorAxis") || (l = E, t.collectionsWithUpdate.push("colorAxis"), t.collectionsWithInit.colorAxis = [t.addColorAxis], z(b, "afterGetAxes", u), function(d) {
              let i = d.prototype.createAxis;
              d.prototype.createAxis = function(g, m) {
                if (g !== "colorAxis") return i.apply(this, arguments);
                let k = new l(this, L(m.axis, { index: this[g].length, isX: !1 }));
                return this.isDirtyLegend = !0, this.axes.forEach((j) => {
                  j.series = [];
                }), this.series.forEach((j) => {
                  j.bindAxes(), j.isDirtyData = !0;
                }), M(m.redraw, !0) && this.redraw(m.animation), k;
              };
            }(b), e.fillSetter = x, e.strokeSetter = S, z(C, "afterGetAllItems", c), z(C, "afterColorizeItem", v), z(C, "afterUpdate", s), O(n, { optionalAxis: "colorAxis", translateColors: a }), O(n.pointClass.prototype, { setVisible: h }), z(o, "afterTranslate", f, { order: 1 }), z(o, "bindAxes", y));
          }, A.pointSetVisible = h;
        }(I || (I = {})), I;
      }), Z(r, "Core/Axis/Color/ColorAxisDefaults.js", [], function() {
        return { lineWidth: 0, minPadding: 0, maxPadding: 0, gridLineColor: "#ffffff", gridLineWidth: 1, tickPixelInterval: 72, startOnTick: !0, endOnTick: !0, offset: 0, marker: { animation: { duration: 50 }, width: 0.01, color: "#999999" }, labels: { distance: 8, overflow: "justify", rotation: 0 }, minColor: "#e6e9ff", maxColor: "#0022ff", tickLength: 5, showInLegend: !0 };
      }), Z(r, "Core/Axis/Color/ColorAxisLike.js", [r["Core/Color/Color.js"], r["Core/Utilities.js"]], function(T, B) {
        var I, R;
        let { parse: z } = T, { merge: O } = B;
        return (R = I || (I = {})).initDataClasses = function(L) {
          let M = this.chart, w = this.legendItem = this.legendItem || {}, A = this.options, l = L.dataClasses || [], u, c, v = M.options.chart.colorCount, s = 0, f;
          this.dataClasses = c = [], w.labels = [];
          for (let y = 0, h = l.length; y < h; ++y) u = O(u = l[y]), c.push(u), (M.styledMode || !u.color) && (A.dataClassColor === "category" ? (M.styledMode || (v = (f = M.options.colors || []).length, u.color = f[s]), u.colorIndex = s, ++s === v && (s = 0)) : u.color = z(A.minColor).tweenTo(z(A.maxColor), h < 2 ? 0.5 : y / (h - 1)));
        }, R.initStops = function() {
          let L = this.options, M = this.stops = L.stops || [[0, L.minColor || ""], [1, L.maxColor || ""]];
          for (let w = 0, A = M.length; w < A; ++w) M[w].color = z(M[w][1]);
        }, R.normalizedValue = function(L) {
          let M = this.max || 0, w = this.min || 0;
          return this.logarithmic && (L = this.logarithmic.log2lin(L)), 1 - (M - L) / (M - w || 1);
        }, R.toColor = function(L, M) {
          let w, A, l, u, c, v, s = this.dataClasses, f = this.stops;
          if (s) {
            for (v = s.length; v--; ) if (A = (c = s[v]).from, l = c.to, (A === void 0 || L >= A) && (l === void 0 || L <= l)) {
              u = c.color, M && (M.dataClass = v, M.colorIndex = c.colorIndex);
              break;
            }
          } else {
            for (w = this.normalizedValue(L), v = f.length; v-- && !(w > f[v][0]); ) ;
            A = f[v] || f[v + 1], w = 1 - ((l = f[v + 1] || A)[0] - w) / (l[0] - A[0] || 1), u = A.color.tweenTo(l.color, w);
          }
          return u;
        }, I;
      }), Z(r, "Core/Axis/Color/ColorAxis.js", [r["Core/Axis/Axis.js"], r["Core/Axis/Color/ColorAxisComposition.js"], r["Core/Axis/Color/ColorAxisDefaults.js"], r["Core/Axis/Color/ColorAxisLike.js"], r["Core/Defaults.js"], r["Core/Legend/LegendSymbol.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { defaultOptions: w } = z, { series: A } = L, { defined: l, extend: u, fireEvent: c, isArray: v, isNumber: s, merge: f, pick: y, relativeLength: h } = M;
        w.colorAxis = f(w.xAxis, I);
        class a extends T {
          static compose(S, E, b, p) {
            B.compose(a, S, E, b, p);
          }
          constructor(S, E) {
            super(S, E), this.coll = "colorAxis", this.visible = !0, this.init(S, E);
          }
          init(S, E) {
            let b = S.options.legend || {}, p = E.layout ? E.layout !== "vertical" : b.layout !== "vertical";
            this.side = E.side || p ? 2 : 1, this.reversed = E.reversed || !p, this.opposite = !p, super.init(S, E, "colorAxis"), this.userOptions = E, v(S.userOptions.colorAxis) && (S.userOptions.colorAxis[this.index] = E), E.dataClasses && this.initDataClasses(E), this.initStops(), this.horiz = p, this.zoomEnabled = !1;
          }
          hasData() {
            return !!(this.tickPositions || []).length;
          }
          setTickPositions() {
            if (!this.dataClasses) return super.setTickPositions();
          }
          setOptions(S) {
            let E = f(w.colorAxis, S, { showEmpty: !1, title: null, visible: this.chart.options.legend.enabled && S.visible !== !1 });
            super.setOptions(E), this.options.crosshair = this.options.marker;
          }
          setAxisSize() {
            var C;
            let S = this.chart, E = (C = this.legendItem) == null ? void 0 : C.symbol, { width: b, height: p } = this.getSize();
            E && (this.left = +E.attr("x"), this.top = +E.attr("y"), this.width = b = +E.attr("width"), this.height = p = +E.attr("height"), this.right = S.chartWidth - this.left - b, this.bottom = S.chartHeight - this.top - p, this.pos = this.horiz ? this.left : this.top), this.len = (this.horiz ? b : p) || a.defaultLegendLength;
          }
          getOffset() {
            var b;
            let S = (b = this.legendItem) == null ? void 0 : b.group, E = this.chart.axisOffset[this.side];
            if (S) {
              this.axisParent = S, super.getOffset();
              let p = this.chart.legend;
              p.allItems.forEach(function(C) {
                C instanceof a && C.drawLegendSymbol(p, C);
              }), p.render(), this.chart.getMargins(!0), this.chart.series.some((C) => C.isDrilling) || (this.isDirty = !0), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = E;
            }
          }
          setLegendColor() {
            let S = this.horiz, E = this.reversed, b = E ? 1 : 0, p = E ? 0 : 1, C = S ? [b, 0, p, 0] : [0, p, 0, b];
            this.legendColor = { linearGradient: { x1: C[0], y1: C[1], x2: C[2], y2: C[3] }, stops: this.stops };
          }
          drawLegendSymbol(S, E) {
            let b = E.legendItem || {}, p = S.padding, C = S.options, o = this.options.labels, t = y(C.itemDistance, 10), e = this.horiz, { width: n, height: d } = this.getSize(), i = y(C.labelPadding, e ? 16 : 30);
            this.setLegendColor(), b.symbol || (b.symbol = this.chart.renderer.symbol("roundedRect").attr({ r: C.symbolRadius ?? 3, zIndex: 1 }).add(b.group)), b.symbol.attr({ x: 0, y: (S.baseline || 0) - 11, width: n, height: d }), b.labelWidth = n + p + (e ? t : y(o.x, o.distance) + (this.maxLabelLength || 0)), b.labelHeight = d + p + (e ? i : 0);
          }
          setState(S) {
            this.series.forEach(function(E) {
              E.setState(S);
            });
          }
          setVisible() {
          }
          getSeriesExtremes() {
            let S = this.series, E, b, p, C, o, t, e = S.length, n, d;
            for (this.dataMin = 1 / 0, this.dataMax = -1 / 0; e--; ) {
              if (b = (t = S[e]).colorKey = y(t.options.colorKey, t.colorKey, t.pointValKey, t.zoneAxis, "y"), C = t.pointArrayMap, o = t[b + "Min"] && t[b + "Max"], t[b + "Data"]) E = t[b + "Data"];
              else if (C) {
                if (E = [], p = C.indexOf(b), n = t.yData, p >= 0 && n) for (d = 0; d < n.length; d++) E.push(y(n[d][p], n[d]));
              } else E = t.yData;
              if (o) t.minColorValue = t[b + "Min"], t.maxColorValue = t[b + "Max"];
              else {
                let i = A.prototype.getExtremes.call(t, E);
                t.minColorValue = i.dataMin, t.maxColorValue = i.dataMax;
              }
              l(t.minColorValue) && l(t.maxColorValue) && (this.dataMin = Math.min(this.dataMin, t.minColorValue), this.dataMax = Math.max(this.dataMax, t.maxColorValue)), o || A.prototype.applyExtremes.call(t);
            }
          }
          drawCrosshair(S, E) {
            let b, p = this.legendItem || {}, C = E && E.plotX, o = E && E.plotY, t = this.pos, e = this.len;
            E && ((b = this.toPixels(E.getNestedProperty(E.series.colorKey))) < t ? b = t - 2 : b > t + e && (b = t + e + 2), E.plotX = b, E.plotY = this.len - b, super.drawCrosshair(S, E), E.plotX = C, E.plotY = o, this.cross && !this.cross.addedToColorAxis && p.group && (this.cross.addClass("highcharts-coloraxis-marker").add(p.group), this.cross.addedToColorAxis = !0, this.chart.styledMode || typeof this.crosshair != "object" || this.cross.attr({ fill: this.crosshair.color })));
          }
          getPlotLinePath(S) {
            let E = this.left, b = S.translatedValue, p = this.top;
            return s(b) ? this.horiz ? [["M", b - 4, p - 6], ["L", b + 4, p - 6], ["L", b, p], ["Z"]] : [["M", E, b], ["L", E - 6, b + 6], ["L", E - 6, b - 6], ["Z"]] : super.getPlotLinePath(S);
          }
          update(S, E) {
            let b = this.chart.legend;
            this.series.forEach((p) => {
              p.isDirtyData = !0;
            }), (S.dataClasses && b.allItems || this.dataClasses) && this.destroyItems(), super.update(S, E), this.legendItem && this.legendItem.label && (this.setLegendColor(), b.colorizeItem(this, !0));
          }
          destroyItems() {
            let S = this.chart, E = this.legendItem || {};
            if (E.label) S.legend.destroyItem(this);
            else if (E.labels) for (let b of E.labels) S.legend.destroyItem(b);
            S.isDirtyLegend = !0;
          }
          destroy() {
            this.chart.isDirtyLegend = !0, this.destroyItems(), super.destroy(...[].slice.call(arguments));
          }
          remove(S) {
            this.destroyItems(), super.remove(S);
          }
          getDataClassLegendSymbols() {
            let S, E = this, b = E.chart, p = E.legendItem && E.legendItem.labels || [], C = b.options.legend, o = y(C.valueDecimals, -1), t = y(C.valueSuffix, ""), e = (n) => E.series.reduce((d, i) => (d.push(...i.points.filter((g) => g.dataClass === n)), d), []);
            return p.length || E.dataClasses.forEach((n, d) => {
              let i = n.from, g = n.to, { numberFormatter: m } = b, k = !0;
              S = "", i === void 0 ? S = "< " : g === void 0 && (S = "> "), i !== void 0 && (S += m(i, o) + t), i !== void 0 && g !== void 0 && (S += " - "), g !== void 0 && (S += m(g, o) + t), p.push(u({ chart: b, name: S, options: {}, drawLegendSymbol: O.rectangle, visible: !0, isDataClass: !0, setState: (j) => {
                for (let P of e(d)) P.setState(j);
              }, setVisible: function() {
                this.visible = k = E.visible = !k;
                let j = [];
                for (let P of e(d)) P.setVisible(k), P.hiddenInDataClass = !k, j.indexOf(P.series) === -1 && j.push(P.series);
                b.legend.colorizeItem(this, k), j.forEach((P) => {
                  c(P, "afterDataClassLegendClick");
                });
              } }, n));
            }), p;
          }
          getSize() {
            let { chart: S, horiz: E } = this, { height: b, width: p } = this.options, { legend: C } = S.options;
            return { width: y(l(p) ? h(p, S.chartWidth) : void 0, C == null ? void 0 : C.symbolWidth, E ? a.defaultLegendLength : 12), height: y(l(b) ? h(b, S.chartHeight) : void 0, C == null ? void 0 : C.symbolHeight, E ? 12 : a.defaultLegendLength) };
          }
        }
        return a.defaultLegendLength = 200, a.keepProps = ["legendItem"], u(a.prototype, R), Array.prototype.push.apply(T.keepProps, a.keepProps), a;
      }), Z(r, "masters/modules/coloraxis.src.js", [r["Core/Globals.js"], r["Core/Axis/Color/ColorAxis.js"]], function(T, B) {
        return T.ColorAxis = T.ColorAxis || B, T.ColorAxis.compose(T.Chart, T.Fx, T.Legend, T.Series), T;
      }), Z(r, "Maps/MapNavigationDefaults.js", [], function() {
        return { lang: { zoomIn: "Zoom in", zoomOut: "Zoom out" }, mapNavigation: { buttonOptions: { alignTo: "plotBox", align: "left", verticalAlign: "top", x: 0, width: 18, height: 18, padding: 5, style: { color: "#666666", fontSize: "1em", fontWeight: "bold" }, theme: { fill: "#ffffff", stroke: "#e6e6e6", "stroke-width": 1, "text-align": "center" } }, buttons: { zoomIn: { onclick: function() {
          this.mapZoom(0.5);
        }, text: "+", y: 0 }, zoomOut: { onclick: function() {
          this.mapZoom(2);
        }, text: "-", y: 28 } }, mouseWheelSensitivity: 1.1 } };
      }), Z(r, "Maps/MapPointer.js", [r["Core/Utilities.js"]], function(T) {
        var B;
        let { defined: I, extend: R, pick: z, wrap: O } = T;
        return function(L) {
          let M, w = 0;
          function A(v) {
            let s = this.chart;
            v = this.normalize(v), s.options.mapNavigation.enableDoubleClickZoomTo ? s.pointer.inClass(v.target, "highcharts-tracker") && s.hoverPoint && s.hoverPoint.zoomTo() : s.isInsidePlot(v.chartX - s.plotLeft, v.chartY - s.plotTop) && s.mapZoom(0.5, void 0, void 0, v.chartX, v.chartY);
          }
          function l(v) {
            let s = this.chart, f = I((v = this.normalize(v)).wheelDelta) && -v.wheelDelta / 120 || v.deltaY || v.detail;
            Math.abs(f) >= 1 && (w += Math.abs(f), M && clearTimeout(M), M = setTimeout(() => {
              w = 0;
            }, 50)), w < 10 && s.isInsidePlot(v.chartX - s.plotLeft, v.chartY - s.plotTop) && s.mapView && s.mapView.zoomBy(-((s.options.mapNavigation.mouseWheelSensitivity - 1) * f), void 0, [v.chartX, v.chartY], !(1 > Math.abs(f)) && void 0);
          }
          function u(v, s, f) {
            let y = this.chart;
            if (s = v.call(this, s, f), y && y.mapView) {
              let h = y.mapView.pixelsToLonLat({ x: s.chartX - y.plotLeft, y: s.chartY - y.plotTop });
              h && R(s, h);
            }
            return s;
          }
          function c(v) {
            let s = this.chart.options.mapNavigation;
            s && z(s.enableTouchZoom, s.enabled) && (this.chart.zooming.pinchType = "xy"), v.apply(this, [].slice.call(arguments, 1));
          }
          L.compose = function(v) {
            let s = v.prototype;
            s.onContainerDblClick || (R(s, { onContainerDblClick: A, onContainerMouseWheel: l }), O(s, "normalize", u), O(s, "zoomOption", c));
          };
        }(B || (B = {})), B;
      }), Z(r, "Maps/MapSymbols.js", [], function() {
        let T;
        function B(R, z, O, L, M) {
          if (M) {
            let w = (M == null ? void 0 : M.r) || 0;
            M.brBoxY = z - w, M.brBoxHeight = L + w;
          }
          return T.roundedRect(R, z, O, L, M);
        }
        function I(R, z, O, L, M) {
          if (M) {
            let w = (M == null ? void 0 : M.r) || 0;
            M.brBoxHeight = L + w;
          }
          return T.roundedRect(R, z, O, L, M);
        }
        return { compose: function(R) {
          (T = R.prototype.symbols).bottombutton = B, T.topbutton = I;
        } };
      }), Z(r, "Maps/MapNavigation.js", [r["Core/Defaults.js"], r["Core/Globals.js"], r["Maps/MapNavigationDefaults.js"], r["Maps/MapPointer.js"], r["Maps/MapSymbols.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { setOptions: L } = T, { composed: M } = B, { addEvent: w, extend: A, merge: l, objectEach: u, pick: c, pushUnique: v } = O;
        function s(y) {
          y && (y.preventDefault && y.preventDefault(), y.stopPropagation && y.stopPropagation(), y.cancelBubble = !0);
        }
        class f {
          static compose(h, a, x) {
            R.compose(a), z.compose(x), v(M, "Map.Navigation") && (w(h, "beforeRender", function() {
              this.mapNavigation = new f(this), this.mapNavigation.update();
            }), L(I));
          }
          constructor(h) {
            this.chart = h, this.navButtons = [];
          }
          update(h) {
            let a = this, x = a.chart, S = a.navButtons, E = function(p) {
              this.handler.call(x, p), s(p);
            }, b = x.options.mapNavigation;
            for (h && (b = x.options.mapNavigation = l(x.options.mapNavigation, h)); S.length; ) S.pop().destroy();
            if (!x.renderer.forExport && c(b.enableButtons, b.enabled)) {
              a.navButtonsGroup || (a.navButtonsGroup = x.renderer.g().attr({ zIndex: 7 }).add()), u(b.buttons, (C, o) => {
                var m;
                let t = { padding: (C = l(b.buttonOptions, C)).padding };
                !x.styledMode && C.theme && (A(t, C.theme), t.style = l(C.theme.style, C.style));
                let { text: e, width: n = 0, height: d = 0, padding: i = 0 } = C, g = x.renderer.button(e !== "+" && e !== "-" && e || "", 0, 0, E, t, void 0, void 0, void 0, o === "zoomIn" ? "topbutton" : "bottombutton").addClass("highcharts-map-navigation highcharts-" + { zoomIn: "zoom-in", zoomOut: "zoom-out" }[o]).attr({ width: n, height: d, title: x.options.lang[o], zIndex: 5 }).add(a.navButtonsGroup);
                if (e === "+" || e === "-") {
                  let k = n + 1, j = [["M", i + 3, i + d / 2], ["L", i + k - 3, i + d / 2]];
                  e === "+" && j.push(["M", i + k / 2, i + 3], ["L", i + k / 2, i + d - 3]), x.renderer.path(j).addClass("highcharts-button-symbol").attr(x.styledMode ? {} : { stroke: (m = C.style) == null ? void 0 : m.color, "stroke-width": 3, "stroke-linecap": "round" }).add(g);
                }
                if (g.handler = C.onclick, w(g.element, "dblclick", s), S.push(g), A(C, { width: g.width, height: 2 * (g.height || 0) }), x.hasLoaded) g.align(C, !1, C.alignTo);
                else {
                  let k = w(x, "load", () => {
                    g.element && g.align(C, !1, C.alignTo), k();
                  });
                }
              });
              let p = (C, o) => !(o.x >= C.x + C.width || o.x + o.width <= C.x || o.y >= C.y + C.height || o.y + o.height <= C.y);
              x.hasLoaded || w(x, "render", function() {
                let C = x.exportingGroup && x.exportingGroup.getBBox();
                if (C) {
                  let o = a.navButtonsGroup.getBBox();
                  if (p(C, o)) {
                    let t = -o.y - o.height + C.y - 5, e = C.y + C.height - o.y + 5, n = b.buttonOptions && b.buttonOptions.verticalAlign;
                    a.navButtonsGroup.attr({ translateY: n === "bottom" ? t : e });
                  }
                }
              });
            }
            this.updateEvents(b);
          }
          updateEvents(h) {
            let a = this.chart;
            c(h.enableDoubleClickZoom, h.enabled) || h.enableDoubleClickZoomTo ? this.unbindDblClick = this.unbindDblClick || w(a.container, "dblclick", function(x) {
              a.pointer.onContainerDblClick(x);
            }) : this.unbindDblClick && (this.unbindDblClick = this.unbindDblClick()), c(h.enableMouseWheelZoom, h.enabled) ? this.unbindMouseWheel = this.unbindMouseWheel || w(a.container, "wheel", function(x) {
              return a.pointer.inClass(x.target, "highcharts-no-mousewheel") || (a.pointer.onContainerMouseWheel(x), s(x)), !1;
            }) : this.unbindMouseWheel && (this.unbindMouseWheel = this.unbindMouseWheel());
          }
        }
        return f;
      }), Z(r, "Series/ColorMapComposition.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { column: { prototype: z } } = T.seriesTypes, { addEvent: O, defined: L } = I;
        return function(M) {
          function w(A) {
            let l = this.series, u = l.chart.renderer;
            this.moveToTopOnHover && this.graphic && (l.stateMarkerGraphic || (l.stateMarkerGraphic = new B(u, "use").css({ pointerEvents: "none" }).add(this.graphic.parentGroup)), (A == null ? void 0 : A.state) === "hover" ? (this.graphic.attr({ id: this.id }), l.stateMarkerGraphic.attr({ href: `${u.url}#${this.id}`, visibility: "visible" })) : l.stateMarkerGraphic.attr({ href: "" }));
          }
          M.pointMembers = { dataLabelOnNull: !0, moveToTopOnHover: !0, isValid: function() {
            return this.value !== null && this.value !== 1 / 0 && this.value !== -1 / 0 && (this.value === void 0 || !isNaN(this.value));
          } }, M.seriesMembers = { colorKey: "value", axisTypes: ["xAxis", "yAxis", "colorAxis"], parallelArrays: ["x", "y", "value"], pointArrayMap: ["value"], trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], colorAttribs: function(A) {
            let l = {};
            return L(A.color) && (!A.state || A.state === "normal") && (l[this.colorProp || "fill"] = A.color), l;
          }, pointAttribs: z.pointAttribs }, M.compose = function(A) {
            return O(A.prototype.pointClass, "afterSetState", w), A;
          };
        }(R || (R = {})), R;
      }), Z(r, "Core/Chart/MapChart.js", [r["Core/Chart/Chart.js"], r["Core/Defaults.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        var z;
        let { getOptions: O } = B, { isNumber: L, merge: M, pick: w } = R;
        class A extends T {
          init(u, c) {
            let v = O().credits, s = M({ chart: { panning: { enabled: !0, type: "xy" }, type: "map" }, credits: { mapText: w(v.mapText, ' © <a href="{geojson.copyrightUrl}">{geojson.copyrightShort}</a>'), mapTextFull: w(v.mapTextFull, "{geojson.copyright}") }, mapView: {}, tooltip: { followTouchMove: !1 } }, u);
            super.init(s, c);
          }
          mapZoom(u, c, v, s, f) {
            this.mapView && (L(u) && (u = Math.log(u) / Math.log(0.5)), this.mapView.zoomBy(u, L(c) && L(v) ? this.mapView.projection.inverse([c, v]) : void 0, L(s) && L(f) ? [s, f] : void 0));
          }
          update(u) {
            var c;
            u.chart && "map" in u.chart && ((c = this.mapView) == null || c.recommendMapView(this, [u.chart.map, ...(this.options.series || []).map((v) => v.mapData)], !0)), super.update.apply(this, arguments);
          }
        }
        return (z = A).maps = {}, z.mapChart = function(l, u, c) {
          return new z(l, u, c);
        }, z.splitPath = function(l) {
          let u;
          return u = typeof l == "string" ? (l = l.replace(/([A-Z])/gi, " $1 ").replace(/^\s*/, "").replace(/\s*$/, "")).split(/[ ,;]+/).map((c) => /[A-Z]/i.test(c) ? c : parseFloat(c)) : l, I.prototype.pathToSegments(u);
        }, A;
      }), Z(r, "Maps/MapUtilities.js", [], function() {
        return { boundsFromPath: function(T) {
          let B = -Number.MAX_VALUE, I = Number.MAX_VALUE, R = -Number.MAX_VALUE, z = Number.MAX_VALUE, O;
          if (T.forEach((L) => {
            let M = L[L.length - 2], w = L[L.length - 1];
            typeof M == "number" && typeof w == "number" && (I = Math.min(I, M), B = Math.max(B, M), z = Math.min(z, w), R = Math.max(R, w), O = !0);
          }), O) return { x1: I, y1: z, x2: B, y2: R };
        } };
      }), Z(r, "Series/Map/MapPoint.js", [r["Series/ColorMapComposition.js"], r["Maps/MapUtilities.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { boundsFromPath: z } = B, O = I.seriesTypes.scatter.prototype.pointClass, { extend: L, isNumber: M, pick: w } = R;
        class A extends O {
          static getProjectedPath(u, c) {
            return u.projectedPath || (c && u.geometry ? (c.hasCoordinates = !0, u.projectedPath = c.path(u.geometry)) : u.projectedPath = u.path), u.projectedPath || [];
          }
          applyOptions(u, c) {
            let v = this.series, s = super.applyOptions(u, c), f = v.joinBy;
            if (v.mapData && v.mapMap) {
              let y = f[1], h = super.getNestedProperty(y), a = h !== void 0 && v.mapMap[h];
              a ? L(s, { ...a, name: s.name ?? a.name }) : v.pointArrayMap.indexOf("value") !== -1 && (s.value = s.value || null);
            }
            return s;
          }
          getProjectedBounds(u) {
            let c = z(A.getProjectedPath(this, u)), v = this.properties, s = this.series.chart.mapView;
            if (c) {
              let f = v && v["hc-middle-lon"], y = v && v["hc-middle-lat"];
              if (s && M(f) && M(y)) {
                let h = u.forward([f, y]);
                c.midX = h[0], c.midY = h[1];
              } else {
                let h = v && v["hc-middle-x"], a = v && v["hc-middle-y"];
                c.midX = c.x1 + (c.x2 - c.x1) * w(this.middleX, M(h) ? h : 0.5);
                let x = w(this.middleY, M(a) ? a : 0.5);
                this.geometry || (x = 1 - x), c.midY = c.y2 - (c.y2 - c.y1) * x;
              }
              return c;
            }
          }
          onMouseOver(u) {
            R.clearTimeout(this.colorInterval), !this.isNull && this.visible || this.series.options.nullInteraction ? super.onMouseOver.call(this, u) : this.series.onMouseOut();
          }
          setVisible(u) {
            this.visible = this.options.visible = !!u, this.dataLabel && this.dataLabel[u ? "show" : "hide"](), this.graphic && this.graphic.attr(this.series.pointAttribs(this));
          }
          zoomTo(u) {
            let c = this.series.chart, v = c.mapView, s = this.bounds;
            if (v && s) {
              let f = M(this.insetIndex) && v.insets[this.insetIndex];
              if (f) {
                let y = f.projectedUnitsToPixels({ x: s.x1, y: s.y1 }), h = f.projectedUnitsToPixels({ x: s.x2, y: s.y2 }), a = v.pixelsToProjectedUnits({ x: y.x, y: y.y }), x = v.pixelsToProjectedUnits({ x: h.x, y: h.y });
                s = { x1: a.x, y1: a.y, x2: x.x, y2: x.y };
              }
              v.fitToBounds(s, void 0, !1), this.series.isDirty = !0, c.redraw(u);
            }
          }
        }
        return L(A.prototype, { dataLabelOnNull: T.pointMembers.dataLabelOnNull, moveToTopOnHover: T.pointMembers.moveToTopOnHover, isValid: T.pointMembers.isValid }), A;
      }), Z(r, "Series/Map/MapSeriesDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { isNumber: B } = T;
        return { affectsMapView: !0, animation: !1, dataLabels: { crop: !1, formatter: function() {
          let { numberFormatter: I } = this.series.chart, { value: R } = this.point;
          return B(R) ? I(R, -1) : this.point.name;
        }, inside: !0, overflow: !1, padding: 0, verticalAlign: "middle" }, linecap: "round", marker: null, nullColor: "#f7f7f7", stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "{point.name}: {point.value}<br/>" }, turboThreshold: 0, allAreas: !0, borderColor: "#e6e6e6", borderWidth: 1, joinBy: "hc-key", states: { hover: { halo: void 0, borderColor: "#666666", borderWidth: 2 }, normal: { animation: !0 }, select: { color: "#cccccc" } }, legendSymbol: "rectangle" };
      }), Z(r, "Maps/MapViewDefaults.js", [], function() {
        return { center: [0, 0], fitToGeometry: void 0, maxZoom: void 0, padding: 0, projection: { name: void 0, parallels: void 0, rotation: void 0 }, zoom: void 0, insetOptions: { borderColor: "#cccccc", borderWidth: 1, padding: "10%", relativeTo: "mapBoundingBox", units: "percent" } };
      }), Z(r, "Maps/GeoJSONComposition.js", [r["Core/Globals.js"], r["Core/Templating.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { win: z } = T, { format: O } = B, { error: L, extend: M, merge: w, wrap: A } = I;
        return function(l) {
          function u(h) {
            return this.mapView && this.mapView.lonLatToProjectedUnits(h);
          }
          function c(h) {
            return this.mapView && this.mapView.projectedUnitsToLonLat(h);
          }
          function v(h, a) {
            let x = this.options.chart.proj4 || z.proj4;
            if (!x) {
              L(21, !1, this);
              return;
            }
            let { jsonmarginX: S = 0, jsonmarginY: E = 0, jsonres: b = 1, scale: p = 1, xoffset: C = 0, xpan: o = 0, yoffset: t = 0, ypan: e = 0 } = a, n = x(a.crs, [h.lon, h.lat]), d = a.cosAngle || a.rotation && Math.cos(a.rotation), i = a.sinAngle || a.rotation && Math.sin(a.rotation), g = a.rotation ? [n[0] * d + n[1] * i, -n[0] * i + n[1] * d] : n;
            return { x: ((g[0] - C) * p + o) * b + S, y: -(((t - g[1]) * p + e) * b - E) };
          }
          function s(h, a) {
            let x = this.options.chart.proj4 || z.proj4;
            if (!x) {
              L(21, !1, this);
              return;
            }
            if (h.y === null) return;
            let { jsonmarginX: S = 0, jsonmarginY: E = 0, jsonres: b = 1, scale: p = 1, xoffset: C = 0, xpan: o = 0, yoffset: t = 0, ypan: e = 0 } = a, n = { x: ((h.x - S) / b - o) / p + C, y: ((h.y - E) / b + e) / p + t }, d = a.cosAngle || a.rotation && Math.cos(a.rotation), i = a.sinAngle || a.rotation && Math.sin(a.rotation), g = x(a.crs, "WGS84", a.rotation ? { x: n.x * d + -(n.y * i), y: n.x * i + n.y * d } : n);
            return { lat: g.y, lon: g.x };
          }
          function f(h, a) {
            a || (a = Object.keys(h.objects)[0]);
            let x = h.objects[a];
            if (x["hc-decoded-geojson"] && x["hc-decoded-geojson"].title === h.title) return x["hc-decoded-geojson"];
            let S = h.arcs;
            if (h.transform) {
              let o, t, e, n = h.arcs, { scale: d, translate: i } = h.transform;
              S = [];
              for (let g = 0, m = n.length; g < m; ++g) {
                let k = n[g];
                S.push(o = []), t = 0, e = 0;
                for (let j = 0, P = k.length; j < P; ++j) o.push([(t += k[j][0]) * d[0] + i[0], (e += k[j][1]) * d[1] + i[1]]);
              }
            }
            let E = (o) => typeof o[0] == "number" ? o.reduce((t, e, n) => {
              let d = e < 0 ? S[~e] : S[e];
              return e < 0 ? (d = d.slice(0, n === 0 ? d.length : d.length - 1)).reverse() : n && (d = d.slice(1)), t.concat(d);
            }, []) : o.map(E), b = x.geometries, p = [];
            for (let o = 0, t = b.length; o < t; ++o) p.push({ type: "Feature", properties: b[o].properties, geometry: { type: b[o].type, coordinates: b[o].coordinates || E(b[o].arcs) } });
            let C = { type: "FeatureCollection", copyright: h.copyright, copyrightShort: h.copyrightShort, copyrightUrl: h.copyrightUrl, features: p, "hc-recommended-mapview": x["hc-recommended-mapview"], bbox: h.bbox, title: h.title };
            return x["hc-decoded-geojson"] = C, C;
          }
          function y(h, a) {
            a = w(!0, this.options.credits, a), h.call(this, a), this.credits && this.mapCreditsFull && this.credits.attr({ title: this.mapCreditsFull });
          }
          l.compose = function(h) {
            let a = h.prototype;
            a.transformFromLatLon || (a.fromLatLonToPoint = u, a.fromPointToLatLon = c, a.transformFromLatLon = v, a.transformToLatLon = s, A(a, "addCredits", y));
          }, l.geojson = function(h, a = "map", x) {
            var p, C;
            let S = [], E = h.type === "Topology" ? f(h) : h, b = E.features;
            for (let o = 0, t = b.length; o < t; ++o) {
              let e, n = b[o], d = n.geometry || {}, i = d.type, g = d.coordinates, m = n.properties;
              if ((a === "map" || a === "mapbubble") && (i === "Polygon" || i === "MultiPolygon") ? g.length && (e = { geometry: { coordinates: g, type: i } }) : a === "mapline" && (i === "LineString" || i === "MultiLineString") ? g.length && (e = { geometry: { coordinates: g, type: i } }) : a === "mappoint" && i === "Point" && g.length && (e = { geometry: { coordinates: g, type: i } }), e) {
                let k = m && (m.name || m.NAME), j = m && m.lon, P = m && m.lat;
                S.push(M(e, { lat: typeof P == "number" ? P : void 0, lon: typeof j == "number" ? j : void 0, name: typeof k == "string" ? k : void 0, properties: m }));
              }
            }
            return x && E.copyrightShort && (x.chart.mapCredits = O((p = x.chart.options.credits) == null ? void 0 : p.mapText, { geojson: E }), x.chart.mapCreditsFull = O((C = x.chart.options.credits) == null ? void 0 : C.mapTextFull, { geojson: E })), S;
          }, l.topo2geo = f;
        }(R || (R = {})), R;
      }), Z(r, "Core/Geometry/PolygonClip.js", [], function() {
        function T(R, z, O = !0) {
          let L = z[z.length - 1], M, w, A, l = R;
          for (let u = 0; u < z.length; u++) {
            let c = l;
            M = z[u], l = [], w = O ? c[c.length - 1] : c[0];
            for (let v = 0; v < c.length; v++) B(L, M, A = c[v]) ? (B(L, M, w) || l.push(I(L, M, w, A)), l.push(A)) : B(L, M, w) && l.push(I(L, M, w, A)), w = A;
            L = M;
          }
          return l;
        }
        function B(R, z, O) {
          return (z[0] - R[0]) * (O[1] - R[1]) > (z[1] - R[1]) * (O[0] - R[0]);
        }
        function I(R, z, O, L) {
          let M = [R[0] - z[0], R[1] - z[1]], w = [O[0] - L[0], O[1] - L[1]], A = R[0] * z[1] - R[1] * z[0], l = O[0] * L[1] - O[1] * L[0], u = 1 / (M[0] * w[1] - M[1] * w[0]), c = [(A * w[0] - l * M[0]) * u, (A * w[1] - l * M[1]) * u];
          return c.isIntersection = !0, c;
        }
        return { clipLineString: function(R, z) {
          let O = [], L = T(R, z, !1);
          for (let M = 1; M < L.length; M++) L[M].isIntersection && L[M - 1].isIntersection && (O.push(L.splice(0, M)), M = 0), M === L.length - 1 && O.push(L);
          return O;
        }, clipPolygon: T };
      }), Z(r, "Maps/Projections/LambertConformalConic.js", [], function() {
        let T = Math.sign || ((z) => z === 0 ? 0 : z > 0 ? 1 : -1), B = Math.PI / 180, I = Math.PI / 2, R = (z) => Math.tan((I + z) / 2);
        return class {
          constructor(z) {
            let O = (z.parallels || []).map((l) => l * B), L = O[0] || 0, M = O[1] ?? L, w = Math.cos(L);
            typeof z.projectedBounds == "object" && (this.projectedBounds = z.projectedBounds);
            let A = L === M ? Math.sin(L) : Math.log(w / Math.cos(M)) / Math.log(R(M) / R(L));
            1e-10 > Math.abs(A) && (A = 1e-10 * (T(A) || 1)), this.n = A, this.c = w * Math.pow(R(L), A) / A;
          }
          forward(z) {
            let { c: O, n: L, projectedBounds: M } = this, w = z[0] * B, A = z[1] * B;
            O > 0 ? A < -I + 1e-6 && (A = -I + 1e-6) : A > I - 1e-6 && (A = I - 1e-6);
            let l = O / Math.pow(R(A), L), u = l * Math.sin(L * w) * 63.78137, c = (O - l * Math.cos(L * w)) * 63.78137, v = [u, c];
            return M && (u < M.x1 || u > M.x2 || c < M.y1 || c > M.y2) && (v.outside = !0), v;
          }
          inverse(z) {
            let { c: O, n: L } = this, M = z[0] / 63.78137, w = O - z[1] / 63.78137, A = T(L) * Math.sqrt(M * M + w * w), l = Math.atan2(M, Math.abs(w)) * T(w);
            return w * L < 0 && (l -= Math.PI * T(M) * T(w)), [l / L / B, (2 * Math.atan(Math.pow(O / A, 1 / L)) - I) / B];
          }
        };
      }), Z(r, "Maps/Projections/EqualEarth.js", [], function() {
        let T = Math.sqrt(3) / 2;
        return class {
          constructor() {
            this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -97.52595454902263, y2: 97.52595454902263 };
          }
          forward(B) {
            let I = Math.PI / 180, R = Math.asin(T * Math.sin(B[1] * I)), z = R * R, O = z * z * z;
            return [B[0] * I * Math.cos(R) * 74.03120656864502 / (T * (1.340264 + -0.24331799999999998 * z + O * (0.0062510000000000005 + 0.034164 * z))), 74.03120656864502 * R * (1.340264 + -0.081106 * z + O * (893e-6 + 3796e-6 * z))];
          }
          inverse(B) {
            let I = B[0] / 74.03120656864502, R = B[1] / 74.03120656864502, z = 180 / Math.PI, O = R, L, M, w, A;
            for (let c = 0; c < 12 && (M = (L = O * O) * L * L, w = O * (1.340264 + -0.081106 * L + M * (893e-6 + 3796e-6 * L)) - R, O -= A = w / (1.340264 + -0.24331799999999998 * L + M * (0.0062510000000000005 + 0.034164 * L)), !(1e-9 > Math.abs(A))); ++c) ;
            M = (L = O * O) * L * L;
            let l = z * T * I * (1.340264 + -0.24331799999999998 * L + M * (0.0062510000000000005 + 0.034164 * L)) / Math.cos(O), u = z * Math.asin(Math.sin(O) / T);
            return Math.abs(l) > 180 ? [NaN, NaN] : [l, u];
          }
        };
      }), Z(r, "Maps/Projections/Miller.js", [], function() {
        let T = Math.PI / 4, B = Math.PI / 180;
        return class {
          constructor() {
            this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -146.91480769173063, y2: 146.91480769173063 };
          }
          forward(I) {
            return [I[0] * B * 63.78137, 79.7267125 * Math.log(Math.tan(T + 0.4 * I[1] * B))];
          }
          inverse(I) {
            return [I[0] / 63.78137 / B, 2.5 * (Math.atan(Math.exp(0.8 * (I[1] / 63.78137))) - T) / B];
          }
        };
      }), Z(r, "Maps/Projections/Orthographic.js", [], function() {
        let T = Math.PI / 180;
        return class {
          constructor() {
            this.antimeridianCutting = !1, this.bounds = { x1: -63.78460826781007, x2: 63.78460826781007, y1: -63.78460826781007, y2: 63.78460826781007 };
          }
          forward(B) {
            let I = B[0], R = B[1] * T, z = [Math.cos(R) * Math.sin(I * T) * 63.78460826781007, 63.78460826781007 * Math.sin(R)];
            return (I < -90 || I > 90) && (z.outside = !0), z;
          }
          inverse(B) {
            let I = B[0] / 63.78460826781007, R = B[1] / 63.78460826781007, z = Math.sqrt(I * I + R * R), O = Math.asin(z), L = Math.sin(O);
            return [Math.atan2(I * L, z * Math.cos(O)) / T, Math.asin(z && R * L / z) / T];
          }
        };
      }), Z(r, "Maps/Projections/WebMercator.js", [], function() {
        let T = Math.PI / 180;
        return class {
          constructor() {
            this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -200.3750834278071, y2: 200.3750834278071 }, this.maxLatitude = 85.0511287798;
          }
          forward(B) {
            let I = Math.sin(B[1] * T), R = [63.78137 * B[0] * T, 63.78137 * Math.log((1 + I) / (1 - I)) / 2];
            return Math.abs(B[1]) > this.maxLatitude && (R.outside = !0), R;
          }
          inverse(B) {
            return [B[0] / (63.78137 * T), (2 * Math.atan(Math.exp(B[1] / 63.78137)) - Math.PI / 2) / T];
          }
        };
      }), Z(r, "Maps/Projections/ProjectionRegistry.js", [r["Maps/Projections/LambertConformalConic.js"], r["Maps/Projections/EqualEarth.js"], r["Maps/Projections/Miller.js"], r["Maps/Projections/Orthographic.js"], r["Maps/Projections/WebMercator.js"]], function(T, B, I, R, z) {
        return { EqualEarth: B, LambertConformalConic: T, Miller: I, Orthographic: R, WebMercator: z };
      }), Z(r, "Maps/Projection.js", [r["Core/Geometry/PolygonClip.js"], r["Maps/Projections/ProjectionRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { clipLineString: R, clipPolygon: z } = T, { clamp: O, erase: L } = I, M = 2 * Math.PI / 360, w = (c) => (c < -180 && (c += 360), c > 180 && (c -= 360), c), A = (c) => (1 - Math.cos(c)) / 2, l = (c, v) => {
          let s = Math.cos, f = c[1] * M, y = c[0] * M, h = v[1] * M, a = v[0] * M;
          return A(h - f) + s(f) * s(h) * A(a - y);
        };
        class u {
          static add(v, s) {
            u.registry[v] = s;
          }
          static distance(v, s) {
            let { atan2: f, sqrt: y } = Math, h = l(v, s);
            return 6371e3 * (2 * f(y(h), y(1 - h)));
          }
          static geodesic(v, s, f, y = 5e5) {
            let { atan2: h, cos: a, sin: x, sqrt: S } = Math, E = u.distance, b = v[1] * M, p = v[0] * M, C = s[1] * M, o = s[0] * M, t = a(b) * a(p), e = a(C) * a(o), n = a(b) * x(p), d = a(C) * x(o), i = x(b), g = x(C), m = E(v, s), k = m / 6371e3, j = x(k), P = Math.round(m / y), D = [];
            if (f && D.push(v), P > 1) {
              let H = 1 / P;
              for (let G = H; G < 0.999; G += H) {
                let V = x((1 - G) * k) / j, F = x(G * k) / j, U = V * t + F * e, Y = V * n + F * d, q = h(V * i + F * g, S(U * U + Y * Y)), N = h(Y, U);
                D.push([N / M, q / M]);
              }
            }
            return f && D.push(s), D;
          }
          static insertGeodesics(v) {
            let s = v.length - 1;
            for (; s--; ) if (Math.max(Math.abs(v[s][0] - v[s + 1][0]), Math.abs(v[s][1] - v[s + 1][1])) > 10) {
              let f = u.geodesic(v[s], v[s + 1]);
              f.length && v.splice(s + 1, 0, ...f);
            }
          }
          static toString(v) {
            let { name: s, rotation: f } = v || {};
            return [s, f && f.join(",")].join(";");
          }
          constructor(v = {}) {
            this.hasCoordinates = !1, this.hasGeoProjection = !1, this.maxLatitude = 90, this.options = v;
            let { name: s, projectedBounds: f, rotation: y } = v;
            this.rotator = y ? this.getRotator(y) : void 0;
            let h = s ? u.registry[s] : void 0;
            h && (this.def = new h(v));
            let { def: a, rotator: x } = this;
            a && (this.maxLatitude = a.maxLatitude || 90, this.hasGeoProjection = !0), x && a ? (this.forward = (S) => a.forward(x.forward(S)), this.inverse = (S) => x.inverse(a.inverse(S))) : a ? (this.forward = (S) => a.forward(S), this.inverse = (S) => a.inverse(S)) : x && (this.forward = x.forward, this.inverse = x.inverse), this.bounds = f === "world" ? a && a.bounds : f;
          }
          lineIntersectsBounds(v) {
            let { x1: s, x2: f, y1: y, y2: h } = this.bounds || {}, a = (E, b, p) => {
              let [C, o] = E, t = b ? 0 : 1;
              if (typeof p == "number" && C[b] >= p != o[b] >= p) {
                let e = (p - C[b]) / (o[b] - C[b]), n = C[t] + e * (o[t] - C[t]);
                return b ? [n, p] : [p, n];
              }
            }, x, S = v[0];
            return ((x = a(v, 0, s)) || (x = a(v, 0, f))) && (S = x, v[1] = x), ((x = a(v, 1, y)) || (x = a(v, 1, h))) && (S = x), S;
          }
          getRotator(v) {
            let s = v[0] * M, f = (v[1] || 0) * M, y = (v[2] || 0) * M, h = Math.cos(f), a = Math.sin(f), x = Math.cos(y), S = Math.sin(y);
            if (s !== 0 || f !== 0 || y !== 0) return { forward: (E) => {
              let b = E[0] * M + s, p = E[1] * M, C = Math.cos(p), o = Math.cos(b) * C, t = Math.sin(b) * C, e = Math.sin(p), n = e * h + o * a;
              return [Math.atan2(t * x - n * S, o * h - e * a) / M, Math.asin(n * x + t * S) / M];
            }, inverse: (E) => {
              let b = E[0] * M, p = E[1] * M, C = Math.cos(p), o = Math.cos(b) * C, t = Math.sin(b) * C, e = Math.sin(p), n = e * x - t * S;
              return [(Math.atan2(t * x + e * S, o * h + n * a) - s) / M, Math.asin(n * h - o * a) / M];
            } };
          }
          forward(v) {
            return v;
          }
          inverse(v) {
            return v;
          }
          cutOnAntimeridian(v, s) {
            let f, y = [], h = [v];
            for (let a = 0, x = v.length; a < x; ++a) {
              let S = v[a], E = v[a - 1];
              if (!a) {
                if (!s) continue;
                E = v[v.length - 1];
              }
              let b = E[0], p = S[0];
              if ((b < -90 || b > 90) && (p < -90 || p > 90) && b > 0 != p > 0) {
                let C = O((180 - (b + 360) % 360) / ((p + 360) % 360 - (b + 360) % 360), 0, 1), o = E[1] + C * (S[1] - E[1]);
                y.push({ i: a, lat: o, direction: b < 0 ? 1 : -1, previousLonLat: E, lonLat: S });
              }
            }
            if (y.length)
              if (s) {
                y.length % 2 == 1 && (f = y.slice().sort((x, S) => Math.abs(S.lat) - Math.abs(x.lat))[0], L(y, f));
                let a = y.length - 2;
                for (; a >= 0; ) {
                  let x = y[a].i, S = w(180 + 1e-6 * y[a].direction), E = w(180 - 1e-6 * y[a].direction), b = v.splice(x, y[a + 1].i - x, ...u.geodesic([S, y[a].lat], [S, y[a + 1].lat], !0));
                  b.push(...u.geodesic([E, y[a + 1].lat], [E, y[a].lat], !0)), h.push(b), a -= 2;
                }
                if (f) for (let x = 0; x < h.length; x++) {
                  let { direction: S, lat: E } = f, b = h[x], p = b.indexOf(f.lonLat);
                  if (p > -1) {
                    let C = (E < 0 ? -1 : 1) * this.maxLatitude, o = w(180 + 1e-6 * S), t = w(180 - 1e-6 * S), e = u.geodesic([o, E], [o, C], !0);
                    for (let n = o + 120 * S; n > -180 && n < 180; n += 120 * S) e.push([n, C]);
                    e.push(...u.geodesic([t, C], [t, f.lat], !0)), b.splice(p, 0, ...e);
                    break;
                  }
                }
              } else {
                let a = y.length;
                for (; a--; ) {
                  let x = y[a].i, S = v.splice(x, v.length, [w(180 + 1e-6 * y[a].direction), y[a].lat]);
                  S.unshift([w(180 - 1e-6 * y[a].direction), y[a].lat]), h.push(S);
                }
              }
            return h;
          }
          path(v) {
            let s, { bounds: f, def: y, rotator: h } = this, a = [], x = v.type === "Polygon" || v.type === "MultiPolygon", S = this.hasGeoProjection, E = !y || y.antimeridianCutting !== !1, b = E ? h : void 0, p = E && y || this;
            f && (s = [[f.x1, f.y1], [f.x2, f.y1], [f.x2, f.y2], [f.x1, f.y2]]);
            let C = (o) => {
              let t = o.map((n) => {
                if (E) {
                  b && (n = b.forward(n));
                  let d = n[0];
                  1e-6 > Math.abs(d - 180) && (d = d < 180 ? 179.999999 : 180.000001), n = [d, n[1]];
                }
                return n;
              }), e = [t];
              S && (u.insertGeodesics(t), E && (e = this.cutOnAntimeridian(t, x))), e.forEach((n) => {
                let d, i;
                if (n.length < 2) return;
                let g = !1, m = !1, k = (H) => {
                  g ? a.push(["L", H[0], H[1]]) : (a.push(["M", H[0], H[1]]), g = !0);
                }, j = !1, P = !1, D = n.map((H) => {
                  let G = p.forward(H);
                  return G.outside ? j = !0 : P = !0, G[1] === 1 / 0 ? G[1] = 1e10 : G[1] === -1 / 0 && (G[1] = -1e10), G;
                });
                if (E) {
                  if (x && D.push(D[0]), j) {
                    if (!P) return;
                    if (s) {
                      if (x) D = z(D, s);
                      else if (f) {
                        R(D, s).forEach((H) => {
                          g = !1, H.forEach(k);
                        });
                        return;
                      }
                    }
                  }
                  D.forEach(k);
                } else for (let H = 0; H < D.length; H++) {
                  let G = n[H], V = D[H];
                  V.outside ? m = !0 : (x && !d && (d = G, n.push(G), D.push(V)), m && i && (x && S ? u.geodesic(i, G).forEach((F) => k(p.forward(F))) : g = !1), k(V), i = G, m = !1);
                }
              });
            };
            return v.type === "LineString" ? C(v.coordinates) : v.type === "MultiLineString" ? v.coordinates.forEach((o) => C(o)) : v.type === "Polygon" ? (v.coordinates.forEach((o) => C(o)), a.length && a.push(["Z"])) : v.type === "MultiPolygon" && (v.coordinates.forEach((o) => {
              o.forEach((t) => C(t));
            }), a.length && a.push(["Z"])), a;
          }
        }
        return u.registry = B, u;
      }), Z(r, "Maps/MapView.js", [r["Core/Globals.js"], r["Maps/MapViewDefaults.js"], r["Maps/GeoJSONComposition.js"], r["Core/Geometry/GeometryUtilities.js"], r["Maps/MapUtilities.js"], r["Maps/Projection.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L) {
        let { composed: M } = T, { pointInPolygon: w } = R, { topo2geo: A } = I, { boundsFromPath: l } = z, { addEvent: u, clamp: c, crisp: v, fireEvent: s, isArray: f, isNumber: y, isObject: h, isString: a, merge: x, pick: S, pushUnique: E, relativeLength: b } = L, p = {};
        function C(n, d) {
          let { width: i, height: g } = d;
          return Math.log(400.979322 / Math.max((n.x2 - n.x1) / (i / 256), (n.y2 - n.y1) / (g / 256))) / Math.log(2);
        }
        function o(n) {
          var d, i;
          n.seriesOptions.mapData && ((i = this.mapView) == null || i.recommendMapView(this, [this.options.chart.map, n.seriesOptions.mapData], (d = this.options.drilldown) == null ? void 0 : d.mapZooming));
        }
        class t {
          static compose(d) {
            E(M, "MapView") && (p = d.maps, u(d, "afterInit", function() {
              this.mapView = new t(this, this.options.mapView);
            }, { order: 0 }), u(d, "addSeriesAsDrilldown", o), u(d, "afterDrillUp", o));
          }
          static compositeBounds(d) {
            if (d.length) return d.slice(1).reduce((i, g) => (i.x1 = Math.min(i.x1, g.x1), i.y1 = Math.min(i.y1, g.y1), i.x2 = Math.max(i.x2, g.x2), i.y2 = Math.max(i.y2, g.y2), i), x(d[0]));
          }
          static mergeInsets(d, i) {
            let g = (k) => {
              let j = {};
              return k.forEach((P, D) => {
                j[P && P.id || `i${D}`] = P;
              }), j;
            }, m = x(g(d), g(i));
            return Object.keys(m).map((k) => m[k]);
          }
          constructor(d, i) {
            var j;
            this.allowTransformAnimation = !0, this.eventsToUnbind = [], this.insets = [], this.padding = [0, 0, 0, 0], this.recommendedMapView = {}, this instanceof e || this.recommendMapView(d, [d.options.chart.map, ...(d.options.series || []).map((P) => P.mapData)]), this.userOptions = i || {};
            let g = x(B, this.recommendedMapView, i), m = (j = this.recommendedMapView) == null ? void 0 : j.insets, k = i && i.insets;
            m && k && (g.insets = t.mergeInsets(m, k)), this.chart = d, this.center = g.center, this.options = g, this.projection = new O(g.projection), this.playingField = d.plotBox, this.zoom = g.zoom || 0, this.minZoom = g.minZoom, this.createInsets(), this.eventsToUnbind.push(u(d, "afterSetChartSize", () => {
              this.playingField = this.getField(), (this.minZoom === void 0 || this.minZoom === this.zoom) && (this.fitToBounds(void 0, void 0, !1), !this.chart.hasRendered && y(this.userOptions.zoom) && (this.zoom = this.userOptions.zoom), this.userOptions.center && x(!0, this.center, this.userOptions.center));
            })), this.setUpEvents();
          }
          createInsets() {
            let d = this.options, i = d.insets;
            i && i.forEach((g) => {
              let m = new e(this, x(d.insetOptions, g));
              this.insets.push(m);
            });
          }
          fitToBounds(d, i, g = !0, m) {
            let k = d || this.getProjectedBounds();
            if (k) {
              let j = S(i, d ? 0 : this.options.padding), P = this.getField(!1), D = f(j) ? j : [j, j, j, j];
              this.padding = [b(D[0], P.height), b(D[1], P.width), b(D[2], P.height), b(D[3], P.width)], this.playingField = this.getField();
              let H = C(k, this.playingField);
              d || (this.minZoom = H);
              let G = this.projection.inverse([(k.x2 + k.x1) / 2, (k.y2 + k.y1) / 2]);
              this.setView(G, H, g, m);
            }
          }
          getField(d = !0) {
            let i = d ? this.padding : [0, 0, 0, 0];
            return { x: i[3], y: i[0], width: this.chart.plotWidth - i[1] - i[3], height: this.chart.plotHeight - i[0] - i[2] };
          }
          getGeoMap(d) {
            if (a(d)) return p[d] && p[d].type === "Topology" ? A(p[d]) : p[d];
            if (h(d, !0)) {
              if (d.type === "FeatureCollection") return d;
              if (d.type === "Topology") return A(d);
            }
          }
          getMapBBox() {
            let d = this.getProjectedBounds(), i = this.getScale();
            if (d) {
              let g = this.padding, m = this.projectedUnitsToPixels({ x: d.x1, y: d.y2 });
              return { width: (d.x2 - d.x1) * i + g[1] + g[3], height: (d.y2 - d.y1) * i + g[0] + g[2], x: m.x - g[3], y: m.y - g[0] };
            }
          }
          getProjectedBounds() {
            let d = this.projection, i = this.chart.series.reduce((m, k) => {
              let j = k.getProjectedBounds && k.getProjectedBounds();
              return j && k.options.affectsMapView !== !1 && m.push(j), m;
            }, []), g = this.options.fitToGeometry;
            if (g) {
              if (!this.fitToGeometryCache)
                if (g.type === "MultiPoint") {
                  let m = g.coordinates.map((P) => d.forward(P)), k = m.map((P) => P[0]), j = m.map((P) => P[1]);
                  this.fitToGeometryCache = { x1: Math.min.apply(0, k), x2: Math.max.apply(0, k), y1: Math.min.apply(0, j), y2: Math.max.apply(0, j) };
                } else this.fitToGeometryCache = l(d.path(g));
              return this.fitToGeometryCache;
            }
            return this.projection.bounds || t.compositeBounds(i);
          }
          getScale() {
            return 256 / 400.979322 * Math.pow(2, this.zoom);
          }
          getSVGTransform() {
            let { x: d, y: i, width: g, height: m } = this.playingField, k = this.projection.forward(this.center), j = this.projection.hasCoordinates ? -1 : 1, P = this.getScale(), D = P * j, H = d + g / 2 - k[0] * P, G = i + m / 2 - k[1] * D;
            return { scaleX: P, scaleY: D, translateX: H, translateY: G };
          }
          lonLatToPixels(d) {
            let i = this.lonLatToProjectedUnits(d);
            if (i) return this.projectedUnitsToPixels(i);
          }
          lonLatToProjectedUnits(d) {
            let i = this.chart, g = i.mapTransforms;
            if (g) {
              for (let k in g) if (Object.hasOwnProperty.call(g, k) && g[k].hitZone) {
                let j = i.transformFromLatLon(d, g[k]);
                if (j && w(j, g[k].hitZone.coordinates[0])) return j;
              }
              return i.transformFromLatLon(d, g.default);
            }
            for (let k of this.insets) if (k.options.geoBounds && w({ x: d.lon, y: d.lat }, k.options.geoBounds.coordinates[0])) {
              let j = k.projection.forward([d.lon, d.lat]), P = k.projectedUnitsToPixels({ x: j[0], y: j[1] });
              return this.pixelsToProjectedUnits(P);
            }
            let m = this.projection.forward([d.lon, d.lat]);
            if (!m.outside) return { x: m[0], y: m[1] };
          }
          projectedUnitsToLonLat(d) {
            let i = this.chart, g = i.mapTransforms;
            if (g) {
              for (let j in g) if (Object.hasOwnProperty.call(g, j) && g[j].hitZone && w(d, g[j].hitZone.coordinates[0])) return i.transformToLatLon(d, g[j]);
              return i.transformToLatLon(d, g.default);
            }
            let m = this.projectedUnitsToPixels(d);
            for (let j of this.insets) if (j.hitZone && w(m, j.hitZone.coordinates[0])) {
              let P = j.pixelsToProjectedUnits(m), D = j.projection.inverse([P.x, P.y]);
              return { lon: D[0], lat: D[1] };
            }
            let k = this.projection.inverse([d.x, d.y]);
            return { lon: k[0], lat: k[1] };
          }
          recommendMapView(d, i, g = !1) {
            var P;
            this.recommendedMapView = {};
            let m = i.map((D) => this.getGeoMap(D)), k = [];
            m.forEach((D) => {
              if (D && (Object.keys(this.recommendedMapView).length || (this.recommendedMapView = D["hc-recommended-mapview"] || {}), D.bbox)) {
                let [H, G, V, F] = D.bbox;
                k.push({ x1: H, y1: G, x2: V, y2: F });
              }
            });
            let j = k.length && t.compositeBounds(k);
            s(this, "onRecommendMapView", { geoBounds: j, chart: d }, function() {
              if (j && this.recommendedMapView) {
                if (!this.recommendedMapView.projection) {
                  let { x1: D, y1: H, x2: G, y2: V } = j;
                  this.recommendedMapView.projection = G - D > 180 && V - H > 90 ? { name: "EqualEarth", parallels: [0, 0], rotation: [0] } : { name: "LambertConformalConic", parallels: [H, V], rotation: [-(D + G) / 2] };
                }
                this.recommendedMapView.insets || (this.recommendedMapView.insets = void 0);
              }
            }), this.geoMap = m[0], g && d.hasRendered && !((P = d.userOptions.mapView) != null && P.projection) && this.recommendedMapView && this.update(this.recommendedMapView);
          }
          redraw(d) {
            this.chart.series.forEach((i) => {
              i.useMapGeometry && (i.isDirty = !0);
            }), this.chart.redraw(d);
          }
          setView(d, i, g = !0, m) {
            d && (this.center = d), typeof i == "number" && (typeof this.minZoom == "number" && (i = Math.max(i, this.minZoom)), typeof this.options.maxZoom == "number" && (i = Math.min(i, this.options.maxZoom)), y(i) && (this.zoom = i));
            let k = this.getProjectedBounds();
            if (k) {
              let j = this.projection.forward(this.center), { x: P, y: D, width: H, height: G } = this.playingField, V = this.getScale(), F = this.projectedUnitsToPixels({ x: k.x1, y: k.y1 }), U = this.projectedUnitsToPixels({ x: k.x2, y: k.y2 }), Y = [(k.x1 + k.x2) / 2, (k.y1 + k.y2) / 2];
              if (!this.chart.series.some((q) => q.isDrilling)) {
                let q = F.x, N = U.y, X = U.x, W = F.y;
                X - q < H ? j[0] = Y[0] : q < P && X < P + H ? j[0] += Math.max(q - P, X - H - P) / V : X > P + H && q > P && (j[0] += Math.min(X - H - P, q - P) / V), W - N < G ? j[1] = Y[1] : N < D && W < D + G ? j[1] -= Math.max(N - D, W - G - D) / V : W > D + G && N > D && (j[1] -= Math.min(W - G - D, N - D) / V), this.center = this.projection.inverse(j);
              }
              this.insets.forEach((q) => {
                q.options.field && (q.hitZone = q.getHitZone(), q.playingField = q.getField());
              }), this.render();
            }
            s(this, "afterSetView"), g && this.redraw(m);
          }
          projectedUnitsToPixels(d) {
            let i = this.getScale(), g = this.projection.forward(this.center), m = this.playingField, k = m.x + m.width / 2, j = m.y + m.height / 2;
            return { x: k - i * (g[0] - d.x), y: j + i * (g[1] - d.y) };
          }
          pixelsToLonLat(d) {
            return this.projectedUnitsToLonLat(this.pixelsToProjectedUnits(d));
          }
          pixelsToProjectedUnits(d) {
            let { x: i, y: g } = d, m = this.getScale(), k = this.projection.forward(this.center), j = this.playingField, P = j.x + j.width / 2, D = j.y + j.height / 2;
            return { x: k[0] + (i - P) / m, y: k[1] - (g - D) / m };
          }
          setUpEvents() {
            let d, i, g, { chart: m } = this, k = (j) => {
              let { lastTouches: P, pinchDown: D } = m.pointer, H = this.projection, G = j.touches, { mouseDownX: V, mouseDownY: F } = m, U = 0;
              if ((D == null ? void 0 : D.length) === 1 ? (V = D[0].chartX, F = D[0].chartY) : (D == null ? void 0 : D.length) === 2 && (V = (D[0].chartX + D[1].chartX) / 2, F = (D[0].chartY + D[1].chartY) / 2), (G == null ? void 0 : G.length) === 2 && P && (U = Math.log(Math.sqrt(Math.pow(P[0].chartX - P[1].chartX, 2) + Math.pow(P[0].chartY - P[1].chartY, 2)) / Math.sqrt(Math.pow(G[0].chartX - G[1].chartX, 2) + Math.pow(G[0].chartY - G[1].chartY, 2))) / Math.log(0.5)), y(V) && y(F)) {
                let Y = `${V},${F}`, { chartX: q, chartY: N } = j.originalEvent;
                (G == null ? void 0 : G.length) === 2 && (q = (G[0].chartX + G[1].chartX) / 2, N = (G[0].chartY + G[1].chartY) / 2), Y !== i && (i = Y, d = this.projection.forward(this.center), g = (this.projection.options.rotation || [0, 0]).slice());
                let X = H.def && H.def.bounds, W = X && C(X, this.playingField) || -1 / 0;
                if (H.options.name === "Orthographic" && 2 > ((G == null ? void 0 : G.length) || 0) && (this.minZoom || 1 / 0) < 1.3 * W) {
                  let _ = 440 / (this.getScale() * Math.min(m.plotWidth, m.plotHeight));
                  if (g) {
                    let K = (V - q) * _ - g[0], J = c(-g[1] - (F - N) * _, -80, 80), $ = this.zoom;
                    this.update({ projection: { rotation: [-K, -J] } }, !1), this.fitToBounds(void 0, void 0, !1), this.zoom = $, m.redraw(!1);
                  }
                } else if (y(q) && y(N)) {
                  let _ = this.getScale(), K = this.projection.hasCoordinates ? 1 : -1, J = this.projection.inverse([d[0] + (V - q) / _, d[1] - (F - N) / _ * K]);
                  isNaN(J[0] + J[1]) || this.zoomBy(U, J, void 0, !1);
                }
                j.preventDefault();
              }
            };
            u(m, "pan", k), u(m, "touchpan", k), u(m, "selection", (j) => {
              if (j.resetSelection) this.zoomBy();
              else {
                let P = j.x - m.plotLeft, D = j.y - m.plotTop, { y: H, x: G } = this.pixelsToProjectedUnits({ x: P, y: D }), { y: V, x: F } = this.pixelsToProjectedUnits({ x: P + j.width, y: D + j.height });
                this.fitToBounds({ x1: G, y1: H, x2: F, y2: V }, void 0, !0, !j.originalEvent.touches && void 0), /^touch/.test(j.originalEvent.type) || m.showResetZoom(), j.preventDefault();
              }
            });
          }
          render() {
            this.group || (this.group = this.chart.renderer.g("map-view").attr({ zIndex: 4 }).add());
          }
          update(d, i = !0, g) {
            let m = d.projection, k = m && O.toString(m) !== O.toString(this.options.projection), j = !1;
            x(!0, this.userOptions, d), x(!0, this.options, d), "insets" in d && (this.insets.forEach((P) => P.destroy()), this.insets.length = 0, j = !0), (k || "fitToGeometry" in d) && delete this.fitToGeometryCache, (k || j) && (this.chart.series.forEach((P) => {
              let D = P.transformGroups;
              if (P.clearBounds && P.clearBounds(), P.isDirty = !0, P.isDirtyData = !0, j && D) for (; D.length > 1; ) {
                let H = D.pop();
                H && H.destroy();
              }
            }), k && (this.projection = new O(this.options.projection)), j && this.createInsets(), !d.center && Object.hasOwnProperty.call(d, "zoom") && !y(d.zoom) && this.fitToBounds(void 0, void 0, !1)), d.center || y(d.zoom) ? this.setView(this.options.center, d.zoom, !1) : "fitToGeometry" in d && this.fitToBounds(void 0, void 0, !1), i && this.chart.redraw(g);
          }
          zoomBy(d, i, g, m) {
            let k = this.chart, j = this.projection.forward(this.center);
            if (typeof d == "number") {
              let P, D, H, G = this.zoom + d;
              if (g) {
                let [V, F] = g, U = this.getScale(), Y = V - k.plotLeft - k.plotWidth / 2, q = F - k.plotTop - k.plotHeight / 2;
                D = j[0] + Y / U, H = j[1] + q / U;
              }
              if (typeof D == "number" && typeof H == "number") {
                let V = 1 - Math.pow(2, this.zoom) / Math.pow(2, G), F = j[0] - D, U = j[1] - H;
                j[0] -= F * V, j[1] += U * V, P = this.projection.inverse(j);
              }
              this.setView(i || P, G, void 0, m);
            } else this.fitToBounds(void 0, void 0, void 0, m);
          }
        }
        class e extends t {
          constructor(d, i) {
            if (super(d.chart, i), this.id = i.id, this.mapView = d, this.options = x({ center: [0, 0] }, d.options.insetOptions, i), this.allBounds = [], this.options.geoBounds) {
              let g = d.projection.path(this.options.geoBounds);
              this.geoBoundsProjectedBox = l(g), this.geoBoundsProjectedPolygon = g.map((m) => [m[1] || 0, m[2] || 0]);
            }
          }
          getField(d = !0) {
            let i = this.hitZone;
            if (i) {
              let g = d ? this.padding : [0, 0, 0, 0], m = i.coordinates[0], k = m.map((V) => V[0]), j = m.map((V) => V[1]), P = Math.min.apply(0, k) + g[3], D = Math.max.apply(0, k) - g[1], H = Math.min.apply(0, j) + g[0], G = Math.max.apply(0, j) - g[2];
              if (y(P) && y(H)) return { x: P, y: H, width: D - P, height: G - H };
            }
            return super.getField.call(this, d);
          }
          getHitZone() {
            let { chart: d, mapView: i, options: g } = this, { coordinates: m } = g.field || {};
            if (m) {
              let k = m[0];
              if (g.units === "percent") {
                let j = g.relativeTo === "mapBoundingBox" && i.getMapBBox() || x(d.plotBox, { x: 0, y: 0 });
                k = k.map((P) => [b(`${P[0]}%`, j.width, j.x), b(`${P[1]}%`, j.height, j.y)]);
              }
              return { type: "Polygon", coordinates: [k] };
            }
          }
          getProjectedBounds() {
            return t.compositeBounds(this.allBounds);
          }
          isInside(d) {
            let { geoBoundsProjectedBox: i, geoBoundsProjectedPolygon: g } = this;
            return !!(i && d.x >= i.x1 && d.x <= i.x2 && d.y >= i.y1 && d.y <= i.y2 && g && w(d, g));
          }
          render() {
            let { chart: d, mapView: i, options: g } = this, m = g.borderPath || g.field;
            if (m && i.group) {
              let k = !0;
              this.border || (this.border = d.renderer.path().addClass("highcharts-mapview-inset-border").add(i.group), k = !1), d.styledMode || this.border.attr({ stroke: g.borderColor, "stroke-width": g.borderWidth });
              let j = this.border.strokeWidth(), P = g.relativeTo === "mapBoundingBox" && i.getMapBBox() || i.playingField, D = (m.coordinates || []).reduce((H, G) => G.reduce((V, F, U) => {
                let [Y, q] = F;
                return g.units === "percent" && (Y = d.plotLeft + b(`${Y}%`, P.width, P.x), q = d.plotTop + b(`${q}%`, P.height, P.y)), Y = v(Y, j), q = v(q, j), V.push(U === 0 ? ["M", Y, q] : ["L", Y, q]), V;
              }, H), []);
              this.border[k ? "animate" : "attr"]({ d: D });
            }
          }
          destroy() {
            this.border && (this.border = this.border.destroy()), this.eventsToUnbind.forEach((d) => d());
          }
          setUpEvents() {
          }
        }
        return t;
      }), Z(r, "Series/Map/MapSeries.js", [r["Core/Animation/AnimationUtilities.js"], r["Series/ColorMapComposition.js"], r["Series/CenteredUtilities.js"], r["Core/Globals.js"], r["Core/Chart/MapChart.js"], r["Series/Map/MapPoint.js"], r["Series/Map/MapSeriesDefaults.js"], r["Maps/MapView.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M, w, A) {
        let { animObject: l, stop: u } = T, { noop: c } = R, { splitPath: v } = z, { column: s, scatter: f } = w.seriesTypes, { extend: y, find: h, fireEvent: a, getNestedProperty: x, isArray: S, defined: E, isNumber: b, isObject: p, merge: C, objectEach: o, pick: t, splat: e } = A;
        class n extends f {
          constructor() {
            super(...arguments), this.processedData = [];
          }
          animate(i) {
            let { chart: g, group: m } = this, k = l(this.options.animation);
            i ? m.attr({ translateX: g.plotLeft + g.plotWidth / 2, translateY: g.plotTop + g.plotHeight / 2, scaleX: 1e-3, scaleY: 1e-3 }) : m.animate({ translateX: g.plotLeft, translateY: g.plotTop, scaleX: 1, scaleY: 1 }, k);
          }
          clearBounds() {
            this.points.forEach((i) => {
              delete i.bounds, delete i.insetIndex, delete i.projectedPath;
            }), delete this.bounds;
          }
          doFullTranslate() {
            return !!(this.isDirtyData || this.chart.isResizing || !this.hasRendered);
          }
          drawMapDataLabels() {
            super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
          }
          drawPoints() {
            let i = this, { chart: g, group: m, transformGroups: k = [] } = this, { mapView: j, renderer: P } = g;
            if (j) {
              this.transformGroups = k, k[0] || (k[0] = P.g().add(m));
              for (let D = 0, H = j.insets.length; D < H; ++D) k[D + 1] || k.push(P.g().add(m));
              this.doFullTranslate() && (this.points.forEach((D) => {
                let { graphic: H } = D;
                D.group = k[typeof D.insetIndex == "number" ? D.insetIndex + 1 : 0], H && H.parentGroup !== D.group && H.add(D.group);
              }), s.prototype.drawPoints.apply(this), this.points.forEach((D) => {
                let H = D.graphic;
                if (H) {
                  let G = H.animate, V = "";
                  D.name && (V += "highcharts-name-" + D.name.replace(/ /g, "-").toLowerCase()), D.properties && D.properties["hc-key"] && (V += " highcharts-key-" + D.properties["hc-key"].toString().toLowerCase()), V && H.addClass(V), g.styledMode && H.css(this.pointAttribs(D, D.selected && "select" || void 0)), H.attr({ visibility: !D.visible && (D.visible || D.isNull) ? "hidden" : "inherit" }), H.animate = function(F, U, Y) {
                    let q = b(F["stroke-width"]) && !b(H["stroke-width"]), N = b(H["stroke-width"]) && !b(F["stroke-width"]);
                    if (q || N) {
                      let X = t(i.getStrokeWidth(i.options), 1) / (g.mapView && g.mapView.getScale() || 1);
                      q && (H["stroke-width"] = X), N && (F["stroke-width"] = X);
                    }
                    return G.call(H, F, U, N ? function() {
                      H.element.removeAttribute("stroke-width"), delete H["stroke-width"], Y && Y.apply(this, arguments);
                    } : Y);
                  };
                }
              })), k.forEach((D, H) => {
                let G = (H === 0 ? j : j.insets[H - 1]).getSVGTransform(), V = t(this.getStrokeWidth(this.options), 1), F = G.scaleX, U = G.scaleY > 0 ? 1 : -1, Y = (q) => {
                  (i.points || []).forEach((N) => {
                    let X, W = N.graphic;
                    W && W["stroke-width"] && (X = this.getStrokeWidth(N.options)) && W.attr({ "stroke-width": X / q });
                  });
                };
                if (P.globalAnimation && g.hasRendered && j.allowTransformAnimation) {
                  let q = Number(D.attr("translateX")), N = Number(D.attr("translateY")), X = Number(D.attr("scaleX")), W = (J, $) => {
                    let et = X + (F - X) * $.pos;
                    D.attr({ translateX: q + (G.translateX - q) * $.pos, translateY: N + (G.translateY - N) * $.pos, scaleX: et, scaleY: et * U, "stroke-width": V / et }), Y(et);
                  }, _ = C(l(P.globalAnimation)), K = _.step;
                  _.step = function() {
                    K && K.apply(this, arguments), W.apply(this, arguments);
                  }, D.attr({ animator: 0 }).animate({ animator: 1 }, _, (function() {
                    typeof P.globalAnimation != "boolean" && P.globalAnimation.complete && P.globalAnimation.complete({ applyDrilldown: !0 }), a(this, "mapZoomComplete");
                  }).bind(this));
                } else u(D), D.attr(C(G, { "stroke-width": V / F })), Y(F);
              }), this.isDrilling || this.drawMapDataLabels();
            }
          }
          getProjectedBounds() {
            if (!this.bounds && this.chart.mapView) {
              let { insets: i, projection: g } = this.chart.mapView, m = [];
              (this.points || []).forEach((k) => {
                if (k.path || k.geometry) {
                  if (typeof k.path == "string" ? k.path = v(k.path) : S(k.path) && k.path[0] === "M" && (k.path = this.chart.renderer.pathToSegments(k.path)), !k.bounds) {
                    let j = k.getProjectedBounds(g);
                    if (j) {
                      k.labelrank = t(k.labelrank, (j.x2 - j.x1) * (j.y2 - j.y1));
                      let { midX: P, midY: D } = j;
                      if (i && b(P) && b(D)) {
                        let H = h(i, (G) => G.isInside({ x: P, y: D }));
                        H && (delete k.projectedPath, (j = k.getProjectedBounds(H.projection)) && H.allBounds.push(j), k.insetIndex = i.indexOf(H));
                      }
                      k.bounds = j;
                    }
                  }
                  k.bounds && k.insetIndex === void 0 && m.push(k.bounds);
                }
              }), this.bounds = M.compositeBounds(m);
            }
            return this.bounds;
          }
          getStrokeWidth(i) {
            let g = this.pointAttrToOptions;
            return i[g && g["stroke-width"] || "borderWidth"];
          }
          hasData() {
            return !!this.processedXData.length;
          }
          pointAttribs(i, g) {
            let { mapView: m, styledMode: k } = i.series.chart, j = k ? this.colorAttribs(i) : s.prototype.pointAttribs.call(this, i, g), P = this.getStrokeWidth(i.options);
            if (g) {
              let H = C(this.options.states && this.options.states[g], i.options.states && i.options.states[g] || {}), G = this.getStrokeWidth(H);
              E(G) && (P = G), j.stroke = H.borderColor ?? i.color;
            }
            P && m && (P /= m.getScale());
            let D = this.getStrokeWidth(this.options);
            return j.dashstyle && m && b(D) && (P = D / m.getScale()), i.visible || (j.fill = this.options.nullColor), E(P) ? j["stroke-width"] = P : delete j["stroke-width"], j["stroke-linecap"] = j["stroke-linejoin"] = this.options.linecap, j;
          }
          updateData() {
            return !this.processedData && super.updateData.apply(this, arguments);
          }
          setData(i, g = !0, m, k) {
            delete this.bounds, super.setData(i, !1, void 0, k), this.processData(), this.generatePoints(), g && this.chart.redraw(m);
          }
          processData() {
            let i, g, m, k = this.options, j = k.data, P = this.chart, D = P.options.chart, H = this.joinBy, G = k.keys || this.pointArrayMap, V = [], F = {}, U = this.chart.mapView, Y = U && (p(k.mapData, !0) ? U.getGeoMap(k.mapData) : U.geoMap), q = P.mapTransforms = D.mapTransforms || Y && Y["hc-transform"] || P.mapTransforms;
            q && o(q, (X) => {
              X.rotation && (X.cosAngle = Math.cos(X.rotation), X.sinAngle = Math.sin(X.rotation));
            }), S(k.mapData) ? m = k.mapData : Y && Y.type === "FeatureCollection" && (this.mapTitle = Y.title, m = R.geojson(Y, this.type, this)), this.processedData = [];
            let N = this.processedData;
            if (j) {
              let X;
              for (let W = 0, _ = j.length; W < _; ++W) {
                if (b(X = j[W])) N[W] = { value: X };
                else if (S(X)) {
                  let K = 0;
                  N[W] = {}, !k.keys && X.length > G.length && typeof X[0] == "string" && (N[W]["hc-key"] = X[0], ++K);
                  for (let J = 0; J < G.length; ++J, ++K) G[J] && X[K] !== void 0 && (G[J].indexOf(".") > 0 ? O.prototype.setNestedProperty(N[W], X[K], G[J]) : N[W][G[J]] = X[K]);
                } else N[W] = j[W];
                H && H[0] === "_i" && (N[W]._i = W);
              }
            }
            if (m) {
              this.mapData = m, this.mapMap = {};
              for (let X = 0; X < m.length; X++) g = (i = m[X]).properties, i._i = X, H[0] && g && g[H[0]] && (i[H[0]] = g[H[0]]), F[i[H[0]]] = i;
              if (this.mapMap = F, H[1]) {
                let X = H[1];
                N.forEach((W) => {
                  let _ = x(X, W);
                  F[_] && V.push(F[_]);
                });
              }
              if (k.allAreas) {
                if (H[1]) {
                  let W = H[1];
                  N.forEach((_) => {
                    V.push(x(W, _));
                  });
                }
                let X = "|" + V.map(function(W) {
                  return W && W[H[0]];
                }).join("|") + "|";
                m.forEach((W) => {
                  H[0] && X.indexOf("|" + W[H[0]] + "|") !== -1 || N.push(C(W, { value: null }));
                });
              }
            }
            this.processedXData = Array(N.length);
          }
          setOptions(i) {
            let g = super.setOptions(i), m = g.joinBy;
            return g.joinBy === null && (m = "_i"), (m = this.joinBy = e(m))[1] || (m[1] = m[0]), g;
          }
          translate() {
            let i = this.doFullTranslate(), g = this.chart.mapView, m = g && g.projection;
            if (this.chart.hasRendered && (this.isDirtyData || !this.hasRendered) && (this.processData(), this.generatePoints(), delete this.bounds, !g || g.userOptions.center || b(g.userOptions.zoom) || g.zoom !== g.minZoom ? this.getProjectedBounds() : g.fitToBounds(void 0, void 0, !1)), g) {
              let k = g.getSVGTransform();
              this.points.forEach((j) => {
                let P = b(j.insetIndex) && g.insets[j.insetIndex].getSVGTransform() || k;
                P && j.bounds && b(j.bounds.midX) && b(j.bounds.midY) && (j.plotX = j.bounds.midX * P.scaleX + P.translateX, j.plotY = j.bounds.midY * P.scaleY + P.translateY), i && (j.shapeType = "path", j.shapeArgs = { d: O.getProjectedPath(j, m) }), j.hiddenInDataClass || (j.projectedPath && !j.projectedPath.length ? j.setVisible(!1) : j.visible || j.setVisible(!0));
              });
            }
            a(this, "afterTranslate");
          }
          update(i) {
            var g;
            i.mapData && ((g = this.chart.mapView) == null || g.recommendMapView(this.chart, [this.chart.options.chart.map, ...(this.chart.options.series || []).map((m, k) => k === this._i ? i.mapData : m.mapData)], !0)), super.update.apply(this, arguments);
          }
        }
        return n.defaultOptions = C(f.defaultOptions, L), y(n.prototype, { type: "map", axisTypes: B.seriesMembers.axisTypes, colorAttribs: B.seriesMembers.colorAttribs, colorKey: B.seriesMembers.colorKey, directTouch: !0, drawDataLabels: c, drawGraph: c, forceDL: !0, getCenter: I.getCenter, getExtremesFromAll: !0, getSymbol: c, isCartesian: !1, parallelArrays: B.seriesMembers.parallelArrays, pointArrayMap: B.seriesMembers.pointArrayMap, pointClass: O, preserveAspectRatio: !0, searchPoint: c, trackerGroups: B.seriesMembers.trackerGroups, useMapGeometry: !0 }), B.compose(n), w.registerSeriesType("map", n), n;
      }), Z(r, "Series/MapLine/MapLineSeriesDefaults.js", [], function() {
        return { lineWidth: 1, fillColor: "none", legendSymbol: "lineMarker" };
      }), Z(r, "Series/MapLine/MapLineSeries.js", [r["Series/MapLine/MapLineSeriesDefaults.js"], r["Series/Map/MapSeries.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { extend: z, merge: O } = R;
        class L extends B {
          pointAttribs(w, A) {
            let l = super.pointAttribs(w, A);
            return l.fill = this.options.fillColor, l;
          }
        }
        return L.defaultOptions = O(B.defaultOptions, T), z(L.prototype, { type: "mapline", colorProp: "stroke", pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" } }), I.registerSeriesType("mapline", L), L;
      }), Z(r, "Series/MapPoint/MapPointPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { scatter: I } = T.seriesTypes, { isNumber: R } = B;
        class z extends I.prototype.pointClass {
          isValid() {
            return !!(this.options.geometry || R(this.x) && R(this.y) || R(this.options.lon) && R(this.options.lat));
          }
        }
        return z;
      }), Z(r, "Series/MapPoint/MapPointSeriesDefaults.js", [], function() {
        return { dataLabels: { crop: !1, defer: !1, enabled: !0, formatter: function() {
          return this.point.name;
        }, overflow: !1, style: { color: "#000000" } }, legendSymbol: "lineMarker" };
      }), Z(r, "Series/MapPoint/MapPointSeries.js", [r["Core/Globals.js"], r["Series/MapPoint/MapPointPoint.js"], r["Series/MapPoint/MapPointSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { noop: L } = T, { map: M, scatter: w } = R.seriesTypes, { extend: A, fireEvent: l, isNumber: u, merge: c } = O;
        class v extends w {
          constructor() {
            super(...arguments), this.clearBounds = M.prototype.clearBounds;
          }
          drawDataLabels() {
            super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
          }
          projectPoint(f) {
            let y = this.chart.mapView;
            if (y) {
              let { geometry: h, lon: a, lat: x } = f, S = h && h.type === "Point" && h.coordinates;
              if (u(a) && u(x) && (S = [a, x]), S) return y.lonLatToProjectedUnits({ lon: S[0], lat: S[1] });
            }
          }
          translate() {
            let f = this.chart.mapView;
            if (this.processedXData || this.processData(), this.generatePoints(), this.getProjectedBounds && this.isDirtyData && (delete this.bounds, this.getProjectedBounds()), f) {
              let y = f.getSVGTransform(), { hasCoordinates: h } = f.projection;
              this.points.forEach((a) => {
                let x, { x: S, y: E } = a, b = u(a.insetIndex) && f.insets[a.insetIndex].getSVGTransform() || y, p = this.projectPoint(a.options) || a.properties && this.projectPoint(a.properties);
                if (p ? (S = p.x, E = p.y) : a.bounds && (S = a.bounds.midX, E = a.bounds.midY, b && u(S) && u(E) && (a.plotX = S * b.scaleX + b.translateX, a.plotY = E * b.scaleY + b.translateY, x = !0)), u(S) && u(E)) {
                  if (!x) {
                    let C = f.projectedUnitsToPixels({ x: S, y: E });
                    a.plotX = C.x, a.plotY = h ? C.y : this.chart.plotHeight - C.y;
                  }
                } else a.y = a.plotX = a.plotY = void 0;
                a.isInside = this.isPointInside(a), a.zone = this.zones.length ? a.getZone() : void 0;
              });
            }
            l(this, "afterTranslate");
          }
        }
        return v.defaultOptions = c(w.defaultOptions, I), z.prototype.symbols.mapmarker = (s, f, y, h, a) => {
          let x, S, E = a && a.context === "legend";
          E ? (x = s + y / 2, S = f + h) : a && typeof a.anchorX == "number" && typeof a.anchorY == "number" ? (x = a.anchorX, S = a.anchorY) : (x = s + y / 2, S = f + h / 2, f -= h);
          let b = E ? h / 3 : h / 2;
          return [["M", x, S], ["C", x, S, x - b, f + 1.5 * b, x - b, f + b], ["A", b, b, 1, 1, 1, x + b, f + b], ["C", x + b, f + 1.5 * b, x, S, x, S], ["Z"]];
        }, A(v.prototype, { type: "mappoint", axisTypes: ["colorAxis"], forceDL: !0, isCartesian: !1, pointClass: B, searchPoint: L, useMapGeometry: !0 }), R.registerSeriesType("mappoint", v), v;
      }), Z(r, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
        return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
      }), Z(r, "Series/Bubble/BubbleLegendItem.js", [r["Core/Color/Color.js"], r["Core/Templating.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { parse: z } = T, { noop: O } = I, { arrayMax: L, arrayMin: M, isNumber: w, merge: A, pick: l, stableSort: u } = R;
        return class {
          constructor(c, v) {
            this.setState = O, this.init(c, v);
          }
          init(c, v) {
            this.options = c, this.visible = !0, this.chart = v.chart, this.legend = v;
          }
          addToLegend(c) {
            c.splice(this.options.legendIndex, 0, this);
          }
          drawLegendSymbol(c) {
            let v, s = l(c.options.itemDistance, 20), f = this.legendItem || {}, y = this.options, h = y.ranges, a = y.connectorDistance;
            if (!h || !h.length || !w(h[0].value)) {
              c.options.bubbleLegend.autoRanges = !0;
              return;
            }
            u(h, function(b, p) {
              return p.value - b.value;
            }), this.ranges = h, this.setOptions(), this.render();
            let x = this.getMaxLabelSize(), S = this.ranges[0].radius, E = 2 * S;
            v = (v = a - S + x.width) > 0 ? v : 0, this.maxLabel = x, this.movementX = y.labels.align === "left" ? v : 0, f.labelWidth = E + v + s, f.labelHeight = E + x.height / 2;
          }
          setOptions() {
            let c = this.ranges, v = this.options, s = this.chart.series[v.seriesIndex], f = this.legend.baseline, y = { zIndex: v.zIndex, "stroke-width": v.borderWidth }, h = { zIndex: v.zIndex, "stroke-width": v.connectorWidth }, a = { align: this.legend.options.rtl || v.labels.align === "left" ? "right" : "left", zIndex: v.zIndex }, x = s.options.marker.fillOpacity, S = this.chart.styledMode;
            c.forEach(function(E, b) {
              S || (y.stroke = l(E.borderColor, v.borderColor, s.color), y.fill = l(E.color, v.color, x !== 1 ? z(s.color).setOpacity(x).get("rgba") : s.color), h.stroke = l(E.connectorColor, v.connectorColor, s.color)), c[b].radius = this.getRangeRadius(E.value), c[b] = A(c[b], { center: c[0].radius - c[b].radius + f }), S || A(!0, c[b], { bubbleAttribs: A(y), connectorAttribs: A(h), labelAttribs: a });
            }, this);
          }
          getRangeRadius(c) {
            let v = this.options, s = this.options.seriesIndex, f = this.chart.series[s], y = v.ranges[0].value, h = v.ranges[v.ranges.length - 1].value, a = v.minSize, x = v.maxSize;
            return f.getRadius.call(this, h, y, a, x, c);
          }
          render() {
            let c = this.legendItem || {}, v = this.chart.renderer, s = this.options.zThreshold;
            for (let f of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), c.symbol = v.g("bubble-legend"), c.label = v.g("bubble-legend-item").css(this.legend.itemStyle || {}), c.symbol.translateX = 0, c.symbol.translateY = 0, c.symbol.add(c.label), c.label.add(c.group), this.ranges)) f.value >= s && this.renderRange(f);
            this.hideOverlappingLabels();
          }
          renderRange(c) {
            let v = this.ranges[0], s = this.legend, f = this.options, y = f.labels, h = this.chart, a = h.series[f.seriesIndex], x = h.renderer, S = this.symbols, E = S.labels, b = c.center, p = Math.abs(c.radius), C = f.connectorDistance || 0, o = y.align, t = s.options.rtl, e = f.borderWidth, n = f.connectorWidth, d = v.radius || 0, i = b - p - e / 2 + n / 2, g = (i % 1 ? 1 : 0.5) - (n % 2 ? 0 : 0.5), m = x.styledMode, k = t || o === "left" ? -C : C;
            o === "center" && (k = 0, f.connectorDistance = 0, c.labelAttribs.align = "center"), S.bubbleItems.push(x.circle(d, b + g, p).attr(m ? {} : c.bubbleAttribs).addClass((m ? "highcharts-color-" + a.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (f.className || "")).add(this.legendItem.symbol)), S.connectors.push(x.path(x.crispLine([["M", d, i], ["L", d + k, i]], f.connectorWidth)).attr(m ? {} : c.connectorAttribs).addClass((m ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (f.connectorClassName || "")).add(this.legendItem.symbol));
            let j = x.text(this.formatLabel(c)).attr(m ? {} : c.labelAttribs).css(m ? {} : y.style).addClass("highcharts-bubble-legend-labels " + (f.labels.className || "")).add(this.legendItem.symbol), P = { x: d + k + f.labels.x, y: i + f.labels.y + 0.4 * j.getBBox().height };
            j.attr(P), E.push(j), j.placed = !0, j.alignAttr = P;
          }
          getMaxLabelSize() {
            let c, v;
            return this.symbols.labels.forEach(function(s) {
              v = s.getBBox(!0), c = c ? v.width > c.width ? v : c : v;
            }), c || {};
          }
          formatLabel(c) {
            let v = this.options, s = v.labels.formatter, f = v.labels.format, { numberFormatter: y } = this.chart;
            return f ? B.format(f, c) : s ? s.call(c) : y(c.value, 1);
          }
          hideOverlappingLabels() {
            let c = this.chart, v = this.options.labels.allowOverlap, s = this.symbols;
            !v && s && (c.hideOverlappingLabels(s.labels), s.labels.forEach(function(f, y) {
              f.newOpacity ? f.newOpacity !== f.oldOpacity && s.connectors[y].show() : s.connectors[y].hide();
            }));
          }
          getRanges() {
            let c = this.legend.bubbleLegend, v = c.chart.series, s = c.options.ranges, f, y, h = Number.MAX_VALUE, a = -Number.MAX_VALUE;
            return v.forEach(function(x) {
              x.isBubble && !x.ignoreSeries && (y = x.zData.filter(w)).length && (h = l(x.options.zMin, Math.min(h, Math.max(M(y), x.options.displayNegative === !1 ? x.options.zThreshold : -Number.MAX_VALUE))), a = l(x.options.zMax, Math.max(a, L(y))));
            }), f = h === a ? [{ value: a }] : [{ value: h }, { value: (h + a) / 2 }, { value: a, autoRanges: !0 }], s.length && s[0].radius && f.reverse(), f.forEach(function(x, S) {
              s && s[S] && (f[S] = A(s[S], x));
            }), f;
          }
          predictBubbleSizes() {
            let c = this.chart, v = c.legend.options, s = v.floating, f = v.layout === "horizontal", y = f ? c.legend.lastLineHeight : 0, h = c.plotSizeX, a = c.plotSizeY, x = c.series[this.options.seriesIndex], S = x.getPxExtremes(), E = Math.ceil(S.minPxSize), b = Math.ceil(S.maxPxSize), p = Math.min(a, h), C, o = x.options.maxSize;
            return s || !/%$/.test(o) ? C = b : (C = (p + y) * (o = parseFloat(o)) / 100 / (o / 100 + 1), (f && a - C >= h || !f && h - C >= a) && (C = b)), [E, Math.ceil(C)];
          }
          updateRanges(c, v) {
            let s = this.legend.options.bubbleLegend;
            s.minSize = c, s.maxSize = v, s.ranges = this.getRanges();
          }
          correctSizes() {
            let c = this.legend, v = this.chart.series[this.options.seriesIndex].getPxExtremes();
            Math.abs(Math.ceil(v.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, v.maxPxSize), c.render());
          }
        };
      }), Z(r, "Series/Bubble/BubbleLegendComposition.js", [r["Series/Bubble/BubbleLegendDefaults.js"], r["Series/Bubble/BubbleLegendItem.js"], r["Core/Defaults.js"], r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B, I, R, z) {
        let { setOptions: O } = I, { composed: L } = R, { addEvent: M, objectEach: w, pushUnique: A, wrap: l } = z;
        function u(h, a, x) {
          let S, E, b, p = this.legend, C = c(this) >= 0;
          p && p.options.enabled && p.bubbleLegend && p.options.bubbleLegend.autoRanges && C ? (S = p.bubbleLegend.options, E = p.bubbleLegend.predictBubbleSizes(), p.bubbleLegend.updateRanges(E[0], E[1]), S.placed || (p.group.placed = !1, p.allItems.forEach((o) => {
            (b = o.legendItem || {}).group && (b.group.translateY = void 0);
          })), p.render(), S.placed || (this.getMargins(), this.axes.forEach(function(o) {
            o.visible && o.render(), S.placed || (o.setScale(), o.updateNames(), w(o.ticks, function(t) {
              t.isNew = !0, t.isNewLabel = !0;
            }));
          }), this.getMargins()), S.placed = !0, h.call(this, a, x), p.bubbleLegend.correctSizes(), y(p, v(p))) : (h.call(this, a, x), p && p.options.enabled && p.bubbleLegend && (p.render(), y(p, v(p))));
        }
        function c(h) {
          let a = h.series, x = 0;
          for (; x < a.length; ) {
            if (a[x] && a[x].isBubble && a[x].visible && a[x].zData.length) return x;
            x++;
          }
          return -1;
        }
        function v(h) {
          let a = h.allItems, x = [], S = a.length, E, b, p, C = 0, o = 0;
          for (C = 0; C < S; C++) if (b = a[C].legendItem || {}, p = (a[C + 1] || {}).legendItem || {}, b.labelHeight && (a[C].itemHeight = b.labelHeight), a[C] === a[S - 1] || b.y !== p.y) {
            for (x.push({ height: 0 }), E = x[x.length - 1]; o <= C; o++) a[o].itemHeight > E.height && (E.height = a[o].itemHeight);
            E.step = C;
          }
          return x;
        }
        function s(h) {
          let a = this.bubbleLegend, x = this.options, S = x.bubbleLegend, E = c(this.chart);
          a && a.ranges && a.ranges.length && (S.ranges.length && (S.autoRanges = !!S.ranges[0].autoRanges), this.destroyItem(a)), E >= 0 && x.enabled && S.enabled && (S.seriesIndex = E, this.bubbleLegend = new B(S, this), this.bubbleLegend.addToLegend(h.allItems));
        }
        function f(h) {
          let a;
          if (h.defaultPrevented) return !1;
          let x = h.legendItem, S = this.chart, E = x.visible;
          this && this.bubbleLegend && (x.visible = !E, x.ignoreSeries = E, a = c(S) >= 0, this.bubbleLegend.visible !== a && (this.update({ bubbleLegend: { enabled: a } }), this.bubbleLegend.visible = a), x.visible = E);
        }
        function y(h, a) {
          let x = h.allItems, S = h.options.rtl, E, b, p, C, o = 0;
          x.forEach((t, e) => {
            (C = t.legendItem || {}).group && (E = C.group.translateX || 0, b = C.y || 0, ((p = t.movementX) || S && t.ranges) && (p = S ? E - t.options.maxSize / 2 : E + p, C.group.attr({ translateX: p })), e > a[o].step && o++, C.group.attr({ translateY: Math.round(b + a[o].height / 2) }), C.y = b + a[o].height / 2);
          });
        }
        return { compose: function(h, a) {
          A(L, "Series.BubbleLegend") && (O({ legend: { bubbleLegend: T } }), l(h.prototype, "drawChartBox", u), M(a, "afterGetAllItems", s), M(a, "itemClick", f));
        } };
      }), Z(r, "Series/Bubble/BubblePoint.js", [r["Core/Series/Point.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { seriesTypes: { scatter: { prototype: { pointClass: R } } } } = B, { extend: z } = I;
        class O extends R {
          haloPath(M) {
            let w = (M && this.marker && this.marker.radius || 0) + M;
            if (this.series.chart.inverted) {
              let A = this.pos() || [0, 0], { xAxis: l, yAxis: u, chart: c } = this.series;
              return c.renderer.symbols.circle(l.len - A[1] - w, u.len - A[0] - w, 2 * w, 2 * w);
            }
            return T.prototype.haloPath.call(this, w);
          }
        }
        return z(O.prototype, { ttBelow: !1 }), O;
      }), Z(r, "Series/Bubble/BubbleSeries.js", [r["Series/Bubble/BubbleLegendComposition.js"], r["Series/Bubble/BubblePoint.js"], r["Core/Color/Color.js"], r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { parse: L } = I, { composed: M, noop: w } = R, { series: A, seriesTypes: { column: { prototype: l }, scatter: u } } = z, { addEvent: c, arrayMax: v, arrayMin: s, clamp: f, extend: y, isNumber: h, merge: a, pick: x, pushUnique: S } = O;
        function E() {
          let p = this.len, { coll: C, isXAxis: o, min: t } = this, e = o ? "xData" : "yData", n = (this.max || 0) - (t || 0), d = 0, i = p, g = p / n, m;
          (C === "xAxis" || C === "yAxis") && (this.series.forEach((k) => {
            if (k.bubblePadding && k.reserveSpace()) {
              this.allowZoomOutside = !0, m = !0;
              let j = k[e];
              if (o && ((k.onPoint || k).getRadii(0, 0, k), k.onPoint && (k.radii = k.onPoint.radii)), n > 0) {
                let P = j.length;
                for (; P--; ) if (h(j[P]) && this.dataMin <= j[P] && j[P] <= this.max) {
                  let D = k.radii && k.radii[P] || 0;
                  d = Math.min((j[P] - t) * g - D, d), i = Math.max((j[P] - t) * g + D, i);
                }
              }
            }
          }), m && n > 0 && !this.logarithmic && (i -= p, g *= (p + Math.max(0, d) - Math.min(i, p)) / p, [["min", "userMin", d], ["max", "userMax", i]].forEach((k) => {
            x(this.options[k[0]], this[k[1]]) === void 0 && (this[k[0]] += k[2] / g);
          })));
        }
        class b extends u {
          static compose(C, o, t) {
            T.compose(o, t), S(M, "Series.Bubble") && c(C, "foundExtremes", E);
          }
          animate(C) {
            !C && this.points.length < this.options.animationLimit && this.points.forEach(function(o) {
              let { graphic: t, plotX: e = 0, plotY: n = 0 } = o;
              t && t.width && (this.hasRendered || t.attr({ x: e, y: n, width: 1, height: 1 }), t.animate(this.markerAttribs(o), this.options.animation));
            }, this);
          }
          getRadii() {
            let C = this.zData, o = this.yData, t = [], e, n, d, i = this.chart.bubbleZExtremes, { minPxSize: g, maxPxSize: m } = this.getPxExtremes();
            if (!i) {
              let k, j = Number.MAX_VALUE, P = -Number.MAX_VALUE;
              this.chart.series.forEach((D) => {
                if (D.bubblePadding && D.reserveSpace()) {
                  let H = (D.onPoint || D).getZExtremes();
                  H && (j = Math.min(x(j, H.zMin), H.zMin), P = Math.max(x(P, H.zMax), H.zMax), k = !0);
                }
              }), k ? (i = { zMin: j, zMax: P }, this.chart.bubbleZExtremes = i) : i = { zMin: 0, zMax: 0 };
            }
            for (n = 0, e = C.length; n < e; n++) d = C[n], t.push(this.getRadius(i.zMin, i.zMax, g, m, d, o && o[n]));
            this.radii = t;
          }
          getRadius(C, o, t, e, n, d) {
            let i = this.options, g = i.sizeBy !== "width", m = i.zThreshold, k = o - C, j = 0.5;
            if (d === null || n === null) return null;
            if (h(n)) {
              if (i.sizeByAbsoluteValue && (n = Math.abs(n - m), o = k = Math.max(o - m, Math.abs(C - m)), C = 0), n < C) return t / 2 - 1;
              k > 0 && (j = (n - C) / k);
            }
            return g && j >= 0 && (j = Math.sqrt(j)), Math.ceil(t + j * (e - t)) / 2;
          }
          hasData() {
            return !!this.processedXData.length;
          }
          markerAttribs(C, o) {
            let t = super.markerAttribs(C, o), { height: e = 0, width: n = 0 } = t;
            return this.chart.inverted ? y(t, { x: (C.plotX || 0) - n / 2, y: (C.plotY || 0) - e / 2 }) : t;
          }
          pointAttribs(C, o) {
            let t = this.options.marker.fillOpacity, e = A.prototype.pointAttribs.call(this, C, o);
            return t !== 1 && (e.fill = L(e.fill).setOpacity(t).get("rgba")), e;
          }
          translate() {
            super.translate.call(this), this.getRadii(), this.translateBubble();
          }
          translateBubble() {
            let { data: C, options: o, radii: t } = this, { minPxSize: e } = this.getPxExtremes(), n = C.length;
            for (; n--; ) {
              let d = C[n], i = t ? t[n] : 0;
              this.zoneAxis === "z" && (d.negative = (d.z || 0) < (o.zThreshold || 0)), h(i) && i >= e / 2 ? (d.marker = y(d.marker, { radius: i, width: 2 * i, height: 2 * i }), d.dlBox = { x: d.plotX - i, y: d.plotY - i, width: 2 * i, height: 2 * i }) : (d.shapeArgs = d.plotY = d.dlBox = void 0, d.isInside = !1);
            }
          }
          getPxExtremes() {
            let C = Math.min(this.chart.plotWidth, this.chart.plotHeight), o = (n) => {
              let d;
              return typeof n == "string" && (d = /%$/.test(n), n = parseInt(n, 10)), d ? C * n / 100 : n;
            }, t = o(x(this.options.minSize, 8)), e = Math.max(o(x(this.options.maxSize, "20%")), t);
            return { minPxSize: t, maxPxSize: e };
          }
          getZExtremes() {
            let C = this.options, o = (this.zData || []).filter(h);
            if (o.length) {
              let t = x(C.zMin, f(s(o), C.displayNegative === !1 ? C.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), e = x(C.zMax, v(o));
              if (h(t) && h(e)) return { zMin: t, zMax: e };
            }
          }
        }
        return b.defaultOptions = a(u.defaultOptions, { dataLabels: { formatter: function() {
          let { numberFormatter: p } = this.series.chart, { z: C } = this.point;
          return h(C) ? p(C, -1) : "";
        }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), y(b.prototype, { alignDataLabel: l.alignDataLabel, applyZones: w, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: B, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), c(b, "updatedData", (p) => {
          delete p.target.chart.bubbleZExtremes;
        }), c(b, "remove", (p) => {
          delete p.target.chart.bubbleZExtremes;
        }), z.registerSeriesType("bubble", b), b;
      }), Z(r, "Series/MapBubble/MapBubblePoint.js", [r["Series/Bubble/BubblePoint.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { seriesTypes: { map: { prototype: { pointClass: { prototype: R } } } } } = B, { extend: z } = I;
        class O extends T {
          isValid() {
            return typeof this.z == "number";
          }
        }
        return z(O.prototype, { applyOptions: R.applyOptions, getProjectedBounds: R.getProjectedBounds }), O;
      }), Z(r, "Series/MapBubble/MapBubbleSeries.js", [r["Series/Bubble/BubbleSeries.js"], r["Series/MapBubble/MapBubblePoint.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R) {
        let { seriesTypes: { map: { prototype: z }, mappoint: { prototype: O } } } = I, { extend: L, merge: M } = R;
        class w extends T {
          constructor() {
            super(...arguments), this.clearBounds = z.clearBounds;
          }
          searchPoint(l, u) {
            return this.searchKDTree({ plotX: l.chartX - this.chart.plotLeft, plotY: l.chartY - this.chart.plotTop }, u, l);
          }
          translate() {
            O.translate.call(this), this.getRadii(), this.translateBubble();
          }
          updateParallelArrays(l, u, c) {
            super.updateParallelArrays.call(this, l, u, c);
            let v = this.processedXData, s = this.xData;
            v && s && (v.length = s.length);
          }
        }
        return w.defaultOptions = M(T.defaultOptions, { lineWidth: 0, animationLimit: 500, joinBy: "hc-key", tooltip: { pointFormat: "{point.name}: {point.z}" } }), L(w.prototype, { type: "mapbubble", axisTypes: ["colorAxis"], getProjectedBounds: z.getProjectedBounds, isCartesian: !1, pointArrayMap: ["z"], pointClass: B, processData: z.processData, projectPoint: O.projectPoint, kdAxisArray: ["plotX", "plotY"], setData: z.setData, setOptions: z.setOptions, updateData: z.updateData, useMapGeometry: !0, xyFromShape: !0 }), I.registerSeriesType("mapbubble", w), w;
      }), Z(r, "Series/Heatmap/HeatmapPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { scatter: { prototype: { pointClass: I } } } = T.seriesTypes, { clamp: R, defined: z, extend: O, pick: L } = B;
        class M extends I {
          applyOptions(A, l) {
            return (this.isNull || this.value === null) && delete this.color, super.applyOptions(A, l), this.formatPrefix = this.isNull || this.value === null ? "null" : "point", this;
          }
          getCellAttributes() {
            let A = this.series, l = A.options, u = (l.colsize || 1) / 2, c = (l.rowsize || 1) / 2, v = A.xAxis, s = A.yAxis, f = this.options.marker || A.options.marker, y = A.pointPlacementToXValue(), h = L(this.pointPadding, l.pointPadding, 0), a = { x1: R(Math.round(v.len - v.translate(this.x - u, !1, !0, !1, !0, -y)), -v.len, 2 * v.len), x2: R(Math.round(v.len - v.translate(this.x + u, !1, !0, !1, !0, -y)), -v.len, 2 * v.len), y1: R(Math.round(s.translate(this.y - c, !1, !0, !1, !0)), -s.len, 2 * s.len), y2: R(Math.round(s.translate(this.y + c, !1, !0, !1, !0)), -s.len, 2 * s.len) };
            for (let x of [["width", "x"], ["height", "y"]]) {
              let S = x[0], E = x[1], b = E + "1", p = E + "2", C = Math.abs(a[b] - a[p]), o = f && f.lineWidth || 0, t = Math.abs(a[b] + a[p]) / 2, e = f && f[S];
              if (z(e) && e < C) {
                let n = e / 2 + o / 2;
                a[b] = t - n, a[p] = t + n;
              }
              h && ((E === "x" && v.reversed || E === "y" && !s.reversed) && (b = p, p = E + "1"), a[b] += h, a[p] -= h);
            }
            return a;
          }
          haloPath(A) {
            if (!A) return [];
            let { x: l = 0, y: u = 0, width: c = 0, height: v = 0 } = this.shapeArgs || {};
            return [["M", l - A, u - A], ["L", l - A, u + v + A], ["L", l + c + A, u + v + A], ["L", l + c + A, u - A], ["Z"]];
          }
          isValid() {
            return this.value !== 1 / 0 && this.value !== -1 / 0;
          }
        }
        return O(M.prototype, { dataLabelOnNull: !0, moveToTopOnHover: !0, ttBelow: !1 }), M;
      }), Z(r, "Series/Heatmap/HeatmapSeriesDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { isNumber: B } = T;
        return { animation: !1, borderRadius: 0, borderWidth: 0, interpolation: !1, nullColor: "#f7f7f7", dataLabels: { formatter: function() {
          let { numberFormatter: I } = this.series.chart, { value: R } = this.point;
          return B(R) ? I(R, -1) : "";
        }, inside: !0, verticalAlign: "middle", crop: !1, overflow: "allow", padding: 0 }, marker: { symbol: "rect", radius: 0, lineColor: void 0, states: { hover: { lineWidthPlus: 0 }, select: {} } }, clip: !0, pointRange: null, tooltip: { pointFormat: "{point.x}, {point.y}: {point.value}<br/>" }, states: { hover: { halo: !1, brightness: 0.2 } }, legendSymbol: "rectangle" };
      }), Z(r, "Series/InterpolationUtilities.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I } = T, { defined: R, pick: z } = B;
        return { colorFromPoint: function(O, L) {
          let M = L.series.colorAxis;
          if (M) {
            let w = M.toColor(O || 0, L).split(")")[0].split("(")[1].split(",").map((A) => z(parseFloat(A), parseInt(A, 10)));
            return w[3] = 255 * z(w[3], 1), R(O) && L.visible || (w[3] = 0), w;
          }
          return [0, 0, 0, 0];
        }, getContext: function(O) {
          let { canvas: L, context: M } = O;
          return L && M ? (M.clearRect(0, 0, L.width, L.height), M) : (O.canvas = I.createElement("canvas"), O.context = O.canvas.getContext("2d", { willReadFrequently: !0 }) || void 0, O.context);
        } };
      }), Z(r, "Series/Heatmap/HeatmapSeries.js", [r["Core/Color/Color.js"], r["Series/ColorMapComposition.js"], r["Series/Heatmap/HeatmapPoint.js"], r["Series/Heatmap/HeatmapSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"], r["Series/InterpolationUtilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { series: w, seriesTypes: { column: A, scatter: l } } = z, { prototype: { symbols: u } } = O, { addEvent: c, extend: v, fireEvent: s, isNumber: f, merge: y, pick: h } = L, { colorFromPoint: a, getContext: x } = M;
        class S extends l {
          constructor() {
            super(...arguments), this.valueMax = NaN, this.valueMin = NaN, this.isDirtyCanvas = !0;
          }
          drawPoints() {
            let b = this, p = b.options, C = p.interpolation, o = p.marker || {};
            if (C) {
              let { image: t, chart: e, xAxis: n, yAxis: d } = b, { reversed: i = !1, len: g } = n, { reversed: m = !1, len: k } = d, j = { width: g, height: k };
              if (!t || b.isDirtyData || b.isDirtyCanvas) {
                let P = x(b), { canvas: D, options: { colsize: H = 1, rowsize: G = 1 }, points: V, points: { length: F } } = b, U = e.colorAxis && e.colorAxis[0];
                if (D && P && U) {
                  let { min: Y, max: q } = n.getExtremes(), { min: N, max: X } = d.getExtremes(), W = q - Y, _ = X - N, K = Math.round(W / H / 8 * 8), J = Math.round(_ / G / 8 * 8), [$, et] = [[K, K / W, i, "ceil"], [J, J / _, !m, "floor"]].map(([ot, nt, ht, ct]) => ht ? (dt) => Math[ct](ot - nt * dt) : (dt) => Math[ct](nt * dt)), st = D.width = K + 1, at = st * (D.height = J + 1), lt = (F - 1) / at, it = new Uint8ClampedArray(4 * at), Q = (ot, nt) => 4 * Math.ceil(st * et(nt - N) + $(ot - Y));
                  b.buildKDTree();
                  for (let ot = 0; ot < at; ot++) {
                    let nt = V[Math.ceil(lt * ot)], { x: ht, y: ct } = nt;
                    it.set(a(nt.value, nt), Q(ht, ct));
                  }
                  P.putImageData(new ImageData(it, st), 0, 0), t ? t.attr({ ...j, href: D.toDataURL("image/png", 1) }) : (b.directTouch = !1, b.image = e.renderer.image(D.toDataURL("image/png", 1)).attr(j).add(b.group));
                }
                b.isDirtyCanvas = !1;
              } else (t.width !== g || t.height !== k) && t.attr(j);
            } else (o.enabled || b._hasPointMarkers) && (w.prototype.drawPoints.call(b), b.points.forEach((t) => {
              t.graphic && (t.graphic[b.chart.styledMode ? "css" : "animate"](b.colorAttribs(t)), t.value === null && t.graphic.addClass("highcharts-null-point"));
            }));
          }
          getExtremes() {
            let { dataMin: b, dataMax: p } = w.prototype.getExtremes.call(this, this.valueData);
            return f(b) && (this.valueMin = b), f(p) && (this.valueMax = p), w.prototype.getExtremes.call(this);
          }
          getValidPoints(b, p) {
            return w.prototype.getValidPoints.call(this, b, p, !0);
          }
          hasData() {
            return !!this.xData;
          }
          init() {
            super.init.apply(this, arguments);
            let b = this.options;
            b.pointRange = h(b.pointRange, b.colsize || 1), this.yAxis.axisPointRange = b.rowsize || 1, u.ellipse = u.circle, b.marker && f(b.borderRadius) && (b.marker.r = b.borderRadius);
          }
          markerAttribs(b, p) {
            let C = b.shapeArgs || {};
            if (b.hasImage) return { x: b.plotX, y: b.plotY };
            if (p && p !== "normal") {
              let o = b.options.marker || {}, t = this.options.marker || {}, e = t.states && t.states[p] || {}, n = o.states && o.states[p] || {}, d = (n.width || e.width || C.width || 0) + (n.widthPlus || e.widthPlus || 0), i = (n.height || e.height || C.height || 0) + (n.heightPlus || e.heightPlus || 0);
              return { x: (C.x || 0) + ((C.width || 0) - d) / 2, y: (C.y || 0) + ((C.height || 0) - i) / 2, width: d, height: i };
            }
            return C;
          }
          pointAttribs(b, p) {
            let C = w.prototype.pointAttribs.call(this, b, p), o = this.options || {}, t = this.chart.options.plotOptions || {}, e = t.series || {}, n = t.heatmap || {}, d = b && b.options.borderColor || o.borderColor || n.borderColor || e.borderColor, i = b && b.options.borderWidth || o.borderWidth || n.borderWidth || e.borderWidth || C["stroke-width"];
            if (C.stroke = b && b.marker && b.marker.lineColor || o.marker && o.marker.lineColor || d || this.color, C["stroke-width"] = i, p && p !== "normal") {
              let g = y(o.states && o.states[p], o.marker && o.marker.states && o.marker.states[p], b && b.options.states && b.options.states[p] || {});
              C.fill = g.color || T.parse(C.fill).brighten(g.brightness || 0).get(), C.stroke = g.lineColor || C.stroke;
            }
            return C;
          }
          translate() {
            let { borderRadius: b, marker: p } = this.options, C = p && p.symbol || "rect", o = u[C] ? C : "rect", t = ["circle", "square"].indexOf(o) !== -1;
            if (!this.processedXData) {
              let { xData: e, yData: n } = this.getProcessedData();
              this.processedXData = e, this.processedYData = n;
            }
            for (let e of (this.generatePoints(), this.points)) {
              let n = e.getCellAttributes(), d = Math.min(n.x1, n.x2), i = Math.min(n.y1, n.y2), g = Math.max(Math.abs(n.x2 - n.x1), 0), m = Math.max(Math.abs(n.y2 - n.y1), 0);
              if (e.hasImage = (e.marker && e.marker.symbol || C).indexOf("url") === 0, t) {
                let k = Math.abs(g - m);
                d = Math.min(n.x1, n.x2) + (g < m ? 0 : k / 2), i = Math.min(n.y1, n.y2) + (g < m ? k / 2 : 0), g = m = Math.min(g, m);
              }
              e.hasImage && (e.marker = { width: g, height: m }), e.plotX = e.clientX = (n.x1 + n.x2) / 2, e.plotY = (n.y1 + n.y2) / 2, e.shapeType = "path", e.shapeArgs = y(!0, { x: d, y: i, width: g, height: m }, { d: u[o](d, i, g, m, { r: f(b) ? b : 0 }) });
            }
            s(this, "afterTranslate");
          }
        }
        return S.defaultOptions = y(l.defaultOptions, R), c(S, "afterDataClassLegendClick", function() {
          this.isDirtyCanvas = !0, this.drawPoints();
        }), v(S.prototype, { axisTypes: B.seriesMembers.axisTypes, colorKey: B.seriesMembers.colorKey, directTouch: !0, getExtremesFromAll: !0, parallelArrays: B.seriesMembers.parallelArrays, pointArrayMap: ["y", "value"], pointClass: I, specialGroup: "group", trackerGroups: B.seriesMembers.trackerGroups, alignDataLabel: A.prototype.alignDataLabel, colorAttribs: B.seriesMembers.colorAttribs, getSymbol: w.prototype.getSymbol }), B.compose(S), z.registerSeriesType("heatmap", S), S;
      }), Z(r, "masters/modules/map.src.js", [r["Core/Globals.js"], r["Maps/MapNavigation.js"], r["Series/ColorMapComposition.js"], r["Series/MapBubble/MapBubbleSeries.js"], r["Maps/GeoJSONComposition.js"], r["Core/Chart/MapChart.js"], r["Maps/MapView.js"], r["Maps/Projection.js"]], function(T, B, I, R, z, O, L, M) {
        return T.ColorMapComposition = I, T.MapChart = T.MapChart || O, T.MapNavigation = T.MapNavigation || B, T.MapView = T.MapView || L, T.Projection = T.Projection || M, T.mapChart = T.Map = T.MapChart.mapChart, T.maps = T.MapChart.maps, T.geojson = z.geojson, T.topo2geo = z.topo2geo, z.compose(T.Chart), R.compose(T.Axis, T.Chart, T.Legend), B.compose(O, T.Pointer, T.SVGRenderer), L.compose(O), T;
      });
    });
  }(Oe)), Oe.exports;
}
var zl = Nl();
const Fl = /* @__PURE__ */ It(zl);
var je = { exports: {} }, qs;
function Ul() {
  return qs || (qs = 1, function(rt) {
    /**
    * Highmaps JS v11.4.8 (2024-08-29)
    *
    * Tilemap module
    *
    * (c) 2010-2024 Highsoft AS
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Series/Tilemap/TilemapPoint.js", [r["Core/Axis/Color/ColorAxisComposition.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { series: { prototype: { pointClass: R } }, seriesTypes: { heatmap: { prototype: { pointClass: z } } } } = B, { extend: O } = I;
        class L extends z {
          haloPath() {
            return this.series.tileShape.haloPath.apply(this, arguments);
          }
        }
        return O(L.prototype, { setState: R.prototype.setState, setVisible: T.pointSetVisible }), L;
      }), Z(r, "Series/Tilemap/TilemapSeriesDefaults.js", [], function() {
        return { marker: null, states: { hover: { halo: { enabled: !0, size: 2, opacity: 0.5, attributes: { zIndex: 3 } } } }, pointPadding: 2, tileShape: "hexagon" };
      }), Z(r, "Series/Tilemap/TilemapShapes.js", [r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I) {
        let { noop: R } = T, { heatmap: z, scatter: O } = B.seriesTypes, { clamp: L, pick: M } = I;
        function w(A, l, u) {
          let c = A.options;
          return { xPad: -((c.colsize || 1) / l), yPad: -((c.rowsize || 1) / u) };
        }
        return { hexagon: { alignDataLabel: O.prototype.alignDataLabel, getSeriesPadding: function(A) {
          return w(A, 3, 2);
        }, haloPath: function(A) {
          if (!A) return [];
          let l = this.tileEdges;
          return [["M", l.x2 - A, l.y1 + A], ["L", l.x3 + A, l.y1 + A], ["L", l.x4 + 1.5 * A, l.y2], ["L", l.x3 + A, l.y3 - A], ["L", l.x2 - A, l.y3 - A], ["L", l.x1 - 1.5 * A, l.y2], ["Z"]];
        }, translate: function() {
          let A, l = this.options, u = this.xAxis, c = this.yAxis, v = l.pointPadding || 0, s = (l.colsize || 1) / 3, f = (l.rowsize || 1) / 2;
          for (let y of (this.generatePoints(), this.points)) {
            let h = L(Math.floor(u.len - u.translate(y.x - 2 * s, 0, 1, 0, 1)), -u.len, 2 * u.len), a = L(Math.floor(u.len - u.translate(y.x - s, 0, 1, 0, 1)), -u.len, 2 * u.len), x = L(Math.floor(u.len - u.translate(y.x + s, 0, 1, 0, 1)), -u.len, 2 * u.len), S = L(Math.floor(u.len - u.translate(y.x + 2 * s, 0, 1, 0, 1)), -u.len, 2 * u.len), E = L(Math.floor(c.translate(y.y - f, 0, 1, 0, 1)), -c.len, 2 * c.len), b = L(Math.floor(c.translate(y.y, 0, 1, 0, 1)), -c.len, 2 * c.len), p = L(Math.floor(c.translate(y.y + f, 0, 1, 0, 1)), -c.len, 2 * c.len), C = y.pointPadding ?? v, o = C * Math.abs(a - h) / Math.abs(p - b), t = u.reversed ? -o : o, e = u.reversed ? -C : C, n = c.reversed ? -C : C;
            y.x % 2 && (A = A || Math.round(Math.abs(p - E) / 2) * (c.reversed ? -1 : 1), E += A, b += A, p += A), y.plotX = y.clientX = (a + x) / 2, y.plotY = b, h += t + e, a += e, x -= e, S -= t + e, E -= n, p += n, y.tileEdges = { x1: h, x2: a, x3: x, x4: S, y1: E, y2: b, y3: p }, y.shapeType = "path", y.shapeArgs = { d: [["M", a, E], ["L", x, E], ["L", S, b], ["L", x, p], ["L", a, p], ["L", h, b], ["Z"]] };
          }
          this.translateColors();
        } }, diamond: { alignDataLabel: O.prototype.alignDataLabel, getSeriesPadding: function(A) {
          return w(A, 2, 2);
        }, haloPath: function(A) {
          if (!A) return [];
          let l = this.tileEdges;
          return [["M", l.x2, l.y1 + A], ["L", l.x3 + A, l.y2], ["L", l.x2, l.y3 - A], ["L", l.x1 - A, l.y2], ["Z"]];
        }, translate: function() {
          let A, l = this.options, u = this.xAxis, c = this.yAxis, v = l.pointPadding || 0, s = l.colsize || 1, f = (l.rowsize || 1) / 2;
          for (let y of (this.generatePoints(), this.points)) {
            let h = L(Math.round(u.len - u.translate(y.x - s, 0, 1, 0, 0)), -u.len, 2 * u.len), a = L(Math.round(u.len - u.translate(y.x + s, 0, 1, 0, 0)), -u.len, 2 * u.len), x = L(Math.round(c.translate(y.y - f, 0, 1, 0, 0)), -c.len, 2 * c.len), S = L(Math.round(c.translate(y.y, 0, 1, 0, 0)), -c.len, 2 * c.len), E = L(Math.round(c.translate(y.y + f, 0, 1, 0, 0)), -c.len, 2 * c.len), b = L(Math.round(u.len - u.translate(y.x, 0, 1, 0, 0)), -u.len, 2 * u.len), p = M(y.pointPadding, v), C = p * Math.abs(b - h) / Math.abs(E - S), o = u.reversed ? -C : C, t = c.reversed ? -p : p;
            y.x % 2 && (A = Math.abs(E - x) / 2 * (c.reversed ? -1 : 1), x += A, S += A, E += A), y.plotX = y.clientX = b, y.plotY = S, h += o, a -= o, x -= t, E += t, y.tileEdges = { x1: h, x2: b, x3: a, y1: x, y2: S, y3: E }, y.shapeType = "path", y.shapeArgs = { d: [["M", b, x], ["L", a, S], ["L", b, E], ["L", h, S], ["Z"]] };
          }
          this.translateColors();
        } }, circle: { alignDataLabel: O.prototype.alignDataLabel, getSeriesPadding: function(A) {
          return w(A, 2, 2);
        }, haloPath: function(A) {
          return O.prototype.pointClass.prototype.haloPath.call(this, A + (A && this.radius));
        }, translate: function() {
          let A = this.options, l = this.xAxis, u = this.yAxis, c = A.pointPadding || 0, v = (A.rowsize || 1) / 2, s = A.colsize || 1, f, y, h, a, x = !1;
          for (let S of (this.generatePoints(), this.points)) {
            let E = L(Math.round(l.len - l.translate(S.x, 0, 1, 0, 0)), -l.len, 2 * l.len), b = c, p = !1, C = L(Math.round(u.translate(S.y, 0, 1, 0, 0)), -u.len, 2 * u.len);
            S.pointPadding !== void 0 && (b = S.pointPadding, p = !0, x = !0), (!a || x) && (h = Math.floor(Math.sqrt((f = Math.abs(L(Math.floor(l.len - l.translate(S.x + s, 0, 1, 0, 0)), -l.len, 2 * l.len) - E)) * f + (y = Math.abs(L(Math.floor(u.translate(S.y + v, 0, 1, 0, 0)), -u.len, 2 * u.len) - C)) * y) / 2), a = Math.min(f, h, y) - b, x && !p && (x = !1)), S.x % 2 && (C += y * (u.reversed ? -1 : 1)), S.plotX = S.clientX = E, S.plotY = C, S.radius = a, S.shapeType = "circle", S.shapeArgs = { x: E, y: C, r: a };
          }
          this.translateColors();
        } }, square: { alignDataLabel: z.prototype.alignDataLabel, translate: z.prototype.translate, getSeriesPadding: R, haloPath: z.prototype.pointClass.prototype.haloPath } };
      }), Z(r, "Series/Tilemap/TilemapSeries.js", [r["Core/Globals.js"], r["Core/Series/SeriesRegistry.js"], r["Series/Tilemap/TilemapPoint.js"], r["Series/Tilemap/TilemapSeriesDefaults.js"], r["Series/Tilemap/TilemapShapes.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O) {
        let { composed: L, noop: M } = T, { column: w, heatmap: A, scatter: l } = B.seriesTypes, { addEvent: u, extend: c, merge: v, pushUnique: s } = O;
        function f() {
          if (this.recomputingForTilemap || this.coll === "colorAxis") return;
          let h = this, a = h.series.map(function(S) {
            return S.getSeriesPixelPadding && S.getSeriesPixelPadding(h);
          }).reduce(function(S, E) {
            return (S && S.padding) > (E && E.padding) ? S : E;
          }, void 0) || { padding: 0, axisLengthFactor: 1 }, x = Math.round(a.padding * a.axisLengthFactor);
          a.padding && (h.len -= x, h.recomputingForTilemap = !0, h.setAxisTranslation(), delete h.recomputingForTilemap, h.minPixelPadding += a.padding, h.len += x);
        }
        class y extends A {
          static compose(a) {
            s(L, "TilemapSeries") && u(a, "afterSetAxisTranslation", f);
          }
          alignDataLabel() {
            return this.tileShape.alignDataLabel.apply(this, arguments);
          }
          drawPoints() {
            for (let a of (w.prototype.drawPoints.call(this), this.points)) a.graphic && a.graphic[this.chart.styledMode ? "css" : "animate"](this.colorAttribs(a));
          }
          getSeriesPixelPadding(a) {
            let x = a.isXAxis, S = this.tileShape.getSeriesPadding(this);
            if (!S) return { padding: 0, axisLengthFactor: 1 };
            let E = Math.round(a.translate(x ? 2 * S.xPad : S.yPad, 0, 1, 0, 1)), b = Math.round(a.translate(x ? S.xPad : 0, 0, 1, 0, 1));
            return { padding: (a.single ? Math.abs(E - b) / 2 : Math.abs(E - b)) || 0, axisLengthFactor: x ? 2 : 1.1 };
          }
          setOptions() {
            let a = super.setOptions.apply(this, arguments);
            return this.tileShape = z[a.tileShape], a;
          }
          translate() {
            return this.tileShape.translate.apply(this, arguments);
          }
        }
        return y.defaultOptions = v(A.defaultOptions, R), c(y.prototype, { getSymbol: M, markerAttribs: l.prototype.markerAttribs, pointAttribs: w.prototype.pointAttribs, pointClass: I }), B.registerSeriesType("tilemap", y), y;
      }), Z(r, "masters/modules/tilemap.src.js", [r["Core/Globals.js"], r["Series/Tilemap/TilemapSeries.js"]], function(T, B) {
        return B.compose(T.Axis), T;
      });
    });
  }(je)), je.exports;
}
var Gl = Ul();
const Xl = /* @__PURE__ */ It(Gl);
var De = { exports: {} }, _s;
function Hl() {
  return _s || (_s = 1, function(rt) {
    /**
    * Highmaps JS v11.4.8 (2024-08-29)
    *
    * (c) 2009-2024 Torstein Honsi
    *
    * License: www.highcharts.com/license
    */
    (function(tt) {
      rt.exports ? (tt.default = tt, rt.exports = tt) : tt(typeof Highcharts < "u" ? Highcharts : void 0);
    })(function(tt) {
      var r = tt ? tt._modules : {};
      function Z(T, B, I, R) {
        T.hasOwnProperty(B) || (T[B] = R.apply(null, I), typeof CustomEvent == "function" && tt.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: B, module: T[B] } })));
      }
      Z(r, "Core/Axis/Color/ColorAxisComposition.js", [r["Core/Color/Color.js"], r["Core/Utilities.js"]], function(T, B) {
        var I;
        let { parse: R } = T, { addEvent: z, extend: O, merge: L, pick: M, splat: w } = B;
        return function(A) {
          let l;
          function u() {
            let { userOptions: E } = this;
            this.colorAxis = [], E.colorAxis && (E.colorAxis = w(E.colorAxis), E.colorAxis.map((b) => new l(this, b)));
          }
          function c(E) {
            let b = this.chart.colorAxis || [], p = (e) => {
              let n = E.allItems.indexOf(e);
              n !== -1 && (this.destroyItem(E.allItems[n]), E.allItems.splice(n, 1));
            }, C = [], o, t;
            for (b.forEach(function(e) {
              (o = e.options) && o.showInLegend && (o.dataClasses && o.visible ? C = C.concat(e.getDataClassLegendSymbols()) : o.visible && C.push(e), e.series.forEach(function(n) {
                (!n.options.showInLegend || o.dataClasses) && (n.options.legendType === "point" ? n.points.forEach(function(d) {
                  p(d);
                }) : p(n));
              }));
            }), t = C.length; t--; ) E.allItems.unshift(C[t]);
          }
          function v(E) {
            E.visible && E.item.legendColor && E.item.legendItem.symbol.attr({ fill: E.item.legendColor });
          }
          function s(E) {
            var b;
            (b = this.chart.colorAxis) == null || b.forEach((p) => {
              p.update({}, E.redraw);
            });
          }
          function f() {
            (this.chart.colorAxis && this.chart.colorAxis.length || this.colorAttribs) && this.translateColors();
          }
          function y() {
            let E = this.axisTypes;
            E ? E.indexOf("colorAxis") === -1 && E.push("colorAxis") : this.axisTypes = ["colorAxis"];
          }
          function h(E) {
            let b = this, p = E ? "show" : "hide";
            b.visible = b.options.visible = !!E, ["graphic", "dataLabel"].forEach(function(C) {
              b[C] && b[C][p]();
            }), this.series.buildKDTree();
          }
          function a() {
            let E = this, b = this.getPointsCollection(), p = this.options.nullColor, C = this.colorAxis, o = this.colorKey;
            b.forEach((t) => {
              let e = t.getNestedProperty(o), n = t.options.color || (t.isNull || t.value === null ? p : C && e !== void 0 ? C.toColor(e, t) : t.color || E.color);
              n && t.color !== n && (t.color = n, E.options.legendType === "point" && t.legendItem && t.legendItem.label && E.chart.legend.colorizeItem(t, t.visible));
            });
          }
          function x() {
            this.elem.attr("fill", R(this.start).tweenTo(R(this.end), this.pos), void 0, !0);
          }
          function S() {
            this.elem.attr("stroke", R(this.start).tweenTo(R(this.end), this.pos), void 0, !0);
          }
          A.compose = function(E, b, p, C, o) {
            let t = b.prototype, e = p.prototype, n = o.prototype;
            t.collectionsWithUpdate.includes("colorAxis") || (l = E, t.collectionsWithUpdate.push("colorAxis"), t.collectionsWithInit.colorAxis = [t.addColorAxis], z(b, "afterGetAxes", u), function(d) {
              let i = d.prototype.createAxis;
              d.prototype.createAxis = function(g, m) {
                if (g !== "colorAxis") return i.apply(this, arguments);
                let k = new l(this, L(m.axis, { index: this[g].length, isX: !1 }));
                return this.isDirtyLegend = !0, this.axes.forEach((j) => {
                  j.series = [];
                }), this.series.forEach((j) => {
                  j.bindAxes(), j.isDirtyData = !0;
                }), M(m.redraw, !0) && this.redraw(m.animation), k;
              };
            }(b), e.fillSetter = x, e.strokeSetter = S, z(C, "afterGetAllItems", c), z(C, "afterColorizeItem", v), z(C, "afterUpdate", s), O(n, { optionalAxis: "colorAxis", translateColors: a }), O(n.pointClass.prototype, { setVisible: h }), z(o, "afterTranslate", f, { order: 1 }), z(o, "bindAxes", y));
          }, A.pointSetVisible = h;
        }(I || (I = {})), I;
      }), Z(r, "Core/Axis/Color/ColorAxisDefaults.js", [], function() {
        return { lineWidth: 0, minPadding: 0, maxPadding: 0, gridLineColor: "#ffffff", gridLineWidth: 1, tickPixelInterval: 72, startOnTick: !0, endOnTick: !0, offset: 0, marker: { animation: { duration: 50 }, width: 0.01, color: "#999999" }, labels: { distance: 8, overflow: "justify", rotation: 0 }, minColor: "#e6e9ff", maxColor: "#0022ff", tickLength: 5, showInLegend: !0 };
      }), Z(r, "Core/Axis/Color/ColorAxisLike.js", [r["Core/Color/Color.js"], r["Core/Utilities.js"]], function(T, B) {
        var I, R;
        let { parse: z } = T, { merge: O } = B;
        return (R = I || (I = {})).initDataClasses = function(L) {
          let M = this.chart, w = this.legendItem = this.legendItem || {}, A = this.options, l = L.dataClasses || [], u, c, v = M.options.chart.colorCount, s = 0, f;
          this.dataClasses = c = [], w.labels = [];
          for (let y = 0, h = l.length; y < h; ++y) u = O(u = l[y]), c.push(u), (M.styledMode || !u.color) && (A.dataClassColor === "category" ? (M.styledMode || (v = (f = M.options.colors || []).length, u.color = f[s]), u.colorIndex = s, ++s === v && (s = 0)) : u.color = z(A.minColor).tweenTo(z(A.maxColor), h < 2 ? 0.5 : y / (h - 1)));
        }, R.initStops = function() {
          let L = this.options, M = this.stops = L.stops || [[0, L.minColor || ""], [1, L.maxColor || ""]];
          for (let w = 0, A = M.length; w < A; ++w) M[w].color = z(M[w][1]);
        }, R.normalizedValue = function(L) {
          let M = this.max || 0, w = this.min || 0;
          return this.logarithmic && (L = this.logarithmic.log2lin(L)), 1 - (M - L) / (M - w || 1);
        }, R.toColor = function(L, M) {
          let w, A, l, u, c, v, s = this.dataClasses, f = this.stops;
          if (s) {
            for (v = s.length; v--; ) if (A = (c = s[v]).from, l = c.to, (A === void 0 || L >= A) && (l === void 0 || L <= l)) {
              u = c.color, M && (M.dataClass = v, M.colorIndex = c.colorIndex);
              break;
            }
          } else {
            for (w = this.normalizedValue(L), v = f.length; v-- && !(w > f[v][0]); ) ;
            A = f[v] || f[v + 1], w = 1 - ((l = f[v + 1] || A)[0] - w) / (l[0] - A[0] || 1), u = A.color.tweenTo(l.color, w);
          }
          return u;
        }, I;
      }), Z(r, "Core/Axis/Color/ColorAxis.js", [r["Core/Axis/Axis.js"], r["Core/Axis/Color/ColorAxisComposition.js"], r["Core/Axis/Color/ColorAxisDefaults.js"], r["Core/Axis/Color/ColorAxisLike.js"], r["Core/Defaults.js"], r["Core/Legend/LegendSymbol.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { defaultOptions: w } = z, { series: A } = L, { defined: l, extend: u, fireEvent: c, isArray: v, isNumber: s, merge: f, pick: y, relativeLength: h } = M;
        w.colorAxis = f(w.xAxis, I);
        class a extends T {
          static compose(S, E, b, p) {
            B.compose(a, S, E, b, p);
          }
          constructor(S, E) {
            super(S, E), this.coll = "colorAxis", this.visible = !0, this.init(S, E);
          }
          init(S, E) {
            let b = S.options.legend || {}, p = E.layout ? E.layout !== "vertical" : b.layout !== "vertical";
            this.side = E.side || p ? 2 : 1, this.reversed = E.reversed || !p, this.opposite = !p, super.init(S, E, "colorAxis"), this.userOptions = E, v(S.userOptions.colorAxis) && (S.userOptions.colorAxis[this.index] = E), E.dataClasses && this.initDataClasses(E), this.initStops(), this.horiz = p, this.zoomEnabled = !1;
          }
          hasData() {
            return !!(this.tickPositions || []).length;
          }
          setTickPositions() {
            if (!this.dataClasses) return super.setTickPositions();
          }
          setOptions(S) {
            let E = f(w.colorAxis, S, { showEmpty: !1, title: null, visible: this.chart.options.legend.enabled && S.visible !== !1 });
            super.setOptions(E), this.options.crosshair = this.options.marker;
          }
          setAxisSize() {
            var C;
            let S = this.chart, E = (C = this.legendItem) == null ? void 0 : C.symbol, { width: b, height: p } = this.getSize();
            E && (this.left = +E.attr("x"), this.top = +E.attr("y"), this.width = b = +E.attr("width"), this.height = p = +E.attr("height"), this.right = S.chartWidth - this.left - b, this.bottom = S.chartHeight - this.top - p, this.pos = this.horiz ? this.left : this.top), this.len = (this.horiz ? b : p) || a.defaultLegendLength;
          }
          getOffset() {
            var b;
            let S = (b = this.legendItem) == null ? void 0 : b.group, E = this.chart.axisOffset[this.side];
            if (S) {
              this.axisParent = S, super.getOffset();
              let p = this.chart.legend;
              p.allItems.forEach(function(C) {
                C instanceof a && C.drawLegendSymbol(p, C);
              }), p.render(), this.chart.getMargins(!0), this.chart.series.some((C) => C.isDrilling) || (this.isDirty = !0), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = E;
            }
          }
          setLegendColor() {
            let S = this.horiz, E = this.reversed, b = E ? 1 : 0, p = E ? 0 : 1, C = S ? [b, 0, p, 0] : [0, p, 0, b];
            this.legendColor = { linearGradient: { x1: C[0], y1: C[1], x2: C[2], y2: C[3] }, stops: this.stops };
          }
          drawLegendSymbol(S, E) {
            let b = E.legendItem || {}, p = S.padding, C = S.options, o = this.options.labels, t = y(C.itemDistance, 10), e = this.horiz, { width: n, height: d } = this.getSize(), i = y(C.labelPadding, e ? 16 : 30);
            this.setLegendColor(), b.symbol || (b.symbol = this.chart.renderer.symbol("roundedRect").attr({ r: C.symbolRadius ?? 3, zIndex: 1 }).add(b.group)), b.symbol.attr({ x: 0, y: (S.baseline || 0) - 11, width: n, height: d }), b.labelWidth = n + p + (e ? t : y(o.x, o.distance) + (this.maxLabelLength || 0)), b.labelHeight = d + p + (e ? i : 0);
          }
          setState(S) {
            this.series.forEach(function(E) {
              E.setState(S);
            });
          }
          setVisible() {
          }
          getSeriesExtremes() {
            let S = this.series, E, b, p, C, o, t, e = S.length, n, d;
            for (this.dataMin = 1 / 0, this.dataMax = -1 / 0; e--; ) {
              if (b = (t = S[e]).colorKey = y(t.options.colorKey, t.colorKey, t.pointValKey, t.zoneAxis, "y"), C = t.pointArrayMap, o = t[b + "Min"] && t[b + "Max"], t[b + "Data"]) E = t[b + "Data"];
              else if (C) {
                if (E = [], p = C.indexOf(b), n = t.yData, p >= 0 && n) for (d = 0; d < n.length; d++) E.push(y(n[d][p], n[d]));
              } else E = t.yData;
              if (o) t.minColorValue = t[b + "Min"], t.maxColorValue = t[b + "Max"];
              else {
                let i = A.prototype.getExtremes.call(t, E);
                t.minColorValue = i.dataMin, t.maxColorValue = i.dataMax;
              }
              l(t.minColorValue) && l(t.maxColorValue) && (this.dataMin = Math.min(this.dataMin, t.minColorValue), this.dataMax = Math.max(this.dataMax, t.maxColorValue)), o || A.prototype.applyExtremes.call(t);
            }
          }
          drawCrosshair(S, E) {
            let b, p = this.legendItem || {}, C = E && E.plotX, o = E && E.plotY, t = this.pos, e = this.len;
            E && ((b = this.toPixels(E.getNestedProperty(E.series.colorKey))) < t ? b = t - 2 : b > t + e && (b = t + e + 2), E.plotX = b, E.plotY = this.len - b, super.drawCrosshair(S, E), E.plotX = C, E.plotY = o, this.cross && !this.cross.addedToColorAxis && p.group && (this.cross.addClass("highcharts-coloraxis-marker").add(p.group), this.cross.addedToColorAxis = !0, this.chart.styledMode || typeof this.crosshair != "object" || this.cross.attr({ fill: this.crosshair.color })));
          }
          getPlotLinePath(S) {
            let E = this.left, b = S.translatedValue, p = this.top;
            return s(b) ? this.horiz ? [["M", b - 4, p - 6], ["L", b + 4, p - 6], ["L", b, p], ["Z"]] : [["M", E, b], ["L", E - 6, b + 6], ["L", E - 6, b - 6], ["Z"]] : super.getPlotLinePath(S);
          }
          update(S, E) {
            let b = this.chart.legend;
            this.series.forEach((p) => {
              p.isDirtyData = !0;
            }), (S.dataClasses && b.allItems || this.dataClasses) && this.destroyItems(), super.update(S, E), this.legendItem && this.legendItem.label && (this.setLegendColor(), b.colorizeItem(this, !0));
          }
          destroyItems() {
            let S = this.chart, E = this.legendItem || {};
            if (E.label) S.legend.destroyItem(this);
            else if (E.labels) for (let b of E.labels) S.legend.destroyItem(b);
            S.isDirtyLegend = !0;
          }
          destroy() {
            this.chart.isDirtyLegend = !0, this.destroyItems(), super.destroy(...[].slice.call(arguments));
          }
          remove(S) {
            this.destroyItems(), super.remove(S);
          }
          getDataClassLegendSymbols() {
            let S, E = this, b = E.chart, p = E.legendItem && E.legendItem.labels || [], C = b.options.legend, o = y(C.valueDecimals, -1), t = y(C.valueSuffix, ""), e = (n) => E.series.reduce((d, i) => (d.push(...i.points.filter((g) => g.dataClass === n)), d), []);
            return p.length || E.dataClasses.forEach((n, d) => {
              let i = n.from, g = n.to, { numberFormatter: m } = b, k = !0;
              S = "", i === void 0 ? S = "< " : g === void 0 && (S = "> "), i !== void 0 && (S += m(i, o) + t), i !== void 0 && g !== void 0 && (S += " - "), g !== void 0 && (S += m(g, o) + t), p.push(u({ chart: b, name: S, options: {}, drawLegendSymbol: O.rectangle, visible: !0, isDataClass: !0, setState: (j) => {
                for (let P of e(d)) P.setState(j);
              }, setVisible: function() {
                this.visible = k = E.visible = !k;
                let j = [];
                for (let P of e(d)) P.setVisible(k), P.hiddenInDataClass = !k, j.indexOf(P.series) === -1 && j.push(P.series);
                b.legend.colorizeItem(this, k), j.forEach((P) => {
                  c(P, "afterDataClassLegendClick");
                });
              } }, n));
            }), p;
          }
          getSize() {
            let { chart: S, horiz: E } = this, { height: b, width: p } = this.options, { legend: C } = S.options;
            return { width: y(l(p) ? h(p, S.chartWidth) : void 0, C == null ? void 0 : C.symbolWidth, E ? a.defaultLegendLength : 12), height: y(l(b) ? h(b, S.chartHeight) : void 0, C == null ? void 0 : C.symbolHeight, E ? 12 : a.defaultLegendLength) };
          }
        }
        return a.defaultLegendLength = 200, a.keepProps = ["legendItem"], u(a.prototype, R), Array.prototype.push.apply(T.keepProps, a.keepProps), a;
      }), Z(r, "masters/modules/coloraxis.src.js", [r["Core/Globals.js"], r["Core/Axis/Color/ColorAxis.js"]], function(T, B) {
        return T.ColorAxis = T.ColorAxis || B, T.ColorAxis.compose(T.Chart, T.Fx, T.Legend, T.Series), T;
      }), Z(r, "Series/ColorMapComposition.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGElement.js"], r["Core/Utilities.js"]], function(T, B, I) {
        var R;
        let { column: { prototype: z } } = T.seriesTypes, { addEvent: O, defined: L } = I;
        return function(M) {
          function w(A) {
            let l = this.series, u = l.chart.renderer;
            this.moveToTopOnHover && this.graphic && (l.stateMarkerGraphic || (l.stateMarkerGraphic = new B(u, "use").css({ pointerEvents: "none" }).add(this.graphic.parentGroup)), (A == null ? void 0 : A.state) === "hover" ? (this.graphic.attr({ id: this.id }), l.stateMarkerGraphic.attr({ href: `${u.url}#${this.id}`, visibility: "visible" })) : l.stateMarkerGraphic.attr({ href: "" }));
          }
          M.pointMembers = { dataLabelOnNull: !0, moveToTopOnHover: !0, isValid: function() {
            return this.value !== null && this.value !== 1 / 0 && this.value !== -1 / 0 && (this.value === void 0 || !isNaN(this.value));
          } }, M.seriesMembers = { colorKey: "value", axisTypes: ["xAxis", "yAxis", "colorAxis"], parallelArrays: ["x", "y", "value"], pointArrayMap: ["value"], trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], colorAttribs: function(A) {
            let l = {};
            return L(A.color) && (!A.state || A.state === "normal") && (l[this.colorProp || "fill"] = A.color), l;
          }, pointAttribs: z.pointAttribs }, M.compose = function(A) {
            return O(A.prototype.pointClass, "afterSetState", w), A;
          };
        }(R || (R = {})), R;
      }), Z(r, "Series/Heatmap/HeatmapPoint.js", [r["Core/Series/SeriesRegistry.js"], r["Core/Utilities.js"]], function(T, B) {
        let { scatter: { prototype: { pointClass: I } } } = T.seriesTypes, { clamp: R, defined: z, extend: O, pick: L } = B;
        class M extends I {
          applyOptions(A, l) {
            return (this.isNull || this.value === null) && delete this.color, super.applyOptions(A, l), this.formatPrefix = this.isNull || this.value === null ? "null" : "point", this;
          }
          getCellAttributes() {
            let A = this.series, l = A.options, u = (l.colsize || 1) / 2, c = (l.rowsize || 1) / 2, v = A.xAxis, s = A.yAxis, f = this.options.marker || A.options.marker, y = A.pointPlacementToXValue(), h = L(this.pointPadding, l.pointPadding, 0), a = { x1: R(Math.round(v.len - v.translate(this.x - u, !1, !0, !1, !0, -y)), -v.len, 2 * v.len), x2: R(Math.round(v.len - v.translate(this.x + u, !1, !0, !1, !0, -y)), -v.len, 2 * v.len), y1: R(Math.round(s.translate(this.y - c, !1, !0, !1, !0)), -s.len, 2 * s.len), y2: R(Math.round(s.translate(this.y + c, !1, !0, !1, !0)), -s.len, 2 * s.len) };
            for (let x of [["width", "x"], ["height", "y"]]) {
              let S = x[0], E = x[1], b = E + "1", p = E + "2", C = Math.abs(a[b] - a[p]), o = f && f.lineWidth || 0, t = Math.abs(a[b] + a[p]) / 2, e = f && f[S];
              if (z(e) && e < C) {
                let n = e / 2 + o / 2;
                a[b] = t - n, a[p] = t + n;
              }
              h && ((E === "x" && v.reversed || E === "y" && !s.reversed) && (b = p, p = E + "1"), a[b] += h, a[p] -= h);
            }
            return a;
          }
          haloPath(A) {
            if (!A) return [];
            let { x: l = 0, y: u = 0, width: c = 0, height: v = 0 } = this.shapeArgs || {};
            return [["M", l - A, u - A], ["L", l - A, u + v + A], ["L", l + c + A, u + v + A], ["L", l + c + A, u - A], ["Z"]];
          }
          isValid() {
            return this.value !== 1 / 0 && this.value !== -1 / 0;
          }
        }
        return O(M.prototype, { dataLabelOnNull: !0, moveToTopOnHover: !0, ttBelow: !1 }), M;
      }), Z(r, "Series/Heatmap/HeatmapSeriesDefaults.js", [r["Core/Utilities.js"]], function(T) {
        let { isNumber: B } = T;
        return { animation: !1, borderRadius: 0, borderWidth: 0, interpolation: !1, nullColor: "#f7f7f7", dataLabels: { formatter: function() {
          let { numberFormatter: I } = this.series.chart, { value: R } = this.point;
          return B(R) ? I(R, -1) : "";
        }, inside: !0, verticalAlign: "middle", crop: !1, overflow: "allow", padding: 0 }, marker: { symbol: "rect", radius: 0, lineColor: void 0, states: { hover: { lineWidthPlus: 0 }, select: {} } }, clip: !0, pointRange: null, tooltip: { pointFormat: "{point.x}, {point.y}: {point.value}<br/>" }, states: { hover: { halo: !1, brightness: 0.2 } }, legendSymbol: "rectangle" };
      }), Z(r, "Series/InterpolationUtilities.js", [r["Core/Globals.js"], r["Core/Utilities.js"]], function(T, B) {
        let { doc: I } = T, { defined: R, pick: z } = B;
        return { colorFromPoint: function(O, L) {
          let M = L.series.colorAxis;
          if (M) {
            let w = M.toColor(O || 0, L).split(")")[0].split("(")[1].split(",").map((A) => z(parseFloat(A), parseInt(A, 10)));
            return w[3] = 255 * z(w[3], 1), R(O) && L.visible || (w[3] = 0), w;
          }
          return [0, 0, 0, 0];
        }, getContext: function(O) {
          let { canvas: L, context: M } = O;
          return L && M ? (M.clearRect(0, 0, L.width, L.height), M) : (O.canvas = I.createElement("canvas"), O.context = O.canvas.getContext("2d", { willReadFrequently: !0 }) || void 0, O.context);
        } };
      }), Z(r, "Series/Heatmap/HeatmapSeries.js", [r["Core/Color/Color.js"], r["Series/ColorMapComposition.js"], r["Series/Heatmap/HeatmapPoint.js"], r["Series/Heatmap/HeatmapSeriesDefaults.js"], r["Core/Series/SeriesRegistry.js"], r["Core/Renderer/SVG/SVGRenderer.js"], r["Core/Utilities.js"], r["Series/InterpolationUtilities.js"]], function(T, B, I, R, z, O, L, M) {
        let { series: w, seriesTypes: { column: A, scatter: l } } = z, { prototype: { symbols: u } } = O, { addEvent: c, extend: v, fireEvent: s, isNumber: f, merge: y, pick: h } = L, { colorFromPoint: a, getContext: x } = M;
        class S extends l {
          constructor() {
            super(...arguments), this.valueMax = NaN, this.valueMin = NaN, this.isDirtyCanvas = !0;
          }
          drawPoints() {
            let b = this, p = b.options, C = p.interpolation, o = p.marker || {};
            if (C) {
              let { image: t, chart: e, xAxis: n, yAxis: d } = b, { reversed: i = !1, len: g } = n, { reversed: m = !1, len: k } = d, j = { width: g, height: k };
              if (!t || b.isDirtyData || b.isDirtyCanvas) {
                let P = x(b), { canvas: D, options: { colsize: H = 1, rowsize: G = 1 }, points: V, points: { length: F } } = b, U = e.colorAxis && e.colorAxis[0];
                if (D && P && U) {
                  let { min: Y, max: q } = n.getExtremes(), { min: N, max: X } = d.getExtremes(), W = q - Y, _ = X - N, K = Math.round(W / H / 8 * 8), J = Math.round(_ / G / 8 * 8), [$, et] = [[K, K / W, i, "ceil"], [J, J / _, !m, "floor"]].map(([ot, nt, ht, ct]) => ht ? (dt) => Math[ct](ot - nt * dt) : (dt) => Math[ct](nt * dt)), st = D.width = K + 1, at = st * (D.height = J + 1), lt = (F - 1) / at, it = new Uint8ClampedArray(4 * at), Q = (ot, nt) => 4 * Math.ceil(st * et(nt - N) + $(ot - Y));
                  b.buildKDTree();
                  for (let ot = 0; ot < at; ot++) {
                    let nt = V[Math.ceil(lt * ot)], { x: ht, y: ct } = nt;
                    it.set(a(nt.value, nt), Q(ht, ct));
                  }
                  P.putImageData(new ImageData(it, st), 0, 0), t ? t.attr({ ...j, href: D.toDataURL("image/png", 1) }) : (b.directTouch = !1, b.image = e.renderer.image(D.toDataURL("image/png", 1)).attr(j).add(b.group));
                }
                b.isDirtyCanvas = !1;
              } else (t.width !== g || t.height !== k) && t.attr(j);
            } else (o.enabled || b._hasPointMarkers) && (w.prototype.drawPoints.call(b), b.points.forEach((t) => {
              t.graphic && (t.graphic[b.chart.styledMode ? "css" : "animate"](b.colorAttribs(t)), t.value === null && t.graphic.addClass("highcharts-null-point"));
            }));
          }
          getExtremes() {
            let { dataMin: b, dataMax: p } = w.prototype.getExtremes.call(this, this.valueData);
            return f(b) && (this.valueMin = b), f(p) && (this.valueMax = p), w.prototype.getExtremes.call(this);
          }
          getValidPoints(b, p) {
            return w.prototype.getValidPoints.call(this, b, p, !0);
          }
          hasData() {
            return !!this.xData;
          }
          init() {
            super.init.apply(this, arguments);
            let b = this.options;
            b.pointRange = h(b.pointRange, b.colsize || 1), this.yAxis.axisPointRange = b.rowsize || 1, u.ellipse = u.circle, b.marker && f(b.borderRadius) && (b.marker.r = b.borderRadius);
          }
          markerAttribs(b, p) {
            let C = b.shapeArgs || {};
            if (b.hasImage) return { x: b.plotX, y: b.plotY };
            if (p && p !== "normal") {
              let o = b.options.marker || {}, t = this.options.marker || {}, e = t.states && t.states[p] || {}, n = o.states && o.states[p] || {}, d = (n.width || e.width || C.width || 0) + (n.widthPlus || e.widthPlus || 0), i = (n.height || e.height || C.height || 0) + (n.heightPlus || e.heightPlus || 0);
              return { x: (C.x || 0) + ((C.width || 0) - d) / 2, y: (C.y || 0) + ((C.height || 0) - i) / 2, width: d, height: i };
            }
            return C;
          }
          pointAttribs(b, p) {
            let C = w.prototype.pointAttribs.call(this, b, p), o = this.options || {}, t = this.chart.options.plotOptions || {}, e = t.series || {}, n = t.heatmap || {}, d = b && b.options.borderColor || o.borderColor || n.borderColor || e.borderColor, i = b && b.options.borderWidth || o.borderWidth || n.borderWidth || e.borderWidth || C["stroke-width"];
            if (C.stroke = b && b.marker && b.marker.lineColor || o.marker && o.marker.lineColor || d || this.color, C["stroke-width"] = i, p && p !== "normal") {
              let g = y(o.states && o.states[p], o.marker && o.marker.states && o.marker.states[p], b && b.options.states && b.options.states[p] || {});
              C.fill = g.color || T.parse(C.fill).brighten(g.brightness || 0).get(), C.stroke = g.lineColor || C.stroke;
            }
            return C;
          }
          translate() {
            let { borderRadius: b, marker: p } = this.options, C = p && p.symbol || "rect", o = u[C] ? C : "rect", t = ["circle", "square"].indexOf(o) !== -1;
            if (!this.processedXData) {
              let { xData: e, yData: n } = this.getProcessedData();
              this.processedXData = e, this.processedYData = n;
            }
            for (let e of (this.generatePoints(), this.points)) {
              let n = e.getCellAttributes(), d = Math.min(n.x1, n.x2), i = Math.min(n.y1, n.y2), g = Math.max(Math.abs(n.x2 - n.x1), 0), m = Math.max(Math.abs(n.y2 - n.y1), 0);
              if (e.hasImage = (e.marker && e.marker.symbol || C).indexOf("url") === 0, t) {
                let k = Math.abs(g - m);
                d = Math.min(n.x1, n.x2) + (g < m ? 0 : k / 2), i = Math.min(n.y1, n.y2) + (g < m ? k / 2 : 0), g = m = Math.min(g, m);
              }
              e.hasImage && (e.marker = { width: g, height: m }), e.plotX = e.clientX = (n.x1 + n.x2) / 2, e.plotY = (n.y1 + n.y2) / 2, e.shapeType = "path", e.shapeArgs = y(!0, { x: d, y: i, width: g, height: m }, { d: u[o](d, i, g, m, { r: f(b) ? b : 0 }) });
            }
            s(this, "afterTranslate");
          }
        }
        return S.defaultOptions = y(l.defaultOptions, R), c(S, "afterDataClassLegendClick", function() {
          this.isDirtyCanvas = !0, this.drawPoints();
        }), v(S.prototype, { axisTypes: B.seriesMembers.axisTypes, colorKey: B.seriesMembers.colorKey, directTouch: !0, getExtremesFromAll: !0, parallelArrays: B.seriesMembers.parallelArrays, pointArrayMap: ["y", "value"], pointClass: I, specialGroup: "group", trackerGroups: B.seriesMembers.trackerGroups, alignDataLabel: A.prototype.alignDataLabel, colorAttribs: B.seriesMembers.colorAttribs, getSymbol: w.prototype.getSymbol }), B.compose(S), z.registerSeriesType("heatmap", S), S;
      }), Z(r, "masters/modules/heatmap.src.js", [r["Core/Globals.js"]], function(T) {
        return T;
      });
    });
  }(De)), De.exports;
}
var Yl = Hl();
const Wl = /* @__PURE__ */ It(Yl), Vl = ["id"], ql = /* @__PURE__ */ Tt({
  __name: "everviz-charts",
  props: {
    model: {
      type: Object
    }
  },
  setup(rt) {
    nl(Ot), hl(Ot), pl(Ot), fl(Ot), yl(Ot), Cl(Ot), wl(Ot), Pl(Ot), Ll(Ot), Dl(Ot), Rl(Ot), Fl(Ot), Xl(Ot), Wl(Ot);
    const tt = rt, r = zt(() => {
      var O;
      return ((O = tt.model) == null ? void 0 : O.domId) ?? "domId";
    }), Z = zt(() => {
      var O;
      return {
        height: (((O = tt.model) == null ? void 0 : O.height) ?? 500) + "px"
      };
    });
    function T(O) {
      O && O.fontFamily === "DWSSlabWeb-Regular" && (O.fontFamily = "DWS Slab"), O && O.fontFamily === "DWSSansWeb-Regular" && (O.fontFamily = "DWS Sans");
    }
    le(() => {
      B();
    });
    async function B() {
      var L, M, w, A, l;
      const O = (L = tt.model) == null ? void 0 : L.data;
      if (O) {
        if (R(O) && typeof O.chart.map == "string") {
          const u = await z(O.chart.map);
          O.chart.map = u;
        }
        if (Ot.Annotation && Ot.Annotation.ControlPoint && (Ot.Annotation.ControlPoint.prototype.redraw = function(u) {
          this.graphic[u ? "animate" : "attr"](
            this.options.positioner ? this.options.positioner.call(this, this.target) : null
          );
        }), (O.lang || O.global) && Ot.setOptions({
          global: O.global || {},
          lang: O.lang || {}
        }), O.caption && O.caption.style && T(O.caption.style), O.chart && O.chart.style && T(O.chart.style), O.legend && (T(O.legend.itemCheckboxStyle), T(O.legend.itemHiddenStyle), T(O.legend.itemHoverStyle), T(O.legend.itemStyle)), O.title && O.title.style && T(O.title.style), O.subtitle && O.subtitle.style && T(O.subtitle.style), O.tooltip && O.tooltip.style && T(O.tooltip.style), O.xAxis) {
          const u = O.xAxis;
          u.labels && u.labels.style && T(u.labels.style), u.title && u.title.style && T(u.title.style);
        }
        if (O.yAxis) {
          const u = O.yAxis;
          u.labels && u.labels.style && T(u.labels.style), u.title && u.title.style && T(u.title.style);
        }
        if (O.plotOptions && O.plotOptions.series && O.plotOptions.series.dataLabels) {
          const u = O.plotOptions.series.dataLabels;
          u && T(u.style);
        }
        I(O), ((w = (M = tt.model) == null ? void 0 : M.chartType) == null ? void 0 : w.toLocaleLowerCase()) === "map" || ((l = (A = tt.model) == null ? void 0 : A.constr) == null ? void 0 : l.toLowerCase()) === "map" ? Ot.mapChart(r.value, O) : Ot.chart(r.value, O);
      }
    }
    function I(O) {
      var L, M;
      O.mapView ?? (O.mapView = {}), (L = O.mapView).insetOptions ?? (L.insetOptions = {}), (M = O.mapView.insetOptions).borderWidth ?? (M.borderWidth = 0);
    }
    function R(O) {
      var M;
      const L = (M = O.chart) == null ? void 0 : M.map;
      return L ? typeof L != "string" ? (console.error(`Unsupported type ${typeof L} provided for 'map'. Expected string value.`), !1) : !0 : !1;
    }
    async function z(O) {
      switch (O) {
        case "countries/de/de-all":
          return await import("./highchart-maps/countries/de/de-all.topo-hwaCZLTs.js");
        case "countries/us/us-all":
          return await import("./highchart-maps/countries/us/us-all.topo-DEYKEdR2.js");
        case "custom/europe":
          return await import("./highchart-maps/custom/europe.topo-6w0Bw9Sc.js");
        case "custom/world":
          return await import("./highchart-maps/custom/world.topo-Ck6shTSZ.js");
        default:
          return console.error(`Could not resolve requested map data for ${O}`), Promise.resolve(O);
      }
    }
    return (O, L) => (wt(), Rt("div", {
      id: r.value,
      class: "everviz-chart",
      style: yn(Z.value)
    }, null, 12, Vl));
  }
}), _l = /* @__PURE__ */ Tt({
  __name: "fund-search",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt, r = Ft(tt.model), Z = Ft(tt.model.resultModel);
    let T;
    const B = () => {
      if (T && (T.abort(), T = void 0), !r.value.searchTerm || r.value.searchTerm.length < 3)
        return;
      T = new AbortController();
      const z = {
        filterOptions: r.value.filterOptions,
        searchTerm: r.value.searchTerm,
        culture: r.value.culture,
        blockId: r.value.blockId
      };
      fetch(r.value.fundSearchApi, {
        body: JSON.stringify(z),
        signal: T.signal,
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        method: "POST"
      }).then((O) => {
        if (O.ok)
          return O.json();
        throw new Error("Request returned an error");
      }).then((O) => {
        Z.value.allResultsLink = O.allResultsLink, Z.value.results = O.results;
      });
    }, I = (z) => {
      (!z || z.length <= 0) && (r.value.searchTerm = ""), r.value.searchTerm !== z && (r.value.searchTerm = z, B());
    }, R = (z) => {
      if (!r.value.filterOptions)
        return;
      const O = z == null ? void 0 : z.isSelected;
      r.value.filterOptions.forEach((L) => L.isSelected = !1), O && (z.isSelected = !0), r.value.filterOptions = [...r.value.filterOptions], B();
    };
    return (z, O) => (wt(), Et(St(Yr), {
      model: r.value,
      "min-length": 3,
      result: Z.value,
      onSearch: I,
      onFilterChanged: R
    }, null, 8, ["model", "result"]));
  }
}), Kl = { class: "d-announcements" }, $l = {
  key: 0,
  class: "d-announcements__button-right"
}, Zl = /* @__PURE__ */ Tt({
  __name: "teaser-announcements",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    return (tt, r) => {
      const Z = bn("BaseLinkV2");
      return wt(), Rt("div", Kl, [
        Qt(St(wn), {
          model: rt.model.teasers,
          "link-corner": !0
        }, {
          teaserContent: Xt((T) => [
            Qt(St(Sn), {
              "teaser-content": T.teaserContent
            }, null, 8, ["teaser-content"])
          ]),
          _: 1
        }, 8, ["model"]),
        rt.model.ctaElementType && rt.model.readMoreLink ? (wt(), Rt("div", $l, [
          rt.model.ctaElementType === St(kn).Link ? (wt(), Et(Z, {
            key: 0,
            "link-model": rt.model.readMoreLink,
            icon: St(Pn).ArrowRight
          }, null, 8, ["link-model", "icon"])) : Wt("", !0)
        ])) : Wt("", !0)
      ]);
    };
  }
}), Ks = "other-country", Jl = /* @__PURE__ */ Tt({
  __name: "entry-gate-modal",
  props: {
    entryGate: {
      type: Object,
      required: !0
    },
    header: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const { setLocale: tt } = Tn(), r = rt;
    let Z;
    const T = Ft(r.entryGate), B = Ft(document.referrer), I = async (R) => {
      var A, l;
      const { location: z } = window, { href: O } = z, L = document.querySelector('meta[name="culture"]'), { content: M } = L, { value: w } = R;
      if (w !== Ks) {
        tt(w), Z == null || Z.abort(), Z = new AbortController();
        const u = new URLSearchParams({
          url: O,
          pageCulture: M,
          displayCulture: w,
          referrer: B.value,
          pageId: r.entryGate.pageId
        }).toString(), c = await fetch(`/EntryGate/GetEntryGateInCulture?${u.toString()}`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          signal: Z.signal
        });
        if (c.ok) {
          const v = await c.json();
          (A = v.audienceList) == null || A.forEach((s) => s.isSelected = !1), T.value = v;
        }
      } else
        (l = T.value) != null && l.countryDropdown && T.value.countryDropdown.forEach((u) => {
          u.value === Ks ? u.isSelected = !0 : u.isSelected = !1;
        });
    };
    return (R, z) => (wt(), Et(St(En), {
      "entry-gate": T.value,
      onCultureChanged: I,
      header: rt.header
    }, null, 8, ["entry-gate", "header"]));
  }
}), Ql = { key: 0 }, th = {
  key: 1,
  class: "headerH2"
}, eh = {
  key: 2,
  class: "headerH3"
}, ih = { key: 3 }, sh = { key: 4 }, oh = { key: 5 }, rh = /* @__PURE__ */ Tt({
  __name: "header",
  props: {
    header: {
      type: String,
      required: !0
    },
    // when named type it's overwritten by vue while nuxt rendering from the IContent property due to the v-bind in the content-area-item.vue
    headerType: {
      type: Number,
      required: !0
    }
  },
  setup(rt) {
    return (tt, r) => rt.headerType === 1 ? (wt(), Rt("h1", Ql, qt(rt.header), 1)) : rt.headerType === 2 ? (wt(), Rt("h2", th, qt(rt.header), 1)) : rt.headerType === 3 ? (wt(), Rt("h3", eh, qt(rt.header), 1)) : rt.headerType === 4 ? (wt(), Rt("h4", ih, qt(rt.header), 1)) : rt.headerType === 5 ? (wt(), Rt("h5", sh, qt(rt.header), 1)) : (wt(), Rt("h6", oh, qt(rt.header), 1));
  }
}), he = (rt, tt) => {
  const r = rt.__vccOpts || rt;
  for (const [Z, T] of tt)
    r[Z] = T;
  return r;
}, nh = /* @__PURE__ */ he(rh, [["__scopeId", "data-v-9bc2d47f"]]), ah = /* @__PURE__ */ Tt({
  __name: "html",
  props: {
    html: {
      type: String,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt;
    return (r, Z) => (wt(), Et(St(Ln), {
      htmlText: tt.html
    }, null, 8, ["htmlText"]));
  }
}), lh = { class: "d-image-wrapper" }, hh = /* @__PURE__ */ Tt({
  __name: "image",
  props: {
    model: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    responsiveOptions: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    return (tt, r) => (wt(), Rt("div", lh, [
      Qt(St(On), {
        model: rt.model,
        "responsive-options": rt.responsiveOptions
      }, null, 8, ["model", "responsive-options"])
    ]));
  }
}), dh = {};
function ch(rt, tt) {
  return wt(), Rt("div", null, [
    Ht(rt.$slots, "default")
  ]);
}
const ph = /* @__PURE__ */ he(dh, [["render", ch]]), uh = /* @__PURE__ */ Tt({
  __name: "layout-row",
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    elementCount: {
      type: Number,
      required: !0
    },
    rowId: {
      type: String,
      default: "section_0"
    },
    isFirst: {
      type: Boolean,
      default: !1
    },
    nextIsBgGrey: {
      type: Boolean,
      default: !1
    },
    prevIsBgGrey: {
      type: Boolean,
      default: !1
    },
    isLast: {
      type: Boolean,
      default: !1
    },
    prevHasOneItem: {
      type: Boolean,
      default: !1
    }
  },
  setup(rt) {
    const tt = rt, r = zt(() => tt.elementCount === 1), Z = zt(() => {
      switch (tt.row.layoutType) {
        case "TwoCol_66_33":
          return re.TwoThirdsOneThird;
        case "TwoCol_33_66":
          return re.OneThirdTwoThirds;
        case "TwoCol_50_50":
          return re.HalfHalf;
        default:
          return re.HalfHalf;
      }
    }), T = zt(() => {
      switch (tt.row.layoutType) {
        case "TwoCol_50_50":
        case "TwoCol_66_33":
        case "TwoCol_33_66":
        case "TwoCol_75_25":
        case "TwoCol_25_75":
          return 2;
        case "ThreeCol_33_33_33":
          return 3;
        default:
          return 1;
      }
    }), B = zt(() => tt.row.layoutType.toLowerCase() === "onecol_centered"), I = zt(() => tt.row.layoutType.toLowerCase() === "onecol_fullwidth"), R = zt(() => tt.row.stretchedColumn === jn.None);
    return (z, O) => (wt(), Rt(vn, null, [
      T.value === 1 ? (wt(), Et(St(Wr), {
        key: 0,
        id: rt.rowId,
        "content-in-full-width": I.value,
        "one-column-centered": B.value,
        "no-margin": rt.row.noMargin,
        background: rt.row.backgroundColor,
        title: rt.row.sectionHeadline,
        "base-heading-type": rt.row.headlineType,
        "is-first": rt.isFirst,
        "is-last": rt.isLast,
        "next-is-bg-grey": rt.nextIsBgGrey,
        "has-one-item": r.value
      }, {
        default: Xt(() => [
          Ht(z.$slots, "colone")
        ]),
        _: 3
      }, 8, ["id", "content-in-full-width", "one-column-centered", "no-margin", "background", "title", "base-heading-type", "is-first", "is-last", "next-is-bg-grey", "has-one-item"])) : Wt("", !0),
      T.value === 2 ? (wt(), Et(St(Dn), {
        key: 1,
        id: rt.rowId,
        "layout-type": Z.value,
        "no-margin": rt.row.noMargin,
        "stretched-column": rt.row.stretchedColumn,
        title: rt.row.sectionHeadline,
        "base-heading-type": rt.row.headlineType,
        "content-width": R.value,
        "vertical-align-content-col-one": rt.row.verticalAlignment,
        "vertical-align-content-col-two": rt.row.verticalAlignment
      }, {
        colone: Xt(() => [
          Ht(z.$slots, "colone")
        ]),
        coltwo: Xt(() => [
          Ht(z.$slots, "coltwo")
        ]),
        _: 3
      }, 8, ["id", "layout-type", "no-margin", "stretched-column", "title", "base-heading-type", "content-width", "vertical-align-content-col-one", "vertical-align-content-col-two"])) : Wt("", !0),
      T.value === 3 ? (wt(), Et(St(In), {
        key: 2,
        id: rt.rowId,
        "no-margin": rt.row.noMargin,
        title: rt.row.sectionHeadline,
        "base-heading-type": rt.row.headlineType,
        "content-width": R.value,
        "stretched-column": rt.row.stretchedColumn,
        "vertical-align-content-col-one": rt.row.verticalAlignment,
        "vertical-align-content-col-two": rt.row.verticalAlignment,
        "vertical-align-content-col-three": rt.row.verticalAlignment
      }, {
        colone: Xt(() => [
          Ht(z.$slots, "colone")
        ]),
        coltwo: Xt(() => [
          Ht(z.$slots, "coltwo")
        ]),
        colthree: Xt(() => [
          Ht(z.$slots, "colthree")
        ]),
        _: 3
      }, 8, ["id", "no-margin", "title", "base-heading-type", "content-width", "stretched-column", "vertical-align-content-col-one", "vertical-align-content-col-two", "vertical-align-content-col-three"])) : Wt("", !0)
    ], 64));
  }
}), Ie = "leaving-disclaimer", qr = /* @__PURE__ */ Tt({
  __name: "leaving-disclaimer",
  props: {
    title: {},
    content: {},
    whitelist: {}
  },
  setup(rt) {
    const tt = rt, r = zt(() => ({
      headerText: tt.title,
      disclaimers: [{
        key: Ie,
        value: tt.content
      }],
      appendTo: "#dx-overlay-leaving-disclaimer"
    })), Z = Ft(!1);
    function T(I) {
      const R = I.target, z = R == null ? void 0 : R.closest("button"), O = z == null ? void 0 : z.getAttribute("data-pc-section"), L = z == null ? void 0 : z.closest("div#dx-overlay-leaving-disclaimer");
      if (O == "closebutton" && L != null) {
        Z.value = !1;
        return;
      }
      const M = R == null ? void 0 : R.closest("a"), w = M == null ? void 0 : M.getAttribute("href");
      if (!(!w || (M == null ? void 0 : M.getAttribute("id")) !== "leavingdisclaimerCancelButton" && w === "javascript:void(0)")) {
        if (Z.value) {
          Z.value = !1;
          return;
        }
        B(w) && w && (js(I, w, Ie), Z.value = !0);
      }
    }
    if (document && (document.removeEventListener("click", T), document.addEventListener("click", T)), window) {
      const I = window.open;
      window.open = function(R, z, O) {
        const L = new CustomEvent("window-open"), M = R == null ? void 0 : R.toString();
        if (Z.value)
          return Z.value = !1, null;
        if (B(M) && M)
          js(L, M, Ie), Z.value = !0;
        else
          return I(R, z || "", O || "");
        return null;
      };
    }
    function B(I) {
      if (I) {
        if (!I.startsWith("http"))
          return !1;
        const R = new URL(window.location.origin), z = new URL(I);
        if (R.hostname === z.hostname || tt.whitelist && tt.whitelist.find((O) => I.indexOf(O.valueOf()) > -1))
          return !1;
      }
      return !0;
    }
    return (I, R) => (wt(), Et(St(Bn), { model: r.value }, null, 8, ["model"]));
  }
}), gh = /* @__PURE__ */ Tt({
  __name: "products-teaser-area",
  setup(rt) {
    const tt = Ft(), r = Ft(0);
    return le(() => {
      r.value = tt.value.children.length > 3 ? 3 : tt.value.children.length;
    }), (Z, T) => (wt(), Rt("div", {
      ref_key: "slot",
      ref: tt,
      class: Xr("d-teaser-product space-y-10 xl:space-y-0 xl:space-x-10 grid grid-cols-1 lg:grid-cols-1 xl:grid-cols-" + r.value)
    }, [
      Ht(Z.$slots, "default")
    ], 2));
  }
}), fh = /* @__PURE__ */ Tt({
  __name: "risk-disclaimer",
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    }
  },
  setup(rt) {
    const tt = rt, r = zt(() => ({
      title: tt.title,
      text: tt.text
    }));
    return (Z, T) => (wt(), Et(St(Rn), { model: r.value }, null, 8, ["model"]));
  }
}), mh = /* @__PURE__ */ Tt({
  __name: "space",
  props: {
    space: {
      type: Number,
      required: !0
    }
  },
  setup(rt) {
    return (tt, r) => (wt(), Rt("div", {
      class: Xr(["spacer", {
        "pb-4": rt.space === 1,
        "pb-8": rt.space === 2,
        "pb-12": rt.space === 3,
        "pb-16": rt.space === 4,
        "pb-20": rt.space === 5,
        "pb-24": rt.space === 6,
        "pb-28": rt.space === 7,
        "pb-32": rt.space === 8,
        "pb-36": rt.space === 9,
        "pb-40": rt.space === 10,
        "pb-44": rt.space === 11,
        "pb-48": rt.space === 12
      }])
    }, null, 2));
  }
}), xh = /* @__PURE__ */ Tt({
  __name: "content-box",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt;
    return (r, Z) => {
      var T;
      return ((T = tt.model) == null ? void 0 : T.type) === "image-box" ? (wt(), Et(St(Nn), {
        key: 0,
        model: tt.model.props
      }, null, 8, ["model"])) : (wt(), Et(St(zn), {
        key: 1,
        content: tt.model.props,
        type: tt.model.type,
        "icon-marker-color": tt.model.iconMarkerColor,
        "headline-type": tt.model.headlineType
      }, null, 8, ["content", "type", "icon-marker-color", "headline-type"]));
    };
  }
}), yh = /* @__PURE__ */ Tt({
  __name: "article-page-overview",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    return (tt, r) => (wt(), Et(St(Wr), { class: "d-article-page__article-page-overview" }, {
      default: Xt(() => [
        Qt(St(Fn), { model: rt.model }, null, 8, ["model"])
      ]),
      _: 1
    }));
  }
}), bh = /* @__PURE__ */ Tt({
  __name: "content-slider",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt;
    return (r, Z) => {
      var T, B;
      return wt(), Et(St(Un), {
        model: tt.model,
        "background-type": (T = tt.model) == null ? void 0 : T.backgroundType,
        "headline-type": (B = tt.model) == null ? void 0 : B.headlineType
      }, null, 8, ["model", "background-type", "headline-type"]);
    };
  }
});
function _r(rt) {
  if (rt.length > 10)
    throw new Error("Maximum of 10 answers allowed");
  const tt = "ABCDEFGHIJ".split(""), r = /* @__PURE__ */ new Map(), Z = /* @__PURE__ */ new Map();
  for (let T = 0; T < rt.length; T++)
    r.set(rt[T].id, tt[T]), Z.set(tt[T], rt[T].id);
  return {
    getFrontendId: (T) => r.get(T),
    getBackendId: (T) => Z.get(T)
  };
}
const vh = /* @__PURE__ */ Tt({
  __name: "poll",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt;
    let r;
    Hr(() => {
      r = _r(tt.model.answers);
      for (const T of tt.model.answers) {
        const B = r.getFrontendId(T.id);
        if (B === void 0)
          throw new Error(`Frontend id for answer ${T.id} should not be 'undefined'.`);
        T.id = B;
      }
    });
    async function Z(T) {
      const B = r.getBackendId(T.id);
      if (B === void 0)
        throw new Error(`Backend id for answer ${T.id} should not be 'undefined.'`);
      const R = await (await fetch(tt.model.voteUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          answerId: B,
          blockId: tt.model.blockId
        })
      })).json();
      for (const z of R) {
        const O = r.getFrontendId(z.id);
        if (O === void 0)
          throw new Error(`Frontend id for answer ${z.id} should not be 'undefined'.`);
        z.id = O;
      }
      return R;
    }
    return (T, B) => (wt(), Et(St(Vr), {
      model: rt.model,
      "poll-callback": (I) => Z(I)
    }, null, 8, ["model", "poll-callback"]));
  }
}), Ch = /* @__PURE__ */ Tt({
  __name: "quiz",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt;
    let r;
    Hr(() => {
      r = _r(tt.model.answers);
      for (const T of tt.model.answers) {
        const B = r.getFrontendId(T.id);
        if (B === void 0)
          throw new Error(`Frontend id for answer ${T.id} should not be 'undefined'.`);
        T.id = B;
      }
    });
    function Z(T) {
      const B = r.getBackendId(T.id);
      if (B === void 0)
        throw new Error(`Backend id for answer ${T.id} should not be 'undefined.'`);
      fetch(tt.model.voteUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          answerId: B,
          blockId: tt.model.blockId
        })
      });
    }
    return (T, B) => (wt(), Et(St(Vr), {
      model: rt.model,
      onAnswerSelected: Z
    }, null, 8, ["model"]));
  }
}), Ah = /* @__PURE__ */ Tt({
  __name: "form-builder",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt, r = (Z) => {
      fetch(tt.model.submitUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          formId: Z.formId,
          hostedPageId: Z.hostedPageId,
          sections: Z.sections
        })
      });
    };
    return (Z, T) => (wt(), Et(St(Gn), {
      model: rt.model,
      onSubmit: r
    }, null, 8, ["model"]));
  }
});
function de(rt) {
  const tt = (window == null ? void 0 : window.location.protocol) + "//" + (window == null ? void 0 : window.location.host) + (window == null ? void 0 : window.location.pathname), r = {}, Z = Object.keys(rt).map((R) => ({ key: R, type: rt[R] }));
  function T() {
    if (window != null && window.history) {
      const R = [];
      for (const O of Z) {
        const L = r[O.key];
        if (L != null)
          if (Array.isArray(L))
            for (const M of L)
              M && M.length > 0 && R.push(O.key + "=" + encodeURIComponent(M));
          else L && L.length > 0 && R.push(O.key + "=" + encodeURIComponent(L));
      }
      let z = tt;
      R.length > 0 && (z += "?" + R.join("&")), window == null || window.history.replaceState("", "", z);
    }
  }
  function B(R, z) {
    var O, L;
    if (z == null)
      r[R] = void 0;
    else if (Array.isArray(z)) {
      if (!z || z.length === 0)
        return;
      let M;
      Object.hasOwn(z[0], "filterOptions") ? M = ((O = z.find((w) => w.identifier === R)) == null ? void 0 : O.filterOptions[R]) ?? [] : M = z, r[R] = M.filter((w) => w.isSelected).map((w) => w.identifier);
    } else typeof z == "string" ? r[R] = z : Object.hasOwn(z, "label") && (r[R] = (L = z.value) == null ? void 0 : L.toString());
  }
  function I(R) {
    R = R == null || R.length == 0 ? window == null ? void 0 : window.location.search : R;
    const z = new URLSearchParams(R);
    for (const O of Z) {
      const L = z == null ? void 0 : z.getAll(O.key);
      (L == null ? void 0 : L.length) > 0 && (O.type === "array" ? r[O.key] = L.map((M) => decodeURIComponent(M)) : r[O.key] = decodeURIComponent(L[0]));
    }
  }
  return {
    updateUrl: () => T(),
    updateProperty: (R, z) => B(R, z),
    parseUrl: (R) => I(R),
    state: r
  };
}
function te(rt = void 0) {
  rt ?? (rt = "");
  let tt;
  async function r(T) {
    tt == null || tt.abort("Multiple Requests"), tt = new AbortController();
    const B = await fetch(T, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      signal: tt.signal
    });
    return B.status === 200 ? await B.json() : null;
  }
  async function Z(T, B) {
    tt == null || tt.abort("Multiple Requests"), tt = new AbortController();
    const I = await fetch(rt, {
      method: "POST",
      body: JSON.stringify(T),
      headers: {
        "Content-Type": "application/json"
      },
      signal: tt.signal
    });
    return I.status === 200 ? await I.json() : null;
  }
  return {
    post: (T) => Z(T),
    postUrl: (T) => r(T)
  };
}
function Mh(rt) {
  var tt, r;
  return (r = (tt = rt == null ? void 0 : rt.filterOptions) == null ? void 0 : tt.find((Z) => Z.isSelected)) == null ? void 0 : r.identifier;
}
function wh(rt) {
  const tt = {};
  if (!rt)
    return {};
  for (const r of rt)
    for (const Z in r.filterOptions) {
      const T = r.filterOptions[Z];
      tt[Z] = T.filter((B) => B.isSelected).map((B) => B.identifier);
    }
  return tt;
}
function $s(rt) {
  var tt;
  return (tt = rt == null ? void 0 : rt.selectedItem) == null ? void 0 : tt.value;
}
const Sh = /* @__PURE__ */ Tt({
  __name: "archive-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    const tt = rt, r = te("Search"), Z = de({
      term: "string",
      topic: "array",
      source: "array",
      format: "array",
      "publish-date": "string"
    });
    Z.parseUrl(tt.queryStringUrl);
    const T = Xn(), B = tt.model.noResultsText && tt.model.noResultsText.length > 0 ? tt.model.noResultsText : "No Results";
    T.initStore(
      tt.model.headline,
      tt.model.introText,
      Z.state.term == null ? "" : Z.state.term,
      tt.model.filters ?? [],
      tt.model.flyoutResults,
      tt.model.results,
      tt.model.showGridFirst,
      !0,
      B,
      tt.model.totalItemsCount ?? 0,
      (R) => I(R),
      tt.model.hideSearchBar
    );
    async function I(R) {
      const z = R.eventType === Hn.SearchTermHasChanged;
      Z.updateProperty("term", R.searchTerm), Z.updateProperty("topic", R.filters), Z.updateProperty("source", R.filters), Z.updateProperty("format", R.filters), Z.updateProperty("publish-date", R.filters), Z.updateUrl();
      const O = await r.post({
        searchTerm: R.searchTerm,
        filters: z ? null : wh(R.filters),
        eventType: R.eventType,
        lazyLoadEventData: z ? null : R.lazyLoadEventData
      });
      return O != null ? z ? {
        flyouts: O.flyouts,
        results: T.results,
        filters: T.filters,
        totalItemsCount: T.totalItemsCount
      } : {
        flyouts: T.flyoutResults,
        results: O.results,
        filters: O.filters ?? T.filters,
        totalItemsCount: O.totalCount
      } : {
        results: T.results,
        flyouts: T.flyoutResults,
        filters: T.filters,
        totalItemsCount: T.totalItemsCount
      };
    }
    return (R, z) => (wt(), Et(St(Yn)));
  }
}), kh = /* @__PURE__ */ Tt({
  __name: "calendar-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    const tt = rt, r = Ft(tt.model), Z = de({
      year: "string"
    });
    Z.parseUrl(tt.queryStringUrl);
    const T = te("events"), B = async (I, R) => {
      Z.updateProperty("year", I.identifier), Z.updateUrl();
      const z = await T.post({
        year: Z.state.year
      });
      z && (r.value = { ...tt.model, eventList: z });
    };
    return (I, R) => (wt(), Et(St(Wn), {
      model: r.value,
      onFilterChanged: B
    }, null, 8, ["model"]));
  }
}), Ph = /* @__PURE__ */ Tt({
  __name: "faq-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    return (tt, r) => (wt(), Et(St(Vn), { model: tt.model }, null, 8, ["model"]));
  }
}), Th = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Eh = /* @__PURE__ */ Tt({
  __name: "search-result-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    var R, z, O;
    const tt = rt, r = te("search"), Z = de({
      term: "string",
      category: "string",
      filterby: "string",
      sortby: "string"
    });
    Z.parseUrl(tt.queryStringUrl);
    const T = qn();
    Th && window.addEventListener("popstate", () => {
      Z.parseUrl(), T.$patch({
        searchTerm: Z.state.term ?? ""
      });
    }), T.initStore(
      Z.state.term ?? "",
      0,
      // Selected Tab Index
      (R = tt.model.props) == null ? void 0 : R.flyouts,
      (z = tt.model.props) == null ? void 0 : z.results,
      (O = tt.model.props) == null ? void 0 : O.filters,
      (L) => I(L)
    );
    const B = Ft(tt.model.props);
    async function I(L) {
      var A, l, u, c, v, s, f, y, h, a, x;
      if (L.searchTerm === "") return B.value;
      const M = L.eventType === _n.SearchTermHasChanged;
      M || (Z.updateProperty("term", L.searchTerm), Z.updateProperty("category", (l = (A = L.filters) == null ? void 0 : A.filter) == null ? void 0 : l.filterOptions), Z.updateProperty("filterby", (c = (u = L.filters) == null ? void 0 : u.filterBy) == null ? void 0 : c.selectedItem), Z.updateProperty("sortby", (s = (v = L.filters) == null ? void 0 : v.sortBy) == null ? void 0 : s.selectedItem), Z.updateUrl());
      const w = await r.post({
        searchTerm: L.searchTerm,
        category: M ? null : Mh((f = L.filters) == null ? void 0 : f.filter),
        sortBy: M ? null : (h = $s((y = L.filters) == null ? void 0 : y.sortBy)) == null ? void 0 : h.toString(),
        filterBy: M ? null : (x = $s((a = L.filters) == null ? void 0 : a.filterBy)) == null ? void 0 : x.toString(),
        eventType: L.eventType,
        lazyLoadEventData: M ? null : L.lazyLoadEventData
      });
      return w != null ? M ? {
        ...w,
        filters: T.filters,
        results: T.results
      } : {
        ...w,
        flyouts: T.flyoutResults
      } : { ...B.value };
    }
    return (L, M) => (wt(), Et(St(Kn)));
  }
}), Lh = /* @__PURE__ */ Tt({
  __name: "person-detail-page",
  props: {
    model: {},
    queryStringUrl: {},
    breadcrumb: {}
  },
  setup(rt) {
    return (tt, r) => (wt(), Et(St($n), {
      props: tt.model,
      breadcrumb: tt.breadcrumb
    }, null, 8, ["props", "breadcrumb"]));
  }
}), Oh = /* @__PURE__ */ he(Lh, [["__scopeId", "data-v-42d6a269"]]), jh = /* @__PURE__ */ Tt({
  __name: "property-gallery-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    const tt = rt;
    Zn().initStore(
      tt.model.filters,
      tt.model.results,
      async (I) => {
        const R = Z(tt.model.results, I.filters.filter((z) => z.isSelected === !0));
        return Promise.resolve({
          filters: tt.model.filters,
          results: R
        });
      }
    );
    function Z(I, R) {
      let z = I;
      for (const O of R)
        switch (O.daclFilterType) {
          case "string":
            z = T(z, O);
            break;
          case "number-range":
            z = B(z, O);
            break;
        }
      return z;
    }
    function T(I, R) {
      const O = R.filterOptions[R.identifier].filter((M) => M.isSelected === !0).map((M) => M.name);
      return I.filter((M) => O.includes(M[R.identifier]));
    }
    function B(I, R) {
      const O = R.filterOptions[R.identifier].filter((M) => M.isSelected === !0);
      return I.filter((M) => O.find((w) => M.marketValueSortValue == null ? !1 : M.marketValueSortValue >= w.lowerBound && (M.marketValueSortValue < w.upperBound || w.inclusiveUpperBound && M.marketValueSortValue == w.upperBound)));
    }
    return (I, R) => (wt(), Et(St(Jn), {
      headline: tt.model.headline ?? "",
      "intro-text": tt.model.introText ?? "",
      "hide-satellite-control": !0,
      "hide-street-view-control": !0
    }, null, 8, ["headline", "intro-text"]));
  }
});
var Dh = /* @__PURE__ */ ((rt) => (rt.Ticker = "Ticker", rt.WKN = "WKN", rt.ISIN = "ISIN", rt))(Dh || {});
const Ih = /* @__PURE__ */ Tt({
  __name: "property-detail-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    return (tt, r) => (wt(), Et(St(Qn), {
      model: tt.model,
      "hide-satellite-control": !0,
      "hide-street-view-control": !0
    }, null, 8, ["model"]));
  }
}), Bh = /* @__PURE__ */ Tt({
  __name: "glossary-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    return (tt, r) => (wt(), Et(St(ta), { model: tt.model }, null, 8, ["model"]));
  }
}), Rh = /* @__PURE__ */ Tt({
  __name: "media-releases-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    const tt = rt, r = te("Search"), Z = de({
      term: "string",
      year: "string"
    });
    Z.parseUrl(tt.queryStringUrl);
    const T = ea();
    T.initStore(
      tt.model.filter,
      tt.model.flyoutResults,
      tt.model.results,
      tt.model.showNumberOfResults ?? !0,
      Z.state.term ?? "",
      (I) => B(I)
    );
    async function B(I) {
      var O;
      if (I.eventType == Ds.SearchTermBlur)
        return {
          results: T.results,
          flyouts: T.flyoutResults,
          filter: T.filter,
          showNumberOfResults: T.showNumberOfResults
        };
      const R = I.eventType === Ds.SearchTermHasChanged;
      Z.updateProperty("term", I.searchTerm), Z.updateProperty("year", (O = I.selectedFilter) == null ? void 0 : O.identifier), Z.updateUrl();
      const z = await r.post({
        searchTerm: I.searchTerm,
        year: Z.state.year,
        eventType: I.eventType
      });
      return z != null ? R ? {
        flyouts: z.flyouts,
        results: T.results,
        filter: T.filter,
        showNumberOfResults: T.showNumberOfResults
      } : {
        results: z.results,
        flyouts: T.flyoutResults,
        filter: z.filter,
        showNumberOfResults: T.showNumberOfResults
      } : {
        results: T.results,
        flyouts: T.flyoutResults,
        filter: T.filter,
        showNumberOfResults: T.showNumberOfResults
      };
    }
    return (I, R) => (wt(), Et(St(ia), {
      headline: tt.model.headline,
      "intro-text": tt.model.introText,
      "page-disclaimer": "test"
    }, null, 8, ["headline", "intro-text"]));
  }
}), Nh = { class: "d-page-section__container" }, zh = /* @__PURE__ */ Tt({
  __name: "product-buying-process-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(rt) {
    const tt = rt, r = zt(() => tt.model.sortBy === "AlphabeticalAZ");
    return (Z, T) => (wt(), Rt("div", Nh, [
      Qt(St(sa), {
        model: tt.model,
        "partners-alphabetically-sorted": r.value
      }, null, 8, ["model", "partners-alphabetically-sorted"])
    ]));
  }
}), Fh = /* @__PURE__ */ he(zh, [["__scopeId", "data-v-fff7fece"]]), vs = async (rt, tt) => {
  var r, Z;
  (r = tt.link) != null && r.href && (await fetch((Z = tt.link) == null ? void 0 : Z.href, {
    method: "POST"
  }), location.reload());
}, Uh = /* @__PURE__ */ Tt({
  __name: "pageframe-patternlab-footer",
  props: {
    model: {
      type: Object,
      required: !1,
      default: null
    }
  },
  setup(rt) {
    return (tt, r) => rt.model ? (wt(), Et(St(oa), {
      key: 0,
      model: rt.model,
      onAudienceChanged: St(vs)
    }, null, 8, ["model", "onAudienceChanged"])) : Wt("", !0);
  }
});
function Kr(rt, tt) {
  const r = te();
  let Z;
  return {
    search: async (I) => {
      if (!rt)
        return;
      rt = decodeURI(rt);
      const R = rt.replace("{searchTerm}", I).replace("{limit}", "5"), z = await r.postUrl(R);
      z && tt(z);
    },
    searchClear: () => {
      tt(Z);
    },
    setStaticResult: (I) => {
      Z = I;
    }
  };
}
var Be, Zs;
function Gh() {
  if (Zs) return Be;
  Zs = 1;
  function rt() {
    this.__data__ = [], this.size = 0;
  }
  return Be = rt, Be;
}
var Re, Js;
function ce() {
  if (Js) return Re;
  Js = 1;
  function rt(tt, r) {
    return tt === r || tt !== tt && r !== r;
  }
  return Re = rt, Re;
}
var Ne, Qs;
function pe() {
  if (Qs) return Ne;
  Qs = 1;
  var rt = ce();
  function tt(r, Z) {
    for (var T = r.length; T--; )
      if (rt(r[T][0], Z))
        return T;
    return -1;
  }
  return Ne = tt, Ne;
}
var ze, to;
function Xh() {
  if (to) return ze;
  to = 1;
  var rt = pe(), tt = Array.prototype, r = tt.splice;
  function Z(T) {
    var B = this.__data__, I = rt(B, T);
    if (I < 0)
      return !1;
    var R = B.length - 1;
    return I == R ? B.pop() : r.call(B, I, 1), --this.size, !0;
  }
  return ze = Z, ze;
}
var Fe, eo;
function Hh() {
  if (eo) return Fe;
  eo = 1;
  var rt = pe();
  function tt(r) {
    var Z = this.__data__, T = rt(Z, r);
    return T < 0 ? void 0 : Z[T][1];
  }
  return Fe = tt, Fe;
}
var Ue, io;
function Yh() {
  if (io) return Ue;
  io = 1;
  var rt = pe();
  function tt(r) {
    return rt(this.__data__, r) > -1;
  }
  return Ue = tt, Ue;
}
var Ge, so;
function Wh() {
  if (so) return Ge;
  so = 1;
  var rt = pe();
  function tt(r, Z) {
    var T = this.__data__, B = rt(T, r);
    return B < 0 ? (++this.size, T.push([r, Z])) : T[B][1] = Z, this;
  }
  return Ge = tt, Ge;
}
var Xe, oo;
function ue() {
  if (oo) return Xe;
  oo = 1;
  var rt = Gh(), tt = Xh(), r = Hh(), Z = Yh(), T = Wh();
  function B(I) {
    var R = -1, z = I == null ? 0 : I.length;
    for (this.clear(); ++R < z; ) {
      var O = I[R];
      this.set(O[0], O[1]);
    }
  }
  return B.prototype.clear = rt, B.prototype.delete = tt, B.prototype.get = r, B.prototype.has = Z, B.prototype.set = T, Xe = B, Xe;
}
var He, ro;
function Vh() {
  if (ro) return He;
  ro = 1;
  var rt = ue();
  function tt() {
    this.__data__ = new rt(), this.size = 0;
  }
  return He = tt, He;
}
var Ye, no;
function qh() {
  if (no) return Ye;
  no = 1;
  function rt(tt) {
    var r = this.__data__, Z = r.delete(tt);
    return this.size = r.size, Z;
  }
  return Ye = rt, Ye;
}
var We, ao;
function _h() {
  if (ao) return We;
  ao = 1;
  function rt(tt) {
    return this.__data__.get(tt);
  }
  return We = rt, We;
}
var Ve, lo;
function Kh() {
  if (lo) return Ve;
  lo = 1;
  function rt(tt) {
    return this.__data__.has(tt);
  }
  return Ve = rt, Ve;
}
var qe, ho;
function $r() {
  if (ho) return qe;
  ho = 1;
  var rt = typeof ne == "object" && ne && ne.Object === Object && ne;
  return qe = rt, qe;
}
var _e, co;
function _t() {
  if (co) return _e;
  co = 1;
  var rt = $r(), tt = typeof self == "object" && self && self.Object === Object && self, r = rt || tt || Function("return this")();
  return _e = r, _e;
}
var Ke, po;
function Zr() {
  if (po) return Ke;
  po = 1;
  var rt = _t(), tt = rt.Symbol;
  return Ke = tt, Ke;
}
var $e, uo;
function $h() {
  if (uo) return $e;
  uo = 1;
  var rt = Zr(), tt = Object.prototype, r = tt.hasOwnProperty, Z = tt.toString, T = rt ? rt.toStringTag : void 0;
  function B(I) {
    var R = r.call(I, T), z = I[T];
    try {
      I[T] = void 0;
      var O = !0;
    } catch {
    }
    var L = Z.call(I);
    return O && (R ? I[T] = z : delete I[T]), L;
  }
  return $e = B, $e;
}
var Ze, go;
function Zh() {
  if (go) return Ze;
  go = 1;
  var rt = Object.prototype, tt = rt.toString;
  function r(Z) {
    return tt.call(Z);
  }
  return Ze = r, Ze;
}
var Je, fo;
function ge() {
  if (fo) return Je;
  fo = 1;
  var rt = Zr(), tt = $h(), r = Zh(), Z = "[object Null]", T = "[object Undefined]", B = rt ? rt.toStringTag : void 0;
  function I(R) {
    return R == null ? R === void 0 ? T : Z : B && B in Object(R) ? tt(R) : r(R);
  }
  return Je = I, Je;
}
var Qe, mo;
function Vt() {
  if (mo) return Qe;
  mo = 1;
  function rt(tt) {
    var r = typeof tt;
    return tt != null && (r == "object" || r == "function");
  }
  return Qe = rt, Qe;
}
var ti, xo;
function Cs() {
  if (xo) return ti;
  xo = 1;
  var rt = ge(), tt = Vt(), r = "[object AsyncFunction]", Z = "[object Function]", T = "[object GeneratorFunction]", B = "[object Proxy]";
  function I(R) {
    if (!tt(R))
      return !1;
    var z = rt(R);
    return z == Z || z == T || z == r || z == B;
  }
  return ti = I, ti;
}
var ei, yo;
function Jh() {
  if (yo) return ei;
  yo = 1;
  var rt = _t(), tt = rt["__core-js_shared__"];
  return ei = tt, ei;
}
var ii, bo;
function Qh() {
  if (bo) return ii;
  bo = 1;
  var rt = Jh(), tt = function() {
    var Z = /[^.]+$/.exec(rt && rt.keys && rt.keys.IE_PROTO || "");
    return Z ? "Symbol(src)_1." + Z : "";
  }();
  function r(Z) {
    return !!tt && tt in Z;
  }
  return ii = r, ii;
}
var si, vo;
function td() {
  if (vo) return si;
  vo = 1;
  var rt = Function.prototype, tt = rt.toString;
  function r(Z) {
    if (Z != null) {
      try {
        return tt.call(Z);
      } catch {
      }
      try {
        return Z + "";
      } catch {
      }
    }
    return "";
  }
  return si = r, si;
}
var oi, Co;
function ed() {
  if (Co) return oi;
  Co = 1;
  var rt = Cs(), tt = Qh(), r = Vt(), Z = td(), T = /[\\^$.*+?()[\]{}|]/g, B = /^\[object .+?Constructor\]$/, I = Function.prototype, R = Object.prototype, z = I.toString, O = R.hasOwnProperty, L = RegExp(
    "^" + z.call(O).replace(T, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function M(w) {
    if (!r(w) || tt(w))
      return !1;
    var A = rt(w) ? L : B;
    return A.test(Z(w));
  }
  return oi = M, oi;
}
var ri, Ao;
function id() {
  if (Ao) return ri;
  Ao = 1;
  function rt(tt, r) {
    return tt == null ? void 0 : tt[r];
  }
  return ri = rt, ri;
}
var ni, Mo;
function As() {
  if (Mo) return ni;
  Mo = 1;
  var rt = ed(), tt = id();
  function r(Z, T) {
    var B = tt(Z, T);
    return rt(B) ? B : void 0;
  }
  return ni = r, ni;
}
var ai, wo;
function Jr() {
  if (wo) return ai;
  wo = 1;
  var rt = As(), tt = _t(), r = rt(tt, "Map");
  return ai = r, ai;
}
var li, So;
function fe() {
  if (So) return li;
  So = 1;
  var rt = As(), tt = rt(Object, "create");
  return li = tt, li;
}
var hi, ko;
function sd() {
  if (ko) return hi;
  ko = 1;
  var rt = fe();
  function tt() {
    this.__data__ = rt ? rt(null) : {}, this.size = 0;
  }
  return hi = tt, hi;
}
var di, Po;
function od() {
  if (Po) return di;
  Po = 1;
  function rt(tt) {
    var r = this.has(tt) && delete this.__data__[tt];
    return this.size -= r ? 1 : 0, r;
  }
  return di = rt, di;
}
var ci, To;
function rd() {
  if (To) return ci;
  To = 1;
  var rt = fe(), tt = "__lodash_hash_undefined__", r = Object.prototype, Z = r.hasOwnProperty;
  function T(B) {
    var I = this.__data__;
    if (rt) {
      var R = I[B];
      return R === tt ? void 0 : R;
    }
    return Z.call(I, B) ? I[B] : void 0;
  }
  return ci = T, ci;
}
var pi, Eo;
function nd() {
  if (Eo) return pi;
  Eo = 1;
  var rt = fe(), tt = Object.prototype, r = tt.hasOwnProperty;
  function Z(T) {
    var B = this.__data__;
    return rt ? B[T] !== void 0 : r.call(B, T);
  }
  return pi = Z, pi;
}
var ui, Lo;
function ad() {
  if (Lo) return ui;
  Lo = 1;
  var rt = fe(), tt = "__lodash_hash_undefined__";
  function r(Z, T) {
    var B = this.__data__;
    return this.size += this.has(Z) ? 0 : 1, B[Z] = rt && T === void 0 ? tt : T, this;
  }
  return ui = r, ui;
}
var gi, Oo;
function ld() {
  if (Oo) return gi;
  Oo = 1;
  var rt = sd(), tt = od(), r = rd(), Z = nd(), T = ad();
  function B(I) {
    var R = -1, z = I == null ? 0 : I.length;
    for (this.clear(); ++R < z; ) {
      var O = I[R];
      this.set(O[0], O[1]);
    }
  }
  return B.prototype.clear = rt, B.prototype.delete = tt, B.prototype.get = r, B.prototype.has = Z, B.prototype.set = T, gi = B, gi;
}
var fi, jo;
function hd() {
  if (jo) return fi;
  jo = 1;
  var rt = ld(), tt = ue(), r = Jr();
  function Z() {
    this.size = 0, this.__data__ = {
      hash: new rt(),
      map: new (r || tt)(),
      string: new rt()
    };
  }
  return fi = Z, fi;
}
var mi, Do;
function dd() {
  if (Do) return mi;
  Do = 1;
  function rt(tt) {
    var r = typeof tt;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? tt !== "__proto__" : tt === null;
  }
  return mi = rt, mi;
}
var xi, Io;
function me() {
  if (Io) return xi;
  Io = 1;
  var rt = dd();
  function tt(r, Z) {
    var T = r.__data__;
    return rt(Z) ? T[typeof Z == "string" ? "string" : "hash"] : T.map;
  }
  return xi = tt, xi;
}
var yi, Bo;
function cd() {
  if (Bo) return yi;
  Bo = 1;
  var rt = me();
  function tt(r) {
    var Z = rt(this, r).delete(r);
    return this.size -= Z ? 1 : 0, Z;
  }
  return yi = tt, yi;
}
var bi, Ro;
function pd() {
  if (Ro) return bi;
  Ro = 1;
  var rt = me();
  function tt(r) {
    return rt(this, r).get(r);
  }
  return bi = tt, bi;
}
var vi, No;
function ud() {
  if (No) return vi;
  No = 1;
  var rt = me();
  function tt(r) {
    return rt(this, r).has(r);
  }
  return vi = tt, vi;
}
var Ci, zo;
function gd() {
  if (zo) return Ci;
  zo = 1;
  var rt = me();
  function tt(r, Z) {
    var T = rt(this, r), B = T.size;
    return T.set(r, Z), this.size += T.size == B ? 0 : 1, this;
  }
  return Ci = tt, Ci;
}
var Ai, Fo;
function fd() {
  if (Fo) return Ai;
  Fo = 1;
  var rt = hd(), tt = cd(), r = pd(), Z = ud(), T = gd();
  function B(I) {
    var R = -1, z = I == null ? 0 : I.length;
    for (this.clear(); ++R < z; ) {
      var O = I[R];
      this.set(O[0], O[1]);
    }
  }
  return B.prototype.clear = rt, B.prototype.delete = tt, B.prototype.get = r, B.prototype.has = Z, B.prototype.set = T, Ai = B, Ai;
}
var Mi, Uo;
function md() {
  if (Uo) return Mi;
  Uo = 1;
  var rt = ue(), tt = Jr(), r = fd(), Z = 200;
  function T(B, I) {
    var R = this.__data__;
    if (R instanceof rt) {
      var z = R.__data__;
      if (!tt || z.length < Z - 1)
        return z.push([B, I]), this.size = ++R.size, this;
      R = this.__data__ = new r(z);
    }
    return R.set(B, I), this.size = R.size, this;
  }
  return Mi = T, Mi;
}
var wi, Go;
function xd() {
  if (Go) return wi;
  Go = 1;
  var rt = ue(), tt = Vh(), r = qh(), Z = _h(), T = Kh(), B = md();
  function I(R) {
    var z = this.__data__ = new rt(R);
    this.size = z.size;
  }
  return I.prototype.clear = tt, I.prototype.delete = r, I.prototype.get = Z, I.prototype.has = T, I.prototype.set = B, wi = I, wi;
}
var Si, Xo;
function Qr() {
  if (Xo) return Si;
  Xo = 1;
  var rt = As(), tt = function() {
    try {
      var r = rt(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return Si = tt, Si;
}
var ki, Ho;
function Ms() {
  if (Ho) return ki;
  Ho = 1;
  var rt = Qr();
  function tt(r, Z, T) {
    Z == "__proto__" && rt ? rt(r, Z, {
      configurable: !0,
      enumerable: !0,
      value: T,
      writable: !0
    }) : r[Z] = T;
  }
  return ki = tt, ki;
}
var Pi, Yo;
function tn() {
  if (Yo) return Pi;
  Yo = 1;
  var rt = Ms(), tt = ce();
  function r(Z, T, B) {
    (B !== void 0 && !tt(Z[T], B) || B === void 0 && !(T in Z)) && rt(Z, T, B);
  }
  return Pi = r, Pi;
}
var Ti, Wo;
function yd() {
  if (Wo) return Ti;
  Wo = 1;
  function rt(tt) {
    return function(r, Z, T) {
      for (var B = -1, I = Object(r), R = T(r), z = R.length; z--; ) {
        var O = R[tt ? z : ++B];
        if (Z(I[O], O, I) === !1)
          break;
      }
      return r;
    };
  }
  return Ti = rt, Ti;
}
var Ei, Vo;
function bd() {
  if (Vo) return Ei;
  Vo = 1;
  var rt = yd(), tt = rt();
  return Ei = tt, Ei;
}
var $t = { exports: {} };
$t.exports;
var qo;
function vd() {
  return qo || (qo = 1, function(rt, tt) {
    var r = _t(), Z = tt && !tt.nodeType && tt, T = Z && !0 && rt && !rt.nodeType && rt, B = T && T.exports === Z, I = B ? r.Buffer : void 0, R = I ? I.allocUnsafe : void 0;
    function z(O, L) {
      if (L)
        return O.slice();
      var M = O.length, w = R ? R(M) : new O.constructor(M);
      return O.copy(w), w;
    }
    rt.exports = z;
  }($t, $t.exports)), $t.exports;
}
var Li, _o;
function Cd() {
  if (_o) return Li;
  _o = 1;
  var rt = _t(), tt = rt.Uint8Array;
  return Li = tt, Li;
}
var Oi, Ko;
function Ad() {
  if (Ko) return Oi;
  Ko = 1;
  var rt = Cd();
  function tt(r) {
    var Z = new r.constructor(r.byteLength);
    return new rt(Z).set(new rt(r)), Z;
  }
  return Oi = tt, Oi;
}
var ji, $o;
function Md() {
  if ($o) return ji;
  $o = 1;
  var rt = Ad();
  function tt(r, Z) {
    var T = Z ? rt(r.buffer) : r.buffer;
    return new r.constructor(T, r.byteOffset, r.length);
  }
  return ji = tt, ji;
}
var Di, Zo;
function wd() {
  if (Zo) return Di;
  Zo = 1;
  function rt(tt, r) {
    var Z = -1, T = tt.length;
    for (r || (r = Array(T)); ++Z < T; )
      r[Z] = tt[Z];
    return r;
  }
  return Di = rt, Di;
}
var Ii, Jo;
function Sd() {
  if (Jo) return Ii;
  Jo = 1;
  var rt = Vt(), tt = Object.create, r = /* @__PURE__ */ function() {
    function Z() {
    }
    return function(T) {
      if (!rt(T))
        return {};
      if (tt)
        return tt(T);
      Z.prototype = T;
      var B = new Z();
      return Z.prototype = void 0, B;
    };
  }();
  return Ii = r, Ii;
}
var Bi, Qo;
function kd() {
  if (Qo) return Bi;
  Qo = 1;
  function rt(tt, r) {
    return function(Z) {
      return tt(r(Z));
    };
  }
  return Bi = rt, Bi;
}
var Ri, tr;
function en() {
  if (tr) return Ri;
  tr = 1;
  var rt = kd(), tt = rt(Object.getPrototypeOf, Object);
  return Ri = tt, Ri;
}
var Ni, er;
function sn() {
  if (er) return Ni;
  er = 1;
  var rt = Object.prototype;
  function tt(r) {
    var Z = r && r.constructor, T = typeof Z == "function" && Z.prototype || rt;
    return r === T;
  }
  return Ni = tt, Ni;
}
var zi, ir;
function Pd() {
  if (ir) return zi;
  ir = 1;
  var rt = Sd(), tt = en(), r = sn();
  function Z(T) {
    return typeof T.constructor == "function" && !r(T) ? rt(tt(T)) : {};
  }
  return zi = Z, zi;
}
var Fi, sr;
function ee() {
  if (sr) return Fi;
  sr = 1;
  function rt(tt) {
    return tt != null && typeof tt == "object";
  }
  return Fi = rt, Fi;
}
var Ui, or;
function Td() {
  if (or) return Ui;
  or = 1;
  var rt = ge(), tt = ee(), r = "[object Arguments]";
  function Z(T) {
    return tt(T) && rt(T) == r;
  }
  return Ui = Z, Ui;
}
var Gi, rr;
function on() {
  if (rr) return Gi;
  rr = 1;
  var rt = Td(), tt = ee(), r = Object.prototype, Z = r.hasOwnProperty, T = r.propertyIsEnumerable, B = rt(/* @__PURE__ */ function() {
    return arguments;
  }()) ? rt : function(I) {
    return tt(I) && Z.call(I, "callee") && !T.call(I, "callee");
  };
  return Gi = B, Gi;
}
var Xi, nr;
function rn() {
  if (nr) return Xi;
  nr = 1;
  var rt = Array.isArray;
  return Xi = rt, Xi;
}
var Hi, ar;
function nn() {
  if (ar) return Hi;
  ar = 1;
  var rt = 9007199254740991;
  function tt(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= rt;
  }
  return Hi = tt, Hi;
}
var Yi, lr;
function ws() {
  if (lr) return Yi;
  lr = 1;
  var rt = Cs(), tt = nn();
  function r(Z) {
    return Z != null && tt(Z.length) && !rt(Z);
  }
  return Yi = r, Yi;
}
var Wi, hr;
function Ed() {
  if (hr) return Wi;
  hr = 1;
  var rt = ws(), tt = ee();
  function r(Z) {
    return tt(Z) && rt(Z);
  }
  return Wi = r, Wi;
}
var Zt = { exports: {} }, Vi, dr;
function Ld() {
  if (dr) return Vi;
  dr = 1;
  function rt() {
    return !1;
  }
  return Vi = rt, Vi;
}
Zt.exports;
var cr;
function an() {
  return cr || (cr = 1, function(rt, tt) {
    var r = _t(), Z = Ld(), T = tt && !tt.nodeType && tt, B = T && !0 && rt && !rt.nodeType && rt, I = B && B.exports === T, R = I ? r.Buffer : void 0, z = R ? R.isBuffer : void 0, O = z || Z;
    rt.exports = O;
  }(Zt, Zt.exports)), Zt.exports;
}
var qi, pr;
function Od() {
  if (pr) return qi;
  pr = 1;
  var rt = ge(), tt = en(), r = ee(), Z = "[object Object]", T = Function.prototype, B = Object.prototype, I = T.toString, R = B.hasOwnProperty, z = I.call(Object);
  function O(L) {
    if (!r(L) || rt(L) != Z)
      return !1;
    var M = tt(L);
    if (M === null)
      return !0;
    var w = R.call(M, "constructor") && M.constructor;
    return typeof w == "function" && w instanceof w && I.call(w) == z;
  }
  return qi = O, qi;
}
var _i, ur;
function jd() {
  if (ur) return _i;
  ur = 1;
  var rt = ge(), tt = nn(), r = ee(), Z = "[object Arguments]", T = "[object Array]", B = "[object Boolean]", I = "[object Date]", R = "[object Error]", z = "[object Function]", O = "[object Map]", L = "[object Number]", M = "[object Object]", w = "[object RegExp]", A = "[object Set]", l = "[object String]", u = "[object WeakMap]", c = "[object ArrayBuffer]", v = "[object DataView]", s = "[object Float32Array]", f = "[object Float64Array]", y = "[object Int8Array]", h = "[object Int16Array]", a = "[object Int32Array]", x = "[object Uint8Array]", S = "[object Uint8ClampedArray]", E = "[object Uint16Array]", b = "[object Uint32Array]", p = {};
  p[s] = p[f] = p[y] = p[h] = p[a] = p[x] = p[S] = p[E] = p[b] = !0, p[Z] = p[T] = p[c] = p[B] = p[v] = p[I] = p[R] = p[z] = p[O] = p[L] = p[M] = p[w] = p[A] = p[l] = p[u] = !1;
  function C(o) {
    return r(o) && tt(o.length) && !!p[rt(o)];
  }
  return _i = C, _i;
}
var Ki, gr;
function Dd() {
  if (gr) return Ki;
  gr = 1;
  function rt(tt) {
    return function(r) {
      return tt(r);
    };
  }
  return Ki = rt, Ki;
}
var Jt = { exports: {} };
Jt.exports;
var fr;
function Id() {
  return fr || (fr = 1, function(rt, tt) {
    var r = $r(), Z = tt && !tt.nodeType && tt, T = Z && !0 && rt && !rt.nodeType && rt, B = T && T.exports === Z, I = B && r.process, R = function() {
      try {
        var z = T && T.require && T.require("util").types;
        return z || I && I.binding && I.binding("util");
      } catch {
      }
    }();
    rt.exports = R;
  }(Jt, Jt.exports)), Jt.exports;
}
var $i, mr;
function ln() {
  if (mr) return $i;
  mr = 1;
  var rt = jd(), tt = Dd(), r = Id(), Z = r && r.isTypedArray, T = Z ? tt(Z) : rt;
  return $i = T, $i;
}
var Zi, xr;
function hn() {
  if (xr) return Zi;
  xr = 1;
  function rt(tt, r) {
    if (!(r === "constructor" && typeof tt[r] == "function") && r != "__proto__")
      return tt[r];
  }
  return Zi = rt, Zi;
}
var Ji, yr;
function Bd() {
  if (yr) return Ji;
  yr = 1;
  var rt = Ms(), tt = ce(), r = Object.prototype, Z = r.hasOwnProperty;
  function T(B, I, R) {
    var z = B[I];
    (!(Z.call(B, I) && tt(z, R)) || R === void 0 && !(I in B)) && rt(B, I, R);
  }
  return Ji = T, Ji;
}
var Qi, br;
function Rd() {
  if (br) return Qi;
  br = 1;
  var rt = Bd(), tt = Ms();
  function r(Z, T, B, I) {
    var R = !B;
    B || (B = {});
    for (var z = -1, O = T.length; ++z < O; ) {
      var L = T[z], M = I ? I(B[L], Z[L], L, B, Z) : void 0;
      M === void 0 && (M = Z[L]), R ? tt(B, L, M) : rt(B, L, M);
    }
    return B;
  }
  return Qi = r, Qi;
}
var ts, vr;
function Nd() {
  if (vr) return ts;
  vr = 1;
  function rt(tt, r) {
    for (var Z = -1, T = Array(tt); ++Z < tt; )
      T[Z] = r(Z);
    return T;
  }
  return ts = rt, ts;
}
var es, Cr;
function dn() {
  if (Cr) return es;
  Cr = 1;
  var rt = 9007199254740991, tt = /^(?:0|[1-9]\d*)$/;
  function r(Z, T) {
    var B = typeof Z;
    return T = T ?? rt, !!T && (B == "number" || B != "symbol" && tt.test(Z)) && Z > -1 && Z % 1 == 0 && Z < T;
  }
  return es = r, es;
}
var is, Ar;
function zd() {
  if (Ar) return is;
  Ar = 1;
  var rt = Nd(), tt = on(), r = rn(), Z = an(), T = dn(), B = ln(), I = Object.prototype, R = I.hasOwnProperty;
  function z(O, L) {
    var M = r(O), w = !M && tt(O), A = !M && !w && Z(O), l = !M && !w && !A && B(O), u = M || w || A || l, c = u ? rt(O.length, String) : [], v = c.length;
    for (var s in O)
      (L || R.call(O, s)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
      (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      A && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      l && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
      T(s, v))) && c.push(s);
    return c;
  }
  return is = z, is;
}
var ss, Mr;
function Fd() {
  if (Mr) return ss;
  Mr = 1;
  function rt(tt) {
    var r = [];
    if (tt != null)
      for (var Z in Object(tt))
        r.push(Z);
    return r;
  }
  return ss = rt, ss;
}
var os, wr;
function Ud() {
  if (wr) return os;
  wr = 1;
  var rt = Vt(), tt = sn(), r = Fd(), Z = Object.prototype, T = Z.hasOwnProperty;
  function B(I) {
    if (!rt(I))
      return r(I);
    var R = tt(I), z = [];
    for (var O in I)
      O == "constructor" && (R || !T.call(I, O)) || z.push(O);
    return z;
  }
  return os = B, os;
}
var rs, Sr;
function cn() {
  if (Sr) return rs;
  Sr = 1;
  var rt = zd(), tt = Ud(), r = ws();
  function Z(T) {
    return r(T) ? rt(T, !0) : tt(T);
  }
  return rs = Z, rs;
}
var ns, kr;
function Gd() {
  if (kr) return ns;
  kr = 1;
  var rt = Rd(), tt = cn();
  function r(Z) {
    return rt(Z, tt(Z));
  }
  return ns = r, ns;
}
var as, Pr;
function Xd() {
  if (Pr) return as;
  Pr = 1;
  var rt = tn(), tt = vd(), r = Md(), Z = wd(), T = Pd(), B = on(), I = rn(), R = Ed(), z = an(), O = Cs(), L = Vt(), M = Od(), w = ln(), A = hn(), l = Gd();
  function u(c, v, s, f, y, h, a) {
    var x = A(c, s), S = A(v, s), E = a.get(S);
    if (E) {
      rt(c, s, E);
      return;
    }
    var b = h ? h(x, S, s + "", c, v, a) : void 0, p = b === void 0;
    if (p) {
      var C = I(S), o = !C && z(S), t = !C && !o && w(S);
      b = S, C || o || t ? I(x) ? b = x : R(x) ? b = Z(x) : o ? (p = !1, b = tt(S, !0)) : t ? (p = !1, b = r(S, !0)) : b = [] : M(S) || B(S) ? (b = x, B(x) ? b = l(x) : (!L(x) || O(x)) && (b = T(S))) : p = !1;
    }
    p && (a.set(S, b), y(b, S, f, h, a), a.delete(S)), rt(c, s, b);
  }
  return as = u, as;
}
var ls, Tr;
function Hd() {
  if (Tr) return ls;
  Tr = 1;
  var rt = xd(), tt = tn(), r = bd(), Z = Xd(), T = Vt(), B = cn(), I = hn();
  function R(z, O, L, M, w) {
    z !== O && r(O, function(A, l) {
      if (w || (w = new rt()), T(A))
        Z(z, O, l, L, R, M, w);
      else {
        var u = M ? M(I(z, l), A, l + "", z, O, w) : void 0;
        u === void 0 && (u = A), tt(z, l, u);
      }
    }, B);
  }
  return ls = R, ls;
}
var hs, Er;
function pn() {
  if (Er) return hs;
  Er = 1;
  function rt(tt) {
    return tt;
  }
  return hs = rt, hs;
}
var ds, Lr;
function Yd() {
  if (Lr) return ds;
  Lr = 1;
  function rt(tt, r, Z) {
    switch (Z.length) {
      case 0:
        return tt.call(r);
      case 1:
        return tt.call(r, Z[0]);
      case 2:
        return tt.call(r, Z[0], Z[1]);
      case 3:
        return tt.call(r, Z[0], Z[1], Z[2]);
    }
    return tt.apply(r, Z);
  }
  return ds = rt, ds;
}
var cs, Or;
function Wd() {
  if (Or) return cs;
  Or = 1;
  var rt = Yd(), tt = Math.max;
  function r(Z, T, B) {
    return T = tt(T === void 0 ? Z.length - 1 : T, 0), function() {
      for (var I = arguments, R = -1, z = tt(I.length - T, 0), O = Array(z); ++R < z; )
        O[R] = I[T + R];
      R = -1;
      for (var L = Array(T + 1); ++R < T; )
        L[R] = I[R];
      return L[T] = B(O), rt(Z, this, L);
    };
  }
  return cs = r, cs;
}
var ps, jr;
function Vd() {
  if (jr) return ps;
  jr = 1;
  function rt(tt) {
    return function() {
      return tt;
    };
  }
  return ps = rt, ps;
}
var us, Dr;
function qd() {
  if (Dr) return us;
  Dr = 1;
  var rt = Vd(), tt = Qr(), r = pn(), Z = tt ? function(T, B) {
    return tt(T, "toString", {
      configurable: !0,
      enumerable: !1,
      value: rt(B),
      writable: !0
    });
  } : r;
  return us = Z, us;
}
var gs, Ir;
function _d() {
  if (Ir) return gs;
  Ir = 1;
  var rt = 800, tt = 16, r = Date.now;
  function Z(T) {
    var B = 0, I = 0;
    return function() {
      var R = r(), z = tt - (R - I);
      if (I = R, z > 0) {
        if (++B >= rt)
          return arguments[0];
      } else
        B = 0;
      return T.apply(void 0, arguments);
    };
  }
  return gs = Z, gs;
}
var fs, Br;
function Kd() {
  if (Br) return fs;
  Br = 1;
  var rt = qd(), tt = _d(), r = tt(rt);
  return fs = r, fs;
}
var ms, Rr;
function $d() {
  if (Rr) return ms;
  Rr = 1;
  var rt = pn(), tt = Wd(), r = Kd();
  function Z(T, B) {
    return r(tt(T, B, rt), T + "");
  }
  return ms = Z, ms;
}
var xs, Nr;
function Zd() {
  if (Nr) return xs;
  Nr = 1;
  var rt = ce(), tt = ws(), r = dn(), Z = Vt();
  function T(B, I, R) {
    if (!Z(R))
      return !1;
    var z = typeof I;
    return (z == "number" ? tt(R) && r(I, R.length) : z == "string" && I in R) ? rt(R[I], B) : !1;
  }
  return xs = T, xs;
}
var ys, zr;
function Jd() {
  if (zr) return ys;
  zr = 1;
  var rt = $d(), tt = Zd();
  function r(Z) {
    return rt(function(T, B) {
      var I = -1, R = B.length, z = R > 1 ? B[R - 1] : void 0, O = R > 2 ? B[2] : void 0;
      for (z = Z.length > 3 && typeof z == "function" ? (R--, z) : void 0, O && tt(B[0], B[1], O) && (z = R < 3 ? void 0 : z, R = 1), T = Object(T); ++I < R; ) {
        var L = B[I];
        L && Z(T, L, I, z);
      }
      return T;
    });
  }
  return ys = r, ys;
}
var bs, Fr;
function Qd() {
  if (Fr) return bs;
  Fr = 1;
  var rt = Hd(), tt = Jd(), r = tt(function(Z, T, B) {
    rt(Z, T, B);
  });
  return bs = r, bs;
}
var tc = Qd();
const un = /* @__PURE__ */ It(tc);
function ec() {
  let rt = window.screen.orientation.angle == 0 ? window.screen.height : window.screen.width;
  return navigator.userAgent.indexOf("Android") >= 0 && window.devicePixelRatio && (rt = rt / window.devicePixelRatio), rt;
}
function Ur(rt, tt) {
  var r, Z, T, B, I, R, z, O, L, M, w, A, l, u, c, v, s, f;
  return {
    datalayer_version: rt.version,
    site_envwork: (r = rt.site) == null ? void 0 : r.environment,
    site_family: (Z = rt.site) == null ? void 0 : Z.family,
    site_country: (T = rt.site) == null ? void 0 : T.country,
    site_business: (B = rt.site) == null ? void 0 : B.business,
    site_language: (I = rt.site) == null ? void 0 : I.language,
    site_target_group: null,
    site_responsivetype: ec() >= 640 ? "Desktop" : "Mobile",
    page_version: (R = rt.page) == null ? void 0 : R.version,
    page_name: (z = rt.page) == null ? void 0 : z.name,
    page_id: (O = rt.page) == null ? void 0 : O.id,
    page_path: (L = rt.page) == null ? void 0 : L.path,
    page_type: (M = rt.page) == null ? void 0 : M.type,
    page_title: tt,
    page_article_id: (w = rt.page) == null ? void 0 : w.articleId,
    page_publication_date: (A = rt.page) == null ? void 0 : A.publicationDate,
    page_website_goal: (l = rt.page) == null ? void 0 : l.websiteGoal,
    page_category: (u = rt.page) == null ? void 0 : u.categories,
    tags: (c = rt.page) == null ? void 0 : c.tags,
    user_type: (v = rt.user) == null ? void 0 : v.type,
    user_logged_id: (s = rt.user) == null ? void 0 : s.id,
    ...((f = rt.page) == null ? void 0 : f.customAttributes) ?? {}
  };
}
const gn = (rt, tt) => {
  var B, I;
  if (!window)
    return null;
  tt ?? (tt = document.title), window.utag_data = {
    page_name: (B = rt.page) == null ? void 0 : B.name
    // Required because uxcl uses this to overwrite event sources
  };
  const r = {};
  (((I = rt.page) == null ? void 0 : I.tags) ?? []).forEach((R) => {
    r[R.tag] = R.childTags;
  });
  const Z = Ur(rt, tt);
  return window.reinitTracking = (R) => {
    setTimeout(() => T(un(Z, Ur(R, tt))), 500);
  }, (R) => {
    Z.user_type = R.userType, Z.user_logged_id = R.userId, T(Z);
  };
  function T(R) {
    if (window.utag_data = R, window.utag) {
      window.utag.view(R);
      return;
    }
    const z = document.createElement("script");
    z.text = `
window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
window.utag_cfg_ovrd.noview = true;`;
    const O = document.createElement("script");
    O.setAttribute("defer", ""), O.src = rt.utagScriptUrl, O.addEventListener("load", () => {
      var L;
      if (((L = window.utag) == null ? void 0 : L.view) == null) {
        console.error("utag object or utag.view function not defined on window object.");
        return;
      }
      window.utag.view(R);
    }), window.document.head.appendChild(z), window.document.head.appendChild(O);
  }
};
async function fn(rt, tt, r, Z) {
  const I = await (await fetch(tt, {
    method: "POST",
    body: JSON.stringify({ currentPageId: rt }),
    headers: {
      "Content-Type": "application/json",
      "epi-current-page-id": rt.toString()
    }
  })).json();
  I && (I.login && r(I.login), I.tracking && Z(I.tracking));
}
const ic = /* @__PURE__ */ Tt({
  __name: "pageframe",
  props: {
    model: {},
    hideBreadcrumb: { type: Boolean }
  },
  setup(rt) {
    var R, z, O, L, M, w, A;
    const tt = rt, r = zt(() => tt.hideBreadcrumb || tt.model.hideBreadcrumb), Z = window != null;
    let T;
    Z && tt.model.tracking && (T = gn(tt.model.tracking, (R = tt.model.seo) == null ? void 0 : R.websiteName));
    const B = Ft({ ...tt.model, hideBreadcrumb: r.value }), I = Kr(tt.model.searchUrl, (l) => {
      var u, c, v;
      (v = (c = (u = B.value) == null ? void 0 : u.header) == null ? void 0 : c.iconList) != null && v.searchIcon && l && (B.value.header.iconList.searchIcon.result = l);
    });
    return (L = (O = (z = B.value) == null ? void 0 : z.header) == null ? void 0 : O.iconList) != null && L.searchIcon && I.setStaticResult((A = (w = (M = tt.model.header) == null ? void 0 : M.iconList) == null ? void 0 : w.searchIcon) == null ? void 0 : A.result), le(async () => {
      Z && await fn(
        tt.model.currentPageId,
        tt.model.userDependentDataUrl,
        (l) => {
          var u, c;
          (c = (u = B.value) == null ? void 0 : u.header) != null && c.iconList && (B.value.header.iconList.loginIcon = l);
        },
        (l) => {
          T && T({
            userType: l.type,
            userId: l.id
          });
        }
      );
    }), (l, u) => (wt(), Et(St(ra), {
      model: B.value,
      onAudienceChanged: St(vs),
      onSearch: St(I).search,
      onSearchClear: St(I).searchClear,
      onSearchShowChanged: St(I).searchClear
    }, {
      default: Xt(() => [
        l.model.leavingDisclaimer ? (wt(), Et(St(qr), Cn(An({ key: 0 }, l.model.leavingDisclaimer)), null, 16)) : Wt("", !0),
        Ht(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["model", "onAudienceChanged", "onSearch", "onSearchClear", "onSearchShowChanged"]));
  }
}), sc = /* @__PURE__ */ Tt({
  __name: "pageframe-patternlab-header",
  props: {
    model: {
      type: Object,
      required: !1,
      default: null
    },
    searchUrl: {
      type: String,
      required: !1,
      default: null
    },
    tracking: {
      type: Object,
      required: !1,
      default: null
    },
    websiteName: {
      type: String,
      required: !1,
      default: null
    },
    userDependentDataUrl: {
      type: String,
      required: !0
    },
    currentPageId: {
      type: Number,
      required: !0
    }
  },
  setup(rt) {
    const tt = rt, r = Ft(tt.model), Z = Kr(tt.searchUrl, (B) => {
      var I, R;
      (R = (I = r.value) == null ? void 0 : I.iconList) != null && R.searchIcon && B && (r.value.iconList.searchIcon.result = B);
    });
    let T;
    return tt.tracking && (T = gn(tt.tracking, tt.websiteName ?? document.title)), le(async () => {
      await fn(
        tt.currentPageId,
        tt.userDependentDataUrl,
        (B) => {
          var I;
          (I = r.value) != null && I.iconList && (r.value.iconList.loginIcon = B);
        },
        (B) => {
          T && T({
            userType: B.type,
            userId: B.id
          });
        }
      );
    }), (B, I) => tt.model ? (wt(), Et(St(na), {
      key: 0,
      model: r.value,
      onAudienceChanged: St(vs),
      onSearch: St(Z).search,
      onSearchClear: St(Z).searchClear
    }, null, 8, ["model", "onAudienceChanged", "onSearch", "onSearchClear"])) : Wt("", !0);
  }
}), oc = {
  en: {
    dwsCustomCarousel: {
      navBackward: "navigate backward",
      navForward: "navigate forward",
      navToPage: "navigate to page"
    }
  },
  de: {
    dwsCustomCarousel: {
      navBackward: "zurück blättern",
      navForward: "vorwärts blättern",
      navToPage: "navigiere zu Seite"
    }
  },
  es: {
    Accept: "Acepte",
    Cancel: "Cancelar"
  },
  fr: {
    Accept: "J'accepte",
    Cancel: "Annuler"
  },
  it: {
    Accept: "D'accordo",
    Cancel: "Cancella"
  },
  ja: {
    Accept: "はい",
    Cancel: "キャンセル"
  },
  nl: {
    Accept: "Aanvaarden",
    Cancel: "Annuleren"
  },
  sv: {
    Accept: "acceptera",
    Cancel: "Avsluta"
  },
  zh: {
    Accept: "同意",
    Cancel: "取消"
  }
}, rc = [
  {
    locale: "en",
    emptyMessage: "No results found",
    emptyFilterMessage: "No results found"
  },
  {
    locale: "de",
    emptyMessage: "Keine Ergebnisse gefunden",
    emptyFilterMessage: "Keine Ergebnisse gefunden"
  },
  {
    locale: "es",
    emptyMessage: "No hay resultados",
    emptyFilterMessage: "No hay resultados"
  },
  {
    locale: "fr",
    emptyMessage: "Aucun résultat trouvé",
    emptyFilterMessage: "Aucun résultat trouvé"
  },
  {
    locale: "it",
    emptyMessage: "Nessun risultato trovato",
    emptyFilterMessage: "Nessun risultato trovato"
  },
  {
    locale: "zh",
    emptyMessage: "未找到结果",
    emptyFilterMessage: "未找到结果"
  },
  {
    locale: "nl",
    emptyMessage: "Geen resultaten gevonden",
    emptyFilterMessage: "Geen resultaten gevonden"
  },
  {
    locale: "sv",
    emptyMessage: "Inga resultat funna",
    emptyFilterMessage: "Inga resultat funna"
  }
], nc = {
  baseImagePath: "/Resources/vue/",
  htmlContentBlockWhitelist: {
    ADD_TAGS: [],
    ADD_ATTR: []
  },
  translationOptions: {
    locale: "en",
    fallbackLocale: "en",
    messages: oc
  },
  serviceUrlOptions: {
    isinValidationServiceUrl: "/EntryGate/other-country-validate-isin"
  },
  localesPrimeVue: rc
};
function Gr(rt) {
  return rt.replace(/([a-z0–9])([A-Z])/g, "$1-$2").toLowerCase();
}
function ac(rt, tt, r, Z, T) {
  const B = r;
  Z.push(tt), Z.push(Gr(tt)), B.props && T.push(
    ...Object.keys(B.props).map((I) => Gr(I)).map((I) => [I, ":" + I]).reduce((I, R) => I.concat(R), [])
  ), rt.component(tt, r);
}
function lc(rt, tt, r) {
  const Z = un(nc, tt), T = [], B = [], I = (R, z) => {
    ac(rt, R, z, T, B);
  };
  return I("VueTeaserWorldwideWebsites", aa), I("VueTeaserHero", la), I("VueTeaserEvent", ha), I("VueTeaserBoxes", da), I("VueKeyFacts", ca), I("VueProductsTeaserArea", gh), I("VueTeaserTopProducts", pa), I("VueTeaserMostClickedProducts", ua), I("VueTeaserProductInFocus", ga), I("VuePersonSection", fa), I("VuePersonDetailPage", Oh), I("VueTabContainer", ma), I("VueTabContent", xa), I("VueVideoModule", ya), I("VueDownloadList", ba), I("VueTopicTileContentBlock", va), I("VueQuote", Ca), I("VueEntryGateModal", Jl), I("VueAccordionContainer", Aa), I("VueAccordionItem", Ma), I("VueSpace", mh), I("VueHtml", ah), I("VueHeader", nh), I("FundSearch", Yr), I("VueFundSearch", _l), I("VueLayout", ph), I("VueLayoutRow", uh), I("VueExpandableTeasers", wa), I("VueEvervizCharts", ql), I("VueRiskDisclaimer", fh), I("VueNewsletterTeaser", Sa), I("VuePageFootnoteList", ka), I("VuePageFootnoteReference", Pa), I("VueLeavingDisclaimer", qr), I("VueTeaserAnnouncements", Zl), I("VueImage", hh), I("VueTextBlock", Ta), I("VueTimeline", Ea), I("VueProductChartTeaser", La), I("VueProductChartTeasers", Oa), I("VueSearchResultsPage", Eh), I("VueArchivePage", Sh), I("VuePropertyGalleryPage", jh), I("VueDataTable", ja), I("VueSingleVideoPlayer", Da), I("VueErrorPage", Ia), I("VuePropertyDetailPage", Ih), I("VueFeaturedPropertyTeaser", Ba), I("VueFactsList", Ra), I("VueCalendarPage", kh), I("VueFaqPage", Ph), I("VueGlossaryPage", Bh), I("VueMarketDataBlock", Na), I("VueImageGallery", za), I("VueJumpmarkAnchor", Fa), I("VueArticleHeader", Ua), I("VueArticlePageOverview", yh), I("VueImageBlock", Ga), I("VueContentBox", xh), I("VueImageGalleryTeaser", Xa), I("VueMediaReleasesPage", Rh), I("VueProductTeaserWithImage", Ha), I("VueQuiz", Ch), I("VuePoll", vh), I("VueDisclaimer", Ya), I("VueContactBox", Wa), I("VueMediaReleasesDetailsPage", Va), I("VueGlossaryItem", qa), I("VueContentSlider", bh), I("VueProductBuyingProcessPage", Fh), I("VueEntryPopupDisclaimer", _a), I("VueAudioModule", Ka), I("VueArticlePageLayout", $a), I("VueInvestmentCalculator", Za), I("VueInflationCalculator", Ja), I("VueFormBuilder", Ah), r && r(I), T.push("PageFootnoteReference"), Z.htmlContentBlockWhitelist && (Z.htmlContentBlockWhitelist.ADD_TAGS = T.filter((R, z, O) => O.indexOf(R) === z), Z.htmlContentBlockWhitelist.ADD_ATTR = B.filter((R, z, O) => O.indexOf(R) === z)), Z;
}
function cc(rt) {
  var I;
  const tt = document.getElementsByClassName("vue"), r = Array.prototype.slice.call(tt) || [], Z = (I = window.DACL) == null ? void 0 : I.config, T = (Z == null ? void 0 : Z.culture) ?? "en", B = (Z == null ? void 0 : Z.fallbackCulture) ?? "en";
  r.forEach((R) => {
    const O = Mn({}), L = lc(
      O,
      {
        translationOptions: {
          locale: T,
          fallbackLocale: B
        }
      },
      () => {
      }
    );
    O.component("VuePageFrame", ic), O.component("VuePageFramePatternlabHeader", sc), O.component("VuePageFramePatternlabFooter", Uh), O.component("UxclBreadcrumb", Qa), O.use(tl, L), rt && rt(O), O.mount(R);
  });
}
export {
  Sh as ArchivePage,
  yh as ArticlePageOverview,
  kh as CalendarPage,
  xh as ContentBox,
  bh as ContentSlider,
  ic as DaclPageFrame,
  Jl as EntryGateModalComponent,
  ql as EvervizChartsComponent,
  Ph as FaqPage,
  Ah as FormBuilder,
  _l as FundSearchComponent,
  Bh as GlossaryPage,
  nh as HeaderComponent,
  ah as HtmlComponent,
  hh as ImageComponent,
  ph as LayoutComponent,
  uh as LayoutRowComponent,
  qr as LeavingDisclaimerComponent,
  Rh as MediaReleasesPage,
  Oh as PersonDetailPage,
  vh as Poll,
  Fh as ProductBuyingProcessPage,
  Dh as ProductIdentifierType,
  gh as ProductsTeaserAreaComponent,
  Ih as PropertyDetailPage,
  jh as PropertyGalleryPage,
  Ch as Quiz,
  fh as RiskDisclaimerComponent,
  Eh as SearchResultsPage,
  mh as SpaceComponent,
  Zl as TeaserAnnouncementsComponent,
  vs as audienceChanged,
  lc as createDxPluginOptions,
  cc as initStaticVueApp,
  oc as locales,
  rc as localesPrimeVue,
  te as useApiRequest,
  Kr as usePageFrameSearchEvents,
  fn as usePageFrameUserDataLoader,
  gn as useTealiumTracking,
  de as useUrlState
};
//# sourceMappingURL=dacl.cms.vue.components.js.map
